export const bbUiDocs: any = {
  pipes: [
    {
      name: 'AccountNumberPipe',
      id: 'pipe-AccountNumberPipe-7b2cab945711649bf0330c0506ef2aace203ef5c1f406196be8ffad4619eb3507ecaa3027151794d195c4f28f491b6b11a0c4afb7bc10a596487b15c92aecd92',
      file: 'libs/ui-ang/account-number-pipe/account-number.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description:
        '<p>Pipe for formatting account numbers.\nIt applies different format configurations per number type.</p>\n',
      rawdescription:
        '\n\n\nPipe for formatting account numbers.\nIt applies different format configurations per number type.\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'string | number',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'configuration',
              type: 'AccountNumberType | AccountsDisplayingFormat',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'cardProviderName',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 42,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\n\nFormats account numbers\n\nto use with a global accountsFormat configuration\n- '12345678' | bbAccountNumber:'iban'\nto apply a custom configuration\n- '12345678' | bbAccountNumber:{ segments: [2, 4, 2] }\nto apply a 'visa' card number configuration\n- '12345678' | bbAccountNumber:'cardNumber':'visa'\n",
          description:
            '<p>Formats account numbers</p>\n<p>to use with a global accountsFormat configuration</p>\n<ul>\n<li>&#39;12345678&#39; | bbAccountNumber:&#39;iban&#39;\nto apply a custom configuration</li>\n<li>&#39;12345678&#39; | bbAccountNumber:{ segments: [2, 4, 2] }\nto apply a &#39;visa&#39; card number configuration</li>\n<li>&#39;12345678&#39; | bbAccountNumber:&#39;cardNumber&#39;:&#39;visa&#39;</li>\n</ul>\n',
          jsdoctags: [
            {
              name: {
                pos: 847,
                end: 852,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              type: 'string | number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 841,
                end: 846,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the string to transform</li>\n</ul>\n',
            },
            {
              name: {
                pos: 891,
                end: 904,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'configuration',
              },
              type: 'AccountNumberType | AccountsDisplayingFormat',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 885,
                end: 890,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>type of the value (iban, bban or number) or a custom numbers format</li>\n</ul>\n',
            },
            {
              name: {
                pos: 987,
                end: 1003,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'cardProviderName',
              },
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                pos: 981,
                end: 986,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>card provider name</li>\n</ul>\n',
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'bbAccountNumber',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { AccountNumberType, AccountsDisplayingFormat } from './constants';\nimport { AccountsDisplayingFormatService } from './accounts-displaying-format.service';\nimport { segment } from '@backbase/ui-ang/util';\n\n/**\n * @name bbAccountNumber\n *\n * @description\n * Pipe for formatting account numbers.\n * It applies different format configurations per number type.\n */\n@Pipe({\n  name: 'bbAccountNumber',\n  standalone: false,\n})\nexport class AccountNumberPipe implements PipeTransform {\n  /**\n   * @name AccountNumberPipe#constructor\n   * @param accountsDisplayingFormatService - AccountsDisplayingFormatService\n   *\n   * @internal\n   */\n  constructor(private readonly accountsDisplayingFormatService: AccountsDisplayingFormatService) {}\n\n  /**\n   * @name AccountNumberPipe#transform\n   * @param value - the string to transform\n   * @param configuration - type of the value (iban, bban or number) or a custom numbers format\n   * @param cardProviderName - card provider name\n   *\n   * @description\n   * Formats account numbers\n   *\n   * to use with a global accountsFormat configuration\n   * - '12345678' | bbAccountNumber:'iban'\n   * to apply a custom configuration\n   * - '12345678' | bbAccountNumber:{ segments: [2, 4, 2] }\n   * to apply a 'visa' card number configuration\n   * - '12345678' | bbAccountNumber:'cardNumber':'visa'\n   */\n  transform(\n    value: string | number,\n    configuration: AccountNumberType | AccountsDisplayingFormat,\n    cardProviderName?: string,\n  ): string {\n    const accountNumber = value.toString();\n    const displayingFormat =\n      typeof configuration === 'object'\n        ? (configuration as AccountsDisplayingFormat)\n        : this.accountsDisplayingFormatService.getDefaultFormat(configuration, cardProviderName);\n\n    return `\\u200e${segment(accountNumber, displayingFormat.segments)}`;\n  }\n}\n",
    },
    {
      name: 'AlertIconPipe',
      id: 'pipe-AlertIconPipe-1c3d8f4dfb0a0f72d43ca54d33b9509116f4892efcc9c3eefb1d07c0a5b0d75e5401eca028cf0289cb7b7c530a273b1c1a680eedc5ba028c07033fb246de7160',
      file: 'libs/ui-ang/alert/alert-icon.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'alertModifier',
              type: 'AlertType',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'alertModifier',
              type: 'AlertType',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'alertIcon',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { AlertType } from './alert.constants';\n\n@Pipe({\n  name: 'alertIcon',\n  standalone: false,\n})\nexport class AlertIconPipe implements PipeTransform {\n  transform(alertModifier: AlertType) {\n    switch (alertModifier) {\n      case 'error':\n        return 'error-outline';\n\n      case 'warning':\n        return 'warning-amber';\n\n      default:\n        return alertModifier;\n    }\n  }\n}\n",
    },
    {
      name: 'AlertTypePipe',
      id: 'pipe-AlertTypePipe-08fdf396ff375723836a4cea6b983806ca053f8f097fe6700a92f5e90292b7491ffa4ce1d8c2f092e0e4920602b22e3f8923e9542fb47cd82177811071c48ae6',
      file: 'libs/ui-ang/alert/alert-type.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'alertModifier',
              type: 'AlertType',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'alertModifier',
              type: 'AlertType',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'alertType',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { AlertType } from './alert.constants';\n\n@Pipe({\n  name: 'alertType',\n  standalone: false,\n})\nexport class AlertTypePipe implements PipeTransform {\n  transform(alertModifier: AlertType) {\n    switch (alertModifier) {\n      case 'error':\n        return 'danger';\n\n      case 'success':\n        return 'success';\n\n      case 'info':\n        return 'info';\n\n      case 'warning':\n        return 'warning';\n\n      default:\n        return alertModifier;\n    }\n  }\n}\n",
    },
    {
      name: 'AmountInputCurrencyRemapPipe',
      id: 'pipe-AmountInputCurrencyRemapPipe-f5a3008f42723349161a6bd5536ae246e567f9c2c6f639a1e25c8d261c0df3edb93bf6941bed52f1342d56fd742bc8a271561e9d79838687f6e85b8ed4bff85d',
      file: 'libs/ui-ang/amount-input/amount-input-currency-remap.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'currency',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'mapCurrency',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 11,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'currency',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'mapCurrency',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'bbAmountInputCurrencyRemap',
      sourceCode:
        "import { getCurrencySymbol } from '@angular/common';\nimport { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';\n\n@Pipe({\n  name: 'bbAmountInputCurrencyRemap',\n  standalone: false,\n})\nexport class AmountInputCurrencyRemapPipe implements PipeTransform {\n  private readonly locale = inject(LOCALE_ID);\n\n  transform(currency: string, mapCurrency: boolean) {\n    if (!currency || !mapCurrency) {\n      return currency;\n    }\n\n    return getCurrencySymbol(currency, 'wide', this.locale);\n  }\n}\n",
    },
    {
      name: 'AvatarInitialsPipe',
      id: 'pipe-AvatarInitialsPipe-4925a4ce849cb1811381966e8125255104af22d9c7e565bdf9dfa167af4c6ed0af5fafc107aec02ddffb0fd515d6c19ffde6a803da77cdbe9eabb9f3b893ea46',
      file: 'libs/ui-ang/avatar/avatar-initials.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'text',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 11,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'text',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'avatarInitials',
      sourceCode:
        "import { inject, Pipe, PipeTransform } from '@angular/core';\nimport { AVATAR_CONFIG_TOKEN, defaultAvatarInitialsFn } from './avatar.token-config';\n\n@Pipe({\n  name: 'avatarInitials',\n  standalone: false,\n})\nexport class AvatarInitialsPipe implements PipeTransform {\n  private readonly customInitialsFn = inject(AVATAR_CONFIG_TOKEN, { optional: true });\n\n  transform(text: string) {\n    const initialsFn = this.customInitialsFn?.initialsFn ?? defaultAvatarInitialsFn;\n\n    return initialsFn(text);\n  }\n}\n",
    },
    {
      name: 'BbDatePipe',
      id: 'pipe-BbDatePipe-c33deb415a3f9e316cab6d93a28b5d2ea0aeaca219bd0ef2105728651e73993f90cfd30a8e4fd22d51fd61c41a0e334cb6fd90475ec287e845422a787c463a21',
      file: 'libs/ui-ang/date-pipe/date-pipe.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description:
        '<p>Pipe for formatting dates\n<br><br></p>\n<h3>Locale token</h3>\n<p><code>LOCALE_ID</code> enables you to globally set the same locale for all instances of <code>bbDatePipe</code> in your project.\nRefer to <a href="https://angular.io/api/core/LOCALE_ID">https://angular.io/api/core/LOCALE_ID</a> for more information.</p>\n<h3>Default timezone and format option</h3>\n<p><code>DATE_PIPE_DEFAULT_OPTIONS</code> enables you to globally set the default timezone and date format for all instances of <code>bbDatePipe</code> in your project.\nRefer to <a href="https://angular.io/api/common/DATE_PIPE_DEFAULT_OPTIONS">https://angular.io/api/common/DATE_PIPE_DEFAULT_OPTIONS</a> for more information.</p>\n<h3>Format configuration token</h3>\n<p><code>DATE_PIPE_CONFIG</code> enables to globally setup format for all instances of <code>bbDatePipe</code> in your project.\nThe following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript"> import { DATE_PIPE_CONFIG, DateFormat } from &#39;&#64;backbase/ui-ang/date-pipe&#39;;\n import { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\n import { AppModule } from &#39;./app/app.module&#39;;\n\n platformBrowserDynamic().bootstrapModule(AppModule, {\n   providers: [{ provide: DATE_PIPE_CONFIG, useValue: DateFormat.short }]\n });</code></pre></div>',
      rawdescription:
        "\n\n\nPipe for formatting dates\n<br><br>\n\n### Locale token\n`LOCALE_ID` enables you to globally set the same locale for all instances of `bbDatePipe` in your project.\nRefer to https://angular.io/api/core/LOCALE_ID for more information.\n\n### Default timezone and format option\n`DATE_PIPE_DEFAULT_OPTIONS` enables you to globally set the default timezone and date format for all instances of `bbDatePipe` in your project.\nRefer to https://angular.io/api/common/DATE_PIPE_DEFAULT_OPTIONS for more information.\n\n### Format configuration token\n`DATE_PIPE_CONFIG` enables to globally setup format for all instances of `bbDatePipe` in your project.\nThe following is an example of how to use the token:\n\n```typescript\n import { DATE_PIPE_CONFIG, DateFormat } from '@backbase/ui-ang/date-pipe';\n import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n import { AppModule } from './app/app.module';\n\n platformBrowserDynamic().bootstrapModule(AppModule, {\n   providers: [{ provide: DATE_PIPE_CONFIG, useValue: DateFormat.short }]\n });\n```\n\n",
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'format',
              type: '',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: "this.dateFormatConfig?.format ?? this.defaultOptions?.dateFormat ?? 'mediumDate'",
            },
            {
              name: 'timezone',
              type: 'string | undefined',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: 'this.defaultOptions?.timezone',
            },
            {
              name: 'locale',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'string | null',
          typeParameters: [],
          line: 67,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\n\n\nDepending on format type, formats a date\nCustom format is called with bbShort,\nand formats to 'MMMM d, y at HH:mm',\notherwise uses the predifined angular formats\n\n",
          description:
            '<p>Depending on format type, formats a date\nCustom format is called with bbShort,\nand formats to &#39;MMMM d, y at HH:mm&#39;,\notherwise uses the predifined angular formats</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 1880,
                end: 1885,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 1874,
                end: 1879,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the date that should be formatted</li>\n</ul>\n',
            },
            {
              name: {
                pos: 1934,
                end: 1940,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'format',
              },
              type: '',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: "this.dateFormatConfig?.format ?? this.defaultOptions?.dateFormat ?? 'mediumDate'",
              tagName: {
                pos: 1928,
                end: 1933,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the format type for the date to be formatted</li>\n</ul>\n',
            },
            {
              name: {
                pos: 2000,
                end: 2008,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'timezone',
              },
              type: 'string | undefined',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: 'this.defaultOptions?.timezone',
              tagName: {
                pos: 1994,
                end: 1999,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>used for formatting the time</li>\n</ul>\n',
            },
            {
              name: {
                pos: 2052,
                end: 2058,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'locale',
              },
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                pos: 2046,
                end: 2051,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>locale to use for formatting</li>\n</ul>\n',
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'bbDate',
      sourceCode:
        "import { Inject, LOCALE_ID, Pipe, PipeTransform, Optional } from '@angular/core';\nimport {\n  DATE_PIPE_DEFAULT_OPTIONS,\n  formatDate,\n  FormatWidth,\n  getLocaleDateTimeFormat,\n  DatePipeConfig as CoreDatePipeConfig,\n} from '@angular/common';\nimport { DATE_PIPE_CONFIG, DatePipeConfig } from './date-format-config';\n\n/**\n * @name bbDate\n *\n * @description\n * Pipe for formatting dates\n * <br><br>\n *\n * ### Locale token\n * `LOCALE_ID` enables you to globally set the same locale for all instances of `bbDatePipe` in your project.\n * Refer to https://angular.io/api/core/LOCALE_ID for more information.\n *\n * ### Default timezone and format option\n * `DATE_PIPE_DEFAULT_OPTIONS` enables you to globally set the default timezone and date format for all instances of `bbDatePipe` in your project.\n * Refer to https://angular.io/api/common/DATE_PIPE_DEFAULT_OPTIONS for more information.\n *\n * ### Format configuration token\n * `DATE_PIPE_CONFIG` enables to globally setup format for all instances of `bbDatePipe` in your project.\n * The following is an example of how to use the token:\n *\n * ```typescript\n *  import { DATE_PIPE_CONFIG, DateFormat } from '@backbase/ui-ang/date-pipe';\n *  import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n *  import { AppModule } from './app/app.module';\n *\n *  platformBrowserDynamic().bootstrapModule(AppModule, {\n *    providers: [{ provide: DATE_PIPE_CONFIG, useValue: DateFormat.short }]\n *  });\n * ```\n *\n */\n@Pipe({\n  name: 'bbDate',\n  standalone: false,\n})\nexport class BbDatePipe implements PipeTransform {\n  constructor(\n    @Inject(LOCALE_ID) private locale: string,\n    @Optional() @Inject(DATE_PIPE_CONFIG) private dateFormatConfig?: DatePipeConfig,\n    @Inject(DATE_PIPE_DEFAULT_OPTIONS) @Optional() private defaultOptions?: CoreDatePipeConfig | null,\n  ) {}\n\n  /**\n   * @name BbDatePipe#transform\n   * @param value - the date that should be formatted\n   * @param format - the format type for the date to be formatted\n   * @param timezone - used for formatting the time\n   * @param locale - locale to use for formatting\n   *\n   *\n   * @description\n   * Depending on format type, formats a date\n   * Custom format is called with bbShort,\n   * and formats to 'MMMM d, y at HH:mm',\n   * otherwise uses the predifined angular formats\n   *\n   */\n  transform(\n    value: any,\n    format = this.dateFormatConfig?.format ?? this.defaultOptions?.dateFormat ?? 'mediumDate',\n    timezone: string | undefined = this.defaultOptions?.timezone,\n    locale?: string,\n  ): string | null {\n    if (format === 'bbShort') {\n      const localeFormat = getLocaleDateTimeFormat(this.locale, FormatWidth.Long);\n      const dateFormatted = formatDate(value, 'MMMM d, y', this.locale, timezone);\n      const timeFormatted = formatDate(value, 'HH:mm', this.locale, timezone);\n\n      return localeFormat.replace(/'/g, '').replace('{1}', dateFormatted).replace('{0}', timeFormatted);\n    }\n\n    if (value == null || value === '' || value !== value) return null;\n\n    try {\n      return formatDate(value, format, locale || this.locale, timezone);\n    } catch (error: any) {\n      throw Error(`InvalidPipeArgument: '${error.message}' for pipe BbDatePipe`);\n    }\n  }\n}\n",
    },
    {
      name: 'BbIbanPipe',
      id: 'pipe-BbIbanPipe-d4e74ef25f183059d1e9456c7ad31b386125eeaeb02c0c2433bd43f8d00f241b21b53ffe41ca9777c3fe484d69edf578c53db9d92f8c4ed16e1ca53693ec0090',
      file: 'libs/ui-ang/iban-pipe/iban-pipe.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '<p>Pipe for formatting iban</p>\n',
      rawdescription: '\n\n\nPipe for formatting iban\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 33,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\n\nSplits the iban up with spaces\nApplies global numbers format configuration for IBAN attribute type\n',
          description:
            '<p>Splits the iban up with spaces\nApplies global numbers format configuration for IBAN attribute type</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 756,
                end: 761,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 750,
                end: 755,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the iban that should be formatted</li>\n</ul>\n',
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'bbIban',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { segment } from '@backbase/ui-ang/util';\nimport { AccountsDisplayingFormatService } from '@backbase/ui-ang/account-number-pipe';\n\n/**\n * @name bbIban\n *\n * @description\n * Pipe for formatting iban\n */\n@Pipe({\n  name: 'bbIban',\n  standalone: false,\n})\nexport class BbIbanPipe implements PipeTransform {\n  private readonly defaultFormat = this.accountsDisplayingFormatService.getDefaultFormat('iban');\n  /**\n   * @name BbIbanPipe#constructor\n   * @param accountsDisplayingFormatService - AccountsDisplayingFormatService\n   *\n   * @internal\n   */\n  constructor(private readonly accountsDisplayingFormatService: AccountsDisplayingFormatService) {}\n\n  /**\n   * @name BbIbanPipe#transform\n   * @param value - the iban that should be formatted\n   *\n   * @description\n   * Splits the iban up with spaces\n   * Applies global numbers format configuration for IBAN attribute type\n   */\n  transform(value: string) {\n    return `\\u200e${segment(value, this.defaultFormat.segments)}`;\n  }\n}\n",
    },
    {
      name: 'CardVendorTitlePipe',
      id: 'pipe-CardVendorTitlePipe-d370eebb055d05e0839fb998cecdd58541977e677040d2e428e5ecbdfa609db42e522a084f42bdf776a42f4ff428c70060e1065c0b4f1126a3c4047dc4b26a0a',
      file: 'libs/ui-ang/card-vendor/card-vendor-title.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'vendor',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 8,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'vendor',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'cardVendorTitle',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\n\n@Pipe({\n  name: 'cardVendorTitle',\n  standalone: false,\n})\nexport class CardVendorTitlePipe implements PipeTransform {\n  transform(vendor: string) {\n    return vendor.trim().toLowerCase().replace(/-/g, ' ');\n  }\n}\n",
    },
    {
      name: 'CountryFlagPipe',
      id: 'pipe-CountryFlagPipe-c7c5e1c82730c5d62654cfd089412f09da003a38545ebb798b439105986ea73876825ac9ea58d4f95f218b6615d4ce871c48c2a4dc8761afb598e59df16abc75',
      file: 'libs/ui-ang/input-phone/country-flag-pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 14,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nTransforms the input value to a flag icon class name.\n\n',
          description: '<p>Transforms the input value to a flag icon class name.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 247,
                end: 252,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 241,
                end: 246,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>The country code to transform.</p>\n',
            },
            {
              tagName: {
                pos: 290,
                end: 297,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'returns',
              },
              comment: '<p>The class name for the flag icon.</p>\n',
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'countryFlag',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\n\n@Pipe({\n  name: 'countryFlag',\n  standalone: false,\n})\nexport class CountryFlagPipe implements PipeTransform {\n  /**\n   * Transforms the input value to a flag icon class name.\n   *\n   * @param value The country code to transform.\n   * @returns The class name for the flag icon.\n   */\n  transform(value: string) {\n    return 'flag-icon-' + value.toLowerCase();\n  }\n}\n",
    },
    {
      name: 'IllustrationAltPipe',
      id: 'pipe-IllustrationAltPipe-0e1393b24549191c687a118bd13ee46d39aad45be21de082dedba21bca03f1ee5278db693fcc852aa52fc308b1c1f5b40b5db9e857e187ee2d5cea9cb90bab35',
      file: 'libs/ui-ang/illustration/illustration-alt.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'text',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 8,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'text',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'illustrationAlt',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\n\n@Pipe({\n  name: 'illustrationAlt',\n  standalone: false,\n})\nexport class IllustrationAltPipe implements PipeTransform {\n  transform(text: string) {\n    return text\n      .replace(/^ic/, '')\n      .replace(/\\-|_/g, ' ')\n      .replace(/\\s?[0-9]/g, '')\n      .trim();\n  }\n}\n",
    },
    {
      name: 'IllustrationSrcPipe',
      id: 'pipe-IllustrationSrcPipe-ca65947da92a06596ee2cee370acc225d0d081ac6f0bf5cef506f421b8920442d1884d7395293a0232729906f154b4ffac37268abe02773d5def753886118c19',
      file: 'libs/ui-ang/illustration/illustration-src.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'name',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'assetPath',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'fileType',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'name',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'assetPath',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'fileType',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'illustrationSrc',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { DEFAULT_ASSET_PATH } from './illustration.constants';\n\n@Pipe({\n  name: 'illustrationSrc',\n  standalone: false,\n})\nexport class IllustrationSrcPipe implements PipeTransform {\n  transform(name: string, assetPath: string, fileType: string) {\n    if (assetPath !== DEFAULT_ASSET_PATH) {\n      return `${assetPath}/${name}.${fileType}`;\n    }\n\n    // strictly map it to our own naming convention which is standardised among platforms\n    const snakeCaseName = name\n      // split pascal case by capital letters and include those letters in split arrays\n      // or split kebab case by \"-\" and exclude \"-\" in split arrays\n      // if matched with a number, split only if number is not preceeded with \"_\"\n      .split(/\\B(?=[A-Z]|(?<!_)[0-9])|\\-/g)\n      .map((str) => str.toLowerCase())\n      .join('_');\n\n    const fileName = snakeCaseName.match(/^ic/) ? snakeCaseName : `ic_${snakeCaseName}`;\n\n    return `${assetPath}/${fileName}.${fileType}`;\n  }\n}\n",
    },
    {
      name: 'NotificationIconColorPipe',
      id: 'pipe-NotificationIconColorPipe-ffe2ddebc760b640b495aae0327811de8371e86234e94ec33f7a39d8b8d058c1f83fa3f8291c4f5e44583a8018b6616d61d69dd7a7d0e13f48c0eeb9617238f0',
      file: 'libs/ui-ang/notification/notification-icon-color.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'modifier',
              type: 'NotificationType',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'modifier',
              type: 'NotificationType',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'notificationIconColor',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport type { NotificationType } from './notification.component';\n\n@Pipe({\n  name: 'notificationIconColor',\n  standalone: false,\n})\nexport class NotificationIconColorPipe implements PipeTransform {\n  transform(modifier: NotificationType) {\n    if (modifier === 'error') {\n      return 'danger';\n    }\n\n    return modifier;\n  }\n}\n",
    },
    {
      name: 'NotificationIconPipe',
      id: 'pipe-NotificationIconPipe-6e35607bc30a1c6802e2f5f04333e7bee4f3f24f67f704fbaca68872a412d3dee90a1c84c864626bf448af5a985777bb95b3cdc4ce2c61e9357f920971a7309e',
      file: 'libs/ui-ang/notification/notification-icon.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'modifier',
              type: 'NotificationType',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'modifier',
              type: 'NotificationType',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'notificationIcon',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport type { NotificationType } from './notification.component';\n\n@Pipe({\n  name: 'notificationIcon',\n  standalone: false,\n})\nexport class NotificationIconPipe implements PipeTransform {\n  transform(modifier: NotificationType) {\n    switch (modifier) {\n      case 'error':\n        return 'error-outline';\n\n      case 'warning':\n        return 'warning-amber';\n\n      default:\n        return modifier;\n    }\n  }\n}\n",
    },
    {
      name: 'PaymentCardNumberPipe',
      id: 'pipe-PaymentCardNumberPipe-f79a51b51d28747b7c3a95209cabcdf5c9b9e95ae67bb5c022300f811b85a2838bef0cb1524bce8c3c4ac0c17595868e6c0e6aa6b97137b326a0fc98612c83f8',
      file: 'libs/ui-ang/payment-card-number-pipe/payment-card-number.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description:
        '<p>A card number is the digit identifier found on payment cards, such as credit cards and debit cards. This card number prefix identifies the issuer of the card, and the digits that follow are used by the issuing organization, such as a bank, to identify the cardholder as a customer with their designated accounts.</p>\n<h3>Numbers masking synchronization token</h3>\n<p>It is possible to enable numbers masking synchronization with backend.\nIf set to <code>true</code> FE does not apply any masking and relies on the backend masking behavior.\nTo enable this feaure the <code>SYNCHRONIZE_NUMBERS_MASKING</code> token should be provided. For example:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript"> // other imports\n import { SYNCHRONIZE_NUMBERS_MASKING } from &#39;&#64;backbase/ui-ang/payment-card-number-pipe&#39;;\n\n &#64;NgModule({\n   //...\n   providers: [\n     //...\n     { provide: SYNCHRONIZE_NUMBERS_MASKING, useValue: true }\n   ]\n })\n export class AppModule {}</code></pre></div>',
      rawdescription:
        "\n\n\nA card number is the digit identifier found on payment cards, such as credit cards and debit cards. This card number prefix identifies the issuer of the card, and the digits that follow are used by the issuing organization, such as a bank, to identify the cardholder as a customer with their designated accounts.\n\n### Numbers masking synchronization token\nIt is possible to enable numbers masking synchronization with backend.\nIf set to `true` FE does not apply any masking and relies on the backend masking behavior.\nTo enable this feaure the `SYNCHRONIZE_NUMBERS_MASKING` token should be provided. For example:\n\n```typescript\n // other imports\n import { SYNCHRONIZE_NUMBERS_MASKING } from '@backbase/ui-ang/payment-card-number-pipe';\n\n @NgModule({\n   //...\n   providers: [\n     //...\n     { provide: SYNCHRONIZE_NUMBERS_MASKING, useValue: true }\n   ]\n })\n export class AppModule {}\n ```\n",
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'string | number',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'config',
              type: 'PaymentCardNumberFormat',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
            {
              name: 'maskChar',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: "'•'",
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 104,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\n\nFormats a card number, mask it and split it into segments\n- do not set config parameter to use with a global accountsFormat configuration\n- use config parameter to apply a custom accountsFormat configuration\n',
          description:
            '<p>Formats a card number, mask it and split it into segments</p>\n<ul>\n<li>do not set config parameter to use with a global accountsFormat configuration</li>\n<li>use config parameter to apply a custom accountsFormat configuration</li>\n</ul>\n',
          jsdoctags: [
            {
              name: {
                pos: 3314,
                end: 3319,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              type: 'string | number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 3308,
                end: 3313,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the string to transform</li>\n</ul>\n',
            },
            {
              name: {
                pos: 3358,
                end: 3364,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'config',
              },
              type: 'PaymentCardNumberFormat',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                pos: 3352,
                end: 3357,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the formatting configuration</li>\n</ul>\n',
            },
            {
              name: {
                pos: 3408,
                end: 3416,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'maskChar',
              },
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: "'•'",
              tagName: {
                pos: 3402,
                end: 3407,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the character to mask with, deprecated from 6.0.0</li>\n</ul>\n',
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'paymentCardNumber',
      sourceCode:
        "import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';\nimport { PaymentCardNumberFormat, SYNCHRONIZE_NUMBERS_MASKING } from './constants';\nimport { segment } from '@backbase/ui-ang/util';\nimport { AccountsDisplayingFormatService } from '@backbase/ui-ang/account-number-pipe';\n\n/**\n * @name pad\n * @inner\n * @param value - the string to pad\n * @param length - the length to pad the string to\n * @param ch - the character to pad the string width\n * @param leftPad - whether to pad left (true) or pad right (false)\n *\n * @description\n * Pad a string to specified length with specified character\n */\nfunction pad(value: string, length: number, ch: string = '0', leftPad = true) {\n  const paddingSize = Math.max(length - value.length, 0);\n  const padding = ch.repeat(paddingSize);\n\n  return leftPad ? padding + value : value + padding;\n}\n\n/**\n * @name mask\n * @inner\n * @param value - the string to mask\n * @param indexStart - the index to start masking from\n * @param indexEnd - the index to end masking\n * @param maskChar - the character to mask with\n *\n * @description\n * Mask part of a string with specified character\n */\nfunction mask(value: string, [indexStart, indexEnd]: [number, number], maskChar: string = '*') {\n  let maskedString = '';\n\n  if (indexEnd < 0) {\n    const charsToShow = value.slice(indexEnd);\n    maskedString = maskChar.repeat(value.length - charsToShow.length) + charsToShow;\n  } else {\n    const maskStr = maskChar.repeat(indexEnd - indexStart);\n    maskedString = value.substring(0, indexStart) + maskStr + value.substring(indexEnd);\n  }\n\n  return maskedString;\n}\n\n/**\n * @name PaymentCardNumberPipe\n *\n * @description\n * A card number is the digit identifier found on payment cards, such as credit cards and debit cards. This card number prefix identifies the issuer of the card, and the digits that follow are used by the issuing organization, such as a bank, to identify the cardholder as a customer with their designated accounts.\n *\n * ### Numbers masking synchronization token\n * It is possible to enable numbers masking synchronization with backend.\n * If set to `true` FE does not apply any masking and relies on the backend masking behavior.\n * To enable this feaure the `SYNCHRONIZE_NUMBERS_MASKING` token should be provided. For example:\n *\n * ```typescript\n *  // other imports\n *  import { SYNCHRONIZE_NUMBERS_MASKING } from '@backbase/ui-ang/payment-card-number-pipe';\n *\n *  @NgModule({\n *    //...\n *    providers: [\n *      //...\n *      { provide: SYNCHRONIZE_NUMBERS_MASKING, useValue: true }\n *    ]\n *  })\n *  export class AppModule {}\n *  ```\n */\n@Pipe({\n  name: 'paymentCardNumber',\n  standalone: false,\n})\nexport class PaymentCardNumberPipe implements PipeTransform {\n  private readonly defaultFormat = this.accountsDisplayingFormatService.getDefaultFormat('cardNumber');\n\n  /**\n   * @name PaymentCardNumberPipe#constructor\n   * @param accountsDisplayingFormatService - AccountsDisplayingFormatService\n   * @param featuresService - FeaturesService\n   *\n   * @internal\n   */\n  constructor(\n    private readonly accountsDisplayingFormatService: AccountsDisplayingFormatService,\n    @Optional() @Inject(SYNCHRONIZE_NUMBERS_MASKING) private readonly synchronizeNumberMasking: boolean,\n  ) {}\n\n  /**\n   * @name PaymentCardNumberPipe#transform\n   * @param value - the string to transform\n   * @param config - the formatting configuration\n   * @param maskChar - the character to mask with, deprecated from 6.0.0\n   *\n   * @description\n   * Formats a card number, mask it and split it into segments\n   * - do not set config parameter to use with a global accountsFormat configuration\n   * - use config parameter to apply a custom accountsFormat configuration\n   */\n  transform(value: string | number, config?: PaymentCardNumberFormat, maskChar: string = '•'): string {\n    const displayingFormat = config ?? this.defaultFormat;\n    let formattedNumber = value.toString();\n\n    if (config && !this.synchronizeNumberMasking) {\n      formattedNumber = pad(formattedNumber, config.length, maskChar);\n      formattedNumber = mask(formattedNumber, config.maskRange, maskChar);\n    }\n\n    return `\\u200e${segment(formattedNumber, displayingFormat.segments)}`;\n  }\n}\n",
    },
    {
      name: 'PhoneNumberPipe',
      id: 'pipe-PhoneNumberPipe-87ed30493105304fdaab075f8fc4a0d7ad0601042d42ee99963656430dd71e043a506ac371266a85614db8901040ffdb21da7ead3c8fee34d4ccaef735467fb8',
      file: 'libs/ui-ang/phone-number-format-pipe/phone-number-format.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description:
        '<p>Pipe for formatting phone numbers to various international formats</p>\n<h3>Global configuration token</h3>\n<p><code>INPUT_PHONE_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>InputPhoneComponent</code> in your project.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>maxLength</code></li>\n<li><code>minLength</code></li>\n<li><code>autocomplete</code></li>\n<li><code>mask</code></li>\n<li><code>displayFormat</code></li>\n<li><code>validationPattern</code></li>\n<li><code>hideSelectedCountryFlag</code></li>\n<li><code>defaultCountryIsoCode</code></li>\n<li><code>countryList</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript"> import { INPUT_PHONE_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/input-phone&#39;;\n import { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\n import { AppModule } from &#39;./app/app.module&#39;;\n\n const inputPhoneConfig = {\n   maxLength: 10,\n   minLength: 5,\n   autocomplete: &#39;off&#39;,\n   displayFormat: &#39;E.164&#39;,\n }\n\n providers: [\n   {\n     provide: INPUT_PHONE_CONFIG_TOKEN,\n     useValue: inputPhoneConfig,\n   },\n ]</code></pre></div><h3>Country Code Format Config Token</h3>\n<p><code>COUNTRY_CODE_FORMAT_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>InputPhoneComponent</code> in your project.</p>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token.\nNote: the <code>minLength</code> and <code>maxLength</code> properties do not account for the country dialling code:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript"> import { COUNTRY_CODE_FORMAT_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/input-phone&#39;;\n import { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\n import { AppModule } from &#39;./app/app.module&#39;;\n\n const countryCodeFormatConfig = {\n   &#39;+1&#39;: {\n     mask: &#39;+0 (000) 000-0000&#39;,\n     minLength: 8,\n     maxLength, 12,\n   },\n };\n\n providers: [\n   {\n     provide: COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n     useValue: countryCodeFormatConfig,\n   },\n ]</code></pre></div><h4>IMPORTANT NOTE:</h4>\n<ul>\n<li>If you wish to validate &amp; format ALL phone numbers using the SAME <code>minLength</code>, <code>maxLength</code> and/or <code>mask</code>, please configure these values using the <code>INPUT_PHONE_CONFIG_TOKEN</code>.</li>\n<li>If you need to support phone numbers for multiple countries (DIFFERENT <code>minLength</code>, <code>maxLength</code> &amp; <code>mask</code>), we advise to use the <code>COUNTRY_CODE_FORMAT_CONFIG_TOKEN</code> instead.</li>\n</ul>\n',
      rawdescription:
        "\n\n\nPipe for formatting phone numbers to various international formats\n\n### Global configuration token\n`INPUT_PHONE_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n\nThe following properties can be overwritten using the token:\n - `maxLength`\n - `minLength`\n - `autocomplete`\n - `mask`\n - `displayFormat`\n - `validationPattern`\n - `hideSelectedCountryFlag`\n - `defaultCountryIsoCode`\n - `countryList`\n\n#### Usage notes\nThe following is an example of how to use the token:\n\n```typescript\n import { INPUT_PHONE_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n import { AppModule } from './app/app.module';\n\n const inputPhoneConfig = {\n   maxLength: 10,\n   minLength: 5,\n   autocomplete: 'off',\n   displayFormat: 'E.164',\n }\n\n providers: [\n   {\n     provide: INPUT_PHONE_CONFIG_TOKEN,\n     useValue: inputPhoneConfig,\n   },\n ]\n```\n\n### Country Code Format Config Token\n`COUNTRY_CODE_FORMAT_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n\n#### Usage notes\nThe following is an example of how to use the token.\nNote: the `minLength` and `maxLength` properties do not account for the country dialling code:\n\n```typescript\n import { COUNTRY_CODE_FORMAT_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n import { AppModule } from './app/app.module';\n\n const countryCodeFormatConfig = {\n   '+1': {\n     mask: '+0 (000) 000-0000',\n     minLength: 8,\n     maxLength, 12,\n   },\n };\n\n providers: [\n   {\n     provide: COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n     useValue: countryCodeFormatConfig,\n   },\n ]\n```\n\n#### IMPORTANT NOTE:\n - If you wish to validate & format ALL phone numbers using the SAME `minLength`, `maxLength` and/or `mask`, please configure these values using the `INPUT_PHONE_CONFIG_TOKEN`.\n - If you need to support phone numbers for multiple countries (DIFFERENT `minLength`, `maxLength` & `mask`), we advise to use the `COUNTRY_CODE_FORMAT_CONFIG_TOKEN` instead.\n\n",
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'string | number',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'countryCode',
              type: 'CountryCode',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
            {
              name: 'isInputElement',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 110,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFormats a phone number to any entered country code international format\n',
          description: '<p>Formats a phone number to any entered country code international format</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 3338,
                end: 3343,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              type: 'string | number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 3332,
                end: 3337,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the phone number string to transform</li>\n</ul>\n',
            },
            {
              name: {
                pos: 3395,
                end: 3406,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'countryCode',
              },
              type: 'CountryCode',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                pos: 3389,
                end: 3394,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>the two letter CDLR code for the country to format to</li>\n</ul>\n',
            },
            {
              name: {
                pos: 3475,
                end: 3489,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'isInputElement',
              },
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                pos: 3469,
                end: 3474,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>whether the value was entered in an input element</li>\n</ul>\n',
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'phoneNumber',
      sourceCode:
        "import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';\nimport { AsYouType, CountryCode, NumberFormat, parsePhoneNumber } from 'libphonenumber-js';\nimport {\n  COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n  CountryCodeFormatConfigMap,\n  INPUT_PHONE_CONFIG_TOKEN,\n  InputPhoneConfig,\n} from '@backbase/ui-ang/input-phone';\nimport { NgxMaskService } from 'ngx-mask';\nexport { CountryCode } from 'libphonenumber-js';\n\n/**\n * @name PhoneNumberFormatPipe\n *\n * @description\n * Pipe for formatting phone numbers to various international formats\n *\n * ### Global configuration token\n * `INPUT_PHONE_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n *\n * The following properties can be overwritten using the token:\n *  - `maxLength`\n *  - `minLength`\n *  - `autocomplete`\n *  - `mask`\n *  - `displayFormat`\n *  - `validationPattern`\n *  - `hideSelectedCountryFlag`\n *  - `defaultCountryIsoCode`\n *  - `countryList`\n *\n * #### Usage notes\n * The following is an example of how to use the token:\n *\n * ```typescript\n *  import { INPUT_PHONE_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n *  import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n *  import { AppModule } from './app/app.module';\n *\n *  const inputPhoneConfig = {\n *    maxLength: 10,\n *    minLength: 5,\n *    autocomplete: 'off',\n *    displayFormat: 'E.164',\n *  }\n *\n *  providers: [\n *    {\n *      provide: INPUT_PHONE_CONFIG_TOKEN,\n *      useValue: inputPhoneConfig,\n *    },\n *  ]\n * ```\n *\n * ### Country Code Format Config Token\n * `COUNTRY_CODE_FORMAT_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n *\n * #### Usage notes\n * The following is an example of how to use the token.\n * Note: the `minLength` and `maxLength` properties do not account for the country dialling code:\n *\n * ```typescript\n *  import { COUNTRY_CODE_FORMAT_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n *  import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n *  import { AppModule } from './app/app.module';\n *\n *  const countryCodeFormatConfig = {\n *    '+1': {\n *      mask: '+0 (000) 000-0000',\n *      minLength: 8,\n *      maxLength, 12,\n *    },\n *  };\n *\n *  providers: [\n *    {\n *      provide: COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n *      useValue: countryCodeFormatConfig,\n *    },\n *  ]\n * ```\n *\n * #### IMPORTANT NOTE:\n *  - If you wish to validate & format ALL phone numbers using the SAME `minLength`, `maxLength` and/or `mask`, please configure these values using the `INPUT_PHONE_CONFIG_TOKEN`.\n *  - If you need to support phone numbers for multiple countries (DIFFERENT `minLength`, `maxLength` & `mask`), we advise to use the `COUNTRY_CODE_FORMAT_CONFIG_TOKEN` instead.\n *\n */\n@Pipe({\n  name: 'phoneNumber',\n  standalone: false,\n})\nexport class PhoneNumberPipe implements PipeTransform {\n  constructor(\n    private maskService: NgxMaskService,\n    @Optional()\n    @Inject(INPUT_PHONE_CONFIG_TOKEN)\n    private readonly overrideConfiguration: InputPhoneConfig,\n    @Optional()\n    @Inject(COUNTRY_CODE_FORMAT_CONFIG_TOKEN)\n    private readonly countryCodeFormatConfig: CountryCodeFormatConfigMap,\n  ) {}\n  /**\n   * @name PhoneNumberFormatPipe#transform\n   * @param value - the phone number string to transform\n   * @param countryCode - the two letter CDLR code for the country to format to\n   * @param isInputElement - whether the value was entered in an input element\n   * @description\n   * Formats a phone number to any entered country code international format\n   */\n  transform(value: string | number, countryCode?: CountryCode, isInputElement?: boolean): string {\n    // try to use country-specific mask before trying anything else\n    if (!isInputElement) {\n      for (let i = 2; i <= 4; i++) {\n        const potentialMatch = value.toString().substring(0, i);\n        const maskFoundForPhoneNumber =\n          this.countryCodeFormatConfig && this.countryCodeFormatConfig[potentialMatch]?.mask;\n        if (maskFoundForPhoneNumber) {\n          return `\\u200e${this.maskService.applyMask(value.toString(), maskFoundForPhoneNumber)}`;\n        }\n      }\n    }\n\n    try {\n      if (!countryCode) {\n        return `\\u200e${value.toString()}`;\n      }\n\n      if (isInputElement) {\n        value = new AsYouType(countryCode).input(value.toString());\n      }\n      const phoneNumber = parsePhoneNumber(value.toString(), countryCode);\n      const displayFormat = this.overrideConfiguration?.displayFormat?.toUpperCase() as NumberFormat;\n\n      const formattedPhoneNumber = displayFormat\n        ? phoneNumber.format(displayFormat)\n        : phoneNumber.formatInternational();\n\n      if (this.overrideConfiguration?.mask) {\n        const diallingCodePrefixMask = '0'.repeat(phoneNumber.countryCallingCode.length);\n        const mask = `+${diallingCodePrefixMask} ${this.overrideConfiguration?.mask}`;\n\n        return `\\u200e${this.maskService.applyMask(formattedPhoneNumber, mask)}`;\n      }\n\n      return `\\u200e${formattedPhoneNumber}`;\n    } catch (e) {\n      return `\\u200e${value.toString()}`;\n    }\n  }\n}\n",
    },
    {
      name: 'PresetIllustrationPipe',
      id: 'pipe-PresetIllustrationPipe-f1c60279691ef6dc28cc6772ceff8678469b57b57af9f5432765cec5b8691db242df8addf5c51d3a84fa50287721a316e82995114ea3644819bae4d4115a19cf',
      file: 'libs/ui-ang/empty-state/preset-illustration.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'EmptyStatePresetType',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'value',
              type: 'EmptyStatePresetType',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'presetIllustration',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { EmptyStatePresetType, PRESETS } from './type';\n\n@Pipe({\n  name: 'presetIllustration',\n  standalone: false,\n})\nexport class PresetIllustrationPipe implements PipeTransform {\n  transform(value: EmptyStatePresetType) {\n    const result = PRESETS[value]?.image;\n\n    return result ?? 'ic_asset_coffee';\n  }\n}\n",
    },
    {
      name: 'PresetPrimaryActionTextPipe',
      id: 'pipe-PresetPrimaryActionTextPipe-b64f88c99ec0333dfa95bbf7bc73b14e596d28ef524e54b27a650a5517ea207f81ae68faa89d06f08bbe7b3822af99a312428c8cf56d7aa411ee160c82e06428',
      file: 'libs/ui-ang/empty-state/preset-primary-action-text.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'EmptyStatePresetType',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'value',
              type: 'EmptyStatePresetType',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'presetPrimaryActionText',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { EmptyStatePresetType, PRESETS } from './type';\n\n@Pipe({\n  name: 'presetPrimaryActionText',\n  standalone: false,\n})\nexport class PresetPrimaryActionTextPipe implements PipeTransform {\n  transform(value: EmptyStatePresetType) {\n    const result = PRESETS[value].primaryActionText;\n\n    return (\n      result ?? $localize`:@@bb-empty-state-ui.bb-empty-state__primary-action-text.unknown_error_personal:Try again`\n    );\n  }\n}\n",
    },
    {
      name: 'PresetSubtitlePipe',
      id: 'pipe-PresetSubtitlePipe-f176752d670a5e2286b540c95beb8a4905a697060dab80d6a252699cf3f50106677af62b4ef342af1e5b0e3adafada25f3f17aff8e0afe83843a682559419dd1',
      file: 'libs/ui-ang/empty-state/preset-subtitle.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'EmptyStatePresetType',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'value',
              type: 'EmptyStatePresetType',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'presetSubtitle',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { EmptyStatePresetType, PRESETS } from './type';\n\n@Pipe({\n  name: 'presetSubtitle',\n  standalone: false,\n})\nexport class PresetSubtitlePipe implements PipeTransform {\n  transform(value: EmptyStatePresetType) {\n    const result = PRESETS[value]?.subtitle;\n\n    return (\n      result ??\n      $localize`:@@bb-empty-state-ui.bb-empty-state__message.unknown_error_personal:\n    Try again or contact us if the problem continues`\n    );\n  }\n}\n",
    },
    {
      name: 'PresetTitlePipe',
      id: 'pipe-PresetTitlePipe-6d7ed23dc2c2db6f54ced0d38720b5f3e13def245727fbc133cf018c5dcdd5f4df37c69b276f8750abb000bf8de211faa6db368aaa9e1b1057b776da76163ed1',
      file: 'libs/ui-ang/empty-state/preset-title.pipe.ts',
      type: 'pipe',
      deprecated: false,
      deprecationMessage: '',
      description: '',
      rawdescription: '\n',
      properties: [],
      methods: [
        {
          name: 'transform',
          args: [
            {
              name: 'value',
              type: 'EmptyStatePresetType',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'value',
              type: 'EmptyStatePresetType',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      standalone: false,
      ngname: 'presetTitle',
      sourceCode:
        "import { Pipe, PipeTransform } from '@angular/core';\nimport { EmptyStatePresetType, PRESETS } from './type';\n\n@Pipe({\n  name: 'presetTitle',\n  standalone: false,\n})\nexport class PresetTitlePipe implements PipeTransform {\n  transform(value: EmptyStatePresetType) {\n    const result = PRESETS[value]?.title;\n\n    return result ?? $localize`:@@bb-empty-state-ui.bb-empty-state__title.unknown_error_personal:Something went wrong`;\n  }\n}\n",
    },
  ],
  interfaces: [
    {
      name: 'AccountData',
      id: 'interface-AccountData-450aa340b6bdbb0d1dae726467e1179d9613eda2b74169c1e689cf6fd08f780559d176dc5674e959deb6fff37c91dd883453fb2965afc6232e7b62af254d535f',
      file: 'libs/ui-ang-examples/src/account-selector/examples/account-selector.example.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface AccountData {\n  id: string;\n  name: string;\n  balance: number;\n  number: string;\n  currency: string;\n  favorite: boolean;\n}\n',
      properties: [
        {
          name: 'balance',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
        {
          name: 'favorite',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 2,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 3,
        },
        {
          name: 'number',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'AccountsDisplayingFormat',
      id: 'interface-AccountsDisplayingFormat-5638743bb3a6b935aae4e50cfc52090eb04bc30809363fd4d1e20d714440db95f21fe0b2d61afe0581321d8965efa86b7585f9932baf3d77385c68705cb05ea0',
      file: 'libs/ui-ang/account-number-pipe/constants.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\n/**\n * Product number types\n */\nexport type AccountNumberType = 'cardNumber' | 'iban' | 'bban';\n\n/**\n * Account numbers displaying format\n */\nexport const DefaultAccountsDisplayingFormat: AccountsDisplayingFormat = {\n  segments: 4,\n};\n\n/**\n * Account numbers displaying format\n */\nexport interface AccountsDisplayingFormat {\n  /**\n   * The size (or array of sizes) the segments should have.\n   */\n  segments: number | Array<number>;\n}\n\n/**\n * Accounts displaying format configuration per attribute type\n */\nexport type AccountsDisplayingFormatConfiguration = {\n  /**\n   * Account displaying formats for iban, bban values\n   */\n  [key in AccountNumberType]?: AccountsDisplayingFormat;\n} & {\n  /**\n   * Account displaying format for card numbers\n   */\n  cardNumber?: AccountsDisplayingFormat & {\n    cardProviders?: Record<string, AccountsDisplayingFormat>;\n  };\n};\n\n/**\n * Accounts displaying format Token\n */\nexport const ACCOUNTS_DISPLAYING_FORMAT = new InjectionToken<AccountsDisplayingFormatConfiguration>(\n  'ACCOUNTS_DISPLAYING_FORMAT_TOKEN',\n);\n",
      properties: [
        {
          name: 'segments',
          deprecated: false,
          deprecationMessage: '',
          type: 'number | Array<number>',
          indexKey: '',
          optional: false,
          description: '<p>The size (or array of sizes) the segments should have.</p>\n',
          line: 22,
          rawdescription: '\n\nThe size (or array of sizes) the segments should have.\n',
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Account numbers displaying format</p>\n',
      rawdescription: '\n\nAccount numbers displaying format\n',
      methods: [],
      extends: [],
    },
    {
      name: 'AccountSelectorDefaultItem',
      id: 'interface-AccountSelectorDefaultItem-6eb1034aabe88c1e553a88f1d249de0cccfdee6afc975c691a9581794235b1c926add83901a4be0fa0e19334a3b0157573d91d3f429eb955e89836c9519acd54',
      file: 'libs/ui-ang/account-selector/account-selector.constants.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { AccountStatus } from '@backbase/ui-ang/base-classes';\n\nexport interface AccountSelectorDefaultItem {\n  id?: string;\n  name?: string;\n  balance?: number;\n  availableBalance?: number;\n  number?: string;\n  currency?: string;\n  favorite?: boolean;\n  status?: AccountStatus;\n  bankBranchCode?: string;\n  type?: string;\n}\n\n/**\n * The type to describe rendering balances data option in the account selector view:\n * - `BalanceDetailsView.Booked` - only booked balance data is rendered, OOTB behavior;\n * - `BalanceDetailsView.Available` - only available balance data is rendered;\n * - `BalanceDetailsView.Ordinary` - available balance data is rendered as primary with label `Available`, booked balance as secondary with label `Balance`;\n * - `BalanceDetailsView.Reverse ` - booked balance data is rendered as primary with label `Balance`, available balance as secondary with label `Available`.\n */\nexport enum BalanceDetailsView {\n  Booked = 'booked',\n  Available = 'available',\n  Ordinary = 'ordinary',\n  Reverse = 'reverse',\n}\n",
      properties: [
        {
          name: 'availableBalance',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 7,
        },
        {
          name: 'balance',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
        {
          name: 'bankBranchCode',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 12,
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 9,
        },
        {
          name: 'favorite',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 10,
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
        {
          name: 'number',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 8,
        },
        {
          name: 'status',
          deprecated: false,
          deprecationMessage: '',
          type: 'AccountStatus',
          indexKey: '',
          optional: true,
          description: '',
          line: 11,
        },
        {
          name: 'type',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 13,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'AccountShowCase',
      id: 'interface-AccountShowCase-6d3fd71f686569707f5c1ad75ea27233058e62c7ebfc1ec6266a48de571da730c9d65b53948465311e4eb093fe71447c5d6f12474c8196023db0f0e7efffdf40',
      file: 'libs/ui-ang-examples/src/account-number/showcase/account-number-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, Inject } from '@angular/core';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\nimport {\n  AccountNumberType,\n  ACCOUNTS_DISPLAYING_FORMAT,\n  AccountsDisplayingFormat,\n  AccountsDisplayingFormatConfiguration,\n} from '@backbase/ui-ang/account-number-pipe';\nimport { BehaviorSubject, asyncScheduler } from 'rxjs';\n\ninterface AccountShowCase {\n  description: string;\n  typeOrFormat?: AccountNumberType | AccountsDisplayingFormat;\n  unMaskedNumber: string;\n  maskedNumber: string;\n  number: string;\n  cardProviderName?: string;\n  masked$: BehaviorSubject<boolean>;\n}\n\ninterface ArrangementShowCase {\n  account: {\n    IBAN?: string;\n    BBAN?: string;\n    number?: string;\n    productKindName?: string;\n    maskedNumber?: string;\n    unMaskedNumber?: string;\n  };\n  masked$: BehaviorSubject<boolean>;\n  description: string;\n  unmaskable: boolean;\n}\n\n@Component({\n  selector: 'bb-account-number-ui-showcase',\n  templateUrl: './account-number-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class AccountNumberShowcaseComponent {\n  private readonly customConfiguration: AccountsDisplayingFormat = { segments: [1, 2, 3, 1, 2, 3, 1, 2, 3] };\n  arrangementItems: ArrangementShowCase[] = [\n    {\n      account: {\n        IBAN: 'GB29NWBK60161331926819',\n        BBAN: 'BBAN00001',\n        number: '1234',\n        productKindName: 'Current Account',\n        maskedNumber: '****************6819', // Only for demo. In actual, should come from backend api.\n        unMaskedNumber: 'GB29NWBK60161331926819',\n      },\n      masked$: new BehaviorSubject<boolean>(false),\n      description: 'With account having iban, bban and number',\n      unmaskable: true,\n    },\n    {\n      account: {\n        BBAN: 'BBAN00001',\n        number: '1234',\n        productKindName: 'Current Account',\n        maskedNumber: '*****0001',\n        unMaskedNumber: 'BBAN00001',\n      },\n      masked$: new BehaviorSubject<boolean>(false),\n      description: 'With account having bban and number',\n      unmaskable: true,\n    },\n    {\n      account: {\n        number: '1234',\n        maskedNumber: '*****',\n        unMaskedNumber: '1234',\n        productKindName: 'Current Account',\n      },\n      masked$: new BehaviorSubject<boolean>(false),\n      description: 'With account having number',\n      unmaskable: true,\n    },\n    {\n      account: {\n        IBAN: 'GB29NWBK60161331926819',\n        BBAN: 'BBAN00001',\n        number: '1234',\n        productKindName: 'Current Account',\n      },\n      masked$: new BehaviorSubject<boolean>(false),\n      description: 'With unmaskable set to false',\n      unmaskable: false,\n    },\n  ];\n\n  accounts: AccountShowCase[] = [\n    {\n      description: 'iban',\n      typeOrFormat: 'iban',\n      unMaskedNumber: 'IBAN1234567891234567',\n      number: 'IBAN1234567891234567',\n      maskedNumber: '****************4567',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n    {\n      description: 'bban',\n      typeOrFormat: 'bban',\n      unMaskedNumber: 'BBAN1234567891234567',\n      number: 'BBAN1234567891234567',\n      maskedNumber: '****************4567',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n    {\n      description: 'cardNumber',\n      typeOrFormat: 'cardNumber',\n      unMaskedNumber: 'num1234567891234567',\n      maskedNumber: '****************4567',\n      number: 'num1234567891234567',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n    {\n      description: 'cardNumber (visa provider)',\n      typeOrFormat: 'cardNumber',\n      unMaskedNumber: 'num1234567891234567',\n      maskedNumber: '****************4567',\n      number: 'num1234567891234567',\n      cardProviderName: 'Visa',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n    {\n      description: `Custom format [${this.customConfiguration.segments}]`,\n      typeOrFormat: this.customConfiguration,\n      unMaskedNumber: 'num1234567891234567',\n      maskedNumber: '****************4567',\n      number: 'num1234567891234567',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n  ];\n\n  onMask(account: AccountShowCase) {\n    asyncScheduler.schedule((_) => {\n      account.number = account.maskedNumber;\n      account.masked$.next(true);\n    });\n  }\n\n  onUnMask(account: AccountShowCase) {\n    asyncScheduler.schedule((_) => {\n      account.number = account.unMaskedNumber;\n      account.masked$.next(false);\n    });\n  }\n\n  onAccountMask(arrangementItem: ArrangementShowCase) {\n    const { account, masked$ } = arrangementItem;\n    asyncScheduler.schedule((_) => {\n      if (account.IBAN) {\n        account.IBAN = account.maskedNumber;\n      } else if (account.BBAN) {\n        account.BBAN = account.maskedNumber;\n      } else {\n        account.number = account.maskedNumber;\n      }\n      masked$.next(true);\n    });\n  }\n\n  onAccountUnMask(arrangementItem: ArrangementShowCase) {\n    const { account, masked$ } = arrangementItem;\n    asyncScheduler.schedule((_) => {\n      if (account.IBAN) {\n        account.IBAN = account.unMaskedNumber;\n      } else if (account.BBAN) {\n        account.BBAN = account.unMaskedNumber;\n      } else {\n        account.number = account.unMaskedNumber;\n      }\n      masked$.next(false);\n    });\n  }\n\n  constructor(@Inject(ACCOUNTS_DISPLAYING_FORMAT) readonly configuration: AccountsDisplayingFormatConfiguration) {}\n}\n",
      properties: [
        {
          name: 'cardProviderName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 17,
        },
        {
          name: 'description',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 12,
        },
        {
          name: 'masked$',
          deprecated: false,
          deprecationMessage: '',
          type: 'BehaviorSubject<boolean>',
          indexKey: '',
          optional: false,
          description: '',
          line: 18,
        },
        {
          name: 'maskedNumber',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 15,
        },
        {
          name: 'number',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 16,
        },
        {
          name: 'typeOrFormat',
          deprecated: false,
          deprecationMessage: '',
          type: 'AccountNumberType | AccountsDisplayingFormat',
          indexKey: '',
          optional: true,
          description: '',
          line: 13,
        },
        {
          name: 'unMaskedNumber',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 14,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'AlertOptions',
      id: 'interface-AlertOptions-17cf245c2dac8ed0517e534dd0e5afb832a065a0228326f6421136d7b8bab60a876159c3cd37c5c40ee382345d59e74d61351a7e69a988b1cec5415bd66fcc04',
      file: 'libs/ui-ang/alert/alert.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  AfterViewInit,\n  ChangeDetectionStrategy,\n  ChangeDetectorRef,\n  Component,\n  ElementRef,\n  EventEmitter,\n  Input,\n  OnInit,\n  Output,\n  ViewChild,\n} from '@angular/core';\nimport { DomAttributesService } from '@backbase/ui-ang/services';\nimport { AlertType } from './alert.constants';\n\ninterface AlertOptions {\n  warning: string;\n  error: string;\n  success: string;\n  info: string;\n\n  [key: string]: string;\n}\n\n/**\n * @name AlertComponent\n *\n * @description\n * Component that displays an alert.\n *\n * ### Accessibility\n * For Alert component it's not required to pass any options for accessibility.\n * It internally handles accessibility for title and message:\n *  - title is linked with aria-labelledby.\n *  - message is linked with aria-describedby.\n */\n@Component({\n  selector: 'bb-alert-ui',\n  templateUrl: './alert.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class AlertComponent implements OnInit, AfterViewInit {\n  /**\n   * The type modifier for the alert. Defaults to 'error'.\n   */\n  @Input() modifier: AlertType = 'error';\n  /**\n   * Whether the alert can be dismissed. Defaults to false.\n   */\n  @Input() dismissible = false;\n  /**\n   * Whether the button in the alert is focused on initial load. Defaults to false.\n   */\n  @Input() autofocus: boolean = false;\n  /**\n   * The title of the alert.\n   * Will throw an error if unset.\n   * It is internaly linked with aria-labelledby.\n   */\n  @Input() title: string | undefined;\n  /**\n   * The message of the alert.\n   * If nothing provided, wouldn't be displayed.\n   * It is internally linked with aria-describedby.\n   */\n  @Input() message: string | undefined;\n  /**\n   * The title of the primary action button.\n   */\n  @Input() primaryActionButtonText: string | undefined;\n  /**\n   * The title of the supportive link button.\n   */\n  @Input() supportiveLinkText: string | undefined;\n\n  /**\n   * Aria label for a \"close\" button\n   */\n  @Input() closeButtonAriaLabel = 'Close alert';\n\n  /**\n   * The callback fired upon closing the alert.\n   */\n  @Output() close = new EventEmitter<void>();\n  /**\n   * The callback fired upon clicking primary action button.\n   */\n  @Output() primaryActionButtonClick = new EventEmitter<void>();\n  /**\n   * The callback fired upon clicking supportive link button.\n   */\n  @Output() supportiveLinkClick = new EventEmitter<void>();\n\n  @ViewChild('contentWrapper') contentWrapper!: ElementRef;\n\n  alertTitleId: string | null = this.domAttrService.generateId();\n  alertDescriptionId: string | null = this.domAttrService.generateId();\n\n  isOpen = true;\n  isContentProvided = true;\n\n  private previousFocused: HTMLElement | null = null;\n\n  constructor(\n    private readonly domAttrService: DomAttributesService,\n    private readonly changeDetector: ChangeDetectorRef,\n    private readonly elementRef: ElementRef,\n  ) {}\n\n  ngOnInit() {\n    if (typeof this.title === 'undefined') {\n      throw new Error(`\"title\" input is required in \"${this.constructor.name}\"`);\n    }\n  }\n\n  ngAfterViewInit() {\n    if (this.autofocus) {\n      const focusable = this.elementRef.nativeElement.querySelector('button');\n\n      if (focusable) {\n        this.previousFocused = document.activeElement as HTMLElement | null;\n        focusable.focus();\n      }\n    }\n\n    if (!!this.message) {\n      this.isContentProvided = false;\n\n      return;\n    }\n\n    this.isContentProvided = Boolean(this.contentWrapper?.nativeElement.innerText);\n    if (!this.isContentProvided) {\n      this.alertDescriptionId = null;\n      this.changeDetector.detectChanges();\n    }\n  }\n\n  closeAlert() {\n    this.previousFocused?.focus();\n    this.close.emit();\n  }\n}\n",
      properties: [
        {
          name: 'error',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 18,
        },
        {
          name: 'info',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 20,
        },
        {
          name: 'success',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 19,
        },
        {
          name: 'warning',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 17,
        },
      ],
      indexSignatures: [
        {
          id: 'index-declaration-17cf245c2dac8ed0517e534dd0e5afb832a065a0228326f6421136d7b8bab60a876159c3cd37c5c40ee382345d59e74d61351a7e69a988b1cec5415bd66fcc04',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'string',
          line: 20,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      methods: [],
      extends: [],
    },
    {
      name: 'AllRuleData',
      id: 'interface-AllRuleData-b86499464611e9c53a8431adccf5dbf3a65a42de30bd04cc805a7b7155731ef4e0d8de34a03cfa775948c2ec43db03c0ccd9956cdd4b488a63d7019622853e7b',
      file: 'tools/scripts/ds-eslint/generate-rule-docs.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import type { TSESLint } from '@typescript-eslint/utils';\nimport { readdirSync, readFileSync, writeFileSync } from 'fs';\nimport { compile } from 'json-schema-to-typescript';\nimport traverse from 'json-schema-traverse';\nimport { join, relative } from 'path';\nimport { format, resolveConfig } from 'prettier';\nimport ts from 'typescript';\n\nconst SPECIAL_UNDERLINE_CHARS = ['~', '^', '#', '%', '¶', '*', '¨', '@'];\n\nconst docsOutputDir = join(__dirname, `../../../libs/eslint-plugin-design-system/docs/rules`);\n\nconst rulesDir = join(__dirname, `../../../libs/eslint-plugin-design-system/src/rules`);\nconst ruleFiles = readdirSync(rulesDir);\n\nconst testDirsDir = join(__dirname, `../../../libs/eslint-plugin-design-system/src/rules`);\nconst testDirs = readdirSync(testDirsDir);\n\n(async function main() {\n  const allRuleData = await generateAllRuleData();\n\n  for (const [ruleName, ruleData] of Object.entries(allRuleData)) {\n    const {\n      ruleConfig: {\n        meta: { deprecated, replacedBy, type, fixable, schema, hasSuggestions },\n        defaultOptions,\n      },\n      docsExtension,\n      ruleFilePath,\n      testCasesFilePath,\n    } = ruleData;\n\n    const docs = ruleData.ruleConfig.meta.docs as TSESLint.RuleMetaDataDocs<[]>;\n    const { description } = docs;\n\n    let schemaAsInterface = '';\n    if (Array.isArray(schema) && schema[0]) {\n      /**\n       * json-schema-to-typescript does not do anything with the \"default\" property,\n       * but it's really useful to include in the documentation, so we apply the\n       * default value in a consistent way to the \"description\" property before\n       * converting.\n       */\n      traverse(schema[0], {\n        allKeys: true,\n        cb: (...data) => {\n          const [schemaNode, , , , , , keyIndex] = data;\n\n          let defaultValue = null;\n\n          if (typeof schemaNode.default !== 'undefined') {\n            defaultValue = schemaNode.default;\n          } else if (defaultOptions?.length) {\n            for (const defaultOption of defaultOptions) {\n              const defaultValueForNode = defaultOption[keyIndex as string];\n              if (defaultValueForNode) {\n                defaultValue = defaultValueForNode;\n              }\n            }\n          }\n\n          if (defaultValue) {\n            if (schemaNode.description) {\n              schemaNode.description += '\\n\\n';\n            } else {\n              schemaNode.description = '';\n            }\n            const serializedDefaultValue = JSON.stringify(defaultValue);\n            schemaNode.description += `Default: \\`${serializedDefaultValue}\\``;\n\n            return;\n          }\n        },\n      });\n      schemaAsInterface = await compile(schema[0], 'Options', {\n        bannerComment: '',\n      });\n      schemaAsInterface = schemaAsInterface.replace('export ', '');\n    }\n\n    const fullRuleName = `@backbase/design-system/${ruleName}`;\n\n    const md = `\n<!--\n\n  DO NOT EDIT.\n\n  This markdown file was autogenerated using a mixture of the following files as the source of truth for its data:\n  - ${relativePath(docsOutputDir, ruleFilePath)}\n  - ${relativePath(docsOutputDir, testCasesFilePath)}\n\n  In order to update this file, it is therefore those files which need to be updated,\n  as well as potentially the generator script:\n  - ${relativePath(docsOutputDir, __filename)}\n\n-->\n\n<br>\n\n# \\`${fullRuleName}\\`\n\n${\n  deprecated\n    ? `## ⚠️ THIS RULE IS DEPRECATED\\n\\nPlease use ${(replacedBy || [])\n        .map((r: string) => `\\`@backbase/design-system/${r}\\``)\n        .join(', ')} instead.\\n\\n---\\n\\n`\n    : ''\n}${description}\n\n- Type: ${type}\n${fixable === 'code' ? '- 🔧 Supports autofix (`--fix`)\\n' : ''}\n${\n  hasSuggestions\n    ? '- 💡 Provides suggestions on how to fix issues (https://eslint.org/docs/developer-guide/working-with-rules#providing-suggestions)'\n    : ''\n}${\n      docsExtension?.rationale\n        ? `\n\n<br>\n\n## Rationale\n\n${docsExtension.rationale}\n`\n        : ''\n    }\n\n<br>\n\n## Rule Options\n\n${\n  schemaAsInterface\n    ? `\nThe rule accepts an options object with the following properties:\n\n\\`\\`\\`ts\n${schemaAsInterface}\n\\`\\`\\`\n`\n    : 'The rule does not have any configuration options.'\n}\n\n<br>\n\n## Usage Examples\n\n> The following examples are generated automatically from the actual unit tests within the plugin,\n so you can be assured that their behavior is accurate based on the current commit.\n\n<br>\n\n<details>\n<summary>❌ - Toggle examples of <strong>incorrect</strong> code for this rule</summary>\n\n${convertCodeExamplesToMarkdown(ruleData.invalid, 'invalid', 'html', fullRuleName)}\n\n</details>\n\n<br>\n\n---\n\n<br>\n\n<details>\n<summary>✅ - Toggle examples of <strong>correct</strong> code for this rule</summary>\n\n${convertCodeExamplesToMarkdown(ruleData.valid, 'valid', 'html', fullRuleName)}\n\n</details>\n\n<br>\n`;\n\n    const outputFilePath = join(docsOutputDir, `${ruleName}.md`);\n    writeFileSync(\n      outputFilePath,\n      await format(md, {\n        ...(await resolveConfig(outputFilePath)),\n        parser: 'markdown',\n      }),\n    );\n  }\n\n  console.log(`\\n✨ Updated docs for all rules in \"@backbase/design-system\"`);\n})();\n\ninterface RuleData {\n  ruleFilePath: string;\n  testCasesFilePath: string;\n  ruleConfig: TSESLint.RuleModule<string, []> & {\n    defaultOptions?: Record<string, unknown>[];\n  };\n  // Rules can optionally export extended documentation content (outside of ESLint's concept of \"docs\")\n  docsExtension?: {\n    rationale?: string;\n  };\n  valid: ExtractedTestCase[];\n  invalid: ExtractedTestCase[];\n}\n\ninterface AllRuleData {\n  [ruleName: string]: RuleData;\n}\n\ninterface ExtractedTestCase {\n  code: string;\n  options?: unknown[];\n}\n\nasync function generateAllRuleData(): Promise<AllRuleData> {\n  const ruleData: AllRuleData = {};\n\n  // For rule sources we just import/execute the rule source file\n  for (const ruleFile of ruleFiles) {\n    if (ruleFile.endsWith('.spec.ts')) {\n      continue;\n    }\n\n    const ruleFilePath = join(rulesDir, ruleFile.replace('.ts', ''));\n    const {\n      default: ruleConfig,\n      RULE_NAME,\n      RULE_DOCS_EXTENSION,\n      // eslint-disable-next-line @typescript-eslint/no-var-requires\n    } = require(ruleFilePath);\n    ruleData[RULE_NAME] = {\n      ruleConfig,\n      ruleFilePath: ruleFilePath + '.ts',\n      docsExtension: RULE_DOCS_EXTENSION,\n    } as RuleData;\n  }\n\n  /**\n   * For tests we want to preserve the annotated sources, so we do NOT want\n   * to execute the file and instead need to parse it using the ts compiler.\n   */\n  for (const testDir of testDirs) {\n    if (testDir.endsWith('.spec.ts')) {\n      continue;\n    }\n\n    const ruleFilePath = join(rulesDir, testDir.replace('.ts', ''));\n    const {\n      RULE_NAME,\n      // eslint-disable-next-line @typescript-eslint/no-var-requires\n    } = require(ruleFilePath);\n\n    const testDirPath = join(testDirsDir, testDir);\n    const casesFilePath = testDirPath.replace(/.ts$/, '.spec.ts');\n    const testCasesContents = readFileSync(casesFilePath, 'utf-8');\n    const casesSourceFile = ts.createSourceFile(casesFilePath, testCasesContents, ts.ScriptTarget.Latest, true);\n\n    const extractedValid: ExtractedTestCase[] = [];\n    const extractedInvalid: ExtractedTestCase[] = [];\n\n    const extractNodes = (node: ts.Node) => {\n      if (\n        ts.isVariableDeclaration(node) &&\n        node.name.getText() === 'valid' &&\n        node.initializer &&\n        ts.isArrayLiteralExpression(node.initializer)\n      ) {\n        node.initializer.elements.forEach((el) => {\n          const newExtractedTestCase: ExtractedTestCase = {\n            code: '',\n          };\n\n          if (ts.isStringLiteralLike(el)) {\n            newExtractedTestCase.code = el.text;\n          }\n\n          if (ts.isObjectLiteralExpression(el)) {\n            el.properties.forEach((prop) => {\n              if (ts.isPropertyAssignment(prop) && prop.name.getText() === 'code') {\n                if (ts.isNoSubstitutionTemplateLiteral(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.rawText || prop.initializer.text;\n                }\n                if (ts.isTemplateExpression(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.getText();\n                }\n                if (ts.isStringLiteral(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.text;\n                }\n              }\n\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'options' &&\n                ts.isArrayLiteralExpression(prop.initializer)\n              ) {\n                newExtractedTestCase.options = convertArrayLiteralExpressionToCode(prop.initializer);\n              }\n            });\n          }\n\n          if (newExtractedTestCase.code) {\n            extractedValid.push(newExtractedTestCase);\n          }\n        });\n      }\n\n      if (\n        ts.isVariableDeclaration(node) &&\n        node.name.getText() === 'invalid' &&\n        node.initializer &&\n        ts.isArrayLiteralExpression(node.initializer)\n      ) {\n        node.initializer.elements.forEach((el) => {\n          if (ts.isCallExpression(el) && el.expression.getText() === 'convertAnnotatedSourceToFailureCase') {\n            const newExtractedTestCase: ExtractedTestCase = {\n              code: '',\n            };\n\n            const config = el.arguments[0] as ts.ObjectLiteralExpression;\n            config.properties.forEach((prop) => {\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'annotatedSource' &&\n                ts.isNoSubstitutionTemplateLiteral(prop.initializer)\n              ) {\n                newExtractedTestCase.code = prop.initializer.text;\n              }\n\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'options' &&\n                ts.isArrayLiteralExpression(prop.initializer)\n              ) {\n                newExtractedTestCase.options = convertArrayLiteralExpressionToCode(prop.initializer);\n              }\n            });\n\n            if (newExtractedTestCase.code) {\n              extractedInvalid.push(newExtractedTestCase);\n            }\n          }\n        });\n      }\n\n      ts.forEachChild(node, extractNodes);\n    };\n\n    // Extract valid and invalid cases as strings\n    extractNodes(casesSourceFile);\n\n    ruleData[RULE_NAME] = {\n      ...ruleData[RULE_NAME],\n      testCasesFilePath: casesFilePath,\n      valid: extractedValid,\n      invalid: extractedInvalid,\n    };\n  }\n\n  return ruleData;\n}\n\nfunction standardizeSpecialUnderlineChar(str: string): string {\n  /**\n   * It is important that we only update special characters when we are on a line\n   * which only has special characters on it (as well as whitespace). Otherwise\n   * we will end up replacing real characters from the source code in the example.\n   */\n  const specialCharsOrWhitespaceRegExp = new RegExp(`^(${SPECIAL_UNDERLINE_CHARS.map(escapeRegExp).join('|')}|\\\\s)+$`);\n  const whitespaceOnlyRegExp = /^\\s+$/;\n\n  return str\n    .split('\\n')\n    .map((line) => {\n      // Is line with exclusively special characters and whitespace (but not just whitespace)?\n      if (!line.match(whitespaceOnlyRegExp) && line.match(specialCharsOrWhitespaceRegExp)) {\n        return line\n          .split('')\n          .map((char) =>\n            SPECIAL_UNDERLINE_CHARS.includes(char as (typeof SPECIAL_UNDERLINE_CHARS)[number]) ? '~' : char,\n          )\n          .join('');\n      }\n\n      return line;\n    })\n    .join('\\n');\n}\n\n// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping\nfunction escapeRegExp(str: string) {\n  return str.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&'); // $& means the whole matched string\n}\n\nfunction convertCodeExamplesToMarkdown(\n  codeExamples: ExtractedTestCase[] = [],\n  kind: 'valid' | 'invalid',\n  highligher: 'html' | 'ts',\n  ruleName: string,\n): string {\n  return codeExamples\n    .map(({ code, options }, i) => {\n      let formattedCode = removeLeadingAndTrailingEmptyLinesFromCodeExample(\n        removeLeadingIndentationFromCodeExample(code),\n      );\n      if (kind === 'invalid') {\n        formattedCode = standardizeSpecialUnderlineChar(formattedCode);\n      }\n\n      const exampleRuleConfig: unknown[] = ['error'];\n      // Not all unit tests have options configured\n      if (options) {\n        exampleRuleConfig.push(options[0]);\n      }\n      const formattedConfig = JSON.stringify(\n        {\n          rules: {\n            [ruleName]: exampleRuleConfig,\n          },\n        },\n        null,\n        2,\n      );\n\n      return `<br>\n\n#### ${options ? 'Custom' : 'Default'} Config\n\n\\`\\`\\`json\n${formattedConfig}\n\\`\\`\\`\n\n<br>\n\n#### ${kind === 'invalid' ? '❌ Invalid' : '✅ Valid'} Code\n\n\\`\\`\\`${highligher}\n${formattedCode}\n\\`\\`\\`\n\n${\n  i === codeExamples.length - 1\n    ? ''\n    : `<br>\n\n---`\n}\n  `;\n    })\n    .join('\\n');\n}\n\nfunction removeLeadingAndTrailingEmptyLinesFromCodeExample(code: string): string {\n  const lines = code.split('\\n');\n\n  let currentLineIndex = 0;\n  let firstNonEmptyLineIndex = -1;\n  let lastNonEmptyLineIndex = -1;\n\n  for (const line of lines) {\n    if (/\\S/.test(line)) {\n      if (firstNonEmptyLineIndex === -1) {\n        firstNonEmptyLineIndex = currentLineIndex;\n      }\n      lastNonEmptyLineIndex = currentLineIndex;\n    }\n    currentLineIndex++;\n  }\n\n  return lines\n    .filter((_, index) => {\n      if (index < firstNonEmptyLineIndex) {\n        return false;\n      }\n      if (index > lastNonEmptyLineIndex) {\n        return false;\n      }\n\n      return true;\n    })\n    .join('\\n');\n}\n\n/**\n * We want to remove unnecessary leading padding, but keeping everything relative,\n * so that code indentation is not messed up\n */\nfunction removeLeadingIndentationFromCodeExample(code: string): string {\n  let detectedAmountToTrim: number | null = null;\n\n  return code\n    .split('\\n')\n    .map((line) => {\n      // Is whitespace-only line, ignore\n      if (!/\\S/.test(line)) {\n        return line;\n      }\n\n      // Haven't yet determined the number of characters to trim from the beginning of each line\n      const charsInLine = line.split('');\n      if (typeof detectedAmountToTrim !== 'number') {\n        let numberOfLeadingWhitespaceChars = 0;\n        for (const char of charsInLine) {\n          if (!/\\S/.test(char)) {\n            numberOfLeadingWhitespaceChars++;\n            continue;\n          }\n          break;\n        }\n        detectedAmountToTrim = numberOfLeadingWhitespaceChars;\n      }\n\n      // Trim the detected number of characters from the beginning of the current line\n      return (\n        line\n          .split('')\n          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion\n          .filter((_, i) => !(i < detectedAmountToTrim!))\n          .join('')\n      );\n    })\n    .join('\\n');\n}\n\nfunction convertStringLikeToCode(strLike: ts.StringLiteralLike): string {\n  if (ts.isStringLiteralLike(strLike)) {\n    return strLike.text;\n  }\n\n  return '';\n}\n\nfunction convertNumericalLiteralToCode(numLiteral: ts.NumericLiteral): number {\n  return Number(numLiteral.text);\n}\n\nfunction convertBooleanLiteralToCode(booleanLiteral: ts.BooleanLiteral): boolean {\n  const stringified = booleanLiteral.getText();\n  if (stringified === 'false') {\n    return false;\n  }\n  if (stringified === 'true') {\n    return true;\n  }\n  throw new Error(`Could not convert booleanLiteral node to code: ${booleanLiteral}`);\n}\n\nfunction convertArrayLiteralExpressionToCode(arrExpr: ts.ArrayLiteralExpression): unknown[] {\n  const arr: unknown[] = [];\n  arrExpr.elements.forEach((el) => {\n    if (ts.isObjectLiteralExpression(el)) {\n      const item = convertObjectLiteralExpressionToCode(el);\n      arr.push(item);\n    }\n    if (ts.isStringLiteralLike(el)) {\n      const item = convertStringLikeToCode(el);\n      arr.push(item);\n    }\n    if (ts.isArrayLiteralExpression(el)) {\n      const item = convertArrayLiteralExpressionToCode(el);\n      arr.push(item);\n    }\n  });\n\n  return arr;\n}\n\nfunction convertObjectLiteralExpressionToCode(objExpr: ts.ObjectLiteralExpression): Record<string, unknown> {\n  const obj: Record<string, unknown> = {};\n  objExpr.properties.forEach((prop) => {\n    if (ts.isPropertyAssignment(prop)) {\n      const key = prop.name.getText();\n\n      let val;\n      if (ts.isObjectLiteralExpression(prop.initializer)) {\n        val = convertObjectLiteralExpressionToCode(prop.initializer);\n      }\n      if (ts.isStringLiteralLike(prop.initializer)) {\n        val = convertStringLikeToCode(prop.initializer);\n      }\n      if (ts.isArrayLiteralExpression(prop.initializer)) {\n        val = convertArrayLiteralExpressionToCode(prop.initializer);\n      }\n      if (ts.isNumericLiteral(prop.initializer)) {\n        val = convertNumericalLiteralToCode(prop.initializer);\n      }\n      if (prop.initializer.kind === ts.SyntaxKind.TrueKeyword || prop.initializer.kind === ts.SyntaxKind.FalseKeyword) {\n        val = convertBooleanLiteralToCode(prop.initializer as ts.BooleanLiteral);\n      }\n\n      if (key && typeof val !== 'undefined') {\n        obj[key] = val;\n      }\n    }\n  });\n\n  return obj;\n}\n\nfunction relativePath(from: string, to: string) {\n  // On Windows relative() outputs backslashes. As the path should always contain normal slashes, replace them.\n  return relative(from, to).replace(/\\\\/g, '/');\n}\n",
      properties: [],
      indexSignatures: [
        {
          id: 'index-declaration-b86499464611e9c53a8431adccf5dbf3a65a42de30bd04cc805a7b7155731ef4e0d8de34a03cfa775948c2ec43db03c0ccd9956cdd4b488a63d7019622853e7b',
          args: [
            {
              name: 'ruleName',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'RuleData',
          line: 204,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      methods: [],
      extends: [],
    },
    {
      name: 'AmountConfig',
      id: 'interface-AmountConfig-d3d4b04511a91f404704e912adc9932e5ac7b478b7f4b8525fdf08b4a1f5cde64d4b2c7bcfb6e1aaedf4fab02585307a51d6fc0fff97238ea9dde3354acf7bd4',
      file: 'libs/ui-ang/amount/amount.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface AmountConfig {\n  abbreviate?: boolean;\n  currency?: string;\n  decimalPlaces?: number;\n  mapCurrency?: boolean;\n  trailingZeroes?: boolean;\n  currencyFormat?: 'wide' | 'narrow';\n  signPosition?: 'left' | 'right';\n}\n\nexport const AMOUNT_CONFIG_TOKEN = new InjectionToken<AmountConfig>('AMOUNT_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'abbreviate',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
        {
          name: 'currencyFormat',
          deprecated: false,
          deprecationMessage: '',
          type: '"wide" | "narrow"',
          indexKey: '',
          optional: true,
          description: '',
          line: 9,
        },
        {
          name: 'decimalPlaces',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
        {
          name: 'mapCurrency',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 7,
        },
        {
          name: 'signPosition',
          deprecated: false,
          deprecationMessage: '',
          type: '"left" | "right"',
          indexKey: '',
          optional: true,
          description: '',
          line: 10,
        },
        {
          name: 'trailingZeroes',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 8,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ArrangementItem',
      id: 'interface-ArrangementItem-ec1e2404ed90a0329d3b31be84633b25af2f38774913b8c5e3071ac51275e16795bf9412b55bb32f7252d533120a1658e9cd620b913cd34862d57e56a534e102',
      file: 'libs/ui-ang/account-number/account-number-model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface ArrangementItem {\n  IBAN?: string;\n  BBAN?: string;\n  number?: string;\n  productKindName?: string;\n}\n',
      properties: [
        {
          name: 'BBAN',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'IBAN',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 3,
        },
        {
          name: 'number',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
        {
          name: 'productKindName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Interface for the account item containing IBAN, BBAN and number.</p>\n',
      rawdescription: '\nInterface for the account item containing IBAN, BBAN and number.',
      methods: [],
      extends: [],
    },
    {
      name: 'ArrangementShowCase',
      id: 'interface-ArrangementShowCase-6d3fd71f686569707f5c1ad75ea27233058e62c7ebfc1ec6266a48de571da730c9d65b53948465311e4eb093fe71447c5d6f12474c8196023db0f0e7efffdf40',
      file: 'libs/ui-ang-examples/src/account-number/showcase/account-number-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, Inject } from '@angular/core';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\nimport {\n  AccountNumberType,\n  ACCOUNTS_DISPLAYING_FORMAT,\n  AccountsDisplayingFormat,\n  AccountsDisplayingFormatConfiguration,\n} from '@backbase/ui-ang/account-number-pipe';\nimport { BehaviorSubject, asyncScheduler } from 'rxjs';\n\ninterface AccountShowCase {\n  description: string;\n  typeOrFormat?: AccountNumberType | AccountsDisplayingFormat;\n  unMaskedNumber: string;\n  maskedNumber: string;\n  number: string;\n  cardProviderName?: string;\n  masked$: BehaviorSubject<boolean>;\n}\n\ninterface ArrangementShowCase {\n  account: {\n    IBAN?: string;\n    BBAN?: string;\n    number?: string;\n    productKindName?: string;\n    maskedNumber?: string;\n    unMaskedNumber?: string;\n  };\n  masked$: BehaviorSubject<boolean>;\n  description: string;\n  unmaskable: boolean;\n}\n\n@Component({\n  selector: 'bb-account-number-ui-showcase',\n  templateUrl: './account-number-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class AccountNumberShowcaseComponent {\n  private readonly customConfiguration: AccountsDisplayingFormat = { segments: [1, 2, 3, 1, 2, 3, 1, 2, 3] };\n  arrangementItems: ArrangementShowCase[] = [\n    {\n      account: {\n        IBAN: 'GB29NWBK60161331926819',\n        BBAN: 'BBAN00001',\n        number: '1234',\n        productKindName: 'Current Account',\n        maskedNumber: '****************6819', // Only for demo. In actual, should come from backend api.\n        unMaskedNumber: 'GB29NWBK60161331926819',\n      },\n      masked$: new BehaviorSubject<boolean>(false),\n      description: 'With account having iban, bban and number',\n      unmaskable: true,\n    },\n    {\n      account: {\n        BBAN: 'BBAN00001',\n        number: '1234',\n        productKindName: 'Current Account',\n        maskedNumber: '*****0001',\n        unMaskedNumber: 'BBAN00001',\n      },\n      masked$: new BehaviorSubject<boolean>(false),\n      description: 'With account having bban and number',\n      unmaskable: true,\n    },\n    {\n      account: {\n        number: '1234',\n        maskedNumber: '*****',\n        unMaskedNumber: '1234',\n        productKindName: 'Current Account',\n      },\n      masked$: new BehaviorSubject<boolean>(false),\n      description: 'With account having number',\n      unmaskable: true,\n    },\n    {\n      account: {\n        IBAN: 'GB29NWBK60161331926819',\n        BBAN: 'BBAN00001',\n        number: '1234',\n        productKindName: 'Current Account',\n      },\n      masked$: new BehaviorSubject<boolean>(false),\n      description: 'With unmaskable set to false',\n      unmaskable: false,\n    },\n  ];\n\n  accounts: AccountShowCase[] = [\n    {\n      description: 'iban',\n      typeOrFormat: 'iban',\n      unMaskedNumber: 'IBAN1234567891234567',\n      number: 'IBAN1234567891234567',\n      maskedNumber: '****************4567',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n    {\n      description: 'bban',\n      typeOrFormat: 'bban',\n      unMaskedNumber: 'BBAN1234567891234567',\n      number: 'BBAN1234567891234567',\n      maskedNumber: '****************4567',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n    {\n      description: 'cardNumber',\n      typeOrFormat: 'cardNumber',\n      unMaskedNumber: 'num1234567891234567',\n      maskedNumber: '****************4567',\n      number: 'num1234567891234567',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n    {\n      description: 'cardNumber (visa provider)',\n      typeOrFormat: 'cardNumber',\n      unMaskedNumber: 'num1234567891234567',\n      maskedNumber: '****************4567',\n      number: 'num1234567891234567',\n      cardProviderName: 'Visa',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n    {\n      description: `Custom format [${this.customConfiguration.segments}]`,\n      typeOrFormat: this.customConfiguration,\n      unMaskedNumber: 'num1234567891234567',\n      maskedNumber: '****************4567',\n      number: 'num1234567891234567',\n      masked$: new BehaviorSubject<boolean>(false),\n    },\n  ];\n\n  onMask(account: AccountShowCase) {\n    asyncScheduler.schedule((_) => {\n      account.number = account.maskedNumber;\n      account.masked$.next(true);\n    });\n  }\n\n  onUnMask(account: AccountShowCase) {\n    asyncScheduler.schedule((_) => {\n      account.number = account.unMaskedNumber;\n      account.masked$.next(false);\n    });\n  }\n\n  onAccountMask(arrangementItem: ArrangementShowCase) {\n    const { account, masked$ } = arrangementItem;\n    asyncScheduler.schedule((_) => {\n      if (account.IBAN) {\n        account.IBAN = account.maskedNumber;\n      } else if (account.BBAN) {\n        account.BBAN = account.maskedNumber;\n      } else {\n        account.number = account.maskedNumber;\n      }\n      masked$.next(true);\n    });\n  }\n\n  onAccountUnMask(arrangementItem: ArrangementShowCase) {\n    const { account, masked$ } = arrangementItem;\n    asyncScheduler.schedule((_) => {\n      if (account.IBAN) {\n        account.IBAN = account.unMaskedNumber;\n      } else if (account.BBAN) {\n        account.BBAN = account.unMaskedNumber;\n      } else {\n        account.number = account.unMaskedNumber;\n      }\n      masked$.next(false);\n    });\n  }\n\n  constructor(@Inject(ACCOUNTS_DISPLAYING_FORMAT) readonly configuration: AccountsDisplayingFormatConfiguration) {}\n}\n",
      properties: [
        {
          name: 'account',
          deprecated: false,
          deprecationMessage: '',
          type: 'literal type',
          indexKey: '',
          optional: false,
          description: '',
          line: 22,
        },
        {
          name: 'description',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 31,
        },
        {
          name: 'masked$',
          deprecated: false,
          deprecationMessage: '',
          type: 'BehaviorSubject<boolean>',
          indexKey: '',
          optional: false,
          description: '',
          line: 30,
        },
        {
          name: 'unmaskable',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 32,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Attachment',
      id: 'interface-Attachment-35219d2712a60b78bb92f4282992a1d42efea7fe0ff6894ddc6c77657fcaebcf1c12cfd390aaa12c94a7c6969419bfcf0e15b63d899ff86b4452d79b36f53300',
      file: 'libs/ui-ang-examples/src/file-attachment/showcase/file-attachment-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { Observable, of } from 'rxjs';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\n\ninterface Attachment {\n  name: string;\n  size: number;\n  loading: boolean;\n  deletable: boolean;\n  disabled: boolean;\n  fileContent: Observable<ArrayBuffer>;\n}\n\nconst attachment: Attachment = {\n  name: 'examplePDF.pdf',\n  deletable: false,\n  disabled: false,\n  size: 10000,\n  loading: false,\n  fileContent: of(new ArrayBuffer(2000000)),\n};\n\n@Component({\n  selector: 'bb-file-attachment-ui-showcase',\n  templateUrl: 'file-attachment-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class FileAttachmentShowcaseComponent {\n  defaultFileAttachmentsList: Attachment[] = [\n    attachment,\n    { ...attachment, name: 'exampleXLS.xls' },\n    { ...attachment, name: 'exampleCSV.csv' },\n    { ...attachment, name: 'examplePNG.png' },\n    { ...attachment, name: 'exampleUnknown' },\n  ];\n\n  deletableFileAttachmentsList = this.defaultFileAttachmentsList.map((defaultAttachment: Attachment) => ({\n    ...defaultAttachment,\n    deletable: true,\n    disabled: true,\n  }));\n\n  deleteAttachment(filesList: Attachment[], index: number) {\n    filesList[index].loading = true;\n    setTimeout(() => {\n      filesList[index].loading = false;\n      filesList.splice(index, 1);\n    }, 1000);\n  }\n}\n",
      properties: [
        {
          name: 'deletable',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
        {
          name: 'disabled',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'fileContent',
          deprecated: false,
          deprecationMessage: '',
          type: 'Observable<ArrayBuffer>',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
        {
          name: 'loading',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 8,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'AvailableFeature',
      id: 'interface-AvailableFeature-1edad08f56c584ba28f52e9efbdaf24af10055c77d8e9cd35a196270dab6055986f1e9670afefd2ed177f8453837f64dddca543d6ae31f55d56034be9d9e93c3',
      file: 'libs/ui-ang/payment-card-number-pipe/constants.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface AvailableFeature {\n  name: string;\n  description: string;\n}\n\n/**\n * The configuration that determines how a payment card number should be\n * formatted.\n */\nexport interface PaymentCardNumberFormat {\n  /**\n   * Total length of the payment card number.\n   */\n  length: number;\n  /**\n   * Index range of characters that should be masked.\n   */\n  maskRange: [number, number];\n  /**\n   * The size (or array of sizes) the segments should have.\n   */\n  segments: number | Array<number>;\n}\n\n/**\n * Default payment card number format.\n */\nexport const DefaultPaymentCardNumberFormat: PaymentCardNumberFormat = {\n  length: 16,\n  maskRange: [0, 12],\n  segments: 4,\n};\n\n/**\n * Lookup object containing payment card number formats for common payment card\n * vendors.\n */\nexport const PaymentCardNumberVendors: { [vendor: string]: PaymentCardNumberFormat } = {\n  mastercard: {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  },\n  visa: {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  },\n  'visa-debit': {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  },\n  'diners-club': {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  },\n  'american-express': {\n    length: 15,\n    maskRange: [0, 11],\n    segments: [4, 6, 5],\n  },\n};\n\n/**\n * A token that enables numbers masking synchronization with backend\n * If set FE should not apply any masking and rely on the backend masking behavior\n *\n * @internal\n */\nexport const SYNCHRONIZE_NUMBERS_MASKING: InjectionToken<boolean> = new InjectionToken<boolean>(\n  'Enables accounts masking synchronization with backend',\n  {\n    providedIn: 'root',\n    factory() {\n      return false;\n    },\n  },\n);\n",
      properties: [
        {
          name: 'description',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'AvatarConfig',
      id: 'interface-AvatarConfig-43bbd4158ab3d8501e243711d1fdc748e37c0ee6fef098ab01806f7c36d51d1b7c8834ffeb4698638add99c186bd259560239afe90892f49e6dafc328890d374',
      file: 'libs/ui-ang/avatar/avatar.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\n/**\n * Defines the configuration options for avatar\n */\nexport interface AvatarConfig {\n  /**\n   * Function used to obtain the initials of an user when given their name\n   */\n  initialsFn?: (text: string) => string;\n}\n\n/**\n * Avatar configuration token\n */\nexport const AVATAR_CONFIG_TOKEN = new InjectionToken<AvatarConfig>('AVATAR_CONFIG_TOKEN');\n\n/**\n * This function retrieves the initials that are shown in the avatar when given a full name\n */\nexport const defaultAvatarInitialsFn: (text: string) => string = (text) => {\n  const textArr = text.split(' ');\n  let result = '';\n\n  if (textArr.length > 1) {\n    result = textArr\n      .filter((_, index, arr) => index === 0 || index === arr.length - 1)\n      .reduce((initials, word) => `${initials}${word.charAt(0)}`, '');\n  } else {\n    result = textArr[0].slice(0, 2);\n  }\n\n  return result.toUpperCase();\n};\n",
      properties: [
        {
          name: 'initialsFn',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: true,
          description: '<p>Function used to obtain the initials of an user when given their name</p>\n',
          line: 10,
          rawdescription: '\n\nFunction used to obtain the initials of an user when given their name\n',
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Defines the configuration options for avatar</p>\n',
      rawdescription: '\n\nDefines the configuration options for avatar\n',
      methods: [],
      extends: [],
    },
    {
      name: 'BbComponentRef',
      id: 'interface-BbComponentRef-3795d1f469175c0b0274470d326af0c96460662e3becb2298f8d14e18476660c4a25838ca4044fc91eb88ba2e7f1b5122f15f6afd18b2ce9f798a0aa2c73756b',
      file: 'libs/ds-toolkit/src/metadata.service.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Inject, Injectable } from '@angular/core';\nimport { BbDsDocs, DsConfig } from './ds-toolkit.module';\nimport { SELECTORS } from './selectors';\n\nexport interface BbComponentRef {\n  template: string;\n  selector: string;\n}\n\nfunction getModuleAnnotations(module: any) {\n  if (module?.decorators?.[0]?.args?.[0]) {\n    return module.decorators[0].args[0];\n  }\n\n  if (module.ɵcmp) {\n    return (module.ɵcmp.selectors && module.ɵcmp.selectors[0]) || [];\n  }\n\n  return undefined;\n}\n\n@Injectable({ providedIn: 'root' })\nexport class MetadataService {\n  libExamplesModule: any;\n  libModule: any;\n  libDocs: BbDsDocs | undefined;\n  libShowcaseModule: any;\n\n  constructor(@Inject('config') config: DsConfig) {\n    this.libDocs = config.docs;\n    this.libModule = config.lib;\n    this.libExamplesModule = config.exampleLib;\n    this.libShowcaseModule = config.showcaseLib;\n  }\n\n  getModuleAnnotations(module: any): any {\n    return getModuleAnnotations(module);\n  }\n\n  getParsedSelectors(module?: any) {\n    return SELECTORS;\n  }\n\n  formatMenuTitle(itemName: string): string {\n    return this.capitalizeFirstLetter(itemName).replace('-', ' ');\n  }\n\n  capitalizeFirstLetter(string: string): string {\n    return string.charAt(0).toUpperCase() + string.slice(1);\n  }\n}\n",
      properties: [
        {
          name: 'selector',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'template',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'BbDsDocs',
      id: 'interface-BbDsDocs-1acca70c1182cfdbae63f5e155ca6ce28f4261b0895e4e661dfc727595d60a65185e50db3bc502e8b804a14a330553fc417a4a9a4902389d685ead0f3f1fbc01',
      file: 'libs/ds-toolkit/src/ds-toolkit.module.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ModuleWithProviders, NgModule } from '@angular/core';\nimport { CommonModule } from '@angular/common';\n\nimport { AlertModule } from '@backbase/ui-ang/alert';\nimport { IconModule } from '@backbase/ui-ang/icon';\nimport { CollapsibleAccordionModule } from '@backbase/ui-ang/collapsible-accordion';\nimport { CollapsibleCardModule } from '@backbase/ui-ang/collapsible-card';\n\nimport { ShowcaseApiComponent } from './showcase/api/showcase-api.component';\nimport { ShowcaseScssTokensComponent } from './showcase/scss-tokens/showcase-scss-tokens.component';\nimport { ShowcaseDescriptionComponent } from './showcase/description/showcase-description.component';\nimport { ShowcaseExampleTemplateComponent } from './showcase/example-template/showcase-example-template.component';\nimport { ShowcaseMethodsComponent } from './showcase/methods/showcase-methods.component';\nimport { ShowcaseSelectorComponent } from './showcase/selector/showcase-selector.component';\nimport { ShowcaseUsageComponent } from './showcase/usage/showcase-usage.component';\nimport { ShowcaseComponent } from './showcase.component';\nimport { MetadataService } from './metadata.service';\n\nexport interface BbDsDocs {\n  components?: any;\n  directives?: any;\n  pipes?: any;\n  interfaces?: any;\n}\n\nexport interface DsConfig {\n  lib: any;\n  exampleLib?: any;\n  showcaseLib?: any;\n  docs: BbDsDocs;\n}\n\nconst components = [\n  ShowcaseScssTokensComponent,\n  ShowcaseApiComponent,\n  ShowcaseDescriptionComponent,\n  ShowcaseExampleTemplateComponent,\n  ShowcaseMethodsComponent,\n  ShowcaseSelectorComponent,\n  ShowcaseUsageComponent,\n  ShowcaseComponent,\n];\n\n/**\n * DynamicDsToolkitModule can be removed in favor of\n * importing the modules (BacbaseUiModule, BackbaseExamplesUiModule)\n * in the app level because this will kill AOT and/or build-optimization\n */\n@NgModule({\n  imports: [CommonModule, IconModule, CollapsibleAccordionModule, CollapsibleCardModule, AlertModule],\n  declarations: [...components],\n  providers: [MetadataService],\n  exports: [...components],\n})\nexport class DsToolkitModule {\n  static forRoot(config: DsConfig): ModuleWithProviders<DsToolkitModule> {\n    // @NgModule({\n    //   imports: [\n    //     CommonModule,\n    //     IconModule,\n    //     CollapsibleAccordionModule,\n    //     CollapsibleCardModule,\n    //     config.exampleLib,\n    //     config.lib,\n    //   ],\n    //   declarations: [...components],\n    //   exports: [...components],\n    // })\n    // class DynamicDsToolkitModule {}\n    return {\n      ngModule: DsToolkitModule,\n      providers: [MetadataService, { provide: 'config', useValue: config }],\n    };\n  }\n}\n\nexport {\n  ShowcaseScssTokensComponent,\n  ShowcaseApiComponent,\n  ShowcaseDescriptionComponent,\n  ShowcaseExampleTemplateComponent,\n  ShowcaseMethodsComponent,\n  ShowcaseSelectorComponent,\n  ShowcaseUsageComponent,\n  ShowcaseComponent,\n};\n",
      properties: [
        {
          name: 'components',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '',
          line: 20,
        },
        {
          name: 'directives',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '',
          line: 21,
        },
        {
          name: 'interfaces',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '',
          line: 23,
        },
        {
          name: 'pipes',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '',
          line: 22,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ButtonAction',
      id: 'interface-ButtonAction-7830b85c0c66fd37d0366158e4378780f5c9ccad855c7e8bfe855c96dc4c08f5d64423e5cae7e84d016bcc303410e3c615df20ae1270c886979867e6d3578c42',
      file: 'libs/ui-ang/page-header/page-header.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  ChangeDetectionStrategy,\n  Component,\n  ContentChild,\n  Directive,\n  EventEmitter,\n  Input,\n  Output,\n  TemplateRef,\n  booleanAttribute,\n} from '@angular/core';\n\nexport interface ButtonAction {\n  text: string;\n  icon?: string;\n}\n\n@Directive({\n  selector: 'ng-template[bbPageHeaderCustomAction]',\n  standalone: false,\n})\nexport class PageHeaderCustomActionDirective {\n  constructor(public templateRef: TemplateRef<any>) {}\n}\n\n/**\n * @name PageHeaderComponent\n *\n * @description\n * A component which provides a layout template for default responsive page headers in Web.\n * It can feature a title and an optional subtitle, as well as up to two default call-to-action buttons (or a custom action) and a navigation link.\n *\n * #### Usage notes\n * If you would like to use your custom action element, you can do the following:\n *\n * ```typescript\n * <bb-page-header-ui title=\"Page title\" subtitle=\"Page subtitle\">\n *   <ng-template bbPageHeaderCustomAction>\n *     <button>Action</button>\n *   </ng-template>\n *\n *   <div>Content</div>\n * </bb-page-header-ui>\n * ```\n *\n */\n@Component({\n  selector: 'bb-page-header-ui',\n  templateUrl: './page-header.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class PageHeaderComponent {\n  @ContentChild(PageHeaderCustomActionDirective, { read: TemplateRef, static: true })\n  pageHeaderCustomAction?: TemplateRef<any>;\n\n  /**\n   * The main text to be displayed.\n   *\n   * Input is required.\n   */\n  @Input({ required: true }) title!: string;\n\n  /**\n   * Whether a colored background is rendered behind the component.\n   * Changes the text and buttons to `on-color` elements.\n   *\n   * Defaults to false.\n   */\n  @Input({ transform: booleanAttribute }) showBackground = false;\n\n  /**\n   * The label of the navigation button.\n   * Renders a button meant for navigating to the previous page if provided.\n   */\n  @Input() navigationLinkText?: string;\n\n  /**\n   * Supplementary text to accommodate the title.\n   */\n  @Input() subtitle?: string;\n\n  /**\n   * An object with properties of a button that takes the primary role.\n   * Renders a button with `primary` style if provided.\n   * Overwrites any custom action if provided.\n   *\n   * Accepts the properties: `text: string`, `icon: string`.\n   */\n  @Input() primaryAction?: ButtonAction;\n\n  /**\n   * An object with properties of a button that takes the secondary role.\n   * Renders a button with `secondary` style if provided.\n   * Overwrites any custom action if provided.\n   *\n   * Accepts the properties: `text: string`, `icon: string`.\n   */\n  @Input() secondaryAction?: ButtonAction;\n\n  /**\n   * An event fired when the navigation button is clicked.\n   */\n  @Output() navigationLinkClick = new EventEmitter<void>();\n\n  /**\n   * An event fired when the primary button is clicked.\n   */\n  @Output() primaryActionClick = new EventEmitter<void>();\n\n  /**\n   * An event fired when the secondary button is clicked.\n   */\n  @Output() secondaryActionClick = new EventEmitter<void>();\n}\n",
      properties: [
        {
          name: 'icon',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 15,
        },
        {
          name: 'text',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 14,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'CheckContentTruncationBehaviour',
      id: 'interface-CheckContentTruncationBehaviour-74932d16a57fbb13874251b1307eab78d8868139e9eb0143ebe5af75aaf5acf35b8f7437e159e808e46668cfea94d27a5891af8181c00801a11e3d508c4e3ac3',
      file: 'libs/ui-ang/ellipsis/directives/is-content-truncated.directive.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectorRef, Directive, ElementRef, Input, AfterViewInit } from '@angular/core';\n\nexport interface CheckContentTruncationBehaviour {\n  /**\n   * Set truncation status of notification message\n   */\n  setIsContentTruncated(isTruncated: boolean): void;\n}\n\n@Directive({\n  selector: '[bbIsContentTruncated]',\n  standalone: false,\n})\nexport class IsContentTruncatedDirective implements AfterViewInit {\n  constructor(\n    private readonly elementRef: ElementRef,\n    private readonly cd: ChangeDetectorRef,\n  ) {}\n\n  @Input() hostRef!: CheckContentTruncationBehaviour;\n\n  ngAfterViewInit() {\n    if (!this.hostRef.setIsContentTruncated) {\n      throw new Error(\n        '\"hostRef\" should implement \"CheckContentTruncationBehaviour\" interface to set truncation status',\n      );\n    }\n    setTimeout(() => {\n      this.setIsContentTruncatedInParentComponent();\n    });\n  }\n\n  private setIsContentTruncatedInParentComponent(): void {\n    const isContentTruncated = this.isContentTruncated(this.elementRef.nativeElement);\n    this.hostRef.setIsContentTruncated(isContentTruncated);\n    this.cd.markForCheck();\n  }\n\n  private isContentTruncated({ offsetHeight, scrollHeight, parentElement }: HTMLElement): boolean {\n    if (navigator.userAgent.indexOf('Firefox') > -1) {\n      // For firefox, the element always returns it's full height regardless of whether\n      // the overflow is hidden or not.\n      // We therefore use to check if the full height of element matches the parent which\n      // would be smaller than the element if the element overflows.\n      return Number(parentElement?.offsetHeight) < offsetHeight;\n    }\n\n    return offsetHeight < scrollHeight;\n  }\n}\n",
      properties: [],
      indexSignatures: [],
      kind: 173,
      methods: [
        {
          name: 'setIsContentTruncated',
          args: [
            {
              name: 'isTruncated',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 7,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet truncation status of notification message\n',
          description: '<p>Set truncation status of notification message</p>\n',
          jsdoctags: [
            {
              name: 'isTruncated',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      extends: [],
    },
    {
      name: 'CombinedFormatters',
      id: 'interface-CombinedFormatters-984bfed07e5940faf938751ccbcfe7d33601391d468c6c33a5c85f7d4dcd0ae62d8e2fa654db6d51cd7be81d0595ad9c92272f5ca592083b3343571f7f181a77',
      file: 'libs/ui-ang/period-selector/period-selector.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';\nimport { DatePipe } from '@angular/common';\nimport { isRtl } from '@backbase/ui-ang/util';\n\nexport type FormatFn = (date: Date) => string;\n// @TODO: should be extended with week, year, etc. once we get requirement for it\nexport type PeriodSize = 'month';\nexport interface Period {\n  start: Date;\n  end: Date;\n}\nexport interface PeriodFormatters {\n  title?: FormatFn;\n  start?: FormatFn;\n  end?: FormatFn;\n}\n\ninterface CombinedFormatters {\n  title: FormatFn;\n  start: FormatFn;\n  end: FormatFn;\n}\n\n/**\n * @name PeriodSelectorComponent\n *\n * @description\n * Component that selects a period.\n */\n@Component({\n  selector: 'bb-period-selector-ui',\n  templateUrl: './period-selector.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class PeriodSelectorComponent implements OnInit {\n  private combinedFormatters: CombinedFormatters = {\n    title: (date) => this.datePipe.transform(date, 'MMMM') || '',\n    start: (date) => this.datePipe.transform(date, 'mediumDate') || '',\n    end: (date) => this.datePipe.transform(date, 'mediumDate') || '',\n  };\n\n  /**\n   * Start date of the period.\n   */\n  @Input() periodStart?: Date;\n  /**\n   * End date of the period.\n   */\n  @Input() periodEnd?: Date;\n  /**\n   * Custom date period formatter. Accepts formatters in the form of:\n   *\n   * ```typescript\n   *  {\n   *    title?: (date: Date) => string;\n   *    start?: (date: Date) => string;\n   *    end?: (date: Date) => string;\n   *  }\n   *```\n   *\n   */\n  @Input()\n  set periodFormatters(formatters: PeriodFormatters) {\n    this.combinedFormatters = Object.assign(this.combinedFormatters, formatters);\n  }\n  /**\n   * Period step. Defaults to 'month'.\n   */\n  @Input() period: PeriodSize = 'month';\n\n  /**\n   * Emits an event when the period is changed.\n   */\n  @Output() periodChange: EventEmitter<Period> = new EventEmitter<Period>();\n\n  chevronPrev = isRtl() ? 'chevron-right' : 'chevron-left';\n  chevronNext = isRtl() ? 'chevron-left' : 'chevron-right';\n\n  constructor(private readonly datePipe: DatePipe) {}\n\n  formattedTitle: string | undefined;\n  formattedStart: string | undefined;\n  formattedEnd: string | undefined;\n\n  get isLastPeriod(): boolean {\n    if (!this.periodStart) {\n      return true;\n    }\n\n    const now = new Date();\n\n    return now.getFullYear() === this.periodStart.getFullYear() && now.getMonth() === this.periodStart.getMonth();\n  }\n\n  get periodLeft() {\n    return isRtl() ? `\\u200f${this.formattedEnd}` : this.formattedStart;\n  }\n\n  get periodRight() {\n    return isRtl() ? `\\u200f${this.formattedStart}` : this.formattedEnd;\n  }\n\n  ngOnInit() {\n    if (typeof this.periodStart === 'undefined' || typeof this.periodEnd === 'undefined') {\n      throw new Error('`periodStart`, and `periodEnd` inputs are required in `bb-period-selector-ui` component');\n    }\n\n    this.setFormattedValues();\n  }\n\n  private setFormattedValues() {\n    this.formattedTitle = this.combinedFormatters.title(this.periodStart as Date);\n    this.formattedStart = this.combinedFormatters.start(this.periodStart as Date);\n    this.formattedEnd = this.combinedFormatters.end(this.periodEnd as Date);\n  }\n\n  changePeriod(next: boolean) {\n    if (!this.periodStart || (next && this.isLastPeriod)) {\n      return;\n    }\n\n    this.periodStart.setMonth(this.periodStart.getMonth() + (next ? 1 : -1));\n    this.periodEnd = this.isLastPeriod\n      ? new Date(this.periodStart.getFullYear(), this.periodStart.getMonth(), new Date().getDate(), 23, 59, 59, 999)\n      : new Date(this.periodStart.getFullYear(), this.periodStart.getMonth() + 1, 0, 23, 59, 59, 999);\n\n    this.setFormattedValues();\n    this.periodChange.emit({\n      start: this.periodStart,\n      end: this.periodEnd,\n    });\n  }\n}\n",
      properties: [
        {
          name: 'end',
          deprecated: false,
          deprecationMessage: '',
          type: 'FormatFn',
          indexKey: '',
          optional: false,
          description: '',
          line: 21,
        },
        {
          name: 'start',
          deprecated: false,
          deprecationMessage: '',
          type: 'FormatFn',
          indexKey: '',
          optional: false,
          description: '',
          line: 20,
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          type: 'FormatFn',
          indexKey: '',
          optional: false,
          description: '',
          line: 19,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Config',
      id: 'interface-Config-6f28845bd38f52e8c424282323a430452a757540b8a63e4f2608128b908874ed5556b64df3c97e76580047afe0d7d102ae5192ae91f32242287a3c6efe89d488',
      file: 'libs/ui-ang/rich-text-editor/helpers/counter.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import 'quill';\n\nexport interface Config {\n  container: string;\n  unit: 'word' | 'char';\n}\n\nexport interface QuillInstance {\n  on: any;\n  getText: any;\n}\n\nexport default class Counter {\n  constructor(readonly quill: QuillInstance, readonly options: Config) {\n    this.quill = quill;\n    this.options = options;\n\n    const container = document.querySelector(this.options.container) as any;\n\n    this.quill.on('editor-change', () => {\n      const length = this.calculate();\n\n      container.innerHTML = length + ' ' + this.options.unit + 's';\n    });\n  }\n\n  calculate() {\n    const text = this.quill.getText().trim();\n\n    if (this.options.unit === 'word') {\n      return !text ? 0 : text.split(/\\s+/).length;\n    }\n\n    return text.length;\n  }\n}\n",
      properties: [
        {
          name: 'container',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
        {
          name: 'unit',
          deprecated: false,
          deprecationMessage: '',
          type: '"word" | "char"',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Country',
      id: 'interface-Country-f9687e1ace4bcdbdad7ead30a55b89238e98c100378923115ab54b127c85b2ffd25a029fc7304e9ee2914d481f5a196974736bc2f03e8e67a5c13fc0008b1f6f',
      file: 'libs/ui-ang/iban-lib/countrySpec.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "const countries: { [key: string]: Country } = {\n  AD: {\n    bban: '08N12C',\n    example: 'AD1200012030200359100100',\n    len: 24,\n    name: 'Andorra',\n  },\n  AE: {\n    bban: '03N16N',\n    example: 'AE260211000000230064016',\n    len: 23,\n    name: 'United Arab Emirates',\n  },\n  AL: {\n    bban: '08N16C',\n    example: 'AL47212110090000000235698741',\n    len: 28,\n    name: 'Albania',\n  },\n  AO: {\n    bban: '21N',\n    example: 'AO06000600000100037131174',\n    len: 25,\n    name: 'Angola',\n  },\n  AT: {\n    bban: '16N',\n    example: 'AT611904300234573201',\n    len: 20,\n    name: 'Austria',\n  },\n  AZ: {\n    bban: '04A20C',\n    example: 'AZ21NABZ00000000137010001944',\n    len: 28,\n    name: 'Azerbaijan',\n  },\n  BA: {\n    bban: '16N',\n    example: 'BA391290079401028494',\n    len: 20,\n    name: 'Bosnia and Herzegovina',\n  },\n  BE: {\n    bban: '12N',\n    example: 'BE68539007547034',\n    len: 16,\n    name: 'Belgium',\n  },\n  BF: {\n    bban: '23N',\n    example: 'BF1030134020015400945000643',\n    len: 27,\n    name: 'Burkina Faso',\n  },\n  BG: {\n    bban: '04A06N08C',\n    example: 'BG80BNBG96611020345678',\n    len: 22,\n    name: 'Bulgaria',\n  },\n  BH: {\n    bban: '04A14C',\n    example: 'BH29BMAG1299123456BH00',\n    len: 22,\n    name: 'Bahrain',\n  },\n  BI: {\n    bban: '23N',\n    example: 'BI4210000100010000332045181',\n    len: 27,\n    name: 'Burundi',\n  },\n  BJ: {\n    bban: '01A23N',\n    example: 'BJ11B00610100400271101192591',\n    len: 28,\n    name: 'Benin',\n  },\n  BR: {\n    bban: '23N01A01C',\n    example: 'BR9700360305000010009795493P1',\n    len: 29,\n    name: 'Brazil',\n  },\n  BY: {\n    bban: '04C04N16C',\n    example: 'BY13NBRB3600900000002Z00AB00',\n    len: 28,\n    name: 'Belarus',\n  },\n  CF: {\n    bban: '23C',\n    example: 'CF4220001000010120069700160',\n    len: 27,\n    name: 'Central African Republic',\n  },\n  CG: {\n    bban: '23C',\n    example: 'CG5230011000202151234567890',\n    len: 27,\n    name: 'Congo',\n  },\n  CH: {\n    bban: '05N12C',\n    example: 'CH9300762011623852957',\n    len: 21,\n    name: 'Switzerland',\n  },\n  CI: {\n    bban: '01A23N',\n    example: 'CI05A00060174100178530011852',\n    len: 28,\n    name: 'Ivory Coast',\n  },\n  CM: {\n    bban: '23N',\n    example: 'CM2110003001000500000605306',\n    len: 27,\n    name: 'Cameroon',\n  },\n  CR: {\n    bban: '04N14N',\n    example: 'CR05015202001026284066',\n    len: 22,\n    name: 'Costa Rica',\n  },\n  CV: {\n    bban: '21N',\n    example: 'CV64000300004547069110176',\n    len: 25,\n    name: 'Cape Verde',\n  },\n  CY: {\n    bban: '08N16C',\n    example: 'CY17002001280000001200527600',\n    len: 28,\n    name: 'Cyprus',\n  },\n  CZ: {\n    bban: '20N',\n    example: 'CZ6508000000192000145399',\n    len: 24,\n    name: 'Czech Republic',\n  },\n  DE: {\n    bban: '18N',\n    example: 'DE89370400440532013000',\n    len: 22,\n    name: 'Germany',\n  },\n  DJ: {\n    bban: '23C',\n    example: 'DJ2110002010010409943020008',\n    len: 27,\n    name: 'Djibouti',\n  },\n  DK: {\n    bban: '14N',\n    example: 'DK5000400440116243',\n    len: 18,\n    name: 'Denmark',\n  },\n  DO: {\n    bban: '04A20N',\n    example: 'DO28BAGR00000001212453611324',\n    len: 28,\n    name: 'Dominican Republic',\n  },\n  DZ: {\n    bban: '20N',\n    example: 'DZ4000400174401001050486',\n    len: 24,\n    name: 'Algeria',\n  },\n  EE: {\n    bban: '16N',\n    example: 'EE382200221020145685',\n    len: 20,\n    name: 'Estonia',\n  },\n  EG: {\n    bban: '25N',\n    example: 'EG450003042150001274922000160',\n    len: 29,\n    name: 'Egypt',\n  },\n  ES: {\n    bban: '20N',\n    example: 'ES9121000418450200051332',\n    len: 24,\n    name: 'Spain',\n  },\n  FI: {\n    bban: '14N',\n    example: 'FI2112345600000785',\n    len: 18,\n    name: 'Finland',\n  },\n  FK: {\n    bban: '02A12N',\n    example: 'FK88SC123456789012',\n    len: 18,\n    name: 'Falkland Islands',\n  },\n  FO: {\n    bban: '14N',\n    example: 'FO1464600009692713',\n    len: 18,\n    name: 'Faroe Islands',\n  },\n  FR: {\n    bban: '10N11C02N',\n    example: 'FR7630007000110009970004942',\n    len: 27,\n    name: 'France',\n  },\n  GA: {\n    bban: '23C',\n    example: 'GA2140002000055602673300064',\n    len: 27,\n    name: 'Gabon',\n  },\n  GB: {\n    bban: '04A14N',\n    example: 'GB29NWBK60161331926819',\n    len: 22,\n    name: 'United Kingdom',\n  },\n  GE: {\n    bban: '02C16N',\n    example: 'GE29NB0000000101904917',\n    len: 22,\n    name: 'Georgia',\n  },\n  GI: {\n    bban: '04A15C',\n    example: 'GI75NWBK000000007099453',\n    len: 23,\n    name: 'Gibraltar',\n  },\n  GL: {\n    bban: '14N',\n    example: 'GL8964710001000206',\n    len: 18,\n    name: 'Greenland',\n  },\n  GQ: {\n    bban: '23C',\n    example: 'GQ7050002001003715228190196',\n    len: 27,\n    name: 'Equatorial Guinea',\n  },\n  GR: {\n    bban: '07N16C',\n    example: 'GR1601101250000000012300695',\n    len: 27,\n    name: 'Greece',\n  },\n  GT: {\n    bban: '04C20C',\n    example: 'GT82TRAJ01020000001210029690',\n    len: 28,\n    name: 'Guatemala',\n  },\n  GW: {\n    bban: '21C',\n    example: 'GW04GW1430010181800637601',\n    len: 25,\n    name: 'Guinea-Bissau',\n  },\n  HN: {\n    bban: '24C',\n    example: 'HN54PISA00000000000000123124',\n    len: 28,\n    name: 'Honduras',\n  },\n  HR: {\n    bban: '17N',\n    example: 'HR1210010051863000160',\n    len: 21,\n    name: 'Croatia',\n  },\n  HU: {\n    bban: '24N',\n    example: 'HU42117730161111101800000000',\n    len: 28,\n    name: 'Hungary',\n  },\n  IE: {\n    bban: '04C14N',\n    example: 'IE29AIBK93115212345678',\n    len: 22,\n    name: 'Ireland',\n  },\n  IL: {\n    bban: '19N',\n    example: 'IL620108000000099999999',\n    len: 23,\n    name: 'Israel',\n  },\n  IQ: {\n    bban: '19C',\n    example: 'IQ20CBIQ861800101010500',\n    len: 23,\n    name: 'Iraq',\n  },\n  IR: {\n    bban: '22N',\n    example: 'IR580540105180021273113007',\n    len: 26,\n    name: 'Iran',\n  },\n  IS: {\n    bban: '22N',\n    example: 'IS140159260076545510730339',\n    len: 26,\n    name: 'Iceland',\n  },\n  IT: {\n    bban: '01A10N12C',\n    example: 'IT60X0542811101000000123456',\n    len: 27,\n    name: 'Italy',\n  },\n  JO: {\n    bban: '04A22N',\n    example: 'JO94CBJO0010000000000131000302',\n    len: 30,\n    name: 'Jordan',\n  },\n  KM: {\n    bban: '23C',\n    example: 'KM4600005000010010904400137',\n    len: 27,\n    name: 'Comoros',\n  },\n  KW: {\n    bban: '04A22C',\n    example: 'KW74NBOK0000000000001000372151',\n    len: 30,\n    name: 'Kuwait',\n  },\n  KZ: {\n    bban: '03N13C',\n    example: 'KZ176010251000042993',\n    len: 20,\n    name: 'Kazakhstan',\n  },\n  LB: {\n    bban: '04N20C',\n    example: 'LB30099900000001001925579115',\n    len: 28,\n    name: 'Lebanon',\n  },\n  LC: {\n    bban: '28C',\n    example: 'LC14BOSL123456789012345678901234',\n    len: 32,\n    name: 'Saint Lucia',\n  },\n  LI: {\n    bban: '05N12C',\n    example: 'LI21088100002324013AA',\n    len: 21,\n    name: 'Liechtenstein',\n  },\n  LT: {\n    bban: '16N',\n    example: 'LT121000011101001000',\n    len: 20,\n    name: 'Lithuania',\n  },\n  LU: {\n    bban: '03N13C',\n    example: 'LU280019400644750000',\n    len: 20,\n    name: 'Luxembourg',\n  },\n  LV: {\n    bban: '04A13C',\n    example: 'LV80BANK0000435195001',\n    len: 21,\n    name: 'Latvia',\n  },\n  MA: {\n    bban: '24C',\n    example: 'MA64011519000001205000534921',\n    len: 28,\n    name: 'Morocco',\n  },\n  MC: {\n    bban: '10N11C02N',\n    example: 'MC5813488000010051108001292',\n    len: 27,\n    name: 'Monaco',\n  },\n  MD: {\n    bban: '02C18C',\n    example: 'MD24AG000225100013104168',\n    len: 24,\n    name: 'Moldova',\n  },\n  ME: {\n    bban: '18N',\n    example: 'ME25505000012345678951',\n    len: 22,\n    name: 'Montenegro',\n  },\n  MG: {\n    bban: '23N',\n    example: 'MG4600005030010101914016056',\n    len: 27,\n    name: 'Madagascar',\n  },\n  MK: {\n    bban: '03N10C02N',\n    example: 'MK07300000000042425',\n    len: 19,\n    name: 'Macedonia',\n  },\n  ML: {\n    bban: '01A23N',\n    example: 'ML03D00890170001002120000447',\n    len: 28,\n    name: 'Mali',\n  },\n  MR: {\n    bban: '23N',\n    example: 'MR1300012000010000002037372',\n    len: 27,\n    name: 'Mauritania',\n  },\n  MT: {\n    bban: '04A05N18C',\n    example: 'MT84MALT011000012345MTLCAST001S',\n    len: 31,\n    name: 'Malta',\n  },\n  MU: {\n    bban: '04A19N03A',\n    example: 'MU17BOMM0101101030300200000MUR',\n    len: 30,\n    name: 'Mauritius',\n  },\n  MZ: {\n    bban: '21N',\n    example: 'MZ59000100000011834194157',\n    len: 25,\n    name: 'Mozambique',\n  },\n  NE: {\n    bban: '24C',\n    example: 'NE58NE0380100100130305000268',\n    len: 28,\n    name: 'Niger',\n  },\n  NI: {\n    bban: '28C',\n    example: 'NI92BAMC000000000000000003123123',\n    len: 32,\n    name: 'Nicaragua',\n  },\n  NL: {\n    bban: '04A10N',\n    example: 'NL91ABNA0417164300',\n    len: 18,\n    name: 'Netherlands',\n  },\n  NO: {\n    bban: '11N',\n    example: 'NO9386011117947',\n    len: 15,\n    name: 'Norway',\n  },\n  PK: {\n    bban: '04C16N',\n    example: 'PK24SCBL0000001171495101',\n    len: 24,\n    name: 'Pakistan',\n  },\n  PL: {\n    bban: '24N',\n    example: 'PL27114020040000300201355387',\n    len: 28,\n    name: 'Poland',\n  },\n  PS: {\n    bban: '04C21N',\n    example: 'PS92PALS000000000400123456702',\n    len: 29,\n    name: 'Palestinian territories',\n  },\n  PT: {\n    bban: '21N',\n    example: 'PT50000200000163099310355',\n    len: 25,\n    name: 'Portugal',\n  },\n  QA: {\n    bban: '04A21C',\n    example: 'QA58DOHB00001234567890ABCDEFG',\n    len: 29,\n    name: 'Qatar',\n  },\n  RO: {\n    bban: '04A16C',\n    example: 'RO49AAAA1B31007593840000',\n    len: 24,\n    name: 'Romania',\n  },\n  RS: {\n    bban: '18N',\n    example: 'RS35260005601001611379',\n    len: 22,\n    name: 'Serbia',\n  },\n  SA: {\n    bban: '02N18C',\n    example: 'SA0380000000608010167519',\n    len: 24,\n    name: 'Saudi Arabia',\n  },\n  SC: {\n    bban: '27C',\n    example: 'SC52BAHL01031234567890123456USD',\n    len: 31,\n    name: 'Seychelles',\n  },\n  SE: {\n    bban: '20N',\n    example: 'SE3550000000054910000003',\n    len: 24,\n    name: 'Sweden',\n  },\n  SI: {\n    bban: '15N',\n    example: 'SI56191000000123438',\n    len: 19,\n    name: 'Slovenia',\n  },\n  SK: {\n    bban: '20N',\n    example: 'SK3112000000198742637541',\n    len: 24,\n    name: 'Slovakia',\n  },\n  SM: {\n    bban: '01A10N12C',\n    example: 'SM86U0322509800000000270100',\n    len: 27,\n    name: 'San Marino',\n  },\n  SN: {\n    bban: '01A23N',\n    example: 'SN12K00100152000025690007542',\n    len: 28,\n    name: 'Senegal',\n  },\n  ST: {\n    bban: '21C',\n    example: 'ST23000200000289355710148',\n    len: 25,\n    name: 'Sao Tome and Principe',\n  },\n  SV: {\n    bban: '24C',\n    example: 'SV43ACAT00000000000000123123',\n    len: 28,\n    name: 'El Salvador',\n  },\n  TD: {\n    bban: '23C',\n    example: 'TD8960002000010271091600153',\n    len: 27,\n    name: 'Chad',\n  },\n  TG: {\n    bban: '24C',\n    example: 'TG53TG0090604310346500400070',\n    len: 28,\n    name: 'Togo',\n  },\n  TL: {\n    bban: '19N',\n    example: 'TL380080012345678910157',\n    len: 23,\n    name: 'East Timor',\n  },\n  TN: {\n    bban: '20N',\n    example: 'TN5914207207100707129648',\n    len: 24,\n    name: 'Tunisia',\n  },\n  TR: {\n    bban: '05N17C',\n    example: 'TR330006100519786457841326',\n    len: 26,\n    name: 'Turkey',\n  },\n  UA: {\n    bban: '06N19C',\n    example: 'UA573543470006762462054925026',\n    len: 29,\n    name: 'Ukraine',\n  },\n  VA: {\n    bban: '03N15N',\n    example: 'VA59001123000012345678',\n    len: 22,\n    name: 'Vatican City',\n  },\n  VG: {\n    bban: '04C16N',\n    example: 'VG96VPVG0000012345678901',\n    len: 24,\n    name: 'Virgin Islands, British',\n  },\n  XK: {\n    bban: '04N10N02N',\n    example: 'XK051212012345678906',\n    len: 20,\n    name: 'Kosovo',\n  },\n  YE: {\n    bban: '04A04N18C',\n    example: 'YE15CBYE0001018861234567891234',\n    len: 30,\n    name: 'Yemen',\n  },\n};\n\nexport interface Country {\n  bban: string;\n  example: string;\n  len: number;\n  name: string;\n}\n\n/**\n * Given an iban returns that country specification\n *\n * type {function}\n * inner\n * throws {Error} If Country code is not defined\n * param {string} iban A valid IBAN number\n * return {object} Country specification\n */\nexport default (iban: string): Country => {\n  const countryCode = iban.slice(0, 2);\n\n  if (!{}.hasOwnProperty.call(countries, countryCode)) {\n    throw new Error(`Country code ${countryCode} is not supported`);\n  }\n\n  return countries[countryCode];\n};\n",
      properties: [
        {
          name: 'bban',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 642,
        },
        {
          name: 'example',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 643,
        },
        {
          name: 'len',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 644,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 645,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'CountryCodeFormatConfig',
      id: 'interface-CountryCodeFormatConfig-2186c35807301e161dc5d6f3ccd42fdbe77037e309f2acbe09de5088017442ab094ceff268b5bbb9cf8a1d00ba40c329e73bec16a8c45d676d3525fbc823aab0',
      file: 'libs/ui-ang/input-phone/input-phone.configuration_token.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\nimport { NumberFormat } from 'libphonenumber-js';\nimport { CountryList } from './input-phone.component';\n\nexport interface InputPhoneConfig {\n  maxLength?: number;\n  minLength?: number;\n  validationPattern?: string;\n  autocomplete?: 'tel' | 'on' | 'off';\n  mask?: string;\n  displayFormat?: NumberFormat | Capitalize<Lowercase<NumberFormat>>;\n  hideSelectedCountryFlag?: boolean;\n  defaultCountryIsoCode?: string;\n  countryList?: CountryList;\n  enableCountryCode?: boolean;\n}\nexport const INPUT_PHONE_CONFIG_TOKEN = new InjectionToken<InputPhoneConfig>('INPUT_PHONE_CONFIG_TOKEN');\n\nexport interface CountryCodeFormatConfig {\n  mask?: string;\n  minLength?: number;\n  maxLength?: number;\n}\nexport interface CountryCodeFormatConfigMap {\n  [key: string]: CountryCodeFormatConfig;\n}\nexport const COUNTRY_CODE_FORMAT_CONFIG_TOKEN = new InjectionToken<CountryCodeFormatConfigMap>(\n  'COUNTRY_CODE_FORMAT_CONFIG_TOKEN',\n);\n",
      properties: [
        {
          name: 'mask',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 20,
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 22,
        },
        {
          name: 'minLength',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 21,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'CountryCodeFormatConfigMap',
      id: 'interface-CountryCodeFormatConfigMap-2186c35807301e161dc5d6f3ccd42fdbe77037e309f2acbe09de5088017442ab094ceff268b5bbb9cf8a1d00ba40c329e73bec16a8c45d676d3525fbc823aab0',
      file: 'libs/ui-ang/input-phone/input-phone.configuration_token.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\nimport { NumberFormat } from 'libphonenumber-js';\nimport { CountryList } from './input-phone.component';\n\nexport interface InputPhoneConfig {\n  maxLength?: number;\n  minLength?: number;\n  validationPattern?: string;\n  autocomplete?: 'tel' | 'on' | 'off';\n  mask?: string;\n  displayFormat?: NumberFormat | Capitalize<Lowercase<NumberFormat>>;\n  hideSelectedCountryFlag?: boolean;\n  defaultCountryIsoCode?: string;\n  countryList?: CountryList;\n  enableCountryCode?: boolean;\n}\nexport const INPUT_PHONE_CONFIG_TOKEN = new InjectionToken<InputPhoneConfig>('INPUT_PHONE_CONFIG_TOKEN');\n\nexport interface CountryCodeFormatConfig {\n  mask?: string;\n  minLength?: number;\n  maxLength?: number;\n}\nexport interface CountryCodeFormatConfigMap {\n  [key: string]: CountryCodeFormatConfig;\n}\nexport const COUNTRY_CODE_FORMAT_CONFIG_TOKEN = new InjectionToken<CountryCodeFormatConfigMap>(\n  'COUNTRY_CODE_FORMAT_CONFIG_TOKEN',\n);\n",
      properties: [],
      indexSignatures: [
        {
          id: 'index-declaration-2186c35807301e161dc5d6f3ccd42fdbe77037e309f2acbe09de5088017442ab094ceff268b5bbb9cf8a1d00ba40c329e73bec16a8c45d676d3525fbc823aab0',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'CountryCodeFormatConfig',
          line: 24,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      methods: [],
      extends: [],
    },
    {
      name: 'CountryData',
      id: 'interface-CountryData-7d06114ff4b3caeeec660831a48cafca952e088daae504f00ea8a8c41a9fca6b7f036fb565fddc2afa59fc896b65fbd5e1b395df405734d03821645d2d605e54',
      file: 'libs/ui-ang/input-phone/input-phone.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  AfterViewInit,\n  ChangeDetectionStrategy,\n  ChangeDetectorRef,\n  Component,\n  ElementRef,\n  EventEmitter,\n  forwardRef,\n  Inject,\n  Input,\n  Optional,\n  Output,\n  Renderer2,\n  ViewChild,\n  OnDestroy,\n} from '@angular/core';\nimport {\n  AbstractControl,\n  NG_VALIDATORS,\n  NG_VALUE_ACCESSOR,\n  ValidationErrors,\n  Validator,\n  Validators,\n} from '@angular/forms';\nimport { InputBaseComponent } from '@backbase/ui-ang/base-classes';\nimport { DomAttributesService } from '@backbase/ui-ang/services';\nimport { getDynamicId } from '@backbase/ui-ang/util';\nimport { NgSelectComponent } from '@ng-select/ng-select';\nimport {\n  COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n  CountryCodeFormatConfig,\n  CountryCodeFormatConfigMap,\n  INPUT_PHONE_CONFIG_TOKEN,\n  InputPhoneConfig,\n} from './input-phone.configuration_token';\nimport { extractCountryFromValue, stripCountryCodeFromValue } from './phone-number-validation-helper';\nimport { BehaviorSubject, Subject, takeUntil } from 'rxjs';\n\n/**\n * @name InputPhoneComponent\n *\n * @description\n * Component that enables the user to enter a phone number.\n *\n * ### Global configuration token\n * `INPUT_PHONE_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n *\n *\n * The following properties can be overwritten using the token:\n *  - `maxLength`\n *  - `minLength`\n *  - `autocomplete`\n *  - `mask`\n *  - `displayFormat`\n *  - `validationPattern`\n *  - `hideSelectedCountryFlag`\n *  - `defaultCountryIsoCode`\n *  - `countryList`\n *\n * #### Usage notes\n * The following is an example of how to use the token:\n *\n * ```\n *  import { INPUT_PHONE_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n *  import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n *  import { AppModule } from './app/app.module';\n *\n *  const inputPhoneConfig = {\n *    maxLength: 10,\n *    minLength: 5,\n *    autocomplete: 'off',\n *    displayFormat: 'E.164',\n *  }\n *\n *  providers: [\n *    {\n *      provide: INPUT_PHONE_CONFIG_TOKEN,\n *      useValue: inputPhoneConfig,\n *    },\n *  ]\n * ```\n *\n * ### Country Code Format Config Token\n * `COUNTRY_CODE_FORMAT_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n *\n * #### Usage notes\n * The following is an example of how to use the token.\n * Note: the `minLength` and `maxLength` properties do not account for the country dialling code:\n *\n * ```\n *  import { COUNTRY_CODE_FORMAT_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n *  import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n *  import { AppModule } from './app/app.module';\n *\n *  const countryCodeFormatConfig = {\n *    '+1': {\n *      mask: '+0 (000) 000-0000',\n *      minLength: 8,\n *      maxLength, 12,\n *    },\n *  };\n *\n *  providers: [\n *    {\n *      provide: COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n *      useValue: countryCodeFormatConfig,\n *    },\n *  ]\n * ```\n *\n * IMPORTANT NOTE:\n *  - If you wish to validate & format ALL phone numbers using the SAME `minLength`, `maxLength` and/or `mask`, please configure these values using the INPUT_PHONE_CONFIG_TOKEN.\n *  - If you need to support phone numbers for multiple countries (DIFFERENT `minLength`, `maxLength` & `mask`), we advise to use the COUNTRY_CODE_FORMAT_CONFIG_TOKEN instead.\n *\n *  @a11y Current component provide option to pass needed accessibility\n * attributes. You need to take care of properties that are required in your case :\n *  - role\n *  - aria-activedescendant\n *  - aria-describedby\n *  - aria-expanded\n *  - aria-invalid\n *  - aria-label\n *  - aria-labelledby\n *  - aria-owns\n *\n * ariaLabel is discernible text for phone input\n */\n\nexport interface CountryData {\n  countryCode: string;\n  isoCode: string;\n  countryName: string;\n}\nexport type CountryList = Array<CountryData>;\nexport interface ValueSet extends CountryData {\n  number: string;\n}\n\n@Component({\n  selector: 'bb-input-phone-ui',\n  templateUrl: './input-phone.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  providers: [\n    {\n      provide: NG_VALUE_ACCESSOR,\n      useExisting: forwardRef(() => InputPhoneComponent),\n      multi: true,\n    },\n    {\n      provide: NG_VALIDATORS,\n      useExisting: forwardRef(() => InputPhoneComponent),\n      multi: true,\n    },\n  ],\n  standalone: false,\n})\nexport class InputPhoneComponent extends InputBaseComponent implements AfterViewInit, Validator, OnDestroy {\n  override writeValue(value: any): void {\n    if (value && typeof value === 'object') {\n      const selectedCountry = this.countryList?.find((country) => country.isoCode === value.isoCode);\n\n      this.selectedCountryCode = value.countryCode;\n      this.selectedCountryIsoCode = value.isoCode;\n      this.selectedCountryName = selectedCountry?.countryName;\n      this.value = value.number;\n      this.valueWithoutCountryCode = value.number;\n      this.updateValues(true);\n    } else {\n      this.value = typeof value === 'string' ? value.trim() : value;\n\n      this.onTextChange(true);\n    }\n  }\n\n  /**\n   * The max size of the phone input.\n   *\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input('maxLength')\n  get maxLength(): InputPhoneConfig['maxLength'] {\n    return this._maxLength ?? this.overrideConfiguration?.maxLength;\n  }\n\n  set maxLength(value: InputPhoneConfig['maxLength']) {\n    this._maxLength = value;\n  }\n  private _maxLength: InputPhoneConfig['maxLength'];\n\n  /**\n   * The validation pattern of the phone input.\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input('validationPattern')\n  get validationPattern(): InputPhoneConfig['validationPattern'] {\n    return this._validationPattern ?? this.overrideConfiguration?.validationPattern;\n  }\n\n  set validationPattern(value: InputPhoneConfig['validationPattern']) {\n    this._validationPattern = value;\n  }\n  private _validationPattern: InputPhoneConfig['validationPattern'];\n\n  /**\n   * The size of the phone input.\n   *\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('minLength')\n  get minLength(): InputPhoneConfig['minLength'] {\n    return this._minLength ?? this.overrideConfiguration?.minLength;\n  }\n  set minLength(value: InputPhoneConfig['minLength']) {\n    this._minLength = value;\n  }\n  private _minLength: InputPhoneConfig['minLength'];\n  /**\n   * The autocomplete value of the enclosed input control. Defaults to 'tel'\n   *\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('autocomplete')\n  get autocomplete(): InputPhoneConfig['autocomplete'] {\n    return this._autocomplete ?? this.overrideConfiguration?.autocomplete;\n  }\n  set autocomplete(value: InputPhoneConfig['autocomplete']) {\n    this._autocomplete = value;\n  }\n  private _autocomplete: InputPhoneConfig['autocomplete'];\n\n  /**\n   * The mask of the phone input. Defaults to null\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('mask')\n  get mask(): InputPhoneConfig['mask'] {\n    return this._mask ?? this.overrideConfiguration?.mask;\n  }\n  set mask(value: InputPhoneConfig['mask']) {\n    this._mask = value;\n  }\n  private _mask: InputPhoneConfig['mask'];\n\n  /**\n   * Whether to hide the flag of the selected country. Defaults to false\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('hideSelectedCountryFlag')\n  get hideSelectedCountryFlag(): InputPhoneConfig['hideSelectedCountryFlag'] {\n    return this._hideSelectedCountryFlag ?? this.overrideConfiguration?.hideSelectedCountryFlag ?? false;\n  }\n  set hideSelectedCountryFlag(value: InputPhoneConfig['hideSelectedCountryFlag']) {\n    this._hideSelectedCountryFlag = value;\n  }\n  private _hideSelectedCountryFlag: InputPhoneConfig['hideSelectedCountryFlag'];\n\n  /**\n   * The placeholder for the phone input. Defaults to an empty string;\n   */\n  @Input() placeholder = '';\n  /**\n   * Whether the phone input is readonly.\n   */\n  @Input() override readonly = false;\n  /**\n   * ariaLabel is discernible text for phone input.\n   */\n  @Input() override ariaLabel = 'Phone Input';\n  /**\n   * Dropdown Position (bottom | top | auto)\n   */\n  @Input() dropdownPosition: 'bottom' | 'top' | 'auto' | undefined;\n  /**\n   * Allow to clear selected value.\n   */\n  @Input() clearable = false;\n  /**\n   * Allow to search for value.\n   */\n  @Input() searchable = false;\n  /**\n   * List of countries to display in dropdown.\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('countryList')\n  get countryList(): InputPhoneConfig['countryList'] {\n    return this._countryList ?? this.overrideConfiguration?.countryList;\n  }\n  set countryList(value: InputPhoneConfig['countryList']) {\n    this._countryList = value;\n  }\n  private _countryList: InputPhoneConfig['countryList'];\n  /**\n   * Default country selected for country dropdown.\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('defaultCountryIsoCode')\n  get defaultCountryIsoCode(): InputPhoneConfig['defaultCountryIsoCode'] {\n    return this._defaultCountryIsoCode ?? this.overrideConfiguration?.defaultCountryIsoCode;\n  }\n  set defaultCountryIsoCode(value: InputPhoneConfig['defaultCountryIsoCode']) {\n    this._defaultCountryIsoCode = value;\n    this.selectedCountryIsoCode = value;\n  }\n  private _defaultCountryIsoCode: InputPhoneConfig['defaultCountryIsoCode'];\n\n  /**\n   * Enable/Disable Country code dropdown\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('enableCountryCode')\n  get enableCountryCode(): InputPhoneConfig['enableCountryCode'] {\n    return this._enableCountryCode ?? this.overrideConfiguration?.enableCountryCode;\n  }\n  set enableCountryCode(value: InputPhoneConfig['enableCountryCode']) {\n    this._enableCountryCode = value;\n  }\n  private _enableCountryCode: InputPhoneConfig['enableCountryCode'];\n\n  /**\n   * Allows manual control of dropdown opening and closing. `true` - won't close. `false` - won't open.\n   * Defaults to `undefined`.\n   */\n  @Input()\n  set isOpen(value) {\n    this._isOpen$.next(value);\n  }\n\n  get isOpen() {\n    return this._isOpen$.getValue();\n  }\n\n  private readonly _isOpen$ = new BehaviorSubject<boolean | undefined>(undefined);\n\n  /**\n   * The event emitter called when the one of the inputs change.\n   */\n  @Output() valueChange = new EventEmitter<ValueSet>();\n\n  @ViewChild('inputPhone') inputEl: ElementRef | undefined;\n  /**\n   * ng-select\n   */\n  @ViewChild(NgSelectComponent) ngSelect: NgSelectComponent | undefined;\n\n  selectedCountryCode?: string;\n  selectedCountryIsoCode?: string;\n  selectedCountryName?: string;\n  countryDropdowndisabled?: boolean;\n  override value = '';\n  valueSet: ValueSet = {\n    countryCode: '',\n    countryName: '',\n    isoCode: '',\n    number: '',\n  };\n  resultCount = 0;\n  countryCodeInputId = `country-code-input-${getDynamicId()}`;\n  notFoundText = $localize`:Text no items found during search or filter@@input-phone.no-items-found:No items found`;\n  private readonly _statusId = this.domAttrService.generateId();\n\n  get statusId() {\n    return this._statusId;\n  }\n\n  get useDefaultAriaDescribedby() {\n    return !this.ariaDescribedby && this.countryDropdowndisabled;\n  }\n\n  private matchingCountry?: CountryData;\n  private valueWithoutCountryCode = '';\n  private noMatchingCountryFound = false;\n  private countrySpecificValidationConfig?: CountryCodeFormatConfig;\n  private readonly _destroy$ = new Subject<void>();\n\n  constructor(\n    private readonly domAttrService: DomAttributesService,\n    private readonly elem: ElementRef,\n    private readonly renderer2: Renderer2,\n    override readonly cd: ChangeDetectorRef,\n    @Optional()\n    @Inject(INPUT_PHONE_CONFIG_TOKEN)\n    private readonly overrideConfiguration: InputPhoneConfig,\n    @Optional()\n    @Inject(COUNTRY_CODE_FORMAT_CONFIG_TOKEN)\n    private readonly countryCodeFormatConfiguration: CountryCodeFormatConfigMap,\n  ) {\n    super(cd);\n  }\n\n  ngOnDestroy() {\n    this._destroy$.next();\n    this._destroy$.complete();\n  }\n\n  onTextChange(preventEmit = false) {\n    this.resetMatchingCountry();\n    this.findMatchingCountryCodeFromValue(this.value);\n    this.selectedCountryCode = this.matchingCountry?.countryCode || this.selectedCountryCode;\n    this.selectedCountryName = this.matchingCountry?.countryName || this.selectedCountryName;\n    this.selectedCountryIsoCode = this.matchingCountry?.isoCode || this.selectedCountryIsoCode;\n    this.value = this.enableCountryCode ? this.valueWithoutCountryCode : this.valueWithoutCountryCode || this.value;\n    this.updateValues(preventEmit);\n    this.restoreCaretPosition();\n  }\n\n  updateValues(preventEmit = false): void {\n    this.valueSet = {\n      countryCode: this.selectedCountryCode || '',\n      countryName: this.selectedCountryName || '',\n      isoCode: this.selectedCountryIsoCode || '',\n      number: this.value,\n    };\n\n    if (!preventEmit) {\n      this.valueChange.emit(this.valueSet);\n    }\n    this.cd.detectChanges();\n  }\n\n  ngAfterViewInit(): void {\n    if (!this.ariaLabel) {\n      this.domAttrService.moveAriaAttributes(\n        this.elem.nativeElement,\n        this.inputEl && this.inputEl.nativeElement,\n        this.renderer2,\n      );\n    }\n\n    this.constructCountryData();\n    this.updateValues(true);\n    this.removeReadonly(); // android talkback reads readonly attribute as disabled\n\n    // force lifecycle to doCheck to prevent console ExpressionChangedAfterItHasBeenCheckedError\n    this.cd.detectChanges();\n\n    if (this.value !== undefined) {\n      this.onTextChange();\n    }\n\n    this._isOpen$.pipe(takeUntil(this._destroy$)).subscribe((isOpen) => {\n      if (isOpen) {\n        this.moveAriaAttributes();\n      }\n\n      if (isOpen === undefined) {\n        this.addAriaExpanded();\n      }\n    });\n  }\n\n  onChanges(event: CountryData) {\n    if (!event || event.constructor !== Object) return;\n\n    this.selectedCountryName = event.countryName;\n    this.selectedCountryIsoCode = event.isoCode;\n    this.selectedCountryCode = event.countryCode;\n    this.countrySpecificValidationConfig =\n      this.countryCodeFormatConfiguration && this.countryCodeFormatConfiguration[this.selectedCountryCode];\n    this.onInputValueChange(this.value);\n\n    this.value = this.valueWithoutCountryCode || this.value;\n    this.updateValues();\n  }\n\n  /**\n   * @deprecated Deprecated in ui-ang@12. To be marked as protected in ui-ang@14. No replacements.\n   */\n  onOpen() {\n    if (!this.ngSelect?.dropdownId) {\n      return;\n    }\n    if (this.readonly || this.disabled) {\n      this.countryDropdowndisabled = true;\n      this.ngSelect.isOpen = false;\n\n      return;\n    }\n\n    // wait for DOM to be updated\n    setTimeout(() => {\n      this.moveAriaAttributes();\n    });\n\n    this.updateResultCount();\n  }\n\n  onClose() {\n    if (this.ngSelect && !this.ngSelect.isOpen) {\n      this.ngSelect.constructor.prototype.focus.call(this.ngSelect);\n    }\n  }\n\n  onClear() {\n    this.onFilterChange(undefined);\n  }\n\n  onFilterChange(query: string | undefined): void {\n    if (this.ngSelect) {\n      this.ngSelect.filter(query || '');\n    }\n    this.updateResultCount();\n  }\n\n  searchFunc(term: string, item: CountryData): boolean {\n    term = term.toLocaleLowerCase();\n\n    return (\n      item.countryCode.toLocaleLowerCase().indexOf(term) > -1 ||\n      item.countryName.toLocaleLowerCase().indexOf(term) > -1 ||\n      item.isoCode.toLocaleLowerCase().indexOf(term) > -1\n    );\n  }\n\n  onInputValueChange(newValue: string) {\n    // remove country code from phone number before validating the input\n    this.resetMatchingCountry();\n    this.findMatchingCountryCodeFromValue(newValue);\n    this.selectedCountryCode = this.matchingCountry?.countryCode ?? this.selectedCountryCode;\n    this.selectedCountryName = this.matchingCountry?.countryName ?? this.selectedCountryName;\n    this.selectedCountryIsoCode = this.matchingCountry?.isoCode ?? this.selectedCountryIsoCode;\n\n    const countryCode = this.selectedCountryCode || '';\n    if (!newValue) {\n      this.onValueChange('');\n\n      return;\n    }\n    this.onValueChange(`${countryCode}${this.valueWithoutCountryCode || newValue}`);\n  }\n\n  validate(control: AbstractControl): ValidationErrors | null {\n    if (control.value === '') {\n      return null;\n    }\n\n    if (this.isPhoneNumberEmpty()) return { required: true };\n\n    if (this.checkValidationPattern(control)) return { invalidFormat: true };\n\n    if (this.noMatchingCountryFound) return { countryCodeUnsupported: true };\n\n    return this.isMinLengthInvalid(control.value) ?? this.isMaxLengthInvalid(control.value);\n  }\n\n  private isPhoneNumberEmpty() {\n    if (!this.required) {\n      return false;\n    }\n\n    const validateWithCountryCode = Boolean(this.enableCountryCode && this.countryList && this.valueSet.countryCode);\n    const isEmptyPhoneNumber = this.valueWithoutCountryCode === '' || this.valueWithoutCountryCode === '+';\n\n    return validateWithCountryCode && isEmptyPhoneNumber;\n  }\n\n  private isMinLengthInvalid(value?: string) {\n    const minLength = this.countrySpecificValidationConfig?.minLength ?? this.minLength;\n\n    if (!minLength || !value) {\n      return null;\n    }\n\n    const phoneNumberLength = this.preparePhoneNumberLengthForValidation(value);\n\n    if (phoneNumberLength > 0 && phoneNumberLength < minLength) {\n      return { minLength: { expectedMinLength: minLength } };\n    }\n\n    return null;\n  }\n\n  private isMaxLengthInvalid(value?: string) {\n    const maxLength = this.countrySpecificValidationConfig?.maxLength ?? this.maxLength;\n\n    if (!maxLength || !value) {\n      return null;\n    }\n\n    const phoneNumberLength = this.preparePhoneNumberLengthForValidation(value);\n\n    if (phoneNumberLength > maxLength) {\n      return { maxLength: { expectedMaxLength: maxLength } };\n    }\n\n    return null;\n  }\n\n  private checkValidationPattern(control: AbstractControl) {\n    if (this.validationPattern) {\n      if (Validators.pattern(this.validationPattern)(control)) {\n        return true;\n      }\n    }\n\n    return false;\n  }\n\n  /**\n   * Resets `matchingCountry` if the `selectedCountry` was changed manually via the country dropdown\n   */\n  private resetMatchingCountry() {\n    if (!this.enableCountryCode || !this.countryList) {\n      return;\n    }\n\n    if (this.selectedCountryIsoCode !== this.matchingCountry?.isoCode) {\n      this.matchingCountry = undefined;\n    }\n  }\n\n  private updateResultCount(): void {\n    this.resultCount = this.ngSelect?.itemsList.filteredItems.filter(({ children }) => !children).length || 0;\n  }\n\n  private constructCountryData(): void {\n    if (!this.enableCountryCode || !this.countryList) {\n      return;\n    }\n\n    const isoCode = this.selectedCountryIsoCode || this.defaultCountryIsoCode;\n    const selectedCountry = this.countryList.find((country) => country.isoCode === isoCode) || this.countryList[0];\n\n    this.countryDropdowndisabled = this.countryList.length === 1 || this.readonly || this.disabled;\n    this.selectedCountryCode = selectedCountry.countryCode;\n    this.selectedCountryName = selectedCountry.countryName;\n    this.selectedCountryIsoCode = selectedCountry.isoCode;\n    this.countrySpecificValidationConfig =\n      this.countryCodeFormatConfiguration && this.countryCodeFormatConfiguration[this.selectedCountryCode];\n  }\n\n  private findMatchingCountryCodeFromValue(value = ''): void {\n    if (!this.countryList) {\n      return;\n    }\n\n    if (!this.enableCountryCode) {\n      this.valueWithoutCountryCode = value;\n      if (value.startsWith('+') && value.length >= 2) {\n        const matchingCountry = extractCountryFromValue(value, this.countryList);\n\n        this.valueWithoutCountryCode = stripCountryCodeFromValue(value, matchingCountry?.countryCode);\n      }\n\n      return;\n    }\n\n    if (value.startsWith('+') && value.length >= 2) {\n      const matchingCountry = extractCountryFromValue(value, this.countryList);\n      const { number, ...valueSet } = { ...this.valueSet };\n\n      this.matchingCountry = matchingCountry?.countryCode === valueSet.countryCode ? valueSet : matchingCountry;\n\n      if (this.matchingCountry) {\n        this.noMatchingCountryFound = false;\n        this.countrySpecificValidationConfig = this.countryCodeFormatConfiguration?.[this.matchingCountry.countryCode];\n        this.valueWithoutCountryCode = stripCountryCodeFromValue(value, this.matchingCountry.countryCode);\n      } else {\n        this.noMatchingCountryFound = true;\n        this.valueWithoutCountryCode = value;\n      }\n    } else {\n      this.noMatchingCountryFound = false;\n      this.valueWithoutCountryCode = value;\n    }\n  }\n\n  private removeReadonly() {\n    if (this.ngSelect && !this.readonly) {\n      this.renderer2.removeAttribute(this.ngSelect?.searchInput.nativeElement, 'readonly');\n    }\n  }\n\n  private preparePhoneNumberLengthForValidation(value: string) {\n    const countryCode = this.selectedCountryCode ?? this.valueSet.countryCode;\n\n    if (this.enableCountryCode && typeof value === 'string' && value.startsWith(countryCode)) {\n      // value contains both country code and phone number, we exclude country code for length validation\n      return value.length - countryCode.length;\n    }\n\n    // account for when users will call \".patch({ mobileNumber: x })\" without the country code\n    return value.length;\n  }\n\n  private moveAriaAttributes() {\n    // HACK: ng-select listbox cannot have roles that are not \"option\"\n    // We move listbox to be the direct parent of the list and not cover the searchbox\n\n    const ngDropdownPanelElement = this.ngSelect?.element.querySelector('ng-dropdown-panel');\n    const listOptionsElement = ngDropdownPanelElement?.querySelector('.ng-dropdown-panel-items');\n\n    if (!ngDropdownPanelElement || !listOptionsElement) {\n      return;\n    }\n\n    this.renderer2.setAttribute(listOptionsElement, 'role', 'listbox');\n    this.renderer2.setAttribute(listOptionsElement, 'aria-label', 'List of countries');\n    this.renderer2.removeAttribute(ngDropdownPanelElement, 'role');\n  }\n\n  private addAriaExpanded() {\n    const comboboxElement = this.ngSelect?.element?.querySelector('[role=\"combobox\"]');\n\n    if (!comboboxElement || comboboxElement.hasAttribute('aria-expanded')) {\n      return;\n    }\n\n    this.renderer2.setAttribute(comboboxElement, 'aria-expanded', 'false');\n  }\n\n  private restoreCaretPosition() {\n    const inputElement = this.inputEl?.nativeElement;\n    if (inputElement === document.activeElement) {\n      const caretPosition = inputElement?.selectionStart || 0; // Preserve caret\n      setTimeout(() => {\n        inputElement?.setSelectionRange(caretPosition, caretPosition); // Restore caret\n      });\n    }\n  }\n}\n",
      properties: [
        {
          name: 'countryCode',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 130,
        },
        {
          name: 'countryName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 132,
        },
        {
          name: 'isoCode',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 131,
        },
      ],
      indexSignatures: [],
      kind: 171,
      description:
        '<p>Component that enables the user to enter a phone number.</p>\n<h3>Global configuration token</h3>\n<p><code>INPUT_PHONE_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>InputPhoneComponent</code> in your project.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>maxLength</code></li>\n<li><code>minLength</code></li>\n<li><code>autocomplete</code></li>\n<li><code>mask</code></li>\n<li><code>displayFormat</code></li>\n<li><code>validationPattern</code></li>\n<li><code>hideSelectedCountryFlag</code></li>\n<li><code>defaultCountryIsoCode</code></li>\n<li><code>countryList</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none"> import { INPUT_PHONE_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/input-phone&#39;;\n import { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\n import { AppModule } from &#39;./app/app.module&#39;;\n\n const inputPhoneConfig = {\n   maxLength: 10,\n   minLength: 5,\n   autocomplete: &#39;off&#39;,\n   displayFormat: &#39;E.164&#39;,\n }\n\n providers: [\n   {\n     provide: INPUT_PHONE_CONFIG_TOKEN,\n     useValue: inputPhoneConfig,\n   },\n ]</code></pre></div><h3>Country Code Format Config Token</h3>\n<p><code>COUNTRY_CODE_FORMAT_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>InputPhoneComponent</code> in your project.</p>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token.\nNote: the <code>minLength</code> and <code>maxLength</code> properties do not account for the country dialling code:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none"> import { COUNTRY_CODE_FORMAT_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/input-phone&#39;;\n import { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\n import { AppModule } from &#39;./app/app.module&#39;;\n\n const countryCodeFormatConfig = {\n   &#39;+1&#39;: {\n     mask: &#39;+0 (000) 000-0000&#39;,\n     minLength: 8,\n     maxLength, 12,\n   },\n };\n\n providers: [\n   {\n     provide: COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n     useValue: countryCodeFormatConfig,\n   },\n ]</code></pre></div><p>IMPORTANT NOTE:</p>\n<ul>\n<li>If you wish to validate &amp; format ALL phone numbers using the SAME <code>minLength</code>, <code>maxLength</code> and/or <code>mask</code>, please configure these values using the INPUT_PHONE_CONFIG_TOKEN.</li>\n<li>If you need to support phone numbers for multiple countries (DIFFERENT <code>minLength</code>, <code>maxLength</code> &amp; <code>mask</code>), we advise to use the COUNTRY_CODE_FORMAT_CONFIG_TOKEN instead.</li>\n</ul>\n<p> @a11y Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n<p>ariaLabel is discernible text for phone input</p>\n',
      rawdescription:
        "\n\n\nComponent that enables the user to enter a phone number.\n\n### Global configuration token\n`INPUT_PHONE_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n\n\nThe following properties can be overwritten using the token:\n - `maxLength`\n - `minLength`\n - `autocomplete`\n - `mask`\n - `displayFormat`\n - `validationPattern`\n - `hideSelectedCountryFlag`\n - `defaultCountryIsoCode`\n - `countryList`\n\n#### Usage notes\nThe following is an example of how to use the token:\n\n```\n import { INPUT_PHONE_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n import { AppModule } from './app/app.module';\n\n const inputPhoneConfig = {\n   maxLength: 10,\n   minLength: 5,\n   autocomplete: 'off',\n   displayFormat: 'E.164',\n }\n\n providers: [\n   {\n     provide: INPUT_PHONE_CONFIG_TOKEN,\n     useValue: inputPhoneConfig,\n   },\n ]\n```\n\n### Country Code Format Config Token\n`COUNTRY_CODE_FORMAT_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n\n#### Usage notes\nThe following is an example of how to use the token.\nNote: the `minLength` and `maxLength` properties do not account for the country dialling code:\n\n```\n import { COUNTRY_CODE_FORMAT_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n import { AppModule } from './app/app.module';\n\n const countryCodeFormatConfig = {\n   '+1': {\n     mask: '+0 (000) 000-0000',\n     minLength: 8,\n     maxLength, 12,\n   },\n };\n\n providers: [\n   {\n     provide: COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n     useValue: countryCodeFormatConfig,\n   },\n ]\n```\n\nIMPORTANT NOTE:\n - If you wish to validate & format ALL phone numbers using the SAME `minLength`, `maxLength` and/or `mask`, please configure these values using the INPUT_PHONE_CONFIG_TOKEN.\n - If you need to support phone numbers for multiple countries (DIFFERENT `minLength`, `maxLength` & `mask`), we advise to use the COUNTRY_CODE_FORMAT_CONFIG_TOKEN instead.\n\n @a11y Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :\n - role\n - aria-activedescendant\n - aria-describedby\n - aria-expanded\n - aria-invalid\n - aria-label\n - aria-labelledby\n - aria-owns\n\nariaLabel is discernible text for phone input\n",
      methods: [],
      extends: [],
    },
    {
      name: 'CountryData',
      id: 'interface-CountryData-520900be74160924773453d35c739d99b0240314060182334453c26e6cb450b35f4106ec4ac2ac8807181f5f7c33aa67032c35a6f8c4943aef954893ea3ceee4-1',
      file: 'libs/ui-ang-examples/src/table/examples/table.example.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface CountryData {\n  [key: string]: string | number;\n  id: number;\n  name: string;\n  flag: string;\n  area: number;\n  population: number;\n}\n',
      properties: [
        {
          name: 'area',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
        {
          name: 'flag',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 3,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
        {
          name: 'population',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
      ],
      indexSignatures: [
        {
          id: 'index-declaration-520900be74160924773453d35c739d99b0240314060182334453c26e6cb450b35f4106ec4ac2ac8807181f5f7c33aa67032c35a6f8c4943aef954893ea3ceee4',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'string | number',
          line: 1,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 171,
      methods: [],
      extends: [],
      isDuplicate: true,
      duplicateId: 1,
      duplicateName: 'CountryData-1',
    },
    {
      name: 'CrossJourneyConfig',
      id: 'interface-CrossJourneyConfig-7c5a00cd6549ea9fa405614942171379f99ecbb461715fd6af3bcfb82475c54e93485b2a116eabc58f198c697a11d3276f1de6635c77a0d37432e8fd3f3b0ab0',
      file: 'libs/ui-ang/animations/types/config-types.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { TranslationAxis, TranslationDirectionType, TranslationDirectionValue } from './translation';\n\nexport interface InJourneyConfig {\n  animationAlias: string;\n  translationDirectionType: TranslationDirectionType;\n  translationAxis: TranslationAxis;\n  translationDirection: TranslationDirectionValue;\n  // enableLeaveGroups: with leave groups enabled the view can decide wether if it wants elements leave from\n  // top or bottom by using a class\n  enableLeaveGroups: boolean;\n  disableAnimation: boolean;\n}\n\nexport interface CrossJourneyConfig {\n  animationAlias: string;\n  disableAnimation: boolean;\n  fadeInOutSelector: string;\n  enableGroups: boolean;\n  enterDelay: string;\n  routerContainerSelector: string;\n}\n\nexport interface ExpandRevealConfig {\n  animationAlias: string;\n  disableAnimation: boolean;\n  contentSelector: string;\n  containerSelector: string;\n  expandStyle: ExpandRevealStyle;\n}\n\nexport enum ExpandRevealStyle {\n  SEQUENCED = 'SEQUENCED_EXPAND',\n  STAGGERED = 'STAGGERED_EXPAND',\n}\n",
      properties: [
        {
          name: 'animationAlias',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 15,
        },
        {
          name: 'disableAnimation',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 16,
        },
        {
          name: 'enableGroups',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 18,
        },
        {
          name: 'enterDelay',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 19,
        },
        {
          name: 'fadeInOutSelector',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 17,
        },
        {
          name: 'routerContainerSelector',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 20,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'CurrencyFieldsState',
      id: 'interface-CurrencyFieldsState-49f9ed97e894172cd256acbdb6bd4eb639af785c9c094170d713e23cffa9ef137ecaf3487487c55f1167967cc4b5c513322e13f365eddfe715e8c03430396581',
      file: 'libs/ui-ang/currency-input/currency-input.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { DecimalPipe, getLocaleNumberSymbol, getNumberOfCurrencyDigits, NumberSymbol } from '@angular/common';\nimport {\n  AfterViewInit,\n  Component,\n  ElementRef,\n  EventEmitter,\n  Inject,\n  Input,\n  LOCALE_ID,\n  OnChanges,\n  OnDestroy,\n  OnInit,\n  Optional,\n  Output,\n  Self,\n  SimpleChanges,\n  ViewChild,\n} from '@angular/core';\nimport { ControlValueAccessor, UntypedFormControl, NgControl } from '@angular/forms';\nimport BigNumber from 'bignumber.js';\nimport { getInputNextId } from '@backbase/ui-ang/base-classes';\nimport { DomAttributesService } from '@backbase/ui-ang/services';\nimport { idListAttr } from '@backbase/ui-ang/util';\nimport { CurrencyInputConfig, CURRENCY_INPUT_CONFIG_TOKEN } from './currency-input.token-config';\nimport { combineLatest, filter, skip, startWith, Subject, takeUntil } from 'rxjs';\n\nconst defaultIntLength = 13;\nconst defaultDecimalPrecision = 2;\n\nexport interface CurrencyFieldsState {\n  currency: boolean;\n  integer: boolean;\n  decimal: boolean;\n}\n\n/**\n * @name CurrencyInputComponent\n *\n * @description\n * Component to display and manage the currency and the amount\n *\n * ### Global configuration token\n * `CURRENCY_INPUT_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of the `CurrencyInputComponent` in your project.\n *\n * *Note:* The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not able to overwrite it.\n *\n * The following properties can be overwritten using the token:\n *  - `allowNegativeValue`\n *  - `currencies`\n *  - `placeholder`\n *\n * #### Usage notes\n * The following is an example of how to use the token:\n *\n * ```typescript\n * import { CURRENCY_INPUT_CONFIG_TOKEN } from '@backbase/ui-ang/currency-input';\n * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n * import { AppModule } from './app/app.module';\n *\n * const currencyInputConfig = {\n *   allowNegativeValue: true\n * }\n *\n * platformBrowserDynamic().bootstrapModule(AppModule, {\n *   providers: [{ provide: CURRENCY_INPUT_CONFIG_TOKEN, useValue: currencyInputConfig }]\n * });\n * ```\n *\n * ### Accessibility\n * Current component provide option to pass needed accessibility\n * attributes. You need to take care of properties that are required in your case :\n *  - aria-describedby\n *  - aria-invalid\n *  - aria-labelledby\n *  - integerLabelSrOnly\n *  - decimalLabelSrOnly\n *\n */\n@Component({\n  selector: 'bb-currency-input-ui',\n  templateUrl: './currency-input.component.html',\n  providers: [DecimalPipe],\n  standalone: false,\n})\nexport class CurrencyInputComponent implements ControlValueAccessor, OnInit, OnDestroy, OnChanges, AfterViewInit {\n  private currencyList: Array<string> = [];\n  private currencyDisabledState: CurrencyFieldsState = {\n    currency: false,\n    integer: false,\n    decimal: false,\n  };\n  private currency: string | undefined;\n  private intMaxLen: number | undefined;\n  readonly decimalSeparator: string = getLocaleNumberSymbol(this.locale, NumberSymbol.CurrencyDecimal);\n  private readonly localeSeparatorSymbols = [\n    this.decimalSeparator,\n    getLocaleNumberSymbol(this.locale, NumberSymbol.CurrencyGroup),\n  ];\n\n  private _decMaxLen: number | undefined;\n  private destroy$ = new Subject<void>();\n\n  /**\n   * Configure the maximum number of decimals.\n   * When greater than the default number of decimals for the specified currency, this value will take precedence.\n   * Configuring this value can affect the input placeholder.\n   */\n  @Input()\n  get decMaxLen(): number | undefined {\n    return typeof this._decMaxLen === 'number' ? this._decMaxLen : this.getDecimalDigits(this.currency || '');\n  }\n\n  set decMaxLen(value: number | undefined) {\n    this._decMaxLen = value;\n  }\n\n  /**\n   * Number of minimum currency precision. Defaults to 2.\n   */\n  @Input() decMinLen = defaultDecimalPrecision;\n\n  /**\n   * Non-configurable placeholder for the decimal input.\n   * Displays a zero digit for every digit that is allowed in the decimal field.\n   */\n  get decPlaceholder(): string {\n    return '0'.repeat(this.decMaxLen || 0);\n  }\n\n  readonly currControl = new UntypedFormControl();\n  readonly intControl = new UntypedFormControl();\n  readonly decControl = new UntypedFormControl();\n\n  /**\n   * The placeholder for the input. Defaults to 0.\n   *\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input()\n  set placeholder(value: CurrencyInputConfig['placeholder']) {\n    this._placeholder = value;\n  }\n\n  get placeholder(): string {\n    return this._placeholder ?? this.overrideConfig?.placeholder ?? '0';\n  }\n\n  private _placeholder: CurrencyInputConfig['placeholder'];\n\n  /**\n   * For set output type string/number, by default 'number', when  need work with long number\n   * ( bigger than MAX_SAFE_INTEGER = 9,007,199,254,740,993 ) need to use 'string'\n   */\n  @Input() resultType: 'string' | 'number' = 'number';\n  /**\n   * Whether there should be only the integer part.\n   * You have to keep in mind, that if you have decimal part, even \".00\"\n   * you will not be able to remove it\n   */\n  @Input() integer = false;\n\n  /**\n   * Whether the input is required. Defaults to false.\n   */\n  @Input() required = false;\n\n  /**\n   * Whether the input is read only. Defaults to false.\n   */\n  @Input() readonly = false;\n\n  /**\n   * Whether the input is disabled. Defaults to false.\n   */\n  @Input()\n  set disabled(disabled: boolean | CurrencyFieldsState) {\n    if (typeof disabled === 'boolean') {\n      this.currencyDisabledState = {\n        currency: disabled,\n        integer: disabled,\n        decimal: disabled,\n      };\n    } else {\n      this.currencyDisabledState = disabled;\n    }\n  }\n\n  get disabled() {\n    return this.currencyDisabledState;\n  }\n\n  /**\n   * Whether integer label is only visible for screen readers.\n   * By default is visible if it is needed to hide change this property\n   * to \"true\" and it will have class \"visually-hidden\"\n   */\n  @Input() integerLabelSrOnly = false;\n  /**\n   * By default is visible if it is needed to hide change this property\n   * to \"true\" and it will have class \"visually-hidden\"\n   * By default is hidden and accessible only for screen reader\n   */\n  @Input() decimalLabelSrOnly = false;\n\n  /**\n   * Currency list to be displayed in the dropdown.\n   *\n   * Note: Non-empty currency list is required for the currency symbol\n   * field to be shown. Otherwise, only the amount fields will be shown.\n   *\n   * Additionally, If only a single currency provided, the dropdown of\n   * the currency selection will be disabled and its value set to that single currency\n   *\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input()\n  set currencies(list: Array<string>) {\n    this.currencyList = list.length ? list : this.overrideConfig?.currencies ?? [];\n\n    if (this.currencyList && this.currencyList.length > 1) {\n      this.currControl.enable();\n    } else {\n      this.currControl.disable();\n    }\n\n    // if currency is not set, use first item from the list\n    if (this.currencyList && (this.currency === undefined || this.currencyList.indexOf(this.currency) === -1)) {\n      // [FIXME] Nothing guarantees that the currencyList isn't empty\n      this.updateCurrency(this.currencyList[0]);\n    }\n  }\n\n  /**\n   * Whether decimal text is aligned to the right.\n   * By default is false\n   */\n  @Input() isRightAligned = false;\n\n  /**\n   * The id for the currency input. Defaults to unique string.\n   * Used to map the label to the input.\n   */\n  @Input() currencyInputId?: string;\n\n  /**\n   * The id for the decimal input. Defaults to unique string.\n   * Used to map the label to the input.\n   */\n  @Input() decimalInputId?: string;\n\n  /**\n   * The id for the integer input. Defaults to unique string.\n   * Used to map the label to the input.\n   */\n  @Input() integerInputId?: string;\n\n  private _integerId = getInputNextId();\n  private _decimalId = getInputNextId();\n\n  public readonly currencyLabelId: string;\n  public readonly decimalLabelId: string;\n  public readonly integerLabelId: string;\n  public readonly validationMessagesId: string;\n  public readonly idListAttr = idListAttr;\n\n  protected initialized = false;\n\n  /**\n   * The id for the integer input. Defaults to unique string.\n   * Used to map the label to the input.\n   */\n  @Input()\n  set integerId(value: string) {\n    this._integerId = value;\n  }\n\n  get integerId() {\n    return this._integerId;\n  }\n\n  /**\n   * The id for the decimal input. Defaults to unique string.\n   * Used to map the label to the input.\n   */\n  @Input()\n  set decimalId(value: string) {\n    this._decimalId = value;\n  }\n\n  get decimalId() {\n    return this._decimalId;\n  }\n\n  /**\n   * The label for the integer input.\n   */\n  @Input() integerLabel = '';\n  /**\n   * The label for the decimal input.\n   */\n  @Input() decimalLabel = '';\n  /**\n   * The label for the currency input.\n   */\n  @Input() currencyLabel = '';\n\n  /**\n   * Flag is used to allow input negative value\n   *\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input()\n  set allowNegativeValue(value: CurrencyInputConfig['allowNegativeValue']) {\n    this._allowNegativeValue = value;\n  }\n\n  get allowNegativeValue(): boolean {\n    return this._allowNegativeValue ?? this.overrideConfig?.allowNegativeValue ?? false;\n  }\n\n  private _allowNegativeValue: CurrencyInputConfig['allowNegativeValue'];\n\n  /**\n   * Aria label for the currency dropdown.\n   */\n  @Input() currencyListAriaLabel = 'Currency List Dropdown';\n  /**\n   * Aria label for the currency list with one item.\n   */\n  @Input() currencyListWithOnItemAriaLabel = 'Currency';\n\n  // eslint-disable-next-line @angular-eslint/no-input-rename\n  @Input('aria-describedby') ariaDescribedby?: string;\n\n  // eslint-disable-next-line @angular-eslint/no-input-rename\n  @Input('aria-labelledby') ariaLabelledby?: string;\n\n  // eslint-disable-next-line @angular-eslint/no-input-rename\n  @Input('aria-invalid') ariaInvalid?: string;\n\n  @ViewChild('integerInput', { static: true }) intEl?: ElementRef;\n  @ViewChild('decimalsInput') decEl?: ElementRef;\n\n  /**\n   * An event emitter for on blur actions.\n   */\n  @Output() blur = new EventEmitter<FocusEvent | void>();\n\n  constructor(\n    private readonly el: ElementRef,\n    @Inject(LOCALE_ID) private readonly locale: string,\n    private domAttributeService: DomAttributesService,\n    @Optional() @Self() public parentFormControl: NgControl,\n    @Optional() @Inject(CURRENCY_INPUT_CONFIG_TOKEN) private readonly overrideConfig: CurrencyInputConfig,\n  ) {\n    this.currencyInputId = this.domAttributeService.generateId();\n    this.currencyLabelId = this.domAttributeService.generateId();\n    this.decimalInputId = this.domAttributeService.generateId();\n    this.decimalLabelId = this.domAttributeService.generateId();\n    this.integerInputId = this.domAttributeService.generateId();\n    this.integerLabelId = this.domAttributeService.generateId();\n    this.validationMessagesId = this.domAttributeService.generateId();\n\n    BigNumber.config({\n      FORMAT: {\n        // grouping separator of the integer part\n        groupSeparator: getLocaleNumberSymbol(this.locale, NumberSymbol.Group),\n        // primary grouping size of the integer part\n        groupSize: 3,\n      },\n    });\n    if (this.parentFormControl != null) {\n      // Setting the value accessor directly (instead of using\n      // the providers) to avoid running into a circular import.\n      this.parentFormControl.valueAccessor = this;\n    }\n  }\n\n  ngOnInit() {\n    this.initialized = true;\n    if (!this.integerLabel || !this.decimalLabel) {\n      console.warn(\n        `\n          Found an input from '\n          ${this.constructor.name}\n          ' without 'label' or 'aria-label' attribute, please provide one of them\n        `,\n      );\n    }\n\n    this.setDisabled(this.currencyDisabledState);\n\n    this.formatInteger();\n    this.sanitizeValidation();\n  }\n\n  ngOnDestroy() {\n    this.destroy$.next();\n    this.destroy$.complete();\n  }\n\n  ngOnChanges(changes: SimpleChanges) {\n    if (changes.disabled) {\n      this.setDisabled(this.currencyDisabledState);\n    }\n  }\n\n  decOnBlur($event: FocusEvent) {\n    this.markAsTouched($event);\n    this.formatDecimal(this.decControl);\n  }\n\n  get cur() {\n    return this.currency;\n  }\n\n  get curList(): string[] {\n    return this.currencyList.length ? this.currencyList : this.overrideConfig?.currencies ?? [];\n  }\n\n  ngAfterViewInit(): void {\n    const len = this.el.nativeElement.getAttribute('maxlength');\n    this.intMaxLen = len ? parseInt(len, 10) : defaultIntLength;\n  }\n\n  onChange = (_: any) => {};\n  onTouched = () => {};\n\n  onPress($event: any) {\n    this.focusDecEl($event.key);\n\n    const keyCode = $event.keyCode || $event.which;\n    const key = String.fromCharCode(keyCode);\n\n    // allow to enter 'minus' only at the first position and if correspondent flag is enabled\n    const isLeadingMinusPosition =\n      this.allowNegativeValue && this.intEl && this.intEl.nativeElement.selectionStart === 0 && key === '-';\n\n    // regexp is used here to support both of regular keyboard's numbers and numpad's numbers\n    if (!(isLeadingMinusPosition || /^\\d$/.test(key)) && $event.keyCode !== 8 && $event.keyCode !== 9) {\n      $event.preventDefault();\n    }\n  }\n\n  onInput() {\n    const isFormatted = this.formatInteger();\n    if (isFormatted) {\n      this.triggerChange();\n    }\n  }\n\n  updateCurrency(currency?: string) {\n    this.currency = currency || this.currControl.value;\n    this.triggerChange();\n  }\n\n  checkValues() {\n    if (this.currency === undefined) {\n      return true;\n    }\n    if (!this.decControl.value && !this.intControl.value) {\n      this.onChange(null);\n\n      return true;\n    }\n\n    return false;\n  }\n\n  formatDecimal(decControl: UntypedFormControl) {\n    const { value } = decControl;\n    if (value && this.decMaxLen && value.length < this.decMaxLen) {\n      const updatedValue = String(value).padEnd(this.decMaxLen, '0');\n      decControl.patchValue(updatedValue);\n\n      return;\n    }\n  }\n\n  triggerChange() {\n    if (this.checkValues()) {\n      return;\n    }\n\n    const int: string = this.intControl.value || '0';\n\n    if (this.resultType === 'string') {\n      const currencyGroupSymbol = new RegExp(`\\\\${this.localeSeparatorSymbols[1]}`, 'g');\n      const whole: string = int.replace(currencyGroupSymbol, '');\n      const dec: string = this.decControl.value || '0';\n      const newAmount = whole + (dec !== '0' ? '.' + dec : '');\n      this.onChange({\n        currency: this.currency,\n        amount: newAmount,\n      });\n    } else {\n      const whole: number = parseInt(int.replace(/[^-\\d]/g, ''), 10);\n      const dec = parseFloat('0.' + this.decControl.value) || 0;\n      const sign = whole < 0 ? -1 : 1;\n      const newAmount = (Math.abs(whole) + dec) * sign;\n      this.onChange({\n        currency: this.currency,\n        amount: newAmount,\n      });\n    }\n  }\n\n  checkNumeric(numeric: any): string {\n    // Removed all dashes except the first one.\n    if (numeric.length > 0) {\n      numeric = numeric[0] + numeric.slice(1).replace(/-/g, '');\n    }\n\n    numeric = this.sanitizeNumericValue(numeric);\n\n    return numeric === '' ? numeric : new BigNumber(numeric || 0).toFormat();\n  }\n\n  /**\n   * Formats integer to user-friendly format.\n   *\n   * @returns Returns true in case of successful formatting, otherwise - false.\n   */\n  formatInteger(): boolean {\n    // The behavior of `formatInteger` is dependent on some component inputs,\n    // so don't format anything until the configuration is available.\n\n    if (!this.initialized || !this.intEl) {\n      return false;\n    }\n    if (!this.intControl.value) {\n      this.intControl.setValue('');\n\n      return true;\n    }\n    const offset = this.intEl.nativeElement.selectionStart - this.intControl.value.length;\n\n    const numeric: string = this.intControl.value.replace(this.allowNegativeValue ? /[^-\\d]/g : /\\D/g, '');\n    if (numeric === '-') {\n      this.intControl.setValue('-', { emitEvent: false });\n\n      return false;\n    }\n    const newVal = this.checkNumeric(numeric);\n    // Extend maxlength (if set) with the amount of special chars.\n    if (this.intMaxLen) {\n      const specialCount = newVal.replace(/\\d/g, '').length;\n      this.intEl.nativeElement.setAttribute('maxlength', '' + (this.intMaxLen + specialCount));\n    }\n\n    this.intControl.setValue(newVal);\n    const newLen = this.intControl.value.length;\n    const newPos = Math.max(offset + newLen, 0);\n    if (newLen > 0 && document.activeElement === this.intEl.nativeElement) {\n      this.intEl.nativeElement.selectionStart = newPos;\n      this.intEl.nativeElement.selectionEnd = newPos;\n    }\n\n    return true;\n  }\n\n  /**\n   * Event handler for backspace key press, and check if correct number is deleted.\n   */\n  onBackspace(el: HTMLInputElement) {\n    if (el.selectionStart) {\n      const selectionStartPosition = el.selectionStart - 1;\n      const value = el.value[selectionStartPosition];\n\n      if (this.localeSeparatorSymbols.includes(value)) {\n        el.setSelectionRange(selectionStartPosition, selectionStartPosition);\n      }\n    }\n  }\n\n  // method is used to correct rendered input's value if user entered '-' and left the field\n  correctInputValue($event: FocusEvent) {\n    this.markAsTouched($event);\n    const numeric = this.intControl.value;\n    if (numeric !== '-') {\n      return;\n    }\n    this.intControl.setValue('', { emitEvent: false });\n  }\n\n  writeValue(model: any | null): void {\n    if (!model) {\n      return;\n    }\n    // currency cannot be set to nothing\n    if (model.currency) {\n      this.currency = model.currency;\n      this.currControl.setValue(model.currency);\n    }\n\n    if (typeof model.amount === 'string' || typeof model.amount === 'number') {\n      const [whole, decimals] = ('' + model.amount).split('.');\n      this.intControl.setValue(whole);\n      this.decControl.setValue(decimals);\n    } else {\n      this.intControl.setValue('');\n      this.decControl.setValue('');\n    }\n\n    this.formatInteger();\n  }\n\n  registerOnChange(fn: () => void): void {\n    this.onChange = fn;\n  }\n\n  registerOnTouched(fn: () => void): void {\n    this.onTouched = fn;\n  }\n\n  markAsTouched($event: FocusEvent) {\n    this.blur.emit($event);\n    this.onTouched();\n  }\n\n  protected setDisabled(disableState: CurrencyFieldsState) {\n    if (disableState.currency) {\n      this.currControl.disable();\n    } else {\n      this.currControl.enable();\n    }\n    if (disableState.integer) {\n      this.intControl.disable();\n    } else {\n      this.intControl.enable();\n    }\n    if (disableState.decimal) {\n      this.decControl.disable();\n    } else {\n      this.decControl.enable();\n    }\n  }\n\n  private focusDecEl(key: string): void {\n    if (this.decEl && ['.', ','].indexOf(key) !== -1) {\n      this.decEl.nativeElement.focus();\n    }\n  }\n\n  /**\n   * Make sure that numeric value doesn't exceed max length (if set)\n   * this might happen in case value is pasted to input that has extended max length\n   *\n   * @param numeric\n   */\n  private sanitizeNumericValue(numeric: string): string {\n    if (this.intMaxLen && numeric) {\n      return numeric.slice(0, this.intMaxLen);\n    }\n\n    return numeric;\n  }\n\n  /**\n   * If currency doesn't have decimal part, decimal placeholder\n   * will be set to default decMinLen\n   */\n  private getDecimalDigits(currency: string) {\n    return getNumberOfCurrencyDigits(currency) === 0 ? this.decMinLen : getNumberOfCurrencyDigits(currency);\n  }\n\n  private sanitizeValidation() {\n    combineLatest([\n      this.intControl.valueChanges.pipe(startWith(null)),\n      this.decControl.valueChanges.pipe(startWith(null)),\n    ])\n      .pipe(\n        skip(1),\n        filter(() => this.required),\n        takeUntil(this.destroy$),\n      )\n      .subscribe(([intValue, decValue]) => {\n        if (!intValue && !!decValue) {\n          const errors = { ...(this.intControl.errors ?? {}) };\n          delete errors.required;\n\n          this.intControl.setErrors(!!Object.keys(errors).length ? errors : null);\n        }\n\n        if (!!intValue && !decValue) {\n          const errors = { ...(this.decControl.errors ?? {}) };\n          delete errors.required;\n\n          this.decControl.setErrors(!!Object.keys(errors).length ? errors : null);\n        }\n      });\n  }\n}\n",
      properties: [
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 31,
        },
        {
          name: 'decimal',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 33,
        },
        {
          name: 'integer',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 32,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'CurrencyInputConfig',
      id: 'interface-CurrencyInputConfig-04809e0d720e8bfec82e3a9564ab0e387af5473269731c2acef3bc395e54dcc1baec98d2ad7b05efc4530ea79476c8633ee6c8f8c439613eb16ffe4b33e1cb57',
      file: 'libs/ui-ang/currency-input/currency-input.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface CurrencyInputConfig {\n  currencies?: string[];\n  placeholder?: string;\n  allowNegativeValue?: boolean;\n}\n\nexport const CURRENCY_INPUT_CONFIG_TOKEN = new InjectionToken<CurrencyInputConfig>('CURRENCY_INPUT_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'allowNegativeValue',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
        {
          name: 'currencies',
          deprecated: false,
          deprecationMessage: '',
          type: 'string[]',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'placeholder',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'DatePipeConfig',
      id: 'interface-DatePipeConfig-1c2809735b9edadbf55e1bef7deb2d691b58760ca1ebfb4adc4850e547ac3c0409af34c9181d36abf5e10721198ba83e3f137a92fe4edda3c4764f9ecb1c76aa',
      file: 'libs/ui-ang/date-pipe/date-format-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport enum DateFormat {\n  short = 'short',\n  medium = 'medium',\n  long = 'long',\n  full = 'full',\n  shortDate = 'shortDate',\n  mediumDate = 'mediumDate',\n  longDate = 'longDate',\n  fullDate = 'fullDate',\n  shortTime = 'shortTime',\n  mediumTime = 'mediumTime',\n  longTime = 'longTime',\n  fullTime = 'fullTime',\n}\n\nexport interface DatePipeConfig {\n  format: DateFormat | string;\n}\n\nexport const DATE_PIPE_CONFIG = new InjectionToken<DatePipeConfig>('DATE_FORMAT_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'format',
          deprecated: false,
          deprecationMessage: '',
          type: 'DateFormat | string',
          indexKey: '',
          optional: false,
          description: '',
          line: 19,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'DateRangeModel',
      id: 'interface-DateRangeModel-bb7a545a7762882f30a880ecea0642f0d51eeb13a1b5b1b095d333495aa7ed6b4796c601692bf42d17191791ebcff98ba65b042becc9bce175c4cf7e0b2bc89e',
      file: 'libs/ui-ang/input-datepicker/input-datepicker.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';\n\nexport const INVALID_DATE_FORMAT_KEY = 'invalidDateFormat';\n\nexport type NgDateStructNullable = NgbDateStruct | null;\n\nexport interface DateSelectionModel {\n  date: NgDateStructNullable;\n  isSelecting?: boolean;\n}\n\nexport interface DateRangeSelectionModel extends DateSelectionModel {\n  isTo: boolean;\n}\n\nexport interface DateRangeModel {\n  from: string;\n  to: string;\n}\n\nexport interface RangeSelectModel {\n  from: NgDateStructNullable;\n  to: NgDateStructNullable;\n  closeDatePicker: boolean;\n}\n",
      properties: [
        {
          name: 'from',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 17,
        },
        {
          name: 'to',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 18,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'DateRangeSelectionModel',
      id: 'interface-DateRangeSelectionModel-bb7a545a7762882f30a880ecea0642f0d51eeb13a1b5b1b095d333495aa7ed6b4796c601692bf42d17191791ebcff98ba65b042becc9bce175c4cf7e0b2bc89e',
      file: 'libs/ui-ang/input-datepicker/input-datepicker.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';\n\nexport const INVALID_DATE_FORMAT_KEY = 'invalidDateFormat';\n\nexport type NgDateStructNullable = NgbDateStruct | null;\n\nexport interface DateSelectionModel {\n  date: NgDateStructNullable;\n  isSelecting?: boolean;\n}\n\nexport interface DateRangeSelectionModel extends DateSelectionModel {\n  isTo: boolean;\n}\n\nexport interface DateRangeModel {\n  from: string;\n  to: string;\n}\n\nexport interface RangeSelectModel {\n  from: NgDateStructNullable;\n  to: NgDateStructNullable;\n  closeDatePicker: boolean;\n}\n",
      properties: [
        {
          name: 'isTo',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 13,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: ['DateSelectionModel'],
    },
    {
      name: 'DateSelectionModel',
      id: 'interface-DateSelectionModel-bb7a545a7762882f30a880ecea0642f0d51eeb13a1b5b1b095d333495aa7ed6b4796c601692bf42d17191791ebcff98ba65b042becc9bce175c4cf7e0b2bc89e',
      file: 'libs/ui-ang/input-datepicker/input-datepicker.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';\n\nexport const INVALID_DATE_FORMAT_KEY = 'invalidDateFormat';\n\nexport type NgDateStructNullable = NgbDateStruct | null;\n\nexport interface DateSelectionModel {\n  date: NgDateStructNullable;\n  isSelecting?: boolean;\n}\n\nexport interface DateRangeSelectionModel extends DateSelectionModel {\n  isTo: boolean;\n}\n\nexport interface DateRangeModel {\n  from: string;\n  to: string;\n}\n\nexport interface RangeSelectModel {\n  from: NgDateStructNullable;\n  to: NgDateStructNullable;\n  closeDatePicker: boolean;\n}\n",
      properties: [
        {
          name: 'date',
          deprecated: false,
          deprecationMessage: '',
          type: 'NgDateStructNullable',
          indexKey: '',
          optional: false,
          description: '',
          line: 8,
        },
        {
          name: 'isSelecting',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 9,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'DropdownItem',
      id: 'interface-DropdownItem-8609dcef24f7336e89d5e5c96e4b07418bdaa3c0880c093ea8de5d33af42a0329e846cefecb09705b2b96392a69280f6f895473cb6a9d1d13700c5d876a2918a',
      file: 'libs/ui-ang-examples/src/configuration/configuration-input.service.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Injectable } from '@angular/core';\nimport { Subject } from 'rxjs';\n\n@Injectable()\nexport class ConfigurationInputService {\n  sharedField = new Subject();\n}\nexport interface RadioItem {\n  label: string;\n  value: boolean | string;\n}\n\nexport type CheckboxItem = RadioItem & {\n  formControlName: string;\n};\nexport type CheckboxList = Array<CheckboxItem>;\n\nexport interface RadioGroup {\n  label: string;\n  formControlName: string;\n  radioItems: RadioItem[];\n}\n\nexport type RadioGroupList = Array<RadioGroup>;\n\nexport type InputList = Array<InputItem>;\n\nexport interface DropdownItem {\n  label: string;\n  formControlName: string;\n  dropdownItemList: string[];\n}\n\nexport interface InputItem {\n  label: string;\n  formControlName: string;\n  value: string;\n}\n\nexport type DropdownList = Array<DropdownItem>;\n",
      properties: [
        {
          name: 'dropdownItemList',
          deprecated: false,
          deprecationMessage: '',
          type: 'string[]',
          indexKey: '',
          optional: false,
          description: '',
          line: 31,
        },
        {
          name: 'formControlName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 30,
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 29,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'DsConfig',
      id: 'interface-DsConfig-1acca70c1182cfdbae63f5e155ca6ce28f4261b0895e4e661dfc727595d60a65185e50db3bc502e8b804a14a330553fc417a4a9a4902389d685ead0f3f1fbc01',
      file: 'libs/ds-toolkit/src/ds-toolkit.module.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ModuleWithProviders, NgModule } from '@angular/core';\nimport { CommonModule } from '@angular/common';\n\nimport { AlertModule } from '@backbase/ui-ang/alert';\nimport { IconModule } from '@backbase/ui-ang/icon';\nimport { CollapsibleAccordionModule } from '@backbase/ui-ang/collapsible-accordion';\nimport { CollapsibleCardModule } from '@backbase/ui-ang/collapsible-card';\n\nimport { ShowcaseApiComponent } from './showcase/api/showcase-api.component';\nimport { ShowcaseScssTokensComponent } from './showcase/scss-tokens/showcase-scss-tokens.component';\nimport { ShowcaseDescriptionComponent } from './showcase/description/showcase-description.component';\nimport { ShowcaseExampleTemplateComponent } from './showcase/example-template/showcase-example-template.component';\nimport { ShowcaseMethodsComponent } from './showcase/methods/showcase-methods.component';\nimport { ShowcaseSelectorComponent } from './showcase/selector/showcase-selector.component';\nimport { ShowcaseUsageComponent } from './showcase/usage/showcase-usage.component';\nimport { ShowcaseComponent } from './showcase.component';\nimport { MetadataService } from './metadata.service';\n\nexport interface BbDsDocs {\n  components?: any;\n  directives?: any;\n  pipes?: any;\n  interfaces?: any;\n}\n\nexport interface DsConfig {\n  lib: any;\n  exampleLib?: any;\n  showcaseLib?: any;\n  docs: BbDsDocs;\n}\n\nconst components = [\n  ShowcaseScssTokensComponent,\n  ShowcaseApiComponent,\n  ShowcaseDescriptionComponent,\n  ShowcaseExampleTemplateComponent,\n  ShowcaseMethodsComponent,\n  ShowcaseSelectorComponent,\n  ShowcaseUsageComponent,\n  ShowcaseComponent,\n];\n\n/**\n * DynamicDsToolkitModule can be removed in favor of\n * importing the modules (BacbaseUiModule, BackbaseExamplesUiModule)\n * in the app level because this will kill AOT and/or build-optimization\n */\n@NgModule({\n  imports: [CommonModule, IconModule, CollapsibleAccordionModule, CollapsibleCardModule, AlertModule],\n  declarations: [...components],\n  providers: [MetadataService],\n  exports: [...components],\n})\nexport class DsToolkitModule {\n  static forRoot(config: DsConfig): ModuleWithProviders<DsToolkitModule> {\n    // @NgModule({\n    //   imports: [\n    //     CommonModule,\n    //     IconModule,\n    //     CollapsibleAccordionModule,\n    //     CollapsibleCardModule,\n    //     config.exampleLib,\n    //     config.lib,\n    //   ],\n    //   declarations: [...components],\n    //   exports: [...components],\n    // })\n    // class DynamicDsToolkitModule {}\n    return {\n      ngModule: DsToolkitModule,\n      providers: [MetadataService, { provide: 'config', useValue: config }],\n    };\n  }\n}\n\nexport {\n  ShowcaseScssTokensComponent,\n  ShowcaseApiComponent,\n  ShowcaseDescriptionComponent,\n  ShowcaseExampleTemplateComponent,\n  ShowcaseMethodsComponent,\n  ShowcaseSelectorComponent,\n  ShowcaseUsageComponent,\n  ShowcaseComponent,\n};\n",
      properties: [
        {
          name: 'docs',
          deprecated: false,
          deprecationMessage: '',
          type: 'BbDsDocs',
          indexKey: '',
          optional: false,
          description: '',
          line: 30,
        },
        {
          name: 'exampleLib',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '',
          line: 28,
        },
        {
          name: 'lib',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: false,
          description: '',
          line: 27,
        },
        {
          name: 'showcaseLib',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '',
          line: 29,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Eta',
      id: 'interface-Eta-fbb0bc82495cf226c9d4164f155cc52e019228be1a6c4520838a45e784ec2b63fcf17f7c7ad04ef9098b6f1071cd582657a0aa6e08b0f16d1ad26a1d9d6e1295',
      file: 'libs/ui-ang/progress-tracker/progress-tracker.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface IProgressTrackerConfig {\n  payload: IEventPayload;\n  id: string;\n  eventStatus: EventStatus;\n}\n\nexport interface IEventPayload {\n  eta: Eta;\n  progressStartTime: number;\n  current: number;\n  size: number;\n  name: string;\n  actionType: EventType;\n  itemId: string;\n}\n\nexport enum EventStatus {\n  IN_PROGRESS,\n  COMPLETED,\n  CANCELLED,\n  TIME_OUT,\n}\n\nexport enum EventType {\n  FILE_UPLOAD,\n}\n\nexport interface Eta {\n  hours: number;\n  mins: number;\n  secs: number;\n}\n',
      properties: [
        {
          name: 'hours',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 29,
        },
        {
          name: 'mins',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 30,
        },
        {
          name: 'secs',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 31,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ExpandRevealConfig',
      id: 'interface-ExpandRevealConfig-7c5a00cd6549ea9fa405614942171379f99ecbb461715fd6af3bcfb82475c54e93485b2a116eabc58f198c697a11d3276f1de6635c77a0d37432e8fd3f3b0ab0',
      file: 'libs/ui-ang/animations/types/config-types.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { TranslationAxis, TranslationDirectionType, TranslationDirectionValue } from './translation';\n\nexport interface InJourneyConfig {\n  animationAlias: string;\n  translationDirectionType: TranslationDirectionType;\n  translationAxis: TranslationAxis;\n  translationDirection: TranslationDirectionValue;\n  // enableLeaveGroups: with leave groups enabled the view can decide wether if it wants elements leave from\n  // top or bottom by using a class\n  enableLeaveGroups: boolean;\n  disableAnimation: boolean;\n}\n\nexport interface CrossJourneyConfig {\n  animationAlias: string;\n  disableAnimation: boolean;\n  fadeInOutSelector: string;\n  enableGroups: boolean;\n  enterDelay: string;\n  routerContainerSelector: string;\n}\n\nexport interface ExpandRevealConfig {\n  animationAlias: string;\n  disableAnimation: boolean;\n  contentSelector: string;\n  containerSelector: string;\n  expandStyle: ExpandRevealStyle;\n}\n\nexport enum ExpandRevealStyle {\n  SEQUENCED = 'SEQUENCED_EXPAND',\n  STAGGERED = 'STAGGERED_EXPAND',\n}\n",
      properties: [
        {
          name: 'animationAlias',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 24,
        },
        {
          name: 'containerSelector',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 27,
        },
        {
          name: 'contentSelector',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 26,
        },
        {
          name: 'disableAnimation',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 25,
        },
        {
          name: 'expandStyle',
          deprecated: false,
          deprecationMessage: '',
          type: 'ExpandRevealStyle',
          indexKey: '',
          optional: false,
          description: '',
          line: 28,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ExtractedTestCase',
      id: 'interface-ExtractedTestCase-b86499464611e9c53a8431adccf5dbf3a65a42de30bd04cc805a7b7155731ef4e0d8de34a03cfa775948c2ec43db03c0ccd9956cdd4b488a63d7019622853e7b',
      file: 'tools/scripts/ds-eslint/generate-rule-docs.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import type { TSESLint } from '@typescript-eslint/utils';\nimport { readdirSync, readFileSync, writeFileSync } from 'fs';\nimport { compile } from 'json-schema-to-typescript';\nimport traverse from 'json-schema-traverse';\nimport { join, relative } from 'path';\nimport { format, resolveConfig } from 'prettier';\nimport ts from 'typescript';\n\nconst SPECIAL_UNDERLINE_CHARS = ['~', '^', '#', '%', '¶', '*', '¨', '@'];\n\nconst docsOutputDir = join(__dirname, `../../../libs/eslint-plugin-design-system/docs/rules`);\n\nconst rulesDir = join(__dirname, `../../../libs/eslint-plugin-design-system/src/rules`);\nconst ruleFiles = readdirSync(rulesDir);\n\nconst testDirsDir = join(__dirname, `../../../libs/eslint-plugin-design-system/src/rules`);\nconst testDirs = readdirSync(testDirsDir);\n\n(async function main() {\n  const allRuleData = await generateAllRuleData();\n\n  for (const [ruleName, ruleData] of Object.entries(allRuleData)) {\n    const {\n      ruleConfig: {\n        meta: { deprecated, replacedBy, type, fixable, schema, hasSuggestions },\n        defaultOptions,\n      },\n      docsExtension,\n      ruleFilePath,\n      testCasesFilePath,\n    } = ruleData;\n\n    const docs = ruleData.ruleConfig.meta.docs as TSESLint.RuleMetaDataDocs<[]>;\n    const { description } = docs;\n\n    let schemaAsInterface = '';\n    if (Array.isArray(schema) && schema[0]) {\n      /**\n       * json-schema-to-typescript does not do anything with the \"default\" property,\n       * but it's really useful to include in the documentation, so we apply the\n       * default value in a consistent way to the \"description\" property before\n       * converting.\n       */\n      traverse(schema[0], {\n        allKeys: true,\n        cb: (...data) => {\n          const [schemaNode, , , , , , keyIndex] = data;\n\n          let defaultValue = null;\n\n          if (typeof schemaNode.default !== 'undefined') {\n            defaultValue = schemaNode.default;\n          } else if (defaultOptions?.length) {\n            for (const defaultOption of defaultOptions) {\n              const defaultValueForNode = defaultOption[keyIndex as string];\n              if (defaultValueForNode) {\n                defaultValue = defaultValueForNode;\n              }\n            }\n          }\n\n          if (defaultValue) {\n            if (schemaNode.description) {\n              schemaNode.description += '\\n\\n';\n            } else {\n              schemaNode.description = '';\n            }\n            const serializedDefaultValue = JSON.stringify(defaultValue);\n            schemaNode.description += `Default: \\`${serializedDefaultValue}\\``;\n\n            return;\n          }\n        },\n      });\n      schemaAsInterface = await compile(schema[0], 'Options', {\n        bannerComment: '',\n      });\n      schemaAsInterface = schemaAsInterface.replace('export ', '');\n    }\n\n    const fullRuleName = `@backbase/design-system/${ruleName}`;\n\n    const md = `\n<!--\n\n  DO NOT EDIT.\n\n  This markdown file was autogenerated using a mixture of the following files as the source of truth for its data:\n  - ${relativePath(docsOutputDir, ruleFilePath)}\n  - ${relativePath(docsOutputDir, testCasesFilePath)}\n\n  In order to update this file, it is therefore those files which need to be updated,\n  as well as potentially the generator script:\n  - ${relativePath(docsOutputDir, __filename)}\n\n-->\n\n<br>\n\n# \\`${fullRuleName}\\`\n\n${\n  deprecated\n    ? `## ⚠️ THIS RULE IS DEPRECATED\\n\\nPlease use ${(replacedBy || [])\n        .map((r: string) => `\\`@backbase/design-system/${r}\\``)\n        .join(', ')} instead.\\n\\n---\\n\\n`\n    : ''\n}${description}\n\n- Type: ${type}\n${fixable === 'code' ? '- 🔧 Supports autofix (`--fix`)\\n' : ''}\n${\n  hasSuggestions\n    ? '- 💡 Provides suggestions on how to fix issues (https://eslint.org/docs/developer-guide/working-with-rules#providing-suggestions)'\n    : ''\n}${\n      docsExtension?.rationale\n        ? `\n\n<br>\n\n## Rationale\n\n${docsExtension.rationale}\n`\n        : ''\n    }\n\n<br>\n\n## Rule Options\n\n${\n  schemaAsInterface\n    ? `\nThe rule accepts an options object with the following properties:\n\n\\`\\`\\`ts\n${schemaAsInterface}\n\\`\\`\\`\n`\n    : 'The rule does not have any configuration options.'\n}\n\n<br>\n\n## Usage Examples\n\n> The following examples are generated automatically from the actual unit tests within the plugin,\n so you can be assured that their behavior is accurate based on the current commit.\n\n<br>\n\n<details>\n<summary>❌ - Toggle examples of <strong>incorrect</strong> code for this rule</summary>\n\n${convertCodeExamplesToMarkdown(ruleData.invalid, 'invalid', 'html', fullRuleName)}\n\n</details>\n\n<br>\n\n---\n\n<br>\n\n<details>\n<summary>✅ - Toggle examples of <strong>correct</strong> code for this rule</summary>\n\n${convertCodeExamplesToMarkdown(ruleData.valid, 'valid', 'html', fullRuleName)}\n\n</details>\n\n<br>\n`;\n\n    const outputFilePath = join(docsOutputDir, `${ruleName}.md`);\n    writeFileSync(\n      outputFilePath,\n      await format(md, {\n        ...(await resolveConfig(outputFilePath)),\n        parser: 'markdown',\n      }),\n    );\n  }\n\n  console.log(`\\n✨ Updated docs for all rules in \"@backbase/design-system\"`);\n})();\n\ninterface RuleData {\n  ruleFilePath: string;\n  testCasesFilePath: string;\n  ruleConfig: TSESLint.RuleModule<string, []> & {\n    defaultOptions?: Record<string, unknown>[];\n  };\n  // Rules can optionally export extended documentation content (outside of ESLint's concept of \"docs\")\n  docsExtension?: {\n    rationale?: string;\n  };\n  valid: ExtractedTestCase[];\n  invalid: ExtractedTestCase[];\n}\n\ninterface AllRuleData {\n  [ruleName: string]: RuleData;\n}\n\ninterface ExtractedTestCase {\n  code: string;\n  options?: unknown[];\n}\n\nasync function generateAllRuleData(): Promise<AllRuleData> {\n  const ruleData: AllRuleData = {};\n\n  // For rule sources we just import/execute the rule source file\n  for (const ruleFile of ruleFiles) {\n    if (ruleFile.endsWith('.spec.ts')) {\n      continue;\n    }\n\n    const ruleFilePath = join(rulesDir, ruleFile.replace('.ts', ''));\n    const {\n      default: ruleConfig,\n      RULE_NAME,\n      RULE_DOCS_EXTENSION,\n      // eslint-disable-next-line @typescript-eslint/no-var-requires\n    } = require(ruleFilePath);\n    ruleData[RULE_NAME] = {\n      ruleConfig,\n      ruleFilePath: ruleFilePath + '.ts',\n      docsExtension: RULE_DOCS_EXTENSION,\n    } as RuleData;\n  }\n\n  /**\n   * For tests we want to preserve the annotated sources, so we do NOT want\n   * to execute the file and instead need to parse it using the ts compiler.\n   */\n  for (const testDir of testDirs) {\n    if (testDir.endsWith('.spec.ts')) {\n      continue;\n    }\n\n    const ruleFilePath = join(rulesDir, testDir.replace('.ts', ''));\n    const {\n      RULE_NAME,\n      // eslint-disable-next-line @typescript-eslint/no-var-requires\n    } = require(ruleFilePath);\n\n    const testDirPath = join(testDirsDir, testDir);\n    const casesFilePath = testDirPath.replace(/.ts$/, '.spec.ts');\n    const testCasesContents = readFileSync(casesFilePath, 'utf-8');\n    const casesSourceFile = ts.createSourceFile(casesFilePath, testCasesContents, ts.ScriptTarget.Latest, true);\n\n    const extractedValid: ExtractedTestCase[] = [];\n    const extractedInvalid: ExtractedTestCase[] = [];\n\n    const extractNodes = (node: ts.Node) => {\n      if (\n        ts.isVariableDeclaration(node) &&\n        node.name.getText() === 'valid' &&\n        node.initializer &&\n        ts.isArrayLiteralExpression(node.initializer)\n      ) {\n        node.initializer.elements.forEach((el) => {\n          const newExtractedTestCase: ExtractedTestCase = {\n            code: '',\n          };\n\n          if (ts.isStringLiteralLike(el)) {\n            newExtractedTestCase.code = el.text;\n          }\n\n          if (ts.isObjectLiteralExpression(el)) {\n            el.properties.forEach((prop) => {\n              if (ts.isPropertyAssignment(prop) && prop.name.getText() === 'code') {\n                if (ts.isNoSubstitutionTemplateLiteral(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.rawText || prop.initializer.text;\n                }\n                if (ts.isTemplateExpression(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.getText();\n                }\n                if (ts.isStringLiteral(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.text;\n                }\n              }\n\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'options' &&\n                ts.isArrayLiteralExpression(prop.initializer)\n              ) {\n                newExtractedTestCase.options = convertArrayLiteralExpressionToCode(prop.initializer);\n              }\n            });\n          }\n\n          if (newExtractedTestCase.code) {\n            extractedValid.push(newExtractedTestCase);\n          }\n        });\n      }\n\n      if (\n        ts.isVariableDeclaration(node) &&\n        node.name.getText() === 'invalid' &&\n        node.initializer &&\n        ts.isArrayLiteralExpression(node.initializer)\n      ) {\n        node.initializer.elements.forEach((el) => {\n          if (ts.isCallExpression(el) && el.expression.getText() === 'convertAnnotatedSourceToFailureCase') {\n            const newExtractedTestCase: ExtractedTestCase = {\n              code: '',\n            };\n\n            const config = el.arguments[0] as ts.ObjectLiteralExpression;\n            config.properties.forEach((prop) => {\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'annotatedSource' &&\n                ts.isNoSubstitutionTemplateLiteral(prop.initializer)\n              ) {\n                newExtractedTestCase.code = prop.initializer.text;\n              }\n\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'options' &&\n                ts.isArrayLiteralExpression(prop.initializer)\n              ) {\n                newExtractedTestCase.options = convertArrayLiteralExpressionToCode(prop.initializer);\n              }\n            });\n\n            if (newExtractedTestCase.code) {\n              extractedInvalid.push(newExtractedTestCase);\n            }\n          }\n        });\n      }\n\n      ts.forEachChild(node, extractNodes);\n    };\n\n    // Extract valid and invalid cases as strings\n    extractNodes(casesSourceFile);\n\n    ruleData[RULE_NAME] = {\n      ...ruleData[RULE_NAME],\n      testCasesFilePath: casesFilePath,\n      valid: extractedValid,\n      invalid: extractedInvalid,\n    };\n  }\n\n  return ruleData;\n}\n\nfunction standardizeSpecialUnderlineChar(str: string): string {\n  /**\n   * It is important that we only update special characters when we are on a line\n   * which only has special characters on it (as well as whitespace). Otherwise\n   * we will end up replacing real characters from the source code in the example.\n   */\n  const specialCharsOrWhitespaceRegExp = new RegExp(`^(${SPECIAL_UNDERLINE_CHARS.map(escapeRegExp).join('|')}|\\\\s)+$`);\n  const whitespaceOnlyRegExp = /^\\s+$/;\n\n  return str\n    .split('\\n')\n    .map((line) => {\n      // Is line with exclusively special characters and whitespace (but not just whitespace)?\n      if (!line.match(whitespaceOnlyRegExp) && line.match(specialCharsOrWhitespaceRegExp)) {\n        return line\n          .split('')\n          .map((char) =>\n            SPECIAL_UNDERLINE_CHARS.includes(char as (typeof SPECIAL_UNDERLINE_CHARS)[number]) ? '~' : char,\n          )\n          .join('');\n      }\n\n      return line;\n    })\n    .join('\\n');\n}\n\n// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping\nfunction escapeRegExp(str: string) {\n  return str.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&'); // $& means the whole matched string\n}\n\nfunction convertCodeExamplesToMarkdown(\n  codeExamples: ExtractedTestCase[] = [],\n  kind: 'valid' | 'invalid',\n  highligher: 'html' | 'ts',\n  ruleName: string,\n): string {\n  return codeExamples\n    .map(({ code, options }, i) => {\n      let formattedCode = removeLeadingAndTrailingEmptyLinesFromCodeExample(\n        removeLeadingIndentationFromCodeExample(code),\n      );\n      if (kind === 'invalid') {\n        formattedCode = standardizeSpecialUnderlineChar(formattedCode);\n      }\n\n      const exampleRuleConfig: unknown[] = ['error'];\n      // Not all unit tests have options configured\n      if (options) {\n        exampleRuleConfig.push(options[0]);\n      }\n      const formattedConfig = JSON.stringify(\n        {\n          rules: {\n            [ruleName]: exampleRuleConfig,\n          },\n        },\n        null,\n        2,\n      );\n\n      return `<br>\n\n#### ${options ? 'Custom' : 'Default'} Config\n\n\\`\\`\\`json\n${formattedConfig}\n\\`\\`\\`\n\n<br>\n\n#### ${kind === 'invalid' ? '❌ Invalid' : '✅ Valid'} Code\n\n\\`\\`\\`${highligher}\n${formattedCode}\n\\`\\`\\`\n\n${\n  i === codeExamples.length - 1\n    ? ''\n    : `<br>\n\n---`\n}\n  `;\n    })\n    .join('\\n');\n}\n\nfunction removeLeadingAndTrailingEmptyLinesFromCodeExample(code: string): string {\n  const lines = code.split('\\n');\n\n  let currentLineIndex = 0;\n  let firstNonEmptyLineIndex = -1;\n  let lastNonEmptyLineIndex = -1;\n\n  for (const line of lines) {\n    if (/\\S/.test(line)) {\n      if (firstNonEmptyLineIndex === -1) {\n        firstNonEmptyLineIndex = currentLineIndex;\n      }\n      lastNonEmptyLineIndex = currentLineIndex;\n    }\n    currentLineIndex++;\n  }\n\n  return lines\n    .filter((_, index) => {\n      if (index < firstNonEmptyLineIndex) {\n        return false;\n      }\n      if (index > lastNonEmptyLineIndex) {\n        return false;\n      }\n\n      return true;\n    })\n    .join('\\n');\n}\n\n/**\n * We want to remove unnecessary leading padding, but keeping everything relative,\n * so that code indentation is not messed up\n */\nfunction removeLeadingIndentationFromCodeExample(code: string): string {\n  let detectedAmountToTrim: number | null = null;\n\n  return code\n    .split('\\n')\n    .map((line) => {\n      // Is whitespace-only line, ignore\n      if (!/\\S/.test(line)) {\n        return line;\n      }\n\n      // Haven't yet determined the number of characters to trim from the beginning of each line\n      const charsInLine = line.split('');\n      if (typeof detectedAmountToTrim !== 'number') {\n        let numberOfLeadingWhitespaceChars = 0;\n        for (const char of charsInLine) {\n          if (!/\\S/.test(char)) {\n            numberOfLeadingWhitespaceChars++;\n            continue;\n          }\n          break;\n        }\n        detectedAmountToTrim = numberOfLeadingWhitespaceChars;\n      }\n\n      // Trim the detected number of characters from the beginning of the current line\n      return (\n        line\n          .split('')\n          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion\n          .filter((_, i) => !(i < detectedAmountToTrim!))\n          .join('')\n      );\n    })\n    .join('\\n');\n}\n\nfunction convertStringLikeToCode(strLike: ts.StringLiteralLike): string {\n  if (ts.isStringLiteralLike(strLike)) {\n    return strLike.text;\n  }\n\n  return '';\n}\n\nfunction convertNumericalLiteralToCode(numLiteral: ts.NumericLiteral): number {\n  return Number(numLiteral.text);\n}\n\nfunction convertBooleanLiteralToCode(booleanLiteral: ts.BooleanLiteral): boolean {\n  const stringified = booleanLiteral.getText();\n  if (stringified === 'false') {\n    return false;\n  }\n  if (stringified === 'true') {\n    return true;\n  }\n  throw new Error(`Could not convert booleanLiteral node to code: ${booleanLiteral}`);\n}\n\nfunction convertArrayLiteralExpressionToCode(arrExpr: ts.ArrayLiteralExpression): unknown[] {\n  const arr: unknown[] = [];\n  arrExpr.elements.forEach((el) => {\n    if (ts.isObjectLiteralExpression(el)) {\n      const item = convertObjectLiteralExpressionToCode(el);\n      arr.push(item);\n    }\n    if (ts.isStringLiteralLike(el)) {\n      const item = convertStringLikeToCode(el);\n      arr.push(item);\n    }\n    if (ts.isArrayLiteralExpression(el)) {\n      const item = convertArrayLiteralExpressionToCode(el);\n      arr.push(item);\n    }\n  });\n\n  return arr;\n}\n\nfunction convertObjectLiteralExpressionToCode(objExpr: ts.ObjectLiteralExpression): Record<string, unknown> {\n  const obj: Record<string, unknown> = {};\n  objExpr.properties.forEach((prop) => {\n    if (ts.isPropertyAssignment(prop)) {\n      const key = prop.name.getText();\n\n      let val;\n      if (ts.isObjectLiteralExpression(prop.initializer)) {\n        val = convertObjectLiteralExpressionToCode(prop.initializer);\n      }\n      if (ts.isStringLiteralLike(prop.initializer)) {\n        val = convertStringLikeToCode(prop.initializer);\n      }\n      if (ts.isArrayLiteralExpression(prop.initializer)) {\n        val = convertArrayLiteralExpressionToCode(prop.initializer);\n      }\n      if (ts.isNumericLiteral(prop.initializer)) {\n        val = convertNumericalLiteralToCode(prop.initializer);\n      }\n      if (prop.initializer.kind === ts.SyntaxKind.TrueKeyword || prop.initializer.kind === ts.SyntaxKind.FalseKeyword) {\n        val = convertBooleanLiteralToCode(prop.initializer as ts.BooleanLiteral);\n      }\n\n      if (key && typeof val !== 'undefined') {\n        obj[key] = val;\n      }\n    }\n  });\n\n  return obj;\n}\n\nfunction relativePath(from: string, to: string) {\n  // On Windows relative() outputs backslashes. As the path should always contain normal slashes, replace them.\n  return relative(from, to).replace(/\\\\/g, '/');\n}\n",
      properties: [
        {
          name: 'code',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 209,
        },
        {
          name: 'options',
          deprecated: false,
          deprecationMessage: '',
          type: '[]',
          indexKey: '',
          optional: true,
          description: '',
          line: 210,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'FileSize',
      id: 'interface-FileSize-6e6095916ce4ae542c4c13c957de3b4d63f13ba66b146fdc6b061ab80d06e8f6cb27a9db7ebd447755b134c98a342472bc9a55f9f3a2c3cbeeec3d02352a3d1c',
      file: 'libs/ui-ang/file-attachment/file-attachment.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  ChangeDetectionStrategy,\n  Component,\n  EventEmitter,\n  Inject,\n  Input,\n  OnInit,\n  Output,\n  Renderer2,\n} from '@angular/core';\nimport { DOCUMENT } from '@angular/common';\nimport { isObservable, Observable } from 'rxjs';\nimport { take } from 'rxjs/operators';\nimport { getDynamicId } from '@backbase/ui-ang/util';\n\nexport interface FileSize {\n  value: number;\n  unit: string;\n}\n\ndeclare global {\n  interface Navigator {\n    msSaveBlob?: (blob: any, defaultName?: string) => boolean;\n  }\n}\n\n/**\n * @name FileAttachmentComponent\n *\n * ### Accessibility\n * Current component provide option to pass needed accessibility\n * attributes:\n *  - id\n *  - aria-label\n *  - aria-describedby\n *\n * @description\n * Component displays file attachment.\n *\n * @dynamic (to suppress error with resolving statics declarations during compilation)\n */\n\n@Component({\n  selector: 'bb-file-attachment-ui',\n  templateUrl: './file-attachment.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class FileAttachmentComponent implements OnInit {\n  /**\n   * Set file name (required).\n   */\n  @Input()\n  get name(): string | undefined {\n    return this._name;\n  }\n  set name(value: string | undefined) {\n    if (value?.trim()) {\n      this._name = value;\n      this.fileType = this.getFileType(value);\n    } else {\n      throw new Error(`\"name\" input is invalid in \"${this.constructor.name}\"`);\n    }\n  }\n\n  /**\n   * Set file size (required). Accepts `number` or `string`.\n   */\n  @Input()\n  set size(value: number | string | undefined) {\n    if (value !== undefined) {\n      const valueAsNumber = Math.trunc(Number(value));\n\n      this._sizeInUnits = this.formatBytes(valueAsNumber, 2);\n    }\n  }\n\n  /**\n   * Get file size in information units (Bytes, Kbs, etc.).\n   */\n  get sizeInUnits() {\n    return this._sizeInUnits;\n  }\n\n  /**\n   * Set file content (required if disabled property is not set to true).\n   */\n  @Input()\n  get fileContent(): Observable<ArrayBuffer> | undefined {\n    return this._fileContent;\n  }\n  set fileContent(value: Observable<ArrayBuffer> | undefined) {\n    if (value && isObservable(value)) {\n      this._fileContent = value;\n    } else {\n      throw new Error(`\"fileContent\" stream input is invalid in \"${this.constructor.name}\"`);\n    }\n  }\n\n  /**\n   * Loading indicator flag. Defaults to false.\n   */\n  @Input() loading = false;\n\n  /**\n   * Show delete button flag. Defaults to false.\n   */\n  @Input() deletable = false;\n\n  /**\n   * Disabled state flag. Defaults to false.\n   */\n  @Input() disabled = false;\n\n  /**\n   * The flag to indicate whether the file-attachment should fill the container that it is in. Defaults to 'false'.\n   */\n  @Input() block = false;\n\n  /**\n   * Set aria-describedby  with an element id that contains a detailed decription of the widget.\n   */\n  @Input('aria-describedby') ariaDescribedby?: string = 'file-attachment-card-body';\n\n  /**\n   * The id for attachment card.\n   */\n  @Input('id') cardId?: string = 'file-attachment-card-body_' + getDynamicId();\n\n  /**\n   * Accessible label for delete button when control does not need to render label tag.\n   */\n  @Input('aria-label') ariaLabel?: string = 'Delete file';\n\n  /**\n   * Event emitted on delete button click.\n   */\n  @Output() delete = new EventEmitter<void>();\n\n  /**\n   * File type which is determined by file extension. Defaults to 'unknown'.\n   */\n  fileType = 'unknown';\n\n  private _sizeInUnits: FileSize | undefined;\n  private _name: string | undefined;\n  private _fileContent: Observable<ArrayBuffer> | undefined;\n\n  constructor(\n    @Inject(DOCUMENT) private readonly document: Document,\n    private readonly renderer: Renderer2,\n  ) {}\n\n  ngOnInit() {\n    if (!this._name) {\n      throw new Error(`\"name\" input is required in \"${this.constructor.name}\"`);\n    }\n\n    if (!this.disabled && !this._fileContent) {\n      throw new Error(`\"fileContent\" input is required in \"${this.constructor.name}\"`);\n    }\n  }\n\n  /**\n   * Download attachment method.\n   *\n   * @param $event Download button click event\n   */\n  onDownload($event: Event) {\n    $event.stopPropagation();\n\n    if (this.fileContent) {\n      this.fileContent.pipe(take(1)).subscribe({\n        next: (response: ArrayBuffer) => {\n          if (!this.document.defaultView) {\n            return;\n          }\n          const window = this.document.defaultView;\n          const blob = new window.Blob([response]);\n\n          if (window.navigator.msSaveBlob) {\n            window.navigator.msSaveBlob(blob, this.name);\n          } else {\n            const fileURL = window.URL.createObjectURL(blob);\n            const link = this.renderer.createElement('a');\n\n            link.setAttribute('href', fileURL);\n            link.setAttribute('target', '_blank');\n            link.setAttribute('download', this.name || '');\n            link.click();\n            URL.revokeObjectURL(fileURL);\n          }\n        },\n      });\n    }\n  }\n\n  /**\n   * Delete attachment event emitter.\n   *\n   * @param event Delete button click event.\n   */\n  onDelete(event: MouseEvent) {\n    event.stopPropagation();\n    this.delete.emit();\n  }\n\n  private getFileType(fileName: string): string {\n    return fileName.includes('.') ? fileName.toLowerCase().split('.').pop() || 'unknown' : 'unknown';\n  }\n\n  private formatBytes(bytes: number, decimals: number): FileSize {\n    if (bytes === 0) {\n      return {\n        value: 0,\n        unit: 'Bytes',\n      };\n    }\n\n    const k = 1024;\n    const dm = decimals <= 0 ? 0 : decimals || 2;\n    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];\n    const i = Math.floor(Math.log(bytes) / Math.log(k));\n\n    return {\n      value: parseFloat((bytes / Math.pow(k, i)).toFixed(dm)),\n      unit: sizes[i],\n    };\n  }\n}\n",
      properties: [
        {
          name: 'unit',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 18,
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 17,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Frequency',
      id: 'interface-Frequency-6b04e45972f78651dad0ec79ec4e0441b702867bb736750d12fe9b47f5a1ae7cb38dd49d749eba52be7de4885a88df6d27152174f1edcc2ba3efa14a8159a966',
      file: 'libs/ui-ang-examples/src/dropdown-single-select/examples/dropdown-single-select.example.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\ninterface Frequency {\n  value: string;\n  every: number;\n}\n\n@Component({\n  selector: 'bb-dropdown-single-select-example-ui',\n  templateUrl: './dropdown-single-select.example.component.html',\n  standalone: false,\n})\nexport class DropdownSingleSelectExampleComponent {\n  objectDropdownOptions = [\n    { title: 'DuckDuckGo', url: 'https://www.duckduckgo.com' },\n    { title: 'Google', url: 'https://google.com' },\n    { title: 'Yahoo', url: 'https://yahoo.com' },\n  ];\n\n  stringDropdownOptions = ['DuckDuckGo', 'Google', 'Yahoo'];\n\n  frequencies: Frequency[] = [\n    {\n      value: 'ONCE',\n      every: 1,\n    },\n    {\n      value: 'DAILY',\n      every: 1,\n    },\n    {\n      value: 'WEEKLY',\n      every: 1,\n    },\n    {\n      value: 'BIWEEKLY',\n      every: 1,\n    },\n    {\n      value: 'MONTHLY',\n      every: 1,\n    },\n    {\n      value: 'QUARTERLY',\n      every: 1,\n    },\n    {\n      value: 'YEARLY',\n      every: 1,\n    },\n  ];\n\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    websiteStrings: [\n      this.stringDropdownOptions[0],\n      Validators.required,\n    ],\n    websiteObjects: [\n      this.objectDropdownOptions[0],\n      Validators.required,\n    ],\n    frequency: [\n      {\n        value: 'ONCE',\n        every: 1,\n      },\n      Validators.required,\n    ],\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n\n  compareByValue(p1: Frequency, p2: Frequency) {\n    if (!p1 || !p2) return;\n\n    return p1.value === p2.value;\n  }\n}\n",
      properties: [
        {
          name: 'every',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Frequency',
      id: 'interface-Frequency-d3adb34835e8244b10e237df4095290cd76a401fe893752884e514009482d54e1cab2c368691f94cf29589b32c498fc565d03c4dc88ebc80d0c3f24af39c0971-1',
      file: 'libs/ui-ang-examples/src/dropdown-single-select/showcase/dropdown-single-select-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl } from '@angular/forms';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\n\ninterface Frequency {\n  value: string;\n  every: number;\n}\n\nconst frequencies = [\n  {\n    value: 'ONCE',\n    every: 1,\n  },\n  {\n    value: 'DAILY',\n    every: 1,\n  },\n  {\n    value: 'WEEKLY',\n    every: 1,\n  },\n  {\n    value: 'BIWEEKLY',\n    every: 1,\n  },\n  {\n    value: 'MONTHLY',\n    every: 1,\n  },\n  {\n    value: 'QUARTERLY',\n    every: 1,\n  },\n  {\n    value: 'YEARLY',\n    every: 1,\n  },\n];\n\n@Component({\n  selector: 'bb-dropdown-single-select-ui-showcase',\n  templateUrl: './dropdown-single-select-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class DropdownSingleSelectShowcaseComponent {\n  vForm: UntypedFormGroup | undefined;\n\n  stringDropdownOptions = ['Option One', 'Option Two', 'Option Three'];\n\n  objectDropdownOptions = [{ title: 'Option One' }, { title: 'Option Two' }, { title: 'Option Three' }];\n\n  frequencies = frequencies;\n\n  modelDropdownOptions = [\n    { model: { displayNames: ['Selection A'], value: 'A' } },\n    { model: { displayNames: ['Selection B'], value: 'B' } },\n    { model: { displayNames: ['Selection C'], value: 'C' } },\n  ];\n\n  assetClassesOptions = [\n    { name: 'Stock', id: 'stock' },\n    { name: 'Bond', id: 'bonds' },\n    { name: ' Liquid Assets', id: 'liquidassets' },\n    { name: 'Real Estate', id: 'realestate' },\n    { name: 'Cash', id: 'cash' },\n  ];\n\n  dropdownMenuOptions = [\n    { name: 'google', url: 'https://google.com' },\n    { name: 'twitter', url: 'https://twitter.com' },\n    { name: 'facebook', url: 'https://www.facebook.com' },\n  ];\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {\n    this.vForm = this.formBuilder.group({\n      stringDropdownOptions: [this.stringDropdownOptions[0], Validators.required],\n      objectDropdownOptions: [this.objectDropdownOptions[0], Validators.required],\n      modelSingleSelect: [undefined, Validators.required],\n      customSingleSelect: undefined,\n      frequency: [\n        {\n          value: 'ONCE',\n          every: 1,\n        },\n      ],\n      i18nSingleSelect: ['one'],\n      modelSingleSelectDisabled: [{ value: this.modelDropdownOptions[0], disabled: true }, Validators.required],\n    });\n  }\n\n  isFieldValid(fieldName: string): boolean | undefined {\n    const control = this.getControl(fieldName);\n    if (control) {\n      return control.valid || control.untouched;\n    }\n\n    return undefined;\n  }\n\n  private getControl(fieldName: string): AbstractControl | undefined {\n    if (this.vForm) {\n      return this.vForm.controls[fieldName];\n    }\n\n    return undefined;\n  }\n\n  compareByValue(p1: Frequency, p2: Frequency) {\n    if (!p1 || !p2) return;\n\n    return p1.value === p2.value;\n  }\n\n  hasRequiredError(field: string) {\n    const fieldControl = this.getControl(field);\n    if (!fieldControl || !fieldControl.errors) {\n      return;\n    }\n\n    return fieldControl.errors.required;\n  }\n}\n",
      properties: [
        {
          name: 'every',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
      isDuplicate: true,
      duplicateId: 1,
      duplicateName: 'Frequency-1',
    },
    {
      name: 'IAppendedComponent',
      id: 'interface-IAppendedComponent-cbfe1fc870ebf77f6b821ae90ea39c34b8d5deb290cd81ae5e5512c2ce29c8fa9ea9a1f02788ca0d98e182de0cb6654602178f85752d75b68ec5c0ec433db833',
      file: 'libs/ui-ang/notification/append-to-dom.service.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  ApplicationRef,\n  ComponentFactoryResolver,\n  ComponentRef,\n  EmbeddedViewRef,\n  Injectable,\n  Injector,\n  Type,\n} from '@angular/core';\nimport { NotificationComponent } from './notification.component';\n\nexport const DEFAULT_ROOT = document.body;\n\nexport interface IAppendedComponent {\n  componentInstance: any;\n  unmountComponent: () => void;\n}\n\n@Injectable({\n  providedIn: 'root',\n})\nexport class AppendToDomService {\n  constructor(\n    private readonly componentFactoryResolver: ComponentFactoryResolver,\n    private readonly appRef: ApplicationRef,\n    private readonly injector: Injector,\n  ) {\n    this.generateListElement(DEFAULT_ROOT);\n  }\n\n  appendComponentToRoot(\n    component: Type<NotificationComponent>,\n    autofocus = false,\n    projectableNodes: any[] = [],\n    root: Node = DEFAULT_ROOT,\n  ): IAppendedComponent {\n    // 1. Create a component reference from the component\n    const componentRef = this.componentFactoryResolver\n      .resolveComponentFactory(component)\n      .create(this.injector, [projectableNodes ?? []]);\n\n    // 2. Attach component to the appRef so that it's inside the ng component tree\n    this.appRef.attachView(componentRef.hostView);\n\n    // 3. Get DOM element from component\n    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;\n\n    // 4. Append notification list if missing\n    const listElement = this.generateListElement(root);\n\n    // 5. Add item class\n    domElem.setAttribute('class', 'bb-notification-list__item');\n\n    componentRef.instance.autofocus = autofocus;\n\n    // 6. Append new element to list of elements and push old ones down.\n    if (listElement) {\n      listElement.insertBefore(domElem, listElement.firstChild);\n    }\n\n    return {\n      componentInstance: componentRef.instance,\n      unmountComponent: () => {\n        this.destroyElement(componentRef);\n      },\n    };\n  }\n\n  private generateListElement(root: Node): Element {\n    let listElement = document.getElementsByClassName('bb-notification-list')[0];\n    if (!listElement) {\n      listElement = document.createElement('div');\n      listElement.setAttribute('class', 'bb-notification-list');\n      listElement.setAttribute('aria-atomic', 'true');\n      listElement.setAttribute('aria-live', 'polite');\n      listElement.setAttribute('role', 'status');\n      listElement.setAttribute('aria-relevant', 'additions');\n      root.appendChild(listElement);\n    }\n\n    return listElement;\n  }\n\n  private destroyElement(componentRef: ComponentRef<any>) {\n    componentRef.instance.beforeDestroy();\n    this.appRef.detachView(componentRef.hostView);\n    componentRef.destroy();\n  }\n}\n",
      properties: [
        {
          name: 'componentInstance',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: false,
          description: '',
          line: 15,
        },
        {
          name: 'unmountComponent',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: false,
          description: '',
          line: 16,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ICollapsible',
      id: 'interface-ICollapsible-10fea7504fbe61e77f4a08f2150c68e9a4dbd1640405541611a85da8ca8202fd9bdccee18fe502200a67529dfeaf1e85df498d8294a28708c146ae880f90fb63',
      file: 'libs/ui-ang/collapsible-accordion/collapsible-accordion.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { AfterContentInit, Component, EventEmitter, Input, OnDestroy, Optional, SkipSelf } from '@angular/core';\nimport { Subscription } from 'rxjs';\n\nexport interface ICollapsible extends OnDestroy {\n  toggle: () => void;\n  isOpen: boolean;\n  isOpenChange: EventEmitter<boolean>;\n}\n\n/**\n * @name CollapsibleAccordionComponent\n *\n * @description\n * Component that groups Collapsible components to show them in an accordion fashion.\n * It can assure that only one Collapsible panel can be opened at a time.\n */\n@Component({\n  selector: 'bb-collapsible-accordion-ui',\n  templateUrl: 'collapsible-accordion.component.html',\n  standalone: false,\n})\nexport class CollapsibleAccordionComponent implements AfterContentInit, OnDestroy {\n  /**\n   * Assures that only one Collapsible panel can be opened at a time.\n   */\n  @Input() closeOthers = false;\n  /**\n   * When true displays the first panel on load.\n   */\n  @Input() openFirst = false;\n  /**\n   * When true the Accordion will inherit the parent Accordion behaviour.\n   */\n  @Input()\n  set obeyParentAccordion(obey: boolean) {\n    if (!this.parentAccordion) {\n      return;\n    }\n\n    if (obey) {\n      this.parentAccordion.registerNestedAccordion(this);\n    } else {\n      this.parentAccordion.unregisterNestedAccordion(this);\n    }\n  }\n\n  private readonly collapsiblePanels = new Map<ICollapsible, Subscription>();\n  private readonly nestedAccordions = new Set<CollapsibleAccordionComponent>();\n\n  constructor(\n    @Optional()\n    @SkipSelf()\n    private readonly parentAccordion: CollapsibleAccordionComponent,\n  ) {}\n\n  ngOnDestroy() {\n    this.obeyParentAccordion = false;\n  }\n\n  registerNestedAccordion(childAccordion: CollapsibleAccordionComponent) {\n    this.nestedAccordions.add(childAccordion);\n  }\n\n  unregisterNestedAccordion(childAccordion: CollapsibleAccordionComponent) {\n    this.nestedAccordions.delete(childAccordion);\n  }\n\n  registerNestedPanel(panel: ICollapsible) {\n    const subscription = panel.isOpenChange.subscribe({\n      next: (isOpen: boolean) => this.closeOtherPanels(panel)(isOpen),\n    });\n    this.collapsiblePanels.set(panel, subscription);\n  }\n\n  unregisterNestedPanel(panel: ICollapsible) {\n    const subscription = this.collapsiblePanels.get(panel);\n    if (subscription) {\n      subscription.unsubscribe();\n    }\n    this.collapsiblePanels.delete(panel);\n  }\n\n  expandAll() {\n    if (this.closeOthers) {\n      return;\n    }\n    this.setPanelsState(true);\n    this.setNestedAccordionsState(true);\n  }\n\n  collapseAll() {\n    this.setPanelsState(false);\n    this.setNestedAccordionsState(false);\n  }\n\n  ngAfterContentInit() {\n    if (this.openFirst) {\n      const firstPanel = this.collapsiblePanels.keys().next().value;\n\n      if (firstPanel) {\n        firstPanel.isOpen = true;\n      }\n    }\n  }\n\n  private readonly closeOtherPanels = (panel: ICollapsible) => (value: boolean) => {\n    if (!value) {\n      return;\n    }\n\n    if (!this.closeOthers) {\n      return;\n    }\n\n    this.collapsiblePanels.forEach((_, item) => {\n      if (panel !== item) {\n        item.isOpen = false;\n      }\n    });\n  };\n\n  private setPanelsState(isOpen: boolean) {\n    this.collapsiblePanels.forEach((_, panel) => (panel.isOpen = isOpen));\n  }\n\n  private setNestedAccordionsState(isOpen: boolean) {\n    this.nestedAccordions.forEach((accordion) => {\n      if (isOpen) {\n        accordion.expandAll();\n      } else {\n        accordion.collapseAll();\n      }\n    });\n  }\n}\n",
      properties: [
        {
          name: 'isOpen',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
        {
          name: 'isOpenChange',
          deprecated: false,
          deprecationMessage: '',
          type: 'EventEmitter<boolean>',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'toggle',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: ['OnDestroy'],
    },
    {
      name: 'IDistanceRange',
      id: 'interface-IDistanceRange-a3236018f98a9b1c46e123c664851ee095ba2d558743fc4ec55f99a5b74c539bda2ca74cb402c57f2d4f7d69a61cb2a0eb3695b5051f156570735d910501d6d0',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/services/event-trigger.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { IInfiniteScrollEvent, IPositionStats } from '../models';\n\nexport interface IScrollerProps extends IDistanceRange {\n  container: IPositionStats;\n  alwaysCallback: boolean;\n  disabled: boolean;\n}\n\nexport interface ITriggerEvents {\n  down: (event: any) => any;\n  up: (event: any) => any;\n}\n\nexport interface IDistanceRange {\n  down: number;\n  up: number;\n}\n\nexport interface IScrollConfig {\n  alwaysCallback: boolean;\n  shouldFireScrollEvent: boolean;\n}\n\nexport function shouldTriggerEvents(\n  alwaysCallback: boolean,\n  shouldFireScrollEvent: boolean,\n  isTriggeredCurrentTotal: boolean,\n) {\n  if (alwaysCallback && shouldFireScrollEvent) {\n    return true;\n  }\n  if (!isTriggeredCurrentTotal && shouldFireScrollEvent) {\n    return true;\n  }\n\n  return false;\n}\n",
      properties: [
        {
          name: 'down',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 15,
        },
        {
          name: 'up',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 16,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IEventPayload',
      id: 'interface-IEventPayload-fbb0bc82495cf226c9d4164f155cc52e019228be1a6c4520838a45e784ec2b63fcf17f7c7ad04ef9098b6f1071cd582657a0aa6e08b0f16d1ad26a1d9d6e1295',
      file: 'libs/ui-ang/progress-tracker/progress-tracker.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface IProgressTrackerConfig {\n  payload: IEventPayload;\n  id: string;\n  eventStatus: EventStatus;\n}\n\nexport interface IEventPayload {\n  eta: Eta;\n  progressStartTime: number;\n  current: number;\n  size: number;\n  name: string;\n  actionType: EventType;\n  itemId: string;\n}\n\nexport enum EventStatus {\n  IN_PROGRESS,\n  COMPLETED,\n  CANCELLED,\n  TIME_OUT,\n}\n\nexport enum EventType {\n  FILE_UPLOAD,\n}\n\nexport interface Eta {\n  hours: number;\n  mins: number;\n  secs: number;\n}\n',
      properties: [
        {
          name: 'actionType',
          deprecated: false,
          deprecationMessage: '',
          type: 'EventType',
          indexKey: '',
          optional: false,
          description: '',
          line: 13,
        },
        {
          name: 'current',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'eta',
          deprecated: false,
          deprecationMessage: '',
          type: 'Eta',
          indexKey: '',
          optional: false,
          description: '',
          line: 8,
        },
        {
          name: 'itemId',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 14,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 12,
        },
        {
          name: 'progressStartTime',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IInfiniteScrollAction',
      id: 'interface-IInfiniteScrollAction-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'payload',
          deprecated: false,
          deprecationMessage: '',
          type: 'IInfiniteScrollEvent',
          indexKey: '',
          optional: false,
          description: '',
          line: 64,
        },
        {
          name: 'type',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 63,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IInfiniteScrollEvent',
      id: 'interface-IInfiniteScrollEvent-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'currentScrollPosition',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IllustrationConfig',
      id: 'interface-IllustrationConfig-098f748d6f4c3ea6978d13a6c8f5688c3e426fc4a0c94df8baf554b8ae881765fb589cd807c3c43072f7a817fc966277243f462ca6b1728baf4b7f1b302b7c5c',
      file: 'libs/ui-ang/illustration/illustration.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface IllustrationConfig {\n  assetPath?: string;\n  fileType?: string;\n}\n\nexport const ILLUSTRATION_CONFIG_TOKEN = new InjectionToken<IllustrationConfig>('ILLUSTRATION_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'assetPath',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'fileType',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IllustrationSizeObject',
      id: 'interface-IllustrationSizeObject-910e8eb3604d3e39dc46d1b6475b9b3ffab89b928f1134e19b0b45af96e1e3708e5179b1e4eea92bd4f32554d6bc81c0c3ff9387a9b842e8e3c288e695fdfb8a',
      file: 'libs/ui-ang/illustration/illustration.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { NgOptimizedImage } from '@angular/common';\nimport { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';\nimport { DEFAULT_ASSET_PATH, ILLUSTRATION_SIZES, ILLUSTRATION_SIZE_MAP } from './illustration.constants';\nimport { ILLUSTRATION_CONFIG_TOKEN, IllustrationConfig } from './illustration.token-config';\n\nexport interface IllustrationSizeObject {\n  width: number | string;\n  height: number | string;\n}\n\nexport type IllustrationSize =\n  | typeof ILLUSTRATION_SIZES.XS\n  | typeof ILLUSTRATION_SIZES.SM\n  | typeof ILLUSTRATION_SIZES.MD\n  | typeof ILLUSTRATION_SIZES.LG\n  | typeof ILLUSTRATION_SIZES.XL;\n\n/**\n * @name IllustrationComponent\n *\n * @description\n * Component that displays an illustration from the Design System visual asset library.\n *\n * ### Usage\n * If you already have a Backbase app, please follow\n * https://backbase.io/developers/documentation/web-devkit/app-development/configure-static-assets/#_configure_an_application_to_add_static_assets to configure static assets inclusion.\n *\n * For this component in particular, you may need to add:\n *\n * ```ts\n * \"assets\": [\n *   {\n *     \"glob\": \"**\\/*\",\n *     \"input\": \"node_modules/@backbase/ui-ang/assets\",\n *     \"output\": \"/assets/design-system\"\n *   }\n * ]\n * ```\n *\n * ### Global configuration token\n * `ILLUSTRATION_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `IllustrationComponent` in your project.\n *\n * *Note:* The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not be able to overwrite it.\n *\n * The following properties can be overwritten using the token:\n *  - `assetPath`\n *  - `fileType`\n *\n * #### Usage notes\n * The following is an example of how to use the token:\n *\n * ```ts\n * import { ILLUSTRATION_CONFIG_TOKEN } from '@backbase/ui-ang/illustration';\n * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n * import { AppModule } from './app/app.module';\n *\n * const illustrationConfig = {\n *   fileType: 'png'\n * }\n *\n * platformBrowserDynamic().bootstrapModule(AppModule, {\n *   providers: [{ provide: ILLUSTRATION_CONFIG_TOKEN, useValue: illustrationConfig }]\n * });\n * ```\n *\n */\n@Component({\n  selector: 'bb-illustration-ui',\n  templateUrl: './illustration.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class IllustrationComponent {\n  /**\n   * The name of the illustration.\n   * This corresponds to the file name. Supports camelCase, snake_case or kebab-case.\n   *\n   * Input is required.\n   */\n  @Input({ required: true }) name!: string;\n\n  /**\n   * The class of the image. Used for additional styling.\n   */\n  @Input() classes?: string;\n\n  /**\n   * Indicates whether this image should have a high priority.\n   */\n  @Input() priority: NgOptimizedImage['priority'] = false;\n\n  /**\n   * The desired loading behavior (lazy, eager, or auto).\n   *\n   * Defaults to `lazy` which is recommended for most images.\n   */\n  @Input() loading: NgOptimizedImage['loading'];\n\n  /**\n   * Location of your assets folder.\n   * Used for overriding or theming the illustrations.\n   * This attribute can be overwritten via the global configuration token.\n   *\n   * Defaults to the `ui-ang` visual asset library folder.\n   */\n  @Input()\n  get assetPath(): string {\n    return this._assetPath ?? this.overrideConfig?.assetPath ?? DEFAULT_ASSET_PATH;\n  }\n  set assetPath(value: IllustrationConfig['assetPath']) {\n    this._assetPath = value?.replace(/\\/$/, '');\n  }\n  /**\n   * The alt attribute value of the illustration HTML <img> tag.\n   * Set the value to empty string `\"\"` so that screen readers won't read it.\n   * This useful when the image does not convey any meaning and avoid disturbing\n   * a screen reader user\n   *\n   * Defaults to `undefined`. It will set `alt` to `name | illustrationAlt` in the html template.\n   */\n  @Input() alt?: string;\n\n  private _assetPath: IllustrationConfig['assetPath'];\n\n  /**\n   * The file type.\n   * This attribute can be overwritten via the global configuration token.\n   *\n   * Defaults to `svg`.\n   */\n  @Input()\n  get fileType(): string {\n    return this._fileType ?? this.overrideConfig?.fileType ?? 'svg';\n  }\n  set fileType(value: IllustrationConfig['fileType']) {\n    this._fileType = value;\n  }\n  private _fileType: IllustrationConfig['fileType'];\n\n  /**\n   * Either\n   *  - a string indicating the size. For example: `\"sm\"`, `\"md\"`\n   *  - an object with dimensions: `{ width, height }`\n   *\n   *  Input is required.\n   */\n  @Input({\n    required: true,\n    transform: (val: IllustrationSize | IllustrationSizeObject) => {\n      const invalidSizeFallback = { width: undefined, height: undefined };\n\n      if (typeof val === 'string') {\n        return ILLUSTRATION_SIZE_MAP[val] ?? invalidSizeFallback;\n      }\n\n      return val?.width && val?.height ? val : invalidSizeFallback;\n    },\n  })\n  size!: IllustrationSizeObject;\n\n  constructor(@Optional() @Inject(ILLUSTRATION_CONFIG_TOKEN) private readonly overrideConfig: IllustrationConfig) {}\n}\n",
      properties: [
        {
          name: 'height',
          deprecated: false,
          deprecationMessage: '',
          type: 'number | string',
          indexKey: '',
          optional: false,
          description: '',
          line: 8,
        },
        {
          name: 'width',
          deprecated: false,
          deprecationMessage: '',
          type: 'number | string',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'InJourneyConfig',
      id: 'interface-InJourneyConfig-7c5a00cd6549ea9fa405614942171379f99ecbb461715fd6af3bcfb82475c54e93485b2a116eabc58f198c697a11d3276f1de6635c77a0d37432e8fd3f3b0ab0',
      file: 'libs/ui-ang/animations/types/config-types.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { TranslationAxis, TranslationDirectionType, TranslationDirectionValue } from './translation';\n\nexport interface InJourneyConfig {\n  animationAlias: string;\n  translationDirectionType: TranslationDirectionType;\n  translationAxis: TranslationAxis;\n  translationDirection: TranslationDirectionValue;\n  // enableLeaveGroups: with leave groups enabled the view can decide wether if it wants elements leave from\n  // top or bottom by using a class\n  enableLeaveGroups: boolean;\n  disableAnimation: boolean;\n}\n\nexport interface CrossJourneyConfig {\n  animationAlias: string;\n  disableAnimation: boolean;\n  fadeInOutSelector: string;\n  enableGroups: boolean;\n  enterDelay: string;\n  routerContainerSelector: string;\n}\n\nexport interface ExpandRevealConfig {\n  animationAlias: string;\n  disableAnimation: boolean;\n  contentSelector: string;\n  containerSelector: string;\n  expandStyle: ExpandRevealStyle;\n}\n\nexport enum ExpandRevealStyle {\n  SEQUENCED = 'SEQUENCED_EXPAND',\n  STAGGERED = 'STAGGERED_EXPAND',\n}\n",
      properties: [
        {
          name: 'animationAlias',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
        {
          name: 'disableAnimation',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
        {
          name: 'enableLeaveGroups',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'translationAxis',
          deprecated: false,
          deprecationMessage: '',
          type: 'TranslationAxis',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
        {
          name: 'translationDirection',
          deprecated: false,
          deprecationMessage: '',
          type: 'TranslationDirectionValue',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'translationDirectionType',
          deprecated: false,
          deprecationMessage: '',
          type: 'TranslationDirectionType',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'InputDatepickerConfig',
      id: 'interface-InputDatepickerConfig-2bf94f3d9e1c006dab7e4259227b6997bfafb8ef7a679a927c0ee0f77f5f15dced146d1c96d3be58d14ebe8535d4fa0c7e65d9bf6a64dbb21db5acc97b05dd8b',
      file: 'libs/ui-ang/input-datepicker/input-datepicker.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface InputDatepickerConfig {\n  autocomplete?: string;\n  displayMonths?: number;\n  firstDayOfWeek?: number;\n  overrideDateFormat?: string;\n  placeholder?: string;\n  rangeSelection?: boolean;\n  mask?: any;\n}\n\nexport const INPUT_DATEPICKER_CONFIG_TOKEN = new InjectionToken<InputDatepickerConfig>('INPUT_DATEPICKER_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'displayMonths',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
        {
          name: 'firstDayOfWeek',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
        {
          name: 'mask',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '',
          line: 10,
        },
        {
          name: 'overrideDateFormat',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 7,
        },
        {
          name: 'placeholder',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 8,
        },
        {
          name: 'rangeSelection',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 9,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'InputEmailConfig',
      id: 'interface-InputEmailConfig-f99a15ac22712e845c812e7f04405d755fdc4dfcf38528a8f3331b8d4a5d6f24d9d341c6ee5d03c2c1936147aedacb782974fe7317901715d5091122c8c4d156',
      file: 'libs/ui-ang/input-email/input-email.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\n/**\n * Defines the configuration options for an email input field.\n */\nexport interface InputEmailConfig {\n  /**\n   * Specifies whether or not the browser should show autocomplete suggestions for email addresses.\n   * Possible values are 'email', 'off', and 'on'.\n   */\n  autocomplete?: 'email' | 'off' | 'on';\n  /**\n   * The maximum number of characters that can be entered into the email input field.\n   */\n  maxLength?: number;\n  /**\n   * The minimum number of characters that must be entered into the email input field.\n   */\n  minLength?: number;\n  /**\n   * The placeholder text to display in the email input field when it is empty.\n   */\n  placeholder?: string;\n  /**\n   * The number of visible characters in the email input field.\n   */\n  size?: number;\n  /**\n   * A regular expression pattern that the entered email must match.\n   */\n  pattern?: string | RegExp;\n}\n\nexport const INPUT_EMAIL_CONFIG_TOKEN = new InjectionToken<InputEmailConfig>('INPUT_EMAIL_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          type: '"email" | "off" | "on"',
          indexKey: '',
          optional: true,
          description:
            '<p>Specifies whether or not the browser should show autocomplete suggestions for email addresses.\nPossible values are &#39;email&#39;, &#39;off&#39;, and &#39;on&#39;.</p>\n',
          line: 11,
          rawdescription:
            "\n\nSpecifies whether or not the browser should show autocomplete suggestions for email addresses.\nPossible values are 'email', 'off', and 'on'.\n",
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '<p>The maximum number of characters that can be entered into the email input field.</p>\n',
          line: 15,
          rawdescription: '\n\nThe maximum number of characters that can be entered into the email input field.\n',
        },
        {
          name: 'minLength',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '<p>The minimum number of characters that must be entered into the email input field.</p>\n',
          line: 19,
          rawdescription: '\n\nThe minimum number of characters that must be entered into the email input field.\n',
        },
        {
          name: 'pattern',
          deprecated: false,
          deprecationMessage: '',
          type: 'string | RegExp',
          indexKey: '',
          optional: true,
          description: '<p>A regular expression pattern that the entered email must match.</p>\n',
          line: 31,
          rawdescription: '\n\nA regular expression pattern that the entered email must match.\n',
        },
        {
          name: 'placeholder',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '<p>The placeholder text to display in the email input field when it is empty.</p>\n',
          line: 23,
          rawdescription: '\n\nThe placeholder text to display in the email input field when it is empty.\n',
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '<p>The number of visible characters in the email input field.</p>\n',
          line: 27,
          rawdescription: '\n\nThe number of visible characters in the email input field.\n',
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Defines the configuration options for an email input field.</p>\n',
      rawdescription: '\n\nDefines the configuration options for an email input field.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'InputItem',
      id: 'interface-InputItem-8609dcef24f7336e89d5e5c96e4b07418bdaa3c0880c093ea8de5d33af42a0329e846cefecb09705b2b96392a69280f6f895473cb6a9d1d13700c5d876a2918a',
      file: 'libs/ui-ang-examples/src/configuration/configuration-input.service.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Injectable } from '@angular/core';\nimport { Subject } from 'rxjs';\n\n@Injectable()\nexport class ConfigurationInputService {\n  sharedField = new Subject();\n}\nexport interface RadioItem {\n  label: string;\n  value: boolean | string;\n}\n\nexport type CheckboxItem = RadioItem & {\n  formControlName: string;\n};\nexport type CheckboxList = Array<CheckboxItem>;\n\nexport interface RadioGroup {\n  label: string;\n  formControlName: string;\n  radioItems: RadioItem[];\n}\n\nexport type RadioGroupList = Array<RadioGroup>;\n\nexport type InputList = Array<InputItem>;\n\nexport interface DropdownItem {\n  label: string;\n  formControlName: string;\n  dropdownItemList: string[];\n}\n\nexport interface InputItem {\n  label: string;\n  formControlName: string;\n  value: string;\n}\n\nexport type DropdownList = Array<DropdownItem>;\n",
      properties: [
        {
          name: 'formControlName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 36,
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 35,
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 37,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'InputPhoneConfig',
      id: 'interface-InputPhoneConfig-2186c35807301e161dc5d6f3ccd42fdbe77037e309f2acbe09de5088017442ab094ceff268b5bbb9cf8a1d00ba40c329e73bec16a8c45d676d3525fbc823aab0',
      file: 'libs/ui-ang/input-phone/input-phone.configuration_token.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\nimport { NumberFormat } from 'libphonenumber-js';\nimport { CountryList } from './input-phone.component';\n\nexport interface InputPhoneConfig {\n  maxLength?: number;\n  minLength?: number;\n  validationPattern?: string;\n  autocomplete?: 'tel' | 'on' | 'off';\n  mask?: string;\n  displayFormat?: NumberFormat | Capitalize<Lowercase<NumberFormat>>;\n  hideSelectedCountryFlag?: boolean;\n  defaultCountryIsoCode?: string;\n  countryList?: CountryList;\n  enableCountryCode?: boolean;\n}\nexport const INPUT_PHONE_CONFIG_TOKEN = new InjectionToken<InputPhoneConfig>('INPUT_PHONE_CONFIG_TOKEN');\n\nexport interface CountryCodeFormatConfig {\n  mask?: string;\n  minLength?: number;\n  maxLength?: number;\n}\nexport interface CountryCodeFormatConfigMap {\n  [key: string]: CountryCodeFormatConfig;\n}\nexport const COUNTRY_CODE_FORMAT_CONFIG_TOKEN = new InjectionToken<CountryCodeFormatConfigMap>(\n  'COUNTRY_CODE_FORMAT_CONFIG_TOKEN',\n);\n",
      properties: [
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          type: '"tel" | "on" | "off"',
          indexKey: '',
          optional: true,
          description: '',
          line: 9,
        },
        {
          name: 'countryList',
          deprecated: false,
          deprecationMessage: '',
          type: 'CountryList',
          indexKey: '',
          optional: true,
          description: '',
          line: 14,
        },
        {
          name: 'defaultCountryIsoCode',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 13,
        },
        {
          name: 'displayFormat',
          deprecated: false,
          deprecationMessage: '',
          type: 'NumberFormat | Capitalize<Lowercase<NumberFormat>>',
          indexKey: '',
          optional: true,
          description: '',
          line: 11,
        },
        {
          name: 'enableCountryCode',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 15,
        },
        {
          name: 'hideSelectedCountryFlag',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 12,
        },
        {
          name: 'mask',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 10,
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
        {
          name: 'minLength',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 7,
        },
        {
          name: 'validationPattern',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 8,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'InputTimepickerConfig',
      id: 'interface-InputTimepickerConfig-4560991261b6073787fc95e4a387132edfc358e70c3b47dfde1a89907ee69d47f12cce6efad413809daf8e43d53b6fc6e0630b81cb3cb17a125bb730d5b2afd7',
      file: 'libs/ui-ang/input-timepicker/input-timepicker.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface InputTimepickerConfig {\n  clock?: '12h' | '24h';\n  hourStep?: number;\n  max?: string;\n  min?: string;\n  minuteStep?: number;\n}\n\nexport const INPUT_TIMEPICKER_CONFIG_TOKEN = new InjectionToken<InputTimepickerConfig>('INPUT_TIMEPICKER_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'clock',
          deprecated: false,
          deprecationMessage: '',
          type: '"12h" | "24h"',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'hourStep',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
        {
          name: 'max',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
        {
          name: 'min',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 7,
        },
        {
          name: 'minuteStep',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 8,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'InputValidationMessageConfig',
      id: 'interface-InputValidationMessageConfig-5d8d0b4949adc12bc2cd94e223e0ccadeb63dc8025a228bac1db37617918778f6def2bb451a83fe8a7c2bca21f7c2acf1c221786355caa665689751b5aed31be',
      file: 'libs/ui-ang/input-validation-message/constants.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface InputValidationMessageConfig {\n  showIcon?: boolean;\n}\n\n/**\n * Input validation message icon visibility Token\n */\nexport const INPUT_VALIDATION_MESSAGE_CONFIG = new InjectionToken<InputValidationMessageConfig>(\n  'INPUT_VALIDATION_MESSAGE_CONFIG',\n);\n",
      properties: [
        {
          name: 'showIcon',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IPositionElements',
      id: 'interface-IPositionElements-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'axis',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
        {
          name: 'windowElement',
          deprecated: false,
          deprecationMessage: '',
          type: 'ContainerRef',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IPositionStats',
      id: 'interface-IPositionStats-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'height',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 15,
        },
        {
          name: 'isWindow',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 18,
        },
        {
          name: 'scrolled',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 16,
        },
        {
          name: 'totalToScroll',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 17,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IProgressTrackerConfig',
      id: 'interface-IProgressTrackerConfig-fbb0bc82495cf226c9d4164f155cc52e019228be1a6c4520838a45e784ec2b63fcf17f7c7ad04ef9098b6f1071cd582657a0aa6e08b0f16d1ad26a1d9d6e1295',
      file: 'libs/ui-ang/progress-tracker/progress-tracker.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface IProgressTrackerConfig {\n  payload: IEventPayload;\n  id: string;\n  eventStatus: EventStatus;\n}\n\nexport interface IEventPayload {\n  eta: Eta;\n  progressStartTime: number;\n  current: number;\n  size: number;\n  name: string;\n  actionType: EventType;\n  itemId: string;\n}\n\nexport enum EventStatus {\n  IN_PROGRESS,\n  COMPLETED,\n  CANCELLED,\n  TIME_OUT,\n}\n\nexport enum EventType {\n  FILE_UPLOAD,\n}\n\nexport interface Eta {\n  hours: number;\n  mins: number;\n  secs: number;\n}\n',
      properties: [
        {
          name: 'eventStatus',
          deprecated: false,
          deprecationMessage: '',
          type: 'EventStatus',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 3,
        },
        {
          name: 'payload',
          deprecated: false,
          deprecationMessage: '',
          type: 'IEventPayload',
          indexKey: '',
          optional: false,
          description: '',
          line: 2,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IProgressTrackerItemTemplateConfig',
      id: 'interface-IProgressTrackerItemTemplateConfig-6f2d89ab4f9cb7d60cf0b7f3eea793620af4c9fc43d18df165c9df911f7e495a99f393abb602fcf755074b16d4257d4d526df30c040c622bbde3d1b7f9f0cafd',
      file: 'libs/ui-ang/progress-tracker/containers/progress-tracker-container.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Eta, IProgressTrackerConfig } from '../progress-tracker.model';\nexport interface IProgressTrackerTemplateConfig {\n  currentEvents: IProgressTrackerConfig[];\n  show: boolean;\n  animate: boolean;\n}\n\nexport interface IProgressTrackerItemTemplateConfig {\n  name: string;\n  eta: Eta;\n  itemId: boolean;\n  size: string;\n  current: string;\n  cancelItem: (id: string) => void;\n}\n",
      properties: [
        {
          name: 'cancelItem',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: false,
          description: '',
          line: 14,
        },
        {
          name: 'current',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 13,
        },
        {
          name: 'eta',
          deprecated: false,
          deprecationMessage: '',
          type: 'Eta',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'itemId',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 12,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IProgressTrackerTemplateConfig',
      id: 'interface-IProgressTrackerTemplateConfig-6f2d89ab4f9cb7d60cf0b7f3eea793620af4c9fc43d18df165c9df911f7e495a99f393abb602fcf755074b16d4257d4d526df30c040c622bbde3d1b7f9f0cafd',
      file: 'libs/ui-ang/progress-tracker/containers/progress-tracker-container.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Eta, IProgressTrackerConfig } from '../progress-tracker.model';\nexport interface IProgressTrackerTemplateConfig {\n  currentEvents: IProgressTrackerConfig[];\n  show: boolean;\n  animate: boolean;\n}\n\nexport interface IProgressTrackerItemTemplateConfig {\n  name: string;\n  eta: Eta;\n  itemId: boolean;\n  size: string;\n  current: string;\n  cancelItem: (id: string) => void;\n}\n",
      properties: [
        {
          name: 'animate',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
        {
          name: 'currentEvents',
          deprecated: false,
          deprecationMessage: '',
          type: 'IProgressTrackerConfig[]',
          indexKey: '',
          optional: false,
          description: '',
          line: 3,
        },
        {
          name: 'show',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IResolver',
      id: 'interface-IResolver-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'axis',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: false,
          description: '',
          line: 35,
        },
        {
          name: 'container',
          deprecated: false,
          deprecationMessage: '',
          type: 'ContainerRef',
          indexKey: '',
          optional: false,
          description: '',
          line: 33,
        },
        {
          name: 'isWindow',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 34,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IScrollConfig',
      id: 'interface-IScrollConfig-a3236018f98a9b1c46e123c664851ee095ba2d558743fc4ec55f99a5b74c539bda2ca74cb402c57f2d4f7d69a61cb2a0eb3695b5051f156570735d910501d6d0',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/services/event-trigger.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { IInfiniteScrollEvent, IPositionStats } from '../models';\n\nexport interface IScrollerProps extends IDistanceRange {\n  container: IPositionStats;\n  alwaysCallback: boolean;\n  disabled: boolean;\n}\n\nexport interface ITriggerEvents {\n  down: (event: any) => any;\n  up: (event: any) => any;\n}\n\nexport interface IDistanceRange {\n  down: number;\n  up: number;\n}\n\nexport interface IScrollConfig {\n  alwaysCallback: boolean;\n  shouldFireScrollEvent: boolean;\n}\n\nexport function shouldTriggerEvents(\n  alwaysCallback: boolean,\n  shouldFireScrollEvent: boolean,\n  isTriggeredCurrentTotal: boolean,\n) {\n  if (alwaysCallback && shouldFireScrollEvent) {\n    return true;\n  }\n  if (!isTriggeredCurrentTotal && shouldFireScrollEvent) {\n    return true;\n  }\n\n  return false;\n}\n",
      properties: [
        {
          name: 'alwaysCallback',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 20,
        },
        {
          name: 'shouldFireScrollEvent',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 21,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IScroller',
      id: 'interface-IScroller-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'alwaysCallback',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 51,
        },
        {
          name: 'disable',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 46,
        },
        {
          name: 'downDistance',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 52,
        },
        {
          name: 'element',
          deprecated: false,
          deprecationMessage: '',
          type: 'ElementRef',
          indexKey: '',
          optional: false,
          description: '',
          line: 49,
        },
        {
          name: 'fromRoot',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 44,
        },
        {
          name: 'horizontal',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 45,
        },
        {
          name: 'scrollContainer',
          deprecated: false,
          deprecationMessage: '',
          type: 'string | ElementRef',
          indexKey: '',
          optional: false,
          description: '',
          line: 50,
        },
        {
          name: 'scrollWindow',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 48,
        },
        {
          name: 'throttle',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 47,
        },
        {
          name: 'upDistance',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 53,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IScrollerDistance',
      id: 'interface-IScrollerDistance-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'down',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 21,
        },
        {
          name: 'up',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 22,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IScrollerProps',
      id: 'interface-IScrollerProps-a3236018f98a9b1c46e123c664851ee095ba2d558743fc4ec55f99a5b74c539bda2ca74cb402c57f2d4f7d69a61cb2a0eb3695b5051f156570735d910501d6d0',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/services/event-trigger.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { IInfiniteScrollEvent, IPositionStats } from '../models';\n\nexport interface IScrollerProps extends IDistanceRange {\n  container: IPositionStats;\n  alwaysCallback: boolean;\n  disabled: boolean;\n}\n\nexport interface ITriggerEvents {\n  down: (event: any) => any;\n  up: (event: any) => any;\n}\n\nexport interface IDistanceRange {\n  down: number;\n  up: number;\n}\n\nexport interface IScrollConfig {\n  alwaysCallback: boolean;\n  shouldFireScrollEvent: boolean;\n}\n\nexport function shouldTriggerEvents(\n  alwaysCallback: boolean,\n  shouldFireScrollEvent: boolean,\n  isTriggeredCurrentTotal: boolean,\n) {\n  if (alwaysCallback && shouldFireScrollEvent) {\n    return true;\n  }\n  if (!isTriggeredCurrentTotal && shouldFireScrollEvent) {\n    return true;\n  }\n\n  return false;\n}\n",
      properties: [
        {
          name: 'alwaysCallback',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
        {
          name: 'container',
          deprecated: false,
          deprecationMessage: '',
          type: 'IPositionStats',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
        {
          name: 'disabled',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: ['IDistanceRange'],
    },
    {
      name: 'IScrollParams',
      id: 'interface-IScrollParams-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'fire',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 58,
        },
        {
          name: 'scrollDown',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 57,
        },
        {
          name: 'stats',
          deprecated: false,
          deprecationMessage: '',
          type: 'IPositionStats',
          indexKey: '',
          optional: false,
          description: '',
          line: 59,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IScrollRegisterConfig',
      id: 'interface-IScrollRegisterConfig-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'container',
          deprecated: false,
          deprecationMessage: '',
          type: 'ContainerRef',
          indexKey: '',
          optional: false,
          description: '',
          line: 39,
        },
        {
          name: 'throttle',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 40,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'IScrollState',
      id: 'interface-IScrollState-afda01aa54e38d0e97c3899e156777673023a0b4fad0eb47ea9dd21d022674fe3c2e0f9ea080bfca6a5a2b9f3f88710841cf4557d5f891961740e5bbb47ce1cd',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ElementRef } from '@angular/core';\n\nexport type ContainerRef = Window | ElementRef | any;\n\nexport interface IInfiniteScrollEvent {\n  currentScrollPosition: number;\n}\n\nexport interface IPositionElements {\n  windowElement: ContainerRef;\n  axis: any;\n}\n\nexport interface IPositionStats {\n  height: number;\n  scrolled: number;\n  totalToScroll: number;\n  isWindow?: boolean;\n}\nexport interface IScrollerDistance {\n  down?: number;\n  up?: number;\n}\n\nexport interface IScrollState {\n  lastTotalToScroll: number;\n  totalToScroll: number;\n  triggered: IScrollerDistance;\n  lastScrollPosition: number;\n}\n\nexport interface IResolver {\n  container: ContainerRef;\n  isWindow: boolean;\n  axis: any;\n}\n\nexport interface IScrollRegisterConfig {\n  container: ContainerRef;\n  throttle: number;\n}\n\nexport interface IScroller {\n  fromRoot: boolean;\n  horizontal: boolean;\n  disable: boolean;\n  throttle: number;\n  scrollWindow: boolean;\n  element: ElementRef;\n  scrollContainer: string | ElementRef;\n  alwaysCallback: boolean;\n  downDistance: number;\n  upDistance: number;\n}\n\nexport interface IScrollParams {\n  scrollDown: boolean;\n  fire: boolean;\n  stats: IPositionStats;\n}\n\nexport interface IInfiniteScrollAction {\n  type: string;\n  payload: IInfiniteScrollEvent;\n}\n",
      properties: [
        {
          name: 'lastScrollPosition',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 29,
        },
        {
          name: 'lastTotalToScroll',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 26,
        },
        {
          name: 'totalToScroll',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 27,
        },
        {
          name: 'triggered',
          deprecated: false,
          deprecationMessage: '',
          type: 'IScrollerDistance',
          indexKey: '',
          optional: false,
          description: '',
          line: 28,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'isValidParentNodeFunc',
      id: 'interface-isValidParentNodeFunc-3a093ef8f77dcb0fd4c2a0c377f1c223f8543c8df14e9bdfe36c2661b3a7ddaa05cc1dbb5d42fd0c2301ac45ac001189d76b2a03a3e7fc6cfe1d533716b62fed',
      file: 'libs/eslint-plugin-design-system/src/utils/is-valid-parent-node.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import type { TmplAstElement, TmplAstTemplate } from '@angular-eslint/bundled-angular-compiler';\n\ninterface isValidParentNodeFunc<T1> {\n  (param1: T1): boolean;\n}\n\nexport type ParentNode = TmplAstElement & TmplAstTemplate & { parent: TmplAstElement };\n\nexport const isValidParentNode = (node: ParentNode, testFunc: isValidParentNodeFunc<TmplAstElement>): boolean => {\n  if (!(node?.name || node?.tagName)) {\n    return false;\n  }\n\n  if (testFunc(node)) {\n    return true;\n  }\n\n  return isValidParentNode(node.parent as ParentNode, testFunc);\n};\n",
      properties: [
        {
          id: 'call-declaration-3a093ef8f77dcb0fd4c2a0c377f1c223f8543c8df14e9bdfe36c2661b3a7ddaa05cc1dbb5d42fd0c2301ac45ac001189d76b2a03a3e7fc6cfe1d533716b62fed',
          args: [
            {
              name: 'param1',
              type: 'T1',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'boolean',
          line: 3,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      indexSignatures: [],
      kind: 179,
      methods: [],
      extends: [],
    },
    {
      name: 'ItemLogRecord',
      id: 'interface-ItemLogRecord-3b6734aea4876873dacfe111418beeb3ab412e6bac342218f0001e4616a01a2227e88a4c7f74ffa77fa08967d9cc291b9059d6901b64b578f1450b45ebc27605',
      file: 'libs/ui-ang/item-log/item-log.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, ChangeDetectionStrategy, Input, Directive, TemplateRef, ContentChild } from '@angular/core';\n\n@Directive({\n  selector: 'ng-template[bbItemLogRecord]',\n  standalone: false,\n})\nexport class ItemLogRecordDirective {\n  constructor(public templateRef: TemplateRef<any>) {}\n}\n\n/**\n * An interface representing an individual item log record.\n */\nexport interface ItemLogRecord {\n  /**\n   * The date and time the log record was created.\n   */\n  createdAt: string;\n  /**\n   * The full name of the user who created the log record.\n   */\n  userFullName: string;\n  /**\n   * The status of the item at the time the log record was created.\n   */\n  status: string;\n  /**\n   * An optional comment added by the user who created the log record.\n   */\n  comment?: string;\n  /**\n   * The ID of the user who created the log record, if it was created externally.\n   */\n  externalUserId?: string;\n}\n/**\n * @name ItemLogComponent\n *\n * @description\n * Component that shows the log of the records.\n *\n */\n@Component({\n  selector: 'bb-item-log-ui',\n  templateUrl: './item-log.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class ItemLogComponent<T> {\n  @ContentChild(ItemLogRecordDirective, { static: true })\n  customItemLog?: ItemLogRecordDirective;\n  /**\n   * Flag that denotes if item log status is pending. Defaults to false\n   */\n  @Input() isPending = false;\n  /**\n   * List of item log records.\n   */\n  @Input() records?: Array<ItemLogRecord | T>;\n}\n",
      properties: [
        {
          name: 'comment',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '<p>An optional comment added by the user who created the log record.</p>\n',
          line: 30,
          rawdescription: '\n\nAn optional comment added by the user who created the log record.\n',
        },
        {
          name: 'createdAt',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '<p>The date and time the log record was created.</p>\n',
          line: 18,
          rawdescription: '\n\nThe date and time the log record was created.\n',
        },
        {
          name: 'externalUserId',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '<p>The ID of the user who created the log record, if it was created externally.</p>\n',
          line: 34,
          rawdescription: '\n\nThe ID of the user who created the log record, if it was created externally.\n',
        },
        {
          name: 'status',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '<p>The status of the item at the time the log record was created.</p>\n',
          line: 26,
          rawdescription: '\n\nThe status of the item at the time the log record was created.\n',
        },
        {
          name: 'userFullName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '<p>The full name of the user who created the log record.</p>\n',
          line: 22,
          rawdescription: '\n\nThe full name of the user who created the log record.\n',
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>An interface representing an individual item log record.</p>\n',
      rawdescription: '\n\nAn interface representing an individual item log record.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'ITriggerEvents',
      id: 'interface-ITriggerEvents-a3236018f98a9b1c46e123c664851ee095ba2d558743fc4ec55f99a5b74c539bda2ca74cb402c57f2d4f7d69a61cb2a0eb3695b5051f156570735d910501d6d0',
      file: 'libs/ui-ang/infinite-scroll/ngx-infinite-scroll-directive/services/event-trigger.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { IInfiniteScrollEvent, IPositionStats } from '../models';\n\nexport interface IScrollerProps extends IDistanceRange {\n  container: IPositionStats;\n  alwaysCallback: boolean;\n  disabled: boolean;\n}\n\nexport interface ITriggerEvents {\n  down: (event: any) => any;\n  up: (event: any) => any;\n}\n\nexport interface IDistanceRange {\n  down: number;\n  up: number;\n}\n\nexport interface IScrollConfig {\n  alwaysCallback: boolean;\n  shouldFireScrollEvent: boolean;\n}\n\nexport function shouldTriggerEvents(\n  alwaysCallback: boolean,\n  shouldFireScrollEvent: boolean,\n  isTriggeredCurrentTotal: boolean,\n) {\n  if (alwaysCallback && shouldFireScrollEvent) {\n    return true;\n  }\n  if (!isTriggeredCurrentTotal && shouldFireScrollEvent) {\n    return true;\n  }\n\n  return false;\n}\n",
      properties: [
        {
          name: 'down',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'up',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'LayoutConfig',
      id: 'interface-LayoutConfig-91cec9b4c5a85500730d5f279e21b411f7cb66126ab7a189906b0b7b84f04161c65f593c203370714771f3b1a65d9e455234587587e45d50108f8ae3f26f6e73',
      file: 'libs/ui-ang/layout/bb-layout-lib/layout.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\nimport { MediaBreakpoints } from '@backbase/ui-ang/media-query-lib';\n\nexport interface LayoutConfig {\n  collapseBreakpoint: MediaBreakpoints;\n}\n\nexport const LAYOUT_CONFIG_TOKEN = new InjectionToken<LayoutConfig>('injectable token for LayoutService');\n",
      properties: [
        {
          name: 'collapseBreakpoint',
          deprecated: false,
          deprecationMessage: '',
          type: 'MediaBreakpoints',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ListMultipleSelectItem',
      id: 'interface-ListMultipleSelectItem-73a81a929122e0333de57ef414e25e3c49046bc4c039ec34233b3313eec5de922ea7fd88beafb97cfbf37de2c1cbedb25b91128af0ee76a3343fdd7a7f2a67b5',
      file: 'libs/ui-ang/list-multiple-select/list-multiple-select.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface ListMultipleSelectItem {\n  icon?: string;\n  iconColor?: string;\n  items?: ListMultipleSelectItems;\n}\n\nexport interface ListMultipleSelectItems {\n  [key: string]: ListMultipleSelectItem;\n}\n',
      properties: [
        {
          name: 'icon',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 2,
        },
        {
          name: 'iconColor',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 3,
        },
        {
          name: 'items',
          deprecated: false,
          deprecationMessage: '',
          type: 'ListMultipleSelectItems',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ListMultipleSelectItems',
      id: 'interface-ListMultipleSelectItems-73a81a929122e0333de57ef414e25e3c49046bc4c039ec34233b3313eec5de922ea7fd88beafb97cfbf37de2c1cbedb25b91128af0ee76a3343fdd7a7f2a67b5',
      file: 'libs/ui-ang/list-multiple-select/list-multiple-select.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface ListMultipleSelectItem {\n  icon?: string;\n  iconColor?: string;\n  items?: ListMultipleSelectItems;\n}\n\nexport interface ListMultipleSelectItems {\n  [key: string]: ListMultipleSelectItem;\n}\n',
      properties: [],
      indexSignatures: [
        {
          id: 'index-declaration-73a81a929122e0333de57ef414e25e3c49046bc4c039ec34233b3313eec5de922ea7fd88beafb97cfbf37de2c1cbedb25b91128af0ee76a3343fdd7a7f2a67b5',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'ListMultipleSelectItem',
          line: 7,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      methods: [],
      extends: [],
    },
    {
      name: 'LoadMoreParams',
      id: 'interface-LoadMoreParams-ce10e254725e43759df708a66b976baa50d8dee4490b30b603a5c7d8757568430c5d696dffb03c110797a70b70b7ce0498d1ece6015f29117e0df98595ffa5c2',
      file: 'libs/ui-ang/load-button/load-button.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';\n\nimport { ButtonComponent } from '@backbase/ui-ang/button';\n\nexport interface LoadMoreParams {\n  from: number;\n}\n\n/**\n * @name LoadButtonComponent\n *\n * @description\n * Component that displays a button with integrated loading indicator.\n * Refer to [Button Component](https://designsystem.backbase.com/web-components/button/web) for button colors and sizes.\n *\n * ### Use Case\n * There are two use-cases for this component:\n *    - Finite loading - button is disabled but remains displayed after a certain limit\n *    - Infinite loading - button is always functional\n * <br><br>\n *\n * #### Finite Loading\n * This is used primarily when paginating a list of items and the number of items is known.\n * The component is enabled and allows loading as long as the current number of displayed results (determined by `from` and `size`) is under the `totalCount`.\n *\n * ```html\n *    <bb-load-button-ui [size]=\"8\" [from]=\"0\" [totalCount]=\"48\" ...></bb-load-button-ui>\n * ```\n *\n * #### Infinite Loading\n * This is used primarily when you are loading a content only once or endlessly.\n * This is the default behaviour.\n * This behaviour is available as long as the `totalCount` is 1.\n *\n * ```html\n *    <bb-load-button-ui [totalCount]=\"1\" ...></bb-load-button-ui>\n * ```\n */\n@Component({\n  selector: 'bb-load-button-ui',\n  templateUrl: './load-button.component.html',\n  standalone: false,\n})\nexport class LoadButtonComponent extends ButtonComponent implements AfterViewInit {\n  /**\n   * Indicates if loading indicator should be shown instead of button content. Defaults to false.\n   */\n  @Input() isLoading = false;\n  /**\n   * The page to list from.\n   */\n  @Input() from = 0;\n  /**\n   * The number of results per page.\n   */\n  @Input() size = 0;\n  /**\n   * Whether it should render the button as a circle. Defaults to false i.e. oblong shape.\n   */\n  @Input() circle = false;\n  /**\n   * The total item count. Defaults to 1 to allow infinite loading.\n   */\n  @Input() totalCount = 1;\n  /**\n   * Accessible label when button does not contain a discernible text.\n   */\n  @Input('aria-label') ariaLabel?: string;\n  /**\n   * This emits new load more params to parent component\n   */\n  @Output() paramChange: EventEmitter<LoadMoreParams> = new EventEmitter();\n\n  @ViewChild('button', { static: true }) buttonComponent?: ElementRef;\n\n  constructor(\n    private readonly elementRef: ElementRef,\n    renderer: Renderer2,\n  ) {\n    super(elementRef, renderer);\n  }\n\n  ngAfterViewInit() {\n    this.moveAriaAttributes(this.elementRef.nativeElement, this.buttonComponent && this.buttonComponent.nativeElement);\n  }\n\n  isLoadMore() {\n    return this.size + this.totalCount + this.from > 0;\n  }\n\n  hasMore(): boolean {\n    return this.from * this.size + this.size < this.totalCount;\n  }\n\n  get isLoadingDisabled(): boolean {\n    return this.disabled || (this.isLoadMore() && !this.isLoading ? !this.hasMore() : false);\n  }\n\n  onClick($event: MouseEvent) {\n    if (this.isLoading && $event) {\n      $event.stopPropagation();\n    }\n    if (this.isLoadMore()) {\n      this.onLoadMore();\n    }\n  }\n\n  onLoadMore(): void {\n    if (this.hasMore() && !this.isLoading) {\n      this.paramChange.emit({\n        from: this.from + 1,\n      });\n    }\n  }\n\n  /**\n   * Host element click listener.\n   * @deprecated Deprecated in ui-ang@12. To be removed in ui-ang@14\n   */\n  onHostElementClick($event: MouseEvent) {\n    if (this.disabled) {\n      // Stop the \"click\" event propogation for the host component\n      // when the template button is disabled\n      $event.stopPropagation();\n      $event.stopImmediatePropagation();\n\n      return false;\n    }\n\n    return true;\n  }\n}\n",
      properties: [
        {
          name: 'from',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Locale',
      id: 'interface-Locale-a95a816e4bb5b86528951c406fe5483af8009917b2cccb2cf6c0791c4ecfa11919b5949ec53d8c7a2c8684542f384baaf35703a49920f773cb9b1cd0e8145f5a',
      file: 'libs/ui-ang/locale-selector/locale-selector.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface Locale {\n  language: string;\n  icon?: string;\n}\n\n/**\n * The `export interface LocaleCatalog` is defining an interface in TypeScript called `LocaleCatalog`.\n * It specifies the structure of an object that represents a catalog of locales. The object has keys of\n * type `string` and values of type `Locale`. This allows for dynamic creation of locale catalogs with\n * any number of locales, where each locale is identified by a unique key.\n */\nexport interface LocaleCatalog {\n  [key: string]: Locale;\n}\n',
      properties: [
        {
          name: 'icon',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 8,
        },
        {
          name: 'language',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
      ],
      indexSignatures: [],
      kind: 171,
      description:
        '<p>The interface has three properties: <code>language</code>, <code>code</code>, and <code>icon</code>.\nThe <code>language</code> property is of type <code>string</code> and represents the language of the locale.\nThe <code>icon</code> property is an optional property of type <code>string</code> and represents an icon associated with the locale.</p>\n',
      rawdescription:
        '\n\nThe interface has three properties: `language`, `code`, and `icon`.\nThe `language` property is of type `string` and represents the language of the locale.\nThe `icon` property is an optional property of type `string` and represents an icon associated with the locale.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'LocaleCatalog',
      id: 'interface-LocaleCatalog-a95a816e4bb5b86528951c406fe5483af8009917b2cccb2cf6c0791c4ecfa11919b5949ec53d8c7a2c8684542f384baaf35703a49920f773cb9b1cd0e8145f5a',
      file: 'libs/ui-ang/locale-selector/locale-selector.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        'export interface Locale {\n  language: string;\n  icon?: string;\n}\n\n/**\n * The `export interface LocaleCatalog` is defining an interface in TypeScript called `LocaleCatalog`.\n * It specifies the structure of an object that represents a catalog of locales. The object has keys of\n * type `string` and values of type `Locale`. This allows for dynamic creation of locale catalogs with\n * any number of locales, where each locale is identified by a unique key.\n */\nexport interface LocaleCatalog {\n  [key: string]: Locale;\n}\n',
      properties: [],
      indexSignatures: [
        {
          id: 'index-declaration-a95a816e4bb5b86528951c406fe5483af8009917b2cccb2cf6c0791c4ecfa11919b5949ec53d8c7a2c8684542f384baaf35703a49920f773cb9b1cd0e8145f5a',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'Locale',
          line: 17,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      description:
        '<p>The <code>export interface LocaleCatalog</code> is defining an interface in TypeScript called <code>LocaleCatalog</code>.\nIt specifies the structure of an object that represents a catalog of locales. The object has keys of\ntype <code>string</code> and values of type <code>Locale</code>. This allows for dynamic creation of locale catalogs with\nany number of locales, where each locale is identified by a unique key.</p>\n',
      rawdescription:
        '\n\nThe `export interface LocaleCatalog` is defining an interface in TypeScript called `LocaleCatalog`.\nIt specifies the structure of an object that represents a catalog of locales. The object has keys of\ntype `string` and values of type `Locale`. This allows for dynamic creation of locale catalogs with\nany number of locales, where each locale is identified by a unique key.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'LocaleConfiguration',
      id: 'interface-LocaleConfiguration-981761b2cfca8d6761b3fd7e1acc433660dc070cd1b323150939fe2ae5b28b3f6869d268fc6f001340d618838b43471c2e1420537280f020fb2d9fcb488580a6',
      file: 'libs/ui-ang/amount/amount.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectionStrategy, Component, Inject, Input, LOCALE_ID, OnChanges, Optional } from '@angular/core';\nimport {\n  getCurrencySymbol,\n  getLocaleNumberFormat,\n  getLocaleNumberSymbol,\n  getNumberOfCurrencyDigits,\n  NumberFormatStyle,\n  NumberSymbol,\n} from '@angular/common';\n\nimport BigNumber from 'bignumber.js';\nimport { AMOUNT_CONFIG_TOKEN, AmountConfig } from './amount.token-config';\nimport { CurrencyFormat, CurrencyFormatEnum } from './models/currency-format.model';\nimport { isRtl } from '@backbase/ui-ang/util';\n\ninterface LocaleConfiguration {\n  currencyFormat: string;\n  decimalFormat: string;\n  percentFormat: string;\n  decimalSymbol: string;\n  groupSymbol: string;\n  minusSymbol: string;\n  plusSymbol: string;\n  percentSymbol: string;\n  currencyGroupSymbol: string;\n  currencyDecimalSymbol: string;\n}\n\n/**\n * @name AmountComponent\n *\n * @description\n * Component to enable the amount to be represented in the currency format.\n * <br><br>\n *\n * ### Locale token\n * `LOCALE_ID` enables you to globally set the same locale for all instances of `AmountComponent` in your project.\n * Refer to https://angular.io/api/core/LOCALE_ID for more information.\n * <br><br>\n *\n * ### Global configuration token\n * `AMOUNT_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `AmountComponent` in your project.\n *\n * *Note:* The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not be able to overwrite it.\n *\n * The following properties can be overwritten using the token:\n *  - `abbreviate`\n *  - `currency`\n *  - `decimalPlaces`\n *  - `mapCurrency`\n *  - `trailingZeroes`\n *  - `currencyFormat`\n *  - `signPosition`\n *\n * The following is an example of how to use the token:\n *\n * ```typescript\n * import { AMOUNT_CONFIG_TOKEN } from '@backbase/ui-ang/amount';\n * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n * import { AppModule } from './app/app.module';\n *\n * const amountConfig = {\n *   abbreviate: true\n * }\n *\n * platformBrowserDynamic().bootstrapModule(AppModule, {\n *   providers: [{ provide: AMOUNT_CONFIG_TOKEN, useValue: amountConfig }]\n * });\n * ```\n *\n * @dynamic (to suppress error with resolving statics declarations during compilation)\n *\n * @a11y\n * The amount component doesn't provide any specific properties for accessibility. But handles accessibility internally.\n *\n */\n@Component({\n  selector: 'bb-amount-ui',\n  templateUrl: './amount.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class AmountComponent implements OnChanges {\n  private static readonly templates = {\n    sign: `<span class=\"sign\">{{}}</span>`,\n    currency: `<bdi class=\"symbol\">{{}}</bdi>`,\n    integer: `<span class=\"integer\">{{}}</span>`,\n    separator: `<span class=\"decimal-separator\">{{}}</span>`,\n    decimals: `<span class=\"decimals\">{{}}</span>`,\n    percent: `<span class=\"percent bb-d-inline-block\">{{}}</span>`,\n  };\n  private static readonly abbreviationConfig = {\n    minAmount: 100000,\n    suffixes: ['K', 'M', 'B', 'T'],\n  };\n  private static readonly maxSafeIntegerLength = Number.MAX_SAFE_INTEGER.toString().length;\n  private static localeConfig: LocaleConfiguration;\n\n  /**\n   * Determines currency type.\n   * If nothing provided, wouldn't be displayed.\n   *\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input()\n  get currency(): string {\n    return this._currency ?? this.overrideConfig?.currency ?? '';\n  }\n  set currency(value: AmountConfig['currency']) {\n    this._currency = value;\n  }\n\n  private _currency: AmountConfig['currency'];\n\n  /**\n   * Whether to display wide or narrow currency format.\n   * Default value 'wide'.\n   */\n  @Input()\n  get currencyFormat(): CurrencyFormat {\n    return this._currencyFormat ?? this.overrideConfig?.currencyFormat ?? CurrencyFormatEnum.WIDE;\n  }\n  set currencyFormat(value: AmountConfig['currencyFormat']) {\n    this._currencyFormat = value;\n  }\n\n  private _currencyFormat: AmountConfig['currencyFormat'];\n\n  /**\n   * If \"true\" currency will be hidden\n   * Can be used to display amounts without currency but still format them according to the currency\n   * (for example number of decimal points and groups symbol is based on a currency)\n   *\n   * Default value false.\n   */\n  @Input() hideCurrencySymbol = false;\n\n  /**\n   * If \"true\" and amount is positive adds plus sign at the beginning.\n   * Default value false.\n   */\n  @Input() showPlusSign = false;\n\n  /**\n   * Whether currency local should be transformed to symbol.\n   * Default value from injection token (if provided), else true.\n   *\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input()\n  get mapCurrency(): boolean {\n    return this._mapCurrency ?? this.overrideConfig?.mapCurrency ?? true;\n  }\n  set mapCurrency(value: AmountConfig['mapCurrency']) {\n    this._mapCurrency = value;\n  }\n\n  private _mapCurrency: AmountConfig['mapCurrency'];\n\n  /**\n   * Whether percent symbol should be shown.\n   * Default value false.\n   */\n  @Input() showPercent = false;\n\n  /**\n   * Whether abbreviation should be applied.\n   * Default value false.\n   *\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input()\n  get abbreviate(): boolean {\n    return this._abbreviate ?? this.overrideConfig?.abbreviate ?? false;\n  }\n  set abbreviate(value: AmountConfig['abbreviate']) {\n    this._abbreviate = value;\n  }\n\n  private _abbreviate: AmountConfig['abbreviate'];\n\n  /**\n   * Overrides amount of decimals places to display.\n   * Default value undefined, which will use currency default amount of decimals.\n   *\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input()\n  get decimalPlaces(): number | undefined {\n    return this._decimalPlaces ?? this.overrideConfig?.decimalPlaces;\n  }\n  set decimalPlaces(value: AmountConfig['decimalPlaces']) {\n    this._decimalPlaces = value;\n  }\n\n  private _decimalPlaces: AmountConfig['decimalPlaces'];\n\n  /**\n   * Whether to display trailing zeroes.\n   * Default value true.\n   *\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input()\n  get trailingZeroes(): boolean {\n    return this._trailingZeroes ?? this.overrideConfig?.trailingZeroes ?? true;\n  }\n  set trailingZeroes(value: AmountConfig['trailingZeroes']) {\n    this._trailingZeroes = value;\n  }\n\n  private _trailingZeroes: AmountConfig['trailingZeroes'];\n\n  /**\n   * Position of the sign, whether it is before or after the currency symbol.\n   * Only applies to negative numbers.\n   * \"left\" renders the sign before the currency.\n   * \"right\" renders the sign after the currency.\n   * Default to \"left\".\n   *\n   * Applied only for LTR locales.\n   *\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input()\n  get signPosition(): Required<AmountConfig['signPosition']> {\n    return this._signPosition ?? this.overrideConfig?.signPosition ?? 'left';\n  }\n  set signPosition(value: AmountConfig['signPosition']) {\n    this._signPosition = value;\n  }\n\n  private _signPosition: AmountConfig['signPosition'];\n\n  /**\n   * Receive amount in number or string format and converts into a floating-point number.\n   *\n   * Does not support comma separated numbers unless used with `DecimalPipe`.\n   * Locale is infer from `LOCALE_ID` and does not support any locales that is different from the app's `LOCALE_ID`.\n   */\n  @Input() amount!: string | number;\n\n  abbreviationSuffix?: string;\n\n  /**\n   * @deprecated Deprecated as of ui-ang@12. To be removed in ui-ang@14. No replacement will be introduced as it is made as a protected class attribute.\n   */\n  amountTemplate?: string;\n\n  protected get amountHtmlTemplate() {\n    return this.getAmountTemplate(this.transformedAmount);\n  }\n\n  private _amountValue = new BigNumber(NaN);\n  private groupSymbol!: string;\n  private decimalSymbol!: string;\n  private numberFormat!: BigNumber.Format;\n\n  constructor(\n    @Inject(LOCALE_ID) private readonly locale: string,\n    @Optional() @Inject(AMOUNT_CONFIG_TOKEN) private readonly overrideConfig: AmountConfig,\n  ) {\n    this.setupConfiguration();\n  }\n\n  ngOnChanges() {\n    if (this.isUnsafeAmount) {\n      console.warn('[bb-amount]: the amount was passed as a non safe number, the display can be wrong');\n    }\n\n    this.updateNumberFormat();\n\n    this._amountValue = new BigNumber(this.toParsableNumber(this.amount));\n  }\n\n  get isNumeric(): boolean {\n    return !this._amountValue.isNaN();\n  }\n\n  private get isPositive(): boolean {\n    return this._amountValue.isPositive();\n  }\n\n  private get isZero(): boolean {\n    return this._amountValue.isZero();\n  }\n\n  private get isUnsafeAmount(): boolean {\n    return (\n      typeof this.amount === 'number' &&\n      (this.amount > Number.MAX_SAFE_INTEGER ||\n        this.amount.toString().replace(/\\D/, '').length > AmountComponent.maxSafeIntegerLength)\n    );\n  }\n\n  private get configDecimalPlaces(): number {\n    return this.decimalPlaces === undefined ? getNumberOfCurrencyDigits(this.currency) : this.decimalPlaces;\n  }\n\n  /**\n   * Currency format depends on locale and could be represented for negative and\n   * positive values differently (separated by `;` symbol).\n   * See more http://cldr.unicode.org/translation/numbers-currency/number-patterns\n   *\n   * Example:\n   * en-NL locale: '¤ #,##0.00;¤ -#,##0.00'\n   */\n  private get amountFormat(): string {\n    const { currencyFormat, decimalFormat, percentFormat, minusSymbol, plusSymbol } = AmountComponent.localeConfig;\n    let formatPattern = decimalFormat;\n\n    if (this.showPercent) {\n      formatPattern = percentFormat;\n    }\n\n    if (this.currency && !this.hideCurrencySymbol) {\n      if (this.showPercent) {\n        console.warn(\n          '[bb-amount]: wrong configuration, `currency` and `showPercent` were set at the same time, therefore showPercent format will be ignored',\n        );\n      }\n\n      formatPattern = currencyFormat;\n    }\n\n    const generalPattern = formatPattern.split(';')[0];\n\n    if (this.isZero) {\n      return generalPattern;\n    } else if (this.isPositive) {\n      return this.showPlusSign ? this.amountFormatWithSign(formatPattern, plusSymbol, minusSymbol) : generalPattern;\n    }\n\n    return this.amountFormatWithSign(formatPattern, plusSymbol, minusSymbol);\n  }\n\n  private amountFormatWithSign(formatPattern: string, positiveSign: string, negativeSign: string) {\n    const sign = this.isPositive ? positiveSign : negativeSign;\n    const [generalPattern, negativePattern] = formatPattern.split(';');\n    const amountPattern = negativePattern ?? generalPattern;\n\n    if (amountPattern.includes(negativeSign)) {\n      // use angular formatting for case '¤ #,##0.00;¤ -#,##0.00'\n      return this.isPositive ? amountPattern.replace(negativeSign, positiveSign) : amountPattern;\n    }\n\n    if (this.signPosition === 'right' && !isRtl() && !/#.*¤/.test(amountPattern)) {\n      // do not replace if currency unit is the last in the amount patten (2.00 USD- is wrong)\n      return amountPattern.replace('¤', `¤${sign}`);\n    }\n\n    return `${sign}${amountPattern}`;\n  }\n\n  private get transformedAmount(): string {\n    const positiveAmount = this._amountValue.abs();\n    const configDecimalPlaces = this.configDecimalPlaces;\n    const shouldAbbreviate =\n      this.abbreviate && positiveAmount.isGreaterThanOrEqualTo(AmountComponent.abbreviationConfig.minAmount);\n\n    /**\n     * Example:\n     *\n     * {@link groupSymbol} = ','\n     * {@link decimalSymbol} = '.'\n     * {@link configDecimalPlaces} = '2'\n     *\n     * Here how regexp source looks line with config above: ([\\d,]+[.]\\d{2}).*\n     * This regexp has two selections:\n     * - selection for the group `([\\d,]+[.]\\d{2})` to match the decimal precision (no rounding)\n     * - and full string selection `.*` (used to replace full string with the group)\n     *\n     * REGEXP GROUP MATCHES ONLY THE AMOUNTS THAT HAVE TO BE UPDATED (TRIMMED)\n     *\n     * There are the cases when it does not have an effect, and it means that amount is already in appropriate format\n     */\n    const regexp = new RegExp(`([\\\\d${this.groupSymbol}]+[${this.decimalSymbol}]\\\\d{${configDecimalPlaces}}).*`, 'g');\n    const amount = shouldAbbreviate ? this.getAbbreviatedAmount(positiveAmount) : positiveAmount;\n    const amountDecimalPlaces = amount.decimalPlaces();\n    // In order to keep the precision keeping the original decimal places and replace with regexp\n    const formattedAmount = amount\n      // @ts-ignore\n      .toFormat(amountDecimalPlaces, BigNumber.ROUND_CEIL, this.numberFormat)\n      .replace(regexp, '$1');\n\n    // @ts-ignore\n    return this.getAmountWithZeroPaddings(formattedAmount, configDecimalPlaces, amountDecimalPlaces);\n  }\n\n  private getAmountWithZeroPaddings(\n    formattedAmount: string,\n    configDecimalPlaces: number,\n    amountDecimalPlaces: number,\n  ): string {\n    if (!this.trailingZeroes || amountDecimalPlaces >= configDecimalPlaces) {\n      return formattedAmount;\n    }\n\n    const amountOfZeros = configDecimalPlaces - amountDecimalPlaces;\n    let stringToAppend = '0'.repeat(amountOfZeros);\n\n    if (!formattedAmount.includes(this.decimalSymbol)) {\n      stringToAppend = this.decimalSymbol + stringToAppend;\n    }\n\n    return formattedAmount + stringToAppend;\n  }\n\n  private setupConfiguration() {\n    if (!AmountComponent.localeConfig) {\n      AmountComponent.localeConfig = {\n        currencyFormat: getLocaleNumberFormat(this.locale, NumberFormatStyle.Currency),\n        decimalFormat: getLocaleNumberFormat(this.locale, NumberFormatStyle.Decimal),\n        percentFormat: getLocaleNumberFormat(this.locale, NumberFormatStyle.Percent),\n        decimalSymbol: getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal),\n        groupSymbol: getLocaleNumberSymbol(this.locale, NumberSymbol.Group),\n        currencyGroupSymbol: getLocaleNumberSymbol(this.locale, NumberSymbol.CurrencyGroup),\n        currencyDecimalSymbol: getLocaleNumberSymbol(this.locale, NumberSymbol.CurrencyDecimal),\n        minusSymbol: getLocaleNumberSymbol(this.locale, NumberSymbol.MinusSign),\n        plusSymbol: getLocaleNumberSymbol(this.locale, NumberSymbol.PlusSign),\n        percentSymbol: getLocaleNumberSymbol(this.locale, NumberSymbol.PercentSign),\n      };\n    }\n  }\n\n  private updateNumberFormat(): void {\n    const { decimalSymbol, currencyDecimalSymbol, groupSymbol, currencyGroupSymbol } = AmountComponent.localeConfig;\n\n    this.groupSymbol = this.currency ? currencyGroupSymbol : groupSymbol;\n    this.decimalSymbol = this.currency ? currencyDecimalSymbol : decimalSymbol;\n    this.numberFormat = {\n      groupSeparator: this.groupSymbol,\n      decimalSeparator: this.decimalSymbol,\n      groupSize: 3,\n    };\n  }\n\n  /**\n   * Converts original amount to abbreviated\n   * Max abbreviated suffix value is 'T' (trillion) see {@link AmountComponent.abbreviationConfig}\n   */\n  private getAbbreviatedAmount(positiveAmount: BigNumber): BigNumber {\n    const suffixes = AmountComponent.abbreviationConfig.suffixes;\n    const config = { suffix: suffixes[0], amount: positiveAmount.shiftedBy(-3) };\n\n    for (let i = 1; i < suffixes.length; i++) {\n      if (!config.amount.isGreaterThanOrEqualTo(1000)) {\n        break;\n      }\n\n      config.suffix = suffixes[i];\n      config.amount = config.amount.shiftedBy(-3);\n    }\n\n    this.abbreviationSuffix = config.suffix;\n\n    return config.amount;\n  }\n\n  private getAmountTemplate(amount: string): string {\n    const { percentSymbol, minusSymbol, plusSymbol } = AmountComponent.localeConfig;\n    const signSymbol = this.isPositive ? plusSymbol : minusSymbol;\n    const currencySymbol = this.mapCurrency\n      ? getCurrencySymbol(this.currency, this.currencyFormat, this.locale)\n      : this.currency;\n\n    return this.amountFormat\n      .replace(signSymbol, this.fillTemplate('sign', signSymbol))\n      .replace(/[#0,.]+/g, this.wrapAmount(amount))\n      .replace('¤', this.fillTemplate('currency', currencySymbol))\n      .replace('%', this.fillTemplate('percent', percentSymbol));\n  }\n\n  private wrapAmount(amount: string): string {\n    const [integer, decimals] = amount.split(this.decimalSymbol);\n\n    const numberPart =\n      this.fillTemplate('integer', integer) +\n      (decimals ? this.fillTemplate('separator', this.decimalSymbol) + this.fillTemplate('decimals', decimals) : '');\n\n    return `<span class=\"bb-amount__number-wrapper\">${numberPart}</span>`;\n  }\n\n  private fillTemplate(templateKey: keyof typeof AmountComponent.templates, value: string): string {\n    return AmountComponent.templates[templateKey].replace('{{}}', value);\n  }\n\n  // ensure BigNumber can properly read numbers from other locales that have commas\n  private toParsableNumber(amount: string | number): string | number {\n    return typeof amount === 'string' ? amount.replace(',', '.') : amount;\n  }\n}\n",
      properties: [
        {
          name: 'currencyDecimalSymbol',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 26,
        },
        {
          name: 'currencyFormat',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 17,
        },
        {
          name: 'currencyGroupSymbol',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 25,
        },
        {
          name: 'decimalFormat',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 18,
        },
        {
          name: 'decimalSymbol',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 20,
        },
        {
          name: 'groupSymbol',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 21,
        },
        {
          name: 'minusSymbol',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 22,
        },
        {
          name: 'percentFormat',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 19,
        },
        {
          name: 'percentSymbol',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 24,
        },
        {
          name: 'plusSymbol',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 23,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'MenuJsonItem',
      id: 'interface-MenuJsonItem-1d3ebd66c40fb04e0118df0b70dd8b24162b637550e11397bc6a33b67af5b49986ab44ee9dc2c735b8888f547010b5d9d7c3f861ebd81f876ddec1c8ee04fd9e',
      file: 'tools/scripts/dso/update-menu-tree.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import menuConfig from '../../../libs/docs/menu.json';\nimport { nameToPath } from './name-to-path';\n\nconst fs = require('fs');\nconst pathToAssets = 'apps/design-system-app/src/assets';\n\ninterface MenuJsonItem {\n  name: string;\n  path?: string;\n  children?: MenuJsonItem[];\n  ios?: boolean;\n  android?: boolean;\n  web?: boolean;\n  webTheme?: boolean;\n  hide?: boolean;\n}\n\ninterface MenuTreeTsItem {\n  name: string;\n  position: number;\n  collapsible: boolean;\n  children?: MenuTreeTsItem[];\n  showExpand?: boolean;\n  url?: string;\n}\n\nconst getUrlForGroupItem = (\n  item: MenuJsonItem,\n  parentItemParsedUrl?: string,\n  defaultChildItem?: MenuJsonItem,\n): string => {\n  const itemNameParsed = nameToPath(item.name);\n  let url = parentItemParsedUrl ? parentItemParsedUrl : itemNameParsed;\n\n  if (!item.path) {\n    if (defaultChildItem) {\n      const defaultChildNameParsed = nameToPath(defaultChildItem.name);\n      url = `${url}/${defaultChildNameParsed}`;\n    }\n  }\n\n  return url;\n};\n\nconst createMenuTree = (\n  items: MenuJsonItem[],\n  parentItemParsedName?: string,\n  parsedItemUrl?: string,\n): MenuTreeTsItem[] => {\n  const result: MenuTreeTsItem[] = [];\n  items.forEach((item: MenuJsonItem, index: number) => {\n    if (!item.hide) {\n      const itemNameParsed = nameToPath(item.name);\n      const parentItemParsedNameUpdated = parentItemParsedName\n        ? `${parentItemParsedName}-${itemNameParsed}`\n        : itemNameParsed;\n      const parsedItemUrlUpdated = parsedItemUrl ? `${parsedItemUrl}/${itemNameParsed}` : itemNameParsed;\n\n      const menuTreeItem: MenuTreeTsItem = {\n        name: itemNameParsed,\n        position: index,\n        children: item.children ? createMenuTree(item.children, parentItemParsedNameUpdated, parsedItemUrlUpdated) : [],\n        collapsible: !!item.children,\n      };\n\n      if (item.children) {\n        menuTreeItem.showExpand = true;\n        const defaultChildItem = item.children.find((child: MenuJsonItem) => !child.children);\n        menuTreeItem.url = getUrlForGroupItem(item, parsedItemUrlUpdated, defaultChildItem);\n      }\n\n      result.push(menuTreeItem);\n    }\n  });\n\n  return result;\n};\n\nconst menuTree = createMenuTree(menuConfig);\n\nconst treeData = `import { MenuTree } from './menu-tree.interface'; \\n\n  export const menuTree: Array<MenuTree> = ${JSON.stringify(menuTree, null, '\\t')}`;\n\nfs.writeFile(`${pathToAssets}/menu-tree.ts`, treeData, (err: any) =>\n  console.log(err || `menu-tree.ts is updated by menu.json`),\n);\n",
      properties: [
        {
          name: 'android',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 17,
        },
        {
          name: 'children',
          deprecated: false,
          deprecationMessage: '',
          type: 'MenuJsonItem[]',
          indexKey: '',
          optional: true,
          description: '',
          line: 15,
        },
        {
          name: 'hide',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 20,
        },
        {
          name: 'ios',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 16,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 13,
        },
        {
          name: 'path',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 14,
        },
        {
          name: 'web',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 18,
        },
        {
          name: 'webTheme',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 19,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'MenuTreeTsItem',
      id: 'interface-MenuTreeTsItem-1d3ebd66c40fb04e0118df0b70dd8b24162b637550e11397bc6a33b67af5b49986ab44ee9dc2c735b8888f547010b5d9d7c3f861ebd81f876ddec1c8ee04fd9e',
      file: 'tools/scripts/dso/update-menu-tree.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import menuConfig from '../../../libs/docs/menu.json';\nimport { nameToPath } from './name-to-path';\n\nconst fs = require('fs');\nconst pathToAssets = 'apps/design-system-app/src/assets';\n\ninterface MenuJsonItem {\n  name: string;\n  path?: string;\n  children?: MenuJsonItem[];\n  ios?: boolean;\n  android?: boolean;\n  web?: boolean;\n  webTheme?: boolean;\n  hide?: boolean;\n}\n\ninterface MenuTreeTsItem {\n  name: string;\n  position: number;\n  collapsible: boolean;\n  children?: MenuTreeTsItem[];\n  showExpand?: boolean;\n  url?: string;\n}\n\nconst getUrlForGroupItem = (\n  item: MenuJsonItem,\n  parentItemParsedUrl?: string,\n  defaultChildItem?: MenuJsonItem,\n): string => {\n  const itemNameParsed = nameToPath(item.name);\n  let url = parentItemParsedUrl ? parentItemParsedUrl : itemNameParsed;\n\n  if (!item.path) {\n    if (defaultChildItem) {\n      const defaultChildNameParsed = nameToPath(defaultChildItem.name);\n      url = `${url}/${defaultChildNameParsed}`;\n    }\n  }\n\n  return url;\n};\n\nconst createMenuTree = (\n  items: MenuJsonItem[],\n  parentItemParsedName?: string,\n  parsedItemUrl?: string,\n): MenuTreeTsItem[] => {\n  const result: MenuTreeTsItem[] = [];\n  items.forEach((item: MenuJsonItem, index: number) => {\n    if (!item.hide) {\n      const itemNameParsed = nameToPath(item.name);\n      const parentItemParsedNameUpdated = parentItemParsedName\n        ? `${parentItemParsedName}-${itemNameParsed}`\n        : itemNameParsed;\n      const parsedItemUrlUpdated = parsedItemUrl ? `${parsedItemUrl}/${itemNameParsed}` : itemNameParsed;\n\n      const menuTreeItem: MenuTreeTsItem = {\n        name: itemNameParsed,\n        position: index,\n        children: item.children ? createMenuTree(item.children, parentItemParsedNameUpdated, parsedItemUrlUpdated) : [],\n        collapsible: !!item.children,\n      };\n\n      if (item.children) {\n        menuTreeItem.showExpand = true;\n        const defaultChildItem = item.children.find((child: MenuJsonItem) => !child.children);\n        menuTreeItem.url = getUrlForGroupItem(item, parsedItemUrlUpdated, defaultChildItem);\n      }\n\n      result.push(menuTreeItem);\n    }\n  });\n\n  return result;\n};\n\nconst menuTree = createMenuTree(menuConfig);\n\nconst treeData = `import { MenuTree } from './menu-tree.interface'; \\n\n  export const menuTree: Array<MenuTree> = ${JSON.stringify(menuTree, null, '\\t')}`;\n\nfs.writeFile(`${pathToAssets}/menu-tree.ts`, treeData, (err: any) =>\n  console.log(err || `menu-tree.ts is updated by menu.json`),\n);\n",
      properties: [
        {
          name: 'children',
          deprecated: false,
          deprecationMessage: '',
          type: 'MenuTreeTsItem[]',
          indexKey: '',
          optional: true,
          description: '',
          line: 27,
        },
        {
          name: 'collapsible',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 26,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 24,
        },
        {
          name: 'position',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 25,
        },
        {
          name: 'showExpand',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 28,
        },
        {
          name: 'url',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 29,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'MigrateError',
      id: 'interface-MigrateError-d0397e7d152acc50309aa6667733ee51c3ffd1d00da6f2e480c8b1c546babad6d01265102da79b5779e42b77173f5545e28e8c7f38c51640d160bdf3b8c2b02a',
      file: 'libs/ui-ang/migrations/src/utils/parse-template.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import type { Node, ParseError } from '@angular/compiler';\n\nexport class ParseTreeResult {\n  constructor(\n    public rootNodes: Node[],\n    public errors: ParseError[],\n  ) {}\n}\n\nexport interface MigrateError {\n  type: string | undefined;\n  error: ParseError;\n}\n\nexport interface ParseResult {\n  tree: ParseTreeResult | undefined;\n  errors: MigrateError[];\n}\n\nexport function parseTemplate(compiler: any, template: string): ParseResult {\n  let parsed: ParseTreeResult;\n\n  try {\n    // Note: we use the HtmlParser here, instead of the `parseTemplate` function, because the\n    // latter returns an Ivy AST, not an HTML AST. The HTML AST has the advantage of preserving\n    // interpolated text as text nodes containing a mixture of interpolation tokens and text tokens,\n    // rather than turning them into `BoundText` nodes like the Ivy AST does. This allows us to\n    // easily get the text-only ranges without having to reconstruct the original text.\n    parsed = new compiler.HtmlParser().parse(template, '', {\n      // Allows for ICUs to be parsed.\n      tokenizeExpansionForms: true,\n      // Explicitly disable blocks so that their characters are treated as plain text.\n      tokenizeBlocks: true,\n      preserveLineEndings: true,\n    });\n\n    // Don't migrate invalid templates.\n    if (parsed.errors && parsed.errors.length > 0) {\n      const errors = parsed.errors.map((e) => ({ type: 'parse', error: e }));\n\n      return { tree: undefined, errors };\n    }\n  } catch (e: any) {\n    return { tree: undefined, errors: [{ type: 'parse', error: e }] };\n  }\n\n  return { tree: parsed, errors: [] };\n}\n",
      properties: [
        {
          name: 'error',
          deprecated: false,
          deprecationMessage: '',
          type: 'ParseError',
          indexKey: '',
          optional: false,
          description: '',
          line: 12,
        },
        {
          name: 'type',
          deprecated: false,
          deprecationMessage: '',
          type: 'string | undefined',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'MoneyProtectionStatusConfig',
      id: 'interface-MoneyProtectionStatusConfig-eaef46a30b13c02f3890ce91b28af0efd12d078b3f37f17245b74a25228bf44bbfb82b26ed97564467dad26dd262f777454682fcf57cb3dac268744f564bdb77',
      file: 'libs/ui-ang/money-protection/constants.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\nexport enum MoneyProtectionStatusEnum {\n  Yes = 'yes',\n  No = 'no',\n  NA = 'n/a',\n}\nexport interface MoneyProtectionStatusTexts {\n  message: string;\n}\nexport interface MoneyProtectionStatusConfig {\n  messagePerStatus: {\n    [MoneyProtectionStatusEnum.Yes]?: MoneyProtectionStatusTexts;\n    [MoneyProtectionStatusEnum.No]?: MoneyProtectionStatusTexts;\n    [MoneyProtectionStatusEnum.NA]?: MoneyProtectionStatusTexts;\n  };\n  disclaimer?: string;\n}\n/**\n * Injection token used to provide static money protection status component configuration.\n */\nexport const BB_MONEY_PROTECTION_STATUS_CONFIG_TOKEN = new InjectionToken<MoneyProtectionStatusConfig>(\n  'BB_MONEY_PROTECTION_STATUS_CONFIGURATION_INJECTION_TOKEN',\n);\n/**\n * Injection token used to provide static banner component configuration.\n *\n * @usageNotes\n *\n * Create a component that will contain you banner code and responsiveness logic.\n *\n * ```typescript\n * @Component({\n *   selector: 'bb-money-protection-sample-banner',\n *   template: `\n *     <span>Money Protection banner</span>\n *   `,\n * })\n * export class MoneyProtectionSampleBannerShowcaseComponent {}\n * ```\n *\n * Provide this component through providers at application level.\n *\n * ```typescript\n * providers: [\n *   {\n *     provide: BB_MONEY_PROTECTION_BANNER_CONFIG_TOKEN,\n *     useValue: MoneyProtectionSampleBannerShowcaseComponent,\n *   },\n * ]\n * ```\n */\nexport const BB_MONEY_PROTECTION_BANNER_CONFIG_TOKEN = new InjectionToken<string>(\n  'BB_MONEY_PROTECTION_BANNER_CONFIGURATION_INJECTION_TOKEN',\n  {\n    providedIn: 'root',\n    factory: () => '',\n  },\n);\n",
      properties: [
        {
          name: 'disclaimer',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 16,
        },
        {
          name: 'messagePerStatus',
          deprecated: false,
          deprecationMessage: '',
          type: 'literal type',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'MoneyProtectionStatusTexts',
      id: 'interface-MoneyProtectionStatusTexts-eaef46a30b13c02f3890ce91b28af0efd12d078b3f37f17245b74a25228bf44bbfb82b26ed97564467dad26dd262f777454682fcf57cb3dac268744f564bdb77',
      file: 'libs/ui-ang/money-protection/constants.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\nexport enum MoneyProtectionStatusEnum {\n  Yes = 'yes',\n  No = 'no',\n  NA = 'n/a',\n}\nexport interface MoneyProtectionStatusTexts {\n  message: string;\n}\nexport interface MoneyProtectionStatusConfig {\n  messagePerStatus: {\n    [MoneyProtectionStatusEnum.Yes]?: MoneyProtectionStatusTexts;\n    [MoneyProtectionStatusEnum.No]?: MoneyProtectionStatusTexts;\n    [MoneyProtectionStatusEnum.NA]?: MoneyProtectionStatusTexts;\n  };\n  disclaimer?: string;\n}\n/**\n * Injection token used to provide static money protection status component configuration.\n */\nexport const BB_MONEY_PROTECTION_STATUS_CONFIG_TOKEN = new InjectionToken<MoneyProtectionStatusConfig>(\n  'BB_MONEY_PROTECTION_STATUS_CONFIGURATION_INJECTION_TOKEN',\n);\n/**\n * Injection token used to provide static banner component configuration.\n *\n * @usageNotes\n *\n * Create a component that will contain you banner code and responsiveness logic.\n *\n * ```typescript\n * @Component({\n *   selector: 'bb-money-protection-sample-banner',\n *   template: `\n *     <span>Money Protection banner</span>\n *   `,\n * })\n * export class MoneyProtectionSampleBannerShowcaseComponent {}\n * ```\n *\n * Provide this component through providers at application level.\n *\n * ```typescript\n * providers: [\n *   {\n *     provide: BB_MONEY_PROTECTION_BANNER_CONFIG_TOKEN,\n *     useValue: MoneyProtectionSampleBannerShowcaseComponent,\n *   },\n * ]\n * ```\n */\nexport const BB_MONEY_PROTECTION_BANNER_CONFIG_TOKEN = new InjectionToken<string>(\n  'BB_MONEY_PROTECTION_BANNER_CONFIGURATION_INJECTION_TOKEN',\n  {\n    providedIn: 'root',\n    factory: () => '',\n  },\n);\n",
      properties: [
        {
          name: 'message',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 8,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Navigator',
      id: 'interface-Navigator-6e6095916ce4ae542c4c13c957de3b4d63f13ba66b146fdc6b061ab80d06e8f6cb27a9db7ebd447755b134c98a342472bc9a55f9f3a2c3cbeeec3d02352a3d1c',
      file: 'libs/ui-ang/file-attachment/file-attachment.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  ChangeDetectionStrategy,\n  Component,\n  EventEmitter,\n  Inject,\n  Input,\n  OnInit,\n  Output,\n  Renderer2,\n} from '@angular/core';\nimport { DOCUMENT } from '@angular/common';\nimport { isObservable, Observable } from 'rxjs';\nimport { take } from 'rxjs/operators';\nimport { getDynamicId } from '@backbase/ui-ang/util';\n\nexport interface FileSize {\n  value: number;\n  unit: string;\n}\n\ndeclare global {\n  interface Navigator {\n    msSaveBlob?: (blob: any, defaultName?: string) => boolean;\n  }\n}\n\n/**\n * @name FileAttachmentComponent\n *\n * ### Accessibility\n * Current component provide option to pass needed accessibility\n * attributes:\n *  - id\n *  - aria-label\n *  - aria-describedby\n *\n * @description\n * Component displays file attachment.\n *\n * @dynamic (to suppress error with resolving statics declarations during compilation)\n */\n\n@Component({\n  selector: 'bb-file-attachment-ui',\n  templateUrl: './file-attachment.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class FileAttachmentComponent implements OnInit {\n  /**\n   * Set file name (required).\n   */\n  @Input()\n  get name(): string | undefined {\n    return this._name;\n  }\n  set name(value: string | undefined) {\n    if (value?.trim()) {\n      this._name = value;\n      this.fileType = this.getFileType(value);\n    } else {\n      throw new Error(`\"name\" input is invalid in \"${this.constructor.name}\"`);\n    }\n  }\n\n  /**\n   * Set file size (required). Accepts `number` or `string`.\n   */\n  @Input()\n  set size(value: number | string | undefined) {\n    if (value !== undefined) {\n      const valueAsNumber = Math.trunc(Number(value));\n\n      this._sizeInUnits = this.formatBytes(valueAsNumber, 2);\n    }\n  }\n\n  /**\n   * Get file size in information units (Bytes, Kbs, etc.).\n   */\n  get sizeInUnits() {\n    return this._sizeInUnits;\n  }\n\n  /**\n   * Set file content (required if disabled property is not set to true).\n   */\n  @Input()\n  get fileContent(): Observable<ArrayBuffer> | undefined {\n    return this._fileContent;\n  }\n  set fileContent(value: Observable<ArrayBuffer> | undefined) {\n    if (value && isObservable(value)) {\n      this._fileContent = value;\n    } else {\n      throw new Error(`\"fileContent\" stream input is invalid in \"${this.constructor.name}\"`);\n    }\n  }\n\n  /**\n   * Loading indicator flag. Defaults to false.\n   */\n  @Input() loading = false;\n\n  /**\n   * Show delete button flag. Defaults to false.\n   */\n  @Input() deletable = false;\n\n  /**\n   * Disabled state flag. Defaults to false.\n   */\n  @Input() disabled = false;\n\n  /**\n   * The flag to indicate whether the file-attachment should fill the container that it is in. Defaults to 'false'.\n   */\n  @Input() block = false;\n\n  /**\n   * Set aria-describedby  with an element id that contains a detailed decription of the widget.\n   */\n  @Input('aria-describedby') ariaDescribedby?: string = 'file-attachment-card-body';\n\n  /**\n   * The id for attachment card.\n   */\n  @Input('id') cardId?: string = 'file-attachment-card-body_' + getDynamicId();\n\n  /**\n   * Accessible label for delete button when control does not need to render label tag.\n   */\n  @Input('aria-label') ariaLabel?: string = 'Delete file';\n\n  /**\n   * Event emitted on delete button click.\n   */\n  @Output() delete = new EventEmitter<void>();\n\n  /**\n   * File type which is determined by file extension. Defaults to 'unknown'.\n   */\n  fileType = 'unknown';\n\n  private _sizeInUnits: FileSize | undefined;\n  private _name: string | undefined;\n  private _fileContent: Observable<ArrayBuffer> | undefined;\n\n  constructor(\n    @Inject(DOCUMENT) private readonly document: Document,\n    private readonly renderer: Renderer2,\n  ) {}\n\n  ngOnInit() {\n    if (!this._name) {\n      throw new Error(`\"name\" input is required in \"${this.constructor.name}\"`);\n    }\n\n    if (!this.disabled && !this._fileContent) {\n      throw new Error(`\"fileContent\" input is required in \"${this.constructor.name}\"`);\n    }\n  }\n\n  /**\n   * Download attachment method.\n   *\n   * @param $event Download button click event\n   */\n  onDownload($event: Event) {\n    $event.stopPropagation();\n\n    if (this.fileContent) {\n      this.fileContent.pipe(take(1)).subscribe({\n        next: (response: ArrayBuffer) => {\n          if (!this.document.defaultView) {\n            return;\n          }\n          const window = this.document.defaultView;\n          const blob = new window.Blob([response]);\n\n          if (window.navigator.msSaveBlob) {\n            window.navigator.msSaveBlob(blob, this.name);\n          } else {\n            const fileURL = window.URL.createObjectURL(blob);\n            const link = this.renderer.createElement('a');\n\n            link.setAttribute('href', fileURL);\n            link.setAttribute('target', '_blank');\n            link.setAttribute('download', this.name || '');\n            link.click();\n            URL.revokeObjectURL(fileURL);\n          }\n        },\n      });\n    }\n  }\n\n  /**\n   * Delete attachment event emitter.\n   *\n   * @param event Delete button click event.\n   */\n  onDelete(event: MouseEvent) {\n    event.stopPropagation();\n    this.delete.emit();\n  }\n\n  private getFileType(fileName: string): string {\n    return fileName.includes('.') ? fileName.toLowerCase().split('.').pop() || 'unknown' : 'unknown';\n  }\n\n  private formatBytes(bytes: number, decimals: number): FileSize {\n    if (bytes === 0) {\n      return {\n        value: 0,\n        unit: 'Bytes',\n      };\n    }\n\n    const k = 1024;\n    const dm = decimals <= 0 ? 0 : decimals || 2;\n    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];\n    const i = Math.floor(Math.log(bytes) / Math.log(k));\n\n    return {\n      value: parseFloat((bytes / Math.pow(k, i)).toFixed(dm)),\n      unit: sizes[i],\n    };\n  }\n}\n",
      properties: [
        {
          name: 'msSaveBlob',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: true,
          description: '',
          line: 23,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Notification',
      id: 'interface-Notification-852df10ca697b99ed9c8f4ac3b123a74a53f18d3b9b316c8542eae96b9484210d1e6c19292083d37419a53411fe64c14d2c2721c337bdfd1eb960159cd2bb7f7',
      file: 'libs/ui-ang/notification/notification.service.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Injectable, TemplateRef } from '@angular/core';\nimport { NotificationComponent, NotificationType } from './notification.component';\nimport { AppendToDomService } from './append-to-dom.service';\nimport { Subject, Observable, of, NEVER } from 'rxjs';\nimport { delay, startWith, switchMap } from 'rxjs/operators';\n\nexport interface Notification {\n  /**\n   * The header for the notification.\n   */\n  header: string | TemplateRef<any>;\n  /**\n   * The message template for the notification. Defaults to an empty string\n   */\n  message: string | TemplateRef<any>;\n  /**\n   * The type modifier for the notification. Defaults to 'info'\n   */\n  modifier?: NotificationType;\n  /**\n   * Whether the notification is dismissible. Defaults to true\n   */\n  dismissible?: boolean;\n  /**\n   * The time the notification will appear for in ms.\n   * 0 will result in the notifaction remaining open.\n   */\n  ttl?: number;\n  /**\n   * The text for the primary action button.\n   * Will throw an error if unset and primary action set.\n   */\n  primaryActionText?: string;\n  /**\n   * A callback function for the primary action.\n   * Required to show the button.\n   */\n  primaryAction?: Function;\n  /**\n   * The text for the secondary action button.\n   * Will throw an error if unset and secondary action set.\n   */\n  secondaryActionText?: string;\n  /**\n   * A callback function for the secondary action.\n   * Required to show the button.\n   */\n  secondaryAction?: Function;\n  /**\n   * A callback function for the manually close action.\n   */\n  closeAction?: Function;\n  /**\n   * A callback function for the host click action.\n   */\n  hostAction?: Function;\n  /**\n   * The context for notification header template.\n   */\n  headerContext?: any;\n  /**\n   * The context for notification message template.\n   */\n  messageContext?: any;\n  /**\n   * The primary action template for the notification.\n   */\n  primaryActionTemplate?: TemplateRef<any>;\n  /**\n   * The secondary action template for the notification.\n   */\n  secondaryActionTemplate?: TemplateRef<any>;\n  /**\n   * Autofocus will cause the component to be focused on the first rendering.\n   */\n  autofocus?: boolean;\n}\n\n/**\n * @name NotificationService\n *\n * @description\n * Service to handle the display of notifications within the application.\n * This service provides methods to show notifications with various options\n * such as header, message, actions, templates, and more.\n *\n * @usageNotes\n * Inject the NotificationService into your component or service to use it.\n *\n * Example:\n *\n * ```typescript\n * constructor(private notificationService: NotificationService) {}\n *\n * this.notificationService.showNotification({\n *   header: 'Notification Header',\n *   message: 'This is a notification message.',\n *   primaryActionText: 'Confirm',\n *   primaryAction: () => { console.log('Primary action executed'); },\n *   secondaryActionText: 'Cancel',\n *   secondaryAction: () => { console.log('Secondary action executed'); },\n *   ttl: 5000,\n *   modifier: 'success',\n * });\n * ```\n */\n@Injectable({\n  providedIn: 'root',\n})\nexport class NotificationService {\n  constructor(private readonly appendtoDomService: AppendToDomService) {}\n\n  /**\n   * Displays a notification with the provided options.\n   * The notification is automatically added to the DOM.\n   *\n   * @param {Notification} options - The options for the notification.\n   * @param {string} options.header - The header text of the notification.\n   * @param {string} options.message - The message text of the notification.\n   * @param {boolean} [options.dismissible=true] - Whether the notification can be dismissed.\n   * @param {number} [options.ttl=3000] - Time to live for the notification in milliseconds.\n   * @param {string} [options.modifier='info'] - The style modifier for the notification.\n   * @param {object} [options.headerContext={}] - The context for the notification header template.\n   * @param {object} [options.messageContext={}] - The context for the notification message template.\n   * @param {string} [options.primaryActionText] - The text for the primary action button.\n   * @param {Function} [options.primaryAction] - The callback function for the primary action.\n   * @param {string} [options.secondaryActionText] - The text for the secondary action button.\n   * @param {Function} [options.secondaryAction] - The callback function for the secondary action.\n   * @param {Function} [options.closeAction] - The callback function for the close action.\n   * @param {Function} [options.hostAction] - The callback function for the host click action.\n   * @param {TemplateRef<any>} [options.primaryActionTemplate] - The template for the primary action.\n   * @param {TemplateRef<any>} [options.secondaryActionTemplate] - The template for the secondary action.\n   * @param {boolean} [options.autofocus=false] - Whether to autofocus the notification on render.\n   *\n   * @returns {Function} A function to hide the notification.\n   */\n  showNotification({\n    header,\n    message,\n    dismissible = true,\n    ttl = 3000,\n    modifier = 'info',\n    headerContext = {},\n    messageContext = {},\n    primaryActionText,\n    primaryAction,\n    secondaryActionText,\n    secondaryAction,\n    closeAction,\n    hostAction,\n    primaryActionTemplate,\n    secondaryActionTemplate,\n    autofocus = false,\n  }: Notification): () => void {\n    const res = this.appendtoDomService.appendComponentToRoot(NotificationComponent, autofocus);\n\n    const componentInstance = res.componentInstance as NotificationComponent;\n    componentInstance.message = message;\n    componentInstance.modifier = modifier;\n    componentInstance.dismissible = dismissible;\n    componentInstance.header = header;\n    componentInstance.primaryActionText = primaryActionText;\n    componentInstance.primaryAction = primaryAction;\n    componentInstance.secondaryActionText = secondaryActionText;\n    componentInstance.secondaryAction = secondaryAction;\n    componentInstance.closeAction = closeAction;\n    componentInstance.hostAction = hostAction;\n    componentInstance.headerContext = headerContext;\n    componentInstance.messageContext = messageContext;\n    componentInstance.primaryActionTemplate = primaryActionTemplate;\n    componentInstance.secondaryActionTemplate = secondaryActionTemplate;\n\n    return this.createHideNotificationFunction(\n      res.unmountComponent,\n      ttl,\n      componentInstance.close,\n      componentInstance.pauseNotification,\n    );\n  }\n\n  private createHideNotificationFunction(\n    hideFn: () => void,\n    ttl: number = 0,\n    closeStream: Observable<any>,\n    pauseNotification: Observable<any>,\n  ): () => void {\n    const hideSubject = new Subject<void>();\n    const hideNotification = () => {\n      hideFn();\n      hideSubscription.unsubscribe();\n      closeSubscription.unsubscribe();\n    };\n    const closeSubscription = closeStream.subscribe({ next: hideNotification });\n\n    const hideSubscription = hideSubject\n      .pipe(\n        switchMap(() => {\n          return pauseNotification.pipe(startWith(false));\n        }),\n        switchMap((enter) => {\n          return enter ? NEVER : of(null).pipe(delay(ttl));\n        }),\n      )\n      .subscribe({ next: hideNotification });\n\n    if (ttl > 0) {\n      hideSubject.next();\n    }\n\n    return hideNotification;\n  }\n}\n",
      properties: [
        {
          name: 'autofocus',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '<p>Autofocus will cause the component to be focused on the first rendering.</p>\n',
          line: 76,
          rawdescription: '\n\nAutofocus will cause the component to be focused on the first rendering.\n',
        },
        {
          name: 'closeAction',
          deprecated: false,
          deprecationMessage: '',
          type: 'Function',
          indexKey: '',
          optional: true,
          description: '<p>A callback function for the manually close action.</p>\n',
          line: 52,
          rawdescription: '\n\nA callback function for the manually close action.\n',
        },
        {
          name: 'dismissible',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '<p>Whether the notification is dismissible. Defaults to true</p>\n',
          line: 23,
          rawdescription: '\n\nWhether the notification is dismissible. Defaults to true\n',
        },
        {
          name: 'header',
          deprecated: false,
          deprecationMessage: '',
          type: 'string | TemplateRef<any>',
          indexKey: '',
          optional: false,
          description: '<p>The header for the notification.</p>\n',
          line: 11,
          rawdescription: '\n\nThe header for the notification.\n',
        },
        {
          name: 'headerContext',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '<p>The context for notification header template.</p>\n',
          line: 60,
          rawdescription: '\n\nThe context for notification header template.\n',
        },
        {
          name: 'hostAction',
          deprecated: false,
          deprecationMessage: '',
          type: 'Function',
          indexKey: '',
          optional: true,
          description: '<p>A callback function for the host click action.</p>\n',
          line: 56,
          rawdescription: '\n\nA callback function for the host click action.\n',
        },
        {
          name: 'message',
          deprecated: false,
          deprecationMessage: '',
          type: 'string | TemplateRef<any>',
          indexKey: '',
          optional: false,
          description: '<p>The message template for the notification. Defaults to an empty string</p>\n',
          line: 15,
          rawdescription: '\n\nThe message template for the notification. Defaults to an empty string\n',
        },
        {
          name: 'messageContext',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: true,
          description: '<p>The context for notification message template.</p>\n',
          line: 64,
          rawdescription: '\n\nThe context for notification message template.\n',
        },
        {
          name: 'modifier',
          deprecated: false,
          deprecationMessage: '',
          type: 'NotificationType',
          indexKey: '',
          optional: true,
          description: '<p>The type modifier for the notification. Defaults to &#39;info&#39;</p>\n',
          line: 19,
          rawdescription: "\n\nThe type modifier for the notification. Defaults to 'info'\n",
        },
        {
          name: 'primaryAction',
          deprecated: false,
          deprecationMessage: '',
          type: 'Function',
          indexKey: '',
          optional: true,
          description: '<p>A callback function for the primary action.\nRequired to show the button.</p>\n',
          line: 38,
          rawdescription: '\n\nA callback function for the primary action.\nRequired to show the button.\n',
        },
        {
          name: 'primaryActionTemplate',
          deprecated: false,
          deprecationMessage: '',
          type: 'TemplateRef<any>',
          indexKey: '',
          optional: true,
          description: '<p>The primary action template for the notification.</p>\n',
          line: 68,
          rawdescription: '\n\nThe primary action template for the notification.\n',
        },
        {
          name: 'primaryActionText',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description:
            '<p>The text for the primary action button.\nWill throw an error if unset and primary action set.</p>\n',
          line: 33,
          rawdescription:
            '\n\nThe text for the primary action button.\nWill throw an error if unset and primary action set.\n',
        },
        {
          name: 'secondaryAction',
          deprecated: false,
          deprecationMessage: '',
          type: 'Function',
          indexKey: '',
          optional: true,
          description: '<p>A callback function for the secondary action.\nRequired to show the button.</p>\n',
          line: 48,
          rawdescription: '\n\nA callback function for the secondary action.\nRequired to show the button.\n',
        },
        {
          name: 'secondaryActionTemplate',
          deprecated: false,
          deprecationMessage: '',
          type: 'TemplateRef<any>',
          indexKey: '',
          optional: true,
          description: '<p>The secondary action template for the notification.</p>\n',
          line: 72,
          rawdescription: '\n\nThe secondary action template for the notification.\n',
        },
        {
          name: 'secondaryActionText',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description:
            '<p>The text for the secondary action button.\nWill throw an error if unset and secondary action set.</p>\n',
          line: 43,
          rawdescription:
            '\n\nThe text for the secondary action button.\nWill throw an error if unset and secondary action set.\n',
        },
        {
          name: 'ttl',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description:
            '<p>The time the notification will appear for in ms.\n0 will result in the notifaction remaining open.</p>\n',
          line: 28,
          rawdescription:
            '\n\nThe time the notification will appear for in ms.\n0 will result in the notifaction remaining open.\n',
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'NotificationExample',
      id: 'interface-NotificationExample-f717eba8d257cfb0ae561343383bef3c851d0da521b1654df23e0227e1dfa8e09ebb6969e0a65302fa0671a74673eb01144ca9f99b3e441df8df8e9c55e2291d',
      file: 'libs/ui-ang-examples/src/notification/examples/notification-example.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { NotificationAlertType } from '@backbase/ui-ang/notification';\n\nexport interface NotificationExample {\n  modifier: NotificationAlertType;\n  buttonModifier: string;\n}\n",
      properties: [
        {
          name: 'buttonModifier',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
        {
          name: 'modifier',
          deprecated: false,
          deprecationMessage: '',
          type: 'NotificationAlertType',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Option',
      id: 'interface-Option-1f615008bf4e14716b6f595723aafa449c49323cd8a10db0684aa25529dad365399f7211d204f089df3fbcd82871153ec41b01eec75dcfc4cae74abee8a97821',
      file: 'libs/ui-ang/dropdown-single-select/dropdown-single-select.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  ChangeDetectionStrategy,\n  ChangeDetectorRef,\n  Component,\n  ContentChildren,\n  forwardRef,\n  Input,\n  QueryList,\n} from '@angular/core';\nimport { InputBaseComponent } from '@backbase/ui-ang/base-classes';\nimport { NG_VALUE_ACCESSOR } from '@angular/forms';\nimport {\n  BB_DROPDOWN_CHANGE_DETECTION_REF_TOKEN,\n  DropdownSingleSelectOptionComponent,\n} from './dropdown-single-select-option.component';\n\ninterface Option {\n  [key: string]: any;\n}\n\n/**\n * @name DropdownSingleSelectComponent\n *\n * @description\n * Component that displays a dropdown with a single select option.\n *\n * ### Accessibility\n * Current component provides option to pass needed accessibility\n * attributes. You need to take care of properties that are required in your case :\n *  - aria-label will be linked to the single select dropdown with label\n *  - set aria-labelledby with ID of another element in the DOM as dropdown's label.\n *  - set aria-describedby with ID of another element in the DOM with descriptive text about the dropdown\n *  - set aria-expanded with a boolean value based on the listbox display.\n *  - set aria-invalid to true when a selected option is not valid ans vice versa\n *  - aria-owns handles contextual relationship between a parent and its child elements,\n *    in this case between dropdown menu and dropdown items, use the id from the input binding.\n * \n * ### Dropdown Single Select Options\n * There are 2 ways to add dropdown items \n * ###1. Via Options Array\n * Using [options] input property.\n *  ```\n  <bb-dropdown-single-select-ui\n    [label]=\"label\"\n    [placeholder]=\"placeholder\"\"\n    (blur)=\"blur($event)\"\n    (focus)=\"focus($event)\"\n    [options]=\"['Option One', 'Option Two', 'Option Three']\">\n     </bb-dropdown-single-select-ui>\n    ```\n * ###2. Via Content Children\n * Using `bb-dropdown-single-select-option-ui` ,it is a child component of `bb-dropdown-single-select-ui` that represents a single option that is part of the dropdown single select component.\n * ```\n  <bb-dropdown-single-select-ui\n    [label]=\"label\"\n    [placeholder]=\"placeholder\"\"\n    (blur)=\"blur($event)\"\n    (focus)=\"focus($event)\">\n      <bb-dropdown-single-select-option-ui label=\"Option One\" value=\"1\">\n      </bb-dropdown-single-select-option-ui>\n      <bb-dropdown-single-select-option-ui label=\"Option Two\" value=\"2\">\n      </bb-dropdown-single-select-option-ui>\n      <bb-dropdown-single-select-option-ui label=\"Option Three\" value=\"3\">\n      </bb-dropdown-single-select-option-ui>\n    </bb-dropdown-single-select-ui>\n ```\n *###NOTE: \n *If you add dropdown items via options and via Content Children at the same time then the items will be combined together and displayed in the dropdown.\n */\n@Component({\n  selector: 'bb-dropdown-single-select-ui',\n  templateUrl: './dropdown-single-select.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  providers: [\n    {\n      provide: NG_VALUE_ACCESSOR,\n      useExisting: forwardRef(() => DropdownSingleSelectComponent),\n      multi: true,\n    },\n    {\n      provide: BB_DROPDOWN_CHANGE_DETECTION_REF_TOKEN,\n      useExisting: ChangeDetectorRef,\n    },\n  ],\n  standalone: false,\n})\nexport class DropdownSingleSelectComponent extends InputBaseComponent {\n  /**\n   * The placeholder for the select. Defaults to an empty string;\n   */\n  @Input() placeholder = '';\n  /**\n   * This Boolean attribute determine if default option as placeholder is displayed. Defaults to false.\n   */\n  @Input() defaultOptionAsPlaceholder = false;\n\n  /**\n   * The value for the input field. It can be a list of strings or list of objects.\n   * If the value is a list of objects, you have to provide the `displayAttributePath` property.\n   */\n  @Input() options: Array<Object | string> = [];\n\n  /**\n   * The child option components of type DropdownSingleSelectOptionComponent\n   */\n  @ContentChildren(DropdownSingleSelectOptionComponent)\n  contentOptions: QueryList<DropdownSingleSelectOptionComponent> | undefined;\n\n  /**\n   * In case the list of options is a list of objects,\n   * this property will set the path to the object property which value will be used to display the option.\n   * Undefined will assume the options are strings.\n   * Child Nodes should be seperated by '.'\n   */\n  @Input() displayAttributePath?: string;\n\n  // TODO: after backbase-theme-v2 released. Change default value to 'corner-down'.\n  /**\n   * Right corner icon name.\n   * Default name 'toggle-down'\n   */\n  @Input() iconName = 'toggle-down';\n\n  /**\n   * Allowing override the option comparison algorithm for tracking identities when\n   * checking for change\n   */\n  @Input() compareWithFn: (a: any, b: any) => boolean = (a, b) => a === b;\n\n  constructor(protected readonly cd: ChangeDetectorRef) {\n    super(cd);\n  }\n\n  getOptionDisplayText(option: Object | string) {\n    return this.displayAttributePath && typeof option === 'object' && option !== null\n      ? this.resolvePath(this.displayAttributePath, option as Option)\n      : option;\n  }\n\n  private resolvePath(path: string, object: Option): string {\n    if (!object && !path) {\n      return '';\n    }\n    let paths;\n    let propName: string;\n    if (path.match(/^\\[\\d\\]/) !== null) {\n      paths = path.replace(/^[\\[\\]]/g, '').split(/\\./);\n      propName = paths[0].replace(/\\]/, '')[0];\n    } else {\n      paths = path.split(/[\\.\\[]/);\n      propName = paths[0];\n    }\n\n    const remainingPath = paths\n      .slice(1)\n      .reduce((result: string[], item: string) => {\n        if (item) {\n          if (item.match(/^\\d\\]/)) {\n            item = '[' + item;\n          }\n          result.push(item);\n        }\n\n        return result;\n      }, [])\n      .join('.');\n\n    if (!remainingPath) {\n      const propValue = object[propName];\n\n      return typeof propValue === 'string' ? propValue : propValue ? String(propValue) : '';\n    } else if (object.hasOwnProperty(propName)) {\n      return this.resolvePath(remainingPath, object[propName]);\n    } else {\n      return '';\n    }\n  }\n}\n",
      properties: [],
      indexSignatures: [
        {
          id: 'index-declaration-1f615008bf4e14716b6f595723aafa449c49323cd8a10db0684aa25529dad365399f7211d204f089df3fbcd82871153ec41b01eec75dcfc4cae74abee8a97821',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'any',
          line: 17,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      methods: [],
      extends: [],
    },
    {
      name: 'OptionListItem',
      id: 'interface-OptionListItem-f3b6d6017c740816d200f90a94a7ad4f61d7b498594f3b6c3223237be159faacea327595793bd537ec71d302796a7b5aa025edf7b6be77323dbde1033b11bf18',
      file: 'libs/ui-ang/option-list/option-list.models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "export interface OptionListItem {\n  label: string;\n  value: string | boolean;\n  disabled?: boolean;\n}\n\n/**\n * Type defining the number of columns for the option list.\n */\nexport type OptionListColumns = 1 | 2 | 3;\n\n/**\n * Type defining the selection mode for the option list.\n */\nexport type OptionListMode = 'radio' | 'checkbox';\n",
      properties: [
        {
          name: 'disabled',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 7,
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'string | boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Interface representing an option list item.</p>\n',
      rawdescription: '\n\nInterface representing an option list item.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'PaginationIcons',
      id: 'interface-PaginationIcons-521f7bf0d0e9a66e7dbf89e7764951d6e3bed2b1a6530baef66ff679b97693a09e1bb11edddf4e989f72d901db749f8f4d1791c7d475a86d2d636e0634255a4a',
      file: 'libs/ui-ang/pagination/pagination.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, Input, Output, EventEmitter } from '@angular/core';\nimport { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';\nimport { isRtl } from '@backbase/ui-ang/util';\n\nexport interface PaginationIcons {\n  first: string;\n  last: string;\n  previous: string;\n  next: string;\n}\n\n/**\n * @name PaginatorComponent\n *\n * @description\n * A component that displays page numbers and allows to customize them in several ways.\n */\n@Component({\n  selector: 'bb-pagination-ui',\n  templateUrl: './pagination.component.html',\n  providers: [NgbPaginationConfig],\n  standalone: false,\n})\nexport class PaginatorComponent {\n  set paginationIcons(icons: PaginationIcons) {\n    this._paginationIcons = icons;\n  }\n\n  /**\n   * @deprecated Deprecated as of ui-ang@12. Setter will be removed in ui-ang@14. Getter will be made protected. No replacement will be introduced.\n   */\n  get paginationIcons() {\n    return this._paginationIcons\n      ? this._paginationIcons\n      : {\n          first: isRtl() ? 'last-page' : 'first-page',\n          last: isRtl() ? 'first-page' : 'last-page',\n          previous: isRtl() ? 'chevron-right' : 'chevron-left',\n          next: isRtl() ? 'chevron-left' : 'chevron-right',\n        };\n  }\n\n  private _paginationIcons?: PaginationIcons;\n\n  /**\n   * The current page.\n   *\n   * `bb-paginator-ui` is 0-indexed, but `ngb-pagination` is 1-indexed. Corrects input by adding 1 internally.\n   */\n  @Input() page = 1;\n  /**\n   * If `true`, the \"First\" and \"Last\" page links are shown. Defaults to false.\n   */\n  @Input() boundaryLinks = false;\n  /**\n   * If `true`, the \"Next\" and \"Previous\" page links are shown. Defaults to false.\n   */\n  @Input() directionLinks = false;\n  /**\n   * The number of items in your paginated collection.\n   *\n   * Note, that this is not the number of pages. Page numbers are calculated dynamically based on\n   * `totalItems` and `itemsPerPage`.\n   */\n  @Input() totalItems = 0;\n  /**\n   * The number of items per page.\n   */\n  @Input() itemsPerPage = 10;\n  /**\n   * The maximum number of pages to display.\n   */\n  @Input() maxNavPages = 5;\n  /**\n   * An event fired when the page is changed. Will fire only if collection size is set and all values are valid.\n   *\n   * Event payload is the number of the newly selected page.\n   *\n   * `bb-paginator-ui` is 0-indexed, but `ngb-pagination` is 1-indexed. Corrects output by subtracting 1 internally.\n   */\n  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();\n\n  onPageChange(page: number) {\n    this.pageChange.emit(page - 1);\n  }\n}\n",
      properties: [
        {
          name: 'first',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
        {
          name: 'last',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'next',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
        {
          name: 'previous',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 8,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ParseResult',
      id: 'interface-ParseResult-d0397e7d152acc50309aa6667733ee51c3ffd1d00da6f2e480c8b1c546babad6d01265102da79b5779e42b77173f5545e28e8c7f38c51640d160bdf3b8c2b02a',
      file: 'libs/ui-ang/migrations/src/utils/parse-template.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import type { Node, ParseError } from '@angular/compiler';\n\nexport class ParseTreeResult {\n  constructor(\n    public rootNodes: Node[],\n    public errors: ParseError[],\n  ) {}\n}\n\nexport interface MigrateError {\n  type: string | undefined;\n  error: ParseError;\n}\n\nexport interface ParseResult {\n  tree: ParseTreeResult | undefined;\n  errors: MigrateError[];\n}\n\nexport function parseTemplate(compiler: any, template: string): ParseResult {\n  let parsed: ParseTreeResult;\n\n  try {\n    // Note: we use the HtmlParser here, instead of the `parseTemplate` function, because the\n    // latter returns an Ivy AST, not an HTML AST. The HTML AST has the advantage of preserving\n    // interpolated text as text nodes containing a mixture of interpolation tokens and text tokens,\n    // rather than turning them into `BoundText` nodes like the Ivy AST does. This allows us to\n    // easily get the text-only ranges without having to reconstruct the original text.\n    parsed = new compiler.HtmlParser().parse(template, '', {\n      // Allows for ICUs to be parsed.\n      tokenizeExpansionForms: true,\n      // Explicitly disable blocks so that their characters are treated as plain text.\n      tokenizeBlocks: true,\n      preserveLineEndings: true,\n    });\n\n    // Don't migrate invalid templates.\n    if (parsed.errors && parsed.errors.length > 0) {\n      const errors = parsed.errors.map((e) => ({ type: 'parse', error: e }));\n\n      return { tree: undefined, errors };\n    }\n  } catch (e: any) {\n    return { tree: undefined, errors: [{ type: 'parse', error: e }] };\n  }\n\n  return { tree: parsed, errors: [] };\n}\n",
      properties: [
        {
          name: 'errors',
          deprecated: false,
          deprecationMessage: '',
          type: 'MigrateError[]',
          indexKey: '',
          optional: false,
          description: '',
          line: 17,
        },
        {
          name: 'tree',
          deprecated: false,
          deprecationMessage: '',
          type: 'ParseTreeResult | undefined',
          indexKey: '',
          optional: false,
          description: '',
          line: 16,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'PaymentCard',
      id: 'interface-PaymentCard-4e9ca0da8c1399ec13e1e9500f1c1b3c748c8095827b3f257086213dd60e15aa0e8901bd6f026105aae590690b19223af21375c51e2b6b9a6057222eb8420a04',
      file: 'libs/ui-ang/payment-card/payment-card.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';\nimport { DefaultPaymentCardNumberFormat, PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { PAYMENT_CARD_CONFIG_TOKEN, PaymentCardConfig } from './payment-card.token-config';\n\n/**\n * Payment card data.\n */\nexport interface PaymentCard {\n  /**\n   * Unformatted payment card number.\n   */\n  number?: number | string;\n  /**\n   * Payment card vendor.\n   */\n  vendor?: string;\n  /**\n   * Name to be displayed on the payment card.\n   */\n  name?: string;\n  /**\n   * Date the payment card expires.\n   */\n  expirationDate?: Date;\n  /**\n   * Name of the card.\n   */\n  cardName?: string;\n  /**\n   * Type of the card. Credit, Debit, etc.\n   */\n  type?: string;\n  /**\n   * Is the card virtual.\n   */\n  virtual?: boolean;\n}\n\nexport enum PaymentCardSizes {\n  SM = 'sm',\n  MD = 'md',\n}\n\n/**\n * The prefix for the payment card class names.\n */\nconst classNamePrefix = 'bb-payment-card-';\n\n/**\n * @name PaymentCardComponent\n *\n * @description\n * A component that displays card of any vendor that can be used as a form of payment.\n */\n@Component({\n  selector: 'bb-payment-card-ui',\n  templateUrl: './payment-card.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class PaymentCardComponent {\n  /**\n   * Payment card data.\n   */\n  @Input() paymentCard?: PaymentCard;\n  /**\n   * Configuration of how the card number should be formatted.\n   * Defaults to the following format:\n   * ```\n      {\n        length: 16,\n        maskRange: [0, 12],\n        segments: 4,\n      }\n    ```\n   *\n   */\n  @Input() paymentCardNumberFormat: PaymentCardNumberFormat = DefaultPaymentCardNumberFormat;\n\n  /**\n   * Defines the size of the card. Small cards show no content.\n   * Defaults to `'md'`.\n   */\n  @Input() size?: 'sm' | 'md' = PaymentCardSizes.MD;\n\n  /**\n   * Configuration to pass a link or (base64, svg) image to be used as the background image of the card.\n   * Defaults to `undefined`.\n   */\n  @Input() imageSrc?: string;\n\n  /**\n   * Display Backbase logo on the card.\n   */\n  @Input() displayEmblem?: boolean = true;\n\n  /**\n   * Display card overlay in the card.\n   * Defaults to `false`.\n   */\n  @Input() displayOverlay?: boolean = false;\n\n  /**\n   * Overlay status to be displayed on the card.\n   * Defaults to `undefined`.\n   */\n  @Input() overlayText?: string;\n\n  /**\n   * Overlay icon to be displayed on the card.\n   * Possible values: 'access-time', 'lock', 'not-interested', 'remove-circle-outline', 'warning'.\n   * Defaults to `undefined`.\n   */\n  @Input() overlayIcon?: 'access-time' | 'lock' | 'not-interested' | 'remove-circle-outline' | 'warning';\n\n  /**\n   * Display the card in a vertical orientation.\n   * Defaults to false\n   */\n  @Input()\n  get vertical(): boolean | undefined {\n    return this._vertical ?? this.overrideConfig?.vertical ?? false;\n  }\n  set vertical(value: PaymentCardConfig['vertical']) {\n    this._vertical = value;\n  }\n\n  private _vertical: PaymentCardConfig['vertical'];\n\n  /**\n   * Local reference to the {@link PaymentCardSizes} enum.\n   */\n  protected PaymentCardSizes = PaymentCardSizes;\n\n  private readonly overrideConfig = inject(PAYMENT_CARD_CONFIG_TOKEN, { optional: true });\n\n  get classNames(): string | undefined {\n    if (this.paymentCard?.cardName) {\n      const classNamePostfix = this.paymentCard.cardName\n        .toLowerCase()\n        .replace(/[^a-zA-Z0-9 ]/g, ' ')\n        .trim()\n        .replace(/\\s/g, '-')\n        .replace(/-{2,}/g, '-');\n\n      return classNamePostfix ? `${classNamePrefix}${classNamePostfix}` : undefined;\n    }\n\n    return undefined;\n  }\n\n  get dynamicImageStyles(): Partial<CSSStyleDeclaration> {\n    if (this.imageSrc) {\n      return {\n        backgroundImage: `url(${this.imageSrc})`,\n        backgroundPosition: 'center',\n        backgroundSize: 'cover',\n      };\n    }\n\n    return {};\n  }\n}\n",
      properties: [
        {
          name: 'cardName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '<p>Name of the card.</p>\n',
          line: 28,
          rawdescription: '\n\nName of the card.\n',
        },
        {
          name: 'expirationDate',
          deprecated: false,
          deprecationMessage: '',
          type: 'Date',
          indexKey: '',
          optional: true,
          description: '<p>Date the payment card expires.</p>\n',
          line: 24,
          rawdescription: '\n\nDate the payment card expires.\n',
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '<p>Name to be displayed on the payment card.</p>\n',
          line: 20,
          rawdescription: '\n\nName to be displayed on the payment card.\n',
        },
        {
          name: 'number',
          deprecated: false,
          deprecationMessage: '',
          type: 'number | string',
          indexKey: '',
          optional: true,
          description: '<p>Unformatted payment card number.</p>\n',
          line: 12,
          rawdescription: '\n\nUnformatted payment card number.\n',
        },
        {
          name: 'type',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '<p>Type of the card. Credit, Debit, etc.</p>\n',
          line: 32,
          rawdescription: '\n\nType of the card. Credit, Debit, etc.\n',
        },
        {
          name: 'vendor',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '<p>Payment card vendor.</p>\n',
          line: 16,
          rawdescription: '\n\nPayment card vendor.\n',
        },
        {
          name: 'virtual',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '<p>Is the card virtual.</p>\n',
          line: 36,
          rawdescription: '\n\nIs the card virtual.\n',
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Payment card data.</p>\n',
      rawdescription: '\n\nPayment card data.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'PaymentCardConfig',
      id: 'interface-PaymentCardConfig-213a93601f505e5ebcb0757b579074ec11688da169479edd9a13beb849f4f91b8b19535fb3d203623ebf48204dd5c6b5c9b57c7d22d313b372bb33fb7a816ba2',
      file: 'libs/ui-ang/payment-card/payment-card.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface PaymentCardConfig {\n  vertical?: boolean;\n}\n\nexport const PAYMENT_CARD_CONFIG_TOKEN = new InjectionToken<PaymentCardConfig>('PAYMENT_CARD_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'vertical',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'PaymentCardNumberFormat',
      id: 'interface-PaymentCardNumberFormat-1edad08f56c584ba28f52e9efbdaf24af10055c77d8e9cd35a196270dab6055986f1e9670afefd2ed177f8453837f64dddca543d6ae31f55d56034be9d9e93c3',
      file: 'libs/ui-ang/payment-card-number-pipe/constants.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface AvailableFeature {\n  name: string;\n  description: string;\n}\n\n/**\n * The configuration that determines how a payment card number should be\n * formatted.\n */\nexport interface PaymentCardNumberFormat {\n  /**\n   * Total length of the payment card number.\n   */\n  length: number;\n  /**\n   * Index range of characters that should be masked.\n   */\n  maskRange: [number, number];\n  /**\n   * The size (or array of sizes) the segments should have.\n   */\n  segments: number | Array<number>;\n}\n\n/**\n * Default payment card number format.\n */\nexport const DefaultPaymentCardNumberFormat: PaymentCardNumberFormat = {\n  length: 16,\n  maskRange: [0, 12],\n  segments: 4,\n};\n\n/**\n * Lookup object containing payment card number formats for common payment card\n * vendors.\n */\nexport const PaymentCardNumberVendors: { [vendor: string]: PaymentCardNumberFormat } = {\n  mastercard: {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  },\n  visa: {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  },\n  'visa-debit': {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  },\n  'diners-club': {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  },\n  'american-express': {\n    length: 15,\n    maskRange: [0, 11],\n    segments: [4, 6, 5],\n  },\n};\n\n/**\n * A token that enables numbers masking synchronization with backend\n * If set FE should not apply any masking and rely on the backend masking behavior\n *\n * @internal\n */\nexport const SYNCHRONIZE_NUMBERS_MASKING: InjectionToken<boolean> = new InjectionToken<boolean>(\n  'Enables accounts masking synchronization with backend',\n  {\n    providedIn: 'root',\n    factory() {\n      return false;\n    },\n  },\n);\n",
      properties: [
        {
          name: 'length',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '<p>Total length of the payment card number.</p>\n',
          line: 16,
          rawdescription: '\n\nTotal length of the payment card number.\n',
        },
        {
          name: 'maskRange',
          deprecated: false,
          deprecationMessage: '',
          type: '[number, number]',
          indexKey: '',
          optional: false,
          description: '<p>Index range of characters that should be masked.</p>\n',
          line: 20,
          rawdescription: '\n\nIndex range of characters that should be masked.\n',
        },
        {
          name: 'segments',
          deprecated: false,
          deprecationMessage: '',
          type: 'number | Array<number>',
          indexKey: '',
          optional: false,
          description: '<p>The size (or array of sizes) the segments should have.</p>\n',
          line: 24,
          rawdescription: '\n\nThe size (or array of sizes) the segments should have.\n',
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>The configuration that determines how a payment card number should be\nformatted.</p>\n',
      rawdescription: '\n\nThe configuration that determines how a payment card number should be\nformatted.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'Period',
      id: 'interface-Period-984bfed07e5940faf938751ccbcfe7d33601391d468c6c33a5c85f7d4dcd0ae62d8e2fa654db6d51cd7be81d0595ad9c92272f5ca592083b3343571f7f181a77',
      file: 'libs/ui-ang/period-selector/period-selector.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';\nimport { DatePipe } from '@angular/common';\nimport { isRtl } from '@backbase/ui-ang/util';\n\nexport type FormatFn = (date: Date) => string;\n// @TODO: should be extended with week, year, etc. once we get requirement for it\nexport type PeriodSize = 'month';\nexport interface Period {\n  start: Date;\n  end: Date;\n}\nexport interface PeriodFormatters {\n  title?: FormatFn;\n  start?: FormatFn;\n  end?: FormatFn;\n}\n\ninterface CombinedFormatters {\n  title: FormatFn;\n  start: FormatFn;\n  end: FormatFn;\n}\n\n/**\n * @name PeriodSelectorComponent\n *\n * @description\n * Component that selects a period.\n */\n@Component({\n  selector: 'bb-period-selector-ui',\n  templateUrl: './period-selector.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class PeriodSelectorComponent implements OnInit {\n  private combinedFormatters: CombinedFormatters = {\n    title: (date) => this.datePipe.transform(date, 'MMMM') || '',\n    start: (date) => this.datePipe.transform(date, 'mediumDate') || '',\n    end: (date) => this.datePipe.transform(date, 'mediumDate') || '',\n  };\n\n  /**\n   * Start date of the period.\n   */\n  @Input() periodStart?: Date;\n  /**\n   * End date of the period.\n   */\n  @Input() periodEnd?: Date;\n  /**\n   * Custom date period formatter. Accepts formatters in the form of:\n   *\n   * ```typescript\n   *  {\n   *    title?: (date: Date) => string;\n   *    start?: (date: Date) => string;\n   *    end?: (date: Date) => string;\n   *  }\n   *```\n   *\n   */\n  @Input()\n  set periodFormatters(formatters: PeriodFormatters) {\n    this.combinedFormatters = Object.assign(this.combinedFormatters, formatters);\n  }\n  /**\n   * Period step. Defaults to 'month'.\n   */\n  @Input() period: PeriodSize = 'month';\n\n  /**\n   * Emits an event when the period is changed.\n   */\n  @Output() periodChange: EventEmitter<Period> = new EventEmitter<Period>();\n\n  chevronPrev = isRtl() ? 'chevron-right' : 'chevron-left';\n  chevronNext = isRtl() ? 'chevron-left' : 'chevron-right';\n\n  constructor(private readonly datePipe: DatePipe) {}\n\n  formattedTitle: string | undefined;\n  formattedStart: string | undefined;\n  formattedEnd: string | undefined;\n\n  get isLastPeriod(): boolean {\n    if (!this.periodStart) {\n      return true;\n    }\n\n    const now = new Date();\n\n    return now.getFullYear() === this.periodStart.getFullYear() && now.getMonth() === this.periodStart.getMonth();\n  }\n\n  get periodLeft() {\n    return isRtl() ? `\\u200f${this.formattedEnd}` : this.formattedStart;\n  }\n\n  get periodRight() {\n    return isRtl() ? `\\u200f${this.formattedStart}` : this.formattedEnd;\n  }\n\n  ngOnInit() {\n    if (typeof this.periodStart === 'undefined' || typeof this.periodEnd === 'undefined') {\n      throw new Error('`periodStart`, and `periodEnd` inputs are required in `bb-period-selector-ui` component');\n    }\n\n    this.setFormattedValues();\n  }\n\n  private setFormattedValues() {\n    this.formattedTitle = this.combinedFormatters.title(this.periodStart as Date);\n    this.formattedStart = this.combinedFormatters.start(this.periodStart as Date);\n    this.formattedEnd = this.combinedFormatters.end(this.periodEnd as Date);\n  }\n\n  changePeriod(next: boolean) {\n    if (!this.periodStart || (next && this.isLastPeriod)) {\n      return;\n    }\n\n    this.periodStart.setMonth(this.periodStart.getMonth() + (next ? 1 : -1));\n    this.periodEnd = this.isLastPeriod\n      ? new Date(this.periodStart.getFullYear(), this.periodStart.getMonth(), new Date().getDate(), 23, 59, 59, 999)\n      : new Date(this.periodStart.getFullYear(), this.periodStart.getMonth() + 1, 0, 23, 59, 59, 999);\n\n    this.setFormattedValues();\n    this.periodChange.emit({\n      start: this.periodStart,\n      end: this.periodEnd,\n    });\n  }\n}\n",
      properties: [
        {
          name: 'end',
          deprecated: false,
          deprecationMessage: '',
          type: 'Date',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'start',
          deprecated: false,
          deprecationMessage: '',
          type: 'Date',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'PeriodFormatters',
      id: 'interface-PeriodFormatters-984bfed07e5940faf938751ccbcfe7d33601391d468c6c33a5c85f7d4dcd0ae62d8e2fa654db6d51cd7be81d0595ad9c92272f5ca592083b3343571f7f181a77',
      file: 'libs/ui-ang/period-selector/period-selector.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';\nimport { DatePipe } from '@angular/common';\nimport { isRtl } from '@backbase/ui-ang/util';\n\nexport type FormatFn = (date: Date) => string;\n// @TODO: should be extended with week, year, etc. once we get requirement for it\nexport type PeriodSize = 'month';\nexport interface Period {\n  start: Date;\n  end: Date;\n}\nexport interface PeriodFormatters {\n  title?: FormatFn;\n  start?: FormatFn;\n  end?: FormatFn;\n}\n\ninterface CombinedFormatters {\n  title: FormatFn;\n  start: FormatFn;\n  end: FormatFn;\n}\n\n/**\n * @name PeriodSelectorComponent\n *\n * @description\n * Component that selects a period.\n */\n@Component({\n  selector: 'bb-period-selector-ui',\n  templateUrl: './period-selector.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class PeriodSelectorComponent implements OnInit {\n  private combinedFormatters: CombinedFormatters = {\n    title: (date) => this.datePipe.transform(date, 'MMMM') || '',\n    start: (date) => this.datePipe.transform(date, 'mediumDate') || '',\n    end: (date) => this.datePipe.transform(date, 'mediumDate') || '',\n  };\n\n  /**\n   * Start date of the period.\n   */\n  @Input() periodStart?: Date;\n  /**\n   * End date of the period.\n   */\n  @Input() periodEnd?: Date;\n  /**\n   * Custom date period formatter. Accepts formatters in the form of:\n   *\n   * ```typescript\n   *  {\n   *    title?: (date: Date) => string;\n   *    start?: (date: Date) => string;\n   *    end?: (date: Date) => string;\n   *  }\n   *```\n   *\n   */\n  @Input()\n  set periodFormatters(formatters: PeriodFormatters) {\n    this.combinedFormatters = Object.assign(this.combinedFormatters, formatters);\n  }\n  /**\n   * Period step. Defaults to 'month'.\n   */\n  @Input() period: PeriodSize = 'month';\n\n  /**\n   * Emits an event when the period is changed.\n   */\n  @Output() periodChange: EventEmitter<Period> = new EventEmitter<Period>();\n\n  chevronPrev = isRtl() ? 'chevron-right' : 'chevron-left';\n  chevronNext = isRtl() ? 'chevron-left' : 'chevron-right';\n\n  constructor(private readonly datePipe: DatePipe) {}\n\n  formattedTitle: string | undefined;\n  formattedStart: string | undefined;\n  formattedEnd: string | undefined;\n\n  get isLastPeriod(): boolean {\n    if (!this.periodStart) {\n      return true;\n    }\n\n    const now = new Date();\n\n    return now.getFullYear() === this.periodStart.getFullYear() && now.getMonth() === this.periodStart.getMonth();\n  }\n\n  get periodLeft() {\n    return isRtl() ? `\\u200f${this.formattedEnd}` : this.formattedStart;\n  }\n\n  get periodRight() {\n    return isRtl() ? `\\u200f${this.formattedStart}` : this.formattedEnd;\n  }\n\n  ngOnInit() {\n    if (typeof this.periodStart === 'undefined' || typeof this.periodEnd === 'undefined') {\n      throw new Error('`periodStart`, and `periodEnd` inputs are required in `bb-period-selector-ui` component');\n    }\n\n    this.setFormattedValues();\n  }\n\n  private setFormattedValues() {\n    this.formattedTitle = this.combinedFormatters.title(this.periodStart as Date);\n    this.formattedStart = this.combinedFormatters.start(this.periodStart as Date);\n    this.formattedEnd = this.combinedFormatters.end(this.periodEnd as Date);\n  }\n\n  changePeriod(next: boolean) {\n    if (!this.periodStart || (next && this.isLastPeriod)) {\n      return;\n    }\n\n    this.periodStart.setMonth(this.periodStart.getMonth() + (next ? 1 : -1));\n    this.periodEnd = this.isLastPeriod\n      ? new Date(this.periodStart.getFullYear(), this.periodStart.getMonth(), new Date().getDate(), 23, 59, 59, 999)\n      : new Date(this.periodStart.getFullYear(), this.periodStart.getMonth() + 1, 0, 23, 59, 59, 999);\n\n    this.setFormattedValues();\n    this.periodChange.emit({\n      start: this.periodStart,\n      end: this.periodEnd,\n    });\n  }\n}\n",
      properties: [
        {
          name: 'end',
          deprecated: false,
          deprecationMessage: '',
          type: 'FormatFn',
          indexKey: '',
          optional: true,
          description: '',
          line: 15,
        },
        {
          name: 'start',
          deprecated: false,
          deprecationMessage: '',
          type: 'FormatFn',
          indexKey: '',
          optional: true,
          description: '',
          line: 14,
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          type: 'FormatFn',
          indexKey: '',
          optional: true,
          description: '',
          line: 13,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Person',
      id: 'interface-Person-bac63835f6efef42ae7719c18d3b7f715b73a681b703ef1af376b0ae0864b3bae368eefb75f45319bdef174b248e74a92c85210f54b6b7fdb4013b1ee973042b',
      file: 'libs/ui-ang-examples/src/search-box/showcase/search-box-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, TemplateRef, ViewChild } from '@angular/core';\nimport { Observable } from 'rxjs';\nimport { map } from 'rxjs/operators';\nimport { UntypedFormControl, UntypedFormGroup } from '@angular/forms';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\nimport { TypeaheadOptions } from '@backbase/ui-ang/search-box';\n\nconst startsWithCaseInsensitive = (haystack: string, needle: string): boolean =>\n  haystack.toLowerCase().startsWith(needle.toLowerCase());\n\ninterface Person {\n  fullName: string;\n  legalEntityName: string;\n}\n\n@Component({\n  selector: 'bb-search-box-ui-showcase',\n  templateUrl: './search-box-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class SearchBoxShowcaseComponent {\n  @ViewChild('rt', { static: true }) resultTemplate: TemplateRef<any> | undefined;\n\n  form = new UntypedFormGroup({\n    name: new UntypedFormControl('John Doe'),\n  });\n\n  search(text: Observable<string>): Observable<string[]> {\n    const searchItems = ['John', 'Jane', 'James', 'Joey'];\n\n    return text.pipe(map((term) => searchItems.filter((item) => startsWithCaseInsensitive(item, term))));\n  }\n\n  readonly typeaheadOptions = {\n    ngbTypeahead: this.search,\n  };\n\n  customSearch(text: Observable<string>): Observable<Person[]> {\n    const searchItems: Person[] = [\n      {\n        fullName: 'John',\n        legalEntityName: 'Legal Entity 1',\n      },\n      {\n        fullName: 'Jane',\n        legalEntityName: 'Legal Entity 2',\n      },\n      {\n        fullName: 'James',\n        legalEntityName: 'Legal Entity 3',\n      },\n      {\n        fullName: 'Joey',\n        legalEntityName: 'Legal Entity 4',\n      },\n    ];\n\n    return text.pipe(map((term) => searchItems.filter((item) => startsWithCaseInsensitive(item.fullName, term))));\n  }\n\n  customInputFormatter(person: Person): string {\n    return person.fullName;\n  }\n\n  get typeaheadOptionsWithTemplate(): TypeaheadOptions<Person> {\n    return {\n      ngbTypeahead: this.customSearch,\n      resultTemplate: this.resultTemplate,\n      inputFormatter: this.customInputFormatter,\n    };\n  }\n}\n",
      properties: [
        {
          name: 'fullName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 12,
        },
        {
          name: 'legalEntityName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 13,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'PlainObject',
      id: 'interface-PlainObject-41b338ff03a514cbdaefb7491423cc50dd4e458fc486445023cafb60efb87949087937d38a9e5dacd0f4888342be35c5dd420e137750dde7d60b3875b4e48cba',
      file: 'libs/ui-ang/control-error-handler/control-error-handler.const.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken, Type } from '@angular/core';\nimport { ValidationMessageComponent } from './components/validation-message/validation-message.component';\nimport { NgControl } from '@angular/forms';\n\nexport interface PlainObject<T> {\n  [key: string]: (params: any) => T;\n}\n\nexport interface ValidationErrorComponentModel {\n  errorId: string;\n  text: string | undefined;\n  control?: NgControl;\n  errorList?: PlainObject<string>;\n  label?: string;\n}\n\nexport const BB_VALIDATION_ERRORS = new InjectionToken('BB_VALIDATION_ERRORS', {\n  providedIn: 'root',\n  factory: () => defaultFormErrors,\n});\n\nexport const BB_DYNAMIC_VALIDATION_ERROR_TMPL = new InjectionToken<Type<ValidationErrorComponentModel>>(\n  'BB_DYNAMIC_VALIDATION_ERROR_TMPL',\n  {\n    providedIn: 'root',\n    factory: () => ValidationMessageComponent,\n  },\n);\n\nexport const defaultFormErrors: PlainObject<string> = {\n  invalid: () => $localize`:@@validation-form-invalid-error:Field is invalid`,\n  required: () => $localize`:@@validation-form-required-error:Field is required`,\n  minlength: ({ requiredLength }) => {\n    const singleStr = $localize`:@@validation-form-minlength-error-single:\n    Must be at least ${requiredLength} character long`;\n    const multipleStr = $localize`:@@validation-form-minlength-error-multiple:\n    Must be at least ${requiredLength} characters long`;\n\n    return requiredLength === 1 ? singleStr : multipleStr;\n  },\n  maxlength: ({ requiredLength }) => {\n    const singleStr = $localize`:@@bb-ui-ang.control-error-handler.validation-form-maxlength-error-single:\n    Must be shorter than ${requiredLength} character`;\n    const multipleStr = $localize`:@@bb-ui-ang.control-error-handler.validation-form-maxlength-error-multiple:\n    Must be shorter than ${requiredLength} characters`;\n\n    return requiredLength === 1 ? singleStr : multipleStr;\n  },\n  min: ({ min }) => $localize`:@@validation-form-min-error:Expect value to be bigger than ${min}`,\n  max: ({ max }) => $localize`:@@validation-form-max-error:Expect value to be less than ${max}`,\n  email: () => $localize`:@@validation-form-email-error:Not a valid email`,\n};\n",
      properties: [],
      indexSignatures: [
        {
          id: 'index-declaration-41b338ff03a514cbdaefb7491423cc50dd4e458fc486445023cafb60efb87949087937d38a9e5dacd0f4888342be35c5dd420e137750dde7d60b3875b4e48cba',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'T',
          line: 5,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      methods: [],
      extends: [],
    },
    {
      name: 'Plugin',
      id: 'interface-Plugin-9982b30be7cadfa5553375413adbbf55e23c3f501f0769f2df2795df93b9a7125c66fe6040f8204dd314b7f10781fd972313c12ef54eabe1a284f4a33f955c03',
      file: 'tools/scripts/ds-eslint/generate-rule-lists.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { readFileSync } from 'fs';\nimport { writeFile } from 'fs/promises';\nimport { resolve } from 'path';\nimport { format, resolveConfig } from 'prettier';\nimport lintTemplatePlugin from '../../../libs/eslint-plugin-design-system/src';\n\ntype RuleModule = (typeof lintTemplatePlugin.rules)[keyof typeof lintTemplatePlugin.rules];\ntype RuleItem = [string, RuleModule];\ntype RulesList = RuleItem[];\ntype Column = { header: string; dataFn: DataFn };\ntype KeyOfEmojiKey = keyof typeof emojiKey;\n\ninterface Plugin {\n  name: string;\n  filePath: string;\n  rules: RulesList;\n}\n\nconst emojiKey = {\n  recommended: { emoji: ':white_check_mark:', desc: 'recommended' },\n} as const satisfies Record<string, { emoji: string; desc: string }>;\n\nconst emojiWithDesc = (key: KeyOfEmojiKey): string => emojiKey[key].emoji;\n\nconst keyListItem = (key: KeyOfEmojiKey): string => `* ${emojiWithDesc(key)} = ${emojiKey[key].desc}`;\n\nconst returnEmojiIfTrue = (key: KeyOfEmojiKey, value: boolean): string => (value ? emojiWithDesc(key) : '');\n\nconst createRuleLink = ([name, rule]: RuleItem, plugin: Plugin): string => {\n  const fullRuleName = plugin.name ? `${name}` : name;\n  return `[\\`${fullRuleName}\\`](${rule?.meta?.docs?.url})`;\n};\n\nconst ruleKey = (): string => ['**Key**', '', keyListItem('recommended')].filter(Boolean).join('\\n');\n\ntype DataFn = (ruleItem: RuleItem, plugin: Plugin) => string;\n\nconst columns: Column[] = [\n  {\n    header: 'Rule',\n    dataFn: (ruleItem: RuleItem, plugin: Plugin) => createRuleLink(ruleItem, plugin),\n  },\n  {\n    header: 'Description',\n    dataFn: ([, rule]: RuleItem) => rule.meta.docs?.description.replace(/\\s{2,}/, ' ') || '',\n  },\n  {\n    header: emojiWithDesc('recommended'),\n    dataFn: ([, rule]: RuleItem) => returnEmojiIfTrue('recommended', !!rule.meta.docs?.recommended),\n  },\n];\n\nconst columnsDeprecated: Column[] = [\n  {\n    header: 'Rule',\n    dataFn: (ruleItem: RuleItem, plugin: Plugin) => createRuleLink(ruleItem, plugin),\n  },\n  {\n    header: 'Replaced by',\n    dataFn: ([name, rule]: RuleItem, plugin: Plugin) =>\n      (rule.meta.replacedBy || [])\n        .map((replacer: string) => createRuleLink([name, rule], plugin).replaceAll(name, replacer))\n        .join(', '),\n  },\n];\n\nconst buildRow = (ruleItem: RuleItem, plugin: Plugin, columnsSet: Column[]): string =>\n  columnsSet.map((col) => col.dataFn(ruleItem, plugin)).join(' | ');\n\nconst buildRulesTable = (rules: RulesList = [], plugin: Plugin): string => {\n  const columnSet = rules[0][1].meta.deprecated ? columnsDeprecated : columns;\n\n  return [\n    `| ${columnSet.map((col) => col.header).join(' | ')} |`,\n    `| ${columnSet.map(() => '---').join(' | ')} |`,\n    ...rules.map((item: RuleItem) => `| ${buildRow(item, plugin, columnSet)} |`),\n  ].join('\\n');\n};\n\nconst buildRulesSection = (categoryName: string, rules: RulesList = [], plugin: Plugin): string =>\n  [\n    '',\n    `### ${categoryName}`,\n    '',\n    rules[0][1].meta.deprecated ? '' : ruleKey(),\n    '',\n    '<!-- prettier-ignore-start -->',\n    buildRulesTable(rules, plugin),\n    '<!-- prettier-ignore-end -->',\n    '',\n  ].join('\\n');\n\nconst updateRulesList = (\n  listName: string,\n  listId: string,\n  rules: RulesList,\n  markdown: string,\n  plugin: Plugin,\n): string => {\n  const listBeginMarker = `<!-- begin ${listId} rule list -->`;\n  const listEndMarker = `<!-- end ${listId} rule list -->`;\n\n  const listStartIndex = markdown.indexOf(listBeginMarker);\n  const listEndIndex = markdown.indexOf(listEndMarker);\n\n  if (listStartIndex === -1 || listEndIndex === -1) {\n    throw new Error(`cannot find start or end of ${listName} list`);\n  }\n\n  const content: string = rules.length ? buildRulesSection(listName, rules, plugin) : '';\n\n  return [\n    markdown.substring(0, listStartIndex - 1),\n    listBeginMarker,\n    '',\n    content,\n    markdown.substring(listEndIndex),\n  ].join('\\n');\n};\n\nconst getRulesByType = (rules: RuleItem[], type: 'suggestion' | 'problem' | 'layout'): RuleItem[] =>\n  rules.filter(([, rule]) => rule.meta.type === type);\n\nconst updateFile = async (plugin: Plugin): Promise<void> => {\n  const filePath = resolve(__dirname, plugin.filePath);\n  const oldReadme = readFileSync(filePath, 'utf8');\n  let readme = oldReadme;\n\n  const deprecated = plugin.rules.filter(([, rule]) => rule.meta.deprecated);\n  const notDeprecated = plugin.rules.filter(([, rule]) => !rule.meta.deprecated);\n\n  readme = updateRulesList('Suggestions', 'suggestions', getRulesByType(notDeprecated, 'suggestion'), readme, plugin);\n  readme = updateRulesList('Deprecated', 'deprecated', deprecated, readme, plugin);\n\n  readme = await format(readme, {\n    ...(await resolveConfig(filePath)),\n    parser: 'markdown',\n  });\n\n  if (readme === oldReadme) {\n    console.log(`\\n✅ Rule list of ${plugin.name} is already up-to-date.`);\n  } else {\n    try {\n      await writeFile(filePath, readme);\n      console.log(`\\n✨ Updated rule list for ${plugin.name}!`);\n    } catch (err) {\n      console.error(`❌ Error while writing updated readme file for ${plugin.name}`);\n      console.error(err);\n    }\n  }\n};\n\nconst getRuleEntries = (rules: Record<string, RuleModule>): RulesList =>\n  Object.entries(rules).sort((a, b) => a[0].localeCompare(b[0]));\n\n(async function main() {\n  const pluginInfo: Plugin = {\n    rules: getRuleEntries(lintTemplatePlugin.rules),\n    name: '@backbase/design-system',\n    filePath: '../../../libs/eslint-plugin-design-system/README.md',\n  };\n  await updateFile(pluginInfo);\n})();\n",
      properties: [
        {
          name: 'filePath',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 15,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 14,
        },
        {
          name: 'rules',
          deprecated: false,
          deprecationMessage: '',
          type: 'RulesList',
          indexKey: '',
          optional: false,
          description: '',
          line: 16,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'PresetConfig',
      id: 'interface-PresetConfig-79e3bb864a68e6438c1730fde0504e3f2a07caabd0e3e7d180a8d048c7edd1f26516fcd83ab656649f7efda7091e4b0b599cc14f68743920fe598f6036ee97b6',
      file: 'libs/ui-ang/empty-state/type.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "export type EmptyStatePresetType =\n  | 'unknown_error_personal'\n  | 'consents'\n  | 'sweeps'\n  | 'batches'\n  | 'payment_not_found'\n  | 'transactions'\n  | 'budgets'\n  | 'permissions'\n  | 'upcoming_payments'\n  /**\n   * @deprecated `results_found` is replaced with `no_results_found`. Will be removed in `ui-ang@14.0.0`.\n   */\n  | 'results_found'\n  | 'no_results_found'\n  | 'notifications'\n  | 'unknown_error_organisation'\n  | 'cards'\n  | 'cashflow'\n  | 'data_found'\n  | 'no_internet'\n  | 'location'\n  | 'user'\n  | 'pockets'\n  | 'insights'\n  | 'transaction_limits'\n  | 'no_contacts'\n  | 'no_conversations'\n  | 'nothing_to_approve'\n  | 'operation_timeout';\n\ninterface PresetConfig {\n  title: string;\n  subtitle?: string;\n  image: string;\n  primaryActionText?: string;\n}\n\n// eslint-disable-next-line max-len\nconst primaryActionTextPreset = $localize`:@@bb-empty-state-ui.bb-empty-state__primary-action-text.unknown_error_personal:Try again`;\n\nexport const PRESETS: { [key: string]: PresetConfig } = {\n  unknown_error_personal: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.unknown_error_personal:Something went wrong`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.unknown_error_personal:\n    Try again or contact us if the problem continues`,\n    image: 'ic_asset_coffee',\n    primaryActionText: primaryActionTextPreset,\n  },\n  consents: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.consents:No consents`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.consents:\n    Try to reload the page or contact the system administrator`,\n    image: 'ic_asset_lock_error',\n    primaryActionText: primaryActionTextPreset,\n  },\n  sweeps: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.sweeps:No sweeps`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.sweeps:There are no sweeps to be displayed`,\n    image: 'ic_asset_calendar',\n    primaryActionText: $localize`:@@bb-empty-state-ui.bb-empty-state__primary-action-text.sweeps:Create sweep`,\n  },\n  batches: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.batches:No batches`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.batches:There are no batches to show`,\n    image: 'ic_scenario_box',\n    primaryActionText: primaryActionTextPreset,\n  },\n  payment_not_found: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.payment_not_found:Payment not found`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.payment_not_found:There are no payments to show`,\n    primaryActionText: primaryActionTextPreset,\n    image: 'ic_asset_money',\n  },\n  transactions: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.transactions:No transactions`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.transactions:\n    You haven’t made any transactions yet`,\n    image: 'ic_scenario_coin_empty',\n    primaryActionText: primaryActionTextPreset,\n  },\n  budgets: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.budgets:No budgets created`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.budgets:\n    You don’t have any budgets to be displayed`,\n    image: 'ic_scenario_graphs',\n    primaryActionText: $localize`:@@bb-empty-state-ui.bb-empty-state__primary-action-text.budgets:Create budget`,\n  },\n  permissions: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.permissions:No permissions`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.permissions:\n    You don’t have the required permission`,\n    image: 'ic_asset_lock_error',\n    primaryActionText: primaryActionTextPreset,\n  },\n  upcoming_payments: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.upcoming_payments:No upcoming payments`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.upcoming_payments:\n    There are no upcoming payments to show`,\n    image: 'ic_asset_money',\n    primaryActionText: primaryActionTextPreset,\n  },\n  results_found: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.results_found:No results to show`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.results_found:\n    We couldn’t find anything to show here`,\n    image: 'ic_scenario_search',\n    primaryActionText: primaryActionTextPreset,\n  },\n  no_results_found: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.no_results_found:No results to show`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.no_results_found:\n    We couldn’t find anything to show here`,\n    image: 'ic_scenario_search',\n    primaryActionText: primaryActionTextPreset,\n  },\n  notifications: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.notifications:No notifications`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.notifications:\n    You don’t have any notifications at the moment`,\n    image: 'ic_asset_bell',\n    primaryActionText: primaryActionTextPreset,\n  },\n  unknown_error_organisation: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.unknown_error_organisation:Something went wrong`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.unknown_error_organisation:\n    Try again or contact the system administrator if the problem continues`,\n    image: 'ic_asset_light_bulb',\n    primaryActionText: primaryActionTextPreset,\n  },\n  cards: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.cards:No cards yet`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.cards:You don’t have a card yet`,\n    image: 'ic_asset_credit_card',\n    primaryActionText: primaryActionTextPreset,\n  },\n  cashflow: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.cashflow:Nothing to show`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.cashflow:We couldn’t find anything to show here`,\n    image: 'ic_graph_line_chart',\n    primaryActionText: primaryActionTextPreset,\n  },\n  data_found: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.data_found:Nothing to show`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.data_found:\n    We couldn’t find anything to show here`,\n    image: 'ic_graph_donut',\n    primaryActionText: primaryActionTextPreset,\n  },\n  no_internet: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.no_internet:No internet connection`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.no_internet:It seems that you’re not online`,\n    image: 'ic_scenario_satellite',\n    primaryActionText: primaryActionTextPreset,\n  },\n  location: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.location:No branches`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.location:There are no branches in this area`,\n    image: 'ic_attribute_dog',\n    primaryActionText: primaryActionTextPreset,\n  },\n  user: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.user:No users`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.user:There are no users to show`,\n    image: 'ic_portrait_casual_woman_1_neutral',\n    primaryActionText: primaryActionTextPreset,\n  },\n  pockets: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.pockets:Create Pockets to save more`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.pockets:\n    Pockets let you put money aside for your savings goals. \n    When you've set up your Pockets, you'll manage them from here.`,\n    image: 'ic_asset_wallet',\n    primaryActionText: $localize`:@@bb-empty-state-ui.bb-empty-state__primary-action-text.pockets:Create a Pocket`,\n  },\n  insights: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.insights:Nothing to show`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.insights:We couldn’t find anything to show here`,\n    image: 'ic_graph_bar_chart',\n    primaryActionText: primaryActionTextPreset,\n  },\n  transaction_limits: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.transaction_limits:No transaction limits`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.transaction_limits:\n    This user can transact with any amount`,\n    image: 'ic_asset_lock_success',\n    primaryActionText: primaryActionTextPreset,\n  },\n  no_contacts: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.no_contacts:No contacts yet`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.no_contacts:\n    You haven’t set up any contacts to pay`,\n    image: 'ic_scenario_mobile_banking',\n    primaryActionText: $localize`:@@bb-empty-state-ui.bb-empty-state__primary-action-text.no_contacts:Add contact`,\n  },\n  no_conversations: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.no_conversations:No conversations`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.no_conversations:\n    We couldn't find any conversation to show here. For help, please contact us.`,\n    image: 'ic_asset_messages',\n    primaryActionText: primaryActionTextPreset,\n  },\n  nothing_to_approve: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.nothing_to_approve:Nothing to approve`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.nothing_to_approve:\n    If anything is waiting for your approval, it will appear here`,\n    image: 'ic_asset_approval',\n    primaryActionText: primaryActionTextPreset,\n  },\n  operation_timeout: {\n    title: $localize`:@@bb-empty-state-ui.bb-empty-state__title.operation_timeout:Operation timed out`,\n    subtitle: $localize`:@@bb-empty-state-ui.bb-empty-state__message.operation_timeout:\n    This operation timed out and has been canceled`,\n    image: 'ic_asset_alarm',\n    primaryActionText: primaryActionTextPreset,\n  },\n};\n",
      properties: [
        {
          name: 'image',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 35,
        },
        {
          name: 'primaryActionText',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 36,
        },
        {
          name: 'subtitle',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 34,
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 33,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'Product',
      id: 'interface-Product-c005ee171b27d2a852b043f6bdc16c6a491b6684402bfead6cfc7d2870ef5c9de9357c393988c62a7da200e4f9001b090b191bdca1864e72b1ef25778acdc181',
      file: 'libs/ui-ang-examples/src/product-selector/showcase/product-selector-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\n\ninterface Product {\n  id: string;\n  amount: string;\n  currency: string;\n  productNumber: string;\n  name: string;\n  productType: string;\n  custonType?: string;\n  header?: string;\n}\n\n@Component({\n  selector: 'bb-product-selector-ui-showcase',\n  templateUrl: './product-selector-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class ProductSelectorShowcaseComponent {\n  singleDropdownOptions = ['Option One', 'Option Two', 'Option Three'];\n  productSelected: Product | null = null;\n  productsInterfaced: Product[] = [\n    {\n      id: '1cdb2224',\n      amount: '1231',\n      currency: 'EUR',\n      productNumber: '2342 443234 4234',\n      name: 'Some Name',\n      productType: 'currentAccounts',\n    },\n    {\n      id: '1cdb222sgdfd4',\n      amount: '123123',\n      currency: 'EUR',\n      productNumber: '2342 443234 4234432',\n      name: 'Some Name 234',\n      productType: 'my Type 234',\n      custonType: 'header',\n      header: 'savingsAccounts',\n    },\n    {\n      id: '1cdb222gdfgsd4',\n      amount: '123123',\n      currency: 'EUR',\n      productNumber: '2342 443234 4234432',\n      name: 'Some NA34534',\n      productType: 'termDeposits',\n    },\n    {\n      id: '1cdb222sdfgd4',\n      amount: '123123',\n      currency: 'EUR',\n      productNumber: '2342 443234 4234432',\n      name: 'Some NA3454',\n      productType: 'loans',\n    },\n    {\n      id: '1cddfgb222sd4',\n      amount: '123123',\n      currency: 'EUR',\n      productNumber: '2342 443234 4234432',\n      name: 'Some N34534',\n      productType: 'creditCards',\n    },\n    {\n      id: '1cdb2sfd22sd4',\n      amount: '123123',\n      currency: 'EUR',\n      productNumber: '2342 443233454 4234432',\n      name: 'Some NAm345',\n      productType: 'debitCards',\n    },\n    {\n      id: '1cdb2df22sd4',\n      amount: '123123',\n      currency: 'EUR',\n      productNumber: '2343542 443234 4234432',\n      name: 'Some Name 234',\n      productType: 'investmentAccounts',\n    },\n  ];\n}\n",
      properties: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 6,
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'custonType',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 11,
        },
        {
          name: 'header',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 12,
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 8,
        },
        {
          name: 'productType',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ProductItem',
      id: 'interface-ProductItem-70923e5dba772348fb68253787ae85d771c2c436261b48097423ded74294f7a176562dd00e3cf2be0183255ab7237c2f8732d7705e6c25b247dd4324744f4e87',
      file: 'libs/ui-ang/product-selector/product-selector.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, ContentChildren, ElementRef, HostListener, Input, QueryList, ViewChild } from '@angular/core';\nimport { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';\nimport { Placement, PlacementArray } from '@ng-bootstrap/ng-bootstrap/util/positioning';\nimport { getDynamicId } from '@backbase/ui-ang/util';\n\nexport interface ProductItem {\n  id: string;\n  name?: string;\n  currency?: string;\n  amount?: string;\n  productNumber?: string;\n  [key: string]: any;\n}\n\n/* eslint-disable */\n/**\n * @name ProductSelectorComponent\n *\n * @description\n * A dropdown component that displays items in a pre-defined format.\n *\n * @a11y\n * Every item from the list in the custom templates need to match the following requirements:\n * * It should have a `role=\"option\"` attribute for detection by Screen Reader like option.\n * * It should have a `#listItem` hash tag for keyBoard accessibility (navigate with keyUp/keyDown)\n * * It should use a `div` HTML element instead of a button for its host HTML element\n * * It should have a `tabindex=\"0\"`\n *\n * @usageNotes\n * Here is a example of custom tempates for the list items:\n * ```\n * <ng-container bbDropdownMenu>\n *   <div\n *     *ngFor=\"let item of productsInterfaced; let i = index\"\n *     (click)=\"productSelected = productsInterfaced[i]\"\n *     \\#listItem\n *     role=\"option\"\n *     tabindex=\"0\"\n *     class=\"bb-product-selector__dropdown-item\"\n *     [ngClass]=\"{ selected: item.id === productSelected?.id }\"\n *   >\n *     <bb-product-item-basic-account-ui\n *       [title]=\"item.name\"\n *       [amount]=\"item.amount\"\n *       [productNumber]=\"item.productNumber\"\n *       [currency]=\"'EUR'\"\n *       [highlight]=\"true\"\n *       [productNumberFormat]=\"{ length: 18, maskRange: [0, 0], segments: 4 }\"\n *       [active]=\"item.id === productSelected?.id\"\n *     ></bb-product-item-basic-account-ui>\n *   </div>\n * </ng-container>\n * ```\n *\n */\n/* eslint-enable */\n@Component({\n  selector: 'bb-product-selector-ui',\n  templateUrl: './product-selector.component.html',\n  standalone: false,\n})\nexport class ProductSelectorComponent {\n  /**\n   * Focused item index from product selector list\n   */\n  focusedItemIndex = -1;\n  /**\n   * State of focus on product selector element\n   */\n  focusState = '';\n  /**\n   * Open/close state of dropDown menu\n   */\n  @Input()\n  set isOpen(value: boolean) {\n    this._isOpen = value;\n  }\n\n  get isOpen() {\n    return this._isOpen;\n  }\n\n  private _isOpen = false;\n  /**\n   * Whether the dropdown should be closed when clicking one of dropdown items or pressing ESC.\n   * Defaults to true.\n   */\n  @Input() autoClose = true;\n\n  /**\n   * Generates ID for dropdown element. It is required for the `aria-controls` attribute\n   */\n  dropdownId = 'product_selector_dropdown_' + getDynamicId();\n\n  /**\n   * A unique identifier for the product-selector toggle element.\n   */\n  @Input() id?: string;\n\n  /**\n   * The position of the dropdown, position will be picked in order of feasibility.\n   */\n  @Input() position: Placement | PlacementArray = ['bottom-end', 'bottom-start', 'top-end', 'top-start'];\n\n  /**\n   * It identifies the currently active element in the selector.\n   */\n  // eslint-disable-next-line @angular-eslint/no-input-rename\n  @Input('aria-activedescendant') ariaActivedescendant?: string;\n\n  /**\n   * Set `aria-describedby` with an element id that contains a detailed decription of the widget.\n   * It is used to establish a relationship between widgets or groups and the text that describes them.\n   */\n  // eslint-disable-next-line @angular-eslint/no-input-rename\n  @Input('aria-describedby') ariaDescribedby?: string;\n\n  /**\n   * Set `ariaLabelForDropdown` with a text that explains what dropdown component is about\n   */\n  @Input() ariaLabelForDropdown = 'A dropdown component with a product list';\n\n  /**\n   * Set `ariaLabelForToggleButton` with a text that explains what a toggle button is about\n   */\n  @Input() ariaLabelForToggleButton = 'A toggle button for a product list';\n\n  /**\n   * Specifies which element the dropdown should be appended to.\n   */\n  @Input() container: '' | 'body' = '';\n\n  isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;\n  @ViewChild('bbDropdown', { static: true }) bbDropdown: NgbDropdown | undefined;\n  @ViewChild('dropdownToggle') dropdownToggle!: ElementRef;\n  @ContentChildren('listItem') listItems!: QueryList<ElementRef>;\n\n  @HostListener('window:keydown', ['$event'])\n  onKeyEvent(event: KeyboardEvent) {\n    if (this.isOpen) {\n      switch (this.isIE ? event.keyCode : event.key) {\n        case 40:\n        case 'ArrowDown':\n          this.focusedItemIndex = Math.min(this.focusedItemIndex + 1, this.listItems.length - 1);\n          this.focusItem();\n          break;\n        case 38:\n        case 'ArrowUp':\n          this.focusedItemIndex = Math.max(this.focusedItemIndex - 1, 0);\n          this.focusItem();\n          break;\n        case 'Enter':\n          this.clickItem();\n          break;\n        default:\n          return;\n      }\n      event.preventDefault();\n    }\n  }\n\n  close() {\n    if (this.bbDropdown && this.autoClose && this.bbDropdown.isOpen()) {\n      this.bbDropdown.close();\n    }\n  }\n\n  open() {\n    if (this.bbDropdown && !this.bbDropdown.isOpen()) {\n      this.bbDropdown.open();\n    }\n  }\n\n  onClose() {\n    if (this.autoClose) {\n      this.close();\n      this.dropdownToggle.nativeElement.focus();\n    }\n  }\n\n  focusItem() {\n    this.listItems.forEach((el, index) => {\n      if (index === this.focusedItemIndex) {\n        el.nativeElement.tabIndex = 0;\n        el.nativeElement.focus();\n      }\n    });\n  }\n\n  private clickItem() {\n    this.listItems.forEach((el, index) => {\n      if (index === this.focusedItemIndex) {\n        el.nativeElement.click();\n      }\n    });\n  }\n\n  /**\n   * Event handler for change open/close state in dropdown menu\n   */\n  onOpenChange($event: boolean) {\n    this.isOpen = $event;\n    if (!this.isOpen) {\n      this.focusedItemIndex = -1;\n    }\n  }\n\n  /**\n   * Event handler for blur dropdown menu\n   */\n  onBlur() {\n    if (this.bbDropdown && this.bbDropdown.isOpen()) {\n      this.bbDropdown.close();\n    }\n  }\n}\n",
      properties: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 10,
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 9,
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 8,
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 11,
        },
      ],
      indexSignatures: [
        {
          id: 'index-declaration-70923e5dba772348fb68253787ae85d771c2c436261b48097423ded74294f7a176562dd00e3cf2be0183255ab7237c2f8732d7705e6c25b247dd4324744f4e87',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'any',
          line: 11,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      methods: [],
      extends: [],
    },
    {
      name: 'QuillInstance',
      id: 'interface-QuillInstance-6f28845bd38f52e8c424282323a430452a757540b8a63e4f2608128b908874ed5556b64df3c97e76580047afe0d7d102ae5192ae91f32242287a3c6efe89d488',
      file: 'libs/ui-ang/rich-text-editor/helpers/counter.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import 'quill';\n\nexport interface Config {\n  container: string;\n  unit: 'word' | 'char';\n}\n\nexport interface QuillInstance {\n  on: any;\n  getText: any;\n}\n\nexport default class Counter {\n  constructor(readonly quill: QuillInstance, readonly options: Config) {\n    this.quill = quill;\n    this.options = options;\n\n    const container = document.querySelector(this.options.container) as any;\n\n    this.quill.on('editor-change', () => {\n      const length = this.calculate();\n\n      container.innerHTML = length + ' ' + this.options.unit + 's';\n    });\n  }\n\n  calculate() {\n    const text = this.quill.getText().trim();\n\n    if (this.options.unit === 'word') {\n      return !text ? 0 : text.split(/\\s+/).length;\n    }\n\n    return text.length;\n  }\n}\n",
      properties: [
        {
          name: 'getText',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'on',
          deprecated: false,
          deprecationMessage: '',
          type: 'any',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'RadioGroup',
      id: 'interface-RadioGroup-8609dcef24f7336e89d5e5c96e4b07418bdaa3c0880c093ea8de5d33af42a0329e846cefecb09705b2b96392a69280f6f895473cb6a9d1d13700c5d876a2918a',
      file: 'libs/ui-ang-examples/src/configuration/configuration-input.service.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Injectable } from '@angular/core';\nimport { Subject } from 'rxjs';\n\n@Injectable()\nexport class ConfigurationInputService {\n  sharedField = new Subject();\n}\nexport interface RadioItem {\n  label: string;\n  value: boolean | string;\n}\n\nexport type CheckboxItem = RadioItem & {\n  formControlName: string;\n};\nexport type CheckboxList = Array<CheckboxItem>;\n\nexport interface RadioGroup {\n  label: string;\n  formControlName: string;\n  radioItems: RadioItem[];\n}\n\nexport type RadioGroupList = Array<RadioGroup>;\n\nexport type InputList = Array<InputItem>;\n\nexport interface DropdownItem {\n  label: string;\n  formControlName: string;\n  dropdownItemList: string[];\n}\n\nexport interface InputItem {\n  label: string;\n  formControlName: string;\n  value: string;\n}\n\nexport type DropdownList = Array<DropdownItem>;\n",
      properties: [
        {
          name: 'formControlName',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 20,
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 19,
        },
        {
          name: 'radioItems',
          deprecated: false,
          deprecationMessage: '',
          type: 'RadioItem[]',
          indexKey: '',
          optional: false,
          description: '',
          line: 21,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'RadioItem',
      id: 'interface-RadioItem-8609dcef24f7336e89d5e5c96e4b07418bdaa3c0880c093ea8de5d33af42a0329e846cefecb09705b2b96392a69280f6f895473cb6a9d1d13700c5d876a2918a',
      file: 'libs/ui-ang-examples/src/configuration/configuration-input.service.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Injectable } from '@angular/core';\nimport { Subject } from 'rxjs';\n\n@Injectable()\nexport class ConfigurationInputService {\n  sharedField = new Subject();\n}\nexport interface RadioItem {\n  label: string;\n  value: boolean | string;\n}\n\nexport type CheckboxItem = RadioItem & {\n  formControlName: string;\n};\nexport type CheckboxList = Array<CheckboxItem>;\n\nexport interface RadioGroup {\n  label: string;\n  formControlName: string;\n  radioItems: RadioItem[];\n}\n\nexport type RadioGroupList = Array<RadioGroup>;\n\nexport type InputList = Array<InputItem>;\n\nexport interface DropdownItem {\n  label: string;\n  formControlName: string;\n  dropdownItemList: string[];\n}\n\nexport interface InputItem {\n  label: string;\n  formControlName: string;\n  value: string;\n}\n\nexport type DropdownList = Array<DropdownItem>;\n",
      properties: [
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean | string',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'RangeSelectModel',
      id: 'interface-RangeSelectModel-bb7a545a7762882f30a880ecea0642f0d51eeb13a1b5b1b095d333495aa7ed6b4796c601692bf42d17191791ebcff98ba65b042becc9bce175c4cf7e0b2bc89e',
      file: 'libs/ui-ang/input-datepicker/input-datepicker.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';\n\nexport const INVALID_DATE_FORMAT_KEY = 'invalidDateFormat';\n\nexport type NgDateStructNullable = NgbDateStruct | null;\n\nexport interface DateSelectionModel {\n  date: NgDateStructNullable;\n  isSelecting?: boolean;\n}\n\nexport interface DateRangeSelectionModel extends DateSelectionModel {\n  isTo: boolean;\n}\n\nexport interface DateRangeModel {\n  from: string;\n  to: string;\n}\n\nexport interface RangeSelectModel {\n  from: NgDateStructNullable;\n  to: NgDateStructNullable;\n  closeDatePicker: boolean;\n}\n",
      properties: [
        {
          name: 'closeDatePicker',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: false,
          description: '',
          line: 24,
        },
        {
          name: 'from',
          deprecated: false,
          deprecationMessage: '',
          type: 'NgDateStructNullable',
          indexKey: '',
          optional: false,
          description: '',
          line: 22,
        },
        {
          name: 'to',
          deprecated: false,
          deprecationMessage: '',
          type: 'NgDateStructNullable',
          indexKey: '',
          optional: false,
          description: '',
          line: 23,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'RuleData',
      id: 'interface-RuleData-b86499464611e9c53a8431adccf5dbf3a65a42de30bd04cc805a7b7155731ef4e0d8de34a03cfa775948c2ec43db03c0ccd9956cdd4b488a63d7019622853e7b',
      file: 'tools/scripts/ds-eslint/generate-rule-docs.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import type { TSESLint } from '@typescript-eslint/utils';\nimport { readdirSync, readFileSync, writeFileSync } from 'fs';\nimport { compile } from 'json-schema-to-typescript';\nimport traverse from 'json-schema-traverse';\nimport { join, relative } from 'path';\nimport { format, resolveConfig } from 'prettier';\nimport ts from 'typescript';\n\nconst SPECIAL_UNDERLINE_CHARS = ['~', '^', '#', '%', '¶', '*', '¨', '@'];\n\nconst docsOutputDir = join(__dirname, `../../../libs/eslint-plugin-design-system/docs/rules`);\n\nconst rulesDir = join(__dirname, `../../../libs/eslint-plugin-design-system/src/rules`);\nconst ruleFiles = readdirSync(rulesDir);\n\nconst testDirsDir = join(__dirname, `../../../libs/eslint-plugin-design-system/src/rules`);\nconst testDirs = readdirSync(testDirsDir);\n\n(async function main() {\n  const allRuleData = await generateAllRuleData();\n\n  for (const [ruleName, ruleData] of Object.entries(allRuleData)) {\n    const {\n      ruleConfig: {\n        meta: { deprecated, replacedBy, type, fixable, schema, hasSuggestions },\n        defaultOptions,\n      },\n      docsExtension,\n      ruleFilePath,\n      testCasesFilePath,\n    } = ruleData;\n\n    const docs = ruleData.ruleConfig.meta.docs as TSESLint.RuleMetaDataDocs<[]>;\n    const { description } = docs;\n\n    let schemaAsInterface = '';\n    if (Array.isArray(schema) && schema[0]) {\n      /**\n       * json-schema-to-typescript does not do anything with the \"default\" property,\n       * but it's really useful to include in the documentation, so we apply the\n       * default value in a consistent way to the \"description\" property before\n       * converting.\n       */\n      traverse(schema[0], {\n        allKeys: true,\n        cb: (...data) => {\n          const [schemaNode, , , , , , keyIndex] = data;\n\n          let defaultValue = null;\n\n          if (typeof schemaNode.default !== 'undefined') {\n            defaultValue = schemaNode.default;\n          } else if (defaultOptions?.length) {\n            for (const defaultOption of defaultOptions) {\n              const defaultValueForNode = defaultOption[keyIndex as string];\n              if (defaultValueForNode) {\n                defaultValue = defaultValueForNode;\n              }\n            }\n          }\n\n          if (defaultValue) {\n            if (schemaNode.description) {\n              schemaNode.description += '\\n\\n';\n            } else {\n              schemaNode.description = '';\n            }\n            const serializedDefaultValue = JSON.stringify(defaultValue);\n            schemaNode.description += `Default: \\`${serializedDefaultValue}\\``;\n\n            return;\n          }\n        },\n      });\n      schemaAsInterface = await compile(schema[0], 'Options', {\n        bannerComment: '',\n      });\n      schemaAsInterface = schemaAsInterface.replace('export ', '');\n    }\n\n    const fullRuleName = `@backbase/design-system/${ruleName}`;\n\n    const md = `\n<!--\n\n  DO NOT EDIT.\n\n  This markdown file was autogenerated using a mixture of the following files as the source of truth for its data:\n  - ${relativePath(docsOutputDir, ruleFilePath)}\n  - ${relativePath(docsOutputDir, testCasesFilePath)}\n\n  In order to update this file, it is therefore those files which need to be updated,\n  as well as potentially the generator script:\n  - ${relativePath(docsOutputDir, __filename)}\n\n-->\n\n<br>\n\n# \\`${fullRuleName}\\`\n\n${\n  deprecated\n    ? `## ⚠️ THIS RULE IS DEPRECATED\\n\\nPlease use ${(replacedBy || [])\n        .map((r: string) => `\\`@backbase/design-system/${r}\\``)\n        .join(', ')} instead.\\n\\n---\\n\\n`\n    : ''\n}${description}\n\n- Type: ${type}\n${fixable === 'code' ? '- 🔧 Supports autofix (`--fix`)\\n' : ''}\n${\n  hasSuggestions\n    ? '- 💡 Provides suggestions on how to fix issues (https://eslint.org/docs/developer-guide/working-with-rules#providing-suggestions)'\n    : ''\n}${\n      docsExtension?.rationale\n        ? `\n\n<br>\n\n## Rationale\n\n${docsExtension.rationale}\n`\n        : ''\n    }\n\n<br>\n\n## Rule Options\n\n${\n  schemaAsInterface\n    ? `\nThe rule accepts an options object with the following properties:\n\n\\`\\`\\`ts\n${schemaAsInterface}\n\\`\\`\\`\n`\n    : 'The rule does not have any configuration options.'\n}\n\n<br>\n\n## Usage Examples\n\n> The following examples are generated automatically from the actual unit tests within the plugin,\n so you can be assured that their behavior is accurate based on the current commit.\n\n<br>\n\n<details>\n<summary>❌ - Toggle examples of <strong>incorrect</strong> code for this rule</summary>\n\n${convertCodeExamplesToMarkdown(ruleData.invalid, 'invalid', 'html', fullRuleName)}\n\n</details>\n\n<br>\n\n---\n\n<br>\n\n<details>\n<summary>✅ - Toggle examples of <strong>correct</strong> code for this rule</summary>\n\n${convertCodeExamplesToMarkdown(ruleData.valid, 'valid', 'html', fullRuleName)}\n\n</details>\n\n<br>\n`;\n\n    const outputFilePath = join(docsOutputDir, `${ruleName}.md`);\n    writeFileSync(\n      outputFilePath,\n      await format(md, {\n        ...(await resolveConfig(outputFilePath)),\n        parser: 'markdown',\n      }),\n    );\n  }\n\n  console.log(`\\n✨ Updated docs for all rules in \"@backbase/design-system\"`);\n})();\n\ninterface RuleData {\n  ruleFilePath: string;\n  testCasesFilePath: string;\n  ruleConfig: TSESLint.RuleModule<string, []> & {\n    defaultOptions?: Record<string, unknown>[];\n  };\n  // Rules can optionally export extended documentation content (outside of ESLint's concept of \"docs\")\n  docsExtension?: {\n    rationale?: string;\n  };\n  valid: ExtractedTestCase[];\n  invalid: ExtractedTestCase[];\n}\n\ninterface AllRuleData {\n  [ruleName: string]: RuleData;\n}\n\ninterface ExtractedTestCase {\n  code: string;\n  options?: unknown[];\n}\n\nasync function generateAllRuleData(): Promise<AllRuleData> {\n  const ruleData: AllRuleData = {};\n\n  // For rule sources we just import/execute the rule source file\n  for (const ruleFile of ruleFiles) {\n    if (ruleFile.endsWith('.spec.ts')) {\n      continue;\n    }\n\n    const ruleFilePath = join(rulesDir, ruleFile.replace('.ts', ''));\n    const {\n      default: ruleConfig,\n      RULE_NAME,\n      RULE_DOCS_EXTENSION,\n      // eslint-disable-next-line @typescript-eslint/no-var-requires\n    } = require(ruleFilePath);\n    ruleData[RULE_NAME] = {\n      ruleConfig,\n      ruleFilePath: ruleFilePath + '.ts',\n      docsExtension: RULE_DOCS_EXTENSION,\n    } as RuleData;\n  }\n\n  /**\n   * For tests we want to preserve the annotated sources, so we do NOT want\n   * to execute the file and instead need to parse it using the ts compiler.\n   */\n  for (const testDir of testDirs) {\n    if (testDir.endsWith('.spec.ts')) {\n      continue;\n    }\n\n    const ruleFilePath = join(rulesDir, testDir.replace('.ts', ''));\n    const {\n      RULE_NAME,\n      // eslint-disable-next-line @typescript-eslint/no-var-requires\n    } = require(ruleFilePath);\n\n    const testDirPath = join(testDirsDir, testDir);\n    const casesFilePath = testDirPath.replace(/.ts$/, '.spec.ts');\n    const testCasesContents = readFileSync(casesFilePath, 'utf-8');\n    const casesSourceFile = ts.createSourceFile(casesFilePath, testCasesContents, ts.ScriptTarget.Latest, true);\n\n    const extractedValid: ExtractedTestCase[] = [];\n    const extractedInvalid: ExtractedTestCase[] = [];\n\n    const extractNodes = (node: ts.Node) => {\n      if (\n        ts.isVariableDeclaration(node) &&\n        node.name.getText() === 'valid' &&\n        node.initializer &&\n        ts.isArrayLiteralExpression(node.initializer)\n      ) {\n        node.initializer.elements.forEach((el) => {\n          const newExtractedTestCase: ExtractedTestCase = {\n            code: '',\n          };\n\n          if (ts.isStringLiteralLike(el)) {\n            newExtractedTestCase.code = el.text;\n          }\n\n          if (ts.isObjectLiteralExpression(el)) {\n            el.properties.forEach((prop) => {\n              if (ts.isPropertyAssignment(prop) && prop.name.getText() === 'code') {\n                if (ts.isNoSubstitutionTemplateLiteral(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.rawText || prop.initializer.text;\n                }\n                if (ts.isTemplateExpression(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.getText();\n                }\n                if (ts.isStringLiteral(prop.initializer)) {\n                  newExtractedTestCase.code = prop.initializer.text;\n                }\n              }\n\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'options' &&\n                ts.isArrayLiteralExpression(prop.initializer)\n              ) {\n                newExtractedTestCase.options = convertArrayLiteralExpressionToCode(prop.initializer);\n              }\n            });\n          }\n\n          if (newExtractedTestCase.code) {\n            extractedValid.push(newExtractedTestCase);\n          }\n        });\n      }\n\n      if (\n        ts.isVariableDeclaration(node) &&\n        node.name.getText() === 'invalid' &&\n        node.initializer &&\n        ts.isArrayLiteralExpression(node.initializer)\n      ) {\n        node.initializer.elements.forEach((el) => {\n          if (ts.isCallExpression(el) && el.expression.getText() === 'convertAnnotatedSourceToFailureCase') {\n            const newExtractedTestCase: ExtractedTestCase = {\n              code: '',\n            };\n\n            const config = el.arguments[0] as ts.ObjectLiteralExpression;\n            config.properties.forEach((prop) => {\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'annotatedSource' &&\n                ts.isNoSubstitutionTemplateLiteral(prop.initializer)\n              ) {\n                newExtractedTestCase.code = prop.initializer.text;\n              }\n\n              if (\n                ts.isPropertyAssignment(prop) &&\n                prop.name.getText() === 'options' &&\n                ts.isArrayLiteralExpression(prop.initializer)\n              ) {\n                newExtractedTestCase.options = convertArrayLiteralExpressionToCode(prop.initializer);\n              }\n            });\n\n            if (newExtractedTestCase.code) {\n              extractedInvalid.push(newExtractedTestCase);\n            }\n          }\n        });\n      }\n\n      ts.forEachChild(node, extractNodes);\n    };\n\n    // Extract valid and invalid cases as strings\n    extractNodes(casesSourceFile);\n\n    ruleData[RULE_NAME] = {\n      ...ruleData[RULE_NAME],\n      testCasesFilePath: casesFilePath,\n      valid: extractedValid,\n      invalid: extractedInvalid,\n    };\n  }\n\n  return ruleData;\n}\n\nfunction standardizeSpecialUnderlineChar(str: string): string {\n  /**\n   * It is important that we only update special characters when we are on a line\n   * which only has special characters on it (as well as whitespace). Otherwise\n   * we will end up replacing real characters from the source code in the example.\n   */\n  const specialCharsOrWhitespaceRegExp = new RegExp(`^(${SPECIAL_UNDERLINE_CHARS.map(escapeRegExp).join('|')}|\\\\s)+$`);\n  const whitespaceOnlyRegExp = /^\\s+$/;\n\n  return str\n    .split('\\n')\n    .map((line) => {\n      // Is line with exclusively special characters and whitespace (but not just whitespace)?\n      if (!line.match(whitespaceOnlyRegExp) && line.match(specialCharsOrWhitespaceRegExp)) {\n        return line\n          .split('')\n          .map((char) =>\n            SPECIAL_UNDERLINE_CHARS.includes(char as (typeof SPECIAL_UNDERLINE_CHARS)[number]) ? '~' : char,\n          )\n          .join('');\n      }\n\n      return line;\n    })\n    .join('\\n');\n}\n\n// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping\nfunction escapeRegExp(str: string) {\n  return str.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&'); // $& means the whole matched string\n}\n\nfunction convertCodeExamplesToMarkdown(\n  codeExamples: ExtractedTestCase[] = [],\n  kind: 'valid' | 'invalid',\n  highligher: 'html' | 'ts',\n  ruleName: string,\n): string {\n  return codeExamples\n    .map(({ code, options }, i) => {\n      let formattedCode = removeLeadingAndTrailingEmptyLinesFromCodeExample(\n        removeLeadingIndentationFromCodeExample(code),\n      );\n      if (kind === 'invalid') {\n        formattedCode = standardizeSpecialUnderlineChar(formattedCode);\n      }\n\n      const exampleRuleConfig: unknown[] = ['error'];\n      // Not all unit tests have options configured\n      if (options) {\n        exampleRuleConfig.push(options[0]);\n      }\n      const formattedConfig = JSON.stringify(\n        {\n          rules: {\n            [ruleName]: exampleRuleConfig,\n          },\n        },\n        null,\n        2,\n      );\n\n      return `<br>\n\n#### ${options ? 'Custom' : 'Default'} Config\n\n\\`\\`\\`json\n${formattedConfig}\n\\`\\`\\`\n\n<br>\n\n#### ${kind === 'invalid' ? '❌ Invalid' : '✅ Valid'} Code\n\n\\`\\`\\`${highligher}\n${formattedCode}\n\\`\\`\\`\n\n${\n  i === codeExamples.length - 1\n    ? ''\n    : `<br>\n\n---`\n}\n  `;\n    })\n    .join('\\n');\n}\n\nfunction removeLeadingAndTrailingEmptyLinesFromCodeExample(code: string): string {\n  const lines = code.split('\\n');\n\n  let currentLineIndex = 0;\n  let firstNonEmptyLineIndex = -1;\n  let lastNonEmptyLineIndex = -1;\n\n  for (const line of lines) {\n    if (/\\S/.test(line)) {\n      if (firstNonEmptyLineIndex === -1) {\n        firstNonEmptyLineIndex = currentLineIndex;\n      }\n      lastNonEmptyLineIndex = currentLineIndex;\n    }\n    currentLineIndex++;\n  }\n\n  return lines\n    .filter((_, index) => {\n      if (index < firstNonEmptyLineIndex) {\n        return false;\n      }\n      if (index > lastNonEmptyLineIndex) {\n        return false;\n      }\n\n      return true;\n    })\n    .join('\\n');\n}\n\n/**\n * We want to remove unnecessary leading padding, but keeping everything relative,\n * so that code indentation is not messed up\n */\nfunction removeLeadingIndentationFromCodeExample(code: string): string {\n  let detectedAmountToTrim: number | null = null;\n\n  return code\n    .split('\\n')\n    .map((line) => {\n      // Is whitespace-only line, ignore\n      if (!/\\S/.test(line)) {\n        return line;\n      }\n\n      // Haven't yet determined the number of characters to trim from the beginning of each line\n      const charsInLine = line.split('');\n      if (typeof detectedAmountToTrim !== 'number') {\n        let numberOfLeadingWhitespaceChars = 0;\n        for (const char of charsInLine) {\n          if (!/\\S/.test(char)) {\n            numberOfLeadingWhitespaceChars++;\n            continue;\n          }\n          break;\n        }\n        detectedAmountToTrim = numberOfLeadingWhitespaceChars;\n      }\n\n      // Trim the detected number of characters from the beginning of the current line\n      return (\n        line\n          .split('')\n          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion\n          .filter((_, i) => !(i < detectedAmountToTrim!))\n          .join('')\n      );\n    })\n    .join('\\n');\n}\n\nfunction convertStringLikeToCode(strLike: ts.StringLiteralLike): string {\n  if (ts.isStringLiteralLike(strLike)) {\n    return strLike.text;\n  }\n\n  return '';\n}\n\nfunction convertNumericalLiteralToCode(numLiteral: ts.NumericLiteral): number {\n  return Number(numLiteral.text);\n}\n\nfunction convertBooleanLiteralToCode(booleanLiteral: ts.BooleanLiteral): boolean {\n  const stringified = booleanLiteral.getText();\n  if (stringified === 'false') {\n    return false;\n  }\n  if (stringified === 'true') {\n    return true;\n  }\n  throw new Error(`Could not convert booleanLiteral node to code: ${booleanLiteral}`);\n}\n\nfunction convertArrayLiteralExpressionToCode(arrExpr: ts.ArrayLiteralExpression): unknown[] {\n  const arr: unknown[] = [];\n  arrExpr.elements.forEach((el) => {\n    if (ts.isObjectLiteralExpression(el)) {\n      const item = convertObjectLiteralExpressionToCode(el);\n      arr.push(item);\n    }\n    if (ts.isStringLiteralLike(el)) {\n      const item = convertStringLikeToCode(el);\n      arr.push(item);\n    }\n    if (ts.isArrayLiteralExpression(el)) {\n      const item = convertArrayLiteralExpressionToCode(el);\n      arr.push(item);\n    }\n  });\n\n  return arr;\n}\n\nfunction convertObjectLiteralExpressionToCode(objExpr: ts.ObjectLiteralExpression): Record<string, unknown> {\n  const obj: Record<string, unknown> = {};\n  objExpr.properties.forEach((prop) => {\n    if (ts.isPropertyAssignment(prop)) {\n      const key = prop.name.getText();\n\n      let val;\n      if (ts.isObjectLiteralExpression(prop.initializer)) {\n        val = convertObjectLiteralExpressionToCode(prop.initializer);\n      }\n      if (ts.isStringLiteralLike(prop.initializer)) {\n        val = convertStringLikeToCode(prop.initializer);\n      }\n      if (ts.isArrayLiteralExpression(prop.initializer)) {\n        val = convertArrayLiteralExpressionToCode(prop.initializer);\n      }\n      if (ts.isNumericLiteral(prop.initializer)) {\n        val = convertNumericalLiteralToCode(prop.initializer);\n      }\n      if (prop.initializer.kind === ts.SyntaxKind.TrueKeyword || prop.initializer.kind === ts.SyntaxKind.FalseKeyword) {\n        val = convertBooleanLiteralToCode(prop.initializer as ts.BooleanLiteral);\n      }\n\n      if (key && typeof val !== 'undefined') {\n        obj[key] = val;\n      }\n    }\n  });\n\n  return obj;\n}\n\nfunction relativePath(from: string, to: string) {\n  // On Windows relative() outputs backslashes. As the path should always contain normal slashes, replace them.\n  return relative(from, to).replace(/\\\\/g, '/');\n}\n",
      properties: [
        {
          name: 'docsExtension',
          deprecated: false,
          deprecationMessage: '',
          type: 'literal type',
          indexKey: '',
          optional: true,
          description: '',
          line: 197,
        },
        {
          name: 'invalid',
          deprecated: false,
          deprecationMessage: '',
          type: 'ExtractedTestCase[]',
          indexKey: '',
          optional: false,
          description: '',
          line: 201,
        },
        {
          name: 'ruleConfig',
          deprecated: false,
          deprecationMessage: '',
          type: '',
          indexKey: '',
          optional: false,
          description: '',
          line: 193,
        },
        {
          name: 'ruleFilePath',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 191,
        },
        {
          name: 'testCasesFilePath',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 192,
        },
        {
          name: 'valid',
          deprecated: false,
          deprecationMessage: '',
          type: 'ExtractedTestCase[]',
          indexKey: '',
          optional: false,
          description: '',
          line: 200,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'SelectListItemBase',
      id: 'interface-SelectListItemBase-549c03a37072651b1d775c643edc0c5e6e663aceb5c9d78a276c64e443df75b225e51e544dd317605a802a28534fd654551d59ab6b536b4bcbef1298192b00fe',
      file: 'libs/ui-ang/select-list/select-list.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  Component,\n  EventEmitter,\n  forwardRef,\n  Input,\n  OnChanges,\n  Output,\n  SimpleChanges,\n  ViewChild,\n  ChangeDetectorRef,\n  AfterViewInit,\n  Renderer2,\n  OnDestroy,\n} from '@angular/core';\nimport { NG_VALUE_ACCESSOR } from '@angular/forms';\nimport { NgSelectComponent } from '@ng-select/ng-select';\nimport { BehaviorSubject, Observable, Subject } from 'rxjs';\nimport { filter, distinctUntilChanged, debounceTime, map, takeUntil } from 'rxjs/operators';\nimport { InputBaseComponent } from '@backbase/ui-ang/base-classes';\n\nexport interface SelectListItemBase {\n  name: string;\n}\n\n@Component({\n  selector: 'bb-select-list-ui',\n  templateUrl: './select-list.component.html',\n  providers: [\n    {\n      provide: NG_VALUE_ACCESSOR,\n      multi: true,\n      useExisting: forwardRef(() => SelectListComponent),\n    },\n  ],\n  standalone: false,\n})\n// TODO: set a generic that extends to SelectListItemBase once Ivy check types step supports correctly types\nexport class SelectListComponent<T extends { name: string }>\n  extends InputBaseComponent\n  implements OnChanges, AfterViewInit, OnDestroy\n{\n  override value: InputBaseComponent['value'] = null;\n\n  @ViewChild('select') ngSelect?: NgSelectComponent;\n\n  /**\n   * Flag to determine if the data in the list is loading\n   */\n  @Input() loading = false;\n\n  /**\n   * Placeholder text to display in the input\n   * */\n  @Input() placeholder = '';\n\n  /**\n   * Minimum number of characters required before searching for items\n   * */\n  @Input() minTermLength = 2;\n\n  /**\n   * Maximum number of selected items, 'none' means unlimited\n   */\n  @Input() maxSelectedItems = 'none';\n\n  /**\n   * Flag to determine if the list allows multiple selection.\n   * */\n  @Input() multiple = false;\n\n  /**\n   * A list of items to select from based on the input text.\n   * */\n  @Input() items: T[] = [];\n\n  /**\n   * Flag to determine if typeahead should be used to filter the items list.\n   * If enabled the items list can not be updated asynchonously as the filtering\n   * and the underlying data will get out of sync.\n   */\n  @Input() filterEnabled = true;\n\n  @Input()\n  set isOpen(value) {\n    this._isOpen$.next(value);\n  }\n\n  get isOpen() {\n    return this._isOpen$.getValue();\n  }\n\n  private readonly _isOpen$ = new BehaviorSubject<boolean | undefined>(undefined);\n\n  /**\n   * Output to capture value change event.\n   */\n  @Output() valueChange = this._valueChange;\n\n  /**\n   * Emitter when search is performed. Outputs search term\n   */\n  @Output() search: EventEmitter<string> = new EventEmitter<string>();\n\n  /**\n   * Emitter when clear is performed.\n   */\n  @Output() clear = new EventEmitter<void>();\n\n  /**\n   * Delay in ms between autocomplete updates.\n   * */\n  private readonly DEBOUNCE_TIME_MS = 500;\n  /**\n   * Observable of the typeahead input\n   */\n  readonly typeaheadInput$ = new Subject<string>();\n  /**\n   * Observable of the filtered items\n   */\n  readonly filteredItems$: Observable<T[]> = this.typeaheadInput$.pipe(\n    filter((term) => term !== null && term.length >= this.minTermLength),\n    distinctUntilChanged(),\n    debounceTime(this.DEBOUNCE_TIME_MS),\n    map((term) => this.items.filter(({ name }: any) => name.toLowerCase().includes(term.toLowerCase()))),\n  );\n\n  private readonly _destroy$ = new Subject<void>();\n\n  protected dropdownPosition: 'bottom' | 'top' | 'auto' = 'auto';\n\n  writeValue(inputValue: Object | string | null): void {\n    if (inputValue !== null) {\n      super.writeValue(inputValue);\n    } else {\n      this.value = inputValue;\n      this.cd.markForCheck();\n    }\n  }\n\n  onSearch(\n    event:\n      | string\n      | {\n          term: string;\n          items: any[];\n        },\n  ) {\n    const searchTerm = typeof event === 'string' ? event : event.term;\n\n    if (searchTerm.length >= this.minTermLength) {\n      this.search.emit(searchTerm);\n    }\n    if (searchTerm?.length === 0 && this.ngSelect?.isOpen === true) {\n      this.ngSelect.isOpen = false;\n    }\n  }\n\n  ngOnChanges(changes: SimpleChanges) {\n    if (this.ngSelect?.isOpen === false && this.ngSelect?.searchTerm) {\n      this.ngSelect.isOpen = true;\n    }\n    const disableChanges = changes.disable;\n\n    if (disableChanges) {\n      this.updateNgSelectComboboxAttrs({ 'aria-disabled': disableChanges.currentValue });\n    }\n  }\n\n  constructor(\n    cd: ChangeDetectorRef,\n    private readonly renderer: Renderer2,\n  ) {\n    super(cd);\n  }\n\n  ngOnDestroy() {\n    this._destroy$.next();\n    this._destroy$.complete();\n  }\n\n  ngAfterViewInit() {\n    this._isOpen$.pipe(takeUntil(this._destroy$)).subscribe((isOpen) => {\n      if (isOpen) {\n        this.moveAriaAttributes();\n        this.dropdownPosition = 'bottom';\n      }\n\n      if (isOpen === undefined) {\n        this.addAriaExpanded();\n      }\n    });\n    this.removeAriaPlaceholder();\n  }\n\n  /**\n   * @deprecated Deprecated in ui-ang@12. To be marked as protected in ui-ang@14. No replacements.\n   */\n  onOpen() {\n    // HACK: ng-select added a duplicate role=listbox as of v11 in https://github.com/ng-select/ng-select/pull/2199\n    // We move role=list and aria-label on ng-dropdown-panel to the child div\n\n    // Wait for dropdown from ng-select to show\n    setTimeout(() => {\n      this.moveAriaAttributes();\n    });\n  }\n\n  // Append aria attributes to combobox (container of ng-select input) for a11y\n  private updateNgSelectComboboxAttrs(changedAttrs: Record<string, any>) {\n    if (!this.ngSelect) {\n      return;\n    }\n\n    const combobox = this.ngSelect.element.querySelector('[role=\"combobox\"]');\n\n    Object.entries(changedAttrs).forEach(([attr, val]) => {\n      if (val) {\n        this.renderer.setAttribute(combobox, attr, val);\n      } else {\n        this.renderer.removeAttribute(combobox, attr);\n      }\n    });\n  }\n\n  private moveAriaAttributes() {\n    const dropdownPanelElement = this.ngSelect?.element.querySelector('ng-dropdown-panel');\n    const listboxElement = dropdownPanelElement?.querySelector('[role=\"listbox\"]');\n\n    if (!dropdownPanelElement || !listboxElement) {\n      return;\n    }\n\n    this.renderer.setAttribute(listboxElement, 'aria-label', dropdownPanelElement.getAttribute('aria-label') ?? '');\n    this.renderer.removeAttribute(dropdownPanelElement, 'role');\n    this.renderer.removeAttribute(dropdownPanelElement, 'aria-label');\n  }\n\n  private addAriaExpanded() {\n    const comboboxElement = this.ngSelect?.element?.querySelector('[role=\"combobox\"]');\n\n    if (!comboboxElement || comboboxElement.hasAttribute('aria-expanded')) {\n      return;\n    }\n\n    this.renderer.setAttribute(comboboxElement, 'aria-expanded', 'false');\n  }\n\n  private removeAriaPlaceholder() {\n    if (!this.ngSelect) {\n      return;\n    }\n\n    const inputContainers = Array.from(this.ngSelect.element.getElementsByClassName('ng-input'));\n    for (const inputContainer of inputContainers) {\n      const inputElements = Array.from(inputContainer.getElementsByTagName('input'));\n      for (const inputElement of inputElements) {\n        inputElement.removeAttribute('aria-placeholder');\n      }\n    }\n  }\n}\n",
      properties: [
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 22,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'SelectListItemCode',
      id: 'interface-SelectListItemCode-8fafaa344a9c82e8eec0ed85a896d2632c43946500fac936574bd20ed8043447890e8d0932522446c5ea9395565f7bae40a51f08f4557d5a39355a3fab1803db',
      file: 'libs/ui-ang-examples/src/select-list/showcase/select-list-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, OnInit } from '@angular/core';\nimport { UntypedFormControl, UntypedFormGroup } from '@angular/forms';\nimport { Observable, BehaviorSubject, of, Subject } from 'rxjs';\nimport { delay, map, switchMap, tap } from 'rxjs/operators';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\nimport { SelectListItemBase } from '@backbase/ui-ang/select-list';\n\ninterface SelectListItemValue extends SelectListItemBase {\n  value: string;\n}\n\ninterface SelectListItemCode extends SelectListItemBase {\n  code: string;\n}\n\n@Component({\n  selector: 'bb-select-list-ui-showcase',\n  templateUrl: './select-list-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class SelectListShowcaseComponent implements OnInit {\n  form!: UntypedFormGroup;\n\n  /** Examples for standard data structure - e.g. { name: '', value: '' } */\n  singleSelectItems: SelectListItemValue[] = [\n    { name: 'Single One', value: 'single-one' },\n    { name: 'Single Two', value: 'single-two' },\n    { name: 'Single Three', value: 'single-three' },\n  ];\n\n  multiSelectItems: SelectListItemValue[] = [\n    { name: 'Multi One', value: 'multi-one' },\n    { name: 'Multi Two', value: 'multi-two' },\n    { name: 'Multi Three', value: 'multi-three' },\n    { name: 'Multi Four', value: 'multi-four' },\n    { name: 'Multi Five', value: 'multi-five' },\n  ];\n\n  /** Example for non-standard data structure - e.g. { name: '', code: '' } */\n  countries: SelectListItemCode[] = [\n    { name: 'France', code: 'FRA' },\n    { name: 'Germany', code: 'GER' },\n    { name: 'Italy', code: 'ITA' },\n    { name: 'United Kingdom', code: 'UK' },\n  ];\n\n  itemsObservable$ = of([\n    { name: 'Item One', value: 'item-one' },\n    { name: 'Item Two', value: 'item-two' },\n  ]);\n\n  private readonly searchOnLoadSubject = new BehaviorSubject<string>('');\n  private readonly searchAfterValueSubject = new Subject<string>();\n  private readonly loadingSubject = new BehaviorSubject<boolean>(false);\n  searchOnLoadItems$ = this.searchOnLoadSubject.pipe(\n    tap(() => this.loadingSubject.next(true)),\n    delay(1000),\n    switchMap(() => this.itemsObservable$),\n    tap(() => this.loadingSubject.next(false)),\n  );\n  loading: Observable<boolean> = this.loadingSubject.asObservable();\n\n  searchAfterValueItems$ = this.searchAfterValueSubject.pipe(switchMap((term) => this.getResultsFromApi(term)));\n\n  ngOnInit() {\n    this.form = new UntypedFormGroup({\n      singleSelect: new UntypedFormControl(null),\n      multipleSelect: new UntypedFormControl([]),\n      multipleSelectDestinations: new UntypedFormControl([]),\n      multipleSelectObservable: new UntypedFormControl([]),\n      searchOnLoad: new UntypedFormControl(undefined),\n      searchAfterValue: new UntypedFormControl(undefined),\n    });\n  }\n\n  searchOnLoad(value: string) {\n    this.searchOnLoadSubject.next(value);\n  }\n\n  searchAfterValue(value: string) {\n    this.searchAfterValueSubject.next(value);\n  }\n\n  private getResultsFromApi(searchTerm: string): Observable<SelectListItemValue[] | undefined> {\n    // Simulates calling an API to get results that match a given search term (server-side filtering)\n    return this.itemsObservable$.pipe(\n      map((results) =>\n        results.filter((item) => !!searchTerm && item.name.toLowerCase().includes(searchTerm.toLowerCase())),\n      ),\n      delay(1000),\n    );\n  }\n}\n",
      properties: [
        {
          name: 'code',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 13,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: ['SelectListItemBase'],
    },
    {
      name: 'SelectListItemValue',
      id: 'interface-SelectListItemValue-8fafaa344a9c82e8eec0ed85a896d2632c43946500fac936574bd20ed8043447890e8d0932522446c5ea9395565f7bae40a51f08f4557d5a39355a3fab1803db',
      file: 'libs/ui-ang-examples/src/select-list/showcase/select-list-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, OnInit } from '@angular/core';\nimport { UntypedFormControl, UntypedFormGroup } from '@angular/forms';\nimport { Observable, BehaviorSubject, of, Subject } from 'rxjs';\nimport { delay, map, switchMap, tap } from 'rxjs/operators';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\nimport { SelectListItemBase } from '@backbase/ui-ang/select-list';\n\ninterface SelectListItemValue extends SelectListItemBase {\n  value: string;\n}\n\ninterface SelectListItemCode extends SelectListItemBase {\n  code: string;\n}\n\n@Component({\n  selector: 'bb-select-list-ui-showcase',\n  templateUrl: './select-list-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class SelectListShowcaseComponent implements OnInit {\n  form!: UntypedFormGroup;\n\n  /** Examples for standard data structure - e.g. { name: '', value: '' } */\n  singleSelectItems: SelectListItemValue[] = [\n    { name: 'Single One', value: 'single-one' },\n    { name: 'Single Two', value: 'single-two' },\n    { name: 'Single Three', value: 'single-three' },\n  ];\n\n  multiSelectItems: SelectListItemValue[] = [\n    { name: 'Multi One', value: 'multi-one' },\n    { name: 'Multi Two', value: 'multi-two' },\n    { name: 'Multi Three', value: 'multi-three' },\n    { name: 'Multi Four', value: 'multi-four' },\n    { name: 'Multi Five', value: 'multi-five' },\n  ];\n\n  /** Example for non-standard data structure - e.g. { name: '', code: '' } */\n  countries: SelectListItemCode[] = [\n    { name: 'France', code: 'FRA' },\n    { name: 'Germany', code: 'GER' },\n    { name: 'Italy', code: 'ITA' },\n    { name: 'United Kingdom', code: 'UK' },\n  ];\n\n  itemsObservable$ = of([\n    { name: 'Item One', value: 'item-one' },\n    { name: 'Item Two', value: 'item-two' },\n  ]);\n\n  private readonly searchOnLoadSubject = new BehaviorSubject<string>('');\n  private readonly searchAfterValueSubject = new Subject<string>();\n  private readonly loadingSubject = new BehaviorSubject<boolean>(false);\n  searchOnLoadItems$ = this.searchOnLoadSubject.pipe(\n    tap(() => this.loadingSubject.next(true)),\n    delay(1000),\n    switchMap(() => this.itemsObservable$),\n    tap(() => this.loadingSubject.next(false)),\n  );\n  loading: Observable<boolean> = this.loadingSubject.asObservable();\n\n  searchAfterValueItems$ = this.searchAfterValueSubject.pipe(switchMap((term) => this.getResultsFromApi(term)));\n\n  ngOnInit() {\n    this.form = new UntypedFormGroup({\n      singleSelect: new UntypedFormControl(null),\n      multipleSelect: new UntypedFormControl([]),\n      multipleSelectDestinations: new UntypedFormControl([]),\n      multipleSelectObservable: new UntypedFormControl([]),\n      searchOnLoad: new UntypedFormControl(undefined),\n      searchAfterValue: new UntypedFormControl(undefined),\n    });\n  }\n\n  searchOnLoad(value: string) {\n    this.searchOnLoadSubject.next(value);\n  }\n\n  searchAfterValue(value: string) {\n    this.searchAfterValueSubject.next(value);\n  }\n\n  private getResultsFromApi(searchTerm: string): Observable<SelectListItemValue[] | undefined> {\n    // Simulates calling an API to get results that match a given search term (server-side filtering)\n    return this.itemsObservable$.pipe(\n      map((results) =>\n        results.filter((item) => !!searchTerm && item.name.toLowerCase().includes(searchTerm.toLowerCase())),\n      ),\n      delay(1000),\n    );\n  }\n}\n",
      properties: [
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: ['SelectListItemBase'],
    },
    {
      name: 'SnoozeDurationExample',
      id: 'interface-SnoozeDurationExample-0b7ac09c8e601697ae37a7191d434291abbc78865bbdf2a3fbf5f15a46bd35f74bd7019d6c9d450de1a8fa5fe08a61cde27952772274e7005b6f86e8d6469cc0',
      file: 'libs/ui-ang-examples/src/dropdown-menu/examples/dropdown-menu.example.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component } from '@angular/core';\n\ninterface SnoozeDurationExample {\n  label: string;\n  duration: number;\n}\n\n@Component({\n  selector: 'bb-dropdown-menu-example-ui',\n  templateUrl: './dropdown-menu.example.component.html',\n  standalone: false,\n})\nexport class DropdownMenuExampleComponent {\n  dropdownMenuOptions: SnoozeDurationExample[] = [\n    { label: '30 minutes', duration: 1800 },\n    { label: '1 hour', duration: 3600 },\n    { label: '1 day', duration: 86400 },\n  ];\n\n  dropdownMenuOptionsLabel = this.dropdownMenuOptions.map(\n    (item) => item.label,\n  );\n\n  onButtonDropdownSelect(label: string) {\n    const item = this.dropdownMenuOptions.find(\n      (option) => option.label === label,\n    );\n\n    if (item) {\n      this.snooze(item.duration);\n    }\n  }\n\n  snooze(duration: number) {\n    alert(`Snooze for ${duration} seconds`);\n  }\n}\n",
      properties: [
        {
          name: 'duration',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 4,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'SortEvent',
      id: 'interface-SortEvent-4a975580d4a60b4cba9c9daf83a15bbed974a0527053810e41b5d345a16b61d6900f0a59885be5892b278b1fc14a3e6152ab68881b412c178454385ea99af57c',
      file: 'libs/ui-ang/table/directives/table-sortable.directive.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  AfterViewInit,\n  ContentChild,\n  ContentChildren,\n  DestroyRef,\n  Directive,\n  ElementRef,\n  EventEmitter,\n  HostBinding,\n  HostListener,\n  inject,\n  Input,\n  OnDestroy,\n  Output,\n  QueryList,\n  Renderer2,\n} from '@angular/core';\nimport { switchMap } from 'rxjs/operators';\nimport { merge } from 'rxjs';\nimport { DropdownMenuToken, DropdownMenuOptionToken } from '@backbase/ui-ang/dropdown-menu';\nimport { TableDirective } from './table.directive';\nimport { takeUntilDestroyed } from '@angular/core/rxjs-interop';\nexport type SortDirection = 'asc' | 'desc' | null;\nconst rotate: { [key: string]: SortDirection } = { asc: 'desc', desc: null, '': 'asc' };\n\nexport interface SortEvent {\n  column: string;\n  direction: SortDirection;\n}\n\n@Directive({\n  selector: 'th[bbSortable]',\n  standalone: false,\n})\nexport class TableSortableDirective implements AfterViewInit, OnDestroy {\n  /**\n   * The name of the column to be sorted\n   */\n  @Input() bbSortable?: string;\n  /**\n   * The current sort direction. Accepts one of the values of 'asc', 'desc' or null\n   */\n  @Input() direction: SortDirection = null;\n\n  private _sortDisabled = false;\n\n  /**\n   * Toggles the sorting functionality on the column.\n   */\n  @Input() set sortDisabled(value: boolean) {\n    this._sortDisabled = value;\n    this.handleSortControlsPresence();\n  }\n  /**\n   * An event emitter for on sort actions.\n   */\n  @Output() sort = new EventEmitter<SortEvent>();\n\n  @ContentChild(DropdownMenuToken) dropdown: DropdownMenuToken | undefined;\n  @ContentChildren(DropdownMenuOptionToken, { descendants: true })\n  bbMenuOptions!: QueryList<DropdownMenuOptionToken>;\n  sortArrow: Element = this.createSortArrowElement();\n  private buttonElement: HTMLElement | undefined;\n\n  private destroyRef$ = inject(DestroyRef);\n\n  constructor(\n    private readonly parentTable: TableDirective,\n    private readonly renderer: Renderer2,\n    private readonly element: ElementRef,\n  ) {\n    this.parentTable.registerHeader(this);\n  }\n  /**\n   * @deprecated Deprecated in ui-ang@13. To be removed in ui-ang@15. No replacements.\n   */\n  sortable = !this._sortDisabled;\n\n  @HostBinding('class.asc')\n  get asc(): boolean {\n    return this.direction === 'asc';\n  }\n\n  @HostBinding('class.desc')\n  get desc(): boolean {\n    return this.direction === 'desc';\n  }\n\n  @HostListener('click')\n  @HostListener('keyup.enter')\n  @HostListener('keyup.space')\n  rotate() {\n    if (this.dropdownButtonEl) {\n      return;\n    }\n\n    if (this._sortDisabled) {\n      return;\n    }\n    this.emitSortEvent();\n\n    if (this.buttonEl) {\n      this.updateAriaSortAttribute();\n    }\n  }\n\n  private get buttonEl() {\n    return this.dropdown?.buttonEl?.nativeElement ?? this.buttonElement;\n  }\n\n  private get dropdownButtonEl(): HTMLElement | null {\n    return this.dropdown?.buttonEl?.nativeElement;\n  }\n\n  private get thContentHtmlElement(): HTMLElement | null {\n    return this.element.nativeElement.querySelector('.th-content');\n  }\n\n  ngAfterViewInit(): void {\n    if (this.dropdownButtonEl) {\n      this.presetDropdownButton();\n    }\n\n    this.getMenuOptionSelectionChanges(this.bbMenuOptions).subscribe({\n      next: (menuOption) => this.onMenuOptionSelect(menuOption),\n    });\n\n    this.handleSortControlsPresence();\n  }\n\n  onMenuOptionSelect(menuOption: DropdownMenuOptionToken): void {\n    if (this._sortDisabled) {\n      return;\n    }\n    const columnValue = menuOption.bbDropdownMenuOption;\n    const activeMenuOption = this.bbMenuOptions?.find((option) => option.active);\n    // Reset currently active item\n    if (activeMenuOption) {\n      activeMenuOption.active = false;\n    }\n    // If same menu item is not clicked, then reset the direction for new menuitem\n    if (activeMenuOption && columnValue !== activeMenuOption.bbDropdownMenuOption) {\n      this.direction = null;\n    }\n    this.bbSortable = menuOption.bbDropdownMenuOption;\n    this.emitSortEvent();\n    this.markMenuOptionAsActive(menuOption);\n    this.updateAriaSortAttribute();\n  }\n\n  /** Notify table with new sorting params */\n  emitSortEvent(): void {\n    if (this.bbSortable) {\n      this.direction = rotate[this.direction ?? ''];\n      this.parentTable.onSort({ column: this.bbSortable, direction: this.direction });\n    }\n  }\n\n  /** Combined stream of all of the bbTableMenuitem selectionChange events. */\n  getMenuOptionSelectionChanges(menuOptions: QueryList<DropdownMenuOptionToken>) {\n    return menuOptions.changes.pipe(\n      switchMap((_) => merge(...menuOptions.map((menuOption) => menuOption.selectionChange))),\n      takeUntilDestroyed(this.destroyRef$),\n    );\n  }\n\n  /** mark the new menuitem as active only if sorting order is asc/desc */\n  markMenuOptionAsActive(menuOption: DropdownMenuOptionToken): void {\n    if (this.direction !== null) {\n      menuOption.active = true;\n    }\n  }\n\n  markAllMenuOptionAsInactive(): void {\n    if (this.bbMenuOptions.length) {\n      this.bbMenuOptions.forEach((menuOption) => (menuOption.active = false));\n    }\n  }\n\n  updateAriaSortAttribute(): void {\n    if (!this.buttonEl) {\n      return;\n    }\n\n    if (!this.direction) {\n      this.renderer.removeAttribute(this.buttonEl, 'aria-sort');\n    } else {\n      this.renderer.setAttribute(this.buttonEl, 'aria-sort', this.getAriaSortAttribute(this.direction));\n    }\n  }\n\n  private getAriaSortAttribute(direction: SortDirection): string {\n    return direction === 'asc' ? 'ascending' : 'descending';\n  }\n\n  /** Preset bb-dropdown button to add role for a11y and set full height and width of table column */\n  private presetDropdownButton(): void {\n    this.renderer.setStyle(this.dropdownButtonEl, 'height', '100%');\n    this.renderer.setStyle(this.dropdownButtonEl, 'width', '100%');\n  }\n\n  private createSortArrowElement(): Element {\n    const element = this.renderer.createElement('span');\n\n    // backbase-theme with append an arrow icon via 'content'\n    // this is necessary to prevent breaking changes while addressing a11y\n    this.renderer.setAttribute(element, 'aria-hidden', 'true');\n\n    return element;\n  }\n\n  private renderSortButton() {\n    if (this.element.nativeElement.querySelector('button')) {\n      return;\n    }\n\n    if (this._sortDisabled) {\n      return;\n    }\n\n    const btn: HTMLButtonElement = this.renderer.createElement('button');\n    btn.classList.add('th-button');\n\n    const label = this.element.nativeElement.querySelector('.th-content')?.innerText;\n    this.renderer.setAttribute(btn, 'aria-label', label ?? '');\n\n    this.renderer.appendChild(this.element.nativeElement, btn);\n    this.buttonElement = btn;\n  }\n\n  private removeSortButton() {\n    if (this.buttonElement) {\n      this.renderer.removeChild(this.element.nativeElement, this.buttonElement);\n    }\n  }\n\n  private appendSortArrow() {\n    if (this._sortDisabled || !this.thContentHtmlElement) {\n      return;\n    }\n    this.renderer.appendChild(this.thContentHtmlElement, this.sortArrow);\n  }\n\n  private removeSortArrow() {\n    this.renderer.removeChild(this.thContentHtmlElement, this.sortArrow);\n  }\n\n  private handleSortControlsPresence() {\n    if (this._sortDisabled) {\n      this.renderer.removeClass(this.element.nativeElement, 'sortable');\n      this.renderer.addClass(this.element.nativeElement, 'sortable--disabled');\n      this.removeSortButton();\n      this.removeSortArrow();\n    } else {\n      this.renderer.removeClass(this.element.nativeElement, 'sortable--disabled');\n      this.renderer.addClass(this.element.nativeElement, 'sortable');\n      this.renderSortButton();\n      this.appendSortArrow();\n    }\n  }\n\n  ngOnDestroy(): void {\n    this.parentTable.unRegisterHeader(this);\n  }\n}\n",
      properties: [
        {
          name: 'column',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 27,
        },
        {
          name: 'direction',
          deprecated: false,
          deprecationMessage: '',
          type: 'SortDirection',
          indexKey: '',
          optional: false,
          description: '',
          line: 28,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'SortOption',
      id: 'interface-SortOption-3c4773582dd9e497f16331ab4163e86f57e977693372cea1d433e2a21fbe0c031fb06218c1930d72fcaf9c8b964e51a47bf049d9793f9dd1214c19ad7f49994f',
      file: 'libs/ui-ang-examples/src/table/showcase/table-showcase.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component, ViewChild } from '@angular/core';\nimport { Observable, of } from 'rxjs';\nimport { SortDirection, SortEvent } from '@backbase/ui-ang/table';\nimport { COUNTRIES } from './countries';\nimport { TableDirective } from '@backbase/ui-ang/table';\nimport { BackbaseDocs } from '@backbase/ui-ang/util';\n\ninterface SortOption {\n  label: string;\n  value: string;\n  direction: SortDirection;\n}\n\n@Component({\n  selector: 'bb-table-ui-showcase',\n  templateUrl: './table-showcase.component.html',\n  standalone: false,\n})\n@BackbaseDocs({\n  isTheme2Stable: true,\n})\nexport class TableShowcaseComponent {\n  countries$?: Observable<any[]>;\n  selected?: Set<any>;\n  currentPage = 0;\n  pageSize = 10;\n  rotate: { [key: string]: SortDirection } = { asc: 'asc', desc: 'desc', '': null };\n  iconMap: Record<string, string> = { asc: 'caret-up', desc: 'caret-down', '': '' };\n  sortDirection: string | null = null;\n  activeSortingOption: SortOption | null = null;\n  sortingOptions: SortOption[] = [\n    { label: 'Capital', value: 'capital', direction: null },\n    { label: 'Population', value: 'population', direction: null },\n  ];\n  sortDisabled = false;\n\n  @ViewChild('tableRef', { static: true, read: TableDirective }) tableRef!: TableDirective;\n\n  constructor() {\n    this.countries$ = of(this.getItems(0, this.pageSize));\n  }\n\n  onSort({ column, direction }: SortEvent) {\n    this.activeSortingOption = null;\n    const selectedOption = this.sortingOptions.find((option) => option.value === column);\n    if (selectedOption && direction !== null) {\n      this.activeSortingOption = selectedOption;\n      this.activeSortingOption.direction = direction;\n    }\n    this.countries$ = of(\n      this.sort(\n        this.getItems(this.currentPage * this.pageSize, this.currentPage * this.pageSize + this.pageSize),\n        column,\n        direction,\n      ),\n    );\n  }\n\n  onRowSelect(data: Set<any>) {\n    this.selected = data;\n  }\n\n  onRowClick(data: any) {\n    this.tableRef.toggleItem(data, !this.tableRef.isSelected(data));\n  }\n\n  search(value: string) {\n    this.countries$ =\n      value === ''\n        ? of(this.getItems(this.currentPage, this.pageSize))\n        : of(COUNTRIES.filter((country) => country.name.toLowerCase().includes(value)));\n  }\n\n  sort(countries: any[], column: string, direction: SortDirection): any[] {\n    this.sortDirection = this.rotate[direction ?? ''];\n    if (direction === null) {\n      return countries;\n    } else {\n      return [...countries].sort((a: any, b: any) => {\n        const res = this.compare(a[column], b[column]);\n\n        return direction === 'asc' ? res : -res;\n      });\n    }\n  }\n\n  compare(v1: number | string, v2: number | string) {\n    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;\n  }\n\n  getItems(start: number, end: number): any[] {\n    return COUNTRIES.slice(start, end);\n  }\n\n  toggleSortDisabled() {\n    this.sortDisabled = !this.sortDisabled;\n  }\n\n  get paginator() {\n    return {\n      page: this.currentPage,\n      boundaryLinks: false,\n      directionLinks: true,\n      totalItems: COUNTRIES.length,\n      itemsPerPage: this.pageSize,\n      maxNavPages: 3,\n      onPageChange: (page: number) => {\n        this.countries$ = of(this.getItems(page * this.pageSize, page * this.pageSize + this.pageSize));\n      },\n    };\n  }\n}\n",
      properties: [
        {
          name: 'direction',
          deprecated: false,
          deprecationMessage: '',
          type: 'SortDirection',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 9,
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'TextEditorFormatGroup',
      id: 'interface-TextEditorFormatGroup-b81f217abd11f05ea30e9442ec983a6a5f42e3e2f2f7d6facdc6d592dbeb31b2fc77a101bb55e30c9f25eac856d34e30465edd1190e82db8c8a6897d2e6f1e4a',
      file: 'libs/ui-ang/rich-text-editor/helpers/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "export enum RichTextEditorActions {\n  Bold = 'Bold',\n  Italic = 'Italic',\n  Strike = 'Strikethrough',\n  Underline = 'Underline',\n  OrderedList = 'Ordered List',\n  UnorderedList = 'Unordered List',\n  Code = 'Code',\n  Link = 'Link',\n  Indent = 'Paragraph',\n  Image = 'Image',\n}\n\nexport enum QuillEditorActionsAdapter {\n  Bold = 'bold',\n  Italic = 'italic',\n  Strikethrough = 'strike',\n  Underline = 'underline',\n  /* eslint-disable @typescript-eslint/no-duplicate-enum-values */\n  'Ordered List' = 'list',\n  'Unordered List' = 'list',\n  /* eslint-enable @typescript-eslint/no-duplicate-enum-values */\n  Code = 'code',\n  Link = 'link',\n  Paragraph = 'indent',\n  Image = 'image',\n}\n\nexport interface TextEditorFormatGroupValue {\n  key: string;\n  translation: string;\n  value?: string;\n  hidden?: () => boolean;\n}\n\nexport interface TextEditorFormatGroup {\n  [key: string]: TextEditorFormatGroupValue[];\n}\n",
      properties: [],
      indexSignatures: [
        {
          id: 'index-declaration-b81f217abd11f05ea30e9442ec983a6a5f42e3e2f2f7d6facdc6d592dbeb31b2fc77a101bb55e30c9f25eac856d34e30465edd1190e82db8c8a6897d2e6f1e4a',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          returnType: 'TextEditorFormatGroupValue[]',
          line: 36,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      kind: 181,
      methods: [],
      extends: [],
    },
    {
      name: 'TextEditorFormatGroupValue',
      id: 'interface-TextEditorFormatGroupValue-b81f217abd11f05ea30e9442ec983a6a5f42e3e2f2f7d6facdc6d592dbeb31b2fc77a101bb55e30c9f25eac856d34e30465edd1190e82db8c8a6897d2e6f1e4a',
      file: 'libs/ui-ang/rich-text-editor/helpers/models.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "export enum RichTextEditorActions {\n  Bold = 'Bold',\n  Italic = 'Italic',\n  Strike = 'Strikethrough',\n  Underline = 'Underline',\n  OrderedList = 'Ordered List',\n  UnorderedList = 'Unordered List',\n  Code = 'Code',\n  Link = 'Link',\n  Indent = 'Paragraph',\n  Image = 'Image',\n}\n\nexport enum QuillEditorActionsAdapter {\n  Bold = 'bold',\n  Italic = 'italic',\n  Strikethrough = 'strike',\n  Underline = 'underline',\n  /* eslint-disable @typescript-eslint/no-duplicate-enum-values */\n  'Ordered List' = 'list',\n  'Unordered List' = 'list',\n  /* eslint-enable @typescript-eslint/no-duplicate-enum-values */\n  Code = 'code',\n  Link = 'link',\n  Paragraph = 'indent',\n  Image = 'image',\n}\n\nexport interface TextEditorFormatGroupValue {\n  key: string;\n  translation: string;\n  value?: string;\n  hidden?: () => boolean;\n}\n\nexport interface TextEditorFormatGroup {\n  [key: string]: TextEditorFormatGroupValue[];\n}\n",
      properties: [
        {
          name: 'hidden',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: true,
          description: '',
          line: 33,
        },
        {
          name: 'key',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 30,
        },
        {
          name: 'translation',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 31,
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 32,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'TooltipConfig',
      id: 'interface-TooltipConfig-500ca07af0c71b0fe1942d1eac32a0c794e1e32d45ba1c30ee4e22622d5fe1a7b2372613b5d2c2bbd86b1db1d01bd45f1598991b511e361ab35143eb0512744f',
      file: 'libs/ui-ang/tooltip-directive/tooltip.token-config.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken } from '@angular/core';\n\nexport interface TooltipConfig {\n  triggers?: string;\n  closeDelay?: number;\n  openDelay?: number;\n}\n\nexport const TOOLTIP_CONFIG_TOKEN = new InjectionToken<TooltipConfig>('TOOLTIP_CONFIG_TOKEN');\n",
      properties: [
        {
          name: 'closeDelay',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
        {
          name: 'openDelay',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
        {
          name: 'triggers',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'TypeaheadOptions',
      id: 'interface-TypeaheadOptions-1bee539f05dff8244ade10b3dbbb0784145cb3b6201b4747fd0e28de9ce1290bbbac51facd1de0138a64f551a5491527421fa5cbc2ad6a282fd11f39295194bb',
      file: 'libs/ui-ang/search-box/search-box.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  AfterViewInit,\n  ChangeDetectorRef,\n  Component,\n  DoCheck,\n  ElementRef,\n  EventEmitter,\n  forwardRef,\n  Input,\n  Output,\n  Renderer2,\n  TemplateRef,\n  ViewChild,\n} from '@angular/core';\nimport { NG_VALUE_ACCESSOR } from '@angular/forms';\nimport { Observable } from 'rxjs';\nimport { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';\nimport { defaultSize, InputBaseComponent } from '@backbase/ui-ang/base-classes';\nimport { DomAttributesService } from '@backbase/ui-ang/services';\nimport { isRtl } from '@backbase/ui-ang/util';\n\nexport interface TypeaheadOptions<T> {\n  ngbTypeahead: (text: Observable<string>) => Observable<Array<T>>;\n  editable?: boolean;\n  focusFirst?: boolean;\n  showHint?: boolean;\n  placement?: string;\n  inputFormatter?: (item: T) => string;\n  resultFormatter?: (item: T) => string;\n  resultTemplate?: TemplateRef<any>;\n  selectItem?: (item: NgbTypeaheadSelectItemEvent) => void;\n  groupCssClasses?: string;\n}\n\nconst SIZE_MEDIUM = defaultSize;\nconst SIZE_SMALL = SIZE_MEDIUM / 2;\n\nconst KEYWORD_SMALL = 'sm';\nconst KEYWORD_MEDIUM = 'md';\n\n/**\n * @name SearchBoxComponent\n *\n * @description\n * Component that provides you a search input field.\n *\n * ### Accessibility\n * Current component provide option to pass needed accessibility\n * attributes. You need to take care of properties that are required in your case :\n *  - Set aria-describedby  with an element id that contains a detailed decription about the Search box.\n *  - aria-label or  aria-labelledby can be used to display the label for search box.\n *\n * If  showSearch = true , searchLabel is discernible text for search button.\n * If  showClear = true , clearLabel is discernible text for clear button.\n *\n */\n@Component({\n  selector: 'bb-search-box-ui',\n  templateUrl: './search-box.component.html',\n  providers: [\n    {\n      provide: NG_VALUE_ACCESSOR,\n      multi: true,\n      useExisting: forwardRef(() => SearchBoxComponent),\n    },\n  ],\n  standalone: false,\n})\nexport class SearchBoxComponent<T> extends InputBaseComponent implements AfterViewInit, DoCheck {\n  /**\n   * The placeholder text to display in the input.\n   */\n  @Input() placeholder = '';\n  /**\n   * The maximum length of the search text. Defaults to 140.\n   */\n  @Input() maxLength = '140';\n  /**\n   * The square border for search box. Defaults to false.\n   */\n  @Input() squareBorder = false;\n  /**\n   * The list of options to use when typeahead is available.\n   * See https://ng-bootstrap.github.io/#/components/typeahead/api#NgbTypeahead for the list of options.\n   */\n  @Input() typeaheadOptions: TypeaheadOptions<T> | undefined;\n  /**\n   * Whether to show the search button icon before the text. Defaults to false.\n   */\n  @Input() showSearch = false;\n  /**\n   * Whether to show the clear button icon after the text. Defaults to false.\n   */\n  @Input() showClear = false;\n  /**\n   * The aria label used when the search button is in focus.\n   */\n  @Input() searchLabel = 'Search';\n  /**\n   * The aria label used when the clear button is in focus.\n   */\n  @Input() clearLabel = 'Clear';\n  /**\n   * The autocomplete attribute value. Defaults to off.\n   */\n  @Input() autocomplete = 'off';\n  /**\n   * The role of the container for the search input. For non-landmarked search, please assign this a value. Defaults to 'search'.\n   */\n  @Input() containerRole = 'search';\n  /**\n   * The label of the container for the search input. When there are multiple search inputs on a page, a label should be assigned. Defaults to ''.\n   */\n  @Input() containerAriaLabel = '';\n  /**\n   * Emits an event when a search is submitted.\n   */\n  @Output() submit: EventEmitter<string | boolean | Object | null> = new EventEmitter<\n    string | boolean | Object | null\n  >();\n  /**\n   * Emits an event when the clear button is clicked.\n   */\n  @Output() clear: EventEmitter<string> = new EventEmitter<string>();\n  /**\n   * Emits an event when the value in the search box is changed.\n   */\n  @Output() valueChange: EventEmitter<any> = this._valueChange;\n\n  @ViewChild('searchBox', { static: true }) searchBox: ElementRef | undefined;\n  @ViewChild('inputField') inputField: ElementRef | undefined;\n  @ViewChild(NgbTypeahead) ngbTypeahead: NgbTypeahead | undefined;\n\n  readonly labelId = `bb_searchbox_label_${this.id}`;\n  readonly isRtl = isRtl;\n\n  hasAppendContent = true;\n\n  constructor(\n    protected readonly cd: ChangeDetectorRef,\n    private readonly renderer: Renderer2,\n    private readonly domAttrService: DomAttributesService,\n    private readonly elem: ElementRef,\n  ) {\n    super(cd);\n  }\n\n  onSubmit() {\n    this.submit.emit(this.value);\n  }\n\n  ngAfterViewInit() {\n    this.domAttrService.moveAriaAttributes(this.elem.nativeElement, this.inputField?.nativeElement, this.renderer);\n\n    if (this.inputField !== undefined) {\n      this.inputField.nativeElement.removeAttribute('aria-multiline');\n    }\n    this.cd.detectChanges();\n  }\n\n  ngDoCheck() {\n    if (this.searchBox) {\n      const listBoxElem = this.searchBox.nativeElement?.querySelector('[role=\"listbox\"]:not([aria-labelledby])');\n\n      if (listBoxElem && this.label) {\n        this.renderer.setAttribute(listBoxElem, 'aria-labelledby', this.labelId);\n      }\n\n      this.cd.detectChanges();\n    }\n  }\n\n  onClear() {\n    this.value = '';\n    if (this.inputField !== undefined) {\n      this.inputField.nativeElement.focus();\n    }\n    this.clear.emit();\n  }\n\n  /**\n   * Sets the focus on the input field.\n   * If the input field reference is defined, it calls the `focus()` method on the native element.\n   */\n  focusOnInputField() {\n    if (this.inputField !== undefined) {\n      this.inputField.nativeElement.focus();\n    }\n  }\n\n  onFocus() {\n    if (this.searchBox === undefined) {\n      return;\n    }\n    this.searchBox.nativeElement.classList.add('bb-focus');\n    super.onFocus();\n  }\n\n  onBlur() {\n    if (this.searchBox === undefined) {\n      return;\n    }\n    this.searchBox.nativeElement.classList.remove('bb-focus');\n    super.onBlur();\n  }\n\n  isClearVisible() {\n    return this.showClear && !!this.value && !this.readonly;\n  }\n\n  focusEditableElement() {\n    if (this.searchBox) {\n      this.searchBox.nativeElement.focus();\n    }\n  }\n\n  getKeywordBySize(size: number | string): string {\n    if (Number(size) <= SIZE_SMALL) {\n      return KEYWORD_SMALL;\n    } else {\n      return KEYWORD_MEDIUM;\n    }\n  }\n\n  getSizeByKeyword(keyword: any): number | undefined {\n    const sizeKeywords: { [index: string]: number } = {\n      [KEYWORD_SMALL]: SIZE_SMALL,\n      [KEYWORD_MEDIUM]: SIZE_MEDIUM,\n    };\n\n    return typeof keyword === 'string' && sizeKeywords.hasOwnProperty(keyword) ? sizeKeywords[keyword] : undefined;\n  }\n\n  onSelect(event: any) {\n    return this.typeaheadOptions?.selectItem?.(event);\n  }\n\n  protected get popperOptions() {\n    return () => ({\n      modifiers: [\n        {\n          enabled: true,\n          name: 'preventOverflow',\n          phase: 'main',\n          fn: function () {},\n        },\n      ],\n    });\n  }\n}\n",
      properties: [
        {
          name: 'editable',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 24,
        },
        {
          name: 'focusFirst',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 25,
        },
        {
          name: 'groupCssClasses',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 32,
        },
        {
          name: 'inputFormatter',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: true,
          description: '',
          line: 28,
        },
        {
          name: 'ngbTypeahead',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: false,
          description: '',
          line: 23,
        },
        {
          name: 'placement',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 27,
        },
        {
          name: 'resultFormatter',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: true,
          description: '',
          line: 29,
        },
        {
          name: 'resultTemplate',
          deprecated: false,
          deprecationMessage: '',
          type: 'TemplateRef<any>',
          indexKey: '',
          optional: true,
          description: '',
          line: 30,
        },
        {
          name: 'selectItem',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: true,
          description: '',
          line: 31,
        },
        {
          name: 'showHint',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 26,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'UniversalHeaderCloseButton',
      id: 'interface-UniversalHeaderCloseButton-5b5aec4884db83162a3931445406843dce911e5266125fa01f3103fe8df747a412f892ce08dd640c6d782bde5258ee8fcb1bb7bb4f7c2991b3c22127b4ad0eaa',
      file: 'libs/ui-ang/universal-header/universal-header.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';\nimport { LogoType } from '@backbase/ui-ang/logo';\n\n/**\n * Type defining the possible background colors for the universal header.\n */\nexport type UniversalHeaderBackgroundColor = 'white' | 'no-background';\n\n/**\n * Interface defining the close button configuration options.\n */\nexport interface UniversalHeaderCloseButton {\n  text?: string;\n  icon?: string;\n  ariaLabel?: string;\n}\n\n/**\n * Interface defining the title configuration options.\n */\nexport interface UniversalHeaderTitle {\n  text?: string;\n  /**\n   * Hides the title for S and XS screen sizes if enabled.\n   */\n  hideForSmallScreen?: boolean;\n}\n\n/**\n * Interface defining the logo configuration options.\n */\nexport interface UniversalHeaderLogo {\n  type?: LogoType;\n  /**\n   * Automatically overrides the logo `type` depend on screen size if enabled.\n   * The logo type \"emblem\" will be activated for S and XS screen sizes and logo type \"full\" for the rest screens which are (* > \"S\")\n   */\n  enableAdaptiveLogoType?: boolean;\n}\n\n@Component({\n  selector: 'bb-universal-header-ui',\n  templateUrl: './universal-header.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class UniversalHeaderComponent {\n  /**\n   * The universal header background color to display.\n   */\n  @Input() backgroundColor: UniversalHeaderBackgroundColor = 'white';\n\n  /**\n   * The universal header logo configuration.\n   */\n  @Input() set logo(configuration: UniversalHeaderLogo) {\n    this._logo = {\n      ...(configuration ?? {}),\n      type: configuration?.type ?? 'full',\n    };\n  }\n  get logo() {\n    return this._logo;\n  }\n\n  /**\n   * The universal header title configuration.\n   */\n  @Input() title?: UniversalHeaderTitle;\n\n  /**\n   * The universal header close button configuration.\n   */\n  @Input() closeButton?: UniversalHeaderCloseButton;\n\n  /**\n   * The universal header close action.\n   */\n  @Output() close: EventEmitter<any> = new EventEmitter<void>();\n\n  private _logo: UniversalHeaderLogo = { type: 'full' };\n}\n",
      properties: [
        {
          name: 'ariaLabel',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 15,
        },
        {
          name: 'icon',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 14,
        },
        {
          name: 'text',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 13,
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Interface defining the close button configuration options.</p>\n',
      rawdescription: '\n\nInterface defining the close button configuration options.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'UniversalHeaderLogo',
      id: 'interface-UniversalHeaderLogo-5b5aec4884db83162a3931445406843dce911e5266125fa01f3103fe8df747a412f892ce08dd640c6d782bde5258ee8fcb1bb7bb4f7c2991b3c22127b4ad0eaa',
      file: 'libs/ui-ang/universal-header/universal-header.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';\nimport { LogoType } from '@backbase/ui-ang/logo';\n\n/**\n * Type defining the possible background colors for the universal header.\n */\nexport type UniversalHeaderBackgroundColor = 'white' | 'no-background';\n\n/**\n * Interface defining the close button configuration options.\n */\nexport interface UniversalHeaderCloseButton {\n  text?: string;\n  icon?: string;\n  ariaLabel?: string;\n}\n\n/**\n * Interface defining the title configuration options.\n */\nexport interface UniversalHeaderTitle {\n  text?: string;\n  /**\n   * Hides the title for S and XS screen sizes if enabled.\n   */\n  hideForSmallScreen?: boolean;\n}\n\n/**\n * Interface defining the logo configuration options.\n */\nexport interface UniversalHeaderLogo {\n  type?: LogoType;\n  /**\n   * Automatically overrides the logo `type` depend on screen size if enabled.\n   * The logo type \"emblem\" will be activated for S and XS screen sizes and logo type \"full\" for the rest screens which are (* > \"S\")\n   */\n  enableAdaptiveLogoType?: boolean;\n}\n\n@Component({\n  selector: 'bb-universal-header-ui',\n  templateUrl: './universal-header.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class UniversalHeaderComponent {\n  /**\n   * The universal header background color to display.\n   */\n  @Input() backgroundColor: UniversalHeaderBackgroundColor = 'white';\n\n  /**\n   * The universal header logo configuration.\n   */\n  @Input() set logo(configuration: UniversalHeaderLogo) {\n    this._logo = {\n      ...(configuration ?? {}),\n      type: configuration?.type ?? 'full',\n    };\n  }\n  get logo() {\n    return this._logo;\n  }\n\n  /**\n   * The universal header title configuration.\n   */\n  @Input() title?: UniversalHeaderTitle;\n\n  /**\n   * The universal header close button configuration.\n   */\n  @Input() closeButton?: UniversalHeaderCloseButton;\n\n  /**\n   * The universal header close action.\n   */\n  @Output() close: EventEmitter<any> = new EventEmitter<void>();\n\n  private _logo: UniversalHeaderLogo = { type: 'full' };\n}\n",
      properties: [
        {
          name: 'enableAdaptiveLogoType',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description:
            '<p>Automatically overrides the logo <code>type</code> depend on screen size if enabled.\nThe logo type &quot;emblem&quot; will be activated for S and XS screen sizes and logo type &quot;full&quot; for the rest screens which are (* &gt; &quot;S&quot;)</p>\n',
          line: 38,
          rawdescription:
            '\n\nAutomatically overrides the logo `type` depend on screen size if enabled.\nThe logo type "emblem" will be activated for S and XS screen sizes and logo type "full" for the rest screens which are (* > "S")\n',
        },
        {
          name: 'type',
          deprecated: false,
          deprecationMessage: '',
          type: 'LogoType',
          indexKey: '',
          optional: true,
          description: '',
          line: 33,
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Interface defining the logo configuration options.</p>\n',
      rawdescription: '\n\nInterface defining the logo configuration options.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'UniversalHeaderTitle',
      id: 'interface-UniversalHeaderTitle-5b5aec4884db83162a3931445406843dce911e5266125fa01f3103fe8df747a412f892ce08dd640c6d782bde5258ee8fcb1bb7bb4f7c2991b3c22127b4ad0eaa',
      file: 'libs/ui-ang/universal-header/universal-header.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';\nimport { LogoType } from '@backbase/ui-ang/logo';\n\n/**\n * Type defining the possible background colors for the universal header.\n */\nexport type UniversalHeaderBackgroundColor = 'white' | 'no-background';\n\n/**\n * Interface defining the close button configuration options.\n */\nexport interface UniversalHeaderCloseButton {\n  text?: string;\n  icon?: string;\n  ariaLabel?: string;\n}\n\n/**\n * Interface defining the title configuration options.\n */\nexport interface UniversalHeaderTitle {\n  text?: string;\n  /**\n   * Hides the title for S and XS screen sizes if enabled.\n   */\n  hideForSmallScreen?: boolean;\n}\n\n/**\n * Interface defining the logo configuration options.\n */\nexport interface UniversalHeaderLogo {\n  type?: LogoType;\n  /**\n   * Automatically overrides the logo `type` depend on screen size if enabled.\n   * The logo type \"emblem\" will be activated for S and XS screen sizes and logo type \"full\" for the rest screens which are (* > \"S\")\n   */\n  enableAdaptiveLogoType?: boolean;\n}\n\n@Component({\n  selector: 'bb-universal-header-ui',\n  templateUrl: './universal-header.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  standalone: false,\n})\nexport class UniversalHeaderComponent {\n  /**\n   * The universal header background color to display.\n   */\n  @Input() backgroundColor: UniversalHeaderBackgroundColor = 'white';\n\n  /**\n   * The universal header logo configuration.\n   */\n  @Input() set logo(configuration: UniversalHeaderLogo) {\n    this._logo = {\n      ...(configuration ?? {}),\n      type: configuration?.type ?? 'full',\n    };\n  }\n  get logo() {\n    return this._logo;\n  }\n\n  /**\n   * The universal header title configuration.\n   */\n  @Input() title?: UniversalHeaderTitle;\n\n  /**\n   * The universal header close button configuration.\n   */\n  @Input() closeButton?: UniversalHeaderCloseButton;\n\n  /**\n   * The universal header close action.\n   */\n  @Output() close: EventEmitter<any> = new EventEmitter<void>();\n\n  private _logo: UniversalHeaderLogo = { type: 'full' };\n}\n",
      properties: [
        {
          name: 'hideForSmallScreen',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '<p>Hides the title for S and XS screen sizes if enabled.</p>\n',
          line: 26,
          rawdescription: '\n\nHides the title for S and XS screen sizes if enabled.\n',
        },
        {
          name: 'text',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 22,
        },
      ],
      indexSignatures: [],
      kind: 171,
      description: '<p>Interface defining the title configuration options.</p>\n',
      rawdescription: '\n\nInterface defining the title configuration options.\n',
      methods: [],
      extends: [],
    },
    {
      name: 'UserItem',
      id: 'interface-UserItem-ac7d9b1a47a6136b3c0ec6465f1ef0c8a8113b252ad5b02dc3bd62d0919b33bc35347ab52a3c6145cb45a1e57013eb8cfebf0352b9f8c75dbb2d10f73772d319',
      file: 'libs/ui-ang-examples/src/search-box/examples/search-box.example.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { Observable } from 'rxjs';\nimport { map } from 'rxjs/operators';\nimport { UntypedFormControl, UntypedFormGroup } from '@angular/forms';\n\nexport interface UserItem {\n  id: number;\n  name: string;\n}\n\n@Component({\n  selector: 'bb-search-box-example-ui',\n  templateUrl: './search-box.example.component.html',\n  standalone: false,\n})\nexport class SearchBoxExampleComponent {\n  form = new UntypedFormGroup({\n    query: new UntypedFormControl(''),\n  });\n\n  startSearching(value: string) {\n    alert(`You are searching for ${value}`);\n  }\n\n  search(text: Observable<string>): Observable<Array<string>> {\n    const searchItems = ['John', 'Jane', 'James', 'Joey'];\n\n    return text.pipe(\n      map((term) =>\n        searchItems.filter(\n          (item) =>\n            item.toLowerCase().indexOf(term.toLowerCase()) === 0,\n        ),\n      ),\n    );\n  }\n  readonly typeaheadOptions = {\n    ngbTypeahead: this.search,\n  };\n}\n",
      properties: [
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 8,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ValidationErrorComponentModel',
      id: 'interface-ValidationErrorComponentModel-41b338ff03a514cbdaefb7491423cc50dd4e458fc486445023cafb60efb87949087937d38a9e5dacd0f4888342be35c5dd420e137750dde7d60b3875b4e48cba',
      file: 'libs/ui-ang/control-error-handler/control-error-handler.const.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { InjectionToken, Type } from '@angular/core';\nimport { ValidationMessageComponent } from './components/validation-message/validation-message.component';\nimport { NgControl } from '@angular/forms';\n\nexport interface PlainObject<T> {\n  [key: string]: (params: any) => T;\n}\n\nexport interface ValidationErrorComponentModel {\n  errorId: string;\n  text: string | undefined;\n  control?: NgControl;\n  errorList?: PlainObject<string>;\n  label?: string;\n}\n\nexport const BB_VALIDATION_ERRORS = new InjectionToken('BB_VALIDATION_ERRORS', {\n  providedIn: 'root',\n  factory: () => defaultFormErrors,\n});\n\nexport const BB_DYNAMIC_VALIDATION_ERROR_TMPL = new InjectionToken<Type<ValidationErrorComponentModel>>(\n  'BB_DYNAMIC_VALIDATION_ERROR_TMPL',\n  {\n    providedIn: 'root',\n    factory: () => ValidationMessageComponent,\n  },\n);\n\nexport const defaultFormErrors: PlainObject<string> = {\n  invalid: () => $localize`:@@validation-form-invalid-error:Field is invalid`,\n  required: () => $localize`:@@validation-form-required-error:Field is required`,\n  minlength: ({ requiredLength }) => {\n    const singleStr = $localize`:@@validation-form-minlength-error-single:\n    Must be at least ${requiredLength} character long`;\n    const multipleStr = $localize`:@@validation-form-minlength-error-multiple:\n    Must be at least ${requiredLength} characters long`;\n\n    return requiredLength === 1 ? singleStr : multipleStr;\n  },\n  maxlength: ({ requiredLength }) => {\n    const singleStr = $localize`:@@bb-ui-ang.control-error-handler.validation-form-maxlength-error-single:\n    Must be shorter than ${requiredLength} character`;\n    const multipleStr = $localize`:@@bb-ui-ang.control-error-handler.validation-form-maxlength-error-multiple:\n    Must be shorter than ${requiredLength} characters`;\n\n    return requiredLength === 1 ? singleStr : multipleStr;\n  },\n  min: ({ min }) => $localize`:@@validation-form-min-error:Expect value to be bigger than ${min}`,\n  max: ({ max }) => $localize`:@@validation-form-max-error:Expect value to be less than ${max}`,\n  email: () => $localize`:@@validation-form-email-error:Not a valid email`,\n};\n",
      properties: [
        {
          name: 'control',
          deprecated: false,
          deprecationMessage: '',
          type: 'NgControl',
          indexKey: '',
          optional: true,
          description: '',
          line: 12,
        },
        {
          name: 'errorId',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 10,
        },
        {
          name: 'errorList',
          deprecated: false,
          deprecationMessage: '',
          type: 'PlainObject<string>',
          indexKey: '',
          optional: true,
          description: '',
          line: 13,
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: true,
          description: '',
          line: 14,
        },
        {
          name: 'text',
          deprecated: false,
          deprecationMessage: '',
          type: 'string | undefined',
          indexKey: '',
          optional: false,
          description: '',
          line: 11,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ValueDiffChangedModel',
      id: 'interface-ValueDiffChangedModel-0ac621052d8c33c49a2416836117d5b201e9552fb1b5434222217ff35f3846aae4f57acea4f6e0c21cda8ef9fb3542ac7d1ab6741ab9520ef69d205487683bb6',
      file: 'libs/ui-ang/value-diff/bb-value-diff.model.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "export enum ValueDiffPosition {\n  BEFORE = 'before',\n  AFTER = 'after',\n}\n\nexport interface ValueDiffChangedModel {\n  newData: string;\n}\n\nexport const highlightValueClass = 'bb-value-diff--highlighted';\nexport const crossOutValueClass = 'bb-value-diff--crossed';\n\nexport const valueDiffArrowLeftClass = 'bb-value-diff--arrow-left';\nexport const valueDiffArrowRightClass = 'bb-value-diff--arrow-right';\n\nexport const srTextForNewVal = $localize`:@@value-diff-current-value-label:Current value:`;\nexport const srTextForOldVal = $localize`:@@value-diff-previous-value-label:Previous value:`;\n",
      properties: [
        {
          name: 'newData',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 7,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'ValueSet',
      id: 'interface-ValueSet-7d06114ff4b3caeeec660831a48cafca952e088daae504f00ea8a8c41a9fca6b7f036fb565fddc2afa59fc896b65fbd5e1b395df405734d03821645d2d605e54',
      file: 'libs/ui-ang/input-phone/input-phone.component.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import {\n  AfterViewInit,\n  ChangeDetectionStrategy,\n  ChangeDetectorRef,\n  Component,\n  ElementRef,\n  EventEmitter,\n  forwardRef,\n  Inject,\n  Input,\n  Optional,\n  Output,\n  Renderer2,\n  ViewChild,\n  OnDestroy,\n} from '@angular/core';\nimport {\n  AbstractControl,\n  NG_VALIDATORS,\n  NG_VALUE_ACCESSOR,\n  ValidationErrors,\n  Validator,\n  Validators,\n} from '@angular/forms';\nimport { InputBaseComponent } from '@backbase/ui-ang/base-classes';\nimport { DomAttributesService } from '@backbase/ui-ang/services';\nimport { getDynamicId } from '@backbase/ui-ang/util';\nimport { NgSelectComponent } from '@ng-select/ng-select';\nimport {\n  COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n  CountryCodeFormatConfig,\n  CountryCodeFormatConfigMap,\n  INPUT_PHONE_CONFIG_TOKEN,\n  InputPhoneConfig,\n} from './input-phone.configuration_token';\nimport { extractCountryFromValue, stripCountryCodeFromValue } from './phone-number-validation-helper';\nimport { BehaviorSubject, Subject, takeUntil } from 'rxjs';\n\n/**\n * @name InputPhoneComponent\n *\n * @description\n * Component that enables the user to enter a phone number.\n *\n * ### Global configuration token\n * `INPUT_PHONE_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n *\n *\n * The following properties can be overwritten using the token:\n *  - `maxLength`\n *  - `minLength`\n *  - `autocomplete`\n *  - `mask`\n *  - `displayFormat`\n *  - `validationPattern`\n *  - `hideSelectedCountryFlag`\n *  - `defaultCountryIsoCode`\n *  - `countryList`\n *\n * #### Usage notes\n * The following is an example of how to use the token:\n *\n * ```\n *  import { INPUT_PHONE_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n *  import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n *  import { AppModule } from './app/app.module';\n *\n *  const inputPhoneConfig = {\n *    maxLength: 10,\n *    minLength: 5,\n *    autocomplete: 'off',\n *    displayFormat: 'E.164',\n *  }\n *\n *  providers: [\n *    {\n *      provide: INPUT_PHONE_CONFIG_TOKEN,\n *      useValue: inputPhoneConfig,\n *    },\n *  ]\n * ```\n *\n * ### Country Code Format Config Token\n * `COUNTRY_CODE_FORMAT_CONFIG_TOKEN` enables you to globally set the same configuration for all instances of `InputPhoneComponent` in your project.\n *\n * #### Usage notes\n * The following is an example of how to use the token.\n * Note: the `minLength` and `maxLength` properties do not account for the country dialling code:\n *\n * ```\n *  import { COUNTRY_CODE_FORMAT_CONFIG_TOKEN } from '@backbase/ui-ang/input-phone';\n *  import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';\n *  import { AppModule } from './app/app.module';\n *\n *  const countryCodeFormatConfig = {\n *    '+1': {\n *      mask: '+0 (000) 000-0000',\n *      minLength: 8,\n *      maxLength, 12,\n *    },\n *  };\n *\n *  providers: [\n *    {\n *      provide: COUNTRY_CODE_FORMAT_CONFIG_TOKEN,\n *      useValue: countryCodeFormatConfig,\n *    },\n *  ]\n * ```\n *\n * IMPORTANT NOTE:\n *  - If you wish to validate & format ALL phone numbers using the SAME `minLength`, `maxLength` and/or `mask`, please configure these values using the INPUT_PHONE_CONFIG_TOKEN.\n *  - If you need to support phone numbers for multiple countries (DIFFERENT `minLength`, `maxLength` & `mask`), we advise to use the COUNTRY_CODE_FORMAT_CONFIG_TOKEN instead.\n *\n *  @a11y Current component provide option to pass needed accessibility\n * attributes. You need to take care of properties that are required in your case :\n *  - role\n *  - aria-activedescendant\n *  - aria-describedby\n *  - aria-expanded\n *  - aria-invalid\n *  - aria-label\n *  - aria-labelledby\n *  - aria-owns\n *\n * ariaLabel is discernible text for phone input\n */\n\nexport interface CountryData {\n  countryCode: string;\n  isoCode: string;\n  countryName: string;\n}\nexport type CountryList = Array<CountryData>;\nexport interface ValueSet extends CountryData {\n  number: string;\n}\n\n@Component({\n  selector: 'bb-input-phone-ui',\n  templateUrl: './input-phone.component.html',\n  changeDetection: ChangeDetectionStrategy.OnPush,\n  providers: [\n    {\n      provide: NG_VALUE_ACCESSOR,\n      useExisting: forwardRef(() => InputPhoneComponent),\n      multi: true,\n    },\n    {\n      provide: NG_VALIDATORS,\n      useExisting: forwardRef(() => InputPhoneComponent),\n      multi: true,\n    },\n  ],\n  standalone: false,\n})\nexport class InputPhoneComponent extends InputBaseComponent implements AfterViewInit, Validator, OnDestroy {\n  override writeValue(value: any): void {\n    if (value && typeof value === 'object') {\n      const selectedCountry = this.countryList?.find((country) => country.isoCode === value.isoCode);\n\n      this.selectedCountryCode = value.countryCode;\n      this.selectedCountryIsoCode = value.isoCode;\n      this.selectedCountryName = selectedCountry?.countryName;\n      this.value = value.number;\n      this.valueWithoutCountryCode = value.number;\n      this.updateValues(true);\n    } else {\n      this.value = typeof value === 'string' ? value.trim() : value;\n\n      this.onTextChange(true);\n    }\n  }\n\n  /**\n   * The max size of the phone input.\n   *\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input('maxLength')\n  get maxLength(): InputPhoneConfig['maxLength'] {\n    return this._maxLength ?? this.overrideConfiguration?.maxLength;\n  }\n\n  set maxLength(value: InputPhoneConfig['maxLength']) {\n    this._maxLength = value;\n  }\n  private _maxLength: InputPhoneConfig['maxLength'];\n\n  /**\n   * The validation pattern of the phone input.\n   * This attribute can be overwritten via the global configuration token.\n   */\n  @Input('validationPattern')\n  get validationPattern(): InputPhoneConfig['validationPattern'] {\n    return this._validationPattern ?? this.overrideConfiguration?.validationPattern;\n  }\n\n  set validationPattern(value: InputPhoneConfig['validationPattern']) {\n    this._validationPattern = value;\n  }\n  private _validationPattern: InputPhoneConfig['validationPattern'];\n\n  /**\n   * The size of the phone input.\n   *\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('minLength')\n  get minLength(): InputPhoneConfig['minLength'] {\n    return this._minLength ?? this.overrideConfiguration?.minLength;\n  }\n  set minLength(value: InputPhoneConfig['minLength']) {\n    this._minLength = value;\n  }\n  private _minLength: InputPhoneConfig['minLength'];\n  /**\n   * The autocomplete value of the enclosed input control. Defaults to 'tel'\n   *\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('autocomplete')\n  get autocomplete(): InputPhoneConfig['autocomplete'] {\n    return this._autocomplete ?? this.overrideConfiguration?.autocomplete;\n  }\n  set autocomplete(value: InputPhoneConfig['autocomplete']) {\n    this._autocomplete = value;\n  }\n  private _autocomplete: InputPhoneConfig['autocomplete'];\n\n  /**\n   * The mask of the phone input. Defaults to null\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('mask')\n  get mask(): InputPhoneConfig['mask'] {\n    return this._mask ?? this.overrideConfiguration?.mask;\n  }\n  set mask(value: InputPhoneConfig['mask']) {\n    this._mask = value;\n  }\n  private _mask: InputPhoneConfig['mask'];\n\n  /**\n   * Whether to hide the flag of the selected country. Defaults to false\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('hideSelectedCountryFlag')\n  get hideSelectedCountryFlag(): InputPhoneConfig['hideSelectedCountryFlag'] {\n    return this._hideSelectedCountryFlag ?? this.overrideConfiguration?.hideSelectedCountryFlag ?? false;\n  }\n  set hideSelectedCountryFlag(value: InputPhoneConfig['hideSelectedCountryFlag']) {\n    this._hideSelectedCountryFlag = value;\n  }\n  private _hideSelectedCountryFlag: InputPhoneConfig['hideSelectedCountryFlag'];\n\n  /**\n   * The placeholder for the phone input. Defaults to an empty string;\n   */\n  @Input() placeholder = '';\n  /**\n   * Whether the phone input is readonly.\n   */\n  @Input() override readonly = false;\n  /**\n   * ariaLabel is discernible text for phone input.\n   */\n  @Input() override ariaLabel = 'Phone Input';\n  /**\n   * Dropdown Position (bottom | top | auto)\n   */\n  @Input() dropdownPosition: 'bottom' | 'top' | 'auto' | undefined;\n  /**\n   * Allow to clear selected value.\n   */\n  @Input() clearable = false;\n  /**\n   * Allow to search for value.\n   */\n  @Input() searchable = false;\n  /**\n   * List of countries to display in dropdown.\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('countryList')\n  get countryList(): InputPhoneConfig['countryList'] {\n    return this._countryList ?? this.overrideConfiguration?.countryList;\n  }\n  set countryList(value: InputPhoneConfig['countryList']) {\n    this._countryList = value;\n  }\n  private _countryList: InputPhoneConfig['countryList'];\n  /**\n   * Default country selected for country dropdown.\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('defaultCountryIsoCode')\n  get defaultCountryIsoCode(): InputPhoneConfig['defaultCountryIsoCode'] {\n    return this._defaultCountryIsoCode ?? this.overrideConfiguration?.defaultCountryIsoCode;\n  }\n  set defaultCountryIsoCode(value: InputPhoneConfig['defaultCountryIsoCode']) {\n    this._defaultCountryIsoCode = value;\n    this.selectedCountryIsoCode = value;\n  }\n  private _defaultCountryIsoCode: InputPhoneConfig['defaultCountryIsoCode'];\n\n  /**\n   * Enable/Disable Country code dropdown\n   * This attribute can be overwritten via the global configuration token\n   */\n  @Input('enableCountryCode')\n  get enableCountryCode(): InputPhoneConfig['enableCountryCode'] {\n    return this._enableCountryCode ?? this.overrideConfiguration?.enableCountryCode;\n  }\n  set enableCountryCode(value: InputPhoneConfig['enableCountryCode']) {\n    this._enableCountryCode = value;\n  }\n  private _enableCountryCode: InputPhoneConfig['enableCountryCode'];\n\n  /**\n   * Allows manual control of dropdown opening and closing. `true` - won't close. `false` - won't open.\n   * Defaults to `undefined`.\n   */\n  @Input()\n  set isOpen(value) {\n    this._isOpen$.next(value);\n  }\n\n  get isOpen() {\n    return this._isOpen$.getValue();\n  }\n\n  private readonly _isOpen$ = new BehaviorSubject<boolean | undefined>(undefined);\n\n  /**\n   * The event emitter called when the one of the inputs change.\n   */\n  @Output() valueChange = new EventEmitter<ValueSet>();\n\n  @ViewChild('inputPhone') inputEl: ElementRef | undefined;\n  /**\n   * ng-select\n   */\n  @ViewChild(NgSelectComponent) ngSelect: NgSelectComponent | undefined;\n\n  selectedCountryCode?: string;\n  selectedCountryIsoCode?: string;\n  selectedCountryName?: string;\n  countryDropdowndisabled?: boolean;\n  override value = '';\n  valueSet: ValueSet = {\n    countryCode: '',\n    countryName: '',\n    isoCode: '',\n    number: '',\n  };\n  resultCount = 0;\n  countryCodeInputId = `country-code-input-${getDynamicId()}`;\n  notFoundText = $localize`:Text no items found during search or filter@@input-phone.no-items-found:No items found`;\n  private readonly _statusId = this.domAttrService.generateId();\n\n  get statusId() {\n    return this._statusId;\n  }\n\n  get useDefaultAriaDescribedby() {\n    return !this.ariaDescribedby && this.countryDropdowndisabled;\n  }\n\n  private matchingCountry?: CountryData;\n  private valueWithoutCountryCode = '';\n  private noMatchingCountryFound = false;\n  private countrySpecificValidationConfig?: CountryCodeFormatConfig;\n  private readonly _destroy$ = new Subject<void>();\n\n  constructor(\n    private readonly domAttrService: DomAttributesService,\n    private readonly elem: ElementRef,\n    private readonly renderer2: Renderer2,\n    override readonly cd: ChangeDetectorRef,\n    @Optional()\n    @Inject(INPUT_PHONE_CONFIG_TOKEN)\n    private readonly overrideConfiguration: InputPhoneConfig,\n    @Optional()\n    @Inject(COUNTRY_CODE_FORMAT_CONFIG_TOKEN)\n    private readonly countryCodeFormatConfiguration: CountryCodeFormatConfigMap,\n  ) {\n    super(cd);\n  }\n\n  ngOnDestroy() {\n    this._destroy$.next();\n    this._destroy$.complete();\n  }\n\n  onTextChange(preventEmit = false) {\n    this.resetMatchingCountry();\n    this.findMatchingCountryCodeFromValue(this.value);\n    this.selectedCountryCode = this.matchingCountry?.countryCode || this.selectedCountryCode;\n    this.selectedCountryName = this.matchingCountry?.countryName || this.selectedCountryName;\n    this.selectedCountryIsoCode = this.matchingCountry?.isoCode || this.selectedCountryIsoCode;\n    this.value = this.enableCountryCode ? this.valueWithoutCountryCode : this.valueWithoutCountryCode || this.value;\n    this.updateValues(preventEmit);\n    this.restoreCaretPosition();\n  }\n\n  updateValues(preventEmit = false): void {\n    this.valueSet = {\n      countryCode: this.selectedCountryCode || '',\n      countryName: this.selectedCountryName || '',\n      isoCode: this.selectedCountryIsoCode || '',\n      number: this.value,\n    };\n\n    if (!preventEmit) {\n      this.valueChange.emit(this.valueSet);\n    }\n    this.cd.detectChanges();\n  }\n\n  ngAfterViewInit(): void {\n    if (!this.ariaLabel) {\n      this.domAttrService.moveAriaAttributes(\n        this.elem.nativeElement,\n        this.inputEl && this.inputEl.nativeElement,\n        this.renderer2,\n      );\n    }\n\n    this.constructCountryData();\n    this.updateValues(true);\n    this.removeReadonly(); // android talkback reads readonly attribute as disabled\n\n    // force lifecycle to doCheck to prevent console ExpressionChangedAfterItHasBeenCheckedError\n    this.cd.detectChanges();\n\n    if (this.value !== undefined) {\n      this.onTextChange();\n    }\n\n    this._isOpen$.pipe(takeUntil(this._destroy$)).subscribe((isOpen) => {\n      if (isOpen) {\n        this.moveAriaAttributes();\n      }\n\n      if (isOpen === undefined) {\n        this.addAriaExpanded();\n      }\n    });\n  }\n\n  onChanges(event: CountryData) {\n    if (!event || event.constructor !== Object) return;\n\n    this.selectedCountryName = event.countryName;\n    this.selectedCountryIsoCode = event.isoCode;\n    this.selectedCountryCode = event.countryCode;\n    this.countrySpecificValidationConfig =\n      this.countryCodeFormatConfiguration && this.countryCodeFormatConfiguration[this.selectedCountryCode];\n    this.onInputValueChange(this.value);\n\n    this.value = this.valueWithoutCountryCode || this.value;\n    this.updateValues();\n  }\n\n  /**\n   * @deprecated Deprecated in ui-ang@12. To be marked as protected in ui-ang@14. No replacements.\n   */\n  onOpen() {\n    if (!this.ngSelect?.dropdownId) {\n      return;\n    }\n    if (this.readonly || this.disabled) {\n      this.countryDropdowndisabled = true;\n      this.ngSelect.isOpen = false;\n\n      return;\n    }\n\n    // wait for DOM to be updated\n    setTimeout(() => {\n      this.moveAriaAttributes();\n    });\n\n    this.updateResultCount();\n  }\n\n  onClose() {\n    if (this.ngSelect && !this.ngSelect.isOpen) {\n      this.ngSelect.constructor.prototype.focus.call(this.ngSelect);\n    }\n  }\n\n  onClear() {\n    this.onFilterChange(undefined);\n  }\n\n  onFilterChange(query: string | undefined): void {\n    if (this.ngSelect) {\n      this.ngSelect.filter(query || '');\n    }\n    this.updateResultCount();\n  }\n\n  searchFunc(term: string, item: CountryData): boolean {\n    term = term.toLocaleLowerCase();\n\n    return (\n      item.countryCode.toLocaleLowerCase().indexOf(term) > -1 ||\n      item.countryName.toLocaleLowerCase().indexOf(term) > -1 ||\n      item.isoCode.toLocaleLowerCase().indexOf(term) > -1\n    );\n  }\n\n  onInputValueChange(newValue: string) {\n    // remove country code from phone number before validating the input\n    this.resetMatchingCountry();\n    this.findMatchingCountryCodeFromValue(newValue);\n    this.selectedCountryCode = this.matchingCountry?.countryCode ?? this.selectedCountryCode;\n    this.selectedCountryName = this.matchingCountry?.countryName ?? this.selectedCountryName;\n    this.selectedCountryIsoCode = this.matchingCountry?.isoCode ?? this.selectedCountryIsoCode;\n\n    const countryCode = this.selectedCountryCode || '';\n    if (!newValue) {\n      this.onValueChange('');\n\n      return;\n    }\n    this.onValueChange(`${countryCode}${this.valueWithoutCountryCode || newValue}`);\n  }\n\n  validate(control: AbstractControl): ValidationErrors | null {\n    if (control.value === '') {\n      return null;\n    }\n\n    if (this.isPhoneNumberEmpty()) return { required: true };\n\n    if (this.checkValidationPattern(control)) return { invalidFormat: true };\n\n    if (this.noMatchingCountryFound) return { countryCodeUnsupported: true };\n\n    return this.isMinLengthInvalid(control.value) ?? this.isMaxLengthInvalid(control.value);\n  }\n\n  private isPhoneNumberEmpty() {\n    if (!this.required) {\n      return false;\n    }\n\n    const validateWithCountryCode = Boolean(this.enableCountryCode && this.countryList && this.valueSet.countryCode);\n    const isEmptyPhoneNumber = this.valueWithoutCountryCode === '' || this.valueWithoutCountryCode === '+';\n\n    return validateWithCountryCode && isEmptyPhoneNumber;\n  }\n\n  private isMinLengthInvalid(value?: string) {\n    const minLength = this.countrySpecificValidationConfig?.minLength ?? this.minLength;\n\n    if (!minLength || !value) {\n      return null;\n    }\n\n    const phoneNumberLength = this.preparePhoneNumberLengthForValidation(value);\n\n    if (phoneNumberLength > 0 && phoneNumberLength < minLength) {\n      return { minLength: { expectedMinLength: minLength } };\n    }\n\n    return null;\n  }\n\n  private isMaxLengthInvalid(value?: string) {\n    const maxLength = this.countrySpecificValidationConfig?.maxLength ?? this.maxLength;\n\n    if (!maxLength || !value) {\n      return null;\n    }\n\n    const phoneNumberLength = this.preparePhoneNumberLengthForValidation(value);\n\n    if (phoneNumberLength > maxLength) {\n      return { maxLength: { expectedMaxLength: maxLength } };\n    }\n\n    return null;\n  }\n\n  private checkValidationPattern(control: AbstractControl) {\n    if (this.validationPattern) {\n      if (Validators.pattern(this.validationPattern)(control)) {\n        return true;\n      }\n    }\n\n    return false;\n  }\n\n  /**\n   * Resets `matchingCountry` if the `selectedCountry` was changed manually via the country dropdown\n   */\n  private resetMatchingCountry() {\n    if (!this.enableCountryCode || !this.countryList) {\n      return;\n    }\n\n    if (this.selectedCountryIsoCode !== this.matchingCountry?.isoCode) {\n      this.matchingCountry = undefined;\n    }\n  }\n\n  private updateResultCount(): void {\n    this.resultCount = this.ngSelect?.itemsList.filteredItems.filter(({ children }) => !children).length || 0;\n  }\n\n  private constructCountryData(): void {\n    if (!this.enableCountryCode || !this.countryList) {\n      return;\n    }\n\n    const isoCode = this.selectedCountryIsoCode || this.defaultCountryIsoCode;\n    const selectedCountry = this.countryList.find((country) => country.isoCode === isoCode) || this.countryList[0];\n\n    this.countryDropdowndisabled = this.countryList.length === 1 || this.readonly || this.disabled;\n    this.selectedCountryCode = selectedCountry.countryCode;\n    this.selectedCountryName = selectedCountry.countryName;\n    this.selectedCountryIsoCode = selectedCountry.isoCode;\n    this.countrySpecificValidationConfig =\n      this.countryCodeFormatConfiguration && this.countryCodeFormatConfiguration[this.selectedCountryCode];\n  }\n\n  private findMatchingCountryCodeFromValue(value = ''): void {\n    if (!this.countryList) {\n      return;\n    }\n\n    if (!this.enableCountryCode) {\n      this.valueWithoutCountryCode = value;\n      if (value.startsWith('+') && value.length >= 2) {\n        const matchingCountry = extractCountryFromValue(value, this.countryList);\n\n        this.valueWithoutCountryCode = stripCountryCodeFromValue(value, matchingCountry?.countryCode);\n      }\n\n      return;\n    }\n\n    if (value.startsWith('+') && value.length >= 2) {\n      const matchingCountry = extractCountryFromValue(value, this.countryList);\n      const { number, ...valueSet } = { ...this.valueSet };\n\n      this.matchingCountry = matchingCountry?.countryCode === valueSet.countryCode ? valueSet : matchingCountry;\n\n      if (this.matchingCountry) {\n        this.noMatchingCountryFound = false;\n        this.countrySpecificValidationConfig = this.countryCodeFormatConfiguration?.[this.matchingCountry.countryCode];\n        this.valueWithoutCountryCode = stripCountryCodeFromValue(value, this.matchingCountry.countryCode);\n      } else {\n        this.noMatchingCountryFound = true;\n        this.valueWithoutCountryCode = value;\n      }\n    } else {\n      this.noMatchingCountryFound = false;\n      this.valueWithoutCountryCode = value;\n    }\n  }\n\n  private removeReadonly() {\n    if (this.ngSelect && !this.readonly) {\n      this.renderer2.removeAttribute(this.ngSelect?.searchInput.nativeElement, 'readonly');\n    }\n  }\n\n  private preparePhoneNumberLengthForValidation(value: string) {\n    const countryCode = this.selectedCountryCode ?? this.valueSet.countryCode;\n\n    if (this.enableCountryCode && typeof value === 'string' && value.startsWith(countryCode)) {\n      // value contains both country code and phone number, we exclude country code for length validation\n      return value.length - countryCode.length;\n    }\n\n    // account for when users will call \".patch({ mobileNumber: x })\" without the country code\n    return value.length;\n  }\n\n  private moveAriaAttributes() {\n    // HACK: ng-select listbox cannot have roles that are not \"option\"\n    // We move listbox to be the direct parent of the list and not cover the searchbox\n\n    const ngDropdownPanelElement = this.ngSelect?.element.querySelector('ng-dropdown-panel');\n    const listOptionsElement = ngDropdownPanelElement?.querySelector('.ng-dropdown-panel-items');\n\n    if (!ngDropdownPanelElement || !listOptionsElement) {\n      return;\n    }\n\n    this.renderer2.setAttribute(listOptionsElement, 'role', 'listbox');\n    this.renderer2.setAttribute(listOptionsElement, 'aria-label', 'List of countries');\n    this.renderer2.removeAttribute(ngDropdownPanelElement, 'role');\n  }\n\n  private addAriaExpanded() {\n    const comboboxElement = this.ngSelect?.element?.querySelector('[role=\"combobox\"]');\n\n    if (!comboboxElement || comboboxElement.hasAttribute('aria-expanded')) {\n      return;\n    }\n\n    this.renderer2.setAttribute(comboboxElement, 'aria-expanded', 'false');\n  }\n\n  private restoreCaretPosition() {\n    const inputElement = this.inputEl?.nativeElement;\n    if (inputElement === document.activeElement) {\n      const caretPosition = inputElement?.selectionStart || 0; // Preserve caret\n      setTimeout(() => {\n        inputElement?.setSelectionRange(caretPosition, caretPosition); // Restore caret\n      });\n    }\n  }\n}\n",
      properties: [
        {
          name: 'number',
          deprecated: false,
          deprecationMessage: '',
          type: 'string',
          indexKey: '',
          optional: false,
          description: '',
          line: 136,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: ['CountryData'],
    },
    {
      name: 'ViewExtensionComponent',
      id: 'interface-ViewExtensionComponent-6e79370cff5ccd9700f3516d8ec6dcdb4988a203ef6784d28cea8af42f362e1c1d66ea4d27a794bbbf890c92a881f9b7d843f444f5e1675141a9f20b258a6dc1',
      file: 'libs/ui-ang/view-extensions/types.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { OnChanges, OnDestroy } from '@angular/core';\n\n/**\n * Journeys providing view extensions should export a public type which extends\n * this interface with a concrete type for ContextType, to allow consumers a\n * type-safe mechanism for implementing view extension components.\n *\n * @typeParam ContextType - The type of data available for a specific view extension point.\n *\n * @example\n *\n * Types exported from a journey:\n *\n * ```typescript\n * // Some data type available for use in a view extension:\n * export interface ExampleEntity {\n *   id: string;\n *   additions?: Record<string, any>;\n *   // etc\n * }\n *\n * // The extension component type for the view extension:\n * export type ExampleEntityExtensionComponent = ViewExtensionComponent<ExampleEntity>;\n * ```\n *\n * In the app providing the view extension implementation:\n *\n * ```typescript\n * @Component({\n *   template: `<p>My custom property: {{ context?.additions?.myCustomProperty }}</p>`\n *   //...\n * })\n * export class ExampleEntityAdditionalDetailsComponent implements ExampleEntityExtensionComponent {\n *   @Input() context: ExampleEntity | undefined;\n * }\n * ```\n */\nexport interface ViewExtensionComponent<ContextType> extends Partial<OnChanges & OnDestroy> {\n  /**\n   * The containing journey will provide the appropriate data via this property.\n   *\n   * Should be implemented as an `@Input()` in the extension component.  Can be\n   * either a plain property or a setter function.\n   *\n   * @param context The data available for rendering in this view extension\n   */\n  set context(context: ContextType | undefined);\n}\n",
      properties: [],
      indexSignatures: [],
      kind: 178,
      description:
        '<p>Journeys providing view extensions should export a public type which extends\nthis interface with a concrete type for ContextType, to allow consumers a\ntype-safe mechanism for implementing view extension components.</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-html"></code></pre></div><p>Types exported from a journey:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">// Some data type available for use in a view extension:\nexport interface ExampleEntity {\n  id: string;\n  additions?: Record&lt;string, any&gt;;\n  // etc\n}\n\n// The extension component type for the view extension:\nexport type ExampleEntityExtensionComponent = ViewExtensionComponent&lt;ExampleEntity&gt;;</code></pre></div><p>In the app providing the view extension implementation:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&#64;Component({\n  template: `&lt;p&gt;My custom property: {{ context?.additions?.myCustomProperty }}&lt;/p&gt;`\n  //...\n})\nexport class ExampleEntityAdditionalDetailsComponent implements ExampleEntityExtensionComponent {\n  &#64;Input() context: ExampleEntity | undefined;\n}</code></pre></div>',
      rawdescription:
        '\n\nJourneys providing view extensions should export a public type which extends\nthis interface with a concrete type for ContextType, to allow consumers a\ntype-safe mechanism for implementing view extension components.\n\n\n```html\n```\nTypes exported from a journey:\n\n```typescript\n// Some data type available for use in a view extension:\nexport interface ExampleEntity {\n  id: string;\n  additions?: Record<string, any>;\n  // etc\n}\n\n// The extension component type for the view extension:\nexport type ExampleEntityExtensionComponent = ViewExtensionComponent<ExampleEntity>;\n```\n\nIn the app providing the view extension implementation:\n\n```typescript\n@Component({\n  template: `<p>My custom property: {{ context?.additions?.myCustomProperty }}</p>`\n  //...\n})\nexport class ExampleEntityAdditionalDetailsComponent implements ExampleEntityExtensionComponent {\n  @Input() context: ExampleEntity | undefined;\n}\n```\n',
      methods: [],
      extends: ['Partial'],
    },
    {
      name: 'Visitor',
      id: 'interface-Visitor-5db26258c64a043112b7f535bf1f72426f0dd00ca3475f0ff65dab9795c1917a647adaffe87a1e2f4290c86aa4989a6e151d9cb21ac3d25b77ed66c57b6494ea',
      file: 'libs/ui-ang/migrations/src/utils/types.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { type Element, type Node } from '@angular/compiler';\n\nexport const TEMPLATE_STRING_SELECTOR = 'PropertyAssignment:has([name=\"template\"]) NoSubstitutionTemplateLiteral';\ninterface Visitor {\n  visit: (node: Node) => void;\n}\n\nexport function visitAll(visitor: Visitor, nodes: Node[]) {\n  nodes.forEach((item) => {\n    visitor.visit(item as Element);\n  });\n}\n\nexport class ElementToMigrate {\n  el: Element;\n\n  constructor(el: Element) {\n    this.el = el;\n  }\n}\n\nexport class ElementCollector implements Visitor {\n  readonly elements: ElementToMigrate[] = [];\n\n  constructor(private selectors: string[] = []) {}\n\n  visit(node: Node) {\n    if (this.selectors.includes((node as Element).name)) {\n      this.elements.push(new ElementToMigrate(node as Element));\n\n      return;\n    }\n\n    if ((node as Element).children) {\n      visitAll(this, (node as Element).children);\n    }\n  }\n}\n",
      properties: [
        {
          name: 'visit',
          deprecated: false,
          deprecationMessage: '',
          type: 'function',
          indexKey: '',
          optional: false,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
    {
      name: 'VisualPageTypes',
      id: 'interface-VisualPageTypes-df75fee93c07dc35de07df993ec7977d86ececcf0663676f676f0dcb540411045b377732582b7d4a7de0bf19451182c6dce7df8c03aff3839162e1da3fd58a32',
      file: 'libs/shared/util/playwright/src/lib/visual/interfaces/visual-page-types.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { VisualTypes } from './visual-types';\n\nexport interface VisualPageTypes extends VisualTypes {\n  clip?: { x: number; y: number; width: number; height: number };\n  fullPage?: boolean;\n}\n",
      properties: [
        {
          name: 'clip',
          deprecated: false,
          deprecationMessage: '',
          type: 'literal type',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'fullPage',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: ['VisualTypes'],
    },
    {
      name: 'VisualTypes',
      id: 'interface-VisualTypes-2c60bac536bb96c14349e1cfc09cfdaaa794f2151559e47e087d0290693b8358c14e7855f4c626932b1ea0bcb3afdb9f2502c35e8672691a958034c13bb646ab',
      file: 'libs/shared/util/playwright/src/lib/visual/interfaces/visual-types.ts',
      deprecated: false,
      deprecationMessage: '',
      type: 'interface',
      sourceCode:
        "import { Locator } from '@playwright/test';\n\nexport interface VisualTypes {\n  animations?: 'disabled' | 'allow';\n  caret?: 'hide' | 'initial';\n  mask?: Array<Locator>;\n  maxDiffPixelRatio?: number;\n  maxDiffPixels?: number;\n  omitBackground?: boolean;\n  scale?: 'css' | 'device';\n  threshold?: number;\n  timeout?: number;\n}\n",
      properties: [
        {
          name: 'animations',
          deprecated: false,
          deprecationMessage: '',
          type: '"disabled" | "allow"',
          indexKey: '',
          optional: true,
          description: '',
          line: 4,
        },
        {
          name: 'caret',
          deprecated: false,
          deprecationMessage: '',
          type: '"hide" | "initial"',
          indexKey: '',
          optional: true,
          description: '',
          line: 5,
        },
        {
          name: 'mask',
          deprecated: false,
          deprecationMessage: '',
          type: 'Array<Locator>',
          indexKey: '',
          optional: true,
          description: '',
          line: 6,
        },
        {
          name: 'maxDiffPixelRatio',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 7,
        },
        {
          name: 'maxDiffPixels',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 8,
        },
        {
          name: 'omitBackground',
          deprecated: false,
          deprecationMessage: '',
          type: 'boolean',
          indexKey: '',
          optional: true,
          description: '',
          line: 9,
        },
        {
          name: 'scale',
          deprecated: false,
          deprecationMessage: '',
          type: '"css" | "device"',
          indexKey: '',
          optional: true,
          description: '',
          line: 10,
        },
        {
          name: 'threshold',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 11,
        },
        {
          name: 'timeout',
          deprecated: false,
          deprecationMessage: '',
          type: 'number',
          indexKey: '',
          optional: true,
          description: '',
          line: 12,
        },
      ],
      indexSignatures: [],
      kind: 171,
      methods: [],
      extends: [],
    },
  ],
  directives: [
    {
      name: 'bbInfiniteScrollDirective',
      selector: '[bbInfiniteScrollDirective]',
      inputsClass: [
        {
          name: 'alwaysCallback',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 61,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'fromRoot',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 62,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'horizontal',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 60,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'immediateCheck',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 59,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'infiniteScrollContainer',
          defaultValue: 'null',
          deprecated: false,
          deprecationMessage: '',
          line: 57,
          type: 'any',
          decorators: [],
        },
        {
          name: 'infiniteScrollDisabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 56,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'infiniteScrollDistance',
          defaultValue: '2',
          deprecated: false,
          deprecationMessage: '',
          line: 53,
          type: 'number',
          decorators: [],
        },
        {
          name: 'infiniteScrollThrottle',
          defaultValue: '150',
          deprecated: false,
          deprecationMessage: '',
          line: 55,
          type: 'number',
          decorators: [],
        },
        {
          name: 'infiniteScrollUpDistance',
          defaultValue: '1.5',
          deprecated: false,
          deprecationMessage: '',
          line: 54,
          type: 'number',
          decorators: [],
        },
        {
          name: 'scrollWindow',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          line: 58,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'scrolled',
          defaultValue: 'new EventEmitter<IInfiniteScrollEvent>()',
          deprecated: false,
          deprecationMessage: '',
          line: 50,
          type: 'EventEmitter',
        },
        {
          name: 'scrolledUp',
          defaultValue: 'new EventEmitter<IInfiniteScrollEvent>()',
          deprecated: false,
          deprecationMessage: '',
          line: 51,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'destroyScroller',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 130,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'handleOnScroll',
          args: [
            {
              type: 'IInfiniteScrollAction',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 113,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              type: 'IInfiniteScrollAction',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'setup',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 94,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ButtonDirective',
      selector: 'button[bbButton]',
      inputsClass: [
        {
          name: 'block',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe flag to indicate whether the button should fill the container that it is in. Defaults to 'false'.\n",
          description:
            '<p>The flag to indicate whether the button should fill the container that it is in. Defaults to &#39;false&#39;.</p>\n',
          line: 63,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'buttonSize',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSize of the button.\n',
          description: '<p>Size of the button.</p>\n',
          line: 56,
          type: '"sm" | "md"',
          decorators: [],
        },
        {
          name: 'circle',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe flag to indicate whether the button should be in a circular shape. Defaults to 'false'.\nThis will only work when there's only an icon inside the button without a text.\n",
          description:
            '<p>The flag to indicate whether the button should be in a circular shape. Defaults to &#39;false&#39;.\nThis will only work when there&#39;s only an icon inside the button without a text.</p>\n',
          line: 70,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'color',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe color for the button. Defaults to 'primary'.\nIf a custom string used, then a css class is going to be added. The pattern is as follows:\n`btn-customColor`\n",
          description:
            '<p>The color for the button. Defaults to &#39;primary&#39;.\nIf a custom string used, then a css class is going to be added. The pattern is as follows:\n<code>btn-customColor</code></p>\n',
          line: 51,
          type: 'ButtonColor | string',
          decorators: [],
        },
        {
          name: 'type',
          defaultValue: "'button'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nButton's type atrribute with default value.\n",
          description: '<p>Button&#39;s type atrribute with default value.</p>\n',
          line: 44,
          type: 'ButtonType',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description:
        '<p>Directive for styling button.</p>\n<h3>Color background mode</h3>\n<p>In case the button is located inside a parent HTML element with a darker background, consider using an <code>On Color</code> palette.\nFor the reference see the <code>On Color</code> example above in the <code>Interactive demo</code> section.\nTo enable the <code>On Color</code> palette one has to add a <code>.btn-on-color</code> class to the parent HTML element like this:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none">&lt;div class=&quot;btn-on-color&quot;&gt;\n  &lt;button\n      bbButton\n      [color]=&quot;button.color&quot;\n      buttonSize=&quot;md&quot;\n    &gt;\n    ...\n    &lt;/button&gt;\n&lt;/div&gt;</code></pre></div><p>The class does not have to be applied to a direct parent of a button component: all buttons under this container,\nno matter how deep, will be displayed in the <code>On Color</code> palette.\n<code>On Color</code> is supported only for <code>primary</code>, <code>secondary</code> and <code>link</code> buttons.</p>\n<p>The <code>bbButton</code> directive doesn&#39;t provide any specific properties for accessibility.\nIn case of necessity add <code>aria-*</code> attributes to the <code>button</code> element.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ControlErrorContainerDirective',
      selector: '[bbControlErrorContainer]',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'DigitOnlyDirective',
      selector: '[bbDigitOnly]',
      inputsClass: [
        {
          name: 'allowNegativeSign',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 28,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'bbDigitOnly',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          line: 25,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onKeyDown',
          args: [
            {
              name: 'e',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 38,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'e',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'DropdownMenuFullWidthDirective',
      selector: '[bbDropdownToggleFullWidth]',
      inputsClass: [
        {
          name: 'bbDropdownToggleFullWidth',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf true it will stretch the dropdown menu to 100% width\n',
          description: '<p>If true it will stretch the dropdown menu to 100% width</p>\n',
          line: 22,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onResize',
          args: [
            {
              name: 'event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 11,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'window:resize', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'DropdownMenuOptionDirective',
      selector: '[bbDropdownMenuOption]',
      inputsClass: [
        {
          name: 'active',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 707,
              end: 725,
              kind: 327,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 708,
                end: 715,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'default',
              },
              comment: '<p>false</p>\n',
            },
          ],
          rawdescription: '\n\nBoolean value to add/remove the active class on menuitem\n\n',
          description: '<p>Boolean value to add/remove the active class on menuitem</p>\n',
          line: 30,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'bbDropdownMenuOption',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nvalue of the dropdown menuitem\n',
          description: '<p>value of the dropdown menuitem</p>\n',
          line: 23,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'selectionChange',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent that is emitted when user clicks on menuitem\n',
          description: '<p>Event that is emitted when user clicks on menuitem</p>\n',
          line: 35,
          type: 'EventEmitter<DropdownMenuOptionDirective>',
        },
      ],
      methodsClass: [
        {
          name: 'onSelect',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 40,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'click'",
            },
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.enter'",
            },
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.space'",
            },
          ],
          modifierKind: [170, 170, 170],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ElementViewInitDirective',
      selector: '[bbElementViewInit]',
      inputsClass: [],
      outputsClass: [
        {
          name: 'bbElementViewInit',
          defaultValue: 'new EventEmitter<ElementRef>()',
          deprecated: false,
          deprecationMessage: '',
          line: 255,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'FocusDirective',
      selector: '[bbFocus]',
      inputsClass: [
        {
          name: 'bbFocus',
          deprecated: false,
          deprecationMessage: '',
          line: 11,
          type: 'boolean | string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'focus',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 28,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'FocusInvalidInputDirective',
      selector: 'form[bbFocusInvalidInput]',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onFormSubmit',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 18,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'submit'",
            },
          ],
          modifierKind: [170],
        },
      ],
      description: '<p>Directive to focus the first invalid form input.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'FormSubmitDirective',
      selector: 'form[bbFormSubmit]',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'HighlightDirective',
      selector: '[bbHighlight]',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 597,
              end: 642,
              kind: 341,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 598,
                end: 603,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Value of highlighted number</p>\n',
              name: {
                pos: 604,
                end: 610,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'amount',
              },
              isNameFirst: true,
              isBracketed: false,
            },
          ],
          rawdescription: '\n\nSetter (Input) for value of highlighted number\n\n',
          description: '<p>Setter (Input) for value of highlighted number</p>\n',
          line: 24,
          type: 'string | number',
          decorators: [],
        },
        {
          name: 'bbHighlight',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 845,
              end: 876,
              kind: 341,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 846,
                end: 851,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Highlight flag</p>\n',
              name: {
                pos: 852,
                end: 857,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              isNameFirst: true,
              isBracketed: false,
            },
          ],
          rawdescription: '\n\nSetter (Input) that turn on/off highlight\n\n',
          description: '<p>Setter (Input) that turn on/off highlight</p>\n',
          line: 34,
          type: 'boolean | string',
          decorators: [],
        },
        {
          name: 'negativeClass',
          defaultValue: 'DEFAULT_NEGATIVE_CLASS',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe class for positive value.\n',
          description: '<p>The class for positive value.</p>\n',
          line: 41,
          type: 'string',
          decorators: [],
        },
        {
          name: 'positiveClass',
          defaultValue: 'DEFAULT_POSITIVE_CLASS',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe class for negative value.\n',
          description: '<p>The class for negative value.</p>\n',
          line: 45,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description:
        '<p>Directive that encapsulate logic for highlighting positive/negative numbers.\nExample usage with bb-amount-ui (AmountModule)</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'HighlightDirective',
      selector: '[bbHighlight]',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 543,
              end: 588,
              kind: 341,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 544,
                end: 549,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Value of highlighted number</p>\n',
              name: {
                pos: 550,
                end: 556,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'amount',
              },
              isNameFirst: true,
              isBracketed: false,
            },
          ],
          rawdescription: '\n\nSetter (Input) for value of highlighted number\n\n',
          description: '<p>Setter (Input) for value of highlighted number</p>\n',
          line: 23,
          type: 'string | number',
          decorators: [],
        },
        {
          name: 'bbHighlight',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 791,
              end: 822,
              kind: 341,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 792,
                end: 797,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Highlight flag</p>\n',
              name: {
                pos: 798,
                end: 803,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              isNameFirst: true,
              isBracketed: false,
            },
          ],
          rawdescription: '\n\nSetter (Input) that turn on/off highlight\n\n',
          description: '<p>Setter (Input) that turn on/off highlight</p>\n',
          line: 33,
          type: 'boolean | string',
          decorators: [],
        },
        {
          name: 'negativeClass',
          defaultValue: 'DEFAULT_NEGATIVE_CLASS',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe class for positive value.\n',
          description: '<p>The class for positive value.</p>\n',
          line: 40,
          type: 'string',
          decorators: [],
        },
        {
          name: 'positiveClass',
          defaultValue: 'DEFAULT_POSITIVE_CLASS',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe class for negative value.\n',
          description: '<p>The class for negative value.</p>\n',
          line: 44,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Directive that encapsulate logic for highlighting positive/negative numbers.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'IbanValidatorDirective',
      selector: '[bbIbanValidatorDir]',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'validate',
          args: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'literal type | null',
          typeParameters: [],
          line: 12,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputRangeDirective',
      selector: '[bbInputRange]',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputRangeMaxDirective',
      selector: 'bb-input-number-ui[bbInputRangeMax]',
      inputsClass: [
        {
          name: 'bbInputRangeMax',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMaximum possible value (optional);\n',
          description: '<p>Maximum possible value (optional);</p>\n',
          line: 50,
          type: 'number',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputRangeMinDirective',
      selector: 'bb-input-number-ui[bbInputRangeMin]',
      inputsClass: [
        {
          name: 'bbInputRangeMin',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMinimum possible value (optional);\n',
          description: '<p>Minimum possible value (optional);</p>\n',
          line: 23,
          type: 'number',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'IsContentTruncatedDirective',
      selector: '[bbIsContentTruncated]',
      inputsClass: [
        {
          name: 'hostRef',
          deprecated: false,
          deprecationMessage: '',
          line: 20,
          type: 'CheckContentTruncationBehaviour',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'KeyboardClickDirective',
      selector: '[bbKeyboardClick]',
      inputsClass: [],
      outputsClass: [
        {
          name: 'bbKeyboardClick',
          defaultValue: 'new EventEmitter<Event>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nStream that should be fired on click/keydown.enter/keydown.space\n',
          description: '<p>Stream that should be fired on click/keydown.enter/keydown.space</p>\n',
          line: 20,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'onActionKeyPressed',
          args: [
            {
              name: '$event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 36,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.enter', ['$event']",
            },
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.space', ['$event']",
            },
          ],
          modifierKind: [170, 170],
          jsdoctags: [
            {
              name: '$event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onClicked',
          args: [
            {
              name: '$event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 45,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'click', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: '$event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description:
        '<p>Directive that add click/keydown.enter/keydown.space events on element\nUsed for adding accessibility(tab navigation events) for element</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'LayoutNavDropdownDirective',
      selector: '[bbLayoutNavDropdown]',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'MaxDateValidatorDirective',
      selector: 'bb-input-datepicker-ui[maxDate]',
      inputsClass: [
        {
          name: 'maxDate',
          deprecated: false,
          deprecationMessage: '',
          line: 26,
          type: 'string | NgbDateStruct | undefined',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'registerOnValidatorChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 37,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'validate',
          args: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'ValidationErrors | null',
          typeParameters: [],
          line: 41,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'MinDateValidatorDirective',
      selector: 'bb-input-datepicker-ui[minDate]',
      inputsClass: [
        {
          name: 'minDate',
          deprecated: false,
          deprecationMessage: '',
          line: 26,
          type: 'string | NgbDateStruct | undefined',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'registerOnValidatorChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 37,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'validate',
          args: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'ValidationErrors | null',
          typeParameters: [],
          line: 41,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TableDirective',
      selector: 'table[bbTable]',
      inputsClass: [
        {
          name: 'bbTable',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe data source for the table.\n',
          description: '<p>The data source for the table.</p>\n',
          line: 137,
          type: 'Array<Object>',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'rowClick',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEmits an event when a row is clicked.\nAn sample implementation could be:\n\n```typescript\nonRowClick(value: unknown) { ..... }\n\nThis will require `[bbRow]="rowData"` to table row and `[bbTableFocus]` to root table element.\n```\n',
          description:
            '<p>Emits an event when a row is clicked.\nAn sample implementation could be:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">onRowClick(value: unknown) { ..... }\n\nThis will require `[bbRow]=&quot;rowData&quot;` to table row and `[bbTableFocus]` to root table element.</code></pre></div>',
          line: 152,
          type: 'EventEmitter',
        },
        {
          name: 'selectRow',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits an event when a row is selected.\n',
          description: '<p>Emits an event when a row is selected.</p>\n',
          line: 141,
          type: 'EventEmitter',
        },
        {
          name: 'sort',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nAn event emitter for on sort actions.\nAn sample implementation could be:\n\n```typescript\nonSort({ column, direction }: SortEvent) { ..... }\n```\n\nThis will require you to add `[bbSortable]="\'columnName\'"` to column header.\n',
          description:
            '<p>An event emitter for on sort actions.\nAn sample implementation could be:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">onSort({ column, direction }: SortEvent) { ..... }</code></pre></div><p>This will require you to add <code>[bbSortable]=&quot;&#39;columnName&#39;&quot;</code> to column header.</p>\n',
          line: 163,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'isSelected',
          args: [
            {
              name: 'row',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 180,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'row',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'isSelectedAll',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 202,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'isSelectedPart',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 212,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onRowClick',
          args: [
            {
              name: 'rowItem',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 176,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'rowItem',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onSort',
          args: [
            {
              name: 'sortEvent',
              type: 'SortEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 220,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'sortEvent',
              type: 'SortEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'registerHeader',
          args: [
            {
              name: 'header',
              type: 'TableSortableDirective',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 168,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'header',
              type: 'TableSortableDirective',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'toggleAllItems',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 193,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'toggleItem',
          args: [
            {
              name: 'row',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'isChecked',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 184,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'row',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'isChecked',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'unRegisterHeader',
          args: [
            {
              name: 'header',
              type: 'TableSortableDirective',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 172,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'header',
              type: 'TableSortableDirective',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description:
        '<p>Directive that displays a table. Can be used with <a href="https://material.angular.io/cdk/table/overview">CdkTable</a> to provide a powerful data-table solution.</p>\n<h4>Sorting</h4>\n<p>Sorting of table can be enabled by adding <code>[bbSortable]=&quot;&#39;columnName&#39;&quot;</code> to column header. Additional you will need to implement handling of <code>sort</code> output.\nHere is small example of how it may look like in template:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&lt;table [bbTable]=&quot;data&quot; (sort)=&quot;onSort($event)&quot;&gt;\n &lt;thead&gt;\n   &lt;tr&gt;\n     &lt;th [bbSortable]=&quot;&#39;columnName&#39;&quot;&gt;\n       &lt;span class=&quot;th-content&quot;&gt;columnName&lt;/span&gt;\n     &lt;/th&gt;\n   &lt;/tr&gt;\n &lt;/thead&gt;\n&lt;/table&gt;</code></pre></div><h4>Focusable and clickable rows</h4>\n<p>In order to achieve keyboard navigation over a table and add support for clickable rows you will need to add <code>bbTableFocus</code> to root table element and <code>[bbRow]=&quot;rowData&quot;</code> to row elements.\nAdditionally <code>selectRow</code> and <code>rowClick</code> can be used to handle appropriate events.</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&lt;table [bbTable]=&quot;data&quot; bbTableFocus&gt;\n &lt;tbody&gt;\n   &lt;tr [bbRow]=&quot;rowData&quot;&gt;\n     &lt;td&gt;&lt;/td&gt;\n   &lt;/tr&gt;\n &lt;/tbody&gt;\n&lt;/table&gt;</code></pre></div><h4>a11y</h4>\n<p>The table directive doesn&#39;t provide any specific properties for accessibility.\nThe <code>aria-sort</code> tag can be set on the sortable header cells with ascending and descending values.</p>\n<h4>Angular CDK Table</h4>\n<p>The <code>CdkTable</code> provides an unopinionated, highly customizable data-table solution with a flexible templating API,\ndynamic column management, and an accessible DOM structure. It can be seamlessly used alongside the <code>bbTable</code> directive\nto combine CDK&#39;s powerful features with bbTable&#39;s functionality.\nIn order to add sorting to the table with <code>CdkTable</code>, you can use the <code>bbSortable</code> directive and follow steps in the <em>Sorting</em> section.</p>\n<p>Key advantages of using Angular CDK tables:</p>\n<ul>\n<li>Dynamic column management: Add, remove, or replace columns through configuration</li>\n<li>Flexible templating system for custom cell rendering</li>\n<li>Built-in accessibility features</li>\n<li>Seamless integration with Angular&#39;s change detection</li>\n</ul>\n<p>Lets have a look at how to use <code>CdkTable</code> alongside <code>bbTable</code> directive:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&#64;Component({\n  selector: &#39;bb-cdk-table-example-ui&#39;,\n  imports: [\n    TableModule,\n    CdkTableModule,\n    NgComponentOutlet,\n    AsyncPipe,\n    DecimalPipe,\n  ],\n  template: `\n    &lt;table\n      cdk-table\n      [bbTable]=&quot;dataSource | async&quot;\n      class=&quot;table table-hover&quot;\n      [dataSource]=&quot;dataSource&quot;\n    &gt;\n      &lt;ng-container cdkColumnDef=&quot;name&quot;&gt;\n        &lt;th cdk-header-cell *cdkHeaderCellDef&gt;\n          &lt;span class=&quot;th-content&quot;&gt;Country&lt;/span&gt;\n        &lt;/th&gt;\n        &lt;td cdk-cell *cdkCellDef=&quot;let element&quot;&gt;\n          {{ element.name }}\n        &lt;/td&gt;\n      &lt;/ng-container&gt;\n\n      &lt;ng-container cdkColumnDef=&quot;area&quot;&gt;\n        &lt;th cdk-header-cell *cdkHeaderCellDef&gt;\n          &lt;span class=&quot;th-content&quot;&gt;Area&lt;/span&gt;\n        &lt;/th&gt;\n        &lt;td cdk-cell *cdkCellDef=&quot;let element&quot;&gt;\n          {{ element.area | number }}\n        &lt;/td&gt;\n      &lt;/ng-container&gt;\n\n      &lt;ng-container cdkColumnDef=&quot;population&quot;&gt;\n        &lt;th cdk-header-cell *cdkHeaderCellDef&gt;\n           &lt;span class=&quot;th-content&quot;&gt;Population&lt;/span&gt;\n        &lt;/th&gt;\n        &lt;td cdk-cell *cdkCellDef=&quot;let element&quot;&gt;\n          {{ element.population | number }}\n        &lt;/td&gt;\n      &lt;/ng-container&gt;\n\n      &lt;ng-container cdkColumnDef=&quot;flag&quot;&gt;\n        &lt;th cdk-header-cell *cdkHeaderCellDef&gt;\n         &lt;span class=&quot;th-content&quot;&gt;&lt;/span&gt;\n        &lt;/th&gt;\n        &lt;td cdk-cell *cdkCellDef=&quot;let element&quot;&gt;\n          &lt;img [alt]=&quot;&#39;Flag of &#39; + element.name&quot; [src]=&quot;pathFlagAssets + element.flag&quot; width=&quot;32&quot; /&gt;\n        &lt;/td&gt;\n      &lt;/ng-container&gt;\n\n      &lt;tr cdk-header-row *cdkHeaderRowDef=&quot;displayColumns&quot;&gt;&lt;/tr&gt;\n      &lt;tr cdk-row *cdkRowDef=&quot;let row; columns: displayColumns;&quot;&gt;&lt;/tr&gt;\n    &lt;/table&gt;\n  `,\n  standalone: true,\n})\nexport class CdkTableExampleComponent {\n  readonly displayColumns: string[] = [&#39;name&#39;, &#39;area&#39;, &#39;population&#39;, &#39;flag&#39;];\n  readonly dataSource = new BehaviorSubject&lt;CountryData[]&gt;(countryData);\n  readonly pathFlagAssets = &#39;https://upload.wikimedia.org/wikipedia/commons/&#39;;\n}</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TableFocusDirective',
      selector: '[bbTableFocus]',
      inputsClass: [
        {
          name: 'focusFirstRowOnChanges',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 27,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onKeyEvent',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 34,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TableRowDirective',
      selector: 'tr[bbRow]',
      inputsClass: [
        {
          name: 'bbRow',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe data of the row element\n',
          description: '<p>The data of the row element</p>\n',
          line: 12,
          type: 'any',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onBlur',
          args: [
            {
              name: 'el',
              type: 'ElementRef',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 35,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'blur', ['$event.target']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'el',
              type: 'ElementRef',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onFocus',
          args: [
            {
              name: 'el',
              type: 'ElementRef',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 30,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'focus', ['$event.target']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'el',
              type: 'ElementRef',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onRowClick',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 25,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'click'",
            },
          ],
          modifierKind: [170],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TableSortableDirective',
      selector: 'th[bbSortable]',
      inputsClass: [
        {
          name: 'bbSortable',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe name of the column to be sorted\n',
          description: '<p>The name of the column to be sorted</p>\n',
          line: 39,
          type: 'string',
          decorators: [],
        },
        {
          name: 'direction',
          defaultValue: 'null',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe current sort direction. Accepts one of the values of 'asc', 'desc' or null\n",
          description:
            '<p>The current sort direction. Accepts one of the values of &#39;asc&#39;, &#39;desc&#39; or null</p>\n',
          line: 43,
          type: 'SortDirection',
          decorators: [],
        },
        {
          name: 'sortDisabled',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nToggles the sorting functionality on the column.\n',
          description: '<p>Toggles the sorting functionality on the column.</p>\n',
          line: 50,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'sort',
          defaultValue: 'new EventEmitter<SortEvent>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on sort actions.\n',
          description: '<p>An event emitter for on sort actions.</p>\n',
          line: 57,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'emitSortEvent',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 152,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\nNotify table with new sorting params',
          description: '<p>Notify table with new sorting params</p>\n',
        },
        {
          name: 'getMenuOptionSelectionChanges',
          args: [
            {
              name: 'menuOptions',
              type: 'QueryList<DropdownMenuOptionToken>',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 160,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\nCombined stream of all of the bbTableMenuitem selectionChange events.',
          description: '<p>Combined stream of all of the bbTableMenuitem selectionChange events.</p>\n',
          jsdoctags: [
            {
              name: 'menuOptions',
              type: 'QueryList<DropdownMenuOptionToken>',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'markAllMenuOptionAsInactive',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 174,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'markMenuOptionAsActive',
          args: [
            {
              name: 'menuOption',
              type: 'DropdownMenuOptionToken',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 168,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\nmark the new menuitem as active only if sorting order is asc/desc',
          description: '<p>mark the new menuitem as active only if sorting order is asc/desc</p>\n',
          jsdoctags: [
            {
              name: 'menuOption',
              type: 'DropdownMenuOptionToken',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onMenuOptionSelect',
          args: [
            {
              name: 'menuOption',
              type: 'DropdownMenuOptionToken',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 131,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'menuOption',
              type: 'DropdownMenuOptionToken',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'rotate',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 92,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'click'",
            },
            {
              name: 'HostListener',
              stringifiedArguments: "'keyup.enter'",
            },
            {
              name: 'HostListener',
              stringifiedArguments: "'keyup.space'",
            },
          ],
          modifierKind: [170, 170, 170],
        },
        {
          name: 'updateAriaSortAttribute',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 180,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TooltipDirective',
      selector: '[bbTooltip]',
      inputsClass: [
        {
          name: 'bbTooltip',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nContent to be displayed as tooltip. If falsy, the tooltip won't open. Accepts a string or TemplateRef.\n",
          description:
            '<p>Content to be displayed as tooltip. If falsy, the tooltip won&#39;t open. Accepts a string or TemplateRef.</p>\n',
          line: 66,
          type: 'string | TemplateRef | null | undefined',
          decorators: [],
        },
        {
          name: 'isOpenWithContext',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether tooltip is initially opened with a given context.\nIf falsy, the tooltip will not open on render.\n\nAccepts any context that will be passed into NgTooltip `open()`.\n\nDefaults to `false`.\n',
          description:
            '<p>Whether tooltip is initially opened with a given context.\nIf falsy, the tooltip will not open on render.</p>\n<p>Accepts any context that will be passed into NgTooltip <code>open()</code>.</p>\n<p>Defaults to <code>false</code>.</p>\n',
          line: 91,
          type: 'any',
          decorators: [],
        },
        {
          name: 'triggers',
          defaultValue: "'click'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nSpecifies the events that should trigger the tooltip (space separated strings). Defaults to 'click'.\n\nThis component extends `NgbTooltip`.\nAll available properties of `NgbTooltip` can be used with this component as well.\nMore information about it and more examples can be found in\n[NgBootstrap documentation](https://ng-bootstrap.github.io/#/components/tooltip/api).\n\nThis attribute can be overwritten via the global configuration token.\n",
          description:
            '<p>Specifies the events that should trigger the tooltip (space separated strings). Defaults to &#39;click&#39;.</p>\n<p>This component extends <code>NgbTooltip</code>.\nAll available properties of <code>NgbTooltip</code> can be used with this component as well.\nMore information about it and more examples can be found in\n<a href="https://ng-bootstrap.github.io/#/components/tooltip/api">NgBootstrap documentation</a>.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 80,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'close',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 159,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler to set aria-expanded on closing the tooltip\n',
          description: '<p>Event handler to set aria-expanded on closing the tooltip</p>\n',
        },
        {
          name: 'open',
          args: [
            {
              name: 'context',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 136,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler to set aria-expanded on opening the tooltip\n',
          description: '<p>Event handler to set aria-expanded on opening the tooltip</p>\n',
          jsdoctags: [
            {
              name: 'context',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description:
        '<p>Directive that displays a tooltip.\n<br><br></p>\n<h3>Global configuration token</h3>\n<p><code>TOOLTIP_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>TooltipComponent</code> in your project.</p>\n<p><em>Note:</em> The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not be able to overwrite it.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>triggers</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">import { TOOLTIP_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/tooltip-directive&#39;;\nimport { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\nimport { AppModule } from &#39;./app/app.module&#39;;\n\nconst tooltipConfig = {\n  triggers: &#39;click&#39;,\n  closeDelay: 400\n};\n\nplatformBrowserDynamic().bootstrapModule(AppModule, {\n  providers: [{ provide: TOOLTIP_CONFIG_TOKEN, useValue: tooltipConfig }]\n});</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ValidationErrorsDirective',
      selector: '[bbFormControl]',
      inputsClass: [
        {
          name: 'errorComponent',
          defaultValue: 'this.errorTmpl',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 2121,
              end: 2158,
              kind: 327,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 2122,
                end: 2129,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'default',
              },
              comment: '<p><code>BB_DYNAMIC_ERROR_TMPL</code>.</p>\n',
            },
          ],
          rawdescription:
            '\n\nCustom component for error message.\n\nUse only if you need to set custom component for specific control.\nTo specify custom component for all form errors use BB_DYNAMIC_ERROR_TMPL InjectionToken.\n\n',
          description:
            '<p>Custom component for error message.</p>\n<p>Use only if you need to set custom component for specific control.\nTo specify custom component for all form errors use BB_DYNAMIC_ERROR_TMPL InjectionToken.</p>\n',
          line: 78,
          type: 'Type<ValidationErrorComponentModel>',
          decorators: [],
        },
        {
          name: 'errorLabels',
          defaultValue: '{}',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 1419,
              end: 1455,
              kind: 327,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 1420,
                end: 1427,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'default',
              },
              comment: '<p><code>BB_VALIDATION_ERRORS</code>.</p>\n',
            },
          ],
          rawdescription:
            '\n\nCustom error labels object.\n\nUse only if you need to set custom error labels for specific control.\nTo specify custom error labels for entire form use BB_VALIDATION_ERRORS InjectionToken.\n\n',
          description:
            '<p>Custom error labels object.</p>\n<p>Use only if you need to set custom error labels for specific control.\nTo specify custom error labels for entire form use BB_VALIDATION_ERRORS InjectionToken.</p>\n',
          line: 52,
          type: 'PlainObject<string>',
          decorators: [],
        },
        {
          name: 'inputSelector',
          defaultValue: "'.form-control'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSelector to indicate the control in which `aria-describedby` should be set.\n',
          description:
            '<p>Selector to indicate the control in which <code>aria-describedby</code> should be set.</p>\n',
          line: 63,
          type: 'string',
          decorators: [],
        },
        {
          name: 'label',
          defaultValue: 'null',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nInput label\n',
          description: '<p>Input label</p>\n',
          line: 68,
          type: 'string | null',
          decorators: [],
        },
        {
          name: 'showError',
          defaultValue: 'this.showErrorDefault',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustom function to specify when errors should be shown.\nBy default will be shown when control is invalid.\n',
          description:
            '<p>Custom function to specify when errors should be shown.\nBy default will be shown when control is invalid.</p>\n',
          line: 58,
          type: '() => boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onElBlur',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 80,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'blur'",
            },
          ],
          modifierKind: [170],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ValueDiffDirective',
      selector: '[bbValueDiff]',
      inputsClass: [
        {
          name: 'bbValueDiff',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nNew data with which we will compare content.\n',
          description: '<p>New data with which we will compare content.</p>\n',
          line: 46,
          type: 'string',
          decorators: [],
        },
        {
          name: 'position',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nA position where differences will be added.\nDefault value: 'before'\n",
          description: '<p>A position where differences will be added.\nDefault value: &#39;before&#39;</p>\n',
          line: 60,
          type: 'ValueDiffPosition',
          decorators: [],
        },
        {
          name: 'showArrow',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nShow arrow between old and new value\nDefault value: false\n',
          description: '<p>Show arrow between old and new value\nDefault value: false</p>\n',
          line: 92,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'sr-only-new',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nText for screen reader to describe new value\nDefault value: 'Current value:'\n",
          description: '<p>Text for screen reader to describe new value\nDefault value: &#39;Current value:&#39;</p>\n',
          line: 83,
          type: 'string',
          decorators: [],
        },
        {
          name: 'sr-only-old',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nText for screen reader to describe old value\nDefault value: 'Previous value:'\n",
          description:
            '<p>Text for screen reader to describe old value\nDefault value: &#39;Previous value:&#39;</p>\n',
          line: 74,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
  ],
  components: [
    {
      name: 'AccountNumberComponent',
      selector: 'bb-account-number, bb-account-number-ui',
      inputsClass: [
        {
          name: 'account',
          defaultValue: '{}',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nAccount that contains account number, a format will be picked automatically\nUsed when `number` unset\n',
          description:
            '<p>Account that contains account number, a format will be picked automatically\nUsed when <code>number</code> unset</p>\n',
          line: 60,
          type: 'ArrangementItem',
          decorators: [],
        },
        {
          name: 'masked',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDefines whether the attribute is masked\n',
          description: '<p>Defines whether the attribute is masked</p>\n',
          line: 77,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'number',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccount number,\nUse with `type` to specify which format to use\n',
          description: '<p>Account number,\nUse with <code>type</code> to specify which format to use</p>\n',
          line: 65,
          type: 'string | number | undefined',
          decorators: [],
        },
        {
          name: 'tooltipTrigger',
          defaultValue: "'hover focus'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n/**\nDefines toolitp trigger behavior for masking/unmasking buttons\n',
          description: '<p>/**\nDefines toolitp trigger behavior for masking/unmasking buttons</p>\n',
          line: 82,
          type: 'string',
          decorators: [],
        },
        {
          name: 'type',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nAccount number type ('bban', 'iban' or 'cardNumber')\n",
          description: '<p>Account number type (&#39;bban&#39;, &#39;iban&#39; or &#39;cardNumber&#39;)</p>\n',
          line: 69,
          type: 'AccountNumberType | undefined',
          decorators: [],
        },
        {
          name: 'unmaskable',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDefines whether the attribute is unmaskable\n',
          description: '<p>Defines whether the attribute is unmaskable</p>\n',
          line: 73,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'mask',
          defaultValue: 'new EventEmitter<AccountNumberType>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits a `AccountNumberType` to be masked\n',
          description: '<p>Emits a <code>AccountNumberType</code> to be masked</p>\n',
          line: 86,
          type: 'EventEmitter<AccountNumberType>',
        },
        {
          name: 'unmask',
          defaultValue: 'new EventEmitter<AccountNumberType>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits a `AccountNumberType` to be unmasked\n',
          description: '<p>Emits a <code>AccountNumberType</code> to be unmasked</p>\n',
          line: 90,
          type: 'EventEmitter<AccountNumberType>',
        },
      ],
      methodsClass: [
        {
          name: 'getAccountNumber',
          args: [],
          optional: false,
          returnType: 'string | number',
          typeParameters: [],
          line: 113,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nGives either number if provided. Otherwise, try to get from account.\n\n',
          description: '<p>Gives either number if provided. Otherwise, try to get from account.</p>\n',
          jsdoctags: [
            {
              tagName: {
                pos: 3106,
                end: 3113,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'returns',
              },
              comment: '<p>Either account number or iban or bban</p>\n',
            },
          ],
        },
        {
          name: 'getAccountNumberType',
          args: [],
          optional: false,
          returnType: 'AccountNumberType',
          typeParameters: [],
          line: 122,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nGives either type if provided. Otherwise, try to get from account.\n\n',
          description: '<p>Gives either type if provided. Otherwise, try to get from account.</p>\n',
          jsdoctags: [
            {
              tagName: {
                pos: 3350,
                end: 3357,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'returns',
              },
              comment: '<p>&#39;cardNumber&#39; | &#39;iban&#39; | &#39;bban&#39;</p>\n',
            },
          ],
        },
        {
          name: 'onMask',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 97,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEvent handler for the `mask` button\nEmits the `masked` output with a `MaskedAttribute`\n\n',
          description:
            '<p>Event handler for the <code>mask</code> button\nEmits the <code>masked</code> output with a <code>MaskedAttribute</code></p>\n',
        },
        {
          name: 'onUnmask',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 105,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEvent handler for the `unmask` button\nEmits the `unmasked` output with a `MaskedAttribute`\n\n',
          description:
            '<p>Event handler for the <code>unmask</code> button\nEmits the <code>unmasked</code> output with a <code>MaskedAttribute</code></p>\n',
        },
      ],
      description:
        '<p>Component that displays account number according to the IBAN, BBAN, cardNumber and number.</p>\n<h3>Usage</h3>\n<p>By default, The masking and unmasking of the account number is not implemented and requires custom implementation.\nIn order to have a fully working component with masking capabilities, map the <code>mask</code> and <code>unmask</code> outputs to functions such that it toggles between the masked and unmasked number.</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&#64;Component({\n  selector: &#39;bb-account-number-ui-showcase&#39;,\n  template: `\n    &lt;bb-account-number-ui\n      [number]=&quot;number&quot;\n      [unmaskable]=&quot;true&quot;\n      [masked]=&quot;masked&quot;\n      (unmask)=&quot;onUnmask()&quot;\n      (mask)=&quot;onMask()&quot;\n    &gt;\n    &lt;/bb-account-number-ui&gt;\n  `,\n})\nexport class AccountNumberShowcaseComponent {\n  number = &#39;1234&#39;;\n  masked = false;\n\n  onMask() {\n    this.number = &#39;**34&#39;;\n    this.masked = true;\n  }\n\n  onUnmask() {\n    this.number = &#39;1234&#39;;\n    this.masked = false;\n  }\n\n  constructor() {}\n}</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'AccountNumberExampleComponent',
      selector: 'bb-account-number-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-account-number-example-ui',\n  templateUrl: './account-number.example.component.html',\n  standalone: false,\n})\nexport class AccountNumberExampleComponent {\n  item = {\n    IBAN: 'GB29NWBK60161331926819',\n    BBAN: 'BBAN00001',\n    number: '1234',\n    productKindName: 'Current Account',\n  };\n}\n",
      template: '<bb-account-number [account]="item"></bb-account-number>\n',
    },
    {
      name: 'AccountNumberPipeExampleComponent',
      selector: 'bb-account-number-pipe-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { AccountNumberType } from '@backbase/ui-ang/account-number-pipe';\n\n@Component({\n  selector: 'bb-account-number-pipe-example-ui',\n  templateUrl: './account-number-pipe.example.component.html',\n  standalone: false,\n})\nexport class AccountNumberPipeExampleComponent {\n  productNumber = 'IBAN1234567891234567';\n  numberType: AccountNumberType = 'iban';\n}\n",
      template: '<p>{{ productNumber | bbAccountNumber : numberType }}</p>\n',
    },
    {
      name: 'AccountSelectorComponent',
      selector: 'bb-account-selector-ui',
      inputsClass: [
        {
          name: 'accountSelectorInstructions',
          defaultValue:
            '`\n  Account selector component.\n  It allows to select multiple accounts by selecting from a dropdown list.\n  To select or deselect all items use left and right buttons.`',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nInstructions for the account selector component.\nUse this to provide guidance on how to select multiple accounts from a dropdown list.\nTo select or deselect all items use the left and right arrow keys.\n',
          description:
            '<p>Instructions for the account selector component.\nUse this to provide guidance on how to select multiple accounts from a dropdown list.\nTo select or deselect all items use the left and right arrow keys.</p>\n',
          line: 488,
          type: 'string',
          decorators: [],
        },
        {
          name: 'appendTo',
          deprecated: false,
          deprecationMessage: '',
          line: 610,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 514,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 521,
          type: 'string',
          decorators: [],
        },
        {
          name: 'clearable',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllow to clear selected value.\n',
          description: '<p>Allow to clear selected value.</p>\n',
          line: 446,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'closeOnSelect',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to close the menu when a value is selected\n',
          description: '<p>Whether to close the menu when a value is selected</p>\n',
          line: 438,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'compareItemsWith',
          defaultValue: '(a, b) => a === b',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCompare the option values with the selected values.\nThe first argument is a value from an option.\nThe second is a value from the selection(model).\nA boolean should be returned.\n',
          description:
            '<p>Compare the option values with the selected values.\nThe first argument is a value from an option.\nThe second is a value from the selection(model).\nA boolean should be returned.</p>\n',
          line: 571,
          type: 'function',
          decorators: [],
        },
        {
          name: 'disabled',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDisabled attr for ng-select\n',
          description: '<p>Disabled attr for ng-select</p>\n',
          line: 356,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'disableScrollEnd',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf true then `scrollEnd` event should NOT be emitted\n',
          description: '<p>If true then <code>scrollEnd</code> event should NOT be emitted</p>\n',
          line: 462,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'dropdownPosition',
          defaultValue: "'bottom'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDropdown Position (bottom | top | auto)\n',
          description: '<p>Dropdown Position (bottom | top | auto)</p>\n',
          line: 458,
          type: 'string',
          decorators: [],
        },
        {
          name: 'filterItems',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFilter items.\n',
          description: '<p>Filter items.</p>\n',
          line: 470,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'forceError',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nAlways show an error border around account selector when enabled.\nThis allows programmatic toggling of the error state.\nIt returns a `{ forcedError: true }` validation which can be used to assign to an error message of your choosing.\n\nDo not use it together with `showError`.\n\nDefaults to `false`.\n',
          description:
            '<p>Always show an error border around account selector when enabled.\nThis allows programmatic toggling of the error state.\nIt returns a <code>{ forcedError: true }</code> validation which can be used to assign to an error message of your choosing.</p>\n<p>Do not use it together with <code>showError</code>.</p>\n<p>Defaults to <code>false</code>.</p>\n',
          line: 414,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'groupByFn',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllow to group items by key or function expression\n',
          description: '<p>Allow to group items by key or function expression</p>\n',
          line: 549,
          type: 'GroupByFunction',
          decorators: [],
        },
        {
          name: 'groupValueFn',
          defaultValue: '(_: string, children: any[]) => ({\n    name: _,\n    total: children.length,\n  })',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFunction expression to provide group value\n',
          description: '<p>Function expression to provide group value</p>\n',
          line: 553,
          type: '(_: string, children: {}) => { name: string; total: any; }',
          decorators: [],
        },
        {
          name: 'highlight',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nTurn on or turn off bbHighlight directive in child product items\n',
          description: '<p>Turn on or turn off bbHighlight directive in child product items</p>\n',
          line: 466,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'internalFiltering',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEnables NgSelect internal filtering functionality\n',
          description: '<p>Enables NgSelect internal filtering functionality</p>\n',
          line: 478,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isOpen',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nAllows manual control of dropdown opening and closing. `true` - won't close. `false` - won't open.\nDefaults to `undefined`.\n",
          description:
            '<p>Allows manual control of dropdown opening and closing. <code>true</code> - won&#39;t close. <code>false</code> - won&#39;t open.\nDefaults to <code>undefined</code>.</p>\n',
          line: 592,
          type: 'any',
          decorators: [],
        },
        {
          name: 'items',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n`AccountSelectorItems` array\n',
          description: '<p><code>AccountSelectorItems</code> array</p>\n',
          line: 341,
          type: 'AccountSelectorItem | AccountSelectorItem[]',
          decorators: [],
        },
        {
          name: 'loading',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nLoading state from the outside (async items loading)\n',
          description: '<p>Loading state from the outside (async items loading)</p>\n',
          line: 454,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'markFirst',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMarks first item as focused when opening/filtering.\n',
          description: '<p>Marks first item as focused when opening/filtering.</p>\n',
          line: 474,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'minTermLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMinimum term length to start a search. Should be used with typeahead\n',
          description: '<p>Minimum term length to start a search. Should be used with typeahead</p>\n',
          line: 503,
          type: 'number',
          decorators: [],
        },
        {
          name: 'moneyProtectionDisclaimerClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to disclamier of money protection\n',
          description: '<p>Allows to add classes to disclamier of money protection</p>\n',
          line: 602,
          type: 'string',
          decorators: [],
        },
        {
          name: 'multiple',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to select multiple items\n',
          description: '<p>Allows to select multiple items</p>\n',
          line: 434,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'notFoundText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nNot found text for ng-select\n',
          description: '<p>Not found text for ng-select</p>\n',
          line: 370,
          type: 'string',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nPlaceholder text\n',
          description: '<p>Placeholder text</p>\n',
          line: 450,
          type: 'string',
          decorators: [],
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted (you can hide or show specific numbers).\n',
          description:
            '<p>Configuration of how the product number should be formatted (you can hide or show specific numbers).</p>\n',
          line: 426,
          type: 'PaymentCardNumberFormat',
          decorators: [],
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEnable required validation for ng-select\n',
          description: '<p>Enable required validation for ng-select</p>\n',
          line: 495,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'searchable',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllow to search for value. Default from ng-select is `true`.\n',
          description: '<p>Allow to search for value. Default from ng-select is <code>true</code>.</p>\n',
          line: 442,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'searchFunc',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllow to apply custom search function\n',
          description: '<p>Allow to apply custom search function</p>\n',
          line: 535,
          type: 'Function',
          decorators: [],
        },
        {
          name: 'selectedItems',
          defaultValue: '[]',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSelected items\n',
          description: '<p>Selected items</p>\n',
          line: 430,
          type: 'AccountSelectorItem | AccountSelectorItem[]',
          decorators: [],
        },
        {
          name: 'showAvailableBalance',
          defaultValue: 'undefined',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 19114,
              end: 19136,
              kind: 327,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 19115,
                end: 19122,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'default',
              },
              comment: '<p>undefined</p>\n',
            },
          ],
          rawdescription:
            '\n\nProperty, that determines how balance details should be rendered.\n\nOptions for this property is described by `BalanceDetailsView` model:\n - `BalanceDetailsView.Booked` - only booked balance data is rendered, OOTB behavior;\n - `BalanceDetailsView.Available` - only available balance data is rendered;\n - `BalanceDetailsView.Ordinary` - available balance data is rendered as primary with label `Available`, booked balance as secondary with label `Balance`;\n - `BalanceDetailsView.Reverse ` - booked balance data is rendered as primary with label `Balance`, available balance as secondary with label `Available`.\n\nDefault value `undefined` is the same behavior as `BalanceDetailsView.Booked`\n\n',
          description:
            '<p>Property, that determines how balance details should be rendered.</p>\n<p>Options for this property is described by <code>BalanceDetailsView</code> model:</p>\n<ul>\n<li><code>BalanceDetailsView.Booked</code> - only booked balance data is rendered, OOTB behavior;</li>\n<li><code>BalanceDetailsView.Available</code> - only available balance data is rendered;</li>\n<li><code>BalanceDetailsView.Ordinary</code> - available balance data is rendered as primary with label <code>Available</code>, booked balance as secondary with label <code>Balance</code>;</li>\n<li><code>BalanceDetailsView.Reverse </code> - booked balance data is rendered as primary with label <code>Balance</code>, available balance as secondary with label <code>Available</code>.</li>\n</ul>\n<p>Default value <code>undefined</code> is the same behavior as <code>BalanceDetailsView.Booked</code></p>\n',
          line: 585,
          type: 'BalanceDetailsView',
          decorators: [],
        },
        {
          name: 'showBankBranchCode',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWill show the bank branch code. Defaults to false\n',
          description: '<p>Will show the bank branch code. Defaults to false</p>\n',
          line: 544,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showCurrencySymbol',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWill show currency Symbol in amount. Default value true\n',
          description: '<p>Will show currency Symbol in amount. Default value true</p>\n',
          line: 540,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showError',
          deprecated: true,
          deprecationMessage:
            'Deprecated in ui-ang@12. To be removed in ui-ang@14. Replace with `forceError`.\n\nShow the error border around account selector when enabled and certain conditions are fulfilled.\nUsed when error needs to be shown on submit or when it requires a programmatic trigger.\nDoes not trigger if set to true on initial render.\n\nRequires condition that\n- `required` is set to `true`\n- the model is invalid when given `[selectedItems]="new UntypedFormControl(undefined, Validator)"\n\nDo not use it together with `forceError`.',
          jsdoctags: [
            {
              pos: 12591,
              end: 13168,
              kind: 331,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 12592,
                end: 12602,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'deprecated',
              },
              comment:
                '<p>Deprecated in ui-ang@12. To be removed in ui-ang@14. Replace with <code>forceError</code>.</p>\n<p>Show the error border around account selector when enabled and certain conditions are fulfilled.\nUsed when error needs to be shown on submit or when it requires a programmatic trigger.\nDoes not trigger if set to true on initial render.</p>\n<p>Requires condition that</p>\n<ul>\n<li><code>required</code> is set to <code>true</code></li>\n<li>the model is invalid when given `[selectedItems]=&quot;new UntypedFormControl(undefined, Validator)&quot;</li>\n</ul>\n<p>Do not use it together with <code>forceError</code>.</p>\n',
            },
          ],
          line: 390,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showMoneyProtectionDisclaimer',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe flag to show money protection disclaimer.\nIn order to see disclaimer you will need to configure `BB_MONEY_PROTECTION_STATUS_CONFIG_TOKEN` to provide\ncomponent to render in disclaimer.\n',
          description:
            '<p>The flag to show money protection disclaimer.\nIn order to see disclaimer you will need to configure <code>BB_MONEY_PROTECTION_STATUS_CONFIG_TOKEN</code> to provide\ncomponent to render in disclaimer.</p>\n',
          line: 608,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 17869,
              end: 17907,
              kind: 341,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 17870,
                end: 17875,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>: <code>AccountSelectorSize</code></p>\n',
              name: {
                pos: 17876,
                end: 17880,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'size',
              },
              isNameFirst: true,
              isBracketed: false,
            },
          ],
          rawdescription: '\n\nSet account selector view size\n\n',
          description: '<p>Set account selector view size</p>\n',
          line: 562,
          type: 'AccountSelectorSize',
          decorators: [],
        },
        {
          name: 'typeahead',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nCustom autocomplete or advanced filter.\n',
          description: '<p>Custom autocomplete or advanced filter.</p>\n',
          line: 499,
          type: 'Subject<string>',
          decorators: [],
        },
        {
          name: 'typeToSearchText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet custom text when using Typeahead\n',
          description: '<p>Set custom text when using Typeahead</p>\n',
          line: 507,
          type: 'string',
          decorators: [],
        },
        {
          name: 'virtualScroll',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEnables virtual scrolling mechanism\n',
          description: '<p>Enables virtual scrolling mechanism</p>\n',
          line: 482,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmit event when account selector is blurred\n',
          description: '<p>Emit event when account selector is blurred</p>\n',
          line: 336,
          type: 'EventEmitter<void>',
        },
        {
          name: 'change',
          defaultValue: 'new EventEmitter<object | object[]>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEmitter when item is added to selected items or removed from selected items.\nWhen Multiple is true: Output is Items[]\nWhen Multuple is false: Output is Item\n',
          description:
            '<p>Emitter when item is added to selected items or removed from selected items.\nWhen Multiple is true: Output is Items[]\nWhen Multuple is false: Output is Item</p>\n',
          line: 324,
          type: 'EventEmitter<object | []>',
        },
        {
          name: 'clearSearch',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmitter when clear search\n',
          description: '<p>Emitter when clear search</p>\n',
          line: 306,
          type: 'EventEmitter<void>',
        },
        {
          name: 'filterChange',
          defaultValue: 'new EventEmitter<string>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmitter when filter value is changed\n',
          description: '<p>Emitter when filter value is changed</p>\n',
          line: 328,
          type: 'EventEmitter<string>',
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmit event when account selector is focused\n',
          description: '<p>Emit event when account selector is focused</p>\n',
          line: 332,
          type: 'EventEmitter<void>',
        },
        {
          name: 'remove',
          defaultValue: 'new EventEmitter<any>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmitter when item is removed\n',
          description: '<p>Emitter when item is removed</p>\n',
          line: 318,
          type: 'EventEmitter<any>',
        },
        {
          name: 'scroll',
          defaultValue: 'new EventEmitter<{ start: number; end: number }>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEmitter when scroll is triggered (will emmit scroll events if virtualScroll is enabled)\n',
          description:
            '<p>Emitter when scroll is triggered (will emmit scroll events if virtualScroll is enabled)</p>\n',
          line: 310,
          type: 'EventEmitter<literal type>',
        },
        {
          name: 'scrollToEnd',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmitter when scrollToEnd is triggered\n',
          description: '<p>Emitter when scrollToEnd is triggered</p>\n',
          line: 314,
          type: 'EventEmitter<void>',
        },
        {
          name: 'search',
          defaultValue: 'new EventEmitter<string>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmitter when search is performed. Outputs search term\n',
          description: '<p>Emitter when search is performed. Outputs search term</p>\n',
          line: 302,
          type: 'EventEmitter<string>',
        },
      ],
      methodsClass: [
        {
          name: 'focusEditableElement',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 863,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onArrowLeft',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nListens for the 'keydown.arrowLeft' event and focuses on the selectAllButton if the ngSelect is open.\n\nThis method is used to handle the left arrow key press event and focuses on the selectAllButton if the ngSelect dropdown is open.\n",
          description:
            '<p>Listens for the &#39;keydown.arrowLeft&#39; event and focuses on the selectAllButton if the ngSelect is open.</p>\n<p>This method is used to handle the left arrow key press event and focuses on the selectAllButton if the ngSelect dropdown is open.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.arrowLeft'",
            },
          ],
          modifierKind: [170],
          jsdoctags: [],
        },
        {
          name: 'onArrowRight',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 254,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nListens for the 'keydown.arrowRight' event and focuses on the unselectAllButton if the ngSelect is open.\nThis method is used to handle the right arrow key press event and focuses on the unselectAllButton if the ngSelect dropdown is open.\n",
          description:
            '<p>Listens for the &#39;keydown.arrowRight&#39; event and focuses on the unselectAllButton if the ngSelect is open.\nThis method is used to handle the right arrow key press event and focuses on the unselectAllButton if the ngSelect dropdown is open.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.arrowRight'",
            },
          ],
          modifierKind: [170],
        },
        {
          name: 'onArrowUpOrDown',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 283,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nListens to keydown events for the arrowUp and arrowDown keys.\nPerforms certain actions if either selectAllFocused or unselectAllFocused conditions are met.\nBlurs the corresponding buttons and focuses on various elements.\n',
          description:
            '<p>Listens to keydown events for the arrowUp and arrowDown keys.\nPerforms certain actions if either selectAllFocused or unselectAllFocused conditions are met.\nBlurs the corresponding buttons and focuses on various elements.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.arrowUp'",
            },
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.arrowDown'",
            },
          ],
          modifierKind: [170, 170],
        },
        {
          name: 'onBlur',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 750,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onChange',
          args: [
            {
              name: 'event',
              type: 'Event | any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 653,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'Event | any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onClear',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 634,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onClose',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 846,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onEnterKey',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 267,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nListens for the 'keydown.enter' event and performs actions based on the active element.\nThis method is used to handle the enter key press event and performs actions based on the active element.\nIf the active element is the selectAllButton, it calls the selectAll() method.\nIf the active element is the unselectAllButton, it calls the unselectAll() method.\n",
          description:
            '<p>Listens for the &#39;keydown.enter&#39; event and performs actions based on the active element.\nThis method is used to handle the enter key press event and performs actions based on the active element.\nIf the active element is the selectAllButton, it calls the selectAll() method.\nIf the active element is the unselectAllButton, it calls the unselectAll() method.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'keydown.enter'",
            },
          ],
          modifierKind: [170],
        },
        {
          name: 'onFilterChange',
          args: [
            {
              name: 'query',
              type: 'string | undefined',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 854,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'query',
              type: 'string | undefined',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onFocus',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 746,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onOpen',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 760,
          deprecated: true,
          deprecationMessage: 'Deprecated in ui-ang@12. To be marked as protected in ui-ang@14. No replacements.',
          rawdescription: '\n\n',
          description: '',
          jsdoctags: [],
        },
        {
          name: 'onRemove',
          args: [
            {
              name: 'event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 649,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onScroll',
          args: [
            {
              name: 'position',
              type: 'literal type',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 639,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'position',
              type: 'literal type',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onScrollToEnd',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 643,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onSearch',
          args: [
            {
              name: 'event',
              type: 'string | literal type',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 614,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'string | literal type',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'resetAccountSelectorModel',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 676,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'selectAll',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 666,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'unselectAll',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 671,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description:
        '<p>Component that provides a select, multiselect and auto complete feature.</p>\n<h3>Custom templates</h3>\n<p>AccountSelectorComponent allows providing optional custom templates for the different parts of its view. Below is\nan example of what a component with all custom templates migh look like:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&lt;bb-account-selector-ui\n  #accountSelector\n  [items]=&quot;items&quot;\n  [selectedItems]=&quot;selectedItems&quot;\n  [required]=&quot;required&quot;\n  [showError]=&quot;showError&quot;\n&gt;\n  &lt;ng-template bbCustomSingleSelectedItemLabel let-item=&quot;item&quot;&gt; &lt;/ng-template&gt;\n  &lt;ng-template bbCustomMultiSelectedItemsLabel let-items=&quot;items&quot;&gt; &lt;/ng-template&gt;\n  &lt;ng-template bbCustomOptionItem let-item=&quot;item&quot; let-item$=&quot;item$&quot; let-index=&quot;index&quot;&gt; &lt;/ng-template&gt;\n  &lt;ng-template bbCustomOptionsHeader&gt; &lt;/ng-template&gt;\n  &lt;ng-template bbCustomGroupItemsHeader let-item=&quot;item&quot;&gt; &lt;/ng-template&gt;\n  &lt;ng-template bbCustomLoadingTemplate&gt; &lt;/ng-template&gt;\n&lt;/bb-account-selector-ui&gt;</code></pre></div><p>By default <code>items</code> input property has the type <code>any</code> to allow any types of items when\nproviding custom item template. If a custom template for items is not provided then <code>items</code>\ninternally matches the type <code>AccountSelectorDefaultItem[]</code>, which could be imported\nfrom <code>@backbase/ui-ang/account-selector</code></p>\n<h3>Money Protection</h3>\n<p><code>moneyProtectionStatus</code> and <code>moneyProtectionStatusClasses</code> Input are used for setting the Status for\n<code>bb-product-item-basic-account-ui</code> component via <code>items</code> input property.</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">items: [{\n     id: &#39;1&#39;,\n     name: &#39;Mrs J. Smith&#39;,\n     availableBalance: 5234.7,\n     balance: 102.1,\n     number: &#39;GB29NWBK60161331926819&#39;,\n     currency: &#39;EUR&#39;,\n     favorite: true,\n     status: &#39;inactive&#39;,\n     bankBranchCode: &#39;01788902&#39;,\n     moneyProtectionStatus: MoneyProtectionStatusEnum.Yes,\n     moneyProtectionStatusClasses: &#39;bg-danger-subtle&#39;,\n }]</code></pre></div><h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>aria-describedby will be linked to the account selector component, dropdown list and search box</li>\n<li>aria-invalid will be linked to the search box</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'AccountSelectorExampleComponent',
      selector: 'bb-account-selector-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onChange',
          args: [
            {
              name: '$event',
              type: 'AccountData | AccountData[]',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 14,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'AccountData | AccountData[]',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onClearSearch',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 28,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onScrollToEnd',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 32,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onSearch',
          args: [
            {
              name: '$event',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 24,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { AccountData } from './account-selector.example.model';\nimport { accounts } from './accounts';\n\n@Component({\n  selector: 'bb-account-selector-example-ui',\n  templateUrl: './account-selector.example.component.html',\n  standalone: false,\n})\nexport class AccountSelectorExampleComponent {\n  items: AccountData[] = accounts;\n  selectedItems: AccountData | AccountData[] = this.items[0];\n\n  onChange($event: AccountData | AccountData[]) {\n    const count = Array.isArray($event)\n      ? $event.length\n      : $event\n        ? 1\n        : 0;\n\n    console.log(`${count} items selected`);\n  }\n\n  onSearch($event: string) {\n    console.log(`Search for query: ${$event}`);\n  }\n\n  onClearSearch() {\n    console.log('Search cleared');\n  }\n\n  onScrollToEnd() {\n    console.log('Scrolled to end');\n  }\n}\n",
      template:
        '<h2 id="ariaLabelledById">Account Selector</h2>\n<div id="ariaDescribedById">\n  Account selector Component that supports single select, multi select\n  and auto complete\n</div>\n<bb-account-selector-ui\n  [items]="items"\n  [disableScrollEnd]="false"\n  [multiple]="true"\n  [closeOnSelect]="true"\n  [filterItems]="true"\n  [selectedItems]="selectedItems"\n  [dropdownPosition]="\'bottom\'"\n  (change)="onChange($event)"\n  (clearSearch)="onClearSearch()"\n  (scrollToEnd)="onScrollToEnd()"\n  (search)="onSearch($event)"\n  placeholder="Select Accounts"\n  [aria-describedby]="\'ariaDescribedById\'"\n>\n</bb-account-selector-ui>\n',
    },
    {
      name: 'ActionStatusComponent',
      selector: 'bb-action-status-ui',
      inputsClass: [
        {
          name: 'state',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe current state of the action.\n',
          description: '<p>The current state of the action.</p>\n',
          line: 20,
          type: 'ActionState',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'getColor',
          args: [],
          optional: false,
          returnType: 'string | undefined',
          typeParameters: [],
          line: 26,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'isLoading',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 22,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '<p>Component that displays a loading indicator or icon to indicate an action response.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ActionStatusExampleComponent',
      selector: 'bb-action-status-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { ActionState } from '@backbase/ui-ang/action-status';\n\n@Component({\n  selector: 'bb-action-status-example-ui',\n  templateUrl: './action-status.example.component.html',\n  standalone: false,\n})\nexport class ActionStatusExampleComponent {\n  actionState: ActionState = 'success';\n}\n",
      template: '<bb-action-status-ui [state]="actionState"></bb-action-status-ui>\n',
    },
    {
      name: 'AlertComponent',
      selector: 'bb-alert-ui',
      inputsClass: [
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the button in the alert is focused on initial load. Defaults to false.\n',
          description: '<p>Whether the button in the alert is focused on initial load. Defaults to false.</p>\n',
          line: 55,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'closeButtonAriaLabel',
          defaultValue: "'Close alert'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAria label for a "close" button\n',
          description: '<p>Aria label for a &quot;close&quot; button</p>\n',
          line: 80,
          type: 'string',
          decorators: [],
        },
        {
          name: 'dismissible',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the alert can be dismissed. Defaults to false.\n',
          description: '<p>Whether the alert can be dismissed. Defaults to false.</p>\n',
          line: 51,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'message',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe message of the alert.\nIf nothing provided, wouldn't be displayed.\nIt is internally linked with aria-describedby.\n",
          description:
            '<p>The message of the alert.\nIf nothing provided, wouldn&#39;t be displayed.\nIt is internally linked with aria-describedby.</p>\n',
          line: 67,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'modifier',
          defaultValue: "'error'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe type modifier for the alert. Defaults to 'error'.\n",
          description: '<p>The type modifier for the alert. Defaults to &#39;error&#39;.</p>\n',
          line: 47,
          type: 'AlertType',
          decorators: [],
        },
        {
          name: 'primaryActionButtonText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe title of the primary action button.\n',
          description: '<p>The title of the primary action button.</p>\n',
          line: 71,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'supportiveLinkText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe title of the supportive link button.\n',
          description: '<p>The title of the supportive link button.</p>\n',
          line: 75,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe title of the alert.\nWill throw an error if unset.\nIt is internaly linked with aria-labelledby.\n',
          description:
            '<p>The title of the alert.\nWill throw an error if unset.\nIt is internaly linked with aria-labelledby.</p>\n',
          line: 61,
          type: 'string | undefined',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'close',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe callback fired upon closing the alert.\n',
          description: '<p>The callback fired upon closing the alert.</p>\n',
          line: 85,
          type: 'EventEmitter',
        },
        {
          name: 'primaryActionButtonClick',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe callback fired upon clicking primary action button.\n',
          description: '<p>The callback fired upon clicking primary action button.</p>\n',
          line: 89,
          type: 'EventEmitter',
        },
        {
          name: 'supportiveLinkClick',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe callback fired upon clicking supportive link button.\n',
          description: '<p>The callback fired upon clicking supportive link button.</p>\n',
          line: 93,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'closeAlert',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 140,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description:
        '<p>Component that displays an alert.</p>\n<h3>Accessibility</h3>\n<p>For Alert component it&#39;s not required to pass any options for accessibility.\nIt internally handles accessibility for title and message:</p>\n<ul>\n<li>title is linked with aria-labelledby.</li>\n<li>message is linked with aria-describedby.</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'AlertExampleComponent',
      selector: 'bb-alert-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'displayAlert',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 80,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'hideAlert',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 70,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { ConfigurationInputService } from '../../configuration/configuration-input.service';\n\nconst MILLISECONDS_PER_SECOND = 1000;\n\n@Component({\n  selector: 'bb-alert-example-ui',\n  templateUrl: './alert.example.component.html',\n  standalone: false,\n})\nexport class AlertExampleComponent {\n  restoreDelay = 5;\n  showAlert = true;\n\n  alertCheckoxList = [\n    {\n      label: 'Dismissible',\n      value: true,\n      formControlName: 'dismissible',\n    },\n  ];\n\n  alertDropdownList = [\n    {\n      label: 'Modifier',\n      formControlName: 'modifier',\n      dropdownItemList: ['info', 'warning', 'success', 'error'],\n    },\n  ];\n\n  alertInputList = [\n    {\n      label: 'Primary action button text',\n      formControlName: 'primaryActionButtonText',\n    },\n    {\n      label: 'Supportive link text',\n      formControlName: 'supportiveLinkText',\n    },\n  ];\n\n  alertValues = {\n    checkbox: {\n      dismissible: true,\n    },\n    dropdown: {\n      modifier: 'primary',\n    },\n    input: {\n      primaryActionButtonText: '',\n      supportiveLinkText: '',\n    },\n  };\n  constructor(\n    private readonly configurationService: ConfigurationInputService,\n  ) {\n    this.configurationService.sharedField.subscribe({\n      next: (val: any) => {\n        this.alertValues.checkbox.dismissible =\n          val.checkbox.dismissible;\n        this.alertValues.dropdown.modifier = val.dropdown.modifier;\n        this.alertValues.input.primaryActionButtonText =\n          val.input.primaryActionButtonText;\n        this.alertValues.input.supportiveLinkText =\n          val.input.supportiveLinkText;\n      },\n    });\n  }\n\n  hideAlert() {\n    this.showAlert = false;\n\n    // Restore alert after 5 seconds for demo purposes\n    setTimeout(\n      () => this.displayAlert(),\n      this.restoreDelay * MILLISECONDS_PER_SECOND,\n    );\n  }\n\n  displayAlert() {\n    this.showAlert = true;\n  }\n}\n",
      template:
        '<div class="example-ui">\n  <div class="example-ui__component-col">\n    @if (showAlert) {\n      <bb-alert-ui\n        title="Example information alert"\n        [modifier]="alertValues.dropdown.modifier"\n        [dismissible]="alertValues.checkbox.dismissible"\n        [primaryActionButtonText]="\n          alertValues.input.primaryActionButtonText\n        "\n        [supportiveLinkText]="alertValues.input.supportiveLinkText"\n        (close)="hideAlert()"\n      >\n        <span>\n          This example will be restored after\n          {{ restoreDelay }} seconds.\n        </span>\n      </bb-alert-ui>\n    }\n  </div>\n  <div class="example-ui__configuration-col">\n    <bb-configuration-input-ui\n      [checkboxList]="alertCheckoxList"\n      [dropdownList]="alertDropdownList"\n      [inputList]="alertInputList"\n    ></bb-configuration-input-ui>\n  </div>\n</div>\n',
    },
    {
      name: 'AmountComponent',
      selector: 'bb-amount-ui',
      inputsClass: [
        {
          name: 'abbreviate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether abbreviation should be applied.\nDefault value false.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>Whether abbreviation should be applied.\nDefault value false.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 173,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nReceive amount in number or string format and converts into a floating-point number.\n\nDoes not support comma separated numbers unless used with `DecimalPipe`.\nLocale is infer from `LOCALE_ID` and does not support any locales that is different from the app's `LOCALE_ID`.\n",
          description:
            '<p>Receive amount in number or string format and converts into a floating-point number.</p>\n<p>Does not support comma separated numbers unless used with <code>DecimalPipe</code>.\nLocale is infer from <code>LOCALE_ID</code> and does not support any locales that is different from the app&#39;s <code>LOCALE_ID</code>.</p>\n',
          line: 241,
          type: 'string | number',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nDetermines currency type.\nIf nothing provided, wouldn't be displayed.\n\nThis attribute can be overwritten via the global configuration token.\n",
          description:
            '<p>Determines currency type.\nIf nothing provided, wouldn&#39;t be displayed.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 106,
          type: 'string',
          decorators: [],
        },
        {
          name: 'currencyFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nWhether to display wide or narrow currency format.\nDefault value 'wide'.\n",
          description: '<p>Whether to display wide or narrow currency format.\nDefault value &#39;wide&#39;.</p>\n',
          line: 120,
          type: 'CurrencyFormat',
          decorators: [],
        },
        {
          name: 'decimalPlaces',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nOverrides amount of decimals places to display.\nDefault value undefined, which will use currency default amount of decimals.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>Overrides amount of decimals places to display.\nDefault value undefined, which will use currency default amount of decimals.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 189,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'hideCurrencySymbol',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIf "true" currency will be hidden\nCan be used to display amounts without currency but still format them according to the currency\n(for example number of decimal points and groups symbol is based on a currency)\n\nDefault value false.\n',
          description:
            '<p>If &quot;true&quot; currency will be hidden\nCan be used to display amounts without currency but still format them according to the currency\n(for example number of decimal points and groups symbol is based on a currency)</p>\n<p>Default value false.</p>\n',
          line: 136,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'mapCurrency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether currency local should be transformed to symbol.\nDefault value from injection token (if provided), else true.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>Whether currency local should be transformed to symbol.\nDefault value from injection token (if provided), else true.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 151,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showPercent',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether percent symbol should be shown.\nDefault value false.\n',
          description: '<p>Whether percent symbol should be shown.\nDefault value false.</p>\n',
          line: 164,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showPlusSign',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIf "true" and amount is positive adds plus sign at the beginning.\nDefault value false.\n',
          description:
            '<p>If &quot;true&quot; and amount is positive adds plus sign at the beginning.\nDefault value false.</p>\n',
          line: 142,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'signPosition',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nPosition of the sign, whether it is before or after the currency symbol.\nOnly applies to negative numbers.\n"left" renders the sign before the currency.\n"right" renders the sign after the currency.\nDefault to "left".\n\nApplied only for LTR locales.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>Position of the sign, whether it is before or after the currency symbol.\nOnly applies to negative numbers.\n&quot;left&quot; renders the sign before the currency.\n&quot;right&quot; renders the sign after the currency.\nDefault to &quot;left&quot;.</p>\n<p>Applied only for LTR locales.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 226,
          type: 'Required<>',
          decorators: [],
        },
        {
          name: 'trailingZeroes',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether to display trailing zeroes.\nDefault value true.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>Whether to display trailing zeroes.\nDefault value true.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 205,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description:
        '<p>Component to enable the amount to be represented in the currency format.\n<br><br></p>\n<h3>Locale token</h3>\n<p><code>LOCALE_ID</code> enables you to globally set the same locale for all instances of <code>AmountComponent</code> in your project.\nRefer to <a href="https://angular.io/api/core/LOCALE_ID">https://angular.io/api/core/LOCALE_ID</a> for more information.\n<br><br></p>\n<h3>Global configuration token</h3>\n<p><code>AMOUNT_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>AmountComponent</code> in your project.</p>\n<p><em>Note:</em> The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not be able to overwrite it.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>abbreviate</code></li>\n<li><code>currency</code></li>\n<li><code>decimalPlaces</code></li>\n<li><code>mapCurrency</code></li>\n<li><code>trailingZeroes</code></li>\n<li><code>currencyFormat</code></li>\n<li><code>signPosition</code></li>\n</ul>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">import { AMOUNT_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/amount&#39;;\nimport { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\nimport { AppModule } from &#39;./app/app.module&#39;;\n\nconst amountConfig = {\n  abbreviate: true\n}\n\nplatformBrowserDynamic().bootstrapModule(AppModule, {\n  providers: [{ provide: AMOUNT_CONFIG_TOKEN, useValue: amountConfig }]\n});</code></pre></div><p>The amount component doesn&#39;t provide any specific properties for accessibility. But handles accessibility internally.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'AmountExampleComponent',
      selector: 'bb-amount-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-amount-example-ui',\n  templateUrl: './amount.example.component.html',\n  standalone: false,\n})\nexport class AmountExampleComponent {}\n",
      template:
        '<bb-amount-ui\n  [currency]="\'USD\'"\n  [amount]="2718281828"\n  [mapCurrency]="true"\n  [showPlusSign]="false"\n  [abbreviate]="false"\n></bb-amount-ui>\n',
    },
    {
      name: 'AmountInputComponent',
      selector: 'bb-amount-input-ui',
      inputsClass: [
        {
          name: 'autoDecimal',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to automatically add decimal places to the input value. Defaults to `false`.\n',
          description:
            '<p>Whether to automatically add decimal places to the input value. Defaults to <code>false</code>.</p>\n',
          line: 113,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDisplays currency either as currency symbol or value, if provided.\n',
          description: '<p>Displays currency either as currency symbol or value, if provided.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'isDotDecimalSeparator',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nFlag to use dot(.) symbol as a decimal separator for the amount value provided to the component.\nDefault value is false which means it expect a locale based decimal separator\n',
          description:
            '<p>Flag to use dot(.) symbol as a decimal separator for the amount value provided to the component.\nDefault value is false which means it expect a locale based decimal separator</p>\n',
          line: 118,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'mapCurrency',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether currency local should be transformed to symbol.\nDefault value true.\n',
          description: '<p>Whether currency local should be transformed to symbol.\nDefault value true.</p>\n',
          line: 91,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maxLength for the text input.\n',
          description: '<p>The maxLength for the text input.</p>\n',
          line: 82,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the text input. Defaults to an empty string.\n',
          description: '<p>The placeholder for the text input. Defaults to an empty string.</p>\n',
          line: 78,
          type: 'string',
          decorators: [],
        },
        {
          name: 'swapCurrencyAndValue',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether we swap places for the currency and value for the input field.\nThe default value is false.\nIf true, the currency will appear on the right and the value on the left of the input field.\n',
          description:
            '<p>Whether we swap places for the currency and value for the input field.\nThe default value is false.\nIf true, the currency will appear on the right and the value on the left of the input field.</p>\n',
          line: 128,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'textHint',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nProvided to add a text hint for the input field.\n',
          description: '<p>Provided to add a text hint for the input field.</p>\n',
          line: 122,
          type: 'string',
          decorators: [],
        },
        {
          name: 'wrapperClasses',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nclassnames for the wrapper div\n',
          description: '<p>classnames for the wrapper div</p>\n',
          line: 86,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'correctInputValue',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 202,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onBackspace',
          args: [
            {
              name: 'el',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 217,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for backspace key press, and check if correct number is deleted\n\n',
          description: '<p>Event handler for backspace key press, and check if correct number is deleted</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 6964,
                end: 6966,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'el',
              },
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 6958,
                end: 6963,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<ul>\n<li>The HTML input element.</li>\n</ul>\n',
            },
          ],
        },
        {
          name: 'onInput',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 242,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onPress',
          args: [
            {
              name: '$event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 223,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'model',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 151,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'model',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>set aria-describedby with ID of another element in the DOM with descriptive text about the amount input,\nby default it is set to div defining the type of currency</li>\n<li>set aria-invalid with boolean value when the entered input value is not valid</li>\n<li>set aria-labelledby with ID of another element in the DOM as input&#39;s label</li>\n</ul>\n<p>Component that displays a text input.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'AmountInputExampleComponent',
      selector: 'bb-amount-input-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-amount-input-example-ui',\n  templateUrl: './amount-input.example.component.html',\n  standalone: false,\n})\nexport class AmountInputExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    name: ['', Validators.required],\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <h2 id="ariaLabelledbyId">Amount with regular size</h2>\n  <bb-amount-input-ui\n    formControlName="name"\n    [id]="\'billpay-amount-input\'"\n    currency="USD"\n    placeholder="0.00"\n    [aria-labelledby]="\'ariaLabelledbyId\'"\n  >\n  </bb-amount-input-ui>\n</form>\n',
    },
    {
      name: 'AvatarComponent',
      selector: 'bb-avatar-ui',
      inputsClass: [
        {
          name: 'image',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe image  of the avatar. Defaults to empty string.\n',
          description: '<p>The image  of the avatar. Defaults to empty string.</p>\n',
          line: 42,
          type: 'string',
          decorators: [],
        },
        {
          name: 'imgAlt',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe imgAlt for provide alt in img of the avatar. Defaults to empty string.\n',
          description: '<p>The imgAlt for provide alt in img of the avatar. Defaults to empty string.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
        },
        {
          required: false,
          name: 'initials',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nInitials to be displayed. If not provided, initials will be derived from the name input. Supports on up to two characters.\n',
          description:
            '<p>Initials to be displayed. If not provided, initials will be derived from the name input. Supports on up to two characters.</p>\n',
          line: 58,
          type: 'string',
          decorators: [],
        },
        {
          name: 'name',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe name  of the avatar. Defaults to empty string.\n',
          description: '<p>The name  of the avatar. Defaults to empty string.</p>\n',
          line: 46,
          type: 'string',
          decorators: [],
        },
        {
          name: 'size',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSize of the avatar. Possible values sm | md | lg | xl. Defaults to empty string.\n',
          description: '<p>Size of the avatar. Possible values sm | md | lg | xl. Defaults to empty string.</p>\n',
          line: 54,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description:
        '<p>Component that displays an avatar.</p>\n<h3>Global configuration token</h3>\n<p><code>AVATAR_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>AvatarComponent</code> in your project.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>initialsFn</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none">import { AVATAR_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/avatar&#39;;\nimport { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\nimport { AppModule } from &#39;./app/app.module&#39;;\n\nconst avatarConfig = {\ninitialsFn: (text) =&gt; `${text[0]}${text[1]}`\n}\n\nplatformBrowserDynamic().bootstrapModule(AppModule, {\nproviders: [{ provide: AVATAR_CONFIG_TOKEN, useValue: avatarConfig }]\n});</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'AvatarExampleComponent',
      selector: 'bb-avatar-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-avatar-example-ui',\n  templateUrl: './avatar.example.component.html',\n  standalone: false,\n})\nexport class AvatarExampleComponent {}\n",
      template: '<bb-avatar-ui name="Jane Doe" size="lg"></bb-avatar-ui>\n',
    },
    {
      name: 'BadgeComponent',
      selector: 'bb-badge-ui',
      inputsClass: [
        {
          name: 'abbr',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe abbreviation to show when using circle styling.\n',
          description: '<p>The abbreviation to show when using circle styling.</p>\n',
          line: 28,
          type: 'string | boolean',
          decorators: [],
        },
        {
          name: 'ariaLabel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 40,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'breakWord',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text break class will be applied (adjusting to the parent box width)\n',
          description: '<p>Whether the text break class will be applied (adjusting to the parent box width)</p>\n',
          line: 44,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'circle',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether circle styling should be applied.\n',
          description: '<p>Whether circle styling should be applied.</p>\n',
          line: 32,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'color',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe (background) color of the badge.  Defaults to 'primary'.\n",
          description: '<p>The (background) color of the badge.  Defaults to &#39;primary&#39;.</p>\n',
          line: 20,
          type: 'BadgeColor | string',
          decorators: [],
        },
        {
          name: 'text',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe text to display in the badge.\n',
          description: '<p>The text to display in the badge.</p>\n',
          line: 24,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'wrap',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether text wrap styling should be applied.\n',
          description: '<p>Whether text wrap styling should be applied.</p>\n',
          line: 36,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that displays a badge.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'BadgeCounterComponent',
      selector: 'bb-badge-counter-ui',
      inputsClass: [
        {
          name: 'color',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe (background) color of the badge. Defaults to 'primary'.\n",
          description: '<p>The (background) color of the badge. Defaults to &#39;primary&#39;.</p>\n',
          line: 19,
          type: 'BadgeColor',
          decorators: [],
        },
        {
          name: 'count',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe count to show in the badge. Defaults to 0 and badge will be hidden if count equals 0.\n',
          description:
            '<p>The count to show in the badge. Defaults to 0 and badge will be hidden if count equals 0.</p>\n',
          line: 23,
          type: 'number',
          decorators: [],
        },
        {
          name: 'maxCount',
          defaultValue: '999',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe max count value to limit text inside badge. Defaults to 999.\n',
          description: '<p>The max count value to limit text inside badge. Defaults to 999.</p>\n',
          line: 27,
          type: 'number',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that displays a counter badge.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'BadgeCounterExampleComponent',
      selector: 'bb-badge-counter-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-badge-counter-example-ui',\n  templateUrl: './badge-counter.example.component.html',\n  standalone: false,\n})\nexport class BadgeCounterExampleComponent {}\n",
      template: '<bb-badge-counter-ui\n  [count]="136"\n  [maxCount]="99"\n  color="danger"\n></bb-badge-counter-ui>\n',
    },
    {
      name: 'BadgeExampleComponent',
      selector: 'bb-badge-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-badge-example-ui',\n  templateUrl: './badge.example.component.html',\n  standalone: false,\n})\nexport class BadgeExampleComponent {}\n",
      template:
        '<bb-badge-ui\n  text="paid in full"\n  color="success"\n  [abbr]="false"\n  [circle]="false"\n></bb-badge-ui>\n',
    },
    {
      name: 'ButtonExampleComponent',
      selector: 'bb-button-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n//Don't include buttonService while developing this component.\nimport { ButtonExampleService } from './button.example.service';\n\n@Component({\n  selector: 'bb-button-example-ui',\n  templateUrl: './button.example.component.html',\n  standalone: false,\n})\nexport class ButtonExampleComponent {\n  //Don't include buttonService while developing this component.\n  constructor(public readonly buttonService: ButtonExampleService) {}\n}\n",
      template:
        '<div class="example-ui">\n  <div class="example-ui__component-col">\n    <button\n      bbButton\n      [color]="buttonService.btnValues.dropdown.color"\n      [buttonSize]="buttonService.btnValues.radio.buttonSize"\n      [disabled]="buttonService.btnValues.checkbox.disabled"\n      [block]="buttonService.btnValues.checkbox.block"\n      class="m-2"\n    >\n      {{ buttonService.btnValues.dropdown.color | titlecase }}\n    </button>\n  </div>\n  <div class="example-ui__configuration-col">\n    <bb-configuration-input-ui\n      [checkboxList]="buttonService.btnCheckboxList"\n      [radioList]="buttonService.btnRadioList"\n      [dropdownList]="buttonService.btnDropdownList"\n    ></bb-configuration-input-ui>\n  </div>\n</div>\n',
    },
    {
      name: 'CardVendorComponent',
      selector: 'bb-card-vendor-ui',
      inputsClass: [
        {
          name: 'vendor',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe vendor that this component displays the logo of.  Mandatory.\n',
          description: '<p>The vendor that this component displays the logo of.  Mandatory.</p>\n',
          line: 34,
          type: 'string | undefined',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that displays the logo of a card vendor.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CardVendorExampleComponent',
      selector: 'bb-card-vendor-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-card-vendor-example-ui',\n  templateUrl: './card-vendor.example.component.html',\n  standalone: false,\n})\nexport class CardVendorExampleComponent {}\n",
      template:
        '<div style="max-width: 48px; max-height: 48px">\n  <bb-card-vendor-ui vendor="mastercard"></bb-card-vendor-ui>\n</div>\n',
    },
    {
      name: 'CharCounterComponent',
      selector: 'bb-char-counter-ui',
      inputsClass: [
        {
          name: 'blockTyping',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the element should be blocked when maximum character count is reached.\n',
          description: '<p>Whether the element should be blocked when maximum character count is reached.</p>\n',
          line: 36,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'element',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe element reference which the characters are typed in.\n',
          description: '<p>The element reference which the characters are typed in.</p>\n',
          line: 23,
          type: 'HTMLInputElement | HTMLTextAreaElement | undefined',
          decorators: [],
        },
        {
          name: 'inputValue',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nPassed value from parent input, it gives option to count\nchar event if value was programmatically changed\n',
          description:
            '<p>Passed value from parent input, it gives option to count\nchar event if value was programmatically changed</p>\n',
          line: 19,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'limitExceededText',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nAdditional text to display when when maximum character count has been exceeded.\nDefaults to `''`.\n",
          description:
            '<p>Additional text to display when when maximum character count has been exceeded.\nDefaults to <code>&#39;&#39;</code>.</p>\n',
          line: 32,
          type: 'string',
          decorators: [],
        },
        {
          name: 'maxLength',
          defaultValue: '150',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIndicator for maximum character count.\n',
          description: '<p>Indicator for maximum character count.</p>\n',
          line: 27,
          type: 'number',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'calculateElementValue',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 79,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '<p>Component for counting characters typed inside a form element</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CharCounterExampleComponent',
      selector: 'bb-char-counter-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-char-counter-example-ui',\n  templateUrl: './char-counter.example.component.html',\n  standalone: false,\n})\nexport class CharCounterExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    textarea: ['', Validators.maxLength(160)],\n  });\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <p>\n    <textarea\n      placeholder="Enter text..."\n      formControlName="textarea"\n      maxLength="160"\n      rows="4"\n      #remarksInput\n    >\n    </textarea>\n  </p>\n  <p>\n    <bb-char-counter-ui\n      [element]="remarksInput"\n      [maxLength]="remarksInput.maxLength"\n      [blockTyping]="true"\n    ></bb-char-counter-ui>\n  </p>\n</form>\n',
    },
    {
      name: 'CheckboxGroupComponent',
      selector: 'bb-checkbox-group-ui',
      inputsClass: [
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'isDisabled',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 109,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nReturns a boolean indicating whether the component is disabled.\n\n',
          description: '<p>Returns a boolean indicating whether the component is disabled.</p>\n',
          jsdoctags: [
            {
              tagName: {
                pos: 3136,
                end: 3143,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'returns',
              },
              comment: '<p>A boolean indicating whether the component is disabled.</p>\n',
            },
          ],
        },
        {
          name: 'onValueChange',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 87,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCalled when the value of the component changes.\n\n - Updates the value of the control and sets the skip$ behavior subject to avoid infinite loops.\n',
          description:
            '<p>Called when the value of the component changes.</p>\n<ul>\n<li>Updates the value of the control and sets the skip$ behavior subject to avoid infinite loops.</li>\n</ul>\n',
          jsdoctags: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Stores a state, determines it and displays a parent checkbox for a checkboxes group.\nRequired module(s): FormsModule</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CheckboxGroupExampleComponent',
      selector: 'bb-checkbox-group-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-checkbox-group-example-ui',\n  templateUrl: './checkbox-group-example.component.html',\n  standalone: false,\n})\nexport class CheckboxGroupExampleComponent {}\n",
      template:
        '<h5>Checkboxes group</h5>\n<h6>Template driven example</h6>\n<div class="form-row">\n  <div class="col-md-4">\n    <form #checkboxGroupForm="ngForm">\n      <ul class="list-unstyled">\n        <li>\n          <bb-checkbox-group-ui ngModelGroup="list" label="Parent"> </bb-checkbox-group-ui>\n          <ul ngModelGroup="list" class="list-unstyled bb-checkbox-group">\n            <li>\n              <bb-input-checkbox-ui name="i1" ngModel disabled label="Child"> </bb-input-checkbox-ui>\n            </li>\n            <li>\n              <bb-input-checkbox-ui name="i2" ngModel label="Child"> </bb-input-checkbox-ui>\n            </li>\n            <li>\n              <bb-checkbox-group-ui ngModelGroup="i3" label="Parent"> </bb-checkbox-group-ui>\n              <ul ngModelGroup="i3" class="list-unstyled bb-checkbox-group">\n                <li>\n                  <bb-input-checkbox-ui ngModel name="q1" label="Child"> </bb-input-checkbox-ui>\n                </li>\n                <li>\n                  <bb-input-checkbox-ui ngModel name="q2" label="Child"> </bb-input-checkbox-ui>\n                </li>\n                <li>\n                  <bb-checkbox-group-ui ngModelGroup="q3" label="Parent"> </bb-checkbox-group-ui>\n                  <ul ngModelGroup="q3" class="list-unstyled bb-checkbox-group">\n                    <li>\n                      <bb-input-checkbox-ui ngModel name="w1" label="Child"> </bb-input-checkbox-ui>\n                    </li>\n                    <li>\n                      <bb-input-checkbox-ui ngModel name="w2" label="Child"> </bb-input-checkbox-ui>\n                    </li>\n                  </ul>\n                </li>\n              </ul>\n            </li>\n          </ul>\n        </li>\n      </ul>\n    </form>\n  </div>\n  <div class="col-md-8">{{ checkboxGroupForm.form.value | json }}</div>\n</div>\n',
    },
    {
      name: 'ChipComponent',
      selector: 'bb-chip-ui',
      inputsClass: [
        {
          name: 'dismissible',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDefines if a dismiss button is displayed on chip\n',
          description: '<p>Defines if a dismiss button is displayed on chip</p>\n',
          line: 23,
          type: 'boolean',
          decorators: [],
        },
        {
          required: true,
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          optional: false,
          rawdescription: '\n\nChip label\n',
          description: '<p>Chip label</p>\n',
          line: 19,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'close',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits when the chip dismiss button is clicked\n',
          description: '<p>Emits when the chip dismiss button is clicked</p>\n',
          line: 27,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [],
      description: '<p>Component that displays a chip with optional action button</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CollapsibleAccordionComponent',
      selector: 'bb-collapsible-accordion-ui',
      inputsClass: [
        {
          name: 'closeOthers',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAssures that only one Collapsible panel can be opened at a time.\n',
          description: '<p>Assures that only one Collapsible panel can be opened at a time.</p>\n',
          line: 26,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'obeyParentAccordion',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhen true the Accordion will inherit the parent Accordion behaviour.\n',
          description: '<p>When true the Accordion will inherit the parent Accordion behaviour.</p>\n',
          line: 35,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'openFirst',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhen true displays the first panel on load.\n',
          description: '<p>When true displays the first panel on load.</p>\n',
          line: 30,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'collapseAll',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 91,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'expandAll',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 83,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'registerNestedAccordion',
          args: [
            {
              name: 'childAccordion',
              type: 'CollapsibleAccordionComponent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 60,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'childAccordion',
              type: 'CollapsibleAccordionComponent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'registerNestedPanel',
          args: [
            {
              name: 'panel',
              type: 'ICollapsible',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 68,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'panel',
              type: 'ICollapsible',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'unregisterNestedAccordion',
          args: [
            {
              name: 'childAccordion',
              type: 'CollapsibleAccordionComponent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 64,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'childAccordion',
              type: 'CollapsibleAccordionComponent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'unregisterNestedPanel',
          args: [
            {
              name: 'panel',
              type: 'ICollapsible',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 75,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'panel',
              type: 'ICollapsible',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description:
        '<p>Component that groups Collapsible components to show them in an accordion fashion.\nIt can assure that only one Collapsible panel can be opened at a time.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CollapsibleAccordionExampleComponent',
      selector: 'bb-collapsible-accordion-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-collapsible-accordion-example-ui',\n  templateUrl: './collapsible-accordion.example.component.html',\n  standalone: false,\n})\nexport class CollapsibleAccordionExampleComponent {}\n",
      template:
        '<bb-collapsible-accordion-ui [closeOthers]="true" [openFirst]="true">\n  <bb-collapsible-card-ui>\n    <div bbCollapsibleTitle>Panel #1</div>\n    <div bbCollapsibleBody>\n      The first panel is expanded automatically.\n    </div>\n  </bb-collapsible-card-ui>\n  <bb-collapsible-card-ui>\n    <div bbCollapsibleTitle>Panel #2</div>\n    <div bbCollapsibleBody>This is the second panel with content.</div>\n  </bb-collapsible-card-ui>\n  <bb-collapsible-card-ui>\n    <div bbCollapsibleTitle>Panel #3</div>\n    <div bbCollapsibleBody>Last but not least, the third panel.</div>\n  </bb-collapsible-card-ui>\n</bb-collapsible-accordion-ui>\n',
    },
    {
      name: 'CollapsibleCardComponent',
      selector: 'bb-collapsible-card-ui',
      inputsClass: [
        {
          name: 'aria-label',
          defaultValue: "'toggle'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label for collapsible card\n',
          description: '<p>Accessible label for collapsible card</p>\n',
          line: 36,
          type: 'string | null',
          decorators: [],
        },
        {
          name: 'ariaLabelForIcon',
          defaultValue: "'Chevron icon'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label for chevron icon.\n',
          description: '<p>Accessible label for chevron icon.</p>\n',
          line: 32,
          type: 'string',
          decorators: [],
        },
        {
          name: 'hasChevron',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether chevron should be displayed. Defaults to true.\n',
          description: '<p>Whether chevron should be displayed. Defaults to true.</p>\n',
          line: 40,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'highlight',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether card should be highlighted. Defaults to false.\n',
          description: '<p>Whether card should be highlighted. Defaults to false.</p>\n',
          line: 44,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isOpen',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 755,
              end: 773,
              kind: 327,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 756,
                end: 763,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'default',
              },
              comment: '<p>false</p>\n',
            },
          ],
          rawdescription: '\n\nCollapsible card open state\n',
          description: '<p>Collapsible card open state</p>\n',
          line: 27,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'shadow',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether card should has shadow effect. Defaults to true.\n',
          description: '<p>Whether card should has shadow effect. Defaults to true.</p>\n',
          line: 48,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'size',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nCard size. Defaults to md.\n',
          description: '<p>Card size. Defaults to md.</p>\n',
          line: 52,
          type: 'CollapsibleCardSize',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'isOpenChange',
          defaultValue: 'new EventEmitter<boolean>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits when the `isOpen` input is changed.\n',
          description: '<p>Emits when the <code>isOpen</code> input is changed.</p>\n',
          line: 57,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'toggle',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 75,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description:
        '<p>Provides an expandable details-summary/body-header view.\nUses bb-collapsible-ui for a predefined template</p>\n<h3>Accessibility</h3>\n<p>ariaLabelForIcon is discernible text for chevron icon</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CollapsibleCardExampleComponent',
      selector: 'bb-collapsible-card-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-collapsible-card-example-ui',\n  templateUrl: './collapsible-card-example.component.html',\n  standalone: false,\n})\nexport class CollapsibleCardExampleComponent {}\n",
      template:
        '<bb-collapsible-card-ui>\n  <span bbCollapsibleTitle>Click me</span>\n  <div bbCollapsibleBody>I am expandable content!</div>\n</bb-collapsible-card-ui>\n',
    },
    {
      name: 'CollapsibleComponent',
      selector: 'bb-collapsible-ui',
      inputsClass: [
        {
          name: 'isOpen',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nToggles the content.\n',
          description: '<p>Toggles the content.</p>\n',
          line: 61,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'recreateBodyContent',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIf true, it will use the ngIf approach to create the content\nwhich is less performant but removes the extra div.\nIn case of styling issues, set this to true.\n',
          description:
            '<p>If true, it will use the ngIf approach to create the content\nwhich is less performant but removes the extra div.\nIn case of styling issues, set this to true.</p>\n',
          line: 53,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'isOpenChange',
          defaultValue: 'new EventEmitter<boolean>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits the toggle content event.\n',
          description: '<p>Emits the toggle content event.</p>\n',
          line: 76,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [],
      description: '<p>Provides an expandable details-summary/body-header view.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CollapsibleExampleComponent',
      selector: 'bb-collapsible-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-collapsible-example-ui',\n  templateUrl: './collapsible.example.component.html',\n  standalone: false,\n})\nexport class CollapsibleExampleComponent {}\n",
      template:
        '<bb-collapsible-ui #collapsible>\n  <ng-template\n    bbCollapsibleHeader\n    let-toggle="toggle"\n    let-isOpen="true"\n  >\n    <button\n      bbButton\n      (click)="toggle()"\n      class="bb-block--md"\n      [attr.aria-expanded]="collapsible.isOpen"\n      aria-controls="collapseBody"\n    >\n      Toggle\n      <bb-icon-ui\n        [name]="collapsible.isOpen ? \'toggle-up\' : \'toggle-down\'"\n        [inverse]="true"\n        size="md"\n      ></bb-icon-ui>\n    </button>\n  </ng-template>\n  <ng-template bbCollapsibleBody>\n    <p id="collapseBody">I am expandable content!</p>\n  </ng-template>\n</bb-collapsible-ui>\n',
    },
    {
      name: 'CommonErrorStateExampleComponent',
      selector: 'bb-common-error-state-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { HttpErrorResponse } from '@angular/common/http';\n\n@Component({\n  selector: 'bb-common-error-state-example-ui',\n  templateUrl: './common-error-state.example.component.html',\n  standalone: false,\n})\nexport class CommonErrorStateExampleComponent {\n  pageNotFound = new HttpErrorResponse({ status: 404 });\n}\n",
      template: '<bb-common-error-state-ui\n  [error]="pageNotFound"\n></bb-common-error-state-ui>\n',
    },
    {
      name: 'ConfigurationInputComponent',
      selector: 'bb-configuration-input-ui',
      inputsClass: [
        {
          name: 'checkboxList',
          defaultValue: '[]',
          deprecated: false,
          deprecationMessage: '',
          line: 22,
          type: 'CheckboxList',
          decorators: [],
        },
        {
          name: 'dropdownList',
          defaultValue: '[]',
          deprecated: false,
          deprecationMessage: '',
          line: 28,
          type: 'DropdownList',
          decorators: [],
        },
        {
          name: 'inputList',
          defaultValue: '[]',
          deprecated: false,
          deprecationMessage: '',
          line: 31,
          type: 'InputList',
          decorators: [],
        },
        {
          name: 'radioList',
          defaultValue: '[]',
          deprecated: false,
          deprecationMessage: '',
          line: 25,
          type: 'RadioGroupList',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CurrencyInputComponent',
      selector: 'bb-currency-input-ui',
      inputsClass: [
        {
          name: 'allowNegativeValue',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nFlag is used to allow input negative value\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>Flag is used to allow input negative value</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 313,
          type: '',
          decorators: [],
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          line: 333,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          line: 339,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          line: 336,
          type: 'string',
          decorators: [],
        },
        {
          name: 'currencies',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCurrency list to be displayed in the dropdown.\n\nNote: Non-empty currency list is required for the currency symbol\nfield to be shown. Otherwise, only the amount fields will be shown.\n\nAdditionally, If only a single currency provided, the dropdown of\nthe currency selection will be disabled and its value set to that single currency\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>Currency list to be displayed in the dropdown.</p>\n<p>Note: Non-empty currency list is required for the currency symbol\nfield to be shown. Otherwise, only the amount fields will be shown.</p>\n<p>Additionally, If only a single currency provided, the dropdown of\nthe currency selection will be disabled and its value set to that single currency</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 217,
          type: 'Array<string>',
          decorators: [],
        },
        {
          name: 'currencyInputId',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe id for the currency input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description:
            '<p>The id for the currency input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 243,
          type: 'string',
          decorators: [],
        },
        {
          name: 'currencyLabel',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the currency input.\n',
          description: '<p>The label for the currency input.</p>\n',
          line: 305,
          type: 'string',
          decorators: [],
        },
        {
          name: 'currencyListAriaLabel',
          defaultValue: "'Currency List Dropdown'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAria label for the currency dropdown.\n',
          description: '<p>Aria label for the currency dropdown.</p>\n',
          line: 326,
          type: 'string',
          decorators: [],
        },
        {
          name: 'currencyListWithOnItemAriaLabel',
          defaultValue: "'Currency'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAria label for the currency list with one item.\n',
          description: '<p>Aria label for the currency list with one item.</p>\n',
          line: 330,
          type: 'string',
          decorators: [],
        },
        {
          name: 'decimalId',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe id for the decimal input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description:
            '<p>The id for the decimal input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 286,
          type: 'string',
          decorators: [],
        },
        {
          name: 'decimalInputId',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe id for the decimal input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description:
            '<p>The id for the decimal input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 249,
          type: 'string',
          decorators: [],
        },
        {
          name: 'decimalLabel',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the decimal input.\n',
          description: '<p>The label for the decimal input.</p>\n',
          line: 301,
          type: 'string',
          decorators: [],
        },
        {
          name: 'decimalLabelSrOnly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nBy default is visible if it is needed to hide change this property\nto "true" and it will have class "visually-hidden"\nBy default is hidden and accessible only for screen reader\n',
          description:
            '<p>By default is visible if it is needed to hide change this property\nto &quot;true&quot; and it will have class &quot;visually-hidden&quot;\nBy default is hidden and accessible only for screen reader</p>\n',
          line: 203,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'decMaxLen',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the maximum number of decimals.\nWhen greater than the default number of decimals for the specified currency, this value will take precedence.\nConfiguring this value can affect the input placeholder.\n',
          description:
            '<p>Configure the maximum number of decimals.\nWhen greater than the default number of decimals for the specified currency, this value will take precedence.\nConfiguring this value can affect the input placeholder.</p>\n',
          line: 109,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'decMinLen',
          defaultValue: 'defaultDecimalPrecision',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nNumber of minimum currency precision. Defaults to 2.\n',
          description: '<p>Number of minimum currency precision. Defaults to 2.</p>\n',
          line: 120,
          type: 'number',
          decorators: [],
        },
        {
          name: 'disabled',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is disabled. Defaults to false.\n',
          description: '<p>Whether the input is disabled. Defaults to false.</p>\n',
          line: 176,
          type: 'boolean | CurrencyFieldsState',
          decorators: [],
        },
        {
          name: 'integer',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether there should be only the integer part.\nYou have to keep in mind, that if you have decimal part, even ".00"\nyou will not be able to remove it\n',
          description:
            '<p>Whether there should be only the integer part.\nYou have to keep in mind, that if you have decimal part, even &quot;.00&quot;\nyou will not be able to remove it</p>\n',
          line: 160,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'integerId',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe id for the integer input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description:
            '<p>The id for the integer input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 273,
          type: 'string',
          decorators: [],
        },
        {
          name: 'integerInputId',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe id for the integer input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description:
            '<p>The id for the integer input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 255,
          type: 'string',
          decorators: [],
        },
        {
          name: 'integerLabel',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the integer input.\n',
          description: '<p>The label for the integer input.</p>\n',
          line: 297,
          type: 'string',
          decorators: [],
        },
        {
          name: 'integerLabelSrOnly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether integer label is only visible for screen readers.\nBy default is visible if it is needed to hide change this property\nto "true" and it will have class "visually-hidden"\n',
          description:
            '<p>Whether integer label is only visible for screen readers.\nBy default is visible if it is needed to hide change this property\nto &quot;true&quot; and it will have class &quot;visually-hidden&quot;</p>\n',
          line: 197,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isRightAligned',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether decimal text is aligned to the right.\nBy default is false\n',
          description: '<p>Whether decimal text is aligned to the right.\nBy default is false</p>\n',
          line: 237,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'placeholder',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe placeholder for the input. Defaults to 0.\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The placeholder for the input. Defaults to 0.</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 140,
          type: '',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 170,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 165,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'resultType',
          defaultValue: "'number'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nFor set output type string/number, by default 'number', when  need work with long number\n( bigger than MAX_SAFE_INTEGER = 9,007,199,254,740,993 ) need to use 'string'\n",
          description:
            '<p>For set output type string/number, by default &#39;number&#39;, when  need work with long number\n( bigger than MAX_SAFE_INTEGER = 9,007,199,254,740,993 ) need to use &#39;string&#39;</p>\n',
          line: 154,
          type: '"string" | "number"',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 347,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'checkNumeric',
          args: [
            {
              name: 'numeric',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 508,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'numeric',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'checkValues',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 457,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'correctInputValue',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 577,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'decOnBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 408,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'formatDecimal',
          args: [
            {
              name: 'decControl',
              type: 'UntypedFormControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 470,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'decControl',
              type: 'UntypedFormControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'formatInteger',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 524,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFormats integer to user-friendly format.\n\n',
          description: '<p>Formats integer to user-friendly format.</p>\n',
          jsdoctags: [
            {
              tagName: {
                pos: 15325,
                end: 15332,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'returns',
              },
              comment: '<p>Returns true in case of successful formatting, otherwise - false.</p>\n',
            },
          ],
        },
        {
          name: 'markAsTouched',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 616,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onBackspace',
          args: [
            {
              name: 'el',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 565,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for backspace key press, and check if correct number is deleted.\n',
          description: '<p>Event handler for backspace key press, and check if correct number is deleted.</p>\n',
          jsdoctags: [
            {
              name: 'el',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onInput',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 445,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onPress',
          args: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 429,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 608,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 612,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'setDisabled',
          args: [
            {
              name: 'disableState',
              type: 'CurrencyFieldsState',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 621,
          deprecated: false,
          deprecationMessage: '',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'disableState',
              type: 'CurrencyFieldsState',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'triggerChange',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 480,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'updateCurrency',
          args: [
            {
              name: 'currency',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 452,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'currency',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'model',
              type: 'any | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 586,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'model',
              type: 'any | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description:
        '<p>Component to display and manage the currency and the amount</p>\n<h3>Global configuration token</h3>\n<p><code>CURRENCY_INPUT_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of the <code>CurrencyInputComponent</code> in your project.</p>\n<p><em>Note:</em> The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not able to overwrite it.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>allowNegativeValue</code></li>\n<li><code>currencies</code></li>\n<li><code>placeholder</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">import { CURRENCY_INPUT_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/currency-input&#39;;\nimport { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\nimport { AppModule } from &#39;./app/app.module&#39;;\n\nconst currencyInputConfig = {\n  allowNegativeValue: true\n}\n\nplatformBrowserDynamic().bootstrapModule(AppModule, {\n  providers: [{ provide: CURRENCY_INPUT_CONFIG_TOKEN, useValue: currencyInputConfig }]\n});</code></pre></div><h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>aria-describedby</li>\n<li>aria-invalid</li>\n<li>aria-labelledby</li>\n<li>integerLabelSrOnly</li>\n<li>decimalLabelSrOnly</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'CurrencyInputExampleComponent',
      selector: 'bb-currency-input-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormControl } from '@angular/forms';\n\n@Component({\n  selector: 'bb-currency-input-example-ui',\n  templateUrl: './currency-input.example.component.html',\n  standalone: false,\n})\nexport class CurrencyInputExampleComponent {\n  public amount = new UntypedFormControl({\n    amount: '123.32',\n    currency: 'EUR',\n  });\n\n  public currencies: string[] = ['USD', 'EUR'];\n}\n",
      template:
        '<bb-currency-input-ui\n  [formControl]="amount"\n  [currencies]="currencies"\n  [allowNegativeValue]="true"\n  resultType="string"\n></bb-currency-input-ui>\n',
    },
    {
      name: 'DatePipeExampleComponent',
      selector: 'bb-date-pipe-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-date-pipe-example-ui',\n  templateUrl: './date-pipe.example.component.html',\n  standalone: false,\n})\nexport class DatePipeExampleComponent {\n  exampleDate = '2018-12-12T14:29:14.000Z';\n}\n",
      template: "<p>\n  {{ exampleDate | bbDate : 'bbShort' : 'GMT-0700' : 'en-US' }}\n</p>\n",
    },
    {
      name: 'DropdownMenuComponent',
      selector: 'bb-dropdown-menu-ui',
      inputsClass: [
        {
          name: 'autoClose',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether the dropdown should be closed when clicking one of dropdown items or pressing ESC. Defaults to true.\n',
          description:
            '<p>Whether the dropdown should be closed when clicking one of dropdown items or pressing ESC. Defaults to true.</p>\n',
          line: 255,
          type: 'boolean | "inside" | "outside"',
          decorators: [],
        },
        {
          name: 'btnCircle',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe flag to indicate whether the dropdown button should be in a circular shape. Defaults to 'false'.\nThis will only work when there's only an icon inside the button without a text.\n",
          description:
            '<p>The flag to indicate whether the dropdown button should be in a circular shape. Defaults to &#39;false&#39;.\nThis will only work when there&#39;s only an icon inside the button without a text.</p>\n',
          line: 239,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'btnColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nColor of the button. Defaults to primary.\n',
          description: '<p>Color of the button. Defaults to primary.</p>\n',
          line: 233,
          type: 'string',
          decorators: [],
        },
        {
          name: 'buttonSize',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nPredefined button sizes\n',
          description: '<p>Predefined button sizes</p>\n',
          line: 282,
          type: '"sm" | "md"',
          decorators: [],
        },
        {
          name: 'container',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSpecifies which element the dropdown should be appended to.\n',
          description: '<p>Specifies which element the dropdown should be appended to.</p>\n',
          line: 260,
          type: 'string | "body"',
          decorators: [],
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 201,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'dropDownButtonLabel',
          defaultValue: '$localize`:@@bb-dropdown-menu-ui.dropdown-button.aria-label:Toggle dropdown`',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDropdown menu (toggle) button aria label.\n\nDefaults to "Toggle dropdown".\n',
          description:
            '<p>Dropdown menu (toggle) button aria label.</p>\n<p>Defaults to &quot;Toggle dropdown&quot;.</p>\n',
          line: 296,
          type: 'any',
          decorators: [],
        },
        {
          name: 'dropDownMenuId',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nID for the dropdown menu\n',
          description: '<p>ID for the dropdown menu</p>\n',
          line: 277,
          type: 'string',
          decorators: [],
        },
        {
          name: 'dropDownMenuRole',
          defaultValue: "'menu'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe role of the dropdown menu defaults to menu\n',
          description: '<p>The role of the dropdown menu defaults to menu</p>\n',
          line: 271,
          type: 'string',
          decorators: [],
        },
        {
          name: 'fullWidth',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf true it will stretch the button inside to 100% width.\n',
          description: '<p>If true it will stretch the button inside to 100% width.</p>\n',
          line: 250,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'icon',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIcon that is displayed in the button.\n',
          description: '<p>Icon that is displayed in the button.</p>\n',
          line: 218,
          type: 'string',
          decorators: [],
        },
        {
          name: 'iconColor',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the icon to be displayed.\n',
          description: '<p>The color of the icon to be displayed.</p>\n',
          line: 228,
          type: 'string',
          decorators: [],
        },
        {
          name: 'iconSize',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe size of the icon to be displayed. Defaults to md.\n',
          description: '<p>The size of the icon to be displayed. Defaults to md.</p>\n',
          line: 223,
          type: 'string',
          decorators: [],
        },
        {
          name: 'isOpen',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDefines whether or not the dropdown menu is opened initially.\n\nDefaults to `false`.\n',
          description:
            '<p>Defines whether or not the dropdown menu is opened initially.</p>\n<p>Defaults to <code>false</code>.</p>\n',
          line: 289,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the button dropdown. Defaults to an empty string.\n',
          description: '<p>The label for the button dropdown. Defaults to an empty string.</p>\n',
          line: 196,
          type: 'string',
          decorators: [],
        },
        {
          name: 'leftIcon',
          deprecated: false,
          deprecationMessage: '',
          line: 213,
          type: 'string',
          decorators: [],
        },
        {
          name: 'optionLabelKey',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nKey that contains the label of the option object.\nMandatory when the type of option is object\n',
          description:
            '<p>Key that contains the label of the option object.\nMandatory when the type of option is object</p>\n',
          line: 245,
          type: 'string',
          decorators: [],
        },
        {
          name: 'options',
          defaultValue: '[]',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf the value is an object, please provide a optionLabelKey.\n',
          description: '<p>If the value is an object, please provide a optionLabelKey.</p>\n',
          line: 206,
          type: 'Array<string | object>',
          decorators: [],
        },
        {
          name: 'position',
          defaultValue: "['bottom-end', 'bottom-start', 'top-end', 'top-start']",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe position of the dropdown, position will be picked in order of feasibility.\n',
          description: '<p>The position of the dropdown, position will be picked in order of feasibility.</p>\n',
          line: 265,
          type: 'Placement | PlacementArray',
          decorators: [],
        },
        {
          name: 'role',
          defaultValue: "'group'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 306,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'select',
          defaultValue: 'new EventEmitter<string | object>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent (Output) that emits the value of selected dropdown item.\n',
          description: '<p>Event (Output) that emits the value of selected dropdown item.</p>\n',
          line: 211,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'closeDropdownAndReturnFocus',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 355,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nInternal handler to close dropdown on keyboard clicks\nand return focus to the dropdown button\n',
          description:
            '<p>Internal handler to close dropdown on keyboard clicks\nand return focus to the dropdown button</p>\n',
        },
        {
          name: 'getOptionLabel',
          args: [
            {
              name: 'option',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 384,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFunction that returns the label of the dropdown item\n\n',
          description: '<p>Function that returns the label of the dropdown item</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 11905,
                end: 11911,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'option',
              },
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 11899,
                end: 11904,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Item that has been clicked</p>\n',
            },
          ],
        },
        {
          name: 'onClick',
          args: [
            {
              name: 'event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'item',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 345,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nInternal handler for clicks on dropdown items\n\n',
          description: '<p>Internal handler for clicks on dropdown items</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 10993,
                end: 10998,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'event',
              },
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 10987,
                end: 10992,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Event</p>\n',
            },
            {
              name: {
                pos: 11017,
                end: 11021,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'item',
              },
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 11011,
                end: 11016,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Item that has been clicked</p>\n',
            },
          ],
        },
        {
          name: 'onKeyUp',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 388,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'window:keydown', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onOpenChange',
          args: [
            {
              name: 'isOpen',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 365,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDrop down change state event handler\n\n',
          description: '<p>Drop down change state event handler</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 11492,
                end: 11498,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'isOpen',
              },
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 11486,
                end: 11491,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
      ],
      description:
        '<p>Component that displays a button with a dropdown</p>\n<ul>\n<li><code>dropDownButtonLabel</code> is discernible text for dropdown button which is used as the <code>aria-label</code>.</li>\n<li><code>aria-owns</code> handles contextual relationship between a parent and its child elements,\nin this case between dropdown menu and dropdown items, it&#39;s internally handled by the component with unique ids.</li>\n<li><code>aria-activedescendant</code> identifies currently active element of dropdown item. It&#39;s internally handled but\nwhen <code>bbDropdownMenuItem</code> directive and [role=menuitem] is used for listing dropdown elements\nthen use [id]=&quot;option&quot;. Example:</li>\n</ul>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none">&lt;ng-template bbDropdownMenuItem&gt;\n&lt;button role=&quot;menuitem&quot; [id]=&quot;option&quot; class=&quot;dropdown-item&quot; *ngFor=&quot;let option of [1,2,3]&quot;&gt;\n{{ option}}\n&lt;/button&gt;\n&lt;/ng-template&gt;</code></pre></div><h3>Keyboard navigation guide</h3>\n<p>This guide will help you understand the keyboard navigation on dropdown menu and its dropdown items.</p>\n<table class="table table-bordered compodoc-table">\n<thead>\n<tr>\n<th>Key</th>\n<th>Function</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>Enter</td>\n<td><strong>When the dropdown menu is open and an item within it is focused:</strong><br>1. <strong>Pressing Enter</strong> selects the item, closes the dropdown, and refocuses on the dropdown button.</td>\n</tr>\n<tr>\n<td>ArrowDown</td>\n<td><strong>When the dropdown menu is closed:</strong><br>1. <strong>Pressing ArrowDown</strong> opens the dropdown menu and focuses on the first item. <br><br><strong>When the dropdown menu is open and an item is focused:</strong><br>1. <strong>Pressing ArrowDown</strong> moves the focus to the next item.</td>\n</tr>\n<tr>\n<td>ArrowUp</td>\n<td><strong>When the dropdown menu is closed:</strong><br>1. Pressing ArrowUp opens the dropdown menu and focuses on the first item. <br><br><strong>When the dropdown menu is open and an item is focused:</strong><br>1. <strong>Pressing ArrowUp</strong> moves the focus to the previous item.</td>\n</tr>\n<tr>\n<td>Tab</td>\n<td><strong>When the dropdown menu is open:</strong><br>1. If the focus is on the dropdown button, pressing Tab shifts the focus to the first item in the dropdown.<br>2. If the focus is on the last item in the dropdown, <strong>pressing Tab</strong> toggles the focus back to the dropdown button and closes the dropdown.<br>3. If the focus is on any item other than the last, <strong>pressing Tab</strong> shifts the focus to the next item in the dropdown.</td>\n</tr>\n<tr>\n<td>Tab + Shift</td>\n<td><strong>When the dropdown menu is open:</strong><br>1. If the focus is on the dropdown button, <strong>pressing Tab + Shift</strong> closes the dropdown menu.<br>2. If the focus is on the first item in the dropdown, <strong>pressing Tab + Shift</strong> toggles the focus to the dropdown button.<br>3. If the focus is on any item other than the first, <strong>pressing Tab + Shift</strong> shifts the focus to the previous item in the dropdown.</td>\n</tr>\n</tbody>\n</table>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'DropdownMenuExampleComponent',
      selector: 'bb-dropdown-menu-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onButtonDropdownSelect',
          args: [
            {
              name: 'label',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 24,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'label',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'snooze',
          args: [
            {
              name: 'duration',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 34,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'duration',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\ninterface SnoozeDurationExample {\n  label: string;\n  duration: number;\n}\n\n@Component({\n  selector: 'bb-dropdown-menu-example-ui',\n  templateUrl: './dropdown-menu.example.component.html',\n  standalone: false,\n})\nexport class DropdownMenuExampleComponent {\n  dropdownMenuOptions: SnoozeDurationExample[] = [\n    { label: '30 minutes', duration: 1800 },\n    { label: '1 hour', duration: 3600 },\n    { label: '1 day', duration: 86400 },\n  ];\n\n  dropdownMenuOptionsLabel = this.dropdownMenuOptions.map(\n    (item) => item.label,\n  );\n\n  onButtonDropdownSelect(label: string) {\n    const item = this.dropdownMenuOptions.find(\n      (option) => option.label === label,\n    );\n\n    if (item) {\n      this.snooze(item.duration);\n    }\n  }\n\n  snooze(duration: number) {\n    alert(`Snooze for ${duration} seconds`);\n  }\n}\n",
      template:
        '<bb-dropdown-menu-ui\n  container="body"\n  position="bottom"\n  icon="caret-down"\n  btnColor="primary"\n  iconSize="lg"\n  [options]="dropdownMenuOptionsLabel"\n  (select)="onButtonDropdownSelect($event)"\n>\n  <ng-template bbDropdownLabel>\n    <bb-icon-ui name="time" size="md"></bb-icon-ui>\n    &nbsp;\n    <span>Snooze notification</span>\n  </ng-template>\n</bb-dropdown-menu-ui>\n',
    },
    {
      name: 'DropdownMultiSelectComponent',
      selector: 'bb-dropdown-multi-select-ui',
      inputsClass: [
        {
          name: 'container',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSpecifies which element the dropdown should be appended to.\n',
          description: '<p>Specifies which element the dropdown should be appended to.</p>\n',
          line: 92,
          type: 'string | "body"',
          decorators: [],
        },
        {
          name: 'dropdownHeaderText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe dropdown header text.\n',
          description: '<p>The dropdown header text.</p>\n',
          line: 62,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'dropdownPosition',
          defaultValue: "['bottom-end', 'bottom-start', 'top-end', 'top-start']",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe position of the dropdown\n',
          description: '<p>The position of the dropdown</p>\n',
          line: 87,
          type: 'PlacementArray',
          decorators: [],
        },
        {
          name: 'filtering',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEnable filtering; Defaults to false.\n',
          description: '<p>Enable filtering; Defaults to false.</p>\n',
          line: 77,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the Dropdown multi select. Defaults to an empty string.\n',
          description: '<p>The label for the Dropdown multi select. Defaults to an empty string.</p>\n',
          line: 72,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'placeholder',
          defaultValue: "'No items selected'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the multi select.\n',
          description: '<p>The placeholder for the multi select.</p>\n',
          line: 67,
          type: 'string',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the Dropdown multi select is read only. Defaults to false.\n',
          description: '<p>Whether the Dropdown multi select is read only. Defaults to false.</p>\n',
          line: 82,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'clearAll',
          args: [
            {
              name: '$event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 228,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nUnselect all selected options from the listbox\n\n',
          description: '<p>Unselect all selected options from the listbox</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 6705,
                end: 6711,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: '$event',
              },
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 6699,
                end: 6704,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'getLabel',
          args: [
            {
              name: 'label',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 271,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nUpdating labels while searching\n\n',
          description: '<p>Updating labels while searching</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 7663,
                end: 7668,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'label',
              },
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 7657,
                end: 7662,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'getLabeledByIds',
          args: [
            {
              name: 'tokens',
              type: 'Array<string | undefined>',
              deprecated: false,
              deprecationMessage: '',
              dotDotDotToken: true,
            },
          ],
          optional: false,
          returnType: 'string | undefined',
          typeParameters: [],
          line: 341,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'tokens',
              type: 'Array<string | undefined>',
              deprecated: false,
              deprecationMessage: '',
              dotDotDotToken: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onDropdownToggle',
          args: [
            {
              name: 'isOpen',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 335,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\n',
          description: '',
          jsdoctags: [
            {
              name: {
                pos: 9156,
                end: 9162,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'isOpen',
              },
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 9150,
                end: 9155,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'onFocusOut',
          args: [
            {
              name: 'event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 346,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onListboxBlur',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 326,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\n',
          description: '',
        },
        {
          name: 'onListboxFocus',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 277,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onListboxKeyDown',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 283,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'trackByValueFn',
          args: [
            {
              name: '_',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'item',
              type: 'DropdownMultiSelectOptionComponent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 238,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\n',
          description: '',
          jsdoctags: [
            {
              name: '_',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: {
                pos: 6852,
                end: 6856,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'item',
              },
              type: 'DropdownMultiSelectOptionComponent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 6846,
                end: 6851,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'value',
              type: 'string[] | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 246,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\n',
          description: '',
          jsdoctags: [
            {
              name: {
                pos: 6986,
                end: 6991,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              type: 'string[] | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 6980,
                end: 6985,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '<p>Component that use for DropDown Multi Select.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'DropdownMultiSelectExampleComponent',
      selector: 'bb-dropdown-multi-select-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormControl,\n  UntypedFormBuilder,\n  UntypedFormGroup,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-dropdown-multi-select-example-ui',\n  templateUrl: './dropdown-multi-select.example.component.html',\n  standalone: false,\n})\nexport class DropdownMultiSelectExampleComponent {\n  form: UntypedFormGroup = this.formBuilder.group({\n    days: new UntypedFormControl(['1', '2', '3', '4', '5']),\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="form">\n  <bb-dropdown-multi-select-ui\n    label="Available days"\n    placeholder="Please choose one or more days"\n    formControlName="days"\n    [required]="true"\n  >\n    <bb-dropdown-multi-select-option-ui value="0" label="Sunday">\n    </bb-dropdown-multi-select-option-ui>\n    <bb-dropdown-multi-select-option-ui value="1" label="Monday">\n    </bb-dropdown-multi-select-option-ui>\n    <bb-dropdown-multi-select-option-ui value="2" label="Tuesday">\n    </bb-dropdown-multi-select-option-ui\n    ><bb-dropdown-multi-select-option-ui value="3" label="Wednesday">\n    </bb-dropdown-multi-select-option-ui>\n    <bb-dropdown-multi-select-option-ui value="4" label="Thursday">\n    </bb-dropdown-multi-select-option-ui\n    ><bb-dropdown-multi-select-option-ui value="5" label="Friday">\n    </bb-dropdown-multi-select-option-ui>\n    <bb-dropdown-multi-select-option-ui value="6" label="Saturday">\n    </bb-dropdown-multi-select-option-ui>\n  </bb-dropdown-multi-select-ui>\n</form>\n',
    },
    {
      name: 'DropdownMultiSelectOptionComponent',
      selector: 'bb-dropdown-multi-select-option-ui',
      inputsClass: [
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\n',
          description: '<p>The id for the input. Defaults to unique string.</p>\n',
          line: 37,
          type: 'string',
          decorators: [],
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label of the option item\n',
          description: '<p>The label of the option item</p>\n',
          line: 52,
          type: 'string',
          decorators: [],
        },
        {
          name: 'state',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 54,
          type: 'boolean | undefined',
          decorators: [],
        },
        {
          name: 'value',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe value of the native option element\n',
          description: '<p>The value of the native option element</p>\n',
          line: 48,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that represents a single option that is part of the multi select component.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'DropdownPanelComponent',
      selector: 'bb-dropdown-panel-ui',
      inputsClass: [
        {
          name: 'buttonClass',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass for the dropdown toggle\n',
          description: '<p>Class for the dropdown toggle</p>\n',
          line: 74,
          type: 'string',
          decorators: [],
        },
        {
          name: 'container',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSpecifies which element the dropdown should be appended to.\n',
          description: '<p>Specifies which element the dropdown should be appended to.</p>\n',
          line: 84,
          type: 'string | "body"',
          decorators: [],
        },
        {
          name: 'isDropdownOpen',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDefines whether or not the dropdown menu is opened initially.\nDefaults to `false`.\n',
          description:
            '<p>Defines whether or not the dropdown menu is opened initially.\nDefaults to <code>false</code>.</p>\n',
          line: 60,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'position',
          defaultValue: "['bottom-end', 'bottom-start', 'top-end', 'top-start']",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe position of the dropdown, position will be picked in order of feasibility.\n',
          description: '<p>The position of the dropdown, position will be picked in order of feasibility.</p>\n',
          line: 79,
          type: 'PlacementArray',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'focusout',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent emitted when the dropdown toggle loses focus\n',
          description: '<p>Event emitted when the dropdown toggle loses focus</p>\n',
          line: 89,
          type: 'EventEmitter',
        },
        {
          name: 'open',
          defaultValue: 'this.isOpen.asObservable()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent emitted when dropdown open/close.\n',
          description: '<p>Event emitted when dropdown open/close.</p>\n',
          line: 95,
          type: 'Observable<boolean>',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'changeState',
          args: [
            {
              name: 'state',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 121,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'state',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'closeMenu',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 144,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onFocusOut',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 125,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '<p>Component incapsulating logic for showing/hiding dropdown.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'DropdownPanelExampleComponent',
      selector: 'bb-dropdown-panel-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-dropdown-panel-example-ui',\n  templateUrl: './dropdown-panel-example.component.html',\n  standalone: false,\n})\nexport class DropdownPanelExampleComponent {}\n",
      template:
        '<div class="row">\n  <div class="col-3">\n    <bb-dropdown-panel-ui>\n      <ng-template bbDropdownToggle> Toggle without arrow </ng-template>\n      <ng-template bbDropdownMenu>\n        <div class="p-2">The content of dropdown</div>\n      </ng-template>\n    </bb-dropdown-panel-ui>\n  </div>\n\n  <div class="col-3">\n    <bb-dropdown-panel-ui>\n      <ng-template bbDropdownToggle let-isOpen="isOpen">\n        <div class="d-flex align-items-center">\n          Dropdown with arrow\n          <bb-icon-ui [name]="isOpen ? \'toggle-up\' : \'toggle-down\'"></bb-icon-ui>\n        </div>\n      </ng-template>\n      <ng-template bbDropdownMenu>\n        <div class="p-2">The content of dropdown</div>\n      </ng-template>\n    </bb-dropdown-panel-ui>\n  </div>\n</div>\n',
    },
    {
      name: 'DropdownSingleSelectComponent',
      selector: 'bb-dropdown-single-select-ui',
      inputsClass: [
        {
          name: 'compareWithFn',
          defaultValue: '(a, b) => a === b',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nAllowing override the option comparison algorithm for tracking identities when\nchecking for change\n',
          description:
            '<p>Allowing override the option comparison algorithm for tracking identities when\nchecking for change</p>\n',
          line: 128,
          type: 'function',
          decorators: [],
        },
        {
          name: 'defaultOptionAsPlaceholder',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThis Boolean attribute determine if default option as placeholder is displayed. Defaults to false.\n',
          description:
            '<p>This Boolean attribute determine if default option as placeholder is displayed. Defaults to false.</p>\n',
          line: 95,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'displayAttributePath',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIn case the list of options is a list of objects,\nthis property will set the path to the object property which value will be used to display the option.\nUndefined will assume the options are strings.\nChild Nodes should be seperated by '.'\n",
          description:
            '<p>In case the list of options is a list of objects,\nthis property will set the path to the object property which value will be used to display the option.\nUndefined will assume the options are strings.\nChild Nodes should be seperated by &#39;.&#39;</p>\n',
          line: 115,
          type: 'string',
          decorators: [],
        },
        {
          name: 'iconName',
          defaultValue: "'toggle-down'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nRight corner icon name.\nDefault name 'toggle-down'\n",
          description: '<p>Right corner icon name.\nDefault name &#39;toggle-down&#39;</p>\n',
          line: 122,
          type: 'string',
          decorators: [],
        },
        {
          name: 'options',
          defaultValue: '[]',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe value for the input field. It can be a list of strings or list of objects.\nIf the value is a list of objects, you have to provide the `displayAttributePath` property.\n',
          description:
            '<p>The value for the input field. It can be a list of strings or list of objects.\nIf the value is a list of objects, you have to provide the <code>displayAttributePath</code> property.</p>\n',
          line: 101,
          type: 'Array<Object | string>',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the select. Defaults to an empty string;\n',
          description: '<p>The placeholder for the select. Defaults to an empty string;</p>\n',
          line: 91,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'getOptionDisplayText',
          args: [
            {
              name: 'option',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 134,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'option',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that displays a dropdown with a single select option.</p>\n<h3>Accessibility</h3>\n<p>Current component provides option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>aria-label will be linked to the single select dropdown with label</li>\n<li>set aria-labelledby with ID of another element in the DOM as dropdown&#39;s label.</li>\n<li>set aria-describedby with ID of another element in the DOM with descriptive text about the dropdown</li>\n<li>set aria-expanded with a boolean value based on the listbox display.</li>\n<li>set aria-invalid to true when a selected option is not valid ans vice versa</li>\n<li>aria-owns handles contextual relationship between a parent and its child elements,\nin this case between dropdown menu and dropdown items, use the id from the input binding.</li>\n</ul>\n<h3>Dropdown Single Select Options</h3>\n<p>There are 2 ways to add dropdown items\n###1. Via Options Array\nUsing [options] input property.</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none">&lt;bb-dropdown-single-select-ui\n[label]=&quot;label&quot;\n[placeholder]=&quot;placeholder&quot;&quot;\n(blur)=&quot;blur($event)&quot;\n(focus)=&quot;focus($event)&quot;\n[options]=&quot;[&#39;Option One&#39;, &#39;Option Two&#39;, &#39;Option Three&#39;]&quot;&gt;\n&lt;/bb-dropdown-single-select-ui&gt;</code></pre></div><p>###2. Via Content Children\nUsing <code>bb-dropdown-single-select-option-ui</code> ,it is a child component of <code>bb-dropdown-single-select-ui</code> that represents a single option that is part of the dropdown single select component.</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none">&lt;bb-dropdown-single-select-ui\n[label]=&quot;label&quot;\n[placeholder]=&quot;placeholder&quot;&quot;\n(blur)=&quot;blur($event)&quot;\n(focus)=&quot;focus($event)&quot;&gt;\n&lt;bb-dropdown-single-select-option-ui label=&quot;Option One&quot; value=&quot;1&quot;&gt;\n&lt;/bb-dropdown-single-select-option-ui&gt;\n&lt;bb-dropdown-single-select-option-ui label=&quot;Option Two&quot; value=&quot;2&quot;&gt;\n&lt;/bb-dropdown-single-select-option-ui&gt;\n&lt;bb-dropdown-single-select-option-ui label=&quot;Option Three&quot; value=&quot;3&quot;&gt;\n&lt;/bb-dropdown-single-select-option-ui&gt;\n&lt;/bb-dropdown-single-select-ui&gt;</code></pre></div><p>###NOTE:\nIf you add dropdown items via options and via Content Children at the same time then the items will be combined together and displayed in the dropdown.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'DropdownSingleSelectExampleComponent',
      selector: 'bb-dropdown-single-select-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'compareByValue',
          args: [
            {
              name: 'p1',
              type: 'Frequency',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'p2',
              type: 'Frequency',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 78,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'p1',
              type: 'Frequency',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'p2',
              type: 'Frequency',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\ninterface Frequency {\n  value: string;\n  every: number;\n}\n\n@Component({\n  selector: 'bb-dropdown-single-select-example-ui',\n  templateUrl: './dropdown-single-select.example.component.html',\n  standalone: false,\n})\nexport class DropdownSingleSelectExampleComponent {\n  objectDropdownOptions = [\n    { title: 'DuckDuckGo', url: 'https://www.duckduckgo.com' },\n    { title: 'Google', url: 'https://google.com' },\n    { title: 'Yahoo', url: 'https://yahoo.com' },\n  ];\n\n  stringDropdownOptions = ['DuckDuckGo', 'Google', 'Yahoo'];\n\n  frequencies: Frequency[] = [\n    {\n      value: 'ONCE',\n      every: 1,\n    },\n    {\n      value: 'DAILY',\n      every: 1,\n    },\n    {\n      value: 'WEEKLY',\n      every: 1,\n    },\n    {\n      value: 'BIWEEKLY',\n      every: 1,\n    },\n    {\n      value: 'MONTHLY',\n      every: 1,\n    },\n    {\n      value: 'QUARTERLY',\n      every: 1,\n    },\n    {\n      value: 'YEARLY',\n      every: 1,\n    },\n  ];\n\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    websiteStrings: [\n      this.stringDropdownOptions[0],\n      Validators.required,\n    ],\n    websiteObjects: [\n      this.objectDropdownOptions[0],\n      Validators.required,\n    ],\n    frequency: [\n      {\n        value: 'ONCE',\n        every: 1,\n      },\n      Validators.required,\n    ],\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n\n  compareByValue(p1: Frequency, p2: Frequency) {\n    if (!p1 || !p2) return;\n\n    return p1.value === p2.value;\n  }\n}\n",
      template:
        '<h4 id="ariaLabelledById">Single select Dropdown</h4>\n<div id="ariaDescribedById">Default with list of string as options</div>\n<div [formGroup]="vForm">\n  <bb-dropdown-single-select-ui\n    label="Choose your search engine"\n    placeholder="No search engine selected"\n    formControlName="websiteStrings"\n    [options]="stringDropdownOptions"\n    [required]="true"\n    [id]="\'singleDropdown\'"\n    class="d-block bb-block bb-block--lg"\n    [aria-label]="\'single select\'"\n    [aria-labelledby]="\'ariaLabelledById\'"\n    [aria-describedby]="\'ariaDescribedById\'"\n    [aria-owns]="\'singleDropdown\'"\n  >\n  </bb-dropdown-single-select-ui>\n\n  <bb-dropdown-single-select-ui\n    label="Choose your search engine"\n    placeholder="No search engine selected"\n    formControlName="websiteObjects"\n    displayAttributePath="title"\n    [options]="objectDropdownOptions"\n    [required]="true"\n    class="d-block bb-block bb-block--lg"\n  >\n  </bb-dropdown-single-select-ui>\n\n  <bb-dropdown-single-select-ui\n    [compareWithFn]="compareByValue"\n    label="Frequency"\n    displayAttributePath="value"\n    formControlName="frequency"\n    data-role="frequency-selector"\n  >\n    @for (frequency of frequencies; track $index) {\n      <bb-dropdown-single-select-option-ui\n        class="text-capitalize"\n        [value]="frequency"\n        [label]="frequency.value"\n      >\n      </bb-dropdown-single-select-option-ui>\n    }\n  </bb-dropdown-single-select-ui>\n</div>\n',
    },
    {
      name: 'DropdownSingleSelectOptionComponent',
      selector: 'bb-dropdown-single-select-option-ui',
      inputsClass: [
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label of the option item\n',
          description: '<p>The label of the option item</p>\n',
          line: 37,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe value of the native option element\n',
          description: '<p>The value of the native option element</p>\n',
          line: 33,
          type: 'string | undefined',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description:
        '<p>Component that represents a single option that is part of the dropdown single select component.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'EllipsisComponent',
      selector: 'bb-ellipsis-ui',
      inputsClass: [
        {
          name: 'lineClamp',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSpecifies after what text line apply truncating\n',
          description: '<p>Specifies after what text line apply truncating</p>\n',
          line: 33,
          type: 'number',
          decorators: [],
        },
        {
          name: 'text',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe text which should be truncated.\n',
          description: '<p>The text which should be truncated.</p>\n',
          line: 21,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'tooltipTriggers',
          defaultValue: "'click'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nSpecifies the events that should trigger the tooltip (space separated strings). Defaults to 'click'.\n",
          description:
            '<p>Specifies the events that should trigger the tooltip (space separated strings). Defaults to &#39;click&#39;.</p>\n',
          line: 27,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onMouseEnter',
          args: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 47,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onMouseLeave',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 54,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'EllipsisExampleComponent',
      selector: 'bb-ellipsis-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-ellipsis-example-ui',\n  templateUrl: './ellipsis.example.component.html',\n  standalone: false,\n})\nexport class EllipsisExampleComponent {}\n",
      template:
        '<div style="width: 320px">\n  <bb-ellipsis-ui\n    [lineClamp]="2"\n    text="Lorem ipsum dolor sit amet, consectetur adipiscing elit,\n    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."\n  ></bb-ellipsis-ui>\n</div>\n',
    },
    {
      name: 'EmptyStateComponent',
      selector: 'bb-empty-state-ui',
      inputsClass: [
        {
          name: 'image',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe image to be displayed for empty state.\nRequired. Will throw an error if unset.\n',
          description: '<p>The image to be displayed for empty state.\nRequired. Will throw an error if unset.</p>\n',
          line: 31,
          type: 'string',
          decorators: [],
        },
        {
          name: 'preset',
          deprecated: false,
          deprecationMessage: '',
          line: 52,
          type: 'EmptyStatePresetType',
          decorators: [],
        },
        {
          name: 'primaryActionText',
          deprecated: false,
          deprecationMessage: '',
          line: 61,
          type: 'string',
          decorators: [],
        },
        {
          name: 'primaryBtnTemplate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nUse the primaryBtnTemplate to add any extra elements to the secondary button, such as icons or dropdowns.\nWhen using this template, do not use primaryActionText instead, include it within the template itself.\n',
          description:
            '<p>Use the primaryBtnTemplate to add any extra elements to the secondary button, such as icons or dropdowns.\nWhen using this template, do not use primaryActionText instead, include it within the template itself.</p>\n',
          line: 45,
          type: 'TemplateRef<any> | undefined',
          decorators: [],
        },
        {
          name: 'secondaryActionText',
          deprecated: false,
          deprecationMessage: '',
          line: 64,
          type: 'string',
          decorators: [],
        },
        {
          name: 'secondaryBtnTemplate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nUse the secondaryBtnTemplate to add any extra elements to the secondary button, such as icons or dropdowns.\nWhen using this template, do not use secondaryActionText instead, include it within the template itself.\n',
          description:
            '<p>Use the secondaryBtnTemplate to add any extra elements to the secondary button, such as icons or dropdowns.\nWhen using this template, do not use secondaryActionText instead, include it within the template itself.</p>\n',
          line: 50,
          type: 'TemplateRef<any> | undefined',
          decorators: [],
        },
        {
          required: false,
          name: 'showPrimaryAction',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 55,
          type: 'boolean',
          decorators: [],
        },
        {
          required: false,
          name: 'showSecondaryAction',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          line: 58,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'subtitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe sub-title of the empty state. Defaults to an empty string.\n',
          description: '<p>The sub-title of the empty state. Defaults to an empty string.</p>\n',
          line: 40,
          type: 'string',
          decorators: [],
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe title of the empty state.\nRequired. Will throw an error if unset.\n',
          description: '<p>The title of the empty state.\nRequired. Will throw an error if unset.</p>\n',
          line: 36,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'primaryActionClick',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          line: 67,
          type: 'EventEmitter',
        },
        {
          name: 'secondaryActionClick',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          line: 70,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [],
      description: '<p>Component that displays an empty state.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'EmptyStateExampleComponent',
      selector: 'bb-empty-state-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-empty-state-example-ui',\n  templateUrl: './empty-state.example.component.html',\n  standalone: false,\n})\nexport class EmptyStateExampleComponent {}\n",
      template:
        '<bb-empty-state-ui\n  image="ic_scenario_coin_empty"\n  title="No transactions found"\n  subtitle="Please change your filters<br>and try again"\n></bb-empty-state-ui>\n',
    },
    {
      name: 'ErrorCommonStateComponent',
      selector: 'bb-common-error-state-ui',
      inputsClass: [
        {
          name: 'error',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nError that should be displayed. Could be HttpErrorResponse, Error, Template reference or string.\nDefaults to empty string.\n',
          description:
            '<p>Error that should be displayed. Could be HttpErrorResponse, Error, Template reference or string.\nDefaults to empty string.</p>\n',
          line: 20,
          type: 'HttpErrorResponse | Error | TemplateRef<any> | string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'getErrorTemplate',
          args: [],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 58,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getMessage',
          args: [],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 85,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '<p>Component that displays error state based on error value that was provided.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'FieldsetComponent',
      selector: 'bb-fieldset-ui',
      inputsClass: [
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to disable all form items within the fieldset.\n',
          description: '<p>Whether to disable all form items within the fieldset.</p>\n',
          line: 24,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'heading',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe caption for the `fieldset` element.\n',
          description: '<p>The caption for the <code>fieldset</code> element.</p>\n',
          line: 19,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that displays a fieldset group.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'FieldsetExampleComponent',
      selector: 'bb-fieldset-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';\n\n@Component({\n  selector: 'bb-fieldset-example-ui',\n  templateUrl: './fieldset.example.component.html',\n  standalone: false,\n})\nexport class FieldsetExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    anonymous: false,\n    personalInformation: this.formBuilder.group({\n      name: [''],\n      surname: [''],\n    }),\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <p>\n    <bb-input-checkbox-ui\n      label="I wish to remain anonymous"\n      formControlName="anonymous"\n    ></bb-input-checkbox-ui>\n  </p>\n  <bb-fieldset-ui\n    heading="Personal information"\n    [disabled]="vForm?.get(\'anonymous\')?.value"\n    [formGroup]="vForm?.get(\'personalInformation\')"\n  >\n    <p>\n      <bb-input-text-ui\n        label="Name"\n        formControlName="name"\n      ></bb-input-text-ui>\n    </p>\n    <p>\n      <bb-input-text-ui\n        label="Surname"\n        formControlName="surname"\n      ></bb-input-text-ui>\n    </p>\n  </bb-fieldset-ui>\n</form>\n',
    },
    {
      name: 'FileAttachmentComponent',
      selector: 'bb-file-attachment-ui',
      inputsClass: [
        {
          name: 'aria-describedby',
          defaultValue: "'file-attachment-card-body'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.</p>\n',
          line: 123,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-label',
          defaultValue: "'Delete file'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label for delete button when control does not need to render label tag.\n',
          description: '<p>Accessible label for delete button when control does not need to render label tag.</p>\n',
          line: 133,
          type: 'string',
          decorators: [],
        },
        {
          name: 'block',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe flag to indicate whether the file-attachment should fill the container that it is in. Defaults to 'false'.\n",
          description:
            '<p>The flag to indicate whether the file-attachment should fill the container that it is in. Defaults to &#39;false&#39;.</p>\n',
          line: 118,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'deletable',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nShow delete button flag. Defaults to false.\n',
          description: '<p>Show delete button flag. Defaults to false.</p>\n',
          line: 108,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDisabled state flag. Defaults to false.\n',
          description: '<p>Disabled state flag. Defaults to false.</p>\n',
          line: 113,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'fileContent',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet file content (required if disabled property is not set to true).\n',
          description: '<p>Set file content (required if disabled property is not set to true).</p>\n',
          line: 89,
          type: 'Observable<ArrayBuffer> | undefined',
          decorators: [],
        },
        {
          name: 'id',
          defaultValue: "'file-attachment-card-body_' + getDynamicId()",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for attachment card.\n',
          description: '<p>The id for attachment card.</p>\n',
          line: 128,
          type: 'string',
          decorators: [],
        },
        {
          name: 'loading',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nLoading indicator flag. Defaults to false.\n',
          description: '<p>Loading indicator flag. Defaults to false.</p>\n',
          line: 103,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet file name (required).\n',
          description: '<p>Set file name (required).</p>\n',
          line: 54,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet file size (required). Accepts `number` or `string`.\n',
          description: '<p>Set file size (required). Accepts <code>number</code> or <code>string</code>.</p>\n',
          line: 70,
          type: 'number | string | undefined',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'delete',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent emitted on delete button click.\n',
          description: '<p>Event emitted on delete button click.</p>\n',
          line: 138,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'onDelete',
          args: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 203,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDelete attachment event emitter.\n\n',
          description: '<p>Delete attachment event emitter.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 5002,
                end: 5007,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'event',
              },
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 4996,
                end: 5001,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Delete button click event.</p>\n',
            },
          ],
        },
        {
          name: 'onDownload',
          args: [
            {
              name: '$event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 169,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDownload attachment method.\n\n',
          description: '<p>Download attachment method.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 4023,
                end: 4029,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: '$event',
              },
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 4017,
                end: 4022,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Download button click event</p>\n',
            },
          ],
        },
      ],
      description:
        '<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes:</p>\n<ul>\n<li>id</li>\n<li>aria-label</li>\n<li>aria-describedby</li>\n</ul>\n<p>Component displays file attachment.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'FileAttachmentExampleComponent',
      selector: 'bb-file-attachment-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { Observable, of } from 'rxjs';\n\n@Component({\n  selector: 'bb-file-attachment-example-ui',\n  templateUrl: './file-attachment.example.component.html',\n  standalone: false,\n})\nexport class FileAttachmentExampleComponent {\n  attachment: {\n    name: string;\n    size: number;\n    fileContent: Observable<ArrayBuffer>;\n  } = {\n    name: 'examplePDF.pdf',\n    size: 10000,\n    fileContent: of(new ArrayBuffer(2000000)),\n  };\n}\n",
      template:
        '<bb-file-attachment-ui\n  [name]="attachment.name"\n  [size]="attachment.size"\n  [fileContent]="attachment.fileContent"\n></bb-file-attachment-ui>\n',
    },
    {
      name: 'HighlightExampleComponent',
      selector: 'bb-highlight-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-highlight-example-ui',\n  templateUrl: './highlight.example.component.html',\n  standalone: false,\n})\nexport class HighlightExampleComponent {\n  balance = '3299.00';\n  creditLimit = '-500';\n}\n",
      template:
        '<table class="table">\n  <tr>\n    <th>Balance</th>\n    <td\n      bbHighlight\n      [amount]="balance"\n      positiveClass="bg-primary"\n      negativeClass="bg-danger"\n    >\n      <bb-amount-ui [amount]="balance"></bb-amount-ui>\n    </td>\n  </tr>\n  <tr>\n    <th>Credit limit</th>\n    <td\n      bbHighlight\n      [amount]="creditLimit"\n      positiveClass="bg-primary"\n      negativeClass="bg-danger"\n    >\n      <bb-amount-ui [amount]="creditLimit"></bb-amount-ui>\n    </td>\n  </tr>\n</table>\n',
    },
    {
      name: 'IbanPipeExampleComponent',
      selector: 'bb-iban-pipe-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-iban-pipe-example-ui',\n  templateUrl: './iban-pipe.example.component.html',\n  standalone: false,\n})\nexport class IbanPipeExampleComponent {\n  productNumber = 'NL81TRIO0212471066';\n}\n",
      template: '<div>\n  {{ productNumber | bbIban }}\n</div>\n',
    },
    {
      name: 'IconComponent',
      selector: 'bb-icon-ui',
      inputsClass: [
        {
          name: 'animate',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the icon should be animated. Defaults to `false`.\n',
          description: '<p>Whether the icon should be animated. Defaults to <code>false</code>.</p>\n',
          line: 44,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nInput that can be used to specify the `aria-label` attribute.\n',
          description: '<p>Input that can be used to specify the <code>aria-label</code> attribute.</p>\n',
          line: 49,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'backgroundType',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWether the icon has a background. If not set it will display just the icon without background.\nPossible values are `circle` and `square`.\n',
          description:
            '<p>Wether the icon has a background. If not set it will display just the icon without background.\nPossible values are <code>circle</code> and <code>square</code>.</p>\n',
          line: 77,
          type: '"circle" | "square" | undefined',
          decorators: [],
        },
        {
          name: 'color',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the icon represented as a color name contained in backbase-theme.\n',
          description: '<p>The color of the icon represented as a color name contained in backbase-theme.</p>\n',
          line: 39,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'cropped',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the icon should be cropped horizontally.\n',
          description: '<p>Whether the icon should be cropped horizontally.</p>\n',
          line: 55,
          type: 'boolean | string',
          decorators: [],
        },
        {
          name: 'flipOnRtl',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the icon should be flipped when the page direction is RTL (right-to-left).\n',
          description: '<p>Whether the icon should be flipped when the page direction is RTL (right-to-left).</p>\n',
          line: 65,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'inverse',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to use white background and inverse icon colors\n',
          description: '<p>Whether to use white background and inverse icon colors</p>\n',
          line: 28,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe name of the icon\n',
          description: '<p>The name of the icon</p>\n',
          line: 23,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'size',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe size of the icon represented as a size name contained in backbase-theme.  This is ignored\nwhen the circle option is used. Defaults to `md`.\n',
          description:
            '<p>The size of the icon represented as a size name contained in backbase-theme.  This is ignored\nwhen the circle option is used. Defaults to <code>md</code>.</p>\n',
          line: 34,
          type: 'IconSize',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that displays an icon.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'IconExampleComponent',
      selector: 'bb-icon-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-icon-example-ui',\n  templateUrl: './icon.example.component.html',\n  standalone: false,\n})\nexport class IconExampleComponent {}\n",
      template:
        '<bb-icon-ui\n  name="shopping-cart"\n  size="xxl"\n  color="primary"\n  backgroundType="circle"\n></bb-icon-ui>\n',
    },
    {
      name: 'IllustrationComponent',
      selector: 'bb-illustration-ui',
      inputsClass: [
        {
          name: 'alt',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe alt attribute value of the illustration HTML <img> tag.\nSet the value to empty string `""` so that screen readers won\'t read it.\nThis useful when the image does not convey any meaning and avoid disturbing\na screen reader user\n\nDefaults to `undefined`. It will set `alt` to `name | illustrationAlt` in the html template.\n',
          description:
            '<p>The alt attribute value of the illustration HTML <img> tag.\nSet the value to empty string <code>&quot;&quot;</code> so that screen readers won&#39;t read it.\nThis useful when the image does not convey any meaning and avoid disturbing\na screen reader user</p>\n<p>Defaults to <code>undefined</code>. It will set <code>alt</code> to <code>name | illustrationAlt</code> in the html template.</p>\n',
          line: 121,
          type: 'string',
          decorators: [],
        },
        {
          name: 'assetPath',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nLocation of your assets folder.\nUsed for overriding or theming the illustrations.\nThis attribute can be overwritten via the global configuration token.\n\nDefaults to the `ui-ang` visual asset library folder.\n',
          description:
            '<p>Location of your assets folder.\nUsed for overriding or theming the illustrations.\nThis attribute can be overwritten via the global configuration token.</p>\n<p>Defaults to the <code>ui-ang</code> visual asset library folder.</p>\n',
          line: 107,
          type: 'string',
          decorators: [],
        },
        {
          name: 'classes',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe class of the image. Used for additional styling.\n',
          description: '<p>The class of the image. Used for additional styling.</p>\n',
          line: 85,
          type: 'string',
          decorators: [],
        },
        {
          name: 'fileType',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe file type.\nThis attribute can be overwritten via the global configuration token.\n\nDefaults to `svg`.\n',
          description:
            '<p>The file type.\nThis attribute can be overwritten via the global configuration token.</p>\n<p>Defaults to <code>svg</code>.</p>\n',
          line: 132,
          type: 'string',
          decorators: [],
        },
        {
          name: 'loading',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe desired loading behavior (lazy, eager, or auto).\n\nDefaults to `lazy` which is recommended for most images.\n',
          description:
            '<p>The desired loading behavior (lazy, eager, or auto).</p>\n<p>Defaults to <code>lazy</code> which is recommended for most images.</p>\n',
          line: 97,
          type: 'NgOptimizedImage',
          decorators: [],
        },
        {
          required: true,
          name: 'name',
          deprecated: false,
          deprecationMessage: '',
          optional: false,
          rawdescription:
            '\n\nThe name of the illustration.\nThis corresponds to the file name. Supports camelCase, snake_case or kebab-case.\n\nInput is required.\n',
          description:
            '<p>The name of the illustration.\nThis corresponds to the file name. Supports camelCase, snake_case or kebab-case.</p>\n<p>Input is required.</p>\n',
          line: 80,
          type: 'string',
          decorators: [],
        },
        {
          name: 'priority',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIndicates whether this image should have a high priority.\n',
          description: '<p>Indicates whether this image should have a high priority.</p>\n',
          line: 90,
          type: 'NgOptimizedImage',
          decorators: [],
        },
        {
          required: true,
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          optional: false,
          rawdescription:
            '\n\nEither\n - a string indicating the size. For example: `"sm"`, `"md"`\n - an object with dimensions: `{ width, height }`\n\n Input is required.\n',
          description:
            '<p>Either</p>\n<ul>\n<li>a string indicating the size. For example: <code>&quot;sm&quot;</code>, <code>&quot;md&quot;</code></li>\n<li>an object with dimensions: <code>{ width, height }</code></li>\n</ul>\n<p> Input is required.</p>\n',
          line: 159,
          type: 'IllustrationSizeObject',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description:
        '<p>Component that displays an illustration from the Design System visual asset library.</p>\n<h3>Usage</h3>\n<p>If you already have a Backbase app, please follow\n<a href="https://backbase.io/developers/documentation/web-devkit/app-development/configure-static-assets/#_configure_an_application_to_add_static_assets">https://backbase.io/developers/documentation/web-devkit/app-development/configure-static-assets/#_configure_an_application_to_add_static_assets</a> to configure static assets inclusion.</p>\n<p>For this component in particular, you may need to add:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-ts">&quot;assets&quot;: [\n  {\n    &quot;glob&quot;: &quot;**\\/*&quot;,\n    &quot;input&quot;: &quot;node_modules/&#64;backbase/ui-ang/assets&quot;,\n    &quot;output&quot;: &quot;/assets/design-system&quot;\n  }\n]</code></pre></div><h3>Global configuration token</h3>\n<p><code>ILLUSTRATION_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>IllustrationComponent</code> in your project.</p>\n<p><em>Note:</em> The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not be able to overwrite it.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>assetPath</code></li>\n<li><code>fileType</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-ts">import { ILLUSTRATION_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/illustration&#39;;\nimport { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\nimport { AppModule } from &#39;./app/app.module&#39;;\n\nconst illustrationConfig = {\n  fileType: &#39;png&#39;\n}\n\nplatformBrowserDynamic().bootstrapModule(AppModule, {\n  providers: [{ provide: ILLUSTRATION_CONFIG_TOKEN, useValue: illustrationConfig }]\n});</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'IllustrationExampleComponent',
      selector: 'bb-illustration-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-illustration-example-ui',\n  templateUrl: './illustration.example.component.html',\n  standalone: false,\n})\nexport class IllustrationExampleComponent {}\n",
      template: '<bb-illustration-ui\n  name="ic_graph_bar_chart"\n  size="md"\n></bb-illustration-ui>\n',
    },
    {
      name: 'InfiniteScrollComponent',
      selector: 'bb-infinite-scroll-ui',
      inputsClass: [
        {
          name: 'aria-label',
          defaultValue: "'Infinite scrolling content'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 71,
          type: 'string',
          decorators: [],
        },
        {
          name: 'debounce',
          defaultValue: '100',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSpecify debounce duration in ms\n',
          description: '<p>Specify debounce duration in ms</p>\n',
          line: 45,
          type: 'number',
          decorators: [],
        },
        {
          name: 'disableScrollEnd',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf true then `scrollEnd` event should NOT be emitted\n',
          description: '<p>If true then <code>scrollEnd</code> event should NOT be emitted</p>\n',
          line: 50,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'focusable',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSets the focusability of the component. If `value` is true, the component becomes focusable.\nIf `value` is false, the component becomes non-focusable. Component is focusable by default\n',
          description:
            '<p>Sets the focusability of the component. If <code>value</code> is true, the component becomes focusable.\nIf <code>value</code> is false, the component becomes non-focusable. Component is focusable by default</p>\n',
          line: 66,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isLoading',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nTakes a boolean value to indicate the loading state of data\n',
          description: '<p>Takes a boolean value to indicate the loading state of data</p>\n',
          line: 60,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'offset',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe number of pixels from the bottom of the element at which to trigger the `scrollEnd` event.\n',
          description:
            '<p>The number of pixels from the bottom of the element at which to trigger the <code>scrollEnd</code> event.</p>\n',
          line: 40,
          type: 'number',
          decorators: [],
        },
        {
          name: 'scrollContainer',
          defaultValue: "'.infinite-scroll-wrapper'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nTakes a CSS class selector to identify the scrolling element\n',
          description: '<p>Takes a CSS class selector to identify the scrolling element</p>\n',
          line: 55,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'scrollEnd',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent that is triggered when the user has scrolled to the bottom of the element.\n',
          description: '<p>Event that is triggered when the user has scrolled to the bottom of the element.</p>\n',
          line: 35,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [],
      description: '<p>Component that displays an infinite scroll.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InfiniteScrollExampleComponent',
      selector: 'bb-infinite-scroll-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'addItems',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 131,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'loadMore',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 118,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'randGen',
          args: [],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 78,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'sentence',
          args: [],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 82,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-infinite-scroll-example-ui',\n  templateUrl: './infinite-scroll.example.component.html',\n  styles: ['.bb-infinite-scroll-container-showcase { height: 320px; }'],\n  standalone: false,\n})\nexport class InfiniteScrollExampleComponent {\n  page = 0;\n  complete = false;\n  loading = false;\n  sum = 10;\n  items: string[] = [];\n\n  // let verbs, nouns, adjectives, adverbs, preposition;\n  nouns = [\n    'television',\n    'clock',\n    'pizza',\n    'plastic',\n    'mud',\n    'thing',\n    'tire',\n    'river',\n    'tree',\n    'clouds',\n  ];\n  verbs = [\n    'decided',\n    'ran',\n    'flew',\n    'adjusted',\n    'modified',\n    'rolled',\n    'walked',\n    'breathed',\n    'slept',\n    'passsed',\n  ];\n  adjectives = [\n    'beautiful',\n    'lazy',\n    'professional',\n    'lovely',\n    'freat',\n    'healty',\n    'soft',\n    'hot',\n    'fresh',\n    'slimy',\n  ];\n  adverbs = [\n    'slowly',\n    'elegantly',\n    'precisely',\n    'quickly',\n    'sadly',\n    'humbly',\n    'proudly',\n    'shockingly',\n    'calmly',\n    'passionately',\n  ];\n  preposition = [\n    'down',\n    'into',\n    'up',\n    'on',\n    'upon',\n    'below',\n    'above',\n    'through',\n    'across',\n    'towards',\n  ];\n\n  randGen() {\n    return Math.floor(Math.random() * 5);\n  }\n\n  sentence() {\n    const rand1 = Math.floor(Math.random() * 10);\n    const rand2 = Math.floor(Math.random() * 10);\n    const rand3 = Math.floor(Math.random() * 10);\n    const rand4 = Math.floor(Math.random() * 10);\n    const rand5 = Math.floor(Math.random() * 10);\n\n    return (\n      'The ' +\n      this.adjectives[rand1] +\n      ' ' +\n      this.nouns[rand2] +\n      ' ' +\n      this.adverbs[rand3] +\n      ' ' +\n      this.verbs[rand4] +\n      ' because some ' +\n      this.nouns[rand1] +\n      ' ' +\n      this.adverbs[rand1] +\n      ' ' +\n      this.verbs[rand1] +\n      ' ' +\n      this.preposition[rand1] +\n      ' a ' +\n      this.adjectives[rand2] +\n      ' ' +\n      this.nouns[rand5] +\n      '.'\n    );\n  }\n\n  constructor() {\n    this.addItems();\n  }\n\n  loadMore() {\n    if (!this.loading) {\n      this.loading = true;\n      this.page++;\n\n      window.setTimeout(() => {\n        this.loading = false;\n        this.addItems();\n        this.complete = this.page >= 5;\n      }, 1000);\n    }\n  }\n\n  addItems() {\n    for (let i = 0; i < this.sum; ++i) {\n      this.items.push(this.sentence());\n    }\n  }\n}\n",
      template:
        '<div class="row">\n  <div class="col-md-6">\n    <div class="card">\n      <div class="bb-infinite-scroll-container-showcase card-body">\n        <bb-infinite-scroll-ui\n          class="bb-infinite-scroll"\n          (scrollEnd)="loadMore()"\n          [disableScrollEnd]="complete || loading"\n          [offset]="180"\n          [isLoading]="loading"\n        >\n          <div\n            class="bb-list bb-subtitle bb-list--density-sm"\n            [attr.aria-busy]="loading"\n            [class.bb-list--infinite]="!complete"\n          >\n            @for (item of items; track item; let i = $index) {\n              <div class="bb-list__item">\n                <div class="bb-stack">\n                  <div class="bb-stack__item">{{ i }}. {{ item }}</div>\n                </div>\n              </div>\n            }\n          </div>\n          @if (loading) {\n            <div class="bb-block bb-block--md">\n              <bb-loading-indicator-ui\n                loaderSize="md"\n              ></bb-loading-indicator-ui>\n            </div>\n          }\n          @if (complete) {\n            <div class="bb-text-align-center p-3">All items loaded</div>\n          }\n        </bb-infinite-scroll-ui>\n      </div>\n    </div>\n  </div>\n</div>\n',
    },
    {
      name: 'InputCheckboxComponent',
      selector: 'bb-input-checkbox-ui',
      inputsClass: [
        {
          name: 'hideCheckbox',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether checkbox should be rendered.\nThere will be no visual changes but the checkbox will not be interactive.\nUsed for preventing nested interactive control violations for accessibility e.g bb-account-selector-ui.\nDefaults to false.\n',
          description:
            '<p>Whether checkbox should be rendered.\nThere will be no visual changes but the checkbox will not be interactive.\nUsed for preventing nested interactive control violations for accessibility e.g bb-account-selector-ui.\nDefaults to false.</p>\n',
          line: 45,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'indeterminate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe value that represents indeterminate state of checkbox.\n',
          description: '<p>The value that represents indeterminate state of checkbox.</p>\n',
          line: 50,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'indeterminateChange',
          defaultValue: 'new EventEmitter<boolean>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nEvent emitted when the checkbox's `indeterminate` value changes.\n",
          description: '<p>Event emitted when the checkbox&#39;s <code>indeterminate</code> value changes.</p>\n',
          line: 38,
          type: 'EventEmitter<boolean>',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 98,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 83,
          deprecated: false,
          deprecationMessage: '',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setFocus',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 92,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '<p>Component that displays a checkbox input.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputCheckboxExampleComponent',
      selector: 'bb-input-checkbox-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-checkbox-example-ui',\n  templateUrl: './input-checkbox.example.component.html',\n  standalone: false,\n})\nexport class InputCheckboxExampleComponent {\n  vForm: UntypedFormGroup | undefined = this.formBuilder.group({\n    termsConditions: { value: false },\n  });\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <p>\n    <bb-input-checkbox-ui\n      label="I agree with the Terms & Conditions"\n      formControlName="inputCheckbox"\n    ></bb-input-checkbox-ui>\n  </p>\n</form>\n',
    },
    {
      name: 'InputDatepickerComponent',
      selector: 'bb-input-datepicker-ui',
      inputsClass: [
        {
          name: 'ariaLabel',
          defaultValue: "'Datepicker'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nA label for the datepicker that will be used to provide an accessible description of the component.\n',
          description:
            '<p>A label for the datepicker that will be used to provide an accessible description of the component.</p>\n',
          line: 389,
          type: 'string',
          decorators: [],
        },
        {
          name: 'ariaLabelForButton',
          defaultValue: '$localize`:@@bb-input-datepicker-ui.datepicker-button.aria-label:Toggle Date popup`',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label for Datepicker button.\n',
          description: '<p>Accessible label for Datepicker button.</p>\n',
          line: 323,
          type: 'any',
          decorators: [],
        },
        {
          name: 'ariaLabelToDate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label for the second input when the datepicker has a ranged split input.\n',
          description: '<p>Accessible label for the second input when the datepicker has a ranged split input.</p>\n',
          line: 333,
          type: 'string',
          decorators: [],
        },
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe autocomplete value of enclosed input control.\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The autocomplete value of enclosed input control.</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 403,
          type: 'InputDatepickerConfig',
          decorators: [],
        },
        {
          name: 'btnColor',
          deprecated: true,
          deprecationMessage: 'in ui-ang@12 and will be removed in ui-ang@14. No replacement provided.',
          jsdoctags: [
            {
              pos: 13227,
              end: 13314,
              kind: 331,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 13228,
                end: 13238,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'deprecated',
              },
              comment: '<p>in ui-ang@12 and will be removed in ui-ang@14. No replacement provided.</p>\n',
            },
          ],
          rawdescription: '\n\nColor of the button.\n\n',
          description: '<p>Color of the button.</p>\n',
          line: 383,
          type: 'string',
          decorators: [],
        },
        {
          name: 'clickOpen',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIndicates if the datepicker is opened when clicking input.\nDefaults to false\n',
          description: '<p>Indicates if the datepicker is opened when clicking input.\nDefaults to false</p>\n',
          line: 289,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'container',
          defaultValue: 'null',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe container element that the datepicker should be attached to.\n',
          description: '<p>The container element that the datepicker should be attached to.</p>\n',
          line: 260,
          type: 'NgbInputDatepickerConfig',
          decorators: [],
        },
        {
          name: 'datepickerDescribedby',
          defaultValue: 'this.defaultDatepickerDescribedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible description for datepicker date selection popup.\n',
          description: '<p>Accessible description for datepicker date selection popup.</p>\n',
          line: 318,
          type: 'string',
          decorators: [],
        },
        {
          name: 'displayMonths',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIndicates how many month will be shown in the picker\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>Indicates how many month will be shown in the picker</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 437,
          type: 'number',
          decorators: [],
        },
        {
          name: 'firstDayOfWeek',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe first day of the week\n\nBy default, the calendar uses ISO 8601 and the weekdays are is 1=Mon ... 7=Sun\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>The first day of the week</p>\n<p>By default, the calendar uses ISO 8601 and the weekdays are is 1=Mon ... 7=Sun</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 421,
          type: 'InputDatepickerConfig',
          decorators: [],
        },
        {
          name: 'focusOpen',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIndicates if the datepicker is opened when focusing input.\nDefaults to false\n',
          description: '<p>Indicates if the datepicker is opened when focusing input.\nDefaults to false</p>\n',
          line: 295,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'footerTemplate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe reference to the custom template for the datepicker footer.\n',
          description: '<p>The reference to the custom template for the datepicker footer.</p>\n',
          line: 517,
          type: 'ElementRef',
          decorators: [],
        },
        {
          name: 'icon',
          defaultValue: "'calendar-today'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIcon that is displayed in the button.\nDefaults to calendar\n',
          description: '<p>Icon that is displayed in the button.\nDefaults to calendar</p>\n',
          line: 365,
          type: 'string',
          decorators: [],
        },
        {
          name: 'iconColor',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the icon to be displayed.\n',
          description: '<p>The color of the icon to be displayed.</p>\n',
          line: 376,
          type: 'string',
          decorators: [],
        },
        {
          name: 'iconSize',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe size of the icon to be displayed.\nDefaults to md\n',
          description: '<p>The size of the icon to be displayed.\nDefaults to md</p>\n',
          line: 371,
          type: 'string',
          decorators: [],
        },
        {
          name: 'isOpen',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDefines whether or not the datepicker is opened initially.\nDefaults to `false`.\n',
          description:
            '<p>Defines whether or not the datepicker is opened initially.\nDefaults to <code>false</code>.</p>\n',
          line: 528,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'labelTo',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe label for the second input when the datepicker has a ranged split input. Defaults to an empty string.\n',
          description:
            '<p>The label for the second input when the datepicker has a ranged split input. Defaults to an empty string.</p>\n',
          line: 328,
          type: 'string',
          decorators: [],
        },
        {
          name: 'markDisabled',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nCallback to mark a given date as disabled.\n',
          description: '<p>Callback to mark a given date as disabled.</p>\n',
          line: 359,
          type: 'Function',
          decorators: [],
        },
        {
          name: 'mask',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nMask configuration (optional). The default value is false\nMask can be:\n 1- enabled: when set from template to boolean true to create mask, or false (default is false if left unset).\n 2- validated: when set from template to some string date pattern such as `00/00/0000` or `SSS 00, 0000`.\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>Mask configuration (optional). The default value is false\nMask can be:\n 1- enabled: when set from template to boolean true to create mask, or false (default is false if left unset).\n 2- validated: when set from template to some string date pattern such as <code>00/00/0000</code> or <code>SSS 00, 0000</code>.\nThis attribute can be overwritten via the global configuration token</p>\n',
          line: 455,
          type: 'InputDatepickerConfig',
          decorators: [],
        },
        {
          name: 'maxDate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nMax date for the navigation. If not provided, 'year' select box will display 10 years\nafter current month.\n",
          description:
            '<p>Max date for the navigation. If not provided, &#39;year&#39; select box will display 10 years\nafter current month.</p>\n',
          line: 351,
          type: 'NgbDateStruct | string | undefined',
          decorators: [],
        },
        {
          name: 'minDate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nMin date for the navigation. If not provided, 'year' select box will display 10 years\nbefore current month\n",
          description:
            '<p>Min date for the navigation. If not provided, &#39;year&#39; select box will display 10 years\nbefore current month</p>\n',
          line: 340,
          type: 'NgbDateStruct | string | undefined',
          decorators: [],
        },
        {
          name: 'navigation',
          defaultValue: "'arrows'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nNavigation pattern through dates.\nDefault to arrows\n',
          description: '<p>Navigation pattern through dates.\nDefault to arrows</p>\n',
          line: 395,
          type: '"select" | "arrows" | "none"',
          decorators: [],
        },
        {
          name: 'overrideDateFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nOverride date format (optional). Supported formats are `yyyy/MM/dd`, `MM/dd/yyyy`, `MMMM dd, yyyy`.\nNote, other formats might work inconsistent in different browsers.\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>Override date format (optional). Supported formats are <code>yyyy/MM/dd</code>, <code>MM/dd/yyyy</code>, <code>MMMM dd, yyyy</code>.\nNote, other formats might work inconsistent in different browsers.</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 503,
          type: 'InputDatepickerConfig',
          decorators: [],
        },
        {
          name: 'placeholder',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe placeholder for the datepicker input. Default is Locale Date Format;\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The placeholder for the datepicker input. Default is Locale Date Format;</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 478,
          type: '',
          decorators: [],
        },
        {
          name: 'placement',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nPlacement of a popup window\n',
          description: '<p>Placement of a popup window</p>\n',
          line: 307,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'rangeSelection',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIndicates whether the datepicker should allow selecting a date range with a single input.\nThe default value is `false`.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>Indicates whether the datepicker should allow selecting a date range with a single input.\nThe default value is <code>false</code>.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 269,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'rangeSelectionSplit',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIndicates if the datepicker should a date range with split input. One for the from date and one for the to date.\nDefaults to false\n',
          description:
            '<p>Indicates if the datepicker should a date range with split input. One for the from date and one for the to date.\nDefaults to false</p>\n',
          line: 283,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'startDate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe date to open calendar with.\n',
          description: '<p>The date to open calendar with.</p>\n',
          line: 522,
          type: 'NgDateStructNullable',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'focusedDate',
          defaultValue: 'new EventEmitter<DateSelectionModel>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEvent that is emitted when a date is focused.\nThe event payload is a `DateSelectionModel`.\n',
          description:
            '<p>Event that is emitted when a date is focused.\nThe event payload is a <code>DateSelectionModel</code>.</p>\n',
          line: 255,
          type: 'EventEmitter',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'autoMask',
          args: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 810,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nif mask for element is set, transform (constrain) input pattern accordingly\n',
          description: '<p>if mask for element is set, transform (constrain) input pattern accordingly</p>\n',
          jsdoctags: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'bindDocumentEvents',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1311,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nBinds event on the global document when the datepicker is not opened\n',
          description: '<p>Binds event on the global document when the datepicker is not opened</p>\n',
        },
        {
          name: 'closeDatePicker',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1237,
          deprecated: false,
          deprecationMessage: '',
          modifierKind: [124],
        },
        {
          name: 'createOrValidateMask',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 693,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\ncreateOrValidateMask\n 1- sets overrideDateFormat to be dateFormat in case it's undefined\n 2- if mask property is boolean and value is true, then createMask()\n 3- else, validateMask()\n",
          description:
            '<p>createOrValidateMask\n 1- sets overrideDateFormat to be dateFormat in case it&#39;s undefined\n 2- if mask property is boolean and value is true, then createMask()\n 3- else, validateMask()</p>\n',
        },
        {
          name: 'handleDocumentEvent',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent | MouseEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1292,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDocument Event handler\n',
          description: '<p>Document Event handler</p>\n',
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent | MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1019,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for blur on the host control.\n\n',
          description: '<p>Event handler for blur on the host control.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 31695,
                end: 31701,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: '$event',
              },
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                pos: 31689,
                end: 31694,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onClosed',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1030,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\nEvent handler for closing `from` or single date picker.\n\n',
          description: '<p>Event handler for closing <code>from</code> or single date picker.</p>\n',
          jsdoctags: [],
        },
        {
          name: 'onClosedTo',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1052,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for closing picker for `to` date.\n',
          description: '<p>Event handler for closing picker for <code>to</code> date.</p>\n',
        },
        {
          name: 'onControlBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1000,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler blur on internal inputs and buttons\n\n',
          description: '<p>Event handler blur on internal inputs and buttons</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 31253,
                end: 31259,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: '$event',
              },
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 31247,
                end: 31252,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'onDayHover',
          args: [
            {
              name: 'event',
              type: 'literal type',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1117,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\nHandling day-hover from day-template on range selection.\n\n',
          description: '<p>Handling day-hover from day-template on range selection.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 34360,
                end: 34365,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'event',
              },
              type: 'literal type',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 34354,
                end: 34359,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'onInputChange',
          args: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 866,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nInput change handler for single date\n\n',
          description: '<p>Input change handler for single date</p>\n',
          jsdoctags: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onInputChangeRange',
          args: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 888,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nUpdate datepicker value on input value change for same input date range selection\n\n',
          description: '<p>Update datepicker value on input value change for same input date range selection</p>\n',
          jsdoctags: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onInputChangeSplitRange',
          args: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 908,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nUpdate datepicker value on input value change for split input date range selection, from date\n\n',
          description:
            '<p>Update datepicker value on input value change for split input date range selection, from date</p>\n',
          jsdoctags: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onInputChangeSplitRangeTo',
          args: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 921,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nUpdate datepicker value on input value change for split input date range selection, to date.\n\n',
          description:
            '<p>Update datepicker value on input value change for split input date range selection, to date.</p>\n',
          jsdoctags: [
            {
              name: 'element',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onInputFocus',
          args: [
            {
              name: 'open',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 932,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for the native input.\n',
          description: '<p>Event handler for the native input.</p>\n',
          jsdoctags: [
            {
              name: 'open',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onInputFocusTo',
          args: [
            {
              name: 'open',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 948,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for the native input\n',
          description: '<p>Event handler for the native input</p>\n',
          jsdoctags: [
            {
              name: 'open',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onPickerTogglerClick',
          args: [
            {
              name: 'event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 959,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for the picker toggle button to\n',
          description: '<p>Event handler for the picker toggle button to</p>\n',
          jsdoctags: [
            {
              name: 'event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onPickerTogglerClickTo',
          args: [
            {
              name: 'event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 971,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for the picker toggle button to (split range selection)\n',
          description: '<p>Event handler for the picker toggle button to (split range selection)</p>\n',
          jsdoctags: [
            {
              name: 'event',
              type: 'Event',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onRangeDateSelect',
          args: [
            {
              name: 'date',
              type: 'NgbDate',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1089,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n Event handler for date setting from picker when single input range selection\n\n',
          description: '<p> Event handler for date setting from picker when single input range selection</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 33532,
                end: 33536,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'date',
              },
              type: 'NgbDate',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 33526,
                end: 33531,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'onRangeDateSelectSplit',
          args: [
            {
              name: 'date',
              type: 'NgbDate',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1076,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEvent handler for date setting from picker for `from` date when split input range selection\n\n',
          description:
            '<p>Event handler for date setting from picker for <code>from</code> date when split input range selection</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 33212,
                end: 33216,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'date',
              },
              type: 'NgbDate',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 33206,
                end: 33211,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'onRangeDateSelectSplitTo',
          args: [
            {
              name: 'date',
              type: 'NgbDate',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1063,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEvent handler for date setting from picker for `to` date when split input range selection\n\n',
          description:
            '<p>Event handler for date setting from picker for <code>to</code> date when split input range selection</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 32878,
                end: 32882,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'date',
              },
              type: 'NgbDate',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 32872,
                end: 32877,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 986,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\nSet disable state for the host control\n\n',
          description: '<p>Set disable state for the host control</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 30961,
                end: 30971,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'isDisabled',
              },
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 30955,
                end: 30960,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'toggleCalendarAriaLabel',
          args: [
            {
              name: 'isDateTo',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 1413,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDateTo',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'model',
              type: 'DateRangeModel | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 1180,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\nImplements the value update for the control\n\n',
          description: '<p>Implements the value update for the control</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 36260,
                end: 36265,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'model',
              },
              type: 'DateRangeModel | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 36254,
                end: 36259,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that displays a datepicker</p>\n<h3>Custom internationalization</h3>\n<p>It is possible to provide a custom internalization. To do this, a <code>DATEPICKER_I18</code> token from <code>@backbase/ui-ang/input-datepicker</code> should be provided on the module level.\nThe token should implement the <a href="https://ng-bootstrap.github.io/#/components/datepicker/api#NgbDatepickerI18n">NgbDatepickerI18n</a> interface.</p>\n<h3>Setting and reading the date</h3>\n<p><em>Note</em> Datepicker uses the date <em>with the timezone</em> inside its model. And hence to make it work properly in all cases there are some recommendations for setting and reading the date to and from the datepicker.</p>\n<h4>Setting the date</h4>\n<p>When setting the date to the datepicker the date must be provided in the format that assumes zero hours and zero minutes in the local timezone. Here are some examples of what the date setting should looks like:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">this.minDate = new Date(2021, 11, 15, 0, 0).toISOString();</code></pre></div><p>or</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">this.minDate = new Date(&#39;2021-12-15T00:00&#39;).toISOString();</code></pre></div><p>Note that</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">new Date(&#39;2021-12-15&#39;).toISOString();</code></pre></div><p>generates a date in GMT0 format and that is not correct for the datepicker input date.</p>\n<h4>Reading the date</h4>\n<p>When a date is selected via UI (the datepicker&#39;s popup window or browser&#39;s input field) its display date is transformed to the ISO string date with the assumption that it’s zero hours and zero minutes in the current time zone. Which leads to the different ISO string values for different time zones for the same date. F.e. &quot;Dec 15 2021&quot; is going to be transformed to &quot;2021-12-14T23:00:00.000Z&quot; for the &quot;GMT+0100 (Central European Standard Time)&quot; time zone and to &quot;2021-12-15T03:00:00.000Z&quot; for &quot;GMT-0300 (West Greenland Standard Time)&quot; time zone. As you can see the <em>day</em> value is different in ISO string based on the timezone. It’s going to be either 14 or 15 in the example above.</p>\n<p>The recommendation here is to convert the ISO string, that the datepicker returns, into the Date object and read its day value. Here is an example:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">private formatDate(stringDate: string): string {\n  const date = new Date(stringDate);\n  if (stringDate &amp;&amp; !isNaN(date.valueOf())) {\n    return `${date.getFullYear()}-${this.appendLeadingZeroes(date.getMonth() + 1)}-${this.appendLeadingZeroes(date.getDate())}`;\n  }\n  return &#39;&#39;;\n}\n\nprivate appendLeadingZeroes(value: number): string {\n  return value &gt; 9 ? value.toString() : `0${value}`;\n}</code></pre></div><h3>Setting the mask</h3>\n<p>When setting the mask, the following rules/expectations apply:</p>\n<ul>\n<li>mask can be set to boolean true/false, or to some string pattern like 00/00/0000</li>\n<li>when mask is set, if overrideDateFormat is not set in the template, it&#39;s set inside the component to be dateFormat</li>\n</ul>\n<p>Rules when mask is set to true in the template:</p>\n<ul>\n<li>when mask is set to true, it will be reset to an overrideDateFormat-compliant-string-pattern that&#39;s created in the component</li>\n<li>if overrideDateFormat is not mask compliant (e.g., has one digit for days or months), overrideDateFormat is adjusted first</li>\n</ul>\n<p>Rules when mask is set to some string pattern in the template:</p>\n<ul>\n<li>string patterns are made of a subset of allowed ngx-mask characters 0&#39;s and S&#39;s only - see <a href="https://www.npmjs.com/package/ngx-mask">https://www.npmjs.com/package/ngx-mask</a></li>\n<li>In the above, 0 is used to be a placeholder for digits, and S for letters</li>\n<li>Typical date separators such as these in [ / , sp - ] are allowed in the created/provided mask pattern</li>\n<li>If created/provided mask pattern is not compliant with overrideDateFormat, component is invalidated and mask is set to be undefined</li>\n</ul>\n<p>Examples when mask is set to true in the template (e.g., [mask]=&quot;true&quot;)</p>\n<ul>\n<li>if overrideDateFormat = &#39;dd/MM/yyyy&#39; or &#39;MM/dd/yyyy&#39;, created mask will be &#39;00/00/0000&#39;</li>\n<li>if overrideDateFormat = &#39;MMM dd, yy&#39;, created mask will be &#39;SSS 00, 00&#39;</li>\n<li>if dateFormat = &#39;M/d/yy&#39;, then overrideDateFormat is corrected to &#39;MM/dd/yy&#39; and created mask will be &#39;00/00/00&#39;</li>\n</ul>\n<p>Examples when mask is set to some string pattern (e.g., [mask]=&quot;&#39;00/00/00&#39;&quot;)</p>\n<ul>\n<li>in this setting, overrideDateFormat is not adjusted, only validation occurs here</li>\n<li>if overrideDateFormat = &#39;yyyy-MMM-00&#39; and template-set mask = &#39;0000-SSS-00&#39;, mask is validated and accepted</li>\n<li>if overrideDateFormat = &#39;yyyy-MMM-00&#39; and template-set mask = &#39;0000-000-00&#39;, mask is rejected (because there are no three-digit months), set to undefined, and element is errored</li>\n</ul>\n<h3>Global configuration token</h3>\n<p><code>INPUT_DATEPICKER_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>InputDatepickerComponent</code> in your project.</p>\n<p><em>Note:</em> The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not able to overwrite it.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>autocomplete</code></li>\n<li><code>displayMonths</code></li>\n<li><code>firstDayOfWeek</code></li>\n<li><code>overrideDateFormat</code></li>\n<li><code>placeholder</code></li>\n<li><code>rangeSelection</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">import { INPUT_DATEPICKER_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/input-datepicker&#39;;\nimport { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\nimport { AppModule } from &#39;./app/app.module&#39;;\n\nconst inputDatepickerConfig = {\n  firstDayOfWeek: 1\n}\n\nplatformBrowserDynamic().bootstrapModule(AppModule, {\n  providers: [{ provide: INPUT_DATEPICKER_CONFIG_TOKEN, useValue: inputDatepickerConfig }]\n});</code></pre></div><h3>Accessibility</h3>\n<p>The component provides options to pass needed accessibility\nattributes. You need to take care of properties that are required in your case:</p>\n<ul>\n<li><code>role</code> describes the role of the element in programs like screen readers</li>\n<li><code>aria-activedescendant</code> identifies the currently active element</li>\n<li><code>aria-describedby</code> identifies the element that describes the component</li>\n<li><code>aria-expanded</code> is set on an element to indicate if the datepicker is expanded or collapsed</li>\n<li><code>aria-invalid</code> state indicates the entered value does not conform to the format expected</li>\n<li><code>aria-label</code> defines a string value that labels the component</li>\n<li><code>aria-labelledby</code> identifies the element that labels the component</li>\n<li><code>aria-owns</code> identifies an element in order to define a visual, functional, or contextual relationship</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputDatepickerDayTemplateRangeComponent',
      selector: 'bb-input-datepicker-range-day-template-ui',
      inputsClass: [
        {
          name: 'currentMonth',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nCurrentMonth on the datepicker window.\n',
          description: '<p>CurrentMonth on the datepicker window.</p>\n',
          line: 59,
          type: 'string',
          decorators: [],
        },
        {
          name: 'date',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDate to render.\n',
          description: '<p>Date to render.</p>\n',
          line: 49,
          type: 'NgbDate',
          decorators: [],
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhen true the date is rendered as disabled.\n',
          description: '<p>When true the date is rendered as disabled.</p>\n',
          line: 54,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'fromDate',
          defaultValue: 'null',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSelected "from" date.\n',
          description: '<p>Selected &quot;from&quot; date.</p>\n',
          line: 64,
          type: 'NgDateStructNullable',
          decorators: [],
        },
        {
          name: 'hoveredDate',
          defaultValue: 'null',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nHovered date by a user\n',
          description: '<p>Hovered date by a user</p>\n',
          line: 85,
          type: 'NgDateStructNullable',
          decorators: [],
        },
        {
          name: 'splitRange',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf "true" the datepicker is displayed with two input fields for "from" and "to" dates\n',
          description:
            '<p>If &quot;true&quot; the datepicker is displayed with two input fields for &quot;from&quot; and &quot;to&quot; dates</p>\n',
          line: 74,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'toDate',
          defaultValue: 'null',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSelected "to" date\n',
          description: '<p>Selected &quot;to&quot; date</p>\n',
          line: 69,
          type: 'NgDateStructNullable',
          decorators: [],
        },
        {
          name: 'toDateDatepicker',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\n"true" when "splitRange" is "true" and the parent datepicker belongs to\nsecond datepicker input (the one for "to" date)\n',
          description:
            '<p>&quot;true&quot; when &quot;splitRange&quot; is &quot;true&quot; and the parent datepicker belongs to\nsecond datepicker input (the one for &quot;to&quot; date)</p>\n',
          line: 80,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'hovered',
          defaultValue: 'new EventEmitter<DateRangeSelectionModel>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent to trigger on date hover.\n',
          description: '<p>Event to trigger on date hover.</p>\n',
          line: 95,
          type: 'EventEmitter',
        },
        {
          name: 'rangeSelect',
          defaultValue: 'new EventEmitter<RangeSelectModel>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits an event when a range is selected\n',
          description: '<p>Emits an event when a range is selected</p>\n',
          line: 90,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'onKeyUp',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 238,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nKeypress handler\n\n',
          description: '<p>Keypress handler</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'document:keyup', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onMouseOut',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 213,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\nHandle mouseover. Emit the hovered date with null.\n\n',
          description: '<p>Handle mouseover. Emit the hovered date with null.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'mouseout'",
            },
          ],
          modifierKind: [170],
          jsdoctags: [],
        },
        {
          name: 'onMouseOver',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 224,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\nHandle mouseover. Emit the hovered date with date.\n\n',
          description: '<p>Handle mouseover. Emit the hovered date with date.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'mouseover'",
            },
          ],
          modifierKind: [170],
          jsdoctags: [],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputDatepickerDayTemplateSingleComponent',
      selector: 'bb-input-datepicker-single-day-template-ui',
      inputsClass: [
        {
          name: 'currentMonth',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe current month on the datepicker window.\n',
          description: '<p>The current month on the datepicker window.</p>\n',
          line: 71,
          type: 'string',
          decorators: [],
        },
        {
          name: 'date',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDate to render.\n',
          description: '<p>Date to render.</p>\n',
          line: 56,
          type: 'NgbDate',
          decorators: [],
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhen true the date is rendered as disabled\n',
          description: '<p>When true the date is rendered as disabled</p>\n',
          line: 66,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'hoveredDate',
          defaultValue: 'null',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nHovered date by a user.\n',
          description: '<p>Hovered date by a user.</p>\n',
          line: 76,
          type: 'NgDateStructNullable',
          decorators: [],
        },
        {
          name: 'selected',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIndicates whether the date is selected\n',
          description: '<p>Indicates whether the date is selected</p>\n',
          line: 61,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'hovered',
          defaultValue: 'new EventEmitter<DateSelectionModel>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent to trigger on date hover.\n',
          description: '<p>Event to trigger on date hover.</p>\n',
          line: 81,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'onKeyUp',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 139,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nKeypress handler\n\n',
          description: '<p>Keypress handler</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'document:keyup', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onMouseOut',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 114,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\nHandle mouseover. Emit the hovered date with null.\n\n',
          description: '<p>Handle mouseover. Emit the hovered date with null.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'mouseout'",
            },
          ],
          modifierKind: [170],
          jsdoctags: [],
        },
        {
          name: 'onMouseOver',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 125,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n\nHandle mouseover. Emit the hovered date with date.\n\n',
          description: '<p>Handle mouseover. Emit the hovered date with date.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'mouseover'",
            },
          ],
          modifierKind: [170],
          jsdoctags: [],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputDatepickerExampleComponent',
      selector: 'bb-input-datepicker-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-input-datepicker-example-ui',\n  templateUrl: './input-datepicker.example.component.html',\n  standalone: false,\n})\nexport class InputDatepickerExampleComponent {\n  transferDate = '2024-12-25T00:00:00.000Z';\n}\n",
      template:
        '<bb-input-datepicker-ui\n  label="Schedule transfer"\n  [(ngModel)]="transferDate"\n></bb-input-datepicker-ui>\n',
    },
    {
      name: 'InputEmailComponent',
      selector: 'bb-input-email-ui',
      inputsClass: [
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe autocomplete value of enclosed input control.\nIf not set, 'email' is used.\nThis attribute can be overwritten via the global configuration token\n",
          description:
            '<p>The autocomplete value of enclosed input control.\nIf not set, &#39;email&#39; is used.\nThis attribute can be overwritten via the global configuration token</p>\n',
          line: 161,
          type: '"email" | "off" | "on"',
          decorators: [],
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe maxLength for the email input.\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The maxLength for the email input.</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 125,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'minLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe minLength for the email input.\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The minLength for the email input.</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 141,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'pattern',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe validation pattern for the email input. Defaults to undefined, resulting\nin the validation check using the built-in Angular validator, Validators.email(control).\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The validation pattern for the email input. Defaults to undefined, resulting\nin the validation check using the built-in Angular validator, Validators.email(control).</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 178,
          type: 'string | RegExp | undefined',
          decorators: [],
        },
        {
          name: 'placeholder',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe placeholder for the email input. Defaults to an empty string;\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The placeholder for the email input. Defaults to an empty string;</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 99,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the email input is readonly.\n',
          description: '<p>Whether the email input is readonly.</p>\n',
          line: 153,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe size for the email input. Defaults to an empty string;\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The size for the email input. Defaults to an empty string;</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 115,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'validate',
          args: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'ValidationErrors | null',
          typeParameters: [],
          line: 202,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that displays an email input.</p>\n<h3>Global configuration token</h3>\n<p><code>INPUT_EMAIL_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of <code>InputEmailComponent</code> instances in your project.</p>\n<p><em>Note:</em> The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not be able to overwrite it.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>autocomplete</code></li>\n<li><code>maxLength</code></li>\n<li><code>minLength</code></li>\n<li><code>placeholder</code></li>\n<li><code>size</code></li>\n<li><code>pattern</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript"> import { INPUT_EMAIL_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/input-email&#39;;\n import { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\n import { AppModule } from &#39;./app/app.module&#39;;\n\n const inputEmailConfig = {\n   autocomplete: &#39;email&#39;\n }\n\n platformBrowserDynamic().bootstrapModule(AppModule, {\n   providers: [{ provide: INPUT_EMAIL_CONFIG_TOKEN, useValue: inputEmailConfig }]\n });</code></pre></div><h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputEmailExampleComponent',
      selector: 'bb-input-email-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-email-example-ui',\n  templateUrl: './input-email.example.component.html',\n  standalone: false,\n})\nexport class InputEmailExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    email: ['info@example.com', Validators.required],\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <bb-input-email-ui\n    label="E-mail address"\n    formControlName="email"\n    placeholder="Please enter a value..."\n  >\n  </bb-input-email-ui>\n</form>\n',
    },
    {
      name: 'InputFileComponent',
      selector: 'bb-input-file-ui',
      inputsClass: [
        {
          name: 'accept',
          defaultValue: "'*'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nAccepted file formats. Defaults to any ('*');\n",
          description: '<p>Accepted file formats. Defaults to any (&#39;*&#39;);</p>\n',
          line: 47,
          type: 'string',
          decorators: [],
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThis Boolean attribute lets you specify that the button should have input focus when the page\nloads, unless the user overrides it, for example by typing in a different control. Only one\nform-associated element in a document can have this attribute specified. Defaults to false.\n',
          description:
            '<p>This Boolean attribute lets you specify that the button should have input focus when the page\nloads, unless the user overrides it, for example by typing in a different control. Only one\nform-associated element in a document can have this attribute specified. Defaults to false.</p>\n',
          line: 69,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'buttonSize',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nSize of the button. Defaults to 'md'.\n",
          description: '<p>Size of the button. Defaults to &#39;md&#39;.</p>\n',
          line: 79,
          type: '"sm" | "md"',
          decorators: [],
        },
        {
          name: 'buttonText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nButton text. If set, change button text from default 'Attach file' to a custom one.\n",
          description:
            '<p>Button text. If set, change button text from default &#39;Attach file&#39; to a custom one.</p>\n',
          line: 74,
          type: 'string',
          decorators: [],
        },
        {
          name: 'color',
          defaultValue: "'link'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nButton color. Defaults to 'link';\n",
          description: '<p>Button color. Defaults to &#39;link&#39;;</p>\n',
          line: 62,
          type: 'ButtonColor | string',
          decorators: [],
        },
        {
          name: 'iconName',
          defaultValue: "'attachment'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nButton icon name. Defaults to 'attachment';\n",
          description: '<p>Button icon name. Defaults to &#39;attachment&#39;;</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
        },
        {
          name: 'maxSizeInMb',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf set, validate according to the maximum file size in Megabytes.\n',
          description: '<p>If set, validate according to the maximum file size in Megabytes.</p>\n',
          line: 52,
          type: 'number | string',
          decorators: [],
        },
        {
          name: 'multiple',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMultiple/single file upload flag. Defaults to false;\n',
          description: '<p>Multiple/single file upload flag. Defaults to false;</p>\n',
          line: 57,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'onValueChange',
          args: [
            {
              name: 'input',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 97,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'input',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'validate',
          args: [],
          optional: false,
          returnType: 'ValidationErrors | null',
          typeParameters: [],
          line: 106,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that displays a file input button.</p>\n<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputFileExampleComponent',
      selector: 'bb-input-file-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-file-example-ui',\n  templateUrl: './input-file.example.component.html',\n  standalone: false,\n})\nexport class InputFileExampleComponent {\n  vForm: UntypedFormGroup | undefined;\n\n  constructor(private formBuilder: UntypedFormBuilder) {\n    this.vForm = this.formBuilder.group({\n      fileInput: undefined,\n    });\n  }\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <div class="bb-block bb-block--lg">\n    <bb-input-file-ui\n      label="File input"\n      formControlName="fileInput"\n      data-role="file-input"\n    >\n    </bb-input-file-ui>\n  </div>\n</form>\n',
    },
    {
      name: 'InputInlineEditComponent',
      selector: 'bb-input-inline-edit-ui',
      inputsClass: [
        {
          name: 'ariaLabelAccept',
          defaultValue: 'defaultAriaLabels.accept',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nstring for aria label on Accept button\n',
          description: '<p>string for aria label on Accept button</p>\n',
          line: 149,
          type: 'any',
          decorators: [],
        },
        {
          name: 'ariaLabelCancel',
          defaultValue: 'defaultAriaLabels.cancel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nstring for aria label on Cancel button\n',
          description: '<p>string for aria label on Cancel button</p>\n',
          line: 154,
          type: 'any',
          decorators: [],
        },
        {
          name: 'ariaLabelEdit',
          defaultValue: 'defaultAriaLabels.edit',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nstring for aria label on Edit button\n',
          description: '<p>string for aria label on Edit button</p>\n',
          line: 159,
          type: 'any',
          decorators: [],
        },
        {
          name: 'ariaLabelInput',
          defaultValue: 'defaultAriaLabels.input',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nstring for aria label on edit input\n',
          description: '<p>string for aria label on edit input</p>\n',
          line: 164,
          type: 'any',
          decorators: [],
        },
        {
          name: 'autocomplete',
          defaultValue: "'off'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe autocomplete value of the enclosed input control.\n',
          description: '<p>The autocomplete value of the enclosed input control.</p>\n',
          line: 184,
          type: 'string',
          decorators: [],
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 130,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'canEdit',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 2185,
              end: 2203,
              kind: 327,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 2186,
                end: 2193,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'default',
              },
              comment: '<p>: true</p>\n',
            },
          ],
          rawdescription: '\n\nFlag represents visibility of edit button\n\n',
          description: '<p>Flag represents visibility of edit button</p>\n',
          line: 85,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to consider the input value as a currency\n',
          description: '<p>Whether to consider the input value as a currency</p>\n',
          line: 204,
          type: 'string',
          decorators: [],
        },
        {
          name: 'hasLoadingState',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 2301,
              end: 2320,
              kind: 327,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 2302,
                end: 2309,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'default',
              },
              comment: '<p>: false</p>\n',
            },
          ],
          rawdescription: '\n\nApplies additional loading state for edit flow\n\n',
          description: '<p>Applies additional loading state for edit flow</p>\n',
          line: 91,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'hint',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nHint to be displayed in edit mode\n',
          description: '<p>Hint to be displayed in edit mode</p>\n',
          line: 194,
          type: 'string',
          decorators: [],
        },
        {
          name: 'inputInlineTemplate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nTemplate for custom and styling text\n',
          description: '<p>Template for custom and styling text</p>\n',
          line: 95,
          type: 'TemplateRef<InputInlineEditComponent> | undefined',
          decorators: [],
        },
        {
          name: 'inputText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nstring for editing\n',
          description: '<p>string for editing</p>\n',
          line: 99,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'maxLength',
          defaultValue: 'Infinity',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maxLength for the text input.\n',
          description: '<p>The maxLength for the text input.</p>\n',
          line: 110,
          type: 'any',
          decorators: [],
        },
        {
          name: 'maxValue',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n The max number value of the text input\n',
          description: '<p> The max number value of the text input</p>\n',
          line: 120,
          type: 'number',
          decorators: [],
        },
        {
          name: 'minLength',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe minLength for the text input.\n',
          description: '<p>The minLength for the text input.</p>\n',
          line: 115,
          type: 'number',
          decorators: [],
        },
        {
          name: 'minValue',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\n The min number value of the text input\n',
          description: '<p> The min number value of the text input</p>\n',
          line: 125,
          type: 'number',
          decorators: [],
        },
        {
          name: 'pattern',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should follow a pattern.\n',
          description: '<p>Whether the text input should follow a pattern.</p>\n',
          line: 189,
          type: 'RegExp | string',
          decorators: [],
        },
        {
          name: 'patternErrorMessage',
          defaultValue: "'Input value provided is invalid'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDisplays custom error message for pattern validation failure.\n',
          description: '<p>Displays custom error message for pattern validation failure.</p>\n',
          line: 135,
          type: 'string',
          decorators: [],
        },
        {
          name: 'showCharCounter',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nShows character counter based on `maxLength`\n',
          description: '<p>Shows character counter based on <code>maxLength</code></p>\n',
          line: 199,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'state',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nState for inline edit\n',
          description: '<p>State for inline edit</p>\n',
          line: 69,
          type: 'InputInlineEditState',
          decorators: [],
        },
        {
          name: 'tooltipAccept',
          defaultValue: 'defaultTooltips.accept',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nstring for tooltip on Accept button\n',
          description: '<p>string for tooltip on Accept button</p>\n',
          line: 169,
          type: 'any',
          decorators: [],
        },
        {
          name: 'tooltipCancel',
          defaultValue: 'defaultTooltips.cancel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nstring for tooltip on Cancel button\n',
          description: '<p>string for tooltip on Cancel button</p>\n',
          line: 174,
          type: 'any',
          decorators: [],
        },
        {
          name: 'tooltipEdit',
          defaultValue: 'defaultTooltips.edit',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nstring for tooltip on Edit button\n',
          description: '<p>string for tooltip on Edit button</p>\n',
          line: 179,
          type: 'any',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'accept',
          defaultValue: 'new EventEmitter<string>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe event that's fired after on Accept.\n",
          description: '<p>The event that&#39;s fired after on Accept.</p>\n',
          line: 144,
          type: 'EventEmitter',
        },
        {
          name: 'cancel',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe event that's fired after on Cancel.\n",
          description: '<p>The event that&#39;s fired after on Cancel.</p>\n',
          line: 140,
          type: 'EventEmitter',
        },
        {
          name: 'stateChange',
          defaultValue: 'new EventEmitter<InputInlineEditState>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmit on edit state changes\n',
          description: '<p>Emit on edit state changes</p>\n',
          line: 79,
          type: 'EventEmitter',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'hasError',
          args: [
            {
              name: 'type',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'boolean | undefined',
          typeParameters: [],
          line: 321,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'type',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onAccept',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 309,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEmits the updated value from input\n\nIf the {@link InputInlineEditComponent.hasLoadingState } set to true -> the state is not changed,\nas component state should be updated from outside, otherwise the value will be updated with the\nnew one and state will be switched to `IDLE`\n\n',
          description:
            '<p>Emits the updated value from input</p>\n<p>If the {@link InputInlineEditComponent.hasLoadingState } set to true -&gt; the state is not changed,\nas component state should be updated from outside, otherwise the value will be updated with the\nnew one and state will be switched to <code>IDLE</code></p>\n',
        },
        {
          name: 'onCancel',
          args: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onEdit',
          args: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 273,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onKeydownHandler',
          args: [
            {
              name: 'evt',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 335,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nCancels the edit mode when the escape key is pressed.\n\n',
          description: '<p>Cancels the edit mode when the escape key is pressed.</p>\n',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'document:keydown.escape', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: {
                pos: 8000,
                end: 8003,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'evt',
              },
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 7994,
                end: 7999,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>The keyboard event.</p>\n',
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n<p>Component that enables inline input editing.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputInlineEditExampleComponent',
      selector: 'bb-input-inline-edit-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onAcceptDescription',
          args: [
            {
              name: 'description',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 16,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'description',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-inline-edit-example-ui',\n  templateUrl: './input-inline-edit.example.component.html',\n  standalone: false,\n})\nexport class InputInlineEditExampleComponent {\n  form: UntypedFormGroup = this.formBuilder.group({\n    description: ['Monthly Rent'],\n  });\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {}\n\n  onAcceptDescription(description: any) {\n    this.form.patchValue({\n      description,\n    });\n  }\n}\n",
      template:
        '<form [formGroup]="form">\n  <bb-input-inline-edit-ui\n    [inputText]="form.get(\'description\')?.value"\n    [maxLength]="64"\n    [minLength]="2"\n    [required]="true"\n    (accept)="onAcceptDescription($event)"\n  >\n  </bb-input-inline-edit-ui>\n</form>\n',
    },
    {
      name: 'InputNumberComponent',
      selector: 'bb-input-number-ui',
      inputsClass: [
        {
          name: 'allowNegativeSign',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIf `true` then the under-laying input control will allow negative sign as well.\nKnown issue is that it is possible to insert the negative sign anywhere in the field, not only at the beginning.\nInserting the negative sign after a digit will render the value empty.\n',
          description:
            '<p>If <code>true</code> then the under-laying input control will allow negative sign as well.\nKnown issue is that it is possible to insert the negative sign anywhere in the field, not only at the beginning.\nInserting the negative sign after a digit will render the value empty.</p>\n',
          line: 114,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'allowNonDigits',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf `true` then the under-laying input control will behave as a default number input.\n',
          description:
            '<p>If <code>true</code> then the under-laying input control will behave as a default number input.</p>\n',
          line: 107,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'ariaLabel',
          defaultValue: '$localize`:@@bb-input-number-ui.input-number.aria-label:Number Input`',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nText used to describe the number input for screen readers.\n',
          description: '<p>Text used to describe the number input for screen readers.</p>\n',
          line: 101,
          type: 'any',
          decorators: [],
        },
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe autocomplete value of the enclosed input control.\n',
          description: '<p>The autocomplete value of the enclosed input control.</p>\n',
          line: 95,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'max',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maximum value to accept.\n',
          description: '<p>The maximum value to accept.</p>\n',
          line: 64,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'min',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe minimum value to accept for this input.\n',
          description: '<p>The minimum value to accept for this input.</p>\n',
          line: 68,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the number input. Defaults to an empty string;\n',
          description: '<p>The placeholder for the number input. Defaults to an empty string;</p>\n',
          line: 60,
          type: 'string',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the number input is readonly.\n',
          description: '<p>Whether the number input is readonly.</p>\n',
          line: 90,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'step',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nA stepping interval to use when using up and down arrows to adjust the value\n',
          description: '<p>A stepping interval to use when using up and down arrows to adjust the value</p>\n',
          line: 86,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'onInput',
          args: [
            {
              name: 'inputNumber',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 128,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputNumber',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onPaste',
          args: [
            {
              name: 'inputNumber',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 137,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputNumber',
              type: 'HTMLInputElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'validate',
          args: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'ValidationErrors | null',
          typeParameters: [],
          line: 151,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that displays a text input.</p>\n<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-errormessage (Always paired with aria-invalid,when aria-invalid is true error message is read)</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputNumberExampleComponent',
      selector: 'bb-input-number-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'hasError',
          args: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'type',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 37,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'type',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'hasMaxError',
          args: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 59,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'hasMinError',
          args: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 55,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'hasRequiredError',
          args: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 46,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'isFieldValid',
          args: [
            {
              name: 'fieldName',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 27,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fieldName',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-number-example-ui',\n  templateUrl: './input-number.example.component.html',\n  standalone: false,\n})\nexport class InputNumberExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    count: [\n      '',\n      Validators.compose([\n        Validators.required,\n        Validators.min(2),\n        Validators.max(42),\n      ]),\n    ],\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n\n  isFieldValid(fieldName: string) {\n    const control = this.getControl(fieldName);\n\n    return control && (control.valid || control.untouched);\n  }\n\n  private getControl(fieldName: string) {\n    return this.vForm?.controls[fieldName];\n  }\n\n  hasError(field: string, type: string) {\n    const fieldControl = this.getControl(field);\n    if (!fieldControl || !fieldControl.errors) {\n      return;\n    }\n\n    return fieldControl.errors[type];\n  }\n\n  hasRequiredError(field: string) {\n    const fieldControl = this.getControl(field);\n    if (!fieldControl || !fieldControl.errors) {\n      return;\n    }\n\n    return fieldControl.errors.required;\n  }\n\n  hasMinError(field: string) {\n    return this.hasError(field, 'min');\n  }\n\n  hasMaxError(field: string) {\n    return this.hasError(field, 'max');\n  }\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <bb-input-number-ui\n    label="Count"\n    placeholder="Enter number..."\n    formControlName="count"\n    [aria-describedby]="\'input-number-showcase-error\'"\n    [aria-invalid]="!!(vForm?.dirty && vForm?.get(\'count\')?.errors)"\n    aria-errormessage="input-number-showcase-error"\n    [min]="2"\n    [max]="42"\n    [required]="true"\n    #numberInput\n  >\n  </bb-input-number-ui>\n  <bb-input-validation-message-ui\n    id="input-number-showcase-error"\n    [showErrors]="vForm?.dirty && vForm?.get(\'count\')?.errors"\n  >\n    @if (hasRequiredError(\'count\')) {\n      <p>Field is required.</p>\n    }\n    @if (hasMinError(\'count\')) {\n      <p>Minimum number allowed is: {{ numberInput.min }}</p>\n    }\n    @if (hasMaxError(\'count\')) {\n      <p>Maximum number allowed is: {{ numberInput.max }}</p>\n    }\n  </bb-input-validation-message-ui>\n</form>\n',
    },
    {
      name: 'InputPasswordComponent',
      selector: 'bb-input-password-ui',
      inputsClass: [
        {
          name: 'ariaLabel',
          defaultValue: "'Password Input'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nText used to describe the password input for screen readers.\n',
          description: '<p>Text used to describe the password input for screen readers.</p>\n',
          line: 89,
          type: 'string',
          decorators: [],
        },
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe autocomplete type for text input.\n',
          description: '<p>The autocomplete type for text input.</p>\n',
          line: 71,
          type: '"new-password" | "current-password" | "on" | "off" | "one-time-code"',
          decorators: [],
        },
        {
          name: 'inputMode',
          defaultValue: "'text'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe inputMode for the input.\n',
          description: '<p>The inputMode for the input.</p>\n',
          line: 94,
          type: 'string',
          decorators: [],
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maxLength for the password input.\n',
          description: '<p>The maxLength for the password input.</p>\n',
          line: 57,
          type: 'number',
          decorators: [],
        },
        {
          name: 'minLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe minLength for the password input.\n',
          description: '<p>The minLength for the password input.</p>\n',
          line: 61,
          type: 'number',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the password input. Defaults to an empty string;\n',
          description: '<p>The placeholder for the password input. Defaults to an empty string;</p>\n',
          line: 53,
          type: 'string',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the password input is readonly.\n',
          description: '<p>Whether the password input is readonly.</p>\n',
          line: 65,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'showPassword',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to show password in plain text.\n',
          description: '<p>Whether to show password in plain text.</p>\n',
          line: 80,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showVisibilityControl',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to show the visibility button icon after the text.\n',
          description: '<p>Whether to show the visibility button icon after the text.</p>\n',
          line: 76,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'visibilityControlLabel',
          defaultValue: "'Show/Hide password'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDiscernible text for show/hide password button.\n',
          description: '<p>Discernible text for show/hide password button.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'toggleVisibility',
          defaultValue: 'new EventEmitter<boolean>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe event emitter called when the visibility button is clicked.\n',
          description: '<p>The event emitter called when the visibility button is clicked.</p>\n',
          line: 99,
          type: 'EventEmitter',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'onVisibilityChange',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 136,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that displays a password input</p>\n<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n<p>visibilityControlLabel is discernible text for show/hide password button.\nariaLabel is discernible text for password input</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputPasswordExampleComponent',
      selector: 'bb-input-password-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onSubmit',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 25,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n// Please replace relative path imports e.g. '../../*' with '@backbase/ui-ang'.\nimport { NotificationService } from '@backbase/ui-ang/notification';\n\n@Component({\n  selector: 'bb-input-password-example-ui',\n  templateUrl: './input-password.example.component.html',\n  standalone: false,\n})\nexport class InputPasswordExampleComponent {\n  changePasswordForm: UntypedFormGroup = this.formBuilder.group({\n    password: ['', Validators.required],\n  });\n\n  constructor(\n    private formBuilder: UntypedFormBuilder,\n    private notificationService: NotificationService,\n  ) {}\n\n  onSubmit() {\n    this.notificationService.showNotification({\n      header: 'Password Changed',\n      message: 'Password has been changed',\n      modifier: 'success',\n    });\n  }\n}\n",
      template:
        '<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">\n  <p>\n    <bb-input-password-ui\n      label="Password"\n      placeholder="Please choose a new password"\n      formControlName="password"\n      autocomplete="new-password"\n      [aria-describedby]="\'password-error\'"\n      [showVisibilityControl]="true"\n    >\n    </bb-input-password-ui>\n  </p>\n  <bb-input-validation-message-ui\n    id="password-error"\n    [showErrors]="\n      !changePasswordForm.pristine && !changePasswordForm.valid\n    "\n  >\n    <p>Password is required.</p>\n  </bb-input-validation-message-ui>\n\n  <button bbButton type="submit">Change password</button>\n</form>\n',
    },
    {
      name: 'InputPhoneComponent',
      selector: 'bb-input-phone-ui',
      inputsClass: [
        {
          name: 'ariaLabel',
          defaultValue: "'Phone Input'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nariaLabel is discernible text for phone input.\n',
          description: '<p>ariaLabel is discernible text for phone input.</p>\n',
          line: 268,
          type: 'string',
          decorators: [],
        },
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe autocomplete value of the enclosed input control. Defaults to 'tel'\n\nThis attribute can be overwritten via the global configuration token\n",
          description:
            '<p>The autocomplete value of the enclosed input control. Defaults to &#39;tel&#39;</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 223,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'clearable',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllow to clear selected value.\n',
          description: '<p>Allow to clear selected value.</p>\n',
          line: 276,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'countryList',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nList of countries to display in dropdown.\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>List of countries to display in dropdown.\nThis attribute can be overwritten via the global configuration token</p>\n',
          line: 286,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'defaultCountryIsoCode',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nDefault country selected for country dropdown.\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>Default country selected for country dropdown.\nThis attribute can be overwritten via the global configuration token</p>\n',
          line: 298,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'dropdownPosition',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDropdown Position (bottom | top | auto)\n',
          description: '<p>Dropdown Position (bottom | top | auto)</p>\n',
          line: 272,
          type: '"bottom" | "top" | "auto" | undefined',
          decorators: [],
        },
        {
          name: 'enableCountryCode',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEnable/Disable Country code dropdown\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>Enable/Disable Country code dropdown\nThis attribute can be overwritten via the global configuration token</p>\n',
          line: 312,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'hideSelectedCountryFlag',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether to hide the flag of the selected country. Defaults to false\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>Whether to hide the flag of the selected country. Defaults to false\nThis attribute can be overwritten via the global configuration token</p>\n',
          line: 249,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'isOpen',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nAllows manual control of dropdown opening and closing. `true` - won't close. `false` - won't open.\nDefaults to `undefined`.\n",
          description:
            '<p>Allows manual control of dropdown opening and closing. <code>true</code> - won&#39;t close. <code>false</code> - won&#39;t open.\nDefaults to <code>undefined</code>.</p>\n',
          line: 325,
          type: 'any',
          decorators: [],
        },
        {
          name: 'mask',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe mask of the phone input. Defaults to null\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The mask of the phone input. Defaults to null\nThis attribute can be overwritten via the global configuration token</p>\n',
          line: 236,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe max size of the phone input.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>The max size of the phone input.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 181,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'minLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe size of the phone input.\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>The size of the phone input.</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 210,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the phone input. Defaults to an empty string;\n',
          description: '<p>The placeholder for the phone input. Defaults to an empty string;</p>\n',
          line: 260,
          type: 'string',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the phone input is readonly.\n',
          description: '<p>Whether the phone input is readonly.</p>\n',
          line: 264,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'searchable',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllow to search for value.\n',
          description: '<p>Allow to search for value.</p>\n',
          line: 280,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'validationPattern',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe validation pattern of the phone input.\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>The validation pattern of the phone input.\nThis attribute can be overwritten via the global configuration token.</p>\n',
          line: 195,
          type: 'InputPhoneConfig',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'valueChange',
          defaultValue: 'new EventEmitter<ValueSet>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe event emitter called when the one of the inputs change.\n',
          description: '<p>The event emitter called when the one of the inputs change.</p>\n',
          line: 338,
          type: 'EventEmitter',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'onChanges',
          args: [
            {
              name: 'event',
              type: 'CountryData',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 452,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'CountryData',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onClear',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 494,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onClose',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 488,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onFilterChange',
          args: [
            {
              name: 'query',
              type: 'string | undefined',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 498,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'query',
              type: 'string | undefined',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onInputValueChange',
          args: [
            {
              name: 'newValue',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 515,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onOpen',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 469,
          deprecated: true,
          deprecationMessage: 'Deprecated in ui-ang@12. To be marked as protected in ui-ang@14. No replacements.',
          rawdescription: '\n\n',
          description: '',
          jsdoctags: [],
        },
        {
          name: 'onTextChange',
          args: [
            {
              name: 'preventEmit',
              type: '',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: 'false',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 396,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'preventEmit',
              type: '',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: 'false',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'searchFunc',
          args: [
            {
              name: 'term',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'item',
              type: 'CountryData',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 505,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'term',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'item',
              type: 'CountryData',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'updateValues',
          args: [
            {
              name: 'preventEmit',
              type: '',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: 'false',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 407,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'preventEmit',
              type: '',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: 'false',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'validate',
          args: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'ValidationErrors | null',
          typeParameters: [],
          line: 532,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'value',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 158,
          deprecated: false,
          deprecationMessage: '',
          modifierKind: [164],
          jsdoctags: [
            {
              name: 'value',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputPhoneExampleComponent',
      selector: 'bb-input-phone-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-phone-example-ui',\n  templateUrl: './input-phone.example.component.html',\n  standalone: false,\n})\nexport class InputPhoneExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    workPhone: '4151234567',\n  });\n\n  country = [\n    {\n      countryCode: '+91',\n      isoCode: 'IN',\n      countryName: 'India',\n    },\n  ];\n\n  countries = [\n    {\n      countryCode: '+1',\n      isoCode: 'US',\n      countryName: 'United States',\n    },\n    {\n      countryCode: '+31',\n      isoCode: 'NL',\n      countryName: 'Netherlands',\n    },\n    {\n      countryCode: '+34',\n      isoCode: 'NZ',\n      countryName: 'New Zealand',\n    },\n    {\n      countryCode: '+355',\n      isoCode: 'AL',\n      countryName: 'Albania',\n    },\n    {\n      countryCode: '+91',\n      isoCode: 'IN',\n      countryName: 'India',\n    },\n    {\n      countryCode: '+55',\n      isoCode: 'BR',\n      countryName: 'Brazil',\n    },\n    {\n      countryCode: '+420',\n      isoCode: 'CZ',\n      countryName: 'Czech Republic',\n    },\n    {\n      countryCode: '+49',\n      isoCode: 'DE',\n      countryName: 'Germany',\n    },\n  ];\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <bb-input-phone-ui\n    label="Work Phone"\n    formControlName="workPhone"\n    placeholder="Phone number without country code"\n    autoComplete="tel-national"\n  ></bb-input-phone-ui>\n\n  <bb-input-phone-ui\n    [id]="\'phoneNumberExample\'"\n    label="Phone Number"\n    formControlName="workPhone"\n    placeholder="Enter a phone number"\n    [required]="true"\n    [enableCountryCode]="true"\n    defaultCountryIsoCode="BR"\n    [countryList]="countries"\n  >\n  </bb-input-phone-ui>\n\n  <bb-input-phone-ui\n    [id]="\'phoneNumberExampleDisabledCountryCode\'"\n    label="Phone Number"\n    formControlName="workPhone"\n    placeholder="Enter a phone number"\n    [required]="true"\n    [enableCountryCode]="true"\n    [countryList]="country"\n  >\n  </bb-input-phone-ui>\n</form>\n',
    },
    {
      name: 'InputRadioComponent',
      selector: 'bb-input-radio-ui',
      inputsClass: [
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe ID of the currently active descendant element when the radio button is part of a group.\n',
          description:
            '<p>The ID of the currently active descendant element when the radio button is part of a group.</p>\n',
          line: 70,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe 'aria-describedby' attribute for the radio button\n",
          description: '<p>The &#39;aria-describedby&#39; attribute for the radio button</p>\n',
          line: 62,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the radio button is expanded (true) or collapsed (false).\n',
          description: '<p>Whether the radio button is expanded (true) or collapsed (false).</p>\n',
          line: 76,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the radio button is invalid (true) or valid (false).\n',
          description: '<p>Whether the radio button is invalid (true) or valid (false).</p>\n',
          line: 82,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 52,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe 'aria-labelledby' attribute for the radio button\n",
          description: '<p>The &#39;aria-labelledby&#39; attribute for the radio button</p>\n',
          line: 57,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe IDs of the elements that are controlled by the radio button.\n',
          description: '<p>The IDs of the elements that are controlled by the radio button.</p>\n',
          line: 88,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the radio button is disabled (true) or enabled (false).\n',
          description: '<p>Whether the radio button is disabled (true) or enabled (false).</p>\n',
          line: 93,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nA unique identifier for the radio element.\n',
          description: '<p>A unique identifier for the radio element.</p>\n',
          line: 30,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label of the radio item\n',
          description: '<p>The label of the radio item</p>\n',
          line: 47,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'labelTemplate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nCustom label template.\n',
          description: '<p>Custom label template.</p>\n',
          line: 34,
          type: 'TemplateRef<any> | undefined',
          decorators: [],
        },
        {
          name: 'labelTemplateContext',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nLabel template context.\n',
          description: '<p>Label template context.</p>\n',
          line: 38,
          type: 'any | undefined',
          decorators: [],
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          line: 64,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'value',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe value of the native radio element.\n',
          description: '<p>The value of the native radio element.</p>\n',
          line: 43,
          type: 'string | undefined',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description:
        '<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n<p>Component that represents a single radio that is part of the radio group component.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputRadioGroupComponent',
      selector: 'bb-input-radio-group-ui',
      inputsClass: [
        {
          name: 'horizontal',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet horizontal placement of the radio elements.\n',
          description: '<p>Set horizontal placement of the radio elements.</p>\n',
          line: 55,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isBlock',
          defaultValue: 'false',
          deprecated: true,
          deprecationMessage:
            'in ui-ang@12. To be removed in ui-ang@14. No replacements. Introduced as a quick fix to layout issues.',
          jsdoctags: [
            {
              pos: 2292,
              end: 2410,
              kind: 331,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 2293,
                end: 2303,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'deprecated',
              },
              comment:
                '<p>in ui-ang@12. To be removed in ui-ang@14. No replacements. Introduced as a quick fix to layout issues.</p>\n',
            },
          ],
          rawdescription: '\n\nDisplay the radio group labels as a block element.\n',
          description: '<p>Display the radio group labels as a block element.</p>\n',
          line: 83,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'labelTemplate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustom group label template. In case with providing both (labelTemplate and label), labelTemplate will be showed.\n',
          description:
            '<p>Custom group label template. In case with providing both (labelTemplate and label), labelTemplate will be showed.</p>\n',
          line: 78,
          type: 'TemplateRef<any> | undefined',
          decorators: [],
        },
        {
          name: 'labelTemplateContext',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nGroup label template context.  In case with providing both (labelTemplate and label), labelTemplate will be showed.\n',
          description:
            '<p>Group label template context.  In case with providing both (labelTemplate and label), labelTemplate will be showed.</p>\n',
          line: 74,
          type: 'any | undefined',
          decorators: [],
        },
        {
          name: 'name',
          defaultValue: '`input_radio_group_${getDynamicId()}`',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe unique name of the radio group. This would the the name used for the descending radio buttons.\n',
          description:
            '<p>The unique name of the radio group. This would the the name used for the descending radio buttons.</p>\n',
          line: 64,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'preselect',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet to true to select the first radio button onInit.\n',
          description: '<p>Set to true to select the first radio button onInit.</p>\n',
          line: 59,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'verticalAlign',
          defaultValue: "'middle'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nVertical align of the radio buttons\n',
          description: '<p>Vertical align of the radio buttons</p>\n',
          line: 69,
          type: '"middle" | "top" | "bottom"',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'valueChange',
          defaultValue: 'this._valueChange',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits an event when the value of the radio group is changed.\n',
          description: '<p>Emits an event when the value of the radio group is changed.</p>\n',
          line: 92,
          type: 'EventEmitter<any>',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'focusOut',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 150,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'focusValue',
          args: [
            {
              name: 'radio',
              type: 'InputRadioComponent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 124,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'radio',
              type: 'InputRadioComponent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'setValue',
          args: [
            {
              name: 'radio',
              type: 'InputRadioComponent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 130,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'radio',
              type: 'InputRadioComponent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'trackByFn',
          args: [
            {
              name: '_',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'item',
              type: 'InputRadioComponent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 146,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '_',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'item',
              type: 'InputRadioComponent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'value',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 137,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'value',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that represents a group of radio buttons.</p>\n<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputRadioGroupExampleComponent',
      selector: 'bb-input-radio-group-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onRadioTemplateFormSubmit',
          args: [
            {
              name: 'form',
              type: 'NgForm',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 21,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'form',
              type: 'NgForm',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  Validators,\n  NgForm,\n  UntypedFormGroup,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-radio-group-example-ui',\n  templateUrl: './input-radio-group.example.component.html',\n  standalone: false,\n})\nexport class InputRadioGroupExampleComponent {\n  form: UntypedFormGroup = this.formBuilder.group({\n    accountType: [{ value: '', disabled: false }, Validators.required],\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n\n  onRadioTemplateFormSubmit(form: NgForm) {\n    console.log(form.value);\n  }\n}\n",
      template:
        '<form [formGroup]="form">\n  <p id="label-account-type">Account type</p>\n  <bb-input-radio-group-ui\n    formControlName="accountType"\n    aria-labelledby="\'label-account-type\'"\n    [horizontal]="true"\n    [preselect]="true"\n    [required]="true"\n  >\n    <bb-input-radio-ui value="cr" label="Credit"></bb-input-radio-ui>\n    <bb-input-radio-ui value="dt" label="Debit"></bb-input-radio-ui>\n  </bb-input-radio-group-ui>\n</form>\n',
    },
    {
      name: 'InputRangeExampleComponent',
      selector: 'bb-input-range-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'isFieldValid',
          args: [
            {
              name: 'control',
              type: 'FormControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 37,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'FormControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  FormControl,\n  UntypedFormBuilder,\n  UntypedFormControl,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-range-example-ui',\n  templateUrl: './input-range.example.component.html',\n  standalone: false,\n})\nexport class InputRangeExampleComponent {\n  form = this.formBuilder.group({\n    range: this.formBuilder.group(\n      {\n        min: [0, Validators.min(10)],\n        max: [100, Validators.max(90)],\n      },\n      {\n        validator: (g: UntypedFormGroup) => {\n          const min = (g.get('min') as UntypedFormControl).errors;\n          const max = (g.get('max') as UntypedFormControl).errors;\n\n          const errors = min || max ? { ...min, ...max } : null;\n\n          return errors;\n        },\n      },\n    ),\n  });\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {}\n\n  isFieldValid(control: FormControl) {\n    return control && (control.valid || control.untouched);\n  }\n}\n",
      template:
        '<form [formGroup]="form">\n  <div bbInputRange formGroupName="range">\n    <bb-input-number-ui\n      bbInputRangeMin\n      formControlName="min"\n      label="Minimum"\n      [aria-describedby]="\'error-min\'"\n      [aria-invalid]="!isFieldValid(form.get(\'range\')?.get(\'min\'))"\n      aria-errormessage="\'error-min\'"\n    ></bb-input-number-ui>\n    <bb-input-number-ui\n      bbInputRangeMax\n      formControlName="max"\n      label="Maximum"\n      [aria-describedby]="\'error-max\'"\n      [aria-invalid]="!isFieldValid(form.get(\'range\')?.get(\'max\'))"\n      aria-errormessage="\'error-max\'"\n    ></bb-input-number-ui>\n  </div>\n  <ng-container\n    *ngTemplateOutlet="\n      errors;\n      context: { $implicit: form.get(\'range\') }\n    "\n  ></ng-container>\n</form>\n\n<ng-template #errors let-control>\n  @if (control?.errors; as errors) {\n    <bb-input-validation-message-ui [showErrors]="control?.touched">\n      @if (errors?.min; as min) {\n        <div id="error-min">Minimum value is {{ min.min }}</div>\n      }\n      @if (errors?.max; as max) {\n        <div id="error-max">Maximum value is {{ max.max }}</div>\n      }\n    </bb-input-validation-message-ui>\n  }\n</ng-template>\n',
    },
    {
      name: 'InputTextComponent',
      selector: 'bb-input-text-ui',
      inputsClass: [
        {
          name: 'autocomplete',
          defaultValue: "'off'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nA string specifying whether the browser should autocomplete the input.\nPossible values: 'on', 'off', or any string that is not empty.\n",
          description:
            '<p>A string specifying whether the browser should autocomplete the input.\nPossible values: &#39;on&#39;, &#39;off&#39;, or any string that is not empty.</p>\n',
          line: 68,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'inputMode',
          defaultValue: "'text'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe inputMode for the text input.\n',
          description: '<p>The inputMode for the text input.</p>\n',
          line: 99,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mask',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nngx-mask related; default value imply no mask is used\n',
          description: '<p>ngx-mask related; default value imply no mask is used</p>\n',
          line: 80,
          type: 'string',
          decorators: [],
        },
        {
          name: 'maskValidator',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nngx-mask related; default value imply validation is applied on mask pattern\n',
          description: '<p>ngx-mask related; default value imply validation is applied on mask pattern</p>\n',
          line: 84,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maxLength for the text input.\n',
          description: '<p>The maxLength for the text input.</p>\n',
          line: 59,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'minLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe minLength for the text input.\n',
          description: '<p>The minLength for the text input.</p>\n',
          line: 63,
          type: 'number | undefined',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the text input. Defaults to an empty string;\n',
          description: '<p>The placeholder for the text input. Defaults to an empty string;</p>\n',
          line: 55,
          type: 'string',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether the text input is readonly.\nIf true, the input cannot be edited.\nDefaults to false.\n',
          description:
            '<p>Whether the text input is readonly.\nIf true, the input cannot be edited.\nDefaults to false.</p>\n',
          line: 75,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'showCharCounter',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nShows character counter based on `maxLength`\n',
          description: '<p>Shows character counter based on <code>maxLength</code></p>\n',
          line: 89,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'valueChange',
          defaultValue: 'this._valueChange',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits an event whenever the input value changes.\n',
          description: '<p>Emits an event whenever the input value changes.</p>\n',
          line: 94,
          type: 'EventEmitter<any>',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'focusEditableElement',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 137,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that displays a text input.</p>\n<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputTextExampleComponent',
      selector: 'bb-input-text-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-text-example-ui',\n  templateUrl: './input-text.example.component.html',\n  standalone: false,\n})\nexport class InputTextExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    name: ['', Validators.required],\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <bb-input-text-ui\n    label="First Name"\n    formControlName="name"\n    [required]="true"\n    placeholder="Name"\n    autoComplete="given-name"\n  ></bb-input-text-ui>\n</form>\n',
    },
    {
      name: 'InputTimepickerComponent',
      selector: 'bb-input-timepicker-ui',
      inputsClass: [
        {
          name: 'autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe autocomplete value of enclosed input control.\n',
          description: '<p>The autocomplete value of enclosed input control.</p>\n',
          line: 192,
          type: '',
          decorators: [],
        },
        {
          name: 'clock',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether to display 12H or 24H mode.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>Whether to display 12H or 24H mode.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 116,
          type: '"12h" | "24h"',
          decorators: [],
        },
        {
          name: 'hourStep',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe number of hours to add/subtract when clicking hour spinners.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>The number of hours to add/subtract when clicking hour spinners.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 100,
          type: 'number',
          decorators: [],
        },
        {
          name: 'max',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIf set , validate according to max time\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>If set , validate according to max time</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 179,
          type: 'InputTimepickerConfig',
          decorators: [],
        },
        {
          name: 'min',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIf set, validate according to min time\n\nThis attribute can be overwritten via the global configuration token\n',
          description:
            '<p>If set, validate according to min time</p>\n<p>This attribute can be overwritten via the global configuration token</p>\n',
          line: 163,
          type: 'InputTimepickerConfig',
          decorators: [],
        },
        {
          name: 'minuteStep',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe number of minutes to add/subtract when clicking minute spinners.\n\nThis attribute can be overwritten via the global configuration token.\n',
          description:
            '<p>The number of minutes to add/subtract when clicking minute spinners.</p>\n<p>This attribute can be overwritten via the global configuration token.</p>\n',
          line: 132,
          type: 'number',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nIf true, the timepicker is readonly and can't be changed.\n",
          description: '<p>If true, the timepicker is readonly and can&#39;t be changed.</p>\n',
          line: 145,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'seconds',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf true, it is possible to select seconds.\n',
          description: '<p>If true, it is possible to select seconds.</p>\n',
          line: 150,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'secondStep',
          defaultValue: '1',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe number of seconds to add/subtract when clicking second spinners.\n',
          description: '<p>The number of seconds to add/subtract when clicking second spinners.</p>\n',
          line: 155,
          type: 'number',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'getKeywordBySize',
          args: [
            {
              name: 'size',
              type: 'number | string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 205,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'size',
              type: 'number | string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'keyword',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 215,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'keyword',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 269,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'validate',
          args: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'ValidationErrors | null',
          typeParameters: [],
          line: 225,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that displays a timepicker.</p>\n<h3>Global configuration token</h3>\n<p><code>INPUT_TIMEPICKER_CONFIG_TOKEN</code> enables you to globally set the same configuration for all instances of  <code>InputTimepickerComponent</code> instances in your project.</p>\n<p><em>Note:</em> The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not be able to overwrite it.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>clock</code></li>\n<li><code>hourStep</code></li>\n<li><code>max</code></li>\n<li><code>min</code></li>\n<li><code>minuteStep</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript"> import { INPUT_TIMEPICKER_CONFIG_TOKEN } from &#39;&#64;backbase/ui-ang/input-timepicker&#39;;\n import { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\n import { AppModule } from &#39;./app/app.module&#39;;\n\n const inputTimepickerConfig = {\n   clock: &#39;12h&#39;\n };\n\n platformBrowserDynamic().bootstrapModule(AppModule, {\n   providers: [{ provide: INPUT_TIMEPICKER_CONFIG_TOKEN, useValue: inputTimepickerConfig }]\n });</code></pre></div><h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputTimepickerExampleComponent',
      selector: 'bb-input-timepicker-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'hasError',
          args: [
            {
              name: 'type',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 24,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'type',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'showErrors',
          args: [],
          optional: false,
          returnType: 'boolean | null',
          typeParameters: [],
          line: 33,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-timepicker-example-ui',\n  templateUrl: './input-timepicker-example.component.html',\n  standalone: false,\n})\n\n/**\n * @name InputTimepickerExampleComponent\n *\n * @description\n * Component that displays multiple examples with the timepicker component.\n */\nexport class InputTimepickerExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    time: [''],\n  });\n  timeModel = '';\n  min = '13:00:00';\n  max = '14:30:00';\n\n  hasError(type: string): boolean {\n    const time = this.vForm.get('time');\n    if (time !== null && time.errors) {\n      return !!time.errors[type];\n    }\n\n    return false;\n  }\n\n  showErrors(): boolean | null {\n    const time = this.vForm.get('time');\n    if (time !== null) {\n      return time.errors && !time.valid;\n    }\n\n    return null;\n  }\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<div class="container d-block">\n  <h5>Timepicker with 10 minute step and validation errors</h5>\n  <form [formGroup]="vForm">\n    <bb-input-timepicker-ui\n      id="timePicker-validation"\n      [readonly]="false"\n      [minuteStep]="10"\n      formControlName="time"\n      [min]="min"\n      [max]="max"\n    >\n    </bb-input-timepicker-ui>\n\n    <bb-input-validation-message-ui [showErrors]="showErrors()">\n      @if (hasError(\'minTime\')) {\n        <span>Time should be after {{ min }}</span>\n      }\n      @if (hasError(\'maxTime\')) {\n        <span>Time should not exceed {{ max }}</span>\n      }\n      @if (hasError(\'minMaxTime\')) {\n        <span>Time should be between {{ min }} and {{ max }}</span>\n      }\n    </bb-input-validation-message-ui>\n  </form>\n  <br />\n\n  <h5>Readonly timepicker</h5>\n  <bb-input-timepicker-ui id="timepicker-readonly" [readonly]="true"> </bb-input-timepicker-ui>\n  <br />\n\n  <h5>Timepicker with seconds and meridian</h5>\n  <bb-input-timepicker-ui\n    id="timepicker-meridian"\n    [readonly]="false"\n    [seconds]="true"\n    clock="12h"\n    [(ngModel)]="timeModel"\n    [min]="min"\n  >\n  </bb-input-timepicker-ui>\n</div>\n',
    },
    {
      name: 'InputValidationMessageComponent',
      selector: 'bb-input-validation-message-ui',
      inputsClass: [
        {
          name: 'messageId',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nOptional reference to bind parent input with this component\n\nThis property is used to bind the parent input element with this component. It is optional and can be used to associate\na validation message with a specific input element using the input element's ID or name.\n",
          description:
            '<p>Optional reference to bind parent input with this component</p>\n<p>This property is used to bind the parent input element with this component. It is optional and can be used to associate\na validation message with a specific input element using the input element&#39;s ID or name.</p>\n',
          line: 58,
          type: 'string',
          decorators: [],
        },
        {
          name: 'role',
          defaultValue: "'alert'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nSets the role attribute on the validation message.\nIf multiple validation messages may be present on the screen then select `'status'`.\nDefault is `'alert'`.\n",
          description:
            '<p>Sets the role attribute on the validation message.\nIf multiple validation messages may be present on the screen then select <code>&#39;status&#39;</code>.\nDefault is <code>&#39;alert&#39;</code>.</p>\n',
          line: 76,
          type: '"status" | "alert"',
          decorators: [],
        },
        {
          name: 'showErrors',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether the errors template should be shown\n\nThis property is used to show or hide the error template for the input element. When set to true, the error template\nwill be displayed.\n',
          description:
            '<p>Whether the errors template should be shown</p>\n<p>This property is used to show or hide the error template for the input element. When set to true, the error template\nwill be displayed.</p>\n',
          line: 50,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showIcon',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether the error template should display "info" icon before the error message. Default is true.\n',
          description:
            '<p>Whether the error template should display &quot;info&quot; icon before the error message. Default is true.</p>\n',
          line: 63,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description:
        '<p>Component that displays an input validation message or helper.</p>\n<h3>Global configuration token</h3>\n<p><code>INPUT_VALIDATION_MESSAGE_CONFIG</code> enables you to globally set the same configuration for all instances of <code>InputValidationMessageComponent</code> in your project.</p>\n<p><em>Note:</em> The token overwrites the default value only. If you have provided a value as a property on a specific component, the token is not be able to overwrite it.</p>\n<p>The following properties can be overwritten using the token:</p>\n<ul>\n<li><code>showIcon</code></li>\n</ul>\n<h4>Usage notes</h4>\n<p>The following is an example of how to use the token:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">import { INPUT_VALIDATION_MESSAGE_CONFIG } from &#39;&#64;backbase/ui-ang/input-validation-message&#39;;\nimport { platformBrowserDynamic } from &#39;&#64;angular/platform-browser-dynamic&#39;;\nimport { AppModule } from &#39;./app/app.module&#39;;\n\nconst inputValidationMessageShowIcon = { showIcon: false };\n\nplatformBrowserDynamic().bootstrapModule(AppModule, {\n  providers: [{ provide: INPUT_VALIDATION_MESSAGE_CONFIG, useValue: inputValidationMessageShowIcon }]\n});</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'InputValidationMessageExampleComponent',
      selector: 'bb-input-validation-message-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'hasError',
          args: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'type',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 36,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'type',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'hasLengthError',
          args: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 45,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'hasRequiredError',
          args: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 54,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'field',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'isFieldValid',
          args: [
            {
              name: 'fieldName',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 26,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fieldName',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-input-validation-message-example-ui',\n  templateUrl: './input-validation-message.example.component.html',\n  standalone: false,\n})\nexport class InputValidationMessageExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    name: [\n      '',\n      Validators.compose([\n        Validators.required,\n        Validators.minLength(5),\n      ]),\n    ],\n  });\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {}\n\n  isFieldValid(fieldName: string) {\n    const control = this.getControl(fieldName);\n\n    return control && (control.valid || control.untouched);\n  }\n\n  private getControl(fieldName: string) {\n    return this.vForm?.controls[fieldName];\n  }\n\n  hasError(field: string, type: string) {\n    const fieldControl = this.getControl(field);\n    if (!fieldControl || !fieldControl.errors) {\n      return;\n    }\n\n    return fieldControl.errors[type];\n  }\n\n  hasLengthError(field: string) {\n    const fieldControl = this.getControl(field);\n    if (!fieldControl || !fieldControl.errors) {\n      return;\n    }\n\n    return fieldControl.errors.minlength;\n  }\n\n  hasRequiredError(field: string) {\n    const fieldControl = this.getControl(field);\n    if (!fieldControl || !fieldControl.errors) {\n      return;\n    }\n\n    return fieldControl.errors.required;\n  }\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <bb-input-text-ui\n    label="First Name"\n    formControlName="name"\n    [aria-describedby]="\'name-errors\'"\n    [aria-invalid]="!isFieldValid(\'name\')"\n    aria-errormessage="name-errors"\n  ></bb-input-text-ui>\n  <bb-input-validation-message-ui\n    id="name-errors"\n    [showErrors]="!isFieldValid(\'name\')"\n  >\n    @if (hasRequiredError(\'name\')) {\n      <span> Field is required. </span>\n    }\n    @if (hasLengthError(\'name\')) {\n      <span> Field has minlength of 5. </span>\n    }\n  </bb-input-validation-message-ui>\n</form>\n',
    },
    {
      name: 'ItemLogComponent',
      selector: 'bb-item-log-ui',
      inputsClass: [
        {
          name: 'isPending',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFlag that denotes if item log status is pending. Defaults to false\n',
          description: '<p>Flag that denotes if item log status is pending. Defaults to false</p>\n',
          line: 55,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'records',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nList of item log records.\n',
          description: '<p>List of item log records.</p>\n',
          line: 59,
          type: 'Array<ItemLogRecord | T>',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that shows the log of the records.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ItemLogExampleComponent',
      selector: 'bb-item-log-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { ItemLogRecord } from '@backbase/ui-ang/item-log';\n\n@Component({\n  selector: 'bb-item-log-example-ui',\n  templateUrl: './item-log.example.component.html',\n  standalone: false,\n})\nexport class ItemLogExampleComponent {\n  logRecords: ItemLogRecord[] = [\n    {\n      userFullName: 'Green Goblet',\n      status: 'REJECTED',\n      createdAt: '2018-01-23T13:44:02Z',\n      comment: 'Limit exceeded',\n    },\n    {\n      userFullName: 'Robin Green',\n      status: 'APPROVED',\n      createdAt: '2018-01-22T13:44:02Z',\n    },\n  ];\n}\n",
      template: '<bb-item-log-ui\n  [records]="logRecords"\n  [isPending]="true"\n></bb-item-log-ui>\n',
    },
    {
      name: 'KeyboardClickExampleComponent',
      selector: 'bb-keyboard-click-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'action',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 13,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { NotificationService } from '@backbase/ui-ang/notification';\n\n@Component({\n  selector: 'bb-keyboard-click-example-ui',\n  templateUrl: './keyboard-click.example.component.html',\n  standalone: false,\n})\nexport class KeyboardClickExampleComponent {\n  constructor(private notificationService: NotificationService) {}\n\n  action() {\n    this.notificationService.showNotification({\n      header: 'Keyboard Click',\n      message: 'bbKeyboardClick event',\n      modifier: 'info',\n    });\n  }\n}\n",
      template: '<button bbButton (bbKeyboardClick)="action()">Click Me!</button>\n',
    },
    {
      name: 'ListMultipleSelectComponent',
      selector: 'bb-list-multiple-select-ui',
      inputsClass: [
        {
          name: 'config',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 2132,
              end: 2169,
              kind: 344,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 2133,
                end: 2137,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'type',
              },
              comment: '',
              typeExpression: {
                pos: 2138,
                end: 2163,
                kind: 309,
                id: 0,
                flags: 16842752,
                modifierFlagsCache: 0,
                transformFlags: 0,
                type: {
                  pos: 2139,
                  end: 2162,
                  kind: 183,
                  id: 0,
                  flags: 16777216,
                  modifierFlagsCache: 0,
                  transformFlags: 1,
                  typeName: {
                    pos: 2139,
                    end: 2162,
                    kind: 80,
                    id: 0,
                    flags: 16777216,
                    transformFlags: 0,
                    escapedText: 'ListMultipleSelectItems',
                  },
                },
              },
            },
            {
              pos: 2169,
              end: 2210,
              kind: 327,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 2170,
                end: 2178,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'memberof',
              },
              comment: '<p>ListMultipleSelectComponent</p>\n',
            },
          ],
          rawdescription:
            '\n\nConfiguration object for describing the icons to be used for each item in the multiple select list.\n\n',
          description:
            '<p>Configuration object for describing the icons to be used for each item in the multiple select list.</p>\n',
          line: 73,
          type: 'ListMultipleSelectItems',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'getKeys',
          args: [
            {
              name: 'object',
              type: 'object',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string[]',
          typeParameters: [],
          line: 99,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'object',
              type: 'object',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '<p>Component that displays list with checkboxes.</p>\n',
      deprecationMessage:
        'Component is deprecated as of ui-ang v12. It will be removed in ui-ang v14. No replacement of this component as there is 0 usage of this component.',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ListMultipleSelectExampleComponent',
      selector: 'bb-list-multiple-select-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onListMultipleSelectClearAll',
          args: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 47,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { ListMultipleSelectItems } from '@backbase/ui-ang/list-multiple-select';\nimport { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';\n\n@Component({\n  selector: 'bb-list-multiple-select-example-ui',\n  templateUrl: './list-multiple-select-example.component.html',\n  standalone: false,\n})\nexport class ListMultipleSelectExampleComponent {\n  listMultipleSelectItemsConfig: ListMultipleSelectItems = {\n    i2: {\n      icon: 'warning',\n      iconColor: 'warning',\n    },\n    i3: {\n      icon: 'warning',\n      iconColor: 'secondary',\n      items: {\n        q2: {\n          icon: 'warning',\n        },\n      },\n    },\n  };\n\n  vForm: UntypedFormGroup | undefined;\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {\n    this.vForm = this.formBuilder.group({\n      listMultipleSelect: this.formBuilder.group({\n        i1: true,\n        i2: true,\n        i3: this.formBuilder.group({\n          q1: false,\n          q2: true,\n          q3: this.formBuilder.group({\n            w1: { value: true, disabled: true },\n            w2: { value: false, disabled: true },\n          }),\n        }),\n      }),\n    });\n  }\n\n  onListMultipleSelectClearAll($event: any) {\n    $event.preventDefault();\n    if (this.vForm) {\n      this.vForm.controls['listMultipleSelect'].patchValue({\n        i1: false,\n        i2: false,\n        i3: {\n          q1: false,\n          q2: false,\n        },\n      });\n    }\n  }\n}\n",
      template:
        '<form class="col-6" [formGroup]="vForm">\n  <bb-list-multiple-select-ui\n    formGroupName="listMultipleSelect"\n    [config]="listMultipleSelectItemsConfig"\n    aria-label="List multiple select"\n  >\n    <ng-template bbListMultipleSelectAction>\n      <a href="" (click)="onListMultipleSelectClearAll($event)">Clear All</a>\n    </ng-template>\n  </bb-list-multiple-select-ui>\n</form>\n',
    },
    {
      name: 'LoadButtonComponent',
      selector: 'bb-load-button-ui',
      inputsClass: [
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when button does not contain a discernible text.\n',
          description: '<p>Accessible label when button does not contain a discernible text.</p>\n',
          line: 68,
          type: 'string',
          decorators: [],
        },
        {
          name: 'circle',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether it should render the button as a circle. Defaults to false i.e. oblong shape.\n',
          description: '<p>Whether it should render the button as a circle. Defaults to false i.e. oblong shape.</p>\n',
          line: 60,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'from',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe page to list from.\n',
          description: '<p>The page to list from.</p>\n',
          line: 52,
          type: 'number',
          decorators: [],
        },
        {
          name: 'isLoading',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIndicates if loading indicator should be shown instead of button content. Defaults to false.\n',
          description:
            '<p>Indicates if loading indicator should be shown instead of button content. Defaults to false.</p>\n',
          line: 48,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'size',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe number of results per page.\n',
          description: '<p>The number of results per page.</p>\n',
          line: 56,
          type: 'number',
          decorators: [],
        },
        {
          name: 'totalCount',
          defaultValue: '1',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe total item count. Defaults to 1 to allow infinite loading.\n',
          description: '<p>The total item count. Defaults to 1 to allow infinite loading.</p>\n',
          line: 64,
          type: 'number',
          decorators: [],
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThis Boolean attribute lets you specify that the button should have input focus when the page\nloads, unless the user overrides it, for example by typing in a different control.  Only one\nform-associated element in a document can have this attribute specified.\n',
          description:
            '<p>This Boolean attribute lets you specify that the button should have input focus when the page\nloads, unless the user overrides it, for example by typing in a different control.  Only one\nform-associated element in a document can have this attribute specified.</p>\n',
          line: 50,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ButtonComponent',
          },
        },
        {
          name: 'block',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe flag to indicate whether the button should fill the container that it is in. Defaults to 'false'.\n",
          description:
            '<p>The flag to indicate whether the button should fill the container that it is in. Defaults to &#39;false&#39;.</p>\n',
          line: 74,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ButtonComponent',
          },
        },
        {
          name: 'buttonSize',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSize of the button.\n',
          description: '<p>Size of the button.</p>\n',
          line: 63,
          type: '"sm" | "md"',
          decorators: [],
          inheritance: {
            file: 'ButtonComponent',
          },
        },
        {
          name: 'color',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe color for the button.  Defaults to 'primary'.\n",
          description: '<p>The color for the button.  Defaults to &#39;primary&#39;.</p>\n',
          line: 67,
          type: 'ButtonColor | string',
          decorators: [],
          inheritance: {
            file: 'ButtonComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThis Boolean attribute indicates that the user cannot interact with the button.  Defaults to\nfalse.\n',
          description:
            '<p>This Boolean attribute indicates that the user cannot interact with the button.  Defaults to\nfalse.</p>\n',
          line: 59,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ButtonComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\nThe id for the button. Defaults to unique string',
          description: '<p>The id for the button. Defaults to unique string</p>\n',
          line: 35,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ButtonComponent',
          },
        },
        {
          name: 'type',
          defaultValue: "'button'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe HTML5 button type.  Defaults to 'button'.\n",
          description: '<p>The HTML5 button type.  Defaults to &#39;button&#39;.</p>\n',
          line: 54,
          type: 'ButtonType',
          decorators: [],
          inheritance: {
            file: 'ButtonComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'paramChange',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThis emits new load more params to parent component\n',
          description: '<p>This emits new load more params to parent component</p>\n',
          line: 72,
          type: 'EventEmitter<LoadMoreParams>',
        },
      ],
      methodsClass: [
        {
          name: 'hasMore',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 91,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'isLoadMore',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 87,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onClick',
          args: [
            {
              name: '$event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 99,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onHostElementClick',
          args: [
            {
              name: '$event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 120,
          deprecated: true,
          deprecationMessage: 'Deprecated in ui-ang@12. To be removed in ui-ang@14',
          rawdescription: '\n\nHost element click listener.\n',
          description: '<p>Host element click listener.</p>\n',
          jsdoctags: [
            {
              name: '$event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onLoadMore',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 108,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'moveAriaAttributes',
          args: [
            {
              name: 'hostEl',
              type: 'HTMLElement',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'childEl',
              type: 'HTMLElement',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 90,
          deprecated: false,
          deprecationMessage: '',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'hostEl',
              type: 'HTMLElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'childEl',
              type: 'HTMLElement',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'ButtonComponent',
          },
        },
      ],
      description:
        '<p>Component that displays a button with integrated loading indicator.\nRefer to <a href="https://designsystem.backbase.com/web-components/button/web">Button Component</a> for button colors and sizes.</p>\n<h3>Use Case</h3>\n<p>There are two use-cases for this component:</p>\n<ul>\n<li>Finite loading - button is disabled but remains displayed after a certain limit</li>\n<li>Infinite loading - button is always functional\n<br><br></li>\n</ul>\n<h4>Finite Loading</h4>\n<p>This is used primarily when paginating a list of items and the number of items is known.\nThe component is enabled and allows loading as long as the current number of displayed results (determined by <code>from</code> and <code>size</code>) is under the <code>totalCount</code>.</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-html">   &lt;bb-load-button-ui [size]=&quot;8&quot; [from]=&quot;0&quot; [totalCount]=&quot;48&quot; ...&gt;&lt;/bb-load-button-ui&gt;</code></pre></div><h4>Infinite Loading</h4>\n<p>This is used primarily when you are loading a content only once or endlessly.\nThis is the default behaviour.\nThis behaviour is available as long as the <code>totalCount</code> is 1.</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-html">   &lt;bb-load-button-ui [totalCount]=&quot;1&quot; ...&gt;&lt;/bb-load-button-ui&gt;</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'LoadButtonExampleComponent',
      selector: 'bb-load-button-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'loadMore',
          args: [
            {
              name: 'params',
              type: 'LoadMoreParams',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 33,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'params',
              type: 'LoadMoreParams',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onLoadButtonPress',
          args: [
            {
              name: 'params',
              type: 'LoadMoreParams',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 29,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'params',
              type: 'LoadMoreParams',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { Subject, Observable, merge, of } from 'rxjs';\nimport { startWith, mergeMap, map, delay, tap } from 'rxjs/operators';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { LoadMoreParams } from '@backbase/ui-ang/load-button';\n\nconst LOADING_DURATION = 1500;\n\n@Component({\n  selector: 'bb-load-button-example-ui',\n  templateUrl: './load-button.example.component.html',\n  standalone: false,\n})\nexport class LoadButtonExampleComponent {\n  itemsPerPage = 4;\n  page = 0;\n  totalItems = 12;\n\n  loadRequest: Subject<LoadMoreParams> = new Subject();\n  loadProcedure = this.loadRequest.pipe(\n    mergeMap((params) => this.loadMore(params)),\n  );\n\n  isLoading: Observable<boolean> = merge(\n    this.loadRequest.pipe(map(() => true)),\n    this.loadProcedure.pipe(map(() => false)),\n  ).pipe(startWith(false));\n\n  onLoadButtonPress(params: LoadMoreParams) {\n    this.loadRequest.next(params);\n  }\n\n  loadMore(params: LoadMoreParams) {\n    console.log('Loading more...');\n\n    return of(params).pipe(\n      delay(LOADING_DURATION),\n      tap(() => {\n        this.page = params.from;\n      }),\n    );\n  }\n}\n",
      template:
        '<bb-load-button-ui\n  color="primary"\n  [size]="itemsPerPage"\n  [from]="page"\n  [totalCount]="totalItems"\n  [isLoading]="isLoading | async"\n  buttonSize="md"\n  (paramChange)="onLoadButtonPress($event)"\n>\n  <bb-icon-ui name="search" size="lg" cropped></bb-icon-ui>\n  Show more results...\n</bb-load-button-ui>\n',
    },
    {
      name: 'LoadingIndicatorComponent',
      selector: 'bb-loading-indicator-ui',
      inputsClass: [
        {
          name: 'hasBackground',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nDefines whether gray background should be displayed.\nDefault to false (background hidden).\n',
          description:
            '<p>Defines whether gray background should be displayed.\nDefault to false (background hidden).</p>\n',
          line: 36,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'inline',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nDefine if spinner should be shown inline without any default padding and margin.\nDefault to false (show default padding and margin).\n',
          description:
            '<p>Define if spinner should be shown inline without any default padding and margin.\nDefault to false (show default padding and margin).</p>\n',
          line: 41,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'loaderSize',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe size of the loading indicator.\nDefaults to 'md'.\n",
          description: '<p>The size of the loading indicator.\nDefaults to &#39;md&#39;.</p>\n',
          line: 26,
          type: 'LoadingIndicatorSize',
          decorators: [],
        },
        {
          name: 'showDelay',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDelay in milliseconds before the loading indicator display.\nDefault to 0.\n',
          description: '<p>Delay in milliseconds before the loading indicator display.\nDefault to 0.</p>\n',
          line: 31,
          type: 'number',
          decorators: [],
        },
        {
          name: 'text',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe text to display under the loading indicator.\n',
          description: '<p>The text to display under the loading indicator.</p>\n',
          line: 21,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that displays a loading spinner and message.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'LoadingIndicatorExampleComponent',
      selector: 'bb-loading-indicator-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-loading-indicator-example-ui',\n  templateUrl: './loading-indicator.example.component.html',\n  standalone: false,\n})\nexport class LoadingIndicatorExampleComponent {}\n",
      template:
        '<bb-loading-indicator-ui\n  loaderSize="lg"\n  [showDelay]="750"\n  text="Loading..."\n></bb-loading-indicator-ui>\n',
    },
    {
      name: 'LocaleSelectorComponent',
      selector: 'bb-locale-selector-ui',
      inputsClass: [
        {
          name: 'btnColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nColor of the button. Defaults to primary.\n',
          description: '<p>Color of the button. Defaults to primary.</p>\n',
          line: 76,
          type: 'string',
          decorators: [],
        },
        {
          name: 'dropDownButtonLabel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nButton aria label.\n',
          description: '<p>Button aria label.</p>\n',
          line: 96,
          type: 'string',
          decorators: [],
        },
        {
          name: 'dropdownPlacement',
          defaultValue: "['bottom-end', 'bottom-start', 'top-end', 'top-start']",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe position of the dropdown for the locale selector, position will be picked in order of feasibility.\n',
          description:
            '<p>The position of the dropdown for the locale selector, position will be picked in order of feasibility.</p>\n',
          line: 72,
          type: 'PlacementArray',
          decorators: [],
        },
        {
          name: 'fullWidth',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf true it will stretch the button inside to 100% width.\n',
          description: '<p>If true it will stretch the button inside to 100% width.</p>\n',
          line: 88,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'icon',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIcon that is displayed in the button.\n',
          description: '<p>Icon that is displayed in the button.</p>\n',
          line: 80,
          type: 'string',
          decorators: [],
        },
        {
          name: 'iconSize',
          defaultValue: "'md'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe size of the icon to be displayed. Defaults to md.\n',
          description: '<p>The size of the icon to be displayed. Defaults to md.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
        },
        {
          name: 'isOpen',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDefines whether or not the dropdown menu is opened initially.\n\nDefaults to `false`.\n',
          description:
            '<p>Defines whether or not the dropdown menu is opened initially.</p>\n<p>Defaults to <code>false</code>.</p>\n',
          line: 102,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showModalOnMobileView',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf true it will show the locale selection inside a modal on mobile view.\n',
          description: '<p>If true it will show the locale selection inside a modal on mobile view.</p>\n',
          line: 92,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'selectLocale',
          defaultValue: 'new EventEmitter<string>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn output property which will emit a selected Locale code.\n',
          description: '<p>An output property which will emit a selected Locale code.</p>\n',
          line: 107,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'changeLanguage',
          args: [
            {
              name: 'localeCode',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 125,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nChanges the current language to the specified locale, toggles locale modal\nand triggers a output event with selected locale code.\n',
          description:
            '<p>Changes the current language to the specified locale, toggles locale modal\nand triggers a output event with selected locale code.</p>\n',
          jsdoctags: [
            {
              name: 'localeCode',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'toggleLocaleModal',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 133,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nToggles the visibility of the locale selector modal.\n',
          description: '<p>Toggles the visibility of the locale selector modal.</p>\n',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'LocaleSelectorExampleComponent',
      selector: 'bb-locale-selector-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-locale-selector-example-ui',\n  templateUrl: './locale-selector.example.component.html',\n  standalone: false,\n})\nexport class LocaleSelectorExampleComponent {}\n",
      template: '<bb-locale-selector-ui></bb-locale-selector-ui>\n',
    },
    {
      name: 'LogoComponent',
      selector: 'bb-logo-ui',
      inputsClass: [
        {
          name: 'isInverse',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFlag to indicate whether to use the inverse colors or not.  Defaults to false.\n',
          description: '<p>Flag to indicate whether to use the inverse colors or not.  Defaults to false.</p>\n',
          line: 27,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'type',
          defaultValue: "'full'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe type of the logo.  Defaults to 'full'.\n",
          description: '<p>The type of the logo.  Defaults to &#39;full&#39;.</p>\n',
          line: 23,
          type: 'LogoType',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that displays the company logo.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'LogoExampleComponent',
      selector: 'bb-logo-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-logo-example-ui',\n  templateUrl: './logo.example.component.html',\n  standalone: false,\n})\nexport class LogoExampleComponent {}\n",
      template: '<div style="max-height: 80px; max-width: 80px">\n  <bb-logo-ui type="emblem"></bb-logo-ui>\n</div>\n',
    },
    {
      name: 'ModalBodyComponent',
      selector: 'bb-modal-body-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'setScrollable',
          args: [
            {
              name: 'scrollable',
              type: 'boolean | undefined',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 26,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'scrollable',
              type: 'boolean | undefined',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ModalComponent',
      selector: 'bb-modal-ui',
      inputsClass: [
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby with an element id that contains a detailed description about the modal.\n',
          description:
            '<p>Set aria-describedby with an element id that contains a detailed description about the modal.</p>\n',
          line: 92,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-labelledby with an element id that contains a brief label about the modal.\nBy default is takes the modal heading.\n',
          description:
            '<p>Set aria-labelledby with an element id that contains a brief label about the modal.\nBy default is takes the modal heading.</p>\n',
          line: 78,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'isOpen',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nThe flag to show the dialog window. Defaults to 'false'.\n",
          description: '<p>The flag to show the dialog window. Defaults to &#39;false&#39;.</p>\n',
          line: 66,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'modalOptions',
          defaultValue: '{}',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nDialog options inherited from https://ng-bootstrap.github.io/#/components/modal/api#NgbModalOptions. Defaults to an empty object.\n',
          description:
            '<p>Dialog options inherited from <a href="https://ng-bootstrap.github.io/#/components/modal/api#NgbModalOptions">https://ng-bootstrap.github.io/#/components/modal/api#NgbModalOptions</a>. Defaults to an empty object.</p>\n',
          line: 114,
          type: 'NgbModalOptions',
          decorators: [],
        },
        {
          name: 'moneyProtectionBannerClasses',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 4044,
              end: 4062,
              kind: 344,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 4045,
                end: 4049,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'type',
              },
              comment: '',
              typeExpression: {
                pos: 4050,
                end: 4058,
                kind: 309,
                id: 0,
                flags: 16842752,
                modifierFlagsCache: 0,
                transformFlags: 0,
                type: {
                  pos: 4051,
                  end: 4057,
                  kind: 154,
                  id: 0,
                  flags: 16777216,
                  transformFlags: 1,
                },
              },
            },
          ],
          rawdescription: '\n\nCustom class to be assigned for money protection banner inside modal\n',
          description: '<p>Custom class to be assigned for money protection banner inside modal</p>\n',
          line: 126,
          type: 'string',
          decorators: [],
        },
        {
          name: 'role',
          defaultValue: "'dialog'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nCustomize the ARIA role this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]=\"'alertdialog'\"`\nif it requires immediate attention of the user.\n\nDefaults to 'dialog'.\n",
          description:
            '<p>Customize the ARIA role this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;alertdialog&#39;&quot;</code>\nif it requires immediate attention of the user.</p>\n<p>Defaults to &#39;dialog&#39;.</p>\n',
          line: 110,
          type: 'string',
          decorators: [],
        },
        {
          name: 'showMoneyProtectionBanner',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe flag to show money protection insurance banner on top of the modal.\nIn order to see banner you will need to configure `BB_MONEY_PROTECTION_BANNER_CONFIG_TOKEN` to provide\ncomponent to render in banner content outlet.\n',
          description:
            '<p>The flag to show money protection insurance banner on top of the modal.\nIn order to see banner you will need to configure <code>BB_MONEY_PROTECTION_BANNER_CONFIG_TOKEN</code> to provide\ncomponent to render in banner content outlet.</p>\n',
          line: 121,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'cancel',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe event that\'s fired after cancel button is pressed. Can be used with\n(click)="dialogRef.onCancel()" where dialogRef is a templateRef on <bb-dialog-ui #dialogRef />\n',
          description:
            '<p>The event that&#39;s fired after cancel button is pressed. Can be used with\n(click)=&quot;dialogRef.onCancel()&quot; where dialogRef is a templateRef on &lt;bb-dialog-ui #dialogRef /&gt;</p>\n',
          line: 136,
          type: 'EventEmitter',
        },
        {
          name: 'confirm',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe event that\'s fired after confirm button is pressed. Can be used with\n(click)="dialogRef.onConfirm()" where dialogRef is a templateRef on <bb-dialog-ui #dialogRef />\n',
          description:
            '<p>The event that&#39;s fired after confirm button is pressed. Can be used with\n(click)=&quot;dialogRef.onConfirm()&quot; where dialogRef is a templateRef on &lt;bb-dialog-ui #dialogRef /&gt;</p>\n',
          line: 131,
          type: 'EventEmitter',
        },
        {
          name: 'isOpenChange',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nUsed for two way binding with the isOpen Input. If used, backdrop\nand esc dismiss cases will be handled automatically.\n',
          description:
            '<p>Used for two way binding with the isOpen Input. If used, backdrop\nand esc dismiss cases will be handled automatically.</p>\n',
          line: 141,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'closeModal',
          args: [
            {
              name: 'reason',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 182,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'reason',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'dismissModal',
          args: [
            {
              name: 'reason',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 178,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'reason',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getDismissReason',
          args: [
            {
              name: 'reason',
              type: 'ModalDismissReasons | string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'ModalDismissReasons | string',
          typeParameters: [],
          line: 172,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'reason',
              type: 'ModalDismissReasons | string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'setConfirm',
          args: [
            {
              name: 'flag',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 186,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'flag',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'trapKeyEvent',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 196,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description:
        '<p>Component that displays a modal window.\n<br><br></p>\n<h3>Controlling components with overflow/z-index</h3>\n<p>If you have nested modals, dropdowns or select components,\nadd (or remove) the property <code>container=&quot;body&quot;</code> on your topmost component.\nYou may have to toggle around depending on your setup or if your modal/dropdown/select has overflow.</p>\n<p>Alternatively, you can also add the <code>.modal-overflow</code> class by doing:\n<code>[modalOptions]=&quot;{ modalDialogClass: &#39;modal-overflow&#39; }&quot;</code>.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ModalExampleComponent',
      selector: 'bb-modal-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'changeColor',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 20,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'closeDialog',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 16,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onConfirmDialog',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 25,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'openDialog',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 12,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n@Component({\n  selector: 'bb-modal-example-ui',\n  templateUrl: './modal.example.component.html',\n  standalone: false,\n})\nexport class ModalExampleComponent {\n  buttonColor = 'primary';\n\n  showDialog = false;\n\n  openDialog() {\n    this.showDialog = true;\n  }\n\n  closeDialog() {\n    this.showDialog = false;\n  }\n\n  changeColor() {\n    this.buttonColor =\n      this.buttonColor === 'primary' ? 'secondary' : 'primary';\n  }\n\n  onConfirmDialog() {\n    this.changeColor();\n    this.closeDialog();\n  }\n}\n",
      template:
        '<div id="ariaDescribedById">\n  Confirm Changing the color By Clicking on the button\n</div>\n<button\n  #button\n  bbButton\n  type="button"\n  [color]="buttonColor"\n  (click)="openDialog()"\n  id="ariaLabelledByID"\n>\n  Click here to change the color!\n</button>\n<bb-modal-ui\n  [isOpen]="showDialog"\n  (cancel)="closeDialog()"\n  (confirm)="onConfirmDialog()"\n  [aria-describedby]="\'ariaDescribedById\'"\n  [aria-labelledby]="\'ariaLabelledByID\'"\n>\n  <bb-modal-header-ui\n    title="Confirm changing the color"\n  ></bb-modal-header-ui>\n  <bb-modal-body-ui>\n    <ng-template bbCustomModalBody>\n      Are you sure you want to change the color?\n    </ng-template>\n  </bb-modal-body-ui>\n  <bb-modal-footer-ui confirmText="I Agree" (confirm)="closeDialog()">\n  </bb-modal-footer-ui>\n</bb-modal-ui>\n',
    },
    {
      name: 'ModalFooterComponent',
      selector: 'bb-modal-footer-ui',
      inputsClass: [
        {
          name: 'cancelText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe text of the cancel button.\n',
          description: '<p>The text of the cancel button.</p>\n',
          line: 30,
          type: 'string',
          decorators: [],
        },
        {
          name: 'confirmText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe text of the confirm button.\n',
          description: '<p>The text of the confirm button.</p>\n',
          line: 26,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'cancel',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe event that\'s fired after cancel button is pressed. Can be used with (click)="dialogRef.onCancel()"\nwhere dialogRef is a templateRef on <bb-dialog-ui #dialogRef />\n',
          description:
            '<p>The event that&#39;s fired after cancel button is pressed. Can be used with (click)=&quot;dialogRef.onCancel()&quot;\nwhere dialogRef is a templateRef on &lt;bb-dialog-ui #dialogRef /&gt;</p>\n',
          line: 40,
          type: 'EventEmitter',
        },
        {
          name: 'confirm',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe event that\'s fired after confirm button is pressed. Can be used with (click)="dialogRef.onConfirm()"\nwhere dialogRef is a templateRef on <bb-dialog-ui #dialogRef />\n',
          description:
            '<p>The event that&#39;s fired after confirm button is pressed. Can be used with (click)=&quot;dialogRef.onConfirm()&quot;\nwhere dialogRef is a templateRef on &lt;bb-dialog-ui #dialogRef /&gt;</p>\n',
          line: 35,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'onCancel',
          args: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 42,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onConfirm',
          args: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 50,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ModalHeaderComponent',
      selector: 'bb-modal-header-ui',
      inputsClass: [
        {
          name: 'closeButtonAriaLabel',
          defaultValue: '$localize`:@@bb-modal-header-ui.close-button.aria-label:Close modal window`',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAria label for a "close" button\n',
          description: '<p>Aria label for a &quot;close&quot; button</p>\n',
          line: 29,
          type: 'any',
          decorators: [],
        },
        {
          name: 'showClose',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to display the close button.\nDefaults to true.\n',
          description: '<p>Whether to display the close button.\nDefaults to true.</p>\n',
          line: 35,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'title',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nTitle text for the modal header. Defaults to empty string.\n',
          description: '<p>Title text for the modal header. Defaults to empty string.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'close',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe event emitted when the modal header close button is clicked.\n',
          description: '<p>The event emitted when the modal header close button is clicked.</p>\n',
          line: 40,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'onClose',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 46,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ModeHeaderComponent',
      selector: 'bb-mode-header-ui',
      inputsClass: [
        {
          name: 'closeButtonAriaLabel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe aria label to describe the close button to screen reader users.\n',
          description: '<p>The aria label to describe the close button to screen reader users.</p>\n',
          line: 34,
          type: 'string',
          decorators: [],
        },
        {
          name: 'reverseTitleOrder',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether or not the order of title elements is reversed.\n',
          description: '<p>Whether or not the order of title elements is reversed.</p>\n',
          line: 39,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'secondaryTitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe smaller, secondary title to display.\n',
          description: '<p>The smaller, secondary title to display.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
        },
        {
          name: 'showCloseButton',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether or not to show the close button. Defaults to true.\n',
          description: '<p>Whether or not to show the close button. Defaults to true.</p>\n',
          line: 29,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe main title to display.\n',
          description: '<p>The main title to display.</p>\n',
          line: 19,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'close',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent fired when the close button is clicked.\n',
          description: '<p>Event fired when the close button is clicked.</p>\n',
          line: 44,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [],
      description: '<p>Component that displays a mode header.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ModeHeaderExampleComponent',
      selector: 'bb-mode-header-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onActionOneClick',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 13,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onActionTwoClick',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 17,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onCloseModeHeaderClick',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 9,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-mode-header-example-ui',\n  templateUrl: './mode-header.example.component.html',\n  standalone: false,\n})\nexport class ModeHeaderExampleComponent {\n  onCloseModeHeaderClick() {\n    console.log('Mode header closed');\n  }\n\n  onActionOneClick() {\n    console.log('Action one clicked');\n  }\n\n  onActionTwoClick() {\n    console.log('Action two clicked');\n  }\n}\n",
      template:
        '<bb-mode-header-ui\n  title="Sarah Conners"\n  secondaryTitle="Retail banking user"\n  closeButtonAriaLabel="Close mode header to exit the user details section"\n  [showCloseButton]="true"\n  [reverseTitleOrder]="true"\n  (close)="onCloseModeHeaderClick()"\n>\n  <bb-icon-ui\n    mode-header-icon\n    name="search"\n    class="bb-stack__item--fill"\n    size="sm"\n    color="primary"\n  ></bb-icon-ui>\n  <bb-badge-ui mode-header-status text="Sample Text" color="success">\n  </bb-badge-ui>\n  <bb-dropdown-menu-ui\n    mode-header-utility-area\n    container="body"\n    icon="caret-down"\n    btnColor="primary"\n    iconSize="md"\n  >\n    <ng-template bbDropdownLabel> <span>Actions</span></ng-template>\n    <ng-template bbDropdownMenuItem>\n      <button\n        class="dropdown-item"\n        type="button"\n        (click)="onActionOneClick()"\n      >\n        Action One\n      </button>\n      <button\n        class="dropdown-item"\n        type="button"\n        (click)="onActionTwoClick()"\n      >\n        Action Two\n      </button>\n    </ng-template>\n  </bb-dropdown-menu-ui>\n</bb-mode-header-ui>\n',
    },
    {
      name: 'NotificationComponent',
      selector: 'bb-notification-ui',
      inputsClass: [
        {
          name: 'animation',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIf `true`, notification opening and closing will be animated.\nAnimation is triggered only when the `.hide()` or `.show()` functions are called.\n',
          description:
            '<p>If <code>true</code>, notification opening and closing will be animated.\nAnimation is triggered only when the <code>.hide()</code> or <code>.show()</code> functions are called.</p>\n',
          line: 177,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the notification should focused when rendered.\n',
          description: '<p>Whether the notification should focused when rendered.</p>\n',
          line: 181,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'closeAction',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe callback function for the manually close event.\n',
          description: '<p>The callback function for the manually close event.</p>\n',
          line: 160,
          type: 'Function',
          decorators: [],
        },
        {
          name: 'dismissible',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether the notification is dismissible. Defaults to `true`.\n\n\nIf `true` then an additional class name is added to the wrapper div of the notification in the following format\n`bb-notification--dismissible`\n',
          description:
            '<p>Whether the notification is dismissible. Defaults to <code>true</code>.</p>\n<p>If <code>true</code> then an additional class name is added to the wrapper div of the notification in the following format\n<code>bb-notification--dismissible</code></p>\n',
          line: 138,
          type: 'boolean',
          decorators: [],
        },
        {
          required: true,
          name: 'header',
          deprecated: false,
          deprecationMessage: '',
          optional: false,
          rawdescription: '\n\nThe header for the notification.\n\nInput is required.\n',
          description: '<p>The header for the notification.</p>\n<p>Input is required.</p>\n',
          line: 110,
          type: 'TemplateRef<any> | string',
          decorators: [],
        },
        {
          name: 'headerContext',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe context for notification header template.\n',
          description: '<p>The context for notification header template.</p>\n',
          line: 168,
          type: 'any',
          decorators: [],
        },
        {
          name: 'hostAction',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe callback function for the host click event.\n',
          description: '<p>The callback function for the host click event.</p>\n',
          line: 164,
          type: 'Function',
          decorators: [],
        },
        {
          name: 'message',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe message template for the notification. Defaults to an empty string.\n',
          description: '<p>The message template for the notification. Defaults to an empty string.</p>\n',
          line: 114,
          type: 'TemplateRef<any> | string',
          decorators: [],
        },
        {
          name: 'messageContext',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe context for notification message template.\n',
          description: '<p>The context for notification message template.</p>\n',
          line: 172,
          type: 'any',
          decorators: [],
        },
        {
          name: 'modifier',
          defaultValue: "'info'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe type modifier for the notification. Defaults to 'info'\n\nThis property will be used to add additional class names to the wrapper div of the notification\nin the following format: `bb-notification--<<modifier>>`\n\n",
          description:
            '<p>The type modifier for the notification. Defaults to &#39;info&#39;</p>\n<p>This property will be used to add additional class names to the wrapper div of the notification\nin the following format: <code>bb-notification--&lt;&lt;modifier&gt;&gt;</code></p>\n',
          line: 130,
          type: 'NotificationType',
          decorators: [],
        },
        {
          name: 'primaryAction',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nA callback function for the primary action. Required for buttons on notification.\n',
          description: '<p>A callback function for the primary action. Required for buttons on notification.</p>\n',
          line: 147,
          type: 'Function',
          decorators: [],
        },
        {
          name: 'primaryActionTemplate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe primary action template for the notification.\n',
          description: '<p>The primary action template for the notification.</p>\n',
          line: 118,
          type: 'TemplateRef<any>',
          decorators: [],
        },
        {
          name: 'primaryActionText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe text for the primary action button.\nWill throw an error if unset and primary action set.\n',
          description:
            '<p>The text for the primary action button.\nWill throw an error if unset and primary action set.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
        },
        {
          name: 'secondaryAction',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nA callback function for the secondary action. Required for buttons on notification.\n',
          description: '<p>A callback function for the secondary action. Required for buttons on notification.</p>\n',
          line: 156,
          type: 'Function',
          decorators: [],
        },
        {
          name: 'secondaryActionTemplate',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe secondary action template for the notification.\n',
          description: '<p>The secondary action template for the notification.</p>\n',
          line: 122,
          type: 'TemplateRef<any>',
          decorators: [],
        },
        {
          name: 'secondaryActionText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe text for the secondary action button.\nWill throw an error if unset and secondary action set.\n',
          description:
            '<p>The text for the secondary action button.\nWill throw an error if unset and secondary action set.</p>\n',
          line: 152,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'close',
          defaultValue: 'new EventEmitter()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nNotification manually close event stream.\n',
          description: '<p>Notification manually close event stream.</p>\n',
          line: 185,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'beforeDestroy',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 320,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getHeaderTemplate',
          args: [],
          optional: false,
          returnType: 'TemplateRef | undefined',
          typeParameters: [],
          line: 359,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getMessageTemplate',
          args: [],
          optional: false,
          returnType: 'TemplateRef | undefined',
          typeParameters: [],
          line: 367,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'hasButtonRow',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 375,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'hasPrimaryAction',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 379,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'hasSecondaryAction',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 383,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onKeyEvent',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 231,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'window:keydown', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onNotificationClick',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 282,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onNotificationClose',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 289,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onPrimaryPress',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 345,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onSecondaryPress',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 352,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description:
        '<p>Component that displays a notification.</p>\n<h3>Usage</h3>\n<p>Notification component can be rendered with <code>NotificationService</code> Below is an example of this this will look like:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&#64;Component({\n   standalone: true,\n   selector: &#39;bb-some-component&#39;,\n   template: &#39;&#39;,\n   imports: [NotificationModule],\n })\n export class SomeComponent {\n   notificationService = inject(NotificationService);\n\n   showNotification() {\n     this.notificationService.showNotification({\n       header: &#39;This is the header of notification&#39;,\n       message: &#39;This is the message of notification&#39;,\n     });\n   }\n }</code></pre></div><h3>Usage with NotificationService</h3>\n<p>NotificationComponent allows providing header and message as templates. Below is\nan example of what a component with might look like:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&#64;Component({\n   standalone: true,\n   selector: &#39;bb-some-component&#39;,\n   template: &#39;\n     &lt;ng-template #headerTml&gt;\n       Template header\n     &lt;/ng-template&gt;\n\n     &lt;ng-template #messageTemplate&gt;\n       This is an html message message template\n     &lt;/ng-template&gt;\n   &#39;,\n   imports: [NotificationModule],\n })\n export class SomeComponent {\n  &#64;ViewChild(&#39;headerTml&#39;, { static: true }) headerTml: TemplateRef&lt;any&gt; | undefined;\n  &#64;ViewChild(&#39;messageTemplate&#39;, { static: true }) messageTemplate: TemplateRef&lt;any&gt; | undefined;\n\n   notificationService = inject(NotificationService);\n\n   showNotification() {\n     this.notificationService.showNotification({\n       header: this.headerTml,\n       message: this.messageTemplate,\n     });\n   }\n }</code></pre></div><h3>Known issues:</h3>\n<h4>Focus event of any element will interrupt VO readout of notification.</h4>\n<p>Due to the fact that notifications container is using <code>aria-live=&quot;polite&quot;</code> and <code>role=&quot;status&quot;</code> notifications can get interrupted with any other event. Example:</p>\n<ul>\n<li>User opens a modal</li>\n<li>After modal is closed, notification is shown</li>\n<li>VO will try to announce notification</li>\n<li>Modal puts focus back to button that triggered it.</li>\n<li>VO is interrupted and starts announcing button text</li>\n</ul>\n<p><strong>Possible solution</strong> is to delay notification render with <code>setTimeout</code> or any other possible solution in streams.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'NotificationExampleComponent',
      selector: 'bb-notification-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'checkMail',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 21,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'checkMailTemplate',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 25,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'showNewMailNotification',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 32,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'showNewMailNotificationWithTemplateMesage',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 47,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component, TemplateRef, ViewChild } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { NotificationService } from '@backbase/ui-ang/notification';\n\nconst LOAD_DELAY = 500;\n\n@Component({\n  selector: 'bb-notification-example-ui',\n  templateUrl: './notification.example.component.html',\n  standalone: false,\n})\nexport class NotificationExampleComponent {\n  constructor(\n    private readonly notificationService: NotificationService,\n  ) {}\n\n  @ViewChild('messageTemplate', { static: true }) messageTemplate!:\n    | TemplateRef<any>\n    | string;\n\n  checkMail() {\n    setTimeout(() => this.showNewMailNotification(), LOAD_DELAY);\n  }\n\n  checkMailTemplate() {\n    setTimeout(\n      () => this.showNewMailNotificationWithTemplateMesage(),\n      LOAD_DELAY,\n    );\n  }\n\n  showNewMailNotification() {\n    this.notificationService.showNotification({\n      header: 'You’ve got new mail!',\n      message:\n        'Backbase Release 1.2.3 is now available! What’s new in this release? ...',\n      modifier: 'info',\n      dismissible: true,\n      ttl: 5000,\n      primaryActionText: 'Visit website',\n      primaryAction: () => {\n        window.location.href = 'https://backbase.com/';\n      },\n    });\n  }\n\n  showNewMailNotificationWithTemplateMesage() {\n    this.notificationService.showNotification({\n      header: 'You’ve got new mail!',\n      message: this.messageTemplate,\n      modifier: 'info',\n      dismissible: true,\n      ttl: 5000,\n      primaryActionText: 'Visit website',\n      primaryAction: () => {\n        window.location.href = 'https://backbase.com/';\n      },\n    });\n  }\n}\n",
      template:
        '<button\n  type="button"\n  (click)="checkMail()"\n  bbButton\n  [buttonSize]="\'md\'"\n  [color]="\'primary\'"\n>\n  Check for new mails\n</button>\n\n<button\n  type="button"\n  (click)="checkMailTemplate()"\n  bbButton\n  [buttonSize]="\'md\'"\n  [color]="\'primary\'"\n>\n  Check for new mails (message template)\n</button>\n\n<ng-template #messageTemplate>\n  <p>Backbase Release <strong>3.8.0</strong> is now available!</p>\n</ng-template>\n',
    },
    {
      name: 'OptionListComponent',
      selector: 'bb-option-list-ui',
      inputsClass: [
        {
          name: 'columns',
          defaultValue: '1',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nNumber of columns for displaying the buttons (one, two or three).\n',
          description: '<p>Number of columns for displaying the buttons (one, two or three).</p>\n',
          line: 60,
          type: 'OptionListColumns',
          decorators: [],
        },
        {
          name: 'mode',
          defaultValue: "'radio'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSelection mode for the option list (radio or checkbox).\n',
          description: '<p>Selection mode for the option list (radio or checkbox).</p>\n',
          line: 55,
          type: 'OptionListMode',
          decorators: [],
        },
        {
          required: true,
          name: 'options',
          deprecated: false,
          deprecationMessage: '',
          optional: false,
          rawdescription: '\n\nList of option buttons to display.\nValidates the number of options (2-9).\n',
          description: '<p>List of option buttons to display.\nValidates the number of options (2-9).</p>\n',
          line: 39,
          type: 'OptionListItem[]',
          decorators: [],
        },
        {
          name: 'preserveColumnsAmount',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEnsures that the number of displayed columns remains constant across all screen sizes.\nIf the flag is set to false or not defined, the number of displayed columns will be reduced to 1 on XS screens.\n',
          description:
            '<p>Ensures that the number of displayed columns remains constant across all screen sizes.\nIf the flag is set to false or not defined, the number of displayed columns will be reduced to 1 on XS screens.</p>\n',
          line: 66,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'isSelected',
          args: [
            {
              name: 'value',
              type: 'string | boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 118,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDetermines whether a value is selected.\n',
          description: '<p>Determines whether a value is selected.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 3289,
                end: 3294,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'value',
              },
              type: 'string | boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 3283,
                end: 3288,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>The value to check.</p>\n',
            },
          ],
        },
        {
          name: 'onButtonBlur',
          args: [
            {
              name: 'index',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 138,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nHandles blur on a button.\n',
          description: '<p>Handles blur on a button.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 3779,
                end: 3784,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'index',
              },
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 3773,
                end: 3778,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>The index of the blurred button.</p>\n',
            },
          ],
        },
        {
          name: 'onButtonFocus',
          args: [
            {
              name: 'index',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 130,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nHandles focus on a button.\n',
          description: '<p>Handles focus on a button.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 3604,
                end: 3609,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'index',
              },
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 3598,
                end: 3603,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>The index of the focused button.</p>\n',
            },
          ],
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 204,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet disable state for the host control\n',
          description: '<p>Set disable state for the host control</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 5600,
                end: 5610,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'isDisabled',
              },
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 5594,
                end: 5599,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'updateValue',
          args: [
            {
              name: 'selectedValue',
              type: 'string | boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 174,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nUpdates the selected value for the option list.\n',
          description: '<p>Updates the selected value for the option list.</p>\n',
          jsdoctags: [
            {
              name: {
                pos: 4649,
                end: 4662,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'selectedValue',
              },
              type: 'string | boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 4643,
                end: 4648,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>The value to select or deselect.</p>\n',
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'string[] | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 150,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nImplements the value update for the control\n',
          description: '<p>Implements the value update for the control</p>\n',
          modifierKind: [164],
          jsdoctags: [
            {
              name: {
                pos: 4071,
                end: 4081,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'inputValue',
              },
              type: 'string[] | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 4065,
                end: 4070,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'PageHeaderComponent',
      selector: 'bb-page-header-ui',
      inputsClass: [
        {
          name: 'navigationLinkText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe label of the navigation button.\nRenders a button meant for navigating to the previous page if provided.\n',
          description:
            '<p>The label of the navigation button.\nRenders a button meant for navigating to the previous page if provided.</p>\n',
          line: 76,
          type: 'string',
          decorators: [],
        },
        {
          name: 'primaryAction',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nAn object with properties of a button that takes the primary role.\nRenders a button with `primary` style if provided.\nOverwrites any custom action if provided.\n\nAccepts the properties: `text: string`, `icon: string`.\n',
          description:
            '<p>An object with properties of a button that takes the primary role.\nRenders a button with <code>primary</code> style if provided.\nOverwrites any custom action if provided.</p>\n<p>Accepts the properties: <code>text: string</code>, <code>icon: string</code>.</p>\n',
          line: 90,
          type: 'ButtonAction',
          decorators: [],
        },
        {
          name: 'secondaryAction',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nAn object with properties of a button that takes the secondary role.\nRenders a button with `secondary` style if provided.\nOverwrites any custom action if provided.\n\nAccepts the properties: `text: string`, `icon: string`.\n',
          description:
            '<p>An object with properties of a button that takes the secondary role.\nRenders a button with <code>secondary</code> style if provided.\nOverwrites any custom action if provided.</p>\n<p>Accepts the properties: <code>text: string</code>, <code>icon: string</code>.</p>\n',
          line: 99,
          type: 'ButtonAction',
          decorators: [],
        },
        {
          required: false,
          name: 'showBackground',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether a colored background is rendered behind the component.\nChanges the text and buttons to `on-color` elements.\n\nDefaults to false.\n',
          description:
            '<p>Whether a colored background is rendered behind the component.\nChanges the text and buttons to <code>on-color</code> elements.</p>\n<p>Defaults to false.</p>\n',
          line: 70,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'subtitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSupplementary text to accommodate the title.\n',
          description: '<p>Supplementary text to accommodate the title.</p>\n',
          line: 81,
          type: 'string',
          decorators: [],
        },
        {
          required: true,
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          optional: false,
          rawdescription: '\n\nThe main text to be displayed.\n\nInput is required.\n',
          description: '<p>The main text to be displayed.</p>\n<p>Input is required.</p>\n',
          line: 62,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'navigationLinkClick',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event fired when the navigation button is clicked.\n',
          description: '<p>An event fired when the navigation button is clicked.</p>\n',
          line: 104,
          type: 'EventEmitter',
        },
        {
          name: 'primaryActionClick',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event fired when the primary button is clicked.\n',
          description: '<p>An event fired when the primary button is clicked.</p>\n',
          line: 109,
          type: 'EventEmitter',
        },
        {
          name: 'secondaryActionClick',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event fired when the secondary button is clicked.\n',
          description: '<p>An event fired when the secondary button is clicked.</p>\n',
          line: 114,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [],
      description:
        '<p>A component which provides a layout template for default responsive page headers in Web.\nIt can feature a title and an optional subtitle, as well as up to two default call-to-action buttons (or a custom action) and a navigation link.</p>\n<h4>Usage notes</h4>\n<p>If you would like to use your custom action element, you can do the following:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript">&lt;bb-page-header-ui title=&quot;Page title&quot; subtitle=&quot;Page subtitle&quot;&gt;\n  &lt;ng-template bbPageHeaderCustomAction&gt;\n    &lt;button&gt;Action&lt;/button&gt;\n  &lt;/ng-template&gt;\n\n  &lt;div&gt;Content&lt;/div&gt;\n&lt;/bb-page-header-ui&gt;</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'PageHeaderExampleComponent',
      selector: 'bb-page-header-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-page-header-example-ui',\n  templateUrl: './page-header.example.component.html',\n  standalone: false,\n})\nexport class PageHeaderExampleComponent {}\n",
      template:
        '<bb-page-header-ui\n  title="This is the page title"\n  subtitle="This is the page subtitle"\n  navigationLinkText="Back to Dashboard"\n  [primaryAction]="{ text: \'New card\' }"\n  [secondaryAction]="{ text: \'Add reminder\', icon: \'access-alarms\' }"\n></bb-page-header-ui>\n',
    },
    {
      name: 'PaginationExampleComponent',
      selector: 'bb-pagination-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onPageChange',
          args: [
            {
              name: 'page',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 12,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'page',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-pagination-example-ui',\n  templateUrl: './pagination.example.component.html',\n  standalone: false,\n})\nexport class PaginationExampleComponent {\n  page = 0;\n  totalItems = 100;\n\n  onPageChange(page: number) {\n    this.page = page;\n  }\n}\n",
      template:
        '<bb-pagination-ui\n  [boundaryLinks]="true"\n  [directionLinks]="true"\n  [itemsPerPage]="10"\n  [maxNavPages]="2"\n  [page]="0"\n  [totalItems]="totalItems"\n  (pageChange)="onPageChange($event)"\n></bb-pagination-ui>\n',
    },
    {
      name: 'PaginatorComponent',
      selector: 'bb-pagination-ui',
      inputsClass: [
        {
          name: 'boundaryLinks',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf `true`, the "First" and "Last" page links are shown. Defaults to false.\n',
          description:
            '<p>If <code>true</code>, the &quot;First&quot; and &quot;Last&quot; page links are shown. Defaults to false.</p>\n',
          line: 54,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'directionLinks',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIf `true`, the "Next" and "Previous" page links are shown. Defaults to false.\n',
          description:
            '<p>If <code>true</code>, the &quot;Next&quot; and &quot;Previous&quot; page links are shown. Defaults to false.</p>\n',
          line: 58,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'itemsPerPage',
          defaultValue: '10',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe number of items per page.\n',
          description: '<p>The number of items per page.</p>\n',
          line: 69,
          type: 'number',
          decorators: [],
        },
        {
          name: 'maxNavPages',
          defaultValue: '5',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maximum number of pages to display.\n',
          description: '<p>The maximum number of pages to display.</p>\n',
          line: 73,
          type: 'number',
          decorators: [],
        },
        {
          name: 'page',
          defaultValue: '1',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe current page.\n\n`bb-paginator-ui` is 0-indexed, but `ngb-pagination` is 1-indexed. Corrects input by adding 1 internally.\n',
          description:
            '<p>The current page.</p>\n<p><code>bb-paginator-ui</code> is 0-indexed, but <code>ngb-pagination</code> is 1-indexed. Corrects input by adding 1 internally.</p>\n',
          line: 50,
          type: 'number',
          decorators: [],
        },
        {
          name: 'totalItems',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe number of items in your paginated collection.\n\nNote, that this is not the number of pages. Page numbers are calculated dynamically based on\n`totalItems` and `itemsPerPage`.\n',
          description:
            '<p>The number of items in your paginated collection.</p>\n<p>Note, that this is not the number of pages. Page numbers are calculated dynamically based on\n<code>totalItems</code> and <code>itemsPerPage</code>.</p>\n',
          line: 65,
          type: 'number',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'pageChange',
          defaultValue: 'new EventEmitter<number>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nAn event fired when the page is changed. Will fire only if collection size is set and all values are valid.\n\nEvent payload is the number of the newly selected page.\n\n`bb-paginator-ui` is 0-indexed, but `ngb-pagination` is 1-indexed. Corrects output by subtracting 1 internally.\n',
          description:
            '<p>An event fired when the page is changed. Will fire only if collection size is set and all values are valid.</p>\n<p>Event payload is the number of the newly selected page.</p>\n<p><code>bb-paginator-ui</code> is 0-indexed, but <code>ngb-pagination</code> is 1-indexed. Corrects output by subtracting 1 internally.</p>\n',
          line: 81,
          type: 'EventEmitter<number>',
        },
      ],
      methodsClass: [
        {
          name: 'onPageChange',
          args: [
            {
              name: 'page',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 83,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'page',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '<p>A component that displays page numbers and allows to customize them in several ways.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'PaymentCardComponent',
      selector: 'bb-payment-card-ui',
      inputsClass: [
        {
          name: 'displayEmblem',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDisplay Backbase logo on the card.\n',
          description: '<p>Display Backbase logo on the card.</p>\n',
          line: 95,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'displayOverlay',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDisplay card overlay in the card.\nDefaults to `false`.\n',
          description: '<p>Display card overlay in the card.\nDefaults to <code>false</code>.</p>\n',
          line: 101,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'imageSrc',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration to pass a link or (base64, svg) image to be used as the background image of the card.\nDefaults to `undefined`.\n',
          description:
            '<p>Configuration to pass a link or (base64, svg) image to be used as the background image of the card.\nDefaults to <code>undefined</code>.</p>\n',
          line: 90,
          type: 'string',
          decorators: [],
        },
        {
          name: 'overlayIcon',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nOverlay icon to be displayed on the card.\nPossible values: 'access-time', 'lock', 'not-interested', 'remove-circle-outline', 'warning'.\nDefaults to `undefined`.\n",
          description:
            '<p>Overlay icon to be displayed on the card.\nPossible values: &#39;access-time&#39;, &#39;lock&#39;, &#39;not-interested&#39;, &#39;remove-circle-outline&#39;, &#39;warning&#39;.\nDefaults to <code>undefined</code>.</p>\n',
          line: 114,
          type: '"access-time" | "lock" | "not-interested" | "remove-circle-outline" | "warning"',
          decorators: [],
        },
        {
          name: 'overlayText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nOverlay status to be displayed on the card.\nDefaults to `undefined`.\n',
          description: '<p>Overlay status to be displayed on the card.\nDefaults to <code>undefined</code>.</p>\n',
          line: 107,
          type: 'string',
          decorators: [],
        },
        {
          name: 'paymentCard',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nPayment card data.\n',
          description: '<p>Payment card data.</p>\n',
          line: 65,
          type: 'PaymentCard',
          decorators: [],
        },
        {
          name: 'paymentCardNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the card number should be formatted.\nDefaults to the following format:\n```\n{\nlength: 16,\nmaskRange: [0, 12],\nsegments: 4,\n}\n```\n\n',
          description:
            '<p>Configuration of how the card number should be formatted.\nDefaults to the following format:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none">{\nlength: 16,\nmaskRange: [0, 12],\nsegments: 4,\n}</code></pre></div>',
          line: 78,
          type: 'PaymentCardNumberFormat',
          decorators: [],
        },
        {
          name: 'size',
          defaultValue: 'PaymentCardSizes.MD',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nDefines the size of the card. Small cards show no content.\nDefaults to `'md'`.\n",
          description:
            '<p>Defines the size of the card. Small cards show no content.\nDefaults to <code>&#39;md&#39;</code>.</p>\n',
          line: 84,
          type: '"sm" | "md"',
          decorators: [],
        },
        {
          name: 'vertical',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nDisplay the card in a vertical orientation.\nDefaults to false\n',
          description: '<p>Display the card in a vertical orientation.\nDefaults to false</p>\n',
          line: 121,
          type: 'boolean | undefined',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that displays card of any vendor that can be used as a form of payment.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'PaymentCardExampleComponent',
      selector: 'bb-payment-card-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCard } from '@backbase/ui-ang/payment-card';\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\n\n@Component({\n  selector: 'bb-payment-card-example-ui',\n  templateUrl: './payment-card.example.component.html',\n  standalone: false,\n})\nexport class PaymentCardExampleComponent {\n  paymentCard: PaymentCard = {\n    name: 'Ricardo Peterson',\n    number: '5678',\n    vendor: 'mastercard',\n    expirationDate: new Date(2021, 2),\n    cardName: 'Backbase Blue Card',\n  };\n\n  numberFormat: PaymentCardNumberFormat = {\n    length: 16,\n    maskRange: [0, 12],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-payment-card-ui\n  [paymentCard]="paymentCard"\n  [paymentCardNumberFormat]="numberFormat"\n  [displayEmblem]="true"\n></bb-payment-card-ui>\n',
    },
    {
      name: 'PaymentCardNumberPipeExampleComponent',
      selector: 'bb-payment-card-number-pipe-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\n\n@Component({\n  selector: 'bb-payment-card-number-pipe-example-ui',\n  templateUrl: './payment-card-number-pipe.example.component.html',\n  standalone: false,\n})\nexport class PaymentCardNumberPipeExampleComponent {\n  productNumber = 'NL75INGB3400120056';\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 12],\n    segments: 4,\n  };\n}\n",
      template: '<p>{{ productNumber | paymentCardNumber : productNumberFormat }}</p>\n',
    },
    {
      name: 'PeriodSelectorComponent',
      selector: 'bb-period-selector-ui',
      inputsClass: [
        {
          name: 'period',
          defaultValue: "'month'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nPeriod step. Defaults to 'month'.\n",
          description: '<p>Period step. Defaults to &#39;month&#39;.</p>\n',
          line: 70,
          type: 'PeriodSize',
          decorators: [],
        },
        {
          name: 'periodEnd',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEnd date of the period.\n',
          description: '<p>End date of the period.</p>\n',
          line: 50,
          type: 'Date',
          decorators: [],
        },
        {
          name: 'periodFormatters',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustom date period formatter. Accepts formatters in the form of:\n\n```typescript\n {\n   title?: (date: Date) => string;\n   start?: (date: Date) => string;\n   end?: (date: Date) => string;\n }\n```\n\n',
          description:
            '<p>Custom date period formatter. Accepts formatters in the form of:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-typescript"> {\n   title?: (date: Date) =&gt; string;\n   start?: (date: Date) =&gt; string;\n   end?: (date: Date) =&gt; string;\n }</code></pre></div>',
          line: 64,
          type: 'PeriodFormatters',
          decorators: [],
        },
        {
          name: 'periodStart',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nStart date of the period.\n',
          description: '<p>Start date of the period.</p>\n',
          line: 46,
          type: 'Date',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'periodChange',
          defaultValue: 'new EventEmitter<Period>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits an event when the period is changed.\n',
          description: '<p>Emits an event when the period is changed.</p>\n',
          line: 75,
          type: 'EventEmitter<Period>',
        },
      ],
      methodsClass: [
        {
          name: 'changePeriod',
          args: [
            {
              name: 'next',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 118,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'next',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '<p>Component that selects a period.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'PeriodSelectorExampleComponent',
      selector: 'bb-period-selector-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PeriodFormatters } from '@backbase/ui-ang/period-selector';\n\nconst dateTimeToDate = (isoDateTime: string) =>\n  isoDateTime.replace(/T.+/, '');\n\n@Component({\n  selector: 'bb-period-selector-example-ui',\n  templateUrl: './period-selector.example.component.html',\n  standalone: false,\n})\nexport class PeriodSelectorExampleComponent {\n  startDate = new Date('2018-08-01');\n  endDate = new Date('2018-08-31');\n\n  periodFormatters: PeriodFormatters = {\n    start: (date: Date) => dateTimeToDate(date.toISOString()),\n    end: (date: Date) => `End: ${dateTimeToDate(date.toISOString())}`,\n  };\n}\n",
      template:
        '<bb-period-selector-ui\n  periodSize="month"\n  [periodStart]="startDate"\n  [periodEnd]="endDate"\n  [periodFormatters]="periodFormatters"\n></bb-period-selector-ui>\n',
    },
    {
      name: 'PhoneNumberPipeExampleComponent',
      selector: 'bb-phone-number-pipe-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-phone-number-pipe-example-ui',\n  templateUrl: './phone-number-pipe.example.component.html',\n  standalone: false,\n})\nexport class PhoneNumberPipeExampleComponent {\n  workPhone = '4151234567';\n}\n",
      template: "<p>{{ workPhone | phoneNumber : 'US' }}</p>\n",
    },
    {
      name: 'ProductItemBasicAccountComponent',
      selector: 'bb-product-item-basic-account-ui',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card amount value.\n',
          description: '<p>The card amount value.</p>\n',
          line: 62,
          type: 'number',
          decorators: [],
        },
        {
          name: 'balanceLabel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe text to be placed above the amount.\n',
          description: '<p>The text to be placed above the amount.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
        },
        {
          name: 'balanceLabelForSecondaryAmount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe text to be placed above the amount.\n',
          description: '<p>The text to be placed above the amount.</p>\n',
          line: 88,
          type: 'string',
          decorators: [],
        },
        {
          name: 'bankBranchCode',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nBranch code of a bank.\n',
          description: '<p>Branch code of a bank.</p>\n',
          line: 92,
          type: 'string',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card currency.\n',
          description: '<p>The card currency.</p>\n',
          line: 54,
          type: 'string',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatus',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMoneyProtectionStatus can be Yes, No or NA\n',
          description: '<p>MoneyProtectionStatus can be Yes, No or NA</p>\n',
          line: 96,
          type: 'MoneyProtectionStatusEnum',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatusClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to status of money protection\n',
          description: '<p>Allows to add classes to status of money protection</p>\n',
          line: 100,
          type: 'string',
          decorators: [],
        },
        {
          name: 'secondaryAmount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe card secondary amount value.(e.g. Available amount is primary and booked balance is secondary).\n',
          description:
            '<p>The card secondary amount value.(e.g. Available amount is primary and booked balance is secondary).</p>\n',
          line: 66,
          type: 'number',
          decorators: [],
        },
        {
          name: 'selected',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether the card is selected.\nThis removes any check mark on the item when `active=true`.\nDefaults to false.\n',
          description:
            '<p>Whether the card is selected.\nThis removes any check mark on the item when <code>active=true</code>.\nDefaults to false.</p>\n',
          line: 72,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showCurrencySymbol',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the item should show the currency symbol. Defaults to true.\n',
          description: '<p>Whether the item should show the currency symbol. Defaults to true.</p>\n',
          line: 58,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'status',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe current account status. Accepts `closed`, `inactive` or `active`.\n',
          description:
            '<p>The current account status. Accepts <code>closed</code>, <code>inactive</code> or <code>active</code>.</p>\n',
          line: 80,
          type: 'AccountStatus',
          decorators: [],
        },
        {
          name: 'type',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe type of icon to be displayed when `selected=true`.\n',
          description: '<p>The type of icon to be displayed when <code>selected=true</code>.</p>\n',
          line: 76,
          type: 'string',
          decorators: [],
        },
        {
          name: 'active',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should have a check icon. Defaults to true.\n',
          description: '<p>Whether the card should have a check icon. Defaults to true.</p>\n',
          line: 42,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favorite',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should be marked as favourite. Defaults to false.\n',
          description: '<p>Whether the card should be marked as favourite. Defaults to false.</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favoriteIconColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the favourite icon when `favorite=true`. Defaults to primary.\n',
          description: '<p>The color of the favourite icon when <code>favorite=true</code>. Defaults to primary.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'highlight',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the amount and currency value should be highlighted.\n',
          description: '<p>Whether the amount and currency value should be highlighted.</p>\n',
          line: 34,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productDetailsInfo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product details information.\n',
          description: '<p>The product details information.</p>\n',
          line: 38,
          type: 'Record<string | any>',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product number.\n',
          description: '<p>The product number.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted.\nDefaults to the following format:\n`{ length: 16, maskRange: [0, 12], segments: 4 }`\n',
          description:
            '<p>Configuration of how the product number should be formatted.\nDefaults to the following format:\n<code>{ length: 16, maskRange: [0, 12], segments: 4 }</code></p>\n',
          line: 30,
          type: 'PaymentCardNumberFormat',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card title.\n',
          description: '<p>The card title.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that renders a styled-container or card for basic account.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductItemBasicAccountExampleComponent',
      selector: 'bb-product-item-basic-account-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\n\n@Component({\n  selector: 'bb-product-item-basic-account-example-ui',\n  templateUrl: './product-item-basic-account.example.component.html',\n  standalone: false,\n})\nexport class ProductItemBasicAccountExampleComponent {\n  product: ProductItem = {\n    id: 'b387bfa5-75fd-410e-bb86-7f764f8ef69c',\n    name: 'Ricardo Norton’s Savings Account',\n    currency: 'EUR',\n    amount: '83652.32',\n    productNumber: 'NL75INGB3400120056',\n  };\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 0],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-product-item-basic-account-ui\n  [title]="product.name"\n  [amount]="product.amount"\n  [productNumber]="product.productNumber"\n  [currency]="product.currency"\n  [productNumberFormat]="productNumberFormat"\n  [highlight]="false"\n  [favorite]="false"\n  [active]="false"\n  balanceLabel="Available balance"\n></bb-product-item-basic-account-ui>\n',
    },
    {
      name: 'ProductItemCreditCardComponent',
      selector: 'bb-product-item-credit-card-ui',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card amount value.\n',
          description: '<p>The card amount value.</p>\n',
          line: 69,
          type: 'number',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card currency.\n',
          description: '<p>The card currency.</p>\n',
          line: 65,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mainSectionAmount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section amount value.\n',
          description: '<p>The card additional main section amount value.</p>\n',
          line: 77,
          type: 'number',
          decorators: [],
        },
        {
          name: 'mainSectionCurrency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section currency.\n',
          description: '<p>The card additional main section currency.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mainSectionTitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section amount value.\n',
          description: '<p>The card additional main section amount value.</p>\n',
          line: 81,
          type: 'string',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatus',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMoneyProtectionStatus can be Yes, No or NA\n',
          description: '<p>MoneyProtectionStatus can be Yes, No or NA</p>\n',
          line: 97,
          type: 'MoneyProtectionStatusEnum',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatusClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to status of money protection\n',
          description: '<p>Allows to add classes to status of money protection</p>\n',
          line: 101,
          type: 'string',
          decorators: [],
        },
        {
          name: 'secondarySectionAmount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional secondary section amount value.\n',
          description: '<p>The card additional secondary section amount value.</p>\n',
          line: 89,
          type: 'number',
          decorators: [],
        },
        {
          name: 'secondarySectionCurrency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional secondary section currency.\n',
          description: '<p>The card additional secondary section currency.</p>\n',
          line: 85,
          type: 'string',
          decorators: [],
        },
        {
          name: 'secondarySectionTitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional secondary section amount value.\n',
          description: '<p>The card additional secondary section amount value.</p>\n',
          line: 93,
          type: 'string',
          decorators: [],
        },
        {
          name: 'active',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should have a check icon. Defaults to true.\n',
          description: '<p>Whether the card should have a check icon. Defaults to true.</p>\n',
          line: 42,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favorite',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should be marked as favourite. Defaults to false.\n',
          description: '<p>Whether the card should be marked as favourite. Defaults to false.</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favoriteIconColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the favourite icon when `favorite=true`. Defaults to primary.\n',
          description: '<p>The color of the favourite icon when <code>favorite=true</code>. Defaults to primary.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'highlight',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the amount and currency value should be highlighted.\n',
          description: '<p>Whether the amount and currency value should be highlighted.</p>\n',
          line: 34,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productDetailsInfo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product details information.\n',
          description: '<p>The product details information.</p>\n',
          line: 38,
          type: 'Record<string | any>',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product number.\n',
          description: '<p>The product number.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted.\nDefaults to the following format:\n`{ length: 16, maskRange: [0, 12], segments: 4 }`\n',
          description:
            '<p>Configuration of how the product number should be formatted.\nDefaults to the following format:\n<code>{ length: 16, maskRange: [0, 12], segments: 4 }</code></p>\n',
          line: 30,
          type: 'PaymentCardNumberFormat',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card title.\n',
          description: '<p>The card title.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that renders a styled-container or card for credit card.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductItemCreditCardExampleComponent',
      selector: 'bb-product-item-credit-card-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\n\n@Component({\n  selector: 'bb-product-item-credit-card-example-ui',\n  templateUrl: './product-item-credit-card.example.component.html',\n  standalone: false,\n})\nexport class ProductItemCreditCardExampleComponent {\n  product: ProductItem = {\n    id: 'b387bfa5-75fd-410e-bb86-7f764f8ef69c',\n    name: 'Ricardo Norton’s Credit Card',\n    currency: 'USD',\n    amount: '1425.99',\n    productNumber: 'CH6629039MLXHC9VOO7M9',\n  };\n\n  interest: ProductItem = {\n    id: 'd2d85314-e60c-44af-ba98-8f704dad5970',\n    name: 'Available Balance',\n    currency: 'USD',\n    amount: '880.54',\n    productNumber: 'CH6629039MLXHC9VOO7M9',\n  };\n\n  credit: ProductItem = {\n    id: 'e9af649e-e338-4b3e-808b-62e9feae0865',\n    name: 'Credit Limit',\n    currency: 'USD',\n    amount: '7280.86',\n  };\n\n  productDetails: { [key: string]: string } = {\n    owner: 'Richard Norton',\n  };\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 0],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-product-item-credit-card-ui\n  [title]="product.name"\n  [amount]="product.amount"\n  [productNumber]="product.productNumber"\n  [currency]="product.currency"\n  [productNumberFormat]="productNumberFormat"\n  [mainSectionCurrency]="interest.currency"\n  [mainSectionAmount]="interest.amount"\n  [mainSectionTitle]="interest.name"\n  [secondarySectionCurrency]="credit.currency"\n  [secondarySectionAmount]="credit.amount"\n  [secondarySectionTitle]="credit.name"\n  [productDetailsInfo]="productDetails"\n  [highlight]="false"\n  [favorite]="false"\n></bb-product-item-credit-card-ui>\n',
    },
    {
      name: 'ProductItemCurrentAccountComponent',
      selector: 'bb-product-item-current-account-ui',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card amount value.\n',
          description: '<p>The card amount value.</p>\n',
          line: 69,
          type: 'number',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card currency.\n',
          description: '<p>The card currency.</p>\n',
          line: 65,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mainSectionAmount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section amount value.\n',
          description: '<p>The card additional main section amount value.</p>\n',
          line: 77,
          type: 'number',
          decorators: [],
        },
        {
          name: 'mainSectionCurrency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section currency.\n',
          description: '<p>The card additional main section currency.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mainSectionTitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section amount value.\n',
          description: '<p>The card additional main section amount value.</p>\n',
          line: 81,
          type: 'string',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatus',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nmoneyProtectionStatus can be Yes, No or NA\n',
          description: '<p>moneyProtectionStatus can be Yes, No or NA</p>\n',
          line: 97,
          type: 'MoneyProtectionStatusEnum',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatusClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to status of money protection\n',
          description: '<p>Allows to add classes to status of money protection</p>\n',
          line: 101,
          type: 'string',
          decorators: [],
        },
        {
          name: 'secondarySectionAmount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional secondary section amount value.\n',
          description: '<p>The card additional secondary section amount value.</p>\n',
          line: 89,
          type: 'number',
          decorators: [],
        },
        {
          name: 'secondarySectionCurrency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional secondary section currency.\n',
          description: '<p>The card additional secondary section currency.</p>\n',
          line: 85,
          type: 'string',
          decorators: [],
        },
        {
          name: 'secondarySectionTitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional secondary section amount value.\n',
          description: '<p>The card additional secondary section amount value.</p>\n',
          line: 93,
          type: 'string',
          decorators: [],
        },
        {
          name: 'active',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should have a check icon. Defaults to true.\n',
          description: '<p>Whether the card should have a check icon. Defaults to true.</p>\n',
          line: 42,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favorite',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should be marked as favourite. Defaults to false.\n',
          description: '<p>Whether the card should be marked as favourite. Defaults to false.</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favoriteIconColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the favourite icon when `favorite=true`. Defaults to primary.\n',
          description: '<p>The color of the favourite icon when <code>favorite=true</code>. Defaults to primary.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'highlight',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the amount and currency value should be highlighted.\n',
          description: '<p>Whether the amount and currency value should be highlighted.</p>\n',
          line: 34,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productDetailsInfo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product details information.\n',
          description: '<p>The product details information.</p>\n',
          line: 38,
          type: 'Record<string | any>',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product number.\n',
          description: '<p>The product number.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted.\nDefaults to the following format:\n`{ length: 16, maskRange: [0, 12], segments: 4 }`\n',
          description:
            '<p>Configuration of how the product number should be formatted.\nDefaults to the following format:\n<code>{ length: 16, maskRange: [0, 12], segments: 4 }</code></p>\n',
          line: 30,
          type: 'PaymentCardNumberFormat',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card title.\n',
          description: '<p>The card title.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that renders a styled-container or card for current account.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductItemCurrentAccountExampleComponent',
      selector: 'bb-product-item-current-account-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\n\n@Component({\n  selector: 'bb-product-item-current-account-example-ui',\n  templateUrl: './product-item-current-account.example.component.html',\n  standalone: false,\n})\nexport class ProductItemCurrentAccountExampleComponent {\n  product: ProductItem = {\n    id: 'b387bfa5-75fd-410e-bb86-7f764f8ef69c',\n    name: 'Ricardo Norton’s Account',\n    currency: 'EUR',\n    amount: '83652.32',\n    productNumber: 'NL75INGB3400120056',\n  };\n\n  interest: ProductItem = {\n    id: 'd2d85314-e60c-44af-ba98-8f704dad5970',\n    name: 'Accrued Interest',\n    currency: 'EUR',\n    amount: '880.54',\n    productNumber: 'NL75INGB3400120056',\n  };\n\n  credit: ProductItem = {\n    id: 'e9af649e-e338-4b3e-808b-62e9feae0865',\n    name: 'Credit Limit',\n    currency: 'EUR',\n    amount: '7500',\n  };\n\n  productDetails: { [key: string]: string } = {\n    owner: 'Richard Norton',\n  };\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 12],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-product-item-current-account-ui\n  [title]="product.name"\n  [amount]="product.amount"\n  [productNumber]="product.productNumber"\n  [currency]="product.currency"\n  [productNumberFormat]="productNumberFormat"\n  [mainSectionCurrency]="interest.currency"\n  [mainSectionAmount]="interest.amount"\n  [mainSectionTitle]="interest.name"\n  [secondarySectionCurrency]="credit.currency"\n  [secondarySectionAmount]="credit.amount"\n  [secondarySectionTitle]="credit.name"\n  [productDetailsInfo]="productDetails"\n  [highlight]="false"\n  [favorite]="true"\n>\n</bb-product-item-current-account-ui>\n',
    },
    {
      name: 'ProductItemDebitCardComponent',
      selector: 'bb-product-item-debit-card-ui',
      inputsClass: [
        {
          name: 'moneyProtectionStatus',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nmoneyProtectionStatus can be Yes, No or NA\n',
          description: '<p>moneyProtectionStatus can be Yes, No or NA</p>\n',
          line: 33,
          type: 'MoneyProtectionStatusEnum',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatusClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to status of money protection\n',
          description: '<p>Allows to add classes to status of money protection</p>\n',
          line: 37,
          type: 'string',
          decorators: [],
        },
        {
          name: 'active',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should have a check icon. Defaults to true.\n',
          description: '<p>Whether the card should have a check icon. Defaults to true.</p>\n',
          line: 42,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favorite',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should be marked as favourite. Defaults to false.\n',
          description: '<p>Whether the card should be marked as favourite. Defaults to false.</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favoriteIconColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the favourite icon when `favorite=true`. Defaults to primary.\n',
          description: '<p>The color of the favourite icon when <code>favorite=true</code>. Defaults to primary.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'highlight',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the amount and currency value should be highlighted.\n',
          description: '<p>Whether the amount and currency value should be highlighted.</p>\n',
          line: 34,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productDetailsInfo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product details information.\n',
          description: '<p>The product details information.</p>\n',
          line: 38,
          type: 'Record<string | any>',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product number.\n',
          description: '<p>The product number.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted.\nDefaults to the following format:\n`{ length: 16, maskRange: [0, 12], segments: 4 }`\n',
          description:
            '<p>Configuration of how the product number should be formatted.\nDefaults to the following format:\n<code>{ length: 16, maskRange: [0, 12], segments: 4 }</code></p>\n',
          line: 30,
          type: 'PaymentCardNumberFormat',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card title.\n',
          description: '<p>The card title.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that renders a styled-container or card for debit card.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductItemDebitCardExampleComponent',
      selector: 'bb-product-item-debit-card-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\n\n@Component({\n  selector: 'bb-product-item-debit-card-example-ui',\n  templateUrl: './product-item-debit-card.example.component.html',\n  standalone: false,\n})\nexport class ProductItemDebitCardExampleComponent {\n  product: ProductItem = {\n    id: 'b387bfa5-75fd-410e-bb86-7f764f8ef69c',\n    name: 'Ricardo Norton’s Savings Account',\n    currency: 'EUR',\n    amount: '83652.32',\n    productNumber: 'NL75INGB3400120056',\n  };\n\n  productDetails: { [key: string]: string } = {\n    owner: 'Richard Norton',\n  };\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 0],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-product-item-debit-card-ui\n  [title]="product.name"\n  [productNumber]="product.productNumber"\n  [productNumberFormat]="productNumberFormat"\n  [highlight]="false"\n  [favorite]="false"\n  [active]="false"\n  [productDetailsInfo]="productDetails"\n></bb-product-item-debit-card-ui>\n',
    },
    {
      name: 'ProductItemInvestmentAccountComponent',
      selector: 'bb-product-item-investment-account-ui',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card amount value.\n',
          description: '<p>The card amount value.</p>\n',
          line: 48,
          type: 'number',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card currency.\n',
          description: '<p>The card currency.</p>\n',
          line: 44,
          type: 'string',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatus',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nmoneyProtectionStatus can be Yes, No or NA\n',
          description: '<p>moneyProtectionStatus can be Yes, No or NA</p>\n',
          line: 52,
          type: 'MoneyProtectionStatusEnum',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatusClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to status of money protection\n',
          description: '<p>Allows to add classes to status of money protection</p>\n',
          line: 56,
          type: 'string',
          decorators: [],
        },
        {
          name: 'active',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should have a check icon. Defaults to true.\n',
          description: '<p>Whether the card should have a check icon. Defaults to true.</p>\n',
          line: 42,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favorite',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should be marked as favourite. Defaults to false.\n',
          description: '<p>Whether the card should be marked as favourite. Defaults to false.</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favoriteIconColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the favourite icon when `favorite=true`. Defaults to primary.\n',
          description: '<p>The color of the favourite icon when <code>favorite=true</code>. Defaults to primary.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'highlight',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the amount and currency value should be highlighted.\n',
          description: '<p>Whether the amount and currency value should be highlighted.</p>\n',
          line: 34,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productDetailsInfo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product details information.\n',
          description: '<p>The product details information.</p>\n',
          line: 38,
          type: 'Record<string | any>',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product number.\n',
          description: '<p>The product number.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted.\nDefaults to the following format:\n`{ length: 16, maskRange: [0, 12], segments: 4 }`\n',
          description:
            '<p>Configuration of how the product number should be formatted.\nDefaults to the following format:\n<code>{ length: 16, maskRange: [0, 12], segments: 4 }</code></p>\n',
          line: 30,
          type: 'PaymentCardNumberFormat',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card title.\n',
          description: '<p>The card title.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that renders a styled-container or card for investment account.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductItemInvestmentAccountExampleComponent',
      selector: 'bb-product-item-investment-account-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\n\n@Component({\n  selector: 'bb-product-item-investment-account-example-ui',\n  templateUrl:\n    './product-item-investment-account.example.component.html',\n  standalone: false,\n})\nexport class ProductItemInvestmentAccountExampleComponent {\n  product: ProductItem = {\n    id: 'b387bfa5-75fd-410e-bb86-7f764f8ef69c',\n    name: 'Ricardo Norton’s Savings Account',\n    currency: 'EUR',\n    amount: '83652.32',\n    productNumber: 'NL75INGB3400120056',\n  };\n\n  productDetails: { [key: string]: string } = {\n    owner: 'Richard Norton',\n  };\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 0],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-product-item-investment-account-ui\n  [title]="product.name"\n  [amount]="product.amount"\n  [productNumber]="product.productNumber"\n  [currency]="product.currency"\n  [productNumberFormat]="productNumberFormat"\n  [productDetailsInfo]="productDetails"\n  [highlight]="false"\n  [favorite]="false"\n  [active]="false"\n></bb-product-item-investment-account-ui>\n',
    },
    {
      name: 'ProductItemLoanComponent',
      selector: 'bb-product-item-loan-ui',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card amount value.\n',
          description: '<p>The card amount value.</p>\n',
          line: 47,
          type: 'number',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card currency.\n',
          description: '<p>The card currency.</p>\n',
          line: 43,
          type: 'string',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatus',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nmoneyProtectionStatus can be Yes, No or NA\n',
          description: '<p>moneyProtectionStatus can be Yes, No or NA</p>\n',
          line: 51,
          type: 'MoneyProtectionStatusEnum',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatusClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to status of money protection\n',
          description: '<p>Allows to add classes to status of money protection</p>\n',
          line: 55,
          type: 'string',
          decorators: [],
        },
        {
          name: 'active',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should have a check icon. Defaults to true.\n',
          description: '<p>Whether the card should have a check icon. Defaults to true.</p>\n',
          line: 42,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favorite',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should be marked as favourite. Defaults to false.\n',
          description: '<p>Whether the card should be marked as favourite. Defaults to false.</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favoriteIconColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the favourite icon when `favorite=true`. Defaults to primary.\n',
          description: '<p>The color of the favourite icon when <code>favorite=true</code>. Defaults to primary.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'highlight',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the amount and currency value should be highlighted.\n',
          description: '<p>Whether the amount and currency value should be highlighted.</p>\n',
          line: 34,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productDetailsInfo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product details information.\n',
          description: '<p>The product details information.</p>\n',
          line: 38,
          type: 'Record<string | any>',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product number.\n',
          description: '<p>The product number.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted.\nDefaults to the following format:\n`{ length: 16, maskRange: [0, 12], segments: 4 }`\n',
          description:
            '<p>Configuration of how the product number should be formatted.\nDefaults to the following format:\n<code>{ length: 16, maskRange: [0, 12], segments: 4 }</code></p>\n',
          line: 30,
          type: 'PaymentCardNumberFormat',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card title.\n',
          description: '<p>The card title.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that renders a styled-container or card for loan.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductItemLoanExampleComponent',
      selector: 'bb-product-item-loan-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\n\n@Component({\n  selector: 'bb-product-item-loan-example-ui',\n  templateUrl: './product-item-loan.example.component.html',\n  standalone: false,\n})\nexport class ProductItemLoanExampleComponent {\n  product: ProductItem = {\n    id: 'b387bfa5-75fd-410e-bb86-7f764f8ef69c',\n    name: 'Ricardo Norton`s Savings Account',\n    currency: 'EUR',\n    amount: '83652.32',\n    productNumber: 'NL75INGB3400120056',\n  };\n\n  productDetails: { [key: string]: string } = {\n    owner: 'Richard Norton',\n  };\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 0],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-product-item-loan-ui\n  [title]="product.name"\n  [amount]="product.amount"\n  [productNumber]="product.productNumber"\n  [currency]="product.currency"\n  [productNumberFormat]="productNumberFormat"\n  [productDetailsInfo]="productDetails"\n  [highlight]="false"\n  [favorite]="false"\n  [active]="false"\n></bb-product-item-loan-ui>\n',
    },
    {
      name: 'ProductItemSavingsAccountComponent',
      selector: 'bb-product-item-savings-account-ui',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card amount value.\n',
          description: '<p>The card amount value.</p>\n',
          line: 58,
          type: 'number',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card currency.\n',
          description: '<p>The card currency.</p>\n',
          line: 54,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mainSectionAmount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section amount value.\n',
          description: '<p>The card additional main section amount value.</p>\n',
          line: 66,
          type: 'number',
          decorators: [],
        },
        {
          name: 'mainSectionCurrency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section currency.\n',
          description: '<p>The card additional main section currency.</p>\n',
          line: 62,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mainSectionTitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section amount value.\n',
          description: '<p>The card additional main section amount value.</p>\n',
          line: 70,
          type: 'string',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatus',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMoneyProtectionStatus can be Yes, No or NA\n',
          description: '<p>MoneyProtectionStatus can be Yes, No or NA</p>\n',
          line: 74,
          type: 'MoneyProtectionStatusEnum',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatusClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to status of money protection\n',
          description: '<p>Allows to add classes to status of money protection</p>\n',
          line: 78,
          type: 'string',
          decorators: [],
        },
        {
          name: 'active',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should have a check icon. Defaults to true.\n',
          description: '<p>Whether the card should have a check icon. Defaults to true.</p>\n',
          line: 42,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favorite',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should be marked as favourite. Defaults to false.\n',
          description: '<p>Whether the card should be marked as favourite. Defaults to false.</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favoriteIconColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the favourite icon when `favorite=true`. Defaults to primary.\n',
          description: '<p>The color of the favourite icon when <code>favorite=true</code>. Defaults to primary.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'highlight',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the amount and currency value should be highlighted.\n',
          description: '<p>Whether the amount and currency value should be highlighted.</p>\n',
          line: 34,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productDetailsInfo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product details information.\n',
          description: '<p>The product details information.</p>\n',
          line: 38,
          type: 'Record<string | any>',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product number.\n',
          description: '<p>The product number.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted.\nDefaults to the following format:\n`{ length: 16, maskRange: [0, 12], segments: 4 }`\n',
          description:
            '<p>Configuration of how the product number should be formatted.\nDefaults to the following format:\n<code>{ length: 16, maskRange: [0, 12], segments: 4 }</code></p>\n',
          line: 30,
          type: 'PaymentCardNumberFormat',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card title.\n',
          description: '<p>The card title.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that renders a styled-container or card for savings account.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductItemSavingsAccountExampleComponent',
      selector: 'bb-product-item-savings-account-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\n\n@Component({\n  selector: 'bb-product-item-savings-account-example-ui',\n  templateUrl: './product-item-savings-account.example.component.html',\n  standalone: false,\n})\nexport class ProductItemSavingsAccountExampleComponent {\n  product: ProductItem = {\n    id: 'b387bfa5-75fd-410e-bb86-7f764f8ef69c',\n    name: 'Ricardo Norton’s Savings Account',\n    currency: 'EUR',\n    amount: '6610.75',\n    productNumber: 'NL75INGB34008927',\n  };\n\n  interest: ProductItem = {\n    id: 'd2d85314-e60c-44af-ba98-8f704dad5970',\n    name: 'Accrued Interest',\n    currency: 'EUR',\n    amount: '880.54',\n    productNumber: 'NL75INGB34008927',\n  };\n\n  productDetails: { [key: string]: string } = {\n    owner: 'Richard Norton',\n  };\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 12],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-product-item-savings-account-ui\n  [title]="product.name"\n  [amount]="product.amount"\n  [productNumber]="product.productNumber"\n  [currency]="product.currency"\n  [productNumberFormat]="productNumberFormat"\n  [mainSectionCurrency]="interest.currency"\n  [mainSectionAmount]="interest.amount"\n  [mainSectionTitle]="interest.name"\n  [productDetailsInfo]="productDetails"\n  [highlight]="false"\n  [favorite]="true"\n></bb-product-item-savings-account-ui>\n',
    },
    {
      name: 'ProductItemTermDepositComponent',
      selector: 'bb-product-item-term-deposit-ui',
      inputsClass: [
        {
          name: 'amount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card amount value.\n',
          description: '<p>The card amount value.</p>\n',
          line: 58,
          type: 'number',
          decorators: [],
        },
        {
          name: 'currency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card currency.\n',
          description: '<p>The card currency.</p>\n',
          line: 54,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mainSectionAmount',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section amount value.\n',
          description: '<p>The card additional main section amount value.</p>\n',
          line: 66,
          type: 'number',
          decorators: [],
        },
        {
          name: 'mainSectionCurrency',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section currency.\n',
          description: '<p>The card additional main section currency.</p>\n',
          line: 62,
          type: 'string',
          decorators: [],
        },
        {
          name: 'mainSectionTitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card additional main section amount value.\n',
          description: '<p>The card additional main section amount value.</p>\n',
          line: 70,
          type: 'string',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatus',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMoneyProtectionStatus can be Yes, No or NA\n',
          description: '<p>MoneyProtectionStatus can be Yes, No or NA</p>\n',
          line: 74,
          type: 'MoneyProtectionStatusEnum',
          decorators: [],
        },
        {
          name: 'moneyProtectionStatusClasses',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAllows to add classes to status of money protection\n',
          description: '<p>Allows to add classes to status of money protection</p>\n',
          line: 78,
          type: 'string',
          decorators: [],
        },
        {
          name: 'active',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should have a check icon. Defaults to true.\n',
          description: '<p>Whether the card should have a check icon. Defaults to true.</p>\n',
          line: 42,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favorite',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the card should be marked as favourite. Defaults to false.\n',
          description: '<p>Whether the card should be marked as favourite. Defaults to false.</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'favoriteIconColor',
          defaultValue: "'primary'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe color of the favourite icon when `favorite=true`. Defaults to primary.\n',
          description: '<p>The color of the favourite icon when <code>favorite=true</code>. Defaults to primary.</p>\n',
          line: 50,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'highlight',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the amount and currency value should be highlighted.\n',
          description: '<p>Whether the amount and currency value should be highlighted.</p>\n',
          line: 34,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productDetailsInfo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product details information.\n',
          description: '<p>The product details information.</p>\n',
          line: 38,
          type: 'Record<string | any>',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumber',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe product number.\n',
          description: '<p>The product number.</p>\n',
          line: 24,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'productNumberFormat',
          defaultValue: 'DefaultPaymentCardNumberFormat',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfiguration of how the product number should be formatted.\nDefaults to the following format:\n`{ length: 16, maskRange: [0, 12], segments: 4 }`\n',
          description:
            '<p>Configuration of how the product number should be formatted.\nDefaults to the following format:\n<code>{ length: 16, maskRange: [0, 12], segments: 4 }</code></p>\n',
          line: 30,
          type: 'PaymentCardNumberFormat',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe card title.\n',
          description: '<p>The card title.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'ProductItemBaseComponent',
          },
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>A component that renders a styled-container or card for term deposit.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductItemTermDepositExampleComponent',
      selector: 'bb-product-item-term-deposit-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\n\n@Component({\n  selector: 'bb-product-item-term-deposit-example-ui',\n  templateUrl: './product-item-term-deposit.example.component.html',\n  standalone: false,\n})\nexport class ProductItemTermDepositExampleComponent {\n  product: ProductItem = {\n    id: 'b387bfa5-75fd-410e-bb86-7f764f8ef69c',\n    name: 'Ricardo Norton`s Account',\n    currency: 'EUR',\n    amount: '83652.32',\n    productNumber: 'NL75INGB3400120056',\n  };\n\n  interest: ProductItem = {\n    id: 'd2d85314-e60c-44af-ba98-8f704dad5970',\n    name: 'Accrued Interest',\n    currency: 'EUR',\n    amount: '880.54',\n    productNumber: 'NL75INGB3400120056',\n  };\n\n  productDetails: { [key: string]: string } = {\n    owner: 'Richard Norton',\n  };\n\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 12],\n    segments: 4,\n  };\n}\n",
      template:
        '<bb-product-item-term-deposit-ui\n  [title]="product.name"\n  [amount]="product.amount"\n  [productNumber]="product.productNumber"\n  [currency]="product.currency"\n  [productNumberFormat]="productNumberFormat"\n  [mainSectionCurrency]="interest.currency"\n  [mainSectionAmount]="interest.amount"\n  [mainSectionTitle]="interest.name"\n  [productDetailsInfo]="productDetails"\n  [highlight]="false"\n  [favorite]="true"\n></bb-product-item-term-deposit-ui>\n',
    },
    {
      name: 'ProductSelectorComponent',
      selector: 'bb-product-selector-ui',
      inputsClass: [
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIt identifies the currently active element in the selector.\n',
          description: '<p>It identifies the currently active element in the selector.</p>\n',
          line: 109,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet `aria-describedby` with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set <code>aria-describedby</code> with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 116,
          type: 'string',
          decorators: [],
        },
        {
          name: 'ariaLabelForDropdown',
          defaultValue: "'A dropdown component with a product list'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSet `ariaLabelForDropdown` with a text that explains what dropdown component is about\n',
          description:
            '<p>Set <code>ariaLabelForDropdown</code> with a text that explains what dropdown component is about</p>\n',
          line: 121,
          type: 'string',
          decorators: [],
        },
        {
          name: 'ariaLabelForToggleButton',
          defaultValue: "'A toggle button for a product list'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet `ariaLabelForToggleButton` with a text that explains what a toggle button is about\n',
          description:
            '<p>Set <code>ariaLabelForToggleButton</code> with a text that explains what a toggle button is about</p>\n',
          line: 126,
          type: 'string',
          decorators: [],
        },
        {
          name: 'autoClose',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhether the dropdown should be closed when clicking one of dropdown items or pressing ESC.\nDefaults to true.\n',
          description:
            '<p>Whether the dropdown should be closed when clicking one of dropdown items or pressing ESC.\nDefaults to true.</p>\n',
          line: 88,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'container',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSpecifies which element the dropdown should be appended to.\n',
          description: '<p>Specifies which element the dropdown should be appended to.</p>\n',
          line: 131,
          type: 'string | "body"',
          decorators: [],
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nA unique identifier for the product-selector toggle element.\n',
          description: '<p>A unique identifier for the product-selector toggle element.</p>\n',
          line: 98,
          type: 'string',
          decorators: [],
        },
        {
          name: 'isOpen',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nOpen/close state of dropDown menu\n',
          description: '<p>Open/close state of dropDown menu</p>\n',
          line: 75,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'position',
          defaultValue: "['bottom-end', 'bottom-start', 'top-end', 'top-start']",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe position of the dropdown, position will be picked in order of feasibility.\n',
          description: '<p>The position of the dropdown, position will be picked in order of feasibility.</p>\n',
          line: 103,
          type: 'Placement | PlacementArray',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'close',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 162,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'focusItem',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 181,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onBlur',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 211,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for blur dropdown menu\n',
          description: '<p>Event handler for blur dropdown menu</p>\n',
        },
        {
          name: 'onClose',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 174,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onKeyEvent',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 139,
          deprecated: false,
          deprecationMessage: '',
          decorators: [
            {
              name: 'HostListener',
              stringifiedArguments: "'window:keydown', ['$event']",
            },
          ],
          modifierKind: [170],
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onOpenChange',
          args: [
            {
              name: '$event',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 201,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEvent handler for change open/close state in dropdown menu\n',
          description: '<p>Event handler for change open/close state in dropdown menu</p>\n',
          jsdoctags: [
            {
              name: '$event',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'open',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 168,
          deprecated: false,
          deprecationMessage: '',
        },
      ],
      description:
        '<p>A dropdown component that displays items in a pre-defined format.</p>\n<p>Every item from the list in the custom templates need to match the following requirements:</p>\n<ul>\n<li>It should have a <code>role=&quot;option&quot;</code> attribute for detection by Screen Reader like option.</li>\n<li>It should have a <code>#listItem</code> hash tag for keyBoard accessibility (navigate with keyUp/keyDown)</li>\n<li>It should use a <code>div</code> HTML element instead of a button for its host HTML element</li>\n<li>It should have a <code>tabindex=&quot;0&quot;</code></li>\n</ul>\n<p>Here is a example of custom tempates for the list items:</p>\n<b>Example :</b><div><pre class="line-numbers"><code class="language-none">&lt;ng-container bbDropdownMenu&gt;\n  &lt;div\n    *ngFor=&quot;let item of productsInterfaced; let i = index&quot;\n    (click)=&quot;productSelected = productsInterfaced[i]&quot;\n    \\#listItem\n    role=&quot;option&quot;\n    tabindex=&quot;0&quot;\n    class=&quot;bb-product-selector__dropdown-item&quot;\n    [ngClass]=&quot;{ selected: item.id === productSelected?.id }&quot;\n  &gt;\n    &lt;bb-product-item-basic-account-ui\n      [title]=&quot;item.name&quot;\n      [amount]=&quot;item.amount&quot;\n      [productNumber]=&quot;item.productNumber&quot;\n      [currency]=&quot;&#39;EUR&#39;&quot;\n      [highlight]=&quot;true&quot;\n      [productNumberFormat]=&quot;{ length: 18, maskRange: [0, 0], segments: 4 }&quot;\n      [active]=&quot;item.id === productSelected?.id&quot;\n    &gt;&lt;/bb-product-item-basic-account-ui&gt;\n  &lt;/div&gt;\n&lt;/ng-container&gt;</code></pre></div>',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ProductSelectorExampleComponent',
      selector: 'bb-product-selector-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'selectProduct',
          args: [
            {
              name: 'product',
              type: 'ProductItem',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 21,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'product',
              type: 'ProductItem',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { PaymentCardNumberFormat } from '@backbase/ui-ang/payment-card-number-pipe';\nimport { ProductItem } from '@backbase/ui-ang/product-selector';\nimport products from './products';\n\n@Component({\n  selector: 'bb-product-selector-example-ui',\n  templateUrl: './product-selector.example.component.html',\n  standalone: false,\n})\nexport class ProductSelectorExampleComponent {\n  products: ProductItem[] = products;\n  selected: ProductItem | undefined;\n  productNumberFormat: PaymentCardNumberFormat = {\n    length: 18,\n    maskRange: [0, 12],\n    segments: 4,\n  };\n\n  selectProduct(product: ProductItem) {\n    this.selected = product;\n  }\n}\n",
      template:
        '<bb-product-selector-ui [autoClose]="false">\n  <ng-container bbDropdownToggle>\n    @if (selected) {\n      <bb-product-item-basic-account-ui\n        class="text-start"\n        [title]="selected.name"\n        [amount]="selected.amount"\n        [productNumber]="selected.productNumber"\n        [currency]="selected.currency"\n        [productNumberFormat]="productNumberFormat"\n        [active]="true"\n      >\n      </bb-product-item-basic-account-ui>\n    }\n    @if (!selected) {\n      <div class="p-4 d-flex align-items-center">\n        <span class="align-items-left py-2"> Select a product </span>\n      </div>\n    }\n  </ng-container>\n  <ng-container bbDropdownMenu>\n    @for (product of products; track product.id) {\n      <button\n        (click)="selectProduct(product)"\n        type="button"\n        role="option"\n        class="flex-column align-items-stretch btn btn-block rounded-0 m-0 p-0 text-start bg-white"\n      >\n        <bb-product-item-basic-account-ui\n          [title]="product.name"\n          [amount]="product.amount"\n          [productNumber]="product.productNumber"\n          [currency]="product.currency"\n          [productNumberFormat]="productNumberFormat"\n          [active]="product.id === selected?.id"\n        ></bb-product-item-basic-account-ui>\n      </button>\n    }\n  </ng-container>\n</bb-product-selector-ui>\n',
    },
    {
      name: 'ProgessbarExampleComponent',
      selector: 'bb-progressbar-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-progressbar-example-ui',\n  templateUrl: './progressbar.example.component.html',\n  standalone: false,\n})\nexport class ProgessbarExampleComponent {\n  value = 0.42;\n}\n",
      template:
        '<bb-progressbar-ui\n  type="primary"\n  [striped]="true"\n  [animated]="true"\n  [showValue]="true"\n  [value]="value"\n  [max]="1"\n  ariaLabel="custom progress tracker"\n>\n</bb-progressbar-ui>\n',
    },
    {
      name: 'ProgressbarComponent',
      selector: 'bb-progressbar-ui',
      inputsClass: [
        {
          name: 'animated',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nA flag indicating if the stripes of the progress bar should be animated. Defaults to false.\n',
          description:
            '<p>A flag indicating if the stripes of the progress bar should be animated. Defaults to false.</p>\n',
          line: 40,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'ariaLabel',
          defaultValue: "'progress bar'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label for the progressbar.\n',
          description: '<p>Accessible label for the progressbar.</p>\n',
          line: 20,
          type: 'string',
          decorators: [],
        },
        {
          name: 'height',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nHeight of the progress bar. Can take values in `px`, `em`, `rem`.\n',
          description:
            '<p>Height of the progress bar. Can take values in <code>px</code>, <code>em</code>, <code>rem</code>.</p>\n',
          line: 24,
          type: 'string | undefined',
          decorators: [],
        },
        {
          name: 'max',
          defaultValue: '100',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMaximum value of the progressbar. Defaults to 100.\n',
          description: '<p>Maximum value of the progressbar. Defaults to 100.</p>\n',
          line: 28,
          type: 'number',
          decorators: [],
        },
        {
          name: 'showValue',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nA flag indicating if the current value should be displayed within the progressbar. Defaults to false.\n',
          description:
            '<p>A flag indicating if the current value should be displayed within the progressbar. Defaults to false.</p>\n',
          line: 32,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'striped',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nA flag indicating if the progress bar should be striped. Defaults to false.\n',
          description: '<p>A flag indicating if the progress bar should be striped. Defaults to false.</p>\n',
          line: 36,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'type',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nType of progress bar. Takes the values `primary`, `success`, `info`, `warning` & `danger`.\n',
          description:
            '<p>Type of progress bar. Takes the values <code>primary</code>, <code>success</code>, <code>info</code>, <code>warning</code> &amp; <code>danger</code>.</p>\n',
          line: 44,
          type: 'ProgressbarType | undefined',
          decorators: [],
        },
        {
          name: 'value',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCurrent value of the progressbar. Should always be less or equal to `max`. Defaults to 0.\n',
          description:
            '<p>Current value of the progressbar. Should always be less or equal to <code>max</code>. Defaults to 0.</p>\n',
          line: 48,
          type: 'number',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that represents the progress of a task.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'RichTextEditorComponent',
      selector: 'bb-rich-text-editor-ui',
      inputsClass: [
        {
          name: 'actions',
          defaultValue:
            '[\n    RichTextEditorActions.Bold,\n    RichTextEditorActions.Italic,\n    RichTextEditorActions.Underline,\n    RichTextEditorActions.Strike,\n    RichTextEditorActions.OrderedList,\n    RichTextEditorActions.UnorderedList,\n    RichTextEditorActions.Code,\n    RichTextEditorActions.Link,\n    RichTextEditorActions.Indent,\n  ]',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nActions of the editor toolbar.\n',
          description: '<p>Actions of the editor toolbar.</p>\n',
          line: 92,
          type: 'RichTextEditorActions[]',
          decorators: [],
        },
        {
          name: 'actionsTooltipPlacement',
          defaultValue: "'auto'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nPlacement of the action tooltip relative to the action button: auto | top | bottom | left | right. Defaults to 'auto'.\n",
          description:
            '<p>Placement of the action tooltip relative to the action button: auto | top | bottom | left | right. Defaults to &#39;auto&#39;.</p>\n',
          line: 87,
          type: 'string',
          decorators: [],
        },
        {
          name: 'counter',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nShow/hide message length. Defaults to true.\n',
          description: '<p>Show/hide message length. Defaults to true.</p>\n',
          line: 83,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'maxLength',
          defaultValue: 'Infinity',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maxLength for the rich-text-editor component.\n',
          description: '<p>The maxLength for the rich-text-editor component.</p>\n',
          line: 71,
          type: 'any',
          decorators: [],
        },
        {
          name: 'minLength',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe minLength for the rich-text-editor component.\n',
          description: '<p>The minLength for the rich-text-editor component.</p>\n',
          line: 75,
          type: 'number',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the rich-text-editor component. Defaults to an empty string.\n',
          description: '<p>The placeholder for the rich-text-editor component. Defaults to an empty string.</p>\n',
          line: 79,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'callOnBlur',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 208,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'callOnChange',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 194,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'callOnFocus',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 199,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'changedEditor',
          args: [
            {
              name: 'event',
              type: 'ContentChange',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 173,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'ContentChange',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'closeModal',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 256,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'configureToolbar',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 261,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getMessageText',
          args: [],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 234,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'labelClick',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 230,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onResult',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 251,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'openLinkModal',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 246,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'setActionTypes',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 169,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'setSelectionUrl',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 242,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'showCounter',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 238,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'updateQuillContent',
          args: [
            {
              name: 'inputValue',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: 'this.messageText',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 190,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: 'this.messageText',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'validate',
          args: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'ValidationErrors | null',
          typeParameters: [],
          line: 217,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'control',
              type: 'AbstractControl',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 181,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '<p>Component that provides you input text with editing.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'RichTextEditorExampleComponent',
      selector: 'bb-rich-text-editor-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';\n\n@Component({\n  selector: 'bb-rich-text-editor-example-ui',\n  templateUrl: './rich-text-editor.example.component.html',\n  standalone: false,\n})\nexport class RichTextEditorExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    remarks: '',\n  });\n\n  constructor(private readonly formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <bb-rich-text-editor-ui\n    label="Remarks"\n    formControlName="remarks"\n    placeholder="Please, enter your message"\n    [maxLength]="300"\n    [required]="true"\n  >\n  </bb-rich-text-editor-ui>\n</form>\n',
    },
    {
      name: 'SearchBoxComponent',
      selector: 'bb-search-box-ui',
      inputsClass: [
        {
          name: 'autocomplete',
          defaultValue: "'off'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe autocomplete attribute value. Defaults to off.\n',
          description: '<p>The autocomplete attribute value. Defaults to off.</p>\n',
          line: 106,
          type: 'string',
          decorators: [],
        },
        {
          name: 'clearLabel',
          defaultValue: "'Clear'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe aria label used when the clear button is in focus.\n',
          description: '<p>The aria label used when the clear button is in focus.</p>\n',
          line: 102,
          type: 'string',
          decorators: [],
        },
        {
          name: 'containerAriaLabel',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe label of the container for the search input. When there are multiple search inputs on a page, a label should be assigned. Defaults to ''.\n",
          description:
            '<p>The label of the container for the search input. When there are multiple search inputs on a page, a label should be assigned. Defaults to &#39;&#39;.</p>\n',
          line: 114,
          type: 'string',
          decorators: [],
        },
        {
          name: 'containerRole',
          defaultValue: "'search'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe role of the container for the search input. For non-landmarked search, please assign this a value. Defaults to 'search'.\n",
          description:
            '<p>The role of the container for the search input. For non-landmarked search, please assign this a value. Defaults to &#39;search&#39;.</p>\n',
          line: 110,
          type: 'string',
          decorators: [],
        },
        {
          name: 'maxLength',
          defaultValue: "'140'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maximum length of the search text. Defaults to 140.\n',
          description: '<p>The maximum length of the search text. Defaults to 140.</p>\n',
          line: 77,
          type: 'string',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder text to display in the input.\n',
          description: '<p>The placeholder text to display in the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
        },
        {
          name: 'searchLabel',
          defaultValue: "'Search'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe aria label used when the search button is in focus.\n',
          description: '<p>The aria label used when the search button is in focus.</p>\n',
          line: 98,
          type: 'string',
          decorators: [],
        },
        {
          name: 'showClear',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to show the clear button icon after the text. Defaults to false.\n',
          description: '<p>Whether to show the clear button icon after the text. Defaults to false.</p>\n',
          line: 94,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'showSearch',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether to show the search button icon before the text. Defaults to false.\n',
          description: '<p>Whether to show the search button icon before the text. Defaults to false.</p>\n',
          line: 90,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'squareBorder',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe square border for search box. Defaults to false.\n',
          description: '<p>The square border for search box. Defaults to false.</p>\n',
          line: 81,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'typeaheadOptions',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe list of options to use when typeahead is available.\nSee https://ng-bootstrap.github.io/#/components/typeahead/api#NgbTypeahead for the list of options.\n',
          description:
            '<p>The list of options to use when typeahead is available.\nSee <a href="https://ng-bootstrap.github.io/#/components/typeahead/api#NgbTypeahead">https://ng-bootstrap.github.io/#/components/typeahead/api#NgbTypeahead</a> for the list of options.</p>\n',
          line: 86,
          type: 'TypeaheadOptions<T> | undefined',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'clear',
          defaultValue: 'new EventEmitter<string>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits an event when the clear button is clicked.\n',
          description: '<p>Emits an event when the clear button is clicked.</p>\n',
          line: 124,
          type: 'EventEmitter<string>',
        },
        {
          name: 'submit',
          defaultValue: 'new EventEmitter<\n    string | boolean | Object | null\n  >()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits an event when a search is submitted.\n',
          description: '<p>Emits an event when a search is submitted.</p>\n',
          line: 118,
          type: 'EventEmitter<string | boolean | Object | null>',
        },
        {
          name: 'valueChange',
          defaultValue: 'this._valueChange',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmits an event when the value in the search box is changed.\n',
          description: '<p>Emits an event when the value in the search box is changed.</p>\n',
          line: 128,
          type: 'EventEmitter<any>',
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'focusEditableElement',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 211,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'focusOnInputField',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 185,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSets the focus on the input field.\nIf the input field reference is defined, it calls the `focus()` method on the native element.\n',
          description:
            '<p>Sets the focus on the input field.\nIf the input field reference is defined, it calls the <code>focus()</code> method on the native element.</p>\n',
        },
        {
          name: 'getKeywordBySize',
          args: [
            {
              name: 'size',
              type: 'number | string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 217,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'size',
              type: 'number | string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'keyword',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 225,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'keyword',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'isClearVisible',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 207,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onBlur',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 199,
          deprecated: false,
          deprecationMessage: '',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onClear',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 173,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onFocus',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 191,
          deprecated: false,
          deprecationMessage: '',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onSelect',
          args: [
            {
              name: 'event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 234,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onSubmit',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 148,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<p>Component that provides you a search input field.</p>\n<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>Set aria-describedby  with an element id that contains a detailed decription about the Search box.</li>\n<li>aria-label or  aria-labelledby can be used to display the label for search box.</li>\n</ul>\n<p>If  showSearch = true , searchLabel is discernible text for search button.\nIf  showClear = true , clearLabel is discernible text for clear button.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'SearchBoxExampleComponent',
      selector: 'bb-search-box-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'search',
          args: [
            {
              name: 'text',
              type: 'Observable<string>',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'Observable<Array<string>>',
          typeParameters: [],
          line: 25,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'text',
              type: 'Observable<string>',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'startSearching',
          args: [
            {
              name: 'value',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 21,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'value',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { Observable } from 'rxjs';\nimport { map } from 'rxjs/operators';\nimport { UntypedFormControl, UntypedFormGroup } from '@angular/forms';\n\nexport interface UserItem {\n  id: number;\n  name: string;\n}\n\n@Component({\n  selector: 'bb-search-box-example-ui',\n  templateUrl: './search-box.example.component.html',\n  standalone: false,\n})\nexport class SearchBoxExampleComponent {\n  form = new UntypedFormGroup({\n    query: new UntypedFormControl(''),\n  });\n\n  startSearching(value: string) {\n    alert(`You are searching for ${value}`);\n  }\n\n  search(text: Observable<string>): Observable<Array<string>> {\n    const searchItems = ['John', 'Jane', 'James', 'Joey'];\n\n    return text.pipe(\n      map((term) =>\n        searchItems.filter(\n          (item) =>\n            item.toLowerCase().indexOf(term.toLowerCase()) === 0,\n        ),\n      ),\n    );\n  }\n  readonly typeaheadOptions = {\n    ngbTypeahead: this.search,\n  };\n}\n",
      template:
        '<form [formGroup]="form">\n  <h4 id="ariaLabelledby">Example Search Box</h4>\n  <div class="bb-block bb-block--lg">\n    <h5 id="ariaDescribedby">\n      Search box with search and clear button.\n    </h5>\n    <bb-search-box-ui\n      formControlName="query"\n      [showClear]="true"\n      [showSearch]="true"\n      placeholder="Search box with autocomplete. Start typing with letter \'J\'"\n      [typeaheadOptions]="typeaheadOptions"\n      (submit)="startSearching($event)"\n      [aria-labelledby]="\'ariaLabelledby\'"\n      [aria-describedby]="\'ariaDescribedby\'"\n    ></bb-search-box-ui>\n  </div>\n</form>\n',
    },
    {
      name: 'SelectListComponent',
      selector: 'bb-select-list-ui',
      inputsClass: [
        {
          name: 'filterEnabled',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nFlag to determine if typeahead should be used to filter the items list.\nIf enabled the items list can not be updated asynchonously as the filtering\nand the underlying data will get out of sync.\n',
          description:
            '<p>Flag to determine if typeahead should be used to filter the items list.\nIf enabled the items list can not be updated asynchonously as the filtering\nand the underlying data will get out of sync.</p>\n',
          line: 81,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isOpen',
          deprecated: false,
          deprecationMessage: '',
          line: 84,
          type: 'any',
          decorators: [],
        },
        {
          name: 'items',
          defaultValue: '[]',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nA list of items to select from based on the input text.\n',
          description: '<p>A list of items to select from based on the input text.</p>\n',
          line: 74,
          type: 'T[]',
          decorators: [],
        },
        {
          name: 'loading',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFlag to determine if the data in the list is loading\n',
          description: '<p>Flag to determine if the data in the list is loading</p>\n',
          line: 49,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'maxSelectedItems',
          defaultValue: "'none'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nMaximum number of selected items, 'none' means unlimited\n",
          description: '<p>Maximum number of selected items, &#39;none&#39; means unlimited</p>\n',
          line: 64,
          type: 'string',
          decorators: [],
        },
        {
          name: 'minTermLength',
          defaultValue: '2',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMinimum number of characters required before searching for items\n',
          description: '<p>Minimum number of characters required before searching for items</p>\n',
          line: 59,
          type: 'number',
          decorators: [],
        },
        {
          name: 'multiple',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nFlag to determine if the list allows multiple selection.\n',
          description: '<p>Flag to determine if the list allows multiple selection.</p>\n',
          line: 69,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nPlaceholder text to display in the input\n',
          description: '<p>Placeholder text to display in the input</p>\n',
          line: 54,
          type: 'string',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'clear',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmitter when clear is performed.\n',
          description: '<p>Emitter when clear is performed.</p>\n',
          line: 107,
          type: 'EventEmitter',
        },
        {
          name: 'search',
          defaultValue: 'new EventEmitter<string>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nEmitter when search is performed. Outputs search term\n',
          description: '<p>Emitter when search is performed. Outputs search term</p>\n',
          line: 102,
          type: 'EventEmitter<string>',
        },
        {
          name: 'valueChange',
          defaultValue: 'this._valueChange',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nOutput to capture value change event.\n',
          description: '<p>Output to capture value change event.</p>\n',
          line: 97,
        },
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'onOpen',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 198,
          deprecated: true,
          deprecationMessage: 'Deprecated in ui-ang@12. To be marked as protected in ui-ang@14. No replacements.',
          rawdescription: '\n\n',
          description: '',
          jsdoctags: [],
        },
        {
          name: 'onSearch',
          args: [
            {
              name: 'event',
              type: 'string | literal type',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 140,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'string | literal type',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 131,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'SelectListExampleComponent',
      selector: 'bb-select-list-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component, OnInit } from '@angular/core';\nimport { UntypedFormControl, UntypedFormGroup } from '@angular/forms';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\n\n@Component({\n  selector: 'bb-select-list-example-ui',\n  templateUrl: './select-list.example.component.html',\n  standalone: false,\n})\nexport class SelectListExampleComponent implements OnInit {\n  form!: UntypedFormGroup;\n\n  items = [\n    { name: 'One', value: 'one' },\n    { name: 'Two', value: 'two' },\n    { name: 'Three', value: 'three' },\n  ];\n\n  ngOnInit() {\n    this.form = new UntypedFormGroup({\n      number: new UntypedFormControl([]),\n    });\n  }\n}\n",
      template:
        '<form [formGroup]="form">\n  <h4 id="selectListLabel">Numbers from one to three</h4>\n  <bb-select-list-ui\n    id="selectListInput"\n    formControlName="number"\n    placeholder="Start typing name of numbers. e.g. one"\n    [items]="items"\n    [minTermLength]="3"\n    aria-labelledby="selectListLabel"\n  >\n  </bb-select-list-ui>\n</form>\n',
    },
    {
      name: 'ShowcaseComponent',
      selector: 'bb-showcase-ui',
      inputsClass: [
        {
          name: 'bbdocs',
          deprecated: false,
          deprecationMessage: '',
          line: 25,
          type: 'BbDsDocs | undefined',
          decorators: [],
        },
        {
          name: 'componentId',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          line: 26,
          type: 'string',
          decorators: [],
        },
        {
          name: 'scssTokensHtml',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          line: 27,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'createAndUpdate',
          args: [
            {
              name: 'componentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 83,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'componentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getComponentTemplate',
          args: [
            {
              name: 'componentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 97,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'componentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onTabSelect',
          args: [
            {
              name: 'tabIndex',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 264,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'tabIndex',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'populateFields',
          args: [
            {
              name: 'obj',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 247,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'obj',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'renderComponentInElement',
          args: [
            {
              name: 'elementRef',
              type: 'ViewContainerRef | undefined',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'componentSelector',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'ComponentFactory<any>',
          typeParameters: [],
          line: 145,
          deprecated: false,
          deprecationMessage: '',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'elementRef',
              type: 'ViewContainerRef | undefined',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'componentSelector',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'setExampleModule',
          args: [
            {
              name: 'exampleComponentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 101,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'exampleComponentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'setShowcaseModule',
          args: [
            {
              name: 'showcaseComponentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 93,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'showcaseComponentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'update',
          args: [
            {
              name: 'docs',
              type: 'BbDsDocs',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'componentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 175,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'docs',
              type: 'BbDsDocs',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'componentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'updateComponentTemplate',
          args: [
            {
              name: 'updatedValue',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'any',
          typeParameters: [],
          line: 124,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'updatedValue',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'updateExampleSourceCode',
          args: [
            {
              name: 'docs',
              type: 'BbDsDocs',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'componentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 225,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'docs',
              type: 'BbDsDocs',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'componentId',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'StepperComponent',
      selector: 'bb-stepper-ui',
      inputsClass: [],
      outputsClass: [
        {
          name: 'select',
          defaultValue: 'new EventEmitter<any>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nEmits an event when a step's link is clicked.\n",
          description: '<p>Emits an event when a step&#39;s link is clicked.</p>\n',
          line: 47,
          type: 'EventEmitter<any>',
        },
      ],
      methodsClass: [
        {
          name: 'onClickHandler',
          args: [
            {
              name: 'data',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 56,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'data',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '<p>Component that represents a navigation stepper.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'StepperExampleComponent',
      selector: 'bb-stepper-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-stepper-example-ui',\n  templateUrl: './stepper.example.component.html',\n  standalone: false,\n})\nexport class StepperExampleComponent {}\n",
      template:
        '<bb-stepper-ui>\n  <bb-stepper-step-ui\n    [isActive]="true"\n    [isChecked]="true"\n    ariaLabel="Step 1 out of 3"\n    label="Step 1"\n  ></bb-stepper-step-ui>\n  <bb-stepper-step-ui\n    label="Step 2"\n    [isActive]="true"\n    [isChecked]="false"\n    [isCurrent]="true"\n    ariaLabel="Step 2 out of 3"\n  >\n    <bb-stepper-step-ui\n      label="Step 2.1"\n      [isActive]="true"\n      [isChecked]="false"\n      [isCurrent]="true"\n      ariaLabel="Sub step 1 out of 1"\n    >\n    </bb-stepper-step-ui>\n  </bb-stepper-step-ui>\n  <bb-stepper-step-ui\n    ariaLabel="Step 3 out of 3"\n    label="Step 3"\n  ></bb-stepper-step-ui>\n</bb-stepper-ui>\n',
    },
    {
      name: 'StepperStepComponent',
      selector: 'bb-stepper-step-ui',
      inputsClass: [
        {
          name: 'ariaLabel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nRepresents step's area-label\n",
          description: '<p>Represents step&#39;s area-label</p>\n',
          line: 41,
          type: 'string',
          decorators: [],
        },
        {
          name: 'data',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nRepresents step's data\n",
          description: '<p>Represents step&#39;s data</p>\n',
          line: 36,
          type: 'any',
          decorators: [],
        },
        {
          name: 'isActive',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMarks step as active\n',
          description: '<p>Marks step as active</p>\n',
          line: 56,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isChecked',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMarks step as checked\n',
          description: '<p>Marks step as checked</p>\n',
          line: 51,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isCurrent',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMarks step as current\n',
          description: '<p>Marks step as current</p>\n',
          line: 46,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nRepresents step's label\n",
          description: '<p>Represents step&#39;s label</p>\n',
          line: 26,
          type: 'string',
          decorators: [],
        },
        {
          name: 'stateLabel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nRepresents step's state label\n",
          description: '<p>Represents step&#39;s state label</p>\n',
          line: 31,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Component that represents a single step that is a part of the stepper component.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'SwitchComponent',
      selector: 'bb-switch-ui',
      inputsClass: [
        {
          name: 'labelPosition',
          defaultValue: 'position.left',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSpecifies the label position of the switch component.\nDefaults to left.\n',
          description: '<p>Specifies the label position of the switch component.\nDefaults to left.</p>\n',
          line: 44,
          type: 'LabelPosition',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is read only. Defaults to false.\n',
          description: '<p>Whether the input is read only. Defaults to false.</p>\n',
          line: 211,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'isLabelLeft',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 69,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'isLabelRight',
          args: [],
          optional: false,
          returnType: 'boolean',
          typeParameters: [],
          line: 73,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 64,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'toggleSwitch',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 59,
          deprecated: false,
          deprecationMessage: '',
        },
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description: '<p>Component that provides you a switch input.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'SwitchExampleComponent',
      selector: 'bb-switch-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';\n\n@Component({\n  selector: 'bb-switch-example-ui',\n  templateUrl: './switch.example.component.html',\n  standalone: false,\n})\nexport class SwitchExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    notifications: true,\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<bb-switch-ui\n  [labelPosition]="\'right\'"\n  [label]="\'Show notifications\'"\n  formControlName="notifications"\n>\n</bb-switch-ui>\n',
    },
    {
      name: 'TabComponent',
      selector: 'bb-tab-ui',
      inputsClass: [
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nFlag to disable a tab. Defaults to 'false'.\n",
          description: '<p>Flag to disable a tab. Defaults to &#39;false&#39;.</p>\n',
          line: 20,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '<p>TabComponent represents Tab item\nthat should be used inside tab group component</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TabExampleComponent',
      selector: 'bb-tab-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'onClick',
          args: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 23,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onSelect',
          args: [
            {
              name: 'index',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 15,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'index',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { NotificationService } from '@backbase/ui-ang/notification';\n\n@Component({\n  selector: 'bb-tab-example-ui',\n  templateUrl: './tab.example.component.html',\n  standalone: false,\n})\nexport class TabExampleComponent {\n  constructor(\n    private readonly notificationService: NotificationService,\n  ) {}\n\n  onSelect(index: number) {\n    this.notificationService.showNotification({\n      header: 'Tab Navigation',\n      message: `Navigate to Tab #${index + 1}'`,\n      modifier: 'info',\n    });\n  }\n\n  onClick($event: any) {\n    $event.stopPropagation();\n    $event.preventDefault();\n  }\n}\n",
      template:
        '<bb-tab-group-ui\n  [initialSelection]="0"\n  (click)="onClick($event)"\n  (select)="onSelect($event)"\n>\n  <bb-tab-ui>First</bb-tab-ui>\n  <bb-tab-ui>Second</bb-tab-ui>\n  <bb-tab-ui>Third</bb-tab-ui>\n  <bb-tab-ui [disabled]="true">Fourth</bb-tab-ui>\n</bb-tab-group-ui>\n',
    },
    {
      name: 'TabGroupComponent',
      selector: 'bb-tab-group-ui',
      inputsClass: [
        {
          name: 'initialSelection',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 679,
              end: 743,
              kind: 341,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 680,
                end: 685,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Index of initially selected tab item</p>\n',
              name: {
                pos: 686,
                end: 702,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'initialSelection',
              },
              isNameFirst: true,
              isBracketed: false,
            },
          ],
          rawdescription: '\n\nSetter (Input) for initial tab item selection\n\n',
          description: '<p>Setter (Input) for initial tab item selection</p>\n',
          line: 36,
          type: 'number | undefined',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'select',
          defaultValue: 'new EventEmitter<number>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nEvent (Output) that emits new value once tab item selection has changed.\nAs a parameter it provides index of newly selected item\n',
          description:
            '<p>Event (Output) that emits new value once tab item selection has changed.\nAs a parameter it provides index of newly selected item</p>\n',
          line: 43,
          type: 'EventEmitter',
        },
      ],
      methodsClass: [
        {
          name: 'onClick',
          args: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'index',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 127,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nInternal handler for clicks on tab items\n\n',
          description: '<p>Internal handler for clicks on tab items</p>\n',
          jsdoctags: [
            {
              name: 'event',
              type: 'MouseEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: {
                pos: 3886,
                end: 3891,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'index',
              },
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 3880,
                end: 3885,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '<p>Index of element that has been clicked</p>\n',
            },
          ],
        },
        {
          name: 'onKeyDown',
          args: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'index',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 61,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'event',
              type: 'KeyboardEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'index',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description:
        '<p>TabGroupComponent represents component that is used\nas a wrapper for tab item components. It tracks user interaction and\nnotifies parent upon selection change</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TableExampleComponent',
      selector: 'bb-table-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [
        {
          name: 'compare',
          args: [
            {
              name: 'v1',
              type: 'number | string',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'v2',
              type: 'number | string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: '0 | 1 | -1',
          typeParameters: [],
          line: 56,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'v1',
              type: 'number | string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'v2',
              type: 'number | string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getAriaSort',
          args: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'string | null',
          typeParameters: [],
          line: 64,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'key',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'getItems',
          args: [
            {
              name: 'start',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'end',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'CountryData[]',
          typeParameters: [],
          line: 60,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'start',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'end',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onRowClick',
          args: [
            {
              name: 'country',
              type: 'CountryData',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 33,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'country',
              type: 'CountryData',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'onSort',
          args: [
            {
              type: 'SortEvent',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 37,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              type: 'SortEvent',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
        {
          name: 'sort',
          args: [
            {
              name: 'countries',
              type: 'CountryData[]',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'column',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'direction',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'CountryData[]',
          typeParameters: [],
          line: 46,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'countries',
              type: 'CountryData[]',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'column',
              type: 'string',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
            {
              name: 'direction',
              type: 'number',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport { Observable, of } from 'rxjs';\n// Please replace relative path imports e.g. '../*' with '@backbase/ui-ang'.\nimport { SortEvent } from '@backbase/ui-ang/table';\nimport { CountryData } from './table.example.model';\nimport { countryData } from './countries';\n\nconst sortInteger: { [key: string]: number } = {\n  asc: 1,\n  desc: -1,\n};\n\n@Component({\n  selector: 'bb-table-example-ui',\n  templateUrl: './table.example.component.html',\n  standalone: false,\n})\nexport class TableExampleComponent {\n  countries$?: Observable<CountryData[]>;\n\n  sortDirection = 0;\n  sortKey = '';\n\n  pathFlagAssets = 'https://upload.wikimedia.org/wikipedia/commons/';\n\n  pageSize = 10;\n  currentPage = 0;\n\n  constructor() {\n    this.countries$ = of(this.getItems(0, this.pageSize));\n  }\n\n  onRowClick(country: CountryData) {\n    alert(`You clicked on ${country.name}`);\n  }\n\n  onSort({ column, direction }: SortEvent) {\n    this.sortDirection = direction ? sortInteger[direction] : 0;\n    this.sortKey = column;\n\n    this.countries$ = of(\n      this.sort(countryData, this.sortKey, this.sortDirection),\n    );\n  }\n\n  sort(\n    countries: CountryData[],\n    column: string,\n    direction: number,\n  ): CountryData[] {\n    return [...countries].sort(\n      (a, b) => direction * this.compare(a[column], b[column]),\n    );\n  }\n\n  compare(v1: number | string, v2: number | string) {\n    return v1 === v2 ? 0 : v1 < v2 ? -1 : 1;\n  }\n\n  getItems(start: number, end: number): CountryData[] {\n    return countryData.slice(start, end);\n  }\n\n  getAriaSort(key: string): string | null {\n    if (this.sortKey === key) {\n      if (this.sortDirection < 0) {\n        return 'descending';\n      } else if (this.sortDirection > 0) {\n        return 'ascending';\n      }\n    }\n\n    return null;\n  }\n\n  get paginator() {\n    return {\n      page: this.currentPage,\n      boundaryLinks: false,\n      directionLinks: true,\n      totalItems: countryData.length,\n      itemsPerPage: this.pageSize,\n      maxNavPages: 3,\n      onPageChange: (page: number) => {\n        this.countries$ = of(\n          this.getItems(\n            page * this.pageSize,\n            page * this.pageSize + this.pageSize,\n          ),\n        );\n      },\n    };\n  }\n}\n",
      template:
        '<table\n  [bbTable]="countries$ | async"\n  bbTableFocus\n  (rowClick)="onRowClick($event)"\n  (sort)="onSort($event)"\n  class="table table-hover"\n>\n  <thead>\n    <tr>\n      <th\n        [attr.aria-sort]="getAriaSort(\'name\')"\n        [bbSortable]="\'name\'"\n        scope="col"\n        tabindex="0"\n      >\n        Country\n      </th>\n      <th\n        [attr.aria-sort]="getAriaSort(\'area\')"\n        [bbSortable]="\'area\'"\n        scope="col"\n        tabindex="0"\n      >\n        Area (km²)\n      </th>\n      <th\n        [attr.aria-sort]="getAriaSort(\'population\')"\n        [bbSortable]="\'population\'"\n        scope="col"\n        tabindex="0"\n      >\n        Population\n      </th>\n      <th></th>\n    </tr>\n  </thead>\n  <tbody>\n    @for (country of countries$ | async; track $index) {\n      <tr [bbRow]="country">\n        <td>\n          {{ country.name }}\n        </td>\n        <td>\n          {{ country.area | number }}\n        </td>\n        <td>\n          {{ country.population | number }}\n        </td>\n        <td>\n          <img\n            [alt]="\'Flag of \' + country.name"\n            [src]="pathFlagAssets + country.flag"\n            width="32"\n          />\n        </td>\n      </tr>\n    }\n  </tbody>\n</table>\n\n<bb-pagination-ui\n  (pageChange)="paginator.onPageChange($event)"\n  [boundaryLinks]="paginator.boundaryLinks"\n  [directionLinks]="paginator.directionLinks"\n  [itemsPerPage]="paginator.itemsPerPage"\n  [maxNavPages]="paginator.maxNavPages"\n  [page]="paginator.page"\n  [totalItems]="paginator.totalItems"\n>\n</bb-pagination-ui>\n',
    },
    {
      name: 'TextareaComponent',
      selector: 'bb-textarea-ui',
      inputsClass: [
        {
          name: 'cols',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe number of columns to display in the textarea.\n',
          description: '<p>The number of columns to display in the textarea.</p>\n',
          line: 39,
          type: 'number',
          decorators: [],
        },
        {
          name: 'maxLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe maxLength for the text input.\n',
          description: '<p>The maxLength for the text input.</p>\n',
          line: 47,
          type: 'number',
          decorators: [],
        },
        {
          name: 'minLength',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe minLength for the text input.\n',
          description: '<p>The minLength for the text input.</p>\n',
          line: 51,
          type: 'number',
          decorators: [],
        },
        {
          name: 'placeholder',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe placeholder for the text input. Defaults to an empty string.\n',
          description: '<p>The placeholder for the text input. Defaults to an empty string.</p>\n',
          line: 43,
          type: 'string',
          decorators: [],
        },
        {
          name: 'readonly',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input is readonly.\n',
          description: '<p>Whether the text input is readonly.</p>\n',
          line: 55,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'rows',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe number of rows to display in the textarea.\n',
          description: '<p>The number of rows to display in the textarea.</p>\n',
          line: 35,
          type: 'number',
          decorators: [],
        },
        {
          name: 'showCharCounter',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nShows character counter based on `maxLength`.\n',
          description: '<p>Shows character counter based on <code>maxLength</code>.</p>\n',
          line: 59,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'wrap',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nIndicates how the control wraps text.\n',
          description: '<p>Indicates how the control wraps text.</p>\n',
          line: 63,
          type: '"soft" | "hard"',
          decorators: [],
        },
        {
          name: 'aria-activedescendant',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nIt identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.\n',
          description:
            '<p>It identifies the currently active element when focus is on a\ncomposite widget, combobox, textbox, group, or application.</p>\n',
          line: 150,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-autocomplete',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nIt indicates whether inputting text could trigger display of one or more\npredictions of the user's intended value for a combobox, searchbox, or textbox.\n",
          description:
            '<p>It indicates whether inputting text could trigger display of one or more\npredictions of the user&#39;s intended value for a combobox, searchbox, or textbox.</p>\n',
          line: 143,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-controls',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nWhen an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.\n',
          description:
            '<p>When an interactive or input control has an impact on another element in a document or application,\nthe aria-control indicates which element or elements the user interface widget controls.</p>\n',
          line: 157,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-describedby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nSet aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.\n',
          description:
            '<p>Set aria-describedby  with an element id that contains a detailed decription of the widget.\nIt is used to establish a relationship between widgets or groups and the text that describes them.</p>\n',
          line: 164,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-expanded',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.\n',
          description:
            '<p>The aria-expanded attribute is set on an element to indicate if a control is expanded or collapsed,\nand whether or not its child elements are displayed or hidden.</p>\n',
          line: 171,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-invalid',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-invalid state indicates the entered value is not in a format expected by the application.\n',
          description:
            '<p>The aria-invalid state indicates the entered value is not in a format expected by the application.</p>\n',
          line: 177,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-label',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAccessible label when control does not need to render label tag.\n',
          description: '<p>Accessible label when control does not need to render label tag.</p>\n',
          line: 183,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-labelledby',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nThe aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don't have native support for associating\nelements to provide an accessible name.\n",
          description:
            '<p>The aria-labelledby property enables authors to reference other elements on the page to define an\naccessible name. This is useful when using elements that don&#39;t have native support for associating\nelements to provide an accessible name.</p>\n',
          line: 191,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'aria-owns',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nThe aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.\n',
          description:
            '<p>The aria-owns attribute identifies an element (or elements) in order to define a visual, functional, or\ncontextual relationship between a parent and its child elements when the DOM hierarchy cannot be used\nto represent the relationship.</p>\n',
          line: 199,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'autofocus',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the text input should be auto-focused when shown.\n',
          description: '<p>Whether the text input should be auto-focused when shown.</p>\n',
          line: 223,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'disabled',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the component is mutable or clickable. Defaults to false.\n',
          description: '<p>Whether the component is mutable or clickable. Defaults to false.</p>\n',
          line: 230,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'id',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe id for the input. Defaults to unique string.\nUsed to map the label to the input.\n',
          description: '<p>The id for the input. Defaults to unique string.\nUsed to map the label to the input.</p>\n',
          line: 73,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'inputClassName',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nClass names that must be included on the `<input>` form control\n',
          description: '<p>Class names that must be included on the <code>&lt;input&gt;</code> form control</p>\n',
          line: 137,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe label for the input. Defaults to an empty string.\n',
          description: '<p>The label for the input. Defaults to an empty string.</p>\n',
          line: 84,
          type: 'string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'required',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether the input is required. Defaults to false.\n',
          description: '<p>Whether the input is required. Defaults to false.</p>\n',
          line: 207,
          type: 'boolean',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'role',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nCustomize the ARIA role for the HTML input/select/textarea element inside this component.\n\nThis can be used to improve accessibility for components, for example by configuring `[role]="\'combobox\'"`\nfor a component that provides an autocomplete list.\n\nValues that are valid for the native HTML form elements are allowed.\n',
          description:
            '<p>Customize the ARIA role for the HTML input/select/textarea element inside this component.</p>\n<p>This can be used to improve accessibility for components, for example by configuring <code>[role]=&quot;&#39;combobox&#39;&quot;</code>\nfor a component that provides an autocomplete list.</p>\n<p>Values that are valid for the native HTML form elements are allowed.</p>\n',
          line: 97,
          type: 'string | undefined',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'size',
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nConfigure the minimum width to fit the specified number of characters that should fit for HTML `<input>`\n',
          description:
            '<p>Configure the minimum width to fit the specified number of characters that should fit for HTML <code>&lt;input&gt;</code></p>\n',
          line: 116,
          type: 'number | string',
          decorators: [],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      outputsClass: [
        {
          name: 'blur',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on blur actions.\n',
          description: '<p>An event emitter for on blur actions.</p>\n',
          line: 215,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'focus',
          defaultValue: 'new EventEmitter<FocusEvent | void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAn event emitter for on focus actions.\n',
          description: '<p>An event emitter for on focus actions.</p>\n',
          line: 219,
          type: 'EventEmitter',
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      methodsClass: [
        {
          name: 'getSizeByKeyword',
          args: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'number | undefined',
          typeParameters: [],
          line: 279,
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            '\n\nReturns the `input` `size` value for a keyword, such as "xxl".\nSubclasses can choose to implement a custom mapping, which will be used to configure `size`.\n',
          description:
            '<p>Returns the <code>input</code> <code>size</code> value for a keyword, such as &quot;xxl&quot;.\nSubclasses can choose to implement a custom mapping, which will be used to configure <code>size</code>.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: 'arg',
              type: 'any',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onBlur',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 236,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onFocus',
          args: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 253,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: '$event',
              type: 'FocusEvent',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'onValueChange',
          args: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 243,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'newValue',
              type: 'Object | string',
              deprecated: false,
              deprecationMessage: '',
              optional: true,
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnChange',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 262,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'registerOnTouched',
          args: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 266,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'fn',
              type: 'function',
              deprecated: false,
              deprecationMessage: '',
              function: [],
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'setDisabledState',
          args: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 270,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'isDisabled',
              type: 'boolean',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
        {
          name: 'writeValue',
          args: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
            },
          ],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 257,
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              name: 'inputValue',
              type: 'Object | string | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                text: 'param',
              },
            },
          ],
          inheritance: {
            file: 'InputBaseComponent',
          },
        },
      ],
      description:
        '<h3>Accessibility</h3>\n<p>Current component provide option to pass needed accessibility\nattributes. You need to take care of properties that are required in your case :</p>\n<ul>\n<li>role</li>\n<li>aria-activedescendant</li>\n<li>aria-describedby</li>\n<li>aria-expanded</li>\n<li>aria-invalid</li>\n<li>aria-label</li>\n<li>aria-labelledby</li>\n<li>aria-owns</li>\n</ul>\n<p>Component that displays a text input.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TextareaExampleComponent',
      selector: 'bb-textarea-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\nimport {\n  UntypedFormBuilder,\n  UntypedFormGroup,\n  Validators,\n} from '@angular/forms';\n\n@Component({\n  selector: 'bb-textarea-example-ui',\n  templateUrl: './textarea.example.component.html',\n  standalone: false,\n})\nexport class TextareaExampleComponent {\n  vForm: UntypedFormGroup = this.formBuilder.group({\n    textarea: ['', Validators.minLength(3)],\n  });\n\n  constructor(private formBuilder: UntypedFormBuilder) {}\n}\n",
      template:
        '<form [formGroup]="vForm">\n  <p>\n    <bb-textarea-ui\n      label="Additional remarks"\n      placeholder="Enter text..."\n      formControlName="textarea"\n      [showCharCounter]="true"\n      [minLength]="3"\n      [maxLength]="160"\n      [rows]="4"\n    >\n    </bb-textarea-ui>\n  </p>\n</form>\n',
    },
    {
      name: 'TooltipExampleComponent',
      selector: 'bb-tooltip-example-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode:
        "import { Component } from '@angular/core';\n\n@Component({\n  selector: 'bb-tooltip-example-ui',\n  templateUrl: './tooltip.example.component.html',\n  standalone: false,\n})\nexport class TooltipExampleComponent {}\n",
      template:
        '<span\n  bbTooltip="Cancelling this payment cannot be undone!"\n  placement="bottom"\n>\n  <bb-icon-ui name="info" color="info" size="lg"></bb-icon-ui>\n</span>\n',
    },
    {
      name: 'TrackerComponent',
      selector: 'bb-tracker-ui',
      inputsClass: [
        {
          name: 'countFn',
          deprecated: false,
          deprecationMessage: '',
          jsdoctags: [
            {
              pos: 1122,
              end: 1140,
              kind: 341,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 1123,
                end: 1128,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
              name: {
                pos: 1129,
                end: 1134,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'index',
              },
              isNameFirst: true,
              isBracketed: false,
            },
            {
              pos: 1140,
              end: 1156,
              kind: 341,
              id: 0,
              flags: 16842752,
              modifierFlagsCache: 0,
              transformFlags: 0,
              tagName: {
                pos: 1141,
                end: 1146,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
              name: {
                pos: 1147,
                end: 1152,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'total',
              },
              isNameFirst: true,
              isBracketed: false,
            },
          ],
          rawdescription: '\n\nCustom counting function that overrides default behaviour.\n',
          description: '<p>Custom counting function that overrides default behaviour.</p>\n',
          line: 44,
          type: 'function',
          decorators: [],
        },
        {
          name: 'disableAnimation',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nDisable component animation.\nDefaults to 'false'\n",
          description: '<p>Disable component animation.\nDefaults to &#39;false&#39;</p>\n',
          line: 88,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'hideCount',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nWhether segment count should be hidden.\nDefaults to 'false'.\n",
          description: '<p>Whether segment count should be hidden.\nDefaults to &#39;false&#39;.</p>\n',
          line: 50,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'progressAriaLabel',
          defaultValue: "'progress'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nAria label attribute for active segment's progress element.\nDefaults to 'progress'.\n",
          description:
            '<p>Aria label attribute for active segment&#39;s progress element.\nDefaults to &#39;progress&#39;.</p>\n',
          line: 80,
          type: 'string',
          decorators: [],
        },
        {
          name: 'segmentActiveIconName',
          defaultValue: "'loop'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nName of the icon used for a segment marked as active.\nDefaults to 'loop'.\n",
          description: '<p>Name of the icon used for a segment marked as active.\nDefaults to &#39;loop&#39;.</p>\n',
          line: 68,
          type: 'string',
          decorators: [],
        },
        {
          name: 'segmentCompletedIconName',
          defaultValue: "'check'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nName of the icon used for a segment marked as completed.\nDefaults to 'check'.\n",
          description:
            '<p>Name of the icon used for a segment marked as completed.\nDefaults to &#39;check&#39;.</p>\n',
          line: 62,
          type: 'string',
          decorators: [],
        },
        {
          name: 'segmented',
          defaultValue: 'true',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether tracker is in segmented mode. Defaults to `true`.\n',
          description: '<p>Whether tracker is in segmented mode. Defaults to <code>true</code>.</p>\n',
          line: 32,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'separator',
          defaultValue: "'.'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nSeparator between count text and segment label.\nApplicable only to non-vertical mode. Defaults to '.'\n",
          description:
            '<p>Separator between count text and segment label.\nApplicable only to non-vertical mode. Defaults to &#39;.&#39;</p>\n',
          line: 74,
          type: 'string',
          decorators: [],
        },
        {
          name: 'showSegmentIcons',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nWhether segment icons should be visible.\nDefaults to 'false'.\n",
          description: '<p>Whether segment icons should be visible.\nDefaults to &#39;false&#39;.</p>\n',
          line: 56,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'vertical',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nWhether tracker is in vertical mode. Defaults to `false`.\n',
          description: '<p>Whether tracker is in vertical mode. Defaults to <code>false</code>.</p>\n',
          line: 37,
          type: 'boolean',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [
        {
          name: 'calculateCount',
          args: [
            {
              name: 'segment',
              type: 'TrackerSegmentComponent | null',
              deprecated: false,
              deprecationMessage: '',
            },
            {
              name: 'segmentIndex',
              type: 'number | null',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: '0',
            },
          ],
          optional: false,
          returnType: 'string',
          typeParameters: [],
          line: 195,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nCalculates count text of the segment.\n',
          description: '<p>Calculates count text of the segment.</p>\n',
          modifierKind: [124],
          jsdoctags: [
            {
              name: {
                pos: 5286,
                end: 5293,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'segment',
              },
              type: 'TrackerSegmentComponent | null',
              deprecated: false,
              deprecationMessage: '',
              tagName: {
                pos: 5280,
                end: 5285,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
            {
              name: {
                pos: 5306,
                end: 5318,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'segmentIndex',
              },
              type: 'number | null',
              deprecated: false,
              deprecationMessage: '',
              defaultValue: '0',
              tagName: {
                pos: 5300,
                end: 5305,
                kind: 80,
                id: 0,
                flags: 16842752,
                transformFlags: 0,
                escapedText: 'param',
              },
              comment: '',
            },
          ],
        },
        {
          name: 'stateChanged',
          args: [],
          optional: false,
          returnType: 'void',
          typeParameters: [],
          line: 185,
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nMarks the component to be change detected.\n',
          description: '<p>Marks the component to be change detected.</p>\n',
        },
      ],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'TrackerSegmentComponent',
      selector: 'bb-tracker-segment-ui',
      inputsClass: [
        {
          name: 'ariaLabel',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nAria label for the segment.\n',
          description: '<p>Aria label for the segment.</p>\n',
          line: 31,
          type: 'string',
          decorators: [],
        },
        {
          name: 'countText',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nSets custom count text.\n',
          description: '<p>Sets custom count text.</p>\n',
          line: 46,
          type: 'string',
          decorators: [],
        },
        {
          name: 'hideCount',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nWhether segment count should be hidden. Defaults to 'false'\n",
          description: '<p>Whether segment count should be hidden. Defaults to &#39;false&#39;</p>\n',
          line: 51,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isActive',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nWhether the segment is marked as active. Defaults to 'false'.\n",
          description: '<p>Whether the segment is marked as active. Defaults to &#39;false&#39;.</p>\n',
          line: 15,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'isCompleted',
          defaultValue: 'false',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nWhether the segment is marked as completed. Defaults to 'false'.\n",
          description: '<p>Whether the segment is marked as completed. Defaults to &#39;false&#39;.</p>\n',
          line: 21,
          type: 'boolean',
          decorators: [],
        },
        {
          name: 'label',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nLabel of the segment.\n',
          description: '<p>Label of the segment.</p>\n',
          line: 26,
          type: 'string',
          decorators: [],
        },
        {
          name: 'progress',
          defaultValue: '0',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: "\n\nProgress level of the segment. Defaults to '0'.\n",
          description: '<p>Progress level of the segment. Defaults to &#39;0&#39;.</p>\n',
          line: 41,
          type: 'number',
          decorators: [],
        },
        {
          name: 'separator',
          defaultValue: "''",
          deprecated: false,
          deprecationMessage: '',
          rawdescription:
            "\n\nSeparator between count text and segment label.\nApplicable only to horizontal or linear mode. Defaults to '-'.\n",
          description:
            '<p>Separator between count text and segment label.\nApplicable only to horizontal or linear mode. Defaults to &#39;-&#39;.</p>\n',
          line: 57,
          type: 'string',
          decorators: [],
        },
        {
          name: 'subtitle',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nOptional subtitle for the segment.\n',
          description: '<p>Optional subtitle for the segment.</p>\n',
          line: 36,
          type: 'string',
          decorators: [],
        },
      ],
      outputsClass: [],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'UniversalHeaderComponent',
      selector: 'bb-universal-header-ui',
      inputsClass: [
        {
          name: 'backgroundColor',
          defaultValue: "'white'",
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe universal header background color to display.\n',
          description: '<p>The universal header background color to display.</p>\n',
          line: 51,
          type: 'UniversalHeaderBackgroundColor',
          decorators: [],
        },
        {
          name: 'closeButton',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe universal header close button configuration.\n',
          description: '<p>The universal header close button configuration.</p>\n',
          line: 74,
          type: 'UniversalHeaderCloseButton',
          decorators: [],
        },
        {
          name: 'logo',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe universal header logo configuration.\n',
          description: '<p>The universal header logo configuration.</p>\n',
          line: 56,
          type: 'UniversalHeaderLogo',
          decorators: [],
        },
        {
          name: 'title',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe universal header title configuration.\n',
          description: '<p>The universal header title configuration.</p>\n',
          line: 69,
          type: 'UniversalHeaderTitle',
          decorators: [],
        },
      ],
      outputsClass: [
        {
          name: 'close',
          defaultValue: 'new EventEmitter<void>()',
          deprecated: false,
          deprecationMessage: '',
          rawdescription: '\n\nThe universal header close action.\n',
          description: '<p>The universal header close action.</p>\n',
          line: 79,
          type: 'EventEmitter<any>',
        },
      ],
      methodsClass: [],
      description: '',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
    {
      name: 'ValidationMessageComponent',
      selector: 'bb-validation-message-ui',
      inputsClass: [],
      outputsClass: [],
      methodsClass: [],
      description: '<p>Dynamic component that displays a control validation message dependence on validation.</p>\n',
      deprecationMessage: '',
      sourceCode: null,
      template: null,
    },
  ],
};
